
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1d4a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1d4a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
'use strict';

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$g = 60103;
$0014624a040e5105$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0014624a040e5105$var$h = Symbol.for;
    $0014624a040e5105$var$g = $0014624a040e5105$var$h("react.element");
    $0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$h("react.fragment");
}
var $0014624a040e5105$var$m = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$n = Object.prototype.hasOwnProperty, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0014624a040e5105$var$n.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0014624a040e5105$var$m.current
    };
}
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$83d89fbfd8236492;
'use strict';

var $4yvvI = parcelRequire("4yvvI");
var $92f4fea5bc247620$var$n = "function" === typeof Symbol && Symbol.for, $92f4fea5bc247620$var$p = $92f4fea5bc247620$var$n ? Symbol.for("react.element") : 60103, $92f4fea5bc247620$var$q = $92f4fea5bc247620$var$n ? Symbol.for("react.portal") : 60106, $92f4fea5bc247620$var$r = $92f4fea5bc247620$var$n ? Symbol.for("react.fragment") : 60107, $92f4fea5bc247620$var$t = $92f4fea5bc247620$var$n ? Symbol.for("react.strict_mode") : 60108, $92f4fea5bc247620$var$u = $92f4fea5bc247620$var$n ? Symbol.for("react.profiler") : 60114, $92f4fea5bc247620$var$v = $92f4fea5bc247620$var$n ? Symbol.for("react.provider") : 60109, $92f4fea5bc247620$var$w = $92f4fea5bc247620$var$n ? Symbol.for("react.context") : 60110, $92f4fea5bc247620$var$x = $92f4fea5bc247620$var$n ? Symbol.for("react.forward_ref") : 60112, $92f4fea5bc247620$var$y = $92f4fea5bc247620$var$n ? Symbol.for("react.suspense") : 60113, $92f4fea5bc247620$var$z = $92f4fea5bc247620$var$n ? Symbol.for("react.memo") : 60115, $92f4fea5bc247620$var$A = $92f4fea5bc247620$var$n ? Symbol.for("react.lazy") : 60116, $92f4fea5bc247620$var$B = "function" === typeof Symbol && Symbol.iterator;
function $92f4fea5bc247620$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $92f4fea5bc247620$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$E = {};
function $92f4fea5bc247620$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$E;
    this.updater = c || $92f4fea5bc247620$var$D;
}
$92f4fea5bc247620$var$F.prototype.isReactComponent = {};
$92f4fea5bc247620$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($92f4fea5bc247620$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$G() {}
$92f4fea5bc247620$var$G.prototype = $92f4fea5bc247620$var$F.prototype;
function $92f4fea5bc247620$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$E;
    this.updater = c || $92f4fea5bc247620$var$D;
}
var $92f4fea5bc247620$var$I = $92f4fea5bc247620$var$H.prototype = new $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$I.constructor = $92f4fea5bc247620$var$H;
$4yvvI($92f4fea5bc247620$var$I, $92f4fea5bc247620$var$F.prototype);
$92f4fea5bc247620$var$I.isPureReactComponent = !0;
var $92f4fea5bc247620$var$J = {
    current: null
}, $92f4fea5bc247620$var$K = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$92f4fea5bc247620$var$K.call(b, e) && !$92f4fea5bc247620$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $92f4fea5bc247620$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $92f4fea5bc247620$var$J.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$p;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g, $92f4fea5bc247620$var$Q = [];
function $92f4fea5bc247620$var$R(a, b, c, e) {
    if ($92f4fea5bc247620$var$Q.length) {
        var d = $92f4fea5bc247620$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $92f4fea5bc247620$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $92f4fea5bc247620$var$Q.length && $92f4fea5bc247620$var$Q.push(a);
}
function $92f4fea5bc247620$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$p:
                case $92f4fea5bc247620$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $92f4fea5bc247620$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $92f4fea5bc247620$var$U(d, k);
        g += $92f4fea5bc247620$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $92f4fea5bc247620$var$B && a[$92f4fea5bc247620$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $92f4fea5bc247620$var$U(d, k++), g += $92f4fea5bc247620$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($92f4fea5bc247620$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $92f4fea5bc247620$var$V(a, b, c) {
    return null == a ? 0 : $92f4fea5bc247620$var$T(a, "", b, c);
}
function $92f4fea5bc247620$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape(a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $92f4fea5bc247620$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $92f4fea5bc247620$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($92f4fea5bc247620$var$O(a) && (a = $92f4fea5bc247620$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + c)), e.push(a));
}
function $92f4fea5bc247620$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($92f4fea5bc247620$var$P, "$&/") + "/");
    b = $92f4fea5bc247620$var$R(b, g, e, d);
    $92f4fea5bc247620$var$V(a, $92f4fea5bc247620$var$aa, b);
    $92f4fea5bc247620$var$S(b);
}
var $92f4fea5bc247620$var$Y = {
    current: null
};
function $92f4fea5bc247620$var$Z() {
    var a = $92f4fea5bc247620$var$Y.current;
    if (null === a) throw Error($92f4fea5bc247620$var$C(321));
    return a;
}
var $92f4fea5bc247620$var$ba = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $92f4fea5bc247620$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $4yvvI
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $92f4fea5bc247620$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $92f4fea5bc247620$var$R(null, null, b, c);
        $92f4fea5bc247620$var$V(a, $92f4fea5bc247620$var$W, b);
        $92f4fea5bc247620$var$S(b);
    },
    count: function(a) {
        return $92f4fea5bc247620$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $92f4fea5bc247620$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error($92f4fea5bc247620$var$C(143));
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$F;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$u;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$H;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$t;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$y;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$ba;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($92f4fea5bc247620$var$C(267, a));
    var e = $4yvvI({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $92f4fea5bc247620$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$92f4fea5bc247620$var$K.call(b, h) && !$92f4fea5bc247620$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $92f4fea5bc247620$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$Z().useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a, b) {
    return $92f4fea5bc247620$var$Z().useContext(a, b);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$Z().useEffect(a, b);
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, c) {
    return $92f4fea5bc247620$var$Z().useImperativeHandle(a, b, c);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$Z().useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$Z().useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, c) {
    return $92f4fea5bc247620$var$Z().useReducer(a, b, c);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$Z().useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$Z().useState(a);
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("4yvvI", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $3512c7c00a4083d8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3512c7c00a4083d8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3512c7c00a4083d8$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $3512c7c00a4083d8$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $3512c7c00a4083d8$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $3512c7c00a4083d8$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $3512c7c00a4083d8$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($3512c7c00a4083d8$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($3512c7c00a4083d8$var$getOwnPropertySymbols) {
            symbols = $3512c7c00a4083d8$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($3512c7c00a4083d8$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});




parcelRegister("foRq4", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $bh6RR = parcelRequire("bh6RR");

var $4yvvI = parcelRequire("4yvvI");

var $4LCdk = parcelRequire("4LCdk");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$bh6RR) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $4yvvI({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $bh6RR.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $4yvvI({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $4yvvI({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $4LCdk.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $4LCdk.unstable_UserBlockingPriority, ed = $4LCdk.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $4yvvI({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$4yvvI(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $4yvvI(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $4yvvI({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $4yvvI({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $4LCdk.unstable_runWithPriority, Jf = $4LCdk.unstable_scheduleCallback, Kf = $4LCdk.unstable_cancelCallback, Lf = $4LCdk.unstable_requestPaint, Mf = $4LCdk.unstable_now, Nf = $4LCdk.unstable_getCurrentPriorityLevel, Of = $4LCdk.unstable_ImmediatePriority, Pf = $4LCdk.unstable_UserBlockingPriority, Qf = $4LCdk.unstable_NormalPriority, Rf = $4LCdk.unstable_LowPriority, Sf = $4LCdk.unstable_IdlePriority, Tf = {}, Uf = $4LCdk.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $4yvvI({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $4yvvI({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $bh6RR.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4yvvI({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $4yvvI({}, f, {
                    value: void 0
                });
                d = $4yvvI({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $4yvvI({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($4yvvI({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("4LCdk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
'use strict';
var $6445fa7f31ec0ca5$var$f, $6445fa7f31ec0ca5$var$g, $6445fa7f31ec0ca5$var$h, $6445fa7f31ec0ca5$var$k, $6445fa7f31ec0ca5$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$p = null, $6445fa7f31ec0ca5$var$q = null, $6445fa7f31ec0ca5$var$t = function() {
        if (null !== $6445fa7f31ec0ca5$var$p) try {
            var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
            $6445fa7f31ec0ca5$var$p(!0, a);
            $6445fa7f31ec0ca5$var$p = null;
        } catch (b) {
            throw setTimeout($6445fa7f31ec0ca5$var$t, 0), b;
        }
    }, $6445fa7f31ec0ca5$var$u = Date.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return Date.now() - $6445fa7f31ec0ca5$var$u;
    };
    $6445fa7f31ec0ca5$var$f = function(a) {
        null !== $6445fa7f31ec0ca5$var$p ? setTimeout($6445fa7f31ec0ca5$var$f, 0, a) : ($6445fa7f31ec0ca5$var$p = a, setTimeout($6445fa7f31ec0ca5$var$t, 0));
    };
    $6445fa7f31ec0ca5$var$g = function(a, b) {
        $6445fa7f31ec0ca5$var$q = setTimeout(a, b);
    };
    $6445fa7f31ec0ca5$var$h = function() {
        clearTimeout($6445fa7f31ec0ca5$var$q);
    };
    $6445fa7f31ec0ca5$var$k = function() {
        return !1;
    };
    $6445fa7f31ec0ca5$var$l = $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function() {};
} else {
    var $6445fa7f31ec0ca5$var$w = window.performance, $6445fa7f31ec0ca5$var$x = window.Date, $6445fa7f31ec0ca5$var$y = window.setTimeout, $6445fa7f31ec0ca5$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $6445fa7f31ec0ca5$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $6445fa7f31ec0ca5$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $6445fa7f31ec0ca5$var$w && "function" === typeof $6445fa7f31ec0ca5$var$w.now) $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$w.now();
    };
    else {
        var $6445fa7f31ec0ca5$var$B = $6445fa7f31ec0ca5$var$x.now();
        $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
            return $6445fa7f31ec0ca5$var$x.now() - $6445fa7f31ec0ca5$var$B;
        };
    }
    var $6445fa7f31ec0ca5$var$C = !1, $6445fa7f31ec0ca5$var$D = null, $6445fa7f31ec0ca5$var$E = -1, $6445fa7f31ec0ca5$var$F = 5, $6445fa7f31ec0ca5$var$G = 0;
    $6445fa7f31ec0ca5$var$k = function() {
        return $6445fa7f31ec0ca5$export$c4744153514ff05d() >= $6445fa7f31ec0ca5$var$G;
    };
    $6445fa7f31ec0ca5$var$l = function() {};
    $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $6445fa7f31ec0ca5$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $6445fa7f31ec0ca5$var$H = new MessageChannel, $6445fa7f31ec0ca5$var$I = $6445fa7f31ec0ca5$var$H.port2;
    $6445fa7f31ec0ca5$var$H.port1.onmessage = function() {
        if (null !== $6445fa7f31ec0ca5$var$D) {
            var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
            $6445fa7f31ec0ca5$var$G = a + $6445fa7f31ec0ca5$var$F;
            try {
                $6445fa7f31ec0ca5$var$D(!0, a) ? $6445fa7f31ec0ca5$var$I.postMessage(null) : ($6445fa7f31ec0ca5$var$C = !1, $6445fa7f31ec0ca5$var$D = null);
            } catch (b) {
                throw $6445fa7f31ec0ca5$var$I.postMessage(null), b;
            }
        } else $6445fa7f31ec0ca5$var$C = !1;
    };
    $6445fa7f31ec0ca5$var$f = function(a) {
        $6445fa7f31ec0ca5$var$D = a;
        $6445fa7f31ec0ca5$var$C || ($6445fa7f31ec0ca5$var$C = !0, $6445fa7f31ec0ca5$var$I.postMessage(null));
    };
    $6445fa7f31ec0ca5$var$g = function(a, b) {
        $6445fa7f31ec0ca5$var$E = $6445fa7f31ec0ca5$var$y(function() {
            a($6445fa7f31ec0ca5$export$c4744153514ff05d());
        }, b);
    };
    $6445fa7f31ec0ca5$var$h = function() {
        $6445fa7f31ec0ca5$var$z($6445fa7f31ec0ca5$var$E);
        $6445fa7f31ec0ca5$var$E = -1;
    };
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $6445fa7f31ec0ca5$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $6445fa7f31ec0ca5$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $6445fa7f31ec0ca5$var$K(n, c)) void 0 !== r && 0 > $6445fa7f31ec0ca5$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $6445fa7f31ec0ca5$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $6445fa7f31ec0ca5$var$N = [], $6445fa7f31ec0ca5$var$O = [], $6445fa7f31ec0ca5$var$P = 1, $6445fa7f31ec0ca5$var$Q = null, $6445fa7f31ec0ca5$var$R = 3, $6445fa7f31ec0ca5$var$S = !1, $6445fa7f31ec0ca5$var$T = !1, $6445fa7f31ec0ca5$var$U = !1;
function $6445fa7f31ec0ca5$var$V(a) {
    for(var b = $6445fa7f31ec0ca5$var$L($6445fa7f31ec0ca5$var$O); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$M($6445fa7f31ec0ca5$var$O);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$M($6445fa7f31ec0ca5$var$O), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$N, b);
        else break;
        b = $6445fa7f31ec0ca5$var$L($6445fa7f31ec0ca5$var$O);
    }
}
function $6445fa7f31ec0ca5$var$W(a) {
    $6445fa7f31ec0ca5$var$U = !1;
    $6445fa7f31ec0ca5$var$V(a);
    if (!$6445fa7f31ec0ca5$var$T) {
        if (null !== $6445fa7f31ec0ca5$var$L($6445fa7f31ec0ca5$var$N)) $6445fa7f31ec0ca5$var$T = !0, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$X);
        else {
            var b = $6445fa7f31ec0ca5$var$L($6445fa7f31ec0ca5$var$O);
            null !== b && $6445fa7f31ec0ca5$var$g($6445fa7f31ec0ca5$var$W, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$X(a, b) {
    $6445fa7f31ec0ca5$var$T = !1;
    $6445fa7f31ec0ca5$var$U && ($6445fa7f31ec0ca5$var$U = !1, $6445fa7f31ec0ca5$var$h());
    $6445fa7f31ec0ca5$var$S = !0;
    var c = $6445fa7f31ec0ca5$var$R;
    try {
        $6445fa7f31ec0ca5$var$V(b);
        for($6445fa7f31ec0ca5$var$Q = $6445fa7f31ec0ca5$var$L($6445fa7f31ec0ca5$var$N); null !== $6445fa7f31ec0ca5$var$Q && (!($6445fa7f31ec0ca5$var$Q.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$k());){
            var d = $6445fa7f31ec0ca5$var$Q.callback;
            if (null !== d) {
                $6445fa7f31ec0ca5$var$Q.callback = null;
                $6445fa7f31ec0ca5$var$R = $6445fa7f31ec0ca5$var$Q.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$Q.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$Q.callback = e : $6445fa7f31ec0ca5$var$Q === $6445fa7f31ec0ca5$var$L($6445fa7f31ec0ca5$var$N) && $6445fa7f31ec0ca5$var$M($6445fa7f31ec0ca5$var$N);
                $6445fa7f31ec0ca5$var$V(b);
            } else $6445fa7f31ec0ca5$var$M($6445fa7f31ec0ca5$var$N);
            $6445fa7f31ec0ca5$var$Q = $6445fa7f31ec0ca5$var$L($6445fa7f31ec0ca5$var$N);
        }
        if (null !== $6445fa7f31ec0ca5$var$Q) var m = !0;
        else {
            var n = $6445fa7f31ec0ca5$var$L($6445fa7f31ec0ca5$var$O);
            null !== n && $6445fa7f31ec0ca5$var$g($6445fa7f31ec0ca5$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $6445fa7f31ec0ca5$var$Q = null, $6445fa7f31ec0ca5$var$R = c, $6445fa7f31ec0ca5$var$S = !1;
    }
}
function $6445fa7f31ec0ca5$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $6445fa7f31ec0ca5$var$Z = $6445fa7f31ec0ca5$var$l;
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$T || $6445fa7f31ec0ca5$var$S || ($6445fa7f31ec0ca5$var$T = !0, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$X));
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$R;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$L($6445fa7f31ec0ca5$var$N);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$R;
    }
    var c = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$R = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$R = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = $6445fa7f31ec0ca5$var$Z;
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$R = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$R = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $6445fa7f31ec0ca5$var$Y(a);
    } else c = $6445fa7f31ec0ca5$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $6445fa7f31ec0ca5$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$O, a), null === $6445fa7f31ec0ca5$var$L($6445fa7f31ec0ca5$var$N) && a === $6445fa7f31ec0ca5$var$L($6445fa7f31ec0ca5$var$O) && ($6445fa7f31ec0ca5$var$U ? $6445fa7f31ec0ca5$var$h() : $6445fa7f31ec0ca5$var$U = !0, $6445fa7f31ec0ca5$var$g($6445fa7f31ec0ca5$var$W, e - d))) : (a.sortIndex = c, $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$N, a), $6445fa7f31ec0ca5$var$T || $6445fa7f31ec0ca5$var$S || ($6445fa7f31ec0ca5$var$T = !0, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$X)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = function() {
    var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    $6445fa7f31ec0ca5$var$V(a);
    var b = $6445fa7f31ec0ca5$var$L($6445fa7f31ec0ca5$var$N);
    return b !== $6445fa7f31ec0ca5$var$Q && null !== $6445fa7f31ec0ca5$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $6445fa7f31ec0ca5$var$Q.expirationTime || $6445fa7f31ec0ca5$var$k();
};
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$R;
    return function() {
        var c = $6445fa7f31ec0ca5$var$R;
        $6445fa7f31ec0ca5$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$R = c;
        }
    };
};

});



parcelRegister("2tbKl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $c3YnH = parcelRequire("c3YnH");
function $1cc766ccf0672393$var$emptyFunction() {}
function $1cc766ccf0672393$var$emptyFunctionWithReset() {}
$1cc766ccf0672393$var$emptyFunctionWithReset.resetWarningCache = $1cc766ccf0672393$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $c3YnH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1cc766ccf0672393$var$emptyFunctionWithReset,
        resetWarningCache: $1cc766ccf0672393$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("c3YnH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $8c849a51633fc8b0$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $8c849a51633fc8b0$var$ReactPropTypesSecret;

});


parcelRegister("1DYgm", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("bRlFp", function(module, exports) {
'use strict';

var $2bBga = parcelRequire("2bBga");

var $djt5d = parcelRequire("djt5d");

var $6zSb1 = parcelRequire("6zSb1");

var $8SEIg = parcelRequire("8SEIg");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $8a2573892eafc323$var$createInstance(defaultConfig) {
    var context = new $6zSb1(defaultConfig);
    var instance = $djt5d($6zSb1.prototype.request, context);
    // Copy axios.prototype to instance
    $2bBga.extend(instance, $6zSb1.prototype, context);
    // Copy context to instance
    $2bBga.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $8a2573892eafc323$var$axios = $8a2573892eafc323$var$createInstance($8SEIg);
// Expose Axios class to allow class inheritance
$8a2573892eafc323$var$axios.Axios = $6zSb1;
// Factory for creating new instances
$8a2573892eafc323$var$axios.create = function create(instanceConfig) {
    return $8a2573892eafc323$var$createInstance($2bBga.merge($8SEIg, instanceConfig));
};

// Expose Cancel & CancelToken
$8a2573892eafc323$var$axios.Cancel = (parcelRequire("guIkb"));

$8a2573892eafc323$var$axios.CancelToken = (parcelRequire("2sjhC"));

$8a2573892eafc323$var$axios.isCancel = (parcelRequire("ksuZT"));
// Expose all/spread
$8a2573892eafc323$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$8a2573892eafc323$var$axios.spread = (parcelRequire("av9gA"));
module.exports = $8a2573892eafc323$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $8a2573892eafc323$var$axios;

});
parcelRegister("2bBga", function(module, exports) {
'use strict';

var $djt5d = parcelRequire("djt5d");

var $c8cSi = parcelRequire("c8cSi");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $197982d8c7a73e5f$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $197982d8c7a73e5f$var$isArray(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $197982d8c7a73e5f$var$isArrayBuffer(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $197982d8c7a73e5f$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $197982d8c7a73e5f$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $197982d8c7a73e5f$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $197982d8c7a73e5f$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $197982d8c7a73e5f$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $197982d8c7a73e5f$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $197982d8c7a73e5f$var$isDate(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $197982d8c7a73e5f$var$isFile(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $197982d8c7a73e5f$var$isBlob(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $197982d8c7a73e5f$var$isFunction(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $197982d8c7a73e5f$var$isStream(val) {
    return $197982d8c7a73e5f$var$isObject(val) && $197982d8c7a73e5f$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $197982d8c7a73e5f$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $197982d8c7a73e5f$var$trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */ function $197982d8c7a73e5f$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $197982d8c7a73e5f$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($197982d8c7a73e5f$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $197982d8c7a73e5f$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === 'object' && typeof val === 'object') result[key] = $197982d8c7a73e5f$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$197982d8c7a73e5f$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $197982d8c7a73e5f$var$extend(a, b, thisArg) {
    $197982d8c7a73e5f$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $djt5d(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $197982d8c7a73e5f$var$isArray,
    isArrayBuffer: $197982d8c7a73e5f$var$isArrayBuffer,
    isBuffer: $c8cSi,
    isFormData: $197982d8c7a73e5f$var$isFormData,
    isArrayBufferView: $197982d8c7a73e5f$var$isArrayBufferView,
    isString: $197982d8c7a73e5f$var$isString,
    isNumber: $197982d8c7a73e5f$var$isNumber,
    isObject: $197982d8c7a73e5f$var$isObject,
    isUndefined: $197982d8c7a73e5f$var$isUndefined,
    isDate: $197982d8c7a73e5f$var$isDate,
    isFile: $197982d8c7a73e5f$var$isFile,
    isBlob: $197982d8c7a73e5f$var$isBlob,
    isFunction: $197982d8c7a73e5f$var$isFunction,
    isStream: $197982d8c7a73e5f$var$isStream,
    isURLSearchParams: $197982d8c7a73e5f$var$isURLSearchParams,
    isStandardBrowserEnv: $197982d8c7a73e5f$var$isStandardBrowserEnv,
    forEach: $197982d8c7a73e5f$var$forEach,
    merge: $197982d8c7a73e5f$var$merge,
    extend: $197982d8c7a73e5f$var$extend,
    trim: $197982d8c7a73e5f$var$trim
};

});
parcelRegister("djt5d", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});

parcelRegister("c8cSi", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

});


parcelRegister("6zSb1", function(module, exports) {
'use strict';

var $8SEIg = parcelRequire("8SEIg");

var $2bBga = parcelRequire("2bBga");

var $5Dm7L = parcelRequire("5Dm7L");

var $eQ5d8 = parcelRequire("eQ5d8");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $4ca0095817960ee3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $5Dm7L(),
        response: new $5Dm7L()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $4ca0095817960ee3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') config = $2bBga.merge({
        url: arguments[0]
    }, arguments[1]);
    config = $2bBga.merge($8SEIg, {
        method: 'get'
    }, this.defaults, config);
    config.method = config.method.toLowerCase();
    // Hook up interceptors middleware
    var chain = [
        $eQ5d8,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
// Provide aliases for supported request methods
$2bBga.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $4ca0095817960ee3$var$Axios.prototype[method] = function(url, config) {
        return this.request($2bBga.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$2bBga.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $4ca0095817960ee3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($2bBga.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $4ca0095817960ee3$var$Axios;

});
parcelRegister("8SEIg", function(module, exports) {
'use strict';

var $2bBga = parcelRequire("2bBga");

var $i16eu = parcelRequire("i16eu");
var $6772f29a7a4c17c5$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $6772f29a7a4c17c5$var$setContentTypeIfUnset(headers, value) {
    if (!$2bBga.isUndefined(headers) && $2bBga.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $6772f29a7a4c17c5$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("9VVcb"));
    return adapter;
}
var $6772f29a7a4c17c5$var$defaults = {
    adapter: $6772f29a7a4c17c5$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $i16eu(headers, 'Content-Type');
            if ($2bBga.isFormData(data) || $2bBga.isArrayBuffer(data) || $2bBga.isBuffer(data) || $2bBga.isStream(data) || $2bBga.isFile(data) || $2bBga.isBlob(data)) return data;
            if ($2bBga.isArrayBufferView(data)) return data.buffer;
            if ($2bBga.isURLSearchParams(data)) {
                $6772f29a7a4c17c5$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($2bBga.isObject(data)) {
                $6772f29a7a4c17c5$var$setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$6772f29a7a4c17c5$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$2bBga.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $6772f29a7a4c17c5$var$defaults.headers[method] = {};
});
$2bBga.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $6772f29a7a4c17c5$var$defaults.headers[method] = $2bBga.merge($6772f29a7a4c17c5$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $6772f29a7a4c17c5$var$defaults;

});
parcelRegister("i16eu", function(module, exports) {
'use strict';

var $2bBga = parcelRequire("2bBga");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $2bBga.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("9VVcb", function(module, exports) {
'use strict';

var $2bBga = parcelRequire("2bBga");

var $1TQad = parcelRequire("1TQad");

var $2RNjJ = parcelRequire("2RNjJ");

var $9cPEm = parcelRequire("9cPEm");

var $g3yOT = parcelRequire("g3yOT");

var $4bjXw = parcelRequire("4bjXw");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($2bBga.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password || '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        request.open(config.method.toUpperCase(), $2RNjJ(config.url, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $9cPEm(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $1TQad(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($4bjXw('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            reject($4bjXw('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($2bBga.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("kTwUV"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $g3yOT(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $2bBga.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (config.withCredentials) request.withCredentials = true;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("1TQad", function(module, exports) {
'use strict';

var $4bjXw = parcelRequire("4bjXw");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    // Note: status is not exposed by XDomainRequest
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($4bjXw('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("4bjXw", function(module, exports) {
'use strict';

var $56XJZ = parcelRequire("56XJZ");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $56XJZ(error, config, code, request, response);
};

});
parcelRegister("56XJZ", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    return error;
};

});



parcelRegister("2RNjJ", function(module, exports) {
'use strict';

var $2bBga = parcelRequire("2bBga");
function $2166c96446d6ea30$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($2bBga.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $2bBga.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($2bBga.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $2bBga.forEach(val, function parseValue(v) {
                if ($2bBga.isDate(v)) v = v.toISOString();
                else if ($2bBga.isObject(v)) v = JSON.stringify(v);
                parts.push($2166c96446d6ea30$var$encode(key) + '=' + $2166c96446d6ea30$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    return url;
};

});

parcelRegister("9cPEm", function(module, exports) {
'use strict';

var $2bBga = parcelRequire("2bBga");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $6b3d4ca234f68ddb$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $2bBga.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $2bBga.trim(line.substr(0, i)).toLowerCase();
        val = $2bBga.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $6b3d4ca234f68ddb$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("g3yOT", function(module, exports) {
'use strict';

var $2bBga = parcelRequire("2bBga");
module.exports = $2bBga.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $2bBga.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("kTwUV", function(module, exports) {
'use strict';

var $2bBga = parcelRequire("2bBga");
module.exports = $2bBga.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($2bBga.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($2bBga.isString(path)) cookie.push('path=' + path);
            if ($2bBga.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});



parcelRegister("5Dm7L", function(module, exports) {
'use strict';

var $2bBga = parcelRequire("2bBga");
function $41a1c1ac65ef962e$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $41a1c1ac65ef962e$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $41a1c1ac65ef962e$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $41a1c1ac65ef962e$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $2bBga.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $41a1c1ac65ef962e$var$InterceptorManager;

});

parcelRegister("eQ5d8", function(module, exports) {
'use strict';

var $2bBga = parcelRequire("2bBga");

var $bhEpd = parcelRequire("bhEpd");

var $ksuZT = parcelRequire("ksuZT");

var $8SEIg = parcelRequire("8SEIg");

var $iUwU6 = parcelRequire("iUwU6");

var $91vFE = parcelRequire("91vFE");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config);
    // Support baseURL config
    if (config.baseURL && !$iUwU6(config.url)) config.url = $91vFE(config.baseURL, config.url);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $bhEpd(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $2bBga.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});
    $2bBga.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $8SEIg.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $bhEpd(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$ksuZT(reason)) {
            $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $bhEpd(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("bhEpd", function(module, exports) {
'use strict';

var $2bBga = parcelRequire("2bBga");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $2bBga.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("ksuZT", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("iUwU6", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("91vFE", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});



parcelRegister("guIkb", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $c021d497680ea7c0$var$Cancel(message) {
    this.message = message;
}
$c021d497680ea7c0$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$c021d497680ea7c0$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $c021d497680ea7c0$var$Cancel;

});

parcelRegister("2sjhC", function(module, exports) {
'use strict';

var $guIkb = parcelRequire("guIkb");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $1c9d2783569136b3$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $guIkb(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $1c9d2783569136b3$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $1c9d2783569136b3$var$CancelToken.source = function source() {
    var cancel;
    var token = new $1c9d2783569136b3$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $1c9d2783569136b3$var$CancelToken;

});

parcelRegister("av9gA", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});


parcelRegister("fHlIx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $5F8v7 = parcelRequire("5F8v7");
function $b6dbb7c4da156a86$var$emptyFunction() {}
function $b6dbb7c4da156a86$var$emptyFunctionWithReset() {}
$b6dbb7c4da156a86$var$emptyFunctionWithReset.resetWarningCache = $b6dbb7c4da156a86$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $5F8v7) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $b6dbb7c4da156a86$var$emptyFunctionWithReset,
        resetWarningCache: $b6dbb7c4da156a86$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("5F8v7", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $41f76033c05285bb$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $41f76033c05285bb$var$ReactPropTypesSecret;

});


parcelRegister("aJtYT", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
exports = module.exports = (parcelRequire("gqJUW"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    'lightseagreen',
    'forestgreen',
    'goldenrod',
    'dodgerblue',
    'darkorchid',
    'crimson'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    r;
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("gqJUW", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("4g0hU"));
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Previous log timestamp.
 */ var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(var i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("4g0hU", function(module, exports) {
/**
 * Helpers.
 */ var $3198e1349f4f8c65$var$s = 1000;
var $3198e1349f4f8c65$var$m = $3198e1349f4f8c65$var$s * 60;
var $3198e1349f4f8c65$var$h = $3198e1349f4f8c65$var$m * 60;
var $3198e1349f4f8c65$var$d = $3198e1349f4f8c65$var$h * 24;
var $3198e1349f4f8c65$var$y = $3198e1349f4f8c65$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $3198e1349f4f8c65$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $3198e1349f4f8c65$var$fmtLong(val) : $3198e1349f4f8c65$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $3198e1349f4f8c65$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $3198e1349f4f8c65$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $3198e1349f4f8c65$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $3198e1349f4f8c65$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $3198e1349f4f8c65$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $3198e1349f4f8c65$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $3198e1349f4f8c65$var$fmtShort(ms) {
    if (ms >= $3198e1349f4f8c65$var$d) return Math.round(ms / $3198e1349f4f8c65$var$d) + 'd';
    if (ms >= $3198e1349f4f8c65$var$h) return Math.round(ms / $3198e1349f4f8c65$var$h) + 'h';
    if (ms >= $3198e1349f4f8c65$var$m) return Math.round(ms / $3198e1349f4f8c65$var$m) + 'm';
    if (ms >= $3198e1349f4f8c65$var$s) return Math.round(ms / $3198e1349f4f8c65$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $3198e1349f4f8c65$var$fmtLong(ms) {
    return $3198e1349f4f8c65$var$plural(ms, $3198e1349f4f8c65$var$d, 'day') || $3198e1349f4f8c65$var$plural(ms, $3198e1349f4f8c65$var$h, 'hour') || $3198e1349f4f8c65$var$plural(ms, $3198e1349f4f8c65$var$m, 'minute') || $3198e1349f4f8c65$var$plural(ms, $3198e1349f4f8c65$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $3198e1349f4f8c65$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});



var $8a748f85a9295de3$exports = {};
$parcel$extendImportMap({
    "3QLMC": "catelyn.e0c14f22.gif",
    "dwZxY": "logo-loading.8688c762.png",
    "bRYlD": "KasselLabsLogo.1f5d5cb9.png"
});

/*!
 * fullscreen-polyfill
 * 1.0.4 - 12/2/2020
 * https://github.com/nguyenj/fullscreen-polyfill#readme
 * (c) John Nguyen; MIT License
 */ var $42b26e93b86cb8e3$var$FullscreenPolyfill = function() {
    "use strict";
    var e = [
        "fullscreen",
        "fullscreenEnabled",
        "fullscreenElement",
        "fullscreenchange",
        "fullscreenerror",
        "exitFullscreen",
        "requestFullscreen"
    ], n = [
        "webkitIsFullScreen",
        "webkitFullscreenEnabled",
        "webkitFullscreenElement",
        "webkitfullscreenchange",
        "webkitfullscreenerror",
        "webkitExitFullscreen",
        "webkitRequestFullscreen"
    ], l = [
        "mozFullScreen",
        "mozFullScreenEnabled",
        "mozFullScreenElement",
        "mozfullscreenchange",
        "mozfullscreenerror",
        "mozCancelFullScreen",
        "mozRequestFullScreen"
    ], t = [
        "",
        "msFullscreenEnabled",
        "msFullscreenElement",
        "MSFullscreenChange",
        "MSFullscreenError",
        "msExitFullscreen",
        "msRequestFullscreen"
    ];
    document || (document = {});
    var u, c = (u = [
        e[1],
        n[1],
        l[1],
        t[1]
    ].find(function(e) {
        return document[e];
    }), [
        e,
        n,
        l,
        t
    ].find(function(e) {
        return e.find(function(e) {
            return e === u;
        });
    }) || []);
    function r(n, l) {
        document[e[0]] = document[c[0]] || !!document[c[2]] || !1, document[e[1]] = document[c[1]] || !1, document[e[2]] = document[c[2]] || null, document.dispatchEvent(new Event(n), l.target);
    }
    return void 0 === document[e[1]] && c.length ? (document[e[0]] = document[c[0]] || !!document[c[2]] || !1, document[e[1]] = document[c[1]] || !1, document[e[2]] = document[c[2]] || null, document.addEventListener(c[3], r.bind(document, e[3]), !1), document.addEventListener(c[4], r.bind(document, e[4]), !1), document[e[5]] = function() {
        return document[c[5]]();
    }, void (Element.prototype[e[6]] = function() {
        return this[c[6]].apply(this, arguments);
    })) : {};
}();



const $52dd19ffb329f39b$export$3e2b244719956741 = (handler)=>{
    if (document.attachEvent ? 'complete' === document.readyState : 'loading' !== document.readyState) handler();
    else document.addEventListener('DOMContentLoaded', handler);
};


var $d4dab640dcbe486c$exports = {};
'use strict';

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


parcelRequire("bh6RR");
var $47cfd4084854a574$exports = {};
'use strict';
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $7244391317ff913c$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $7244391317ff913c$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $7244391317ff913c$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $7244391317ff913c$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $7244391317ff913c$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $7244391317ff913c$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $7244391317ff913c$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $7244391317ff913c$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $7244391317ff913c$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $7244391317ff913c$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $7244391317ff913c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $7244391317ff913c$var$root = $7244391317ff913c$var$freeGlobal || $7244391317ff913c$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $7244391317ff913c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7244391317ff913c$var$objectToString = $7244391317ff913c$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7244391317ff913c$var$nativeMax = Math.max, $7244391317ff913c$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $7244391317ff913c$var$now = function() {
    return $7244391317ff913c$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $7244391317ff913c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($7244391317ff913c$var$FUNC_ERROR_TEXT);
    wait = $7244391317ff913c$var$toNumber(wait) || 0;
    if ($7244391317ff913c$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $7244391317ff913c$var$nativeMax($7244391317ff913c$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $7244391317ff913c$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $7244391317ff913c$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($7244391317ff913c$var$now());
    }
    function debounced() {
        var time = $7244391317ff913c$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $7244391317ff913c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($7244391317ff913c$var$FUNC_ERROR_TEXT);
    if ($7244391317ff913c$var$isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $7244391317ff913c$var$debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7244391317ff913c$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $7244391317ff913c$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $7244391317ff913c$var$isSymbol(value) {
    return typeof value == 'symbol' || $7244391317ff913c$var$isObjectLike(value) && $7244391317ff913c$var$objectToString.call(value) == $7244391317ff913c$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $7244391317ff913c$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($7244391317ff913c$var$isSymbol(value)) return $7244391317ff913c$var$NAN;
    if ($7244391317ff913c$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $7244391317ff913c$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($7244391317ff913c$var$reTrim, '');
    var isBinary = $7244391317ff913c$var$reIsBinary.test(value);
    return isBinary || $7244391317ff913c$var$reIsOctal.test(value) ? $7244391317ff913c$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $7244391317ff913c$var$reIsBadHex.test(value) ? $7244391317ff913c$var$NAN : +value;
}
$7244391317ff913c$exports = $7244391317ff913c$var$throttle;


const $ba1a0615ca5fa74d$export$f591db0547f88493 = 1448;
const $ba1a0615ca5fa74d$export$7bed3f195b53d466 = ()=>({
        overlay_content: {
            fontSize: 37,
            letterSpacing: 8
        },
        texts: [
            /* #text0 */ {
                top: 384,
                left: 746,
                width: 669,
                height: 300
            },
            /* #text1 */ {
                top: 380,
                left: 122,
                width: 669,
                height: 300
            },
            /* #text2 */ {
                top: 377,
                left: 531,
                width: 868,
                height: 300
            },
            /* #text3 */ {
                top: 507,
                left: 672,
                width: 749,
                height: 300
            },
            /* #text4 */ {
                top: 380,
                left: 30,
                width: 749,
                height: 300
            },
            /* #text5 */ {
                top: 561,
                left: 764,
                width: 659,
                height: 250
            },
            /* #text6 */ {
                top: 319,
                left: 17,
                width: 687,
                height: 467
            },
            /* #text7 */ {
                top: 295,
                left: 23,
                width: 828,
                height: 493
            },
            /* #text8 */ {
                top: 277,
                left: 620,
                width: 789,
                height: 510
            },
            /* #text9 */ {
                top: 329,
                left: 19,
                width: 1039,
                height: 470
            },
            /* #text10 */ {
                top: 245,
                left: 639,
                width: 791,
                height: 540
            },
            /* #text11 */ {
                top: 327,
                left: 700,
                width: 719,
                height: 457
            },
            /* #text12 */ {
                top: 281,
                left: 706,
                width: 719,
                height: 520
            },
            /* #text13 */ {
                top: 278,
                left: 26,
                width: 1089,
                height: 520
            },
            /* #text14 */ {
                top: 334,
                left: 20,
                width: 1009,
                height: 440
            },
            /* #text15 */ {
                top: 26,
                left: 26,
                width: 933,
                height: 396
            },
            /* #text16 */ {
                top: 389,
                left: 26,
                width: 939,
                height: 400
            },
            /* #text17 */ {
                top: 389,
                left: 26,
                width: 1010,
                height: 400
            },
            /* #text18 */ {
                top: 337,
                left: 26,
                width: 939,
                height: 453
            },
            /* #text19 */ {
                top: 293,
                left: 749,
                width: 669,
                height: 500
            },
            /* #text20 */ {
                top: 290,
                left: 26,
                width: 949,
                height: 500
            },
            /* #text21 */ {
                top: 288,
                left: 26,
                width: 791,
                height: 500
            },
            /* #text22 */ {
                top: 289,
                left: 729,
                width: 689,
                height: 500
            },
            /* #text23 */ {
                top: 335,
                left: 26,
                width: 829,
                height: 459
            },
            /* #text24 */ {
                top: 290,
                left: 26,
                width: 1219,
                height: 500
            },
            /* #text25 */ {
                top: 251,
                left: 26,
                width: 1122,
                height: 550
            },
            /* #text26 */ {
                // Game of Thrones Logo
                top: 264,
                left: 0,
                width: 1448,
                height: 283
            },
            /* #text27 */ {
                top: 26,
                left: 26,
                width: 1400,
                height: 767
            },
            /* #text28 */ {
                top: 26,
                left: 26,
                width: 1400,
                height: 767
            }
        ]
    });


const $5d7b1aa2c3e4450e$var$VIDEO_RATIO = 16 / 9;
const $5d7b1aa2c3e4450e$var$px = (value)=>`${value}px`;
const $5d7b1aa2c3e4450e$var$calcRelativeValue = (value, videoWidth)=>$5d7b1aa2c3e4450e$var$px(value / (0, $ba1a0615ca5fa74d$export$f591db0547f88493) * videoWidth);
const $5d7b1aa2c3e4450e$var$calcVideoSize = (viewportHeight, viewportWidth)=>{
    const viewportRatio = viewportWidth / viewportHeight;
    const videoSize = {
        height: 0,
        width: 0
    };
    if (viewportHeight > viewportWidth) {
        if (viewportRatio > $5d7b1aa2c3e4450e$var$VIDEO_RATIO) {
            videoSize.height = viewportHeight;
            return videoSize;
        }
        videoSize.width = viewportWidth;
        return videoSize;
    }
    if (viewportRatio > $5d7b1aa2c3e4450e$var$VIDEO_RATIO) {
        videoSize.height = viewportHeight;
        return videoSize;
    }
    videoSize.width = viewportWidth;
    return videoSize;
};
const $5d7b1aa2c3e4450e$var$calcViewportSize = (videoContainer)=>{
    const isFullscreen = document.fullscreenElement !== null;
    if (isFullscreen) return {
        height: window.innerHeight,
        width: window.innerWidth
    };
    return {
        height: videoContainer.offsetHeight,
        width: videoContainer.offsetWidth
    };
};
const $5d7b1aa2c3e4450e$var$getAnimationConfiguration = ()=>{
    const configurations = (0, $ba1a0615ca5fa74d$export$7bed3f195b53d466)();
    const videoContainer = document.querySelector('.video-container');
    if (videoContainer) {
        const viewportSize = $5d7b1aa2c3e4450e$var$calcViewportSize(videoContainer);
        const video = $5d7b1aa2c3e4450e$var$calcVideoSize(viewportSize.height, viewportSize.width);
        video.width = video.width || (video.height * $5d7b1aa2c3e4450e$var$VIDEO_RATIO).toFixed(0);
        video.height = video.height || (video.width / $5d7b1aa2c3e4450e$var$VIDEO_RATIO).toFixed(0);
        configurations.overlay = {
            width: $5d7b1aa2c3e4450e$var$px(video.width),
            height: $5d7b1aa2c3e4450e$var$px(video.height),
            top: $5d7b1aa2c3e4450e$var$px((viewportSize.height - video.height) / 2),
            left: $5d7b1aa2c3e4450e$var$px((viewportSize.width - video.width) / 2)
        };
        const defaultFontSize = configurations.overlay_content.fontSize;
        const relativeFontSize = $5d7b1aa2c3e4450e$var$calcRelativeValue(defaultFontSize, video.width);
        configurations.overlay_content.fontSize = relativeFontSize;
        const defaultLetterSpacing = configurations.overlay_content.letterSpacing;
        const relativeLetterSpacing = $5d7b1aa2c3e4450e$var$calcRelativeValue(defaultLetterSpacing, video.width);
        configurations.overlay_content.letterSpacing = relativeLetterSpacing;
        configurations.texts = configurations.texts.map((text)=>{
            const top = $5d7b1aa2c3e4450e$var$calcRelativeValue(text.top, video.width);
            const left = $5d7b1aa2c3e4450e$var$calcRelativeValue(text.left, video.width);
            const width = text.width ? $5d7b1aa2c3e4450e$var$calcRelativeValue(text.width, video.width) : '';
            const height = text.height ? $5d7b1aa2c3e4450e$var$calcRelativeValue(text.height, video.width) : '';
            return {
                ...text,
                top: top,
                left: left,
                width: width,
                height: height
            };
        });
    }
    return configurations;
};
var $5d7b1aa2c3e4450e$export$2e2bcd8739ae039 = $5d7b1aa2c3e4450e$var$getAnimationConfiguration;



parcelRequire("bh6RR");
var $0844b15ea8db3747$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $0844b15ea8db3747$var$__DEV__ = false;
var $0844b15ea8db3747$var$warning = function() {};
if ($0844b15ea8db3747$var$__DEV__) {
    var $0844b15ea8db3747$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $0844b15ea8db3747$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $0844b15ea8db3747$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$0844b15ea8db3747$exports = $0844b15ea8db3747$var$warning;



var $bh6RR = parcelRequire("bh6RR");
var $aa40b802dd2fccfc$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa40b802dd2fccfc$var$ReactIs, $aa40b802dd2fccfc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$aa40b802dd2fccfc$exports = (parcelRequire("2tbKl"))();


function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    return $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $39ab41060f0dd572$export$2e2bcd8739ae039.apply(null, arguments);
}


function $5b8b43e396b05c37$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $5b8b43e396b05c37$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $5b8b43e396b05c37$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $5b8b43e396b05c37$var$isAbsolute(to);
    var isFromAbs = from && $5b8b43e396b05c37$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $5b8b43e396b05c37$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $5b8b43e396b05c37$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $5b8b43e396b05c37$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $5b8b43e396b05c37$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$5b8b43e396b05c37$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $5b8b43e396b05c37$export$2e2bcd8739ae039 = $5b8b43e396b05c37$var$resolvePathname;


function $f06dd50279713a67$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $f06dd50279713a67$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $f06dd50279713a67$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $f06dd50279713a67$var$valueOf(a);
        var bValue = $f06dd50279713a67$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $f06dd50279713a67$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $f06dd50279713a67$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $f06dd50279713a67$export$2e2bcd8739ae039 = $f06dd50279713a67$var$valueEqual;



var $1e4fba22ff93a100$var$isProduction = true;
var $1e4fba22ff93a100$var$prefix = 'Invariant failed';
function $1e4fba22ff93a100$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($1e4fba22ff93a100$var$isProduction) throw new Error($1e4fba22ff93a100$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($1e4fba22ff93a100$var$prefix, ": ").concat(provided) : $1e4fba22ff93a100$var$prefix;
    throw new Error(value);
}


function $32e4998d9dcb6f96$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $32e4998d9dcb6f96$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $32e4998d9dcb6f96$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $32e4998d9dcb6f96$var$stripBasename(path, prefix) {
    return $32e4998d9dcb6f96$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $32e4998d9dcb6f96$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $32e4998d9dcb6f96$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $32e4998d9dcb6f96$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $32e4998d9dcb6f96$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $5b8b43e396b05c37$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $32e4998d9dcb6f96$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $f06dd50279713a67$export$2e2bcd8739ae039)(a.state, b.state);
}
function $32e4998d9dcb6f96$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $32e4998d9dcb6f96$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $32e4998d9dcb6f96$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $32e4998d9dcb6f96$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $32e4998d9dcb6f96$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $32e4998d9dcb6f96$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $32e4998d9dcb6f96$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $32e4998d9dcb6f96$var$PopStateEvent = 'popstate';
var $32e4998d9dcb6f96$var$HashChangeEvent = 'hashchange';
function $32e4998d9dcb6f96$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $32e4998d9dcb6f96$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$32e4998d9dcb6f96$var$canUseDOM && (0, $1e4fba22ff93a100$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $32e4998d9dcb6f96$var$supportsHistory();
    var needsHashChangeListener = !$32e4998d9dcb6f96$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $32e4998d9dcb6f96$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $32e4998d9dcb6f96$var$stripTrailingSlash($32e4998d9dcb6f96$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $32e4998d9dcb6f96$var$stripBasename(path, basename);
        return $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $32e4998d9dcb6f96$var$createTransitionManager();
    function setState(nextState) {
        (0, $39ab41060f0dd572$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($32e4998d9dcb6f96$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($32e4998d9dcb6f96$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($32e4998d9dcb6f96$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $32e4998d9dcb6f96$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($32e4998d9dcb6f96$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($32e4998d9dcb6f96$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($32e4998d9dcb6f96$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($32e4998d9dcb6f96$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $32e4998d9dcb6f96$var$HashChangeEvent$1 = 'hashchange';
var $32e4998d9dcb6f96$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $32e4998d9dcb6f96$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $32e4998d9dcb6f96$var$stripLeadingSlash,
        decodePath: $32e4998d9dcb6f96$var$addLeadingSlash
    },
    slash: {
        encodePath: $32e4998d9dcb6f96$var$addLeadingSlash,
        decodePath: $32e4998d9dcb6f96$var$addLeadingSlash
    }
};
function $32e4998d9dcb6f96$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $32e4998d9dcb6f96$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $32e4998d9dcb6f96$var$pushHashPath(path) {
    window.location.hash = path;
}
function $32e4998d9dcb6f96$var$replaceHashPath(path) {
    window.location.replace($32e4998d9dcb6f96$var$stripHash(window.location.href) + '#' + path);
}
function $32e4998d9dcb6f96$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$32e4998d9dcb6f96$var$canUseDOM && (0, $1e4fba22ff93a100$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $32e4998d9dcb6f96$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $32e4998d9dcb6f96$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $32e4998d9dcb6f96$var$stripTrailingSlash($32e4998d9dcb6f96$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $32e4998d9dcb6f96$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($32e4998d9dcb6f96$var$getHashPath());
        if (basename) path = $32e4998d9dcb6f96$var$stripBasename(path, basename);
        return $32e4998d9dcb6f96$export$90c043f1c57770b8(path);
    }
    var transitionManager = $32e4998d9dcb6f96$var$createTransitionManager();
    function setState(nextState) {
        (0, $39ab41060f0dd572$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $32e4998d9dcb6f96$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $32e4998d9dcb6f96$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $32e4998d9dcb6f96$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($32e4998d9dcb6f96$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($32e4998d9dcb6f96$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $32e4998d9dcb6f96$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $32e4998d9dcb6f96$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $32e4998d9dcb6f96$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $32e4998d9dcb6f96$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $32e4998d9dcb6f96$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $32e4998d9dcb6f96$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $32e4998d9dcb6f96$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $32e4998d9dcb6f96$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($32e4998d9dcb6f96$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $32e4998d9dcb6f96$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $32e4998d9dcb6f96$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $32e4998d9dcb6f96$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($32e4998d9dcb6f96$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($32e4998d9dcb6f96$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($32e4998d9dcb6f96$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $32e4998d9dcb6f96$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $32e4998d9dcb6f96$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $32e4998d9dcb6f96$var$createTransitionManager();
    function setState(nextState) {
        (0, $39ab41060f0dd572$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $32e4998d9dcb6f96$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $32e4998d9dcb6f96$export$90c043f1c57770b8(entry, undefined, createKey()) : $32e4998d9dcb6f96$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $32e4998d9dcb6f96$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $32e4998d9dcb6f96$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $32e4998d9dcb6f96$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}


// Written in this round about way for babel-transform-imports

var $fb89ab44c0e57c1a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $fb89ab44c0e57c1a$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$fb89ab44c0e57c1a$exports = $fb89ab44c0e57c1a$var$invariant;



var $bh6RR = parcelRequire("bh6RR");

var $56302628598d017e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $56302628598d017e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $56302628598d017e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $56302628598d017e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $56302628598d017e$var$Router = function(_React$Component) {
    $56302628598d017e$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $56302628598d017e$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $56302628598d017e$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $56302628598d017e$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $56302628598d017e$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($0844b15ea8db3747$exports)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$56302628598d017e$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).node
};
$56302628598d017e$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$56302628598d017e$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object.isRequired
};
var $56302628598d017e$export$2e2bcd8739ae039 = $56302628598d017e$var$Router;


var $80416866bf5b41dc$export$2e2bcd8739ae039 = (0, $56302628598d017e$export$2e2bcd8739ae039);


function $691e9536716fb7ca$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $691e9536716fb7ca$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $691e9536716fb7ca$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $691e9536716fb7ca$var$HashRouter = function(_React$Component) {
    $691e9536716fb7ca$var$_inherits(HashRouter, _React$Component);
    function HashRouter() {
        var _temp, _this, _ret;
        $691e9536716fb7ca$var$_classCallCheck(this, HashRouter);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $691e9536716fb7ca$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.history = (0, $32e4998d9dcb6f96$export$b71fdd3798280242)(_this.props), _temp), $691e9536716fb7ca$var$_possibleConstructorReturn(_this, _ret);
    }
    HashRouter.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($0844b15ea8db3747$exports)))(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { HashRouter as Router }`.");
    };
    HashRouter.prototype.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $80416866bf5b41dc$export$2e2bcd8739ae039), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$691e9536716fb7ca$var$HashRouter.propTypes = {
    basename: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    getUserConfirmation: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    hashType: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "hashbang",
        "noslash",
        "slash"
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).node
};
var $691e9536716fb7ca$export$2e2bcd8739ae039 = $691e9536716fb7ca$var$HashRouter;

// Written in this round about way for babel-transform-imports



var $bh6RR = parcelRequire("bh6RR");

var $eeac86488245adff$exports = {};
var $713d1c6c66d58098$exports = {};
$713d1c6c66d58098$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $eeac86488245adff$exports = $eeac86488245adff$var$pathToRegexp;
$eeac86488245adff$exports.parse = $eeac86488245adff$var$parse;
$eeac86488245adff$exports.compile = $eeac86488245adff$var$compile;
$eeac86488245adff$exports.tokensToFunction = $eeac86488245adff$var$tokensToFunction;
$eeac86488245adff$exports.tokensToRegExp = $eeac86488245adff$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $eeac86488245adff$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $eeac86488245adff$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $eeac86488245adff$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $eeac86488245adff$var$escapeGroup(pattern) : asterisk ? '.*' : $eeac86488245adff$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $eeac86488245adff$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $eeac86488245adff$var$escapeString(delimiter) + ']+?';
    return $eeac86488245adff$var$escapeString(prevText) + '|(?:(?!' + $eeac86488245adff$var$escapeString(prevText) + ')[^' + $eeac86488245adff$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $eeac86488245adff$var$compile(str, options) {
    return $eeac86488245adff$var$tokensToFunction($eeac86488245adff$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $eeac86488245adff$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $eeac86488245adff$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $eeac86488245adff$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $eeac86488245adff$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $eeac86488245adff$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($713d1c6c66d58098$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $eeac86488245adff$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $eeac86488245adff$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $eeac86488245adff$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $eeac86488245adff$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $eeac86488245adff$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $eeac86488245adff$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $eeac86488245adff$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $eeac86488245adff$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($eeac86488245adff$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $eeac86488245adff$var$flags(options));
    return $eeac86488245adff$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $eeac86488245adff$var$stringToRegexp(path, keys, options) {
    return $eeac86488245adff$var$tokensToRegExp($eeac86488245adff$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $eeac86488245adff$var$tokensToRegExp(tokens, keys, options) {
    if (!$713d1c6c66d58098$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $eeac86488245adff$var$escapeString(token);
        else {
            var prefix = $eeac86488245adff$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $eeac86488245adff$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $eeac86488245adff$var$attachKeys(new RegExp('^' + route, $eeac86488245adff$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $eeac86488245adff$var$pathToRegexp(path, keys, options) {
    if (!$713d1c6c66d58098$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $eeac86488245adff$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($713d1c6c66d58098$exports(path)) return $eeac86488245adff$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $eeac86488245adff$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $eb8d1c2e03f2680a$var$patternCache = {};
var $eb8d1c2e03f2680a$var$cacheLimit = 10000;
var $eb8d1c2e03f2680a$var$cacheCount = 0;
var $eb8d1c2e03f2680a$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $eb8d1c2e03f2680a$var$patternCache[cacheKey] || ($eb8d1c2e03f2680a$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($eeac86488245adff$exports)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($eb8d1c2e03f2680a$var$cacheCount < $eb8d1c2e03f2680a$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $eb8d1c2e03f2680a$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $eb8d1c2e03f2680a$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $eb8d1c2e03f2680a$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $eb8d1c2e03f2680a$export$2e2bcd8739ae039 = $eb8d1c2e03f2680a$var$matchPath;


var $b688a70dfb811d67$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $b688a70dfb811d67$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b688a70dfb811d67$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b688a70dfb811d67$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $b688a70dfb811d67$var$isEmptyChildren = function isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var $b688a70dfb811d67$var$Route = function(_React$Component) {
    $b688a70dfb811d67$var$_inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        $b688a70dfb811d67$var$_classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $b688a70dfb811d67$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), $b688a70dfb811d67$var$_possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: $b688a70dfb811d67$var$_extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, $eb8d1c2e03f2680a$export$2e2bcd8739ae039)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($0844b15ea8db3747$exports)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($0844b15ea8db3747$exports)))(!(this.props.component && this.props.children && !$b688a70dfb811d67$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($0844b15ea8db3747$exports)))(!(this.props.render && this.props.children && !$b688a70dfb811d67$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, (/*@__PURE__*/$parcel$interopDefault($0844b15ea8db3747$exports)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($0844b15ea8db3747$exports)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !$b688a70dfb811d67$var$isEmptyChildren(children)) return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.only(children);
        return null;
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$b688a70dfb811d67$var$Route.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
    component: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).node
    ]),
    location: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$b688a70dfb811d67$var$Route.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
    })
};
$b688a70dfb811d67$var$Route.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object.isRequired
};
var $b688a70dfb811d67$export$2e2bcd8739ae039 = $b688a70dfb811d67$var$Route;


var $fcf57e8865974c97$export$2e2bcd8739ae039 = (0, $b688a70dfb811d67$export$2e2bcd8739ae039);

// Written in this round about way for babel-transform-imports

var $bh6RR = parcelRequire("bh6RR");




function $b532b9fb207762d0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b532b9fb207762d0$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b532b9fb207762d0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */ var $b532b9fb207762d0$var$Switch = function(_React$Component) {
    $b532b9fb207762d0$var$_inherits(Switch, _React$Component);
    function Switch() {
        $b532b9fb207762d0$var$_classCallCheck(this, Switch);
        return $b532b9fb207762d0$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Switch.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(this.context.router, "You should not use <Switch> outside a <Router>");
    };
    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($0844b15ea8db3747$exports)))(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($0844b15ea8db3747$exports)))(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };
    Switch.prototype.render = function render() {
        var route = this.context.router.route;
        var children = this.props.children;
        var location = this.props.location || route.location;
        var match = void 0, child = void 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.forEach(children, function(element) {
            if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).isValidElement(element)) {
                var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                var path = pathProp || from;
                child = element;
                match = (0, $eb8d1c2e03f2680a$export$2e2bcd8739ae039)(location.pathname, {
                    path: path,
                    exact: exact,
                    strict: strict,
                    sensitive: sensitive
                }, route.match);
            }
        });
        return match ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(child, {
            location: location,
            computedMatch: match
        }) : null;
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$b532b9fb207762d0$var$Switch.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).shape({
        route: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object.isRequired
    }).isRequired
};
$b532b9fb207762d0$var$Switch.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
var $b532b9fb207762d0$export$2e2bcd8739ae039 = $b532b9fb207762d0$var$Switch;


var $43cd07aecf347b85$export$2e2bcd8739ae039 = (0, $b532b9fb207762d0$export$2e2bcd8739ae039);



var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

var $770bbfe5492d7fd4$exports = {};
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $770bbfe5492d7fd4$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $770bbfe5492d7fd4$var$defineProperty = Object.defineProperty;
var $770bbfe5492d7fd4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $770bbfe5492d7fd4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $770bbfe5492d7fd4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $770bbfe5492d7fd4$var$getPrototypeOf = Object.getPrototypeOf;
var $770bbfe5492d7fd4$var$objectPrototype = $770bbfe5492d7fd4$var$getPrototypeOf && $770bbfe5492d7fd4$var$getPrototypeOf(Object);
function $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($770bbfe5492d7fd4$var$objectPrototype) {
            var inheritedComponent = $770bbfe5492d7fd4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $770bbfe5492d7fd4$var$objectPrototype) $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $770bbfe5492d7fd4$var$getOwnPropertyNames(sourceComponent);
        if ($770bbfe5492d7fd4$var$getOwnPropertySymbols) keys = keys.concat($770bbfe5492d7fd4$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$770bbfe5492d7fd4$var$REACT_STATICS[key] && !$770bbfe5492d7fd4$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $770bbfe5492d7fd4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $770bbfe5492d7fd4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
$770bbfe5492d7fd4$exports = $770bbfe5492d7fd4$var$hoistNonReactStatics;



var $df938650094f2b43$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $df938650094f2b43$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/**
 * A public higher-order component to access the imperative API
 */ var $df938650094f2b43$var$withRouter = function withRouter(Component) {
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = $df938650094f2b43$var$_objectWithoutProperties(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $b688a70dfb811d67$export$2e2bcd8739ae039), {
            children: function children(routeComponentProps) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, $df938650094f2b43$var$_extends({}, remainingProps, routeComponentProps, {
                    ref: wrappedComponentRef
                }));
            }
        });
    };
    C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    C.WrappedComponent = Component;
    C.propTypes = {
        wrappedComponentRef: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($770bbfe5492d7fd4$exports)))(C, Component);
};
var $df938650094f2b43$export$2e2bcd8739ae039 = $df938650094f2b43$var$withRouter;


window.dataLayer = window.dataLayer || [];
function $2962d698ef21dc24$var$gtag() {
    window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
}
const $2962d698ef21dc24$var$gtagKey = 'UA-116931857-7';
$2962d698ef21dc24$var$gtag('js', new Date());
const $2962d698ef21dc24$var$sendGAPageView = ()=>{
    $2962d698ef21dc24$var$gtag('config', $2962d698ef21dc24$var$gtagKey, {
        page_path: `${window.location.pathname}${window.location.search}${window.location.hash}`
    });
};
var $2962d698ef21dc24$export$2e2bcd8739ae039 = $2962d698ef21dc24$var$sendGAPageView;


class $97c042ebbd22f932$var$GAListener extends (0, $bh6RR.PureComponent) {
    static propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).node.isRequired,
        history: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
    };
    componentDidMount() {
        const { history: history } = this.props;
        (0, $2962d698ef21dc24$export$2e2bcd8739ae039)();
        history.listen((0, $2962d698ef21dc24$export$2e2bcd8739ae039));
    }
    render() {
        return this.props.children;
    }
}
var $97c042ebbd22f932$export$2e2bcd8739ae039 = (0, $df938650094f2b43$export$2e2bcd8739ae039)($97c042ebbd22f932$var$GAListener);




var $bh6RR = parcelRequire("bh6RR");


var $17bc0d4f42435b88$exports = {};
'use strict';
Object.defineProperty($17bc0d4f42435b88$exports, "__esModule", {
    value: true
});
var $17bc0d4f42435b88$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bh6RR = parcelRequire("bh6RR");
var $17bc0d4f42435b88$var$_react2 = $17bc0d4f42435b88$var$_interopRequireDefault($bh6RR);
function $17bc0d4f42435b88$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Generates a HOC to wrap a component with context values in props.
 *
 * @returns {Component} A HOC which pass context state into props to child component.
 * @param {Object} ContextProvider an Object with `Consumer` attribute, like the Context object or a Custom Provider
 * @param {Function} mapContextToProps a functiona that receives the context from `Context.Consumer` and returns a object to be used as props for the wrapped component.
 */ var $17bc0d4f42435b88$var$connectContext = function connectContext(ContextProvider, mapContextToProps) {
    return function(Component) {
        var WrappedContextComponent = function WrappedContextComponent(props) {
            return $17bc0d4f42435b88$var$_react2.default.createElement(ContextProvider.Consumer, null, function(context) {
                return $17bc0d4f42435b88$var$_react2.default.createElement(Component, $17bc0d4f42435b88$var$_extends({}, mapContextToProps(context), props));
            });
        };
        var componentName = Component.displayName || Component.name;
        var providerName = ContextProvider.displayName || ContextProvider.name;
        var wrapperName = providerName + '(' + componentName + ')';
        WrappedContextComponent.displayName = wrapperName;
        return WrappedContextComponent;
    };
};
$17bc0d4f42435b88$exports.default = $17bc0d4f42435b88$var$connectContext;


var $70d54b79d383c562$var$key = {
    fullscreenEnabled: 0,
    fullscreenElement: 1,
    requestFullscreen: 2,
    exitFullscreen: 3,
    fullscreenchange: 4,
    fullscreenerror: 5,
    fullscreen: 6
};
var $70d54b79d383c562$var$webkit = [
    'webkitFullscreenEnabled',
    'webkitFullscreenElement',
    'webkitRequestFullscreen',
    'webkitExitFullscreen',
    'webkitfullscreenchange',
    'webkitfullscreenerror',
    '-webkit-full-screen'
];
var $70d54b79d383c562$var$moz = [
    'mozFullScreenEnabled',
    'mozFullScreenElement',
    'mozRequestFullScreen',
    'mozCancelFullScreen',
    'mozfullscreenchange',
    'mozfullscreenerror',
    '-moz-full-screen'
];
var $70d54b79d383c562$var$ms = [
    'msFullscreenEnabled',
    'msFullscreenElement',
    'msRequestFullscreen',
    'msExitFullscreen',
    'MSFullscreenChange',
    'MSFullscreenError',
    '-ms-fullscreen'
];
// so it doesn't throw if no window or document
var $70d54b79d383c562$var$document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
var $70d54b79d383c562$var$vendor = 'fullscreenEnabled' in $70d54b79d383c562$var$document && Object.keys($70d54b79d383c562$var$key) || $70d54b79d383c562$var$webkit[0] in $70d54b79d383c562$var$document && $70d54b79d383c562$var$webkit || $70d54b79d383c562$var$moz[0] in $70d54b79d383c562$var$document && $70d54b79d383c562$var$moz || $70d54b79d383c562$var$ms[0] in $70d54b79d383c562$var$document && $70d54b79d383c562$var$ms || [];
var $70d54b79d383c562$var$fscreen = {
    requestFullscreen: function(element) {
        return element[$70d54b79d383c562$var$vendor[$70d54b79d383c562$var$key.requestFullscreen]]();
    },
    requestFullscreenFunction: function(element) {
        return element[$70d54b79d383c562$var$vendor[$70d54b79d383c562$var$key.requestFullscreen]];
    },
    get exitFullscreen () {
        return $70d54b79d383c562$var$document[$70d54b79d383c562$var$vendor[$70d54b79d383c562$var$key.exitFullscreen]].bind($70d54b79d383c562$var$document);
    },
    get fullscreenPseudoClass () {
        return ":" + $70d54b79d383c562$var$vendor[$70d54b79d383c562$var$key.fullscreen];
    },
    addEventListener: function(type, handler1, options) {
        return $70d54b79d383c562$var$document.addEventListener($70d54b79d383c562$var$vendor[$70d54b79d383c562$var$key[type]], handler1, options);
    },
    removeEventListener: function(type, handler1, options) {
        return $70d54b79d383c562$var$document.removeEventListener($70d54b79d383c562$var$vendor[$70d54b79d383c562$var$key[type]], handler1, options);
    },
    get fullscreenEnabled () {
        return Boolean($70d54b79d383c562$var$document[$70d54b79d383c562$var$vendor[$70d54b79d383c562$var$key.fullscreenEnabled]]);
    },
    set fullscreenEnabled (val){},
    get fullscreenElement () {
        return $70d54b79d383c562$var$document[$70d54b79d383c562$var$vendor[$70d54b79d383c562$var$key.fullscreenElement]];
    },
    set fullscreenElement (val){},
    get onfullscreenchange () {
        return $70d54b79d383c562$var$document[("on" + $70d54b79d383c562$var$vendor[$70d54b79d383c562$var$key.fullscreenchange]).toLowerCase()];
    },
    set onfullscreenchange (handler){
        return $70d54b79d383c562$var$document[("on" + $70d54b79d383c562$var$vendor[$70d54b79d383c562$var$key.fullscreenchange]).toLowerCase()] = handler;
    },
    get onfullscreenerror () {
        return $70d54b79d383c562$var$document[("on" + $70d54b79d383c562$var$vendor[$70d54b79d383c562$var$key.fullscreenerror]).toLowerCase()];
    },
    set onfullscreenerror (handler){
        return $70d54b79d383c562$var$document[("on" + $70d54b79d383c562$var$vendor[$70d54b79d383c562$var$key.fullscreenerror]).toLowerCase()] = handler;
    }
};
var $70d54b79d383c562$export$2e2bcd8739ae039 = $70d54b79d383c562$var$fscreen;




var $bh6RR = parcelRequire("bh6RR");


var $1DYgm = parcelRequire("1DYgm");
var $726d757834788151$exports = {};
/*! @license DOMPurify 3.3.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.1/LICENSE */ (function(global, factory) {
    $726d757834788151$exports = factory();
})($726d757834788151$exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'search',
        'section',
        'select',
        'shadow',
        'slot',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'enterkeyhint',
        'exportparts',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'inputmode',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'part',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'exportparts',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inert',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'part',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'mask-type',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.3.1';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (cfg.ADD_ATTR) {
                if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            if (cfg.ADD_FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName])) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === 'value' ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title|textarea)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && stringMatch(value, 'href')) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {
                    _removeAttribute(name, currentNode);
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});



var $c372e7bb106ee43b$exports = {};
/*!
* sweetalert2 v7.17.0
* Released under the MIT License.
*/ (function(global, factory) {
    $c372e7bb106ee43b$exports = factory();
})($c372e7bb106ee43b$exports, function() {
    'use strict';
    var consolePrefix = 'SweetAlert2:';
    /**
 * Filter the unique values into a new array
 * @param arr
 */ var uniqueArray = function uniqueArray(arr) {
        var result = [];
        for(var i = 0; i < arr.length; i++)if (result.indexOf(arr[i]) === -1) result.push(arr[i]);
        return result;
    };
    /**
 * Converts `inputOptions` into an array of `[value, label]`s
 * @param inputOptions
 */ var formatInputOptions = function formatInputOptions(inputOptions) {
        var result = [];
        if (inputOptions instanceof Map) inputOptions.forEach(function(value, key) {
            result.push([
                key,
                value
            ]);
        });
        else Object.keys(inputOptions).forEach(function(key) {
            result.push([
                key,
                inputOptions[key]
            ]);
        });
        return result;
    };
    /**
 * Standardise console warnings
 * @param message
 */ var warn = function warn(message) {
        console.warn(consolePrefix + ' ' + message);
    };
    /**
 * Standardise console errors
 * @param message
 */ var error = function error(message) {
        console.error(consolePrefix + ' ' + message);
    };
    /**
 * Private global state for `warnOnce`
 * @type {Array}
 * @private
 */ var previousWarnOnceMessages = [];
    /**
 * Show a console warning, but only if it hasn't already been shown
 * @param message
 */ var warnOnce = function warnOnce(message) {
        if (!(previousWarnOnceMessages.indexOf(message) !== -1)) {
            previousWarnOnceMessages.push(message);
            warn(message);
        }
    };
    /**
 * If `arg` is a function, call it (with no arguments or context) and return the result.
 * Otherwise, just pass the value through
 * @param arg
 */ var callIfFunction = function callIfFunction(arg) {
        return typeof arg === 'function' ? arg() : arg;
    };
    var defaultParams = {
        title: '',
        titleText: '',
        text: '',
        html: '',
        footer: '',
        type: null,
        toast: false,
        customClass: '',
        target: 'body',
        backdrop: true,
        animation: true,
        allowOutsideClick: true,
        allowEscapeKey: true,
        allowEnterKey: true,
        showConfirmButton: true,
        showCancelButton: false,
        preConfirm: null,
        confirmButtonText: 'OK',
        confirmButtonAriaLabel: '',
        confirmButtonColor: null,
        confirmButtonClass: null,
        cancelButtonText: 'Cancel',
        cancelButtonAriaLabel: '',
        cancelButtonColor: null,
        cancelButtonClass: null,
        buttonsStyling: true,
        reverseButtons: false,
        focusConfirm: true,
        focusCancel: false,
        showCloseButton: false,
        closeButtonAriaLabel: 'Close this dialog',
        showLoaderOnConfirm: false,
        imageUrl: null,
        imageWidth: null,
        imageHeight: null,
        imageAlt: '',
        imageClass: null,
        timer: null,
        width: null,
        padding: null,
        background: null,
        input: null,
        inputPlaceholder: '',
        inputValue: '',
        inputOptions: {},
        inputAutoTrim: true,
        inputClass: null,
        inputAttributes: {},
        inputValidator: null,
        grow: false,
        position: 'center',
        progressSteps: [],
        currentProgressStep: null,
        progressStepsDistance: null,
        onBeforeOpen: null,
        onAfterClose: null,
        onOpen: null,
        onClose: null,
        useRejections: false,
        expectRejections: false
    };
    var deprecatedParams = [
        'useRejections',
        'expectRejections'
    ];
    /**
 * Is valid parameter
 * @param {String} paramName
 */ var isValidParameter = function isValidParameter(paramName) {
        return defaultParams.hasOwnProperty(paramName) || paramName === 'extraParams';
    };
    /**
 * Is deprecated parameter
 * @param {String} paramName
 */ var isDeprecatedParameter = function isDeprecatedParameter(paramName) {
        return deprecatedParams.indexOf(paramName) !== -1;
    };
    /**
 * Show relevant warnings for given params
 *
 * @param params
 */ var showWarningsForParams = function showWarningsForParams(params) {
        for(var param in params){
            if (!isValidParameter(param)) warn('Unknown parameter "' + param + '"');
            if (isDeprecatedParameter(param)) warnOnce('The parameter "' + param + '" is deprecated and will be removed in the next major release.');
        }
    };
    var swalPrefix = 'swal2-';
    var prefix = function prefix(items) {
        var result = {};
        for(var i in items)result[items[i]] = swalPrefix + items[i];
        return result;
    };
    var swalClasses = prefix([
        'container',
        'shown',
        'iosfix',
        'popup',
        'modal',
        'no-backdrop',
        'toast',
        'toast-shown',
        'fade',
        'show',
        'hide',
        'noanimation',
        'close',
        'title',
        'header',
        'content',
        'actions',
        'confirm',
        'cancel',
        'footer',
        'icon',
        'icon-text',
        'image',
        'input',
        'has-input',
        'file',
        'range',
        'select',
        'radio',
        'checkbox',
        'textarea',
        'inputerror',
        'validationerror',
        'progresssteps',
        'activeprogressstep',
        'progresscircle',
        'progressline',
        'loading',
        'styled',
        'top',
        'top-start',
        'top-end',
        'top-left',
        'top-right',
        'center',
        'center-start',
        'center-end',
        'center-left',
        'center-right',
        'bottom',
        'bottom-start',
        'bottom-end',
        'bottom-left',
        'bottom-right',
        'grow-row',
        'grow-column',
        'grow-fullscreen'
    ]);
    var iconTypes = prefix([
        'success',
        'warning',
        'info',
        'question',
        'error'
    ]);
    // Remember state in cases where opening and handling a modal will fiddle with it.
    var states = {
        previousActiveElement: null,
        previousBodyPadding: null
    };
    var hasClass = function hasClass(elem, className) {
        if (elem.classList) return elem.classList.contains(className);
        return false;
    };
    var focusInput = function focusInput(input) {
        input.focus();
        // place cursor at end of text in text input
        if (input.type !== 'file') {
            // http://stackoverflow.com/a/2345915/1331425
            var val = input.value;
            input.value = '';
            input.value = val;
        }
    };
    var addOrRemoveClass = function addOrRemoveClass(target, classList, add) {
        if (!target || !classList) return;
        if (typeof classList === 'string') classList = classList.split(/\s+/).filter(Boolean);
        classList.forEach(function(className) {
            if (target.forEach) target.forEach(function(elem) {
                add ? elem.classList.add(className) : elem.classList.remove(className);
            });
            else add ? target.classList.add(className) : target.classList.remove(className);
        });
    };
    var addClass = function addClass(target, classList) {
        addOrRemoveClass(target, classList, true);
    };
    var removeClass = function removeClass(target, classList) {
        addOrRemoveClass(target, classList, false);
    };
    var getChildByClass = function getChildByClass(elem, className) {
        for(var i = 0; i < elem.childNodes.length; i++){
            if (hasClass(elem.childNodes[i], className)) return elem.childNodes[i];
        }
    };
    var show = function show(elem) {
        elem.style.opacity = '';
        elem.style.display = elem.id === swalClasses.content ? 'block' : 'flex';
    };
    var hide = function hide(elem) {
        elem.style.opacity = '';
        elem.style.display = 'none';
    };
    var empty = function empty(elem) {
        while(elem.firstChild)elem.removeChild(elem.firstChild);
    };
    // borrowed from jquery $(elem).is(':visible') implementation
    var isVisible = function isVisible(elem) {
        return elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    var removeStyleProperty = function removeStyleProperty(elem, property) {
        if (elem.style.removeProperty) elem.style.removeProperty(property);
        else elem.style.removeAttribute(property);
    };
    // Reset previous window keydown handler and focued element
    var resetPrevState = function resetPrevState() {
        if (states.previousActiveElement && states.previousActiveElement.focus) {
            var x = window.scrollX;
            var y = window.scrollY;
            states.previousActiveElement.focus();
            if (typeof x !== 'undefined' && typeof y !== 'undefined') // IE doesn't have scrollX/scrollY support
            window.scrollTo(x, y);
        }
    };
    var getContainer = function getContainer() {
        return document.body.querySelector('.' + swalClasses.container);
    };
    var elementByClass = function elementByClass(className) {
        var container = getContainer();
        return container ? container.querySelector('.' + className) : null;
    };
    var getPopup = function getPopup() {
        return elementByClass(swalClasses.popup);
    };
    var getIcons = function getIcons() {
        var popup = getPopup();
        return popup.querySelectorAll('.' + swalClasses.icon);
    };
    var getTitle = function getTitle() {
        return elementByClass(swalClasses.title);
    };
    var getContent = function getContent() {
        return elementByClass(swalClasses.content);
    };
    var getImage = function getImage() {
        return elementByClass(swalClasses.image);
    };
    var getProgressSteps = function getProgressSteps() {
        return elementByClass(swalClasses.progresssteps);
    };
    var getValidationError = function getValidationError() {
        return elementByClass(swalClasses.validationerror);
    };
    var getConfirmButton = function getConfirmButton() {
        return elementByClass(swalClasses.confirm);
    };
    var getCancelButton = function getCancelButton() {
        return elementByClass(swalClasses.cancel);
    };
    var getButtonsWrapper = function getButtonsWrapper() {
        warnOnce('swal.getButtonsWrapper() is deprecated and will be removed in the next major release, use swal.getActions() instead');
        return elementByClass(swalClasses.actions);
    };
    var getActions = function getActions() {
        return elementByClass(swalClasses.actions);
    };
    var getFooter = function getFooter() {
        return elementByClass(swalClasses.footer);
    };
    var getCloseButton = function getCloseButton() {
        return elementByClass(swalClasses.close);
    };
    var getFocusableElements = function getFocusableElements() {
        var focusableElementsWithTabindex = Array.prototype.slice.call(getPopup().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'))// sort according to tabindex
        .sort(function(a, b) {
            a = parseInt(a.getAttribute('tabindex'));
            b = parseInt(b.getAttribute('tabindex'));
            if (a > b) return 1;
            else if (a < b) return -1;
            return 0;
        });
        // https://github.com/jkup/focusable/blob/master/index.js
        var otherFocusableElements = Array.prototype.slice.call(getPopup().querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable], audio[controls], video[controls]'));
        return uniqueArray(focusableElementsWithTabindex.concat(otherFocusableElements));
    };
    var isModal = function isModal() {
        return !document.body.classList.contains(swalClasses['toast-shown']);
    };
    var isToast = function isToast() {
        return document.body.classList.contains(swalClasses['toast-shown']);
    };
    var isLoading = function isLoading() {
        return getPopup().hasAttribute('data-loading');
    };
    // Detect Node env
    var isNodeEnv = function isNodeEnv() {
        return typeof window === 'undefined' || typeof document === 'undefined';
    };
    var sweetHTML = ('\n <div aria-labelledby="' + swalClasses.title + '" aria-describedby="' + swalClasses.content + '" class="' + swalClasses.popup + '" tabindex="-1">\n   <div class="' + swalClasses.header + '">\n     <ul class="' + swalClasses.progresssteps + '"></ul>\n     <div class="' + swalClasses.icon + ' ' + iconTypes.error + '">\n       <span class="swal2-x-mark"><span class="swal2-x-mark-line-left"></span><span class="swal2-x-mark-line-right"></span></span>\n     </div>\n     <div class="' + swalClasses.icon + ' ' + iconTypes.question + '">\n       <span class="' + swalClasses['icon-text'] + '">?</span>\n      </div>\n     <div class="' + swalClasses.icon + ' ' + iconTypes.warning + '">\n       <span class="' + swalClasses['icon-text'] + '">!</span>\n      </div>\n     <div class="' + swalClasses.icon + ' ' + iconTypes.info + '">\n       <span class="' + swalClasses['icon-text'] + '">i</span>\n      </div>\n     <div class="' + swalClasses.icon + ' ' + iconTypes.success + '">\n       <div class="swal2-success-circular-line-left"></div>\n       <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n       <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n       <div class="swal2-success-circular-line-right"></div>\n     </div>\n     <img class="' + swalClasses.image + '" />\n     <h2 class="' + swalClasses.title + '" id="' + swalClasses.title + '"></h2>\n     <button type="button" class="' + swalClasses.close + '">\xD7</button>\n   </div>\n   <div class="' + swalClasses.content + '">\n     <div id="' + swalClasses.content + '"></div>\n     <input class="' + swalClasses.input + '" />\n     <input type="file" class="' + swalClasses.file + '" />\n     <div class="' + swalClasses.range + '">\n       <input type="range" />\n       <output></output>\n     </div>\n     <select class="' + swalClasses.select + '"></select>\n     <div class="' + swalClasses.radio + '"></div>\n     <label for="' + swalClasses.checkbox + '" class="' + swalClasses.checkbox + '">\n       <input type="checkbox" />\n     </label>\n     <textarea class="' + swalClasses.textarea + '"></textarea>\n     <div class="' + swalClasses.validationerror + '" id="' + swalClasses.validationerror + '"></div>\n   </div>\n   <div class="' + swalClasses.actions + '">\n     <button type="button" class="' + swalClasses.confirm + '">OK</button>\n     <button type="button" class="' + swalClasses.cancel + '">Cancel</button>\n   </div>\n   <div class="' + swalClasses.footer + '">\n   </div>\n </div>\n').replace(/(^|\n)\s*/g, '');
    /*
 * Add modal + backdrop to DOM
 */ var init = function init(params) {
        // Clean up the old popup if it exists
        var c = getContainer();
        if (c) {
            c.parentNode.removeChild(c);
            removeClass([
                document.documentElement,
                document.body
            ], [
                swalClasses['no-backdrop'],
                swalClasses['has-input'],
                swalClasses['toast-shown']
            ]);
        }
        if (isNodeEnv()) {
            error('SweetAlert2 requires document to initialize');
            return;
        }
        var container = document.createElement('div');
        container.className = swalClasses.container;
        container.innerHTML = sweetHTML;
        var targetElement = typeof params.target === 'string' ? document.querySelector(params.target) : params.target;
        targetElement.appendChild(container);
        var popup = getPopup();
        var content = getContent();
        var input = getChildByClass(content, swalClasses.input);
        var file = getChildByClass(content, swalClasses.file);
        var range = content.querySelector('.' + swalClasses.range + ' input');
        var rangeOutput = content.querySelector('.' + swalClasses.range + ' output');
        var select = getChildByClass(content, swalClasses.select);
        var checkbox = content.querySelector('.' + swalClasses.checkbox + ' input');
        var textarea = getChildByClass(content, swalClasses.textarea);
        // a11y
        popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
        popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');
        if (!params.toast) popup.setAttribute('aria-modal', 'true');
        var resetValidationError = function resetValidationError() {
            sweetAlert.isVisible() && sweetAlert.resetValidationError();
        };
        input.oninput = resetValidationError;
        file.onchange = resetValidationError;
        select.onchange = resetValidationError;
        checkbox.onchange = resetValidationError;
        textarea.oninput = resetValidationError;
        range.oninput = function() {
            resetValidationError();
            rangeOutput.value = range.value;
        };
        range.onchange = function() {
            resetValidationError();
            range.nextSibling.value = range.value;
        };
        return popup;
    };
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var parseHtmlToContainer = function parseHtmlToContainer(param, target) {
        if (!param) return hide(target);
        if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) === 'object') {
            target.innerHTML = '';
            if (0 in param) for(var i = 0; i in param; i++)target.appendChild(param[i].cloneNode(true));
            else target.appendChild(param.cloneNode(true));
        } else if (param) target.innerHTML = param;
        show(target);
    };
    var animationEndEvent = function() {
        // Prevent run in Node env
        if (isNodeEnv()) return false;
        var testEl = document.createElement('div');
        var transEndEventNames = {
            'WebkitAnimation': 'webkitAnimationEnd',
            'OAnimation': 'oAnimationEnd oanimationend',
            'animation': 'animationend'
        };
        for(var i in transEndEventNames){
            if (transEndEventNames.hasOwnProperty(i) && typeof testEl.style[i] !== 'undefined') return transEndEventNames[i];
        }
        return false;
    }();
    // Measure width of scrollbar
    // https://github.com/twbs/bootstrap/blob/master/js/modal.js#L279-L286
    var measureScrollbar = function measureScrollbar() {
        var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
        if (supportsTouch) return 0;
        var scrollDiv = document.createElement('div');
        scrollDiv.style.width = '50px';
        scrollDiv.style.height = '50px';
        scrollDiv.style.overflow = 'scroll';
        document.body.appendChild(scrollDiv);
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
    };
    var defaultInputValidators = {
        email: function email(string) {
            return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(string) ? Promise.resolve() : Promise.reject('Invalid email address');
        },
        url: function url(string) {
            // taken from https://stackoverflow.com/a/3809435/1331425
            return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/.test(string) ? Promise.resolve() : Promise.reject('Invalid URL');
        }
    };
    /**
 * Set type, text and actions on popup
 *
 * @param params
 * @returns {boolean}
 */ function setParameters(params) {
        // Use default `inputValidator` for supported input types if not provided
        if (!params.inputValidator) Object.keys(defaultInputValidators).forEach(function(key) {
            if (params.input === key) params.inputValidator = params.expectRejections ? defaultInputValidators[key] : sweetAlert.adaptInputValidator(defaultInputValidators[key]);
        });
        // Determine if the custom target element is valid
        if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
            warn('Target parameter is not valid, defaulting to "body"');
            params.target = 'body';
        }
        var popup = void 0;
        var oldPopup = getPopup();
        var targetElement = typeof params.target === 'string' ? document.querySelector(params.target) : params.target;
        // If the model target has changed, refresh the popup
        if (oldPopup && targetElement && oldPopup.parentNode !== targetElement.parentNode) popup = init(params);
        else popup = oldPopup || init(params);
        // Set popup width
        if (params.width) popup.style.width = typeof params.width === 'number' ? params.width + 'px' : params.width;
        // Set popup padding
        if (params.padding) popup.style.padding = typeof params.padding === 'number' ? params.padding + 'px' : params.padding;
        // Set popup background
        if (params.background) popup.style.background = params.background;
        var popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
        var successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');
        for(var i = 0; i < successIconParts.length; i++)successIconParts[i].style.backgroundColor = popupBackgroundColor;
        var container = getContainer();
        var title = getTitle();
        var content = getContent().querySelector('#' + swalClasses.content);
        var actions = getActions();
        var confirmButton = getConfirmButton();
        var cancelButton = getCancelButton();
        var closeButton = getCloseButton();
        var footer = getFooter();
        // Title
        if (params.titleText) title.innerText = params.titleText;
        else if (params.title) title.innerHTML = params.title.split('\n').join('<br />');
        if (typeof params.backdrop === 'string') getContainer().style.background = params.backdrop;
        else if (!params.backdrop) addClass([
            document.documentElement,
            document.body
        ], swalClasses['no-backdrop']);
        // Content as HTML
        if (params.html) parseHtmlToContainer(params.html, content);
        else if (params.text) {
            content.textContent = params.text;
            show(content);
        } else hide(content);
        // Position
        if (params.position in swalClasses) addClass(container, swalClasses[params.position]);
        else {
            warn('The "position" parameter is not valid, defaulting to "center"');
            addClass(container, swalClasses.center);
        }
        // Grow
        if (params.grow && typeof params.grow === 'string') {
            var growClass = 'grow-' + params.grow;
            if (growClass in swalClasses) addClass(container, swalClasses[growClass]);
        }
        // Animation
        if (typeof params.animation === 'function') params.animation = params.animation.call();
        // Close button
        if (params.showCloseButton) {
            closeButton.setAttribute('aria-label', params.closeButtonAriaLabel);
            show(closeButton);
        } else hide(closeButton);
        // Default Class
        popup.className = swalClasses.popup;
        if (params.toast) {
            addClass([
                document.documentElement,
                document.body
            ], swalClasses['toast-shown']);
            addClass(popup, swalClasses.toast);
        } else addClass(popup, swalClasses.modal);
        // Custom Class
        if (params.customClass) addClass(popup, params.customClass);
        // Progress steps
        var progressStepsContainer = getProgressSteps();
        var currentProgressStep = parseInt(params.currentProgressStep === null ? sweetAlert.getQueueStep() : params.currentProgressStep, 10);
        if (params.progressSteps && params.progressSteps.length) {
            show(progressStepsContainer);
            empty(progressStepsContainer);
            if (currentProgressStep >= params.progressSteps.length) warn("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)");
            params.progressSteps.forEach(function(step, index) {
                var circle = document.createElement('li');
                addClass(circle, swalClasses.progresscircle);
                circle.innerHTML = step;
                if (index === currentProgressStep) addClass(circle, swalClasses.activeprogressstep);
                progressStepsContainer.appendChild(circle);
                if (index !== params.progressSteps.length - 1) {
                    var line = document.createElement('li');
                    addClass(line, swalClasses.progressline);
                    if (params.progressStepsDistance) line.style.width = params.progressStepsDistance;
                    progressStepsContainer.appendChild(line);
                }
            });
        } else hide(progressStepsContainer);
        // Icon
        var icons = getIcons();
        for(var _i = 0; _i < icons.length; _i++)hide(icons[_i]);
        if (params.type) {
            var validType = false;
            for(var iconType in iconTypes)if (params.type === iconType) {
                validType = true;
                break;
            }
            if (!validType) {
                error('Unknown alert type: ' + params.type);
                return false;
            }
            var icon = popup.querySelector('.' + swalClasses.icon + '.' + iconTypes[params.type]);
            show(icon);
            // Animate icon
            if (params.animation) addClass(icon, 'swal2-animate-' + params.type + '-icon');
        }
        // Custom image
        var image = getImage();
        if (params.imageUrl) {
            image.setAttribute('src', params.imageUrl);
            image.setAttribute('alt', params.imageAlt);
            show(image);
            if (params.imageWidth) image.setAttribute('width', params.imageWidth);
            else image.removeAttribute('width');
            if (params.imageHeight) image.setAttribute('height', params.imageHeight);
            else image.removeAttribute('height');
            image.className = swalClasses.image;
            if (params.imageClass) addClass(image, params.imageClass);
        } else hide(image);
        // Cancel button
        if (params.showCancelButton) cancelButton.style.display = 'inline-block';
        else hide(cancelButton);
        // Confirm button
        if (params.showConfirmButton) removeStyleProperty(confirmButton, 'display');
        else hide(confirmButton);
        // Actions (buttons) wrapper
        if (!params.showConfirmButton && !params.showCancelButton) hide(actions);
        else show(actions);
        // Edit text on confirm and cancel buttons
        confirmButton.innerHTML = params.confirmButtonText;
        cancelButton.innerHTML = params.cancelButtonText;
        // ARIA labels for confirm and cancel buttons
        confirmButton.setAttribute('aria-label', params.confirmButtonAriaLabel);
        cancelButton.setAttribute('aria-label', params.cancelButtonAriaLabel);
        // Add buttons custom classes
        confirmButton.className = swalClasses.confirm;
        addClass(confirmButton, params.confirmButtonClass);
        cancelButton.className = swalClasses.cancel;
        addClass(cancelButton, params.cancelButtonClass);
        // Buttons styling
        if (params.buttonsStyling) {
            addClass([
                confirmButton,
                cancelButton
            ], swalClasses.styled);
            // Buttons background colors
            if (params.confirmButtonColor) confirmButton.style.backgroundColor = params.confirmButtonColor;
            if (params.cancelButtonColor) cancelButton.style.backgroundColor = params.cancelButtonColor;
            // Loading state
            var confirmButtonBackgroundColor = window.getComputedStyle(confirmButton).getPropertyValue('background-color');
            confirmButton.style.borderLeftColor = confirmButtonBackgroundColor;
            confirmButton.style.borderRightColor = confirmButtonBackgroundColor;
        } else {
            removeClass([
                confirmButton,
                cancelButton
            ], swalClasses.styled);
            confirmButton.style.backgroundColor = confirmButton.style.borderLeftColor = confirmButton.style.borderRightColor = '';
            cancelButton.style.backgroundColor = cancelButton.style.borderLeftColor = cancelButton.style.borderRightColor = '';
        }
        // Footer
        parseHtmlToContainer(params.footer, footer);
        // CSS animation
        if (params.animation === true) removeClass(popup, swalClasses.noanimation);
        else addClass(popup, swalClasses.noanimation);
        // showLoaderOnConfirm && preConfirm
        if (params.showLoaderOnConfirm && !params.preConfirm) warn("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request");
    }
    var DismissReason = Object.freeze({
        cancel: 'cancel',
        backdrop: 'overlay',
        close: 'close',
        esc: 'esc',
        timer: 'timer'
    });
    var fixScrollbar = function fixScrollbar() {
        // for queues, do not do this more than once
        if (states.previousBodyPadding !== null) return;
        // if the body has overflow
        if (document.body.scrollHeight > window.innerHeight) {
            // add padding so the content doesn't shift after removal of scrollbar
            states.previousBodyPadding = document.body.style.paddingRight;
            document.body.style.paddingRight = measureScrollbar() + 'px';
        }
    };
    var undoScrollbar = function undoScrollbar() {
        if (states.previousBodyPadding !== null) {
            document.body.style.paddingRight = states.previousBodyPadding;
            states.previousBodyPadding = null;
        }
    };
    // Fix iOS scrolling http://stackoverflow.com/q/39626302/1331425
    var iOSfix = function iOSfix() {
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (iOS && !hasClass(document.body, swalClasses.iosfix)) {
            var offset = document.body.scrollTop;
            document.body.style.top = offset * -1 + 'px';
            addClass(document.body, swalClasses.iosfix);
        }
    };
    var undoIOSfix = function undoIOSfix() {
        if (hasClass(document.body, swalClasses.iosfix)) {
            var offset = parseInt(document.body.style.top, 10);
            removeClass(document.body, swalClasses.iosfix);
            document.body.style.top = '';
            document.body.scrollTop = offset * -1;
        }
    };
    var version = "7.17.0";
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var argsToParams = function argsToParams(args) {
        var params = {};
        switch(_typeof$1(args[0])){
            case 'string':
                [
                    'title',
                    'html',
                    'type'
                ].forEach(function(name, index) {
                    if (args[index] !== undefined) params[name] = args[index];
                });
                break;
            case 'object':
                _extends(params, args[0]);
                break;
            default:
                error('Unexpected type of argument! Expected "string" or "object", got ' + _typeof$1(args[0]));
                return false;
        }
        return params;
    };
    /**
 * Adapt a legacy inputValidator for use with expectRejections=false
 */ var adaptInputValidator = function adaptInputValidator(legacyValidator) {
        return function adaptedInputValidator(inputValue, extraParams) {
            return legacyValidator.call(this, inputValue, extraParams).then(function() {
                return undefined;
            }, function(validationError) {
                return validationError;
            });
        };
    };
    var _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var globalState = {
        popupParams: _extends$1({}, defaultParams)
    };
    /*
 * Global function to close sweetAlert
 */ var close = function close(onClose, onAfterClose) {
        var container = getContainer();
        var popup = getPopup();
        if (!popup) return;
        if (onClose !== null && typeof onClose === 'function') onClose(popup);
        removeClass(popup, swalClasses.show);
        addClass(popup, swalClasses.hide);
        clearTimeout(popup.timeout);
        if (!isToast()) {
            resetPrevState();
            window.onkeydown = globalState.previousWindowKeyDown;
            globalState.windowOnkeydownOverridden = false;
        }
        var removePopupAndResetState = function removePopupAndResetState() {
            if (container.parentNode) container.parentNode.removeChild(container);
            removeClass([
                document.documentElement,
                document.body
            ], [
                swalClasses.shown,
                swalClasses['no-backdrop'],
                swalClasses['has-input'],
                swalClasses['toast-shown']
            ]);
            if (isModal()) {
                undoScrollbar();
                undoIOSfix();
            }
            if (onAfterClose !== null && typeof onAfterClose === 'function') setTimeout(function() {
                onAfterClose();
            });
        };
        // If animation is supported, animate
        if (animationEndEvent && !hasClass(popup, swalClasses.noanimation)) popup.addEventListener(animationEndEvent, function swalCloseEventFinished() {
            popup.removeEventListener(animationEndEvent, swalCloseEventFinished);
            if (hasClass(popup, swalClasses.hide)) removePopupAndResetState();
        });
        else // Otherwise, remove immediately
        removePopupAndResetState();
    };
    /*
 * Global function to determine if swal2 popup is shown
 */ var isVisible$1 = function isVisible() {
        return !!getPopup();
    };
    /*
 * Global function to click 'Confirm' button
 */ var clickConfirm = function clickConfirm() {
        return getConfirmButton().click();
    };
    /*
 * Global function to click 'Cancel' button
 */ var clickCancel = function clickCancel() {
        return getCancelButton().click();
    };
    var _extends$2 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    /**
 * Returns a wrapped instance of `swal` containing `params` as defaults.
 * Useful for reusing swal configuration.
 *
 * For example:
 *
 * Before:
 * const textPromptOptions = { input: 'text', showCancelButton: true }
 * const {value: firstName} = await swal({ ...textPromptOptions, title: 'What is your first name?' })
 * const {value: lastName} = await swal({ ...textPromptOptions, title: 'What is your last name?' })
 *
 * After:
 * const myTextPrompt = swal.mixin({ input: 'text', showCancelButton: true })
 * const {value: firstName} = await myTextPrompt('What is your first name?')
 * const {value: lastName} = await myTextPrompt('What is your last name?')
 *
 * @param params
 */ var mixin = function mixin(params) {
        var parentSwal = this;
        var childSwal = function childSwal() {
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return parentSwal(_extends$2({}, params, parentSwal.argsToParams(args)));
        };
        return _extends$2(childSwal, parentSwal);
    };
    // private global state for the queue feature
    var currentSteps = [];
    /*
 * Global function for chaining sweetAlert popups
 */ var queue = function queue(steps) {
        var swal = this;
        currentSteps = steps;
        var resetQueue = function resetQueue() {
            currentSteps = [];
            document.body.removeAttribute('data-swal2-queue-step');
        };
        var queueResult = [];
        return new Promise(function(resolve, reject) {
            (function step(i, callback) {
                if (i < currentSteps.length) {
                    document.body.setAttribute('data-swal2-queue-step', i);
                    swal(currentSteps[i]).then(function(result) {
                        if (typeof result.value !== 'undefined') {
                            queueResult.push(result.value);
                            step(i + 1, callback);
                        } else {
                            resetQueue();
                            resolve({
                                dismiss: result.dismiss
                            });
                        }
                    });
                } else {
                    resetQueue();
                    resolve({
                        value: queueResult
                    });
                }
            })(0);
        });
    };
    /*
 * Global function for getting the index of current popup in queue
 */ var getQueueStep = function getQueueStep() {
        return document.body.getAttribute('data-swal2-queue-step');
    };
    /*
 * Global function for inserting a popup to the queue
 */ var insertQueueStep = function insertQueueStep(step, index) {
        if (index && index < currentSteps.length) return currentSteps.splice(index, 0, step);
        return currentSteps.push(step);
    };
    /*
 * Global function for deleting a popup from the queue
 */ var deleteQueueStep = function deleteQueueStep(index) {
        if (typeof currentSteps[index] !== 'undefined') currentSteps.splice(index, 1);
    };
    var _extends$3 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var _typeof$2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    /**
 * Set default params for each popup
 * @param {Object} userParams
 */ var setDefaults = function setDefaults(userParams) {
        if (!userParams || (typeof userParams === 'undefined' ? 'undefined' : _typeof$2(userParams)) !== 'object') return error('the argument for setDefaults() is required and has to be a object');
        showWarningsForParams(userParams);
        // assign valid params from userParams to popupParams
        for(var param in userParams)if (isValidParameter(param)) globalState.popupParams[param] = userParams[param];
    };
    /**
 * Reset default params for each popup
 */ var resetDefaults = function resetDefaults() {
        globalState.popupParams = _extends$3({}, defaultParams);
    };
    /**
 * Show spinner instead of Confirm button and disable Cancel button
 */ var showLoading = function showLoading() {
        var popup = getPopup();
        if (!popup) sweetAlert('');
        popup = getPopup();
        var actions = getActions();
        var confirmButton = getConfirmButton();
        var cancelButton = getCancelButton();
        show(actions);
        show(confirmButton);
        addClass([
            popup,
            actions
        ], swalClasses.loading);
        confirmButton.disabled = true;
        cancelButton.disabled = true;
        popup.setAttribute('data-loading', true);
        popup.setAttribute('aria-busy', true);
        popup.focus();
    };
    var staticMethods = Object.freeze({
        isValidParameter: isValidParameter,
        isDeprecatedParameter: isDeprecatedParameter,
        argsToParams: argsToParams,
        adaptInputValidator: adaptInputValidator,
        close: close,
        closePopup: close,
        closeModal: close,
        closeToast: close,
        isVisible: isVisible$1,
        clickConfirm: clickConfirm,
        clickCancel: clickCancel,
        getTitle: getTitle,
        getContent: getContent,
        getImage: getImage,
        getButtonsWrapper: getButtonsWrapper,
        getActions: getActions,
        getConfirmButton: getConfirmButton,
        getCancelButton: getCancelButton,
        getFooter: getFooter,
        isLoading: isLoading,
        mixin: mixin,
        queue: queue,
        getQueueStep: getQueueStep,
        insertQueueStep: insertQueueStep,
        deleteQueueStep: deleteQueueStep,
        setDefaults: setDefaults,
        resetDefaults: resetDefaults,
        showLoading: showLoading,
        enableLoading: showLoading
    });
    var _typeof$3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var _extends$4 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var currentContext = void 0;
    /**
 * Animations
 *
 * @param animation
 * @param onBeforeOpen
 * @param onComplete
 */ var openPopup = function openPopup(animation, onBeforeOpen, onOpen) {
        var container = getContainer();
        var popup = getPopup();
        if (onBeforeOpen !== null && typeof onBeforeOpen === 'function') onBeforeOpen(popup);
        if (animation) {
            addClass(popup, swalClasses.show);
            addClass(container, swalClasses.fade);
            removeClass(popup, swalClasses.hide);
        } else removeClass(popup, swalClasses.fade);
        show(popup);
        // scrolling is 'hidden' until animation is done, after that 'auto'
        container.style.overflowY = 'hidden';
        if (animationEndEvent && !hasClass(popup, swalClasses.noanimation)) popup.addEventListener(animationEndEvent, function swalCloseEventFinished() {
            popup.removeEventListener(animationEndEvent, swalCloseEventFinished);
            container.style.overflowY = 'auto';
        });
        else container.style.overflowY = 'auto';
        addClass([
            document.documentElement,
            document.body,
            container
        ], swalClasses.shown);
        if (isModal()) {
            fixScrollbar();
            iOSfix();
        }
        states.previousActiveElement = document.activeElement;
        if (onOpen !== null && typeof onOpen === 'function') setTimeout(function() {
            onOpen(popup);
        });
    };
    // SweetAlert entry point
    var sweetAlert = function sweetAlert() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // Prevent run in Node env
        if (typeof window === 'undefined') return;
        // Check for the existence of Promise
        if (typeof Promise === 'undefined') error('This package requires a Promise library, please include a shim to enable it in this browser (See: https://github.com/sweetalert2/sweetalert2/wiki/Migration-from-SweetAlert-to-SweetAlert2#1-ie-support)');
        if (typeof args[0] === 'undefined') {
            error('SweetAlert2 expects at least 1 attribute!');
            return false;
        }
        var context = currentContext = {};
        var userParams = sweetAlert.argsToParams(args);
        showWarningsForParams(userParams);
        var params = context.params = _extends$4({}, globalState.popupParams, userParams);
        setParameters(params);
        var domCache = context.domCache = {
            popup: getPopup(),
            container: getContainer(),
            content: getContent(),
            actions: getActions(),
            confirmButton: getConfirmButton(),
            cancelButton: getCancelButton(),
            closeButton: getCloseButton(),
            validationError: getValidationError(),
            progressSteps: getProgressSteps()
        };
        return new Promise(function(resolve, reject) {
            // functions to handle all resolving/rejecting/settling
            var succeedWith = function succeedWith(value) {
                sweetAlert.closePopup(params.onClose, params.onAfterClose);
                if (params.useRejections) resolve(value);
                else resolve({
                    value: value
                });
            };
            var dismissWith = function dismissWith(dismiss) {
                sweetAlert.closePopup(params.onClose, params.onAfterClose);
                if (params.useRejections) reject(dismiss);
                else resolve({
                    dismiss: dismiss
                });
            };
            var errorWith = function errorWith(error$$1) {
                sweetAlert.closePopup(params.onClose, params.onAfterClose);
                reject(error$$1);
            };
            // Close on timer
            if (params.timer) domCache.popup.timeout = setTimeout(function() {
                return dismissWith('timer');
            }, params.timer);
            // Get the value of the popup input
            var getInputValue = function getInputValue() {
                var input = sweetAlert.getInput();
                if (!input) return null;
                switch(params.input){
                    case 'checkbox':
                        return input.checked ? 1 : 0;
                    case 'radio':
                        return input.checked ? input.value : null;
                    case 'file':
                        return input.files.length ? input.files[0] : null;
                    default:
                        return params.inputAutoTrim ? input.value.trim() : input.value;
                }
            };
            // input autofocus
            if (params.input) setTimeout(function() {
                var input = sweetAlert.getInput();
                if (input) focusInput(input);
            }, 0);
            var confirm = function confirm(value) {
                if (params.showLoaderOnConfirm) sweetAlert.showLoading();
                if (params.preConfirm) {
                    sweetAlert.resetValidationError();
                    var preConfirmPromise = Promise.resolve().then(function() {
                        return params.preConfirm(value, params.extraParams);
                    });
                    if (params.expectRejections) preConfirmPromise.then(function(preConfirmValue) {
                        return succeedWith(preConfirmValue || value);
                    }, function(validationError) {
                        sweetAlert.hideLoading();
                        if (validationError) sweetAlert.showValidationError(validationError);
                    });
                    else preConfirmPromise.then(function(preConfirmValue) {
                        if (isVisible(domCache.validationError) || preConfirmValue === false) sweetAlert.hideLoading();
                        else succeedWith(preConfirmValue || value);
                    }, function(error$$1) {
                        return errorWith(error$$1);
                    });
                } else succeedWith(value);
            };
            // Mouse interactions
            var onButtonEvent = function onButtonEvent(event) {
                var e = event || window.event;
                var target = e.target || e.srcElement;
                var confirmButton = domCache.confirmButton, cancelButton = domCache.cancelButton;
                var targetedConfirm = confirmButton && (confirmButton === target || confirmButton.contains(target));
                var targetedCancel = cancelButton && (cancelButton === target || cancelButton.contains(target));
                switch(e.type){
                    case 'click':
                        // Clicked 'confirm'
                        if (targetedConfirm && sweetAlert.isVisible()) {
                            sweetAlert.disableButtons();
                            if (params.input) {
                                var inputValue = getInputValue();
                                if (params.inputValidator) {
                                    sweetAlert.disableInput();
                                    var validationPromise = Promise.resolve().then(function() {
                                        return params.inputValidator(inputValue, params.extraParams);
                                    });
                                    if (params.expectRejections) validationPromise.then(function() {
                                        sweetAlert.enableButtons();
                                        sweetAlert.enableInput();
                                        confirm(inputValue);
                                    }, function(validationError) {
                                        sweetAlert.enableButtons();
                                        sweetAlert.enableInput();
                                        if (validationError) sweetAlert.showValidationError(validationError);
                                    });
                                    else validationPromise.then(function(validationError) {
                                        sweetAlert.enableButtons();
                                        sweetAlert.enableInput();
                                        if (validationError) sweetAlert.showValidationError(validationError);
                                        else confirm(inputValue);
                                    }, function(error$$1) {
                                        return errorWith(error$$1);
                                    });
                                } else confirm(inputValue);
                            } else confirm(true);
                        // Clicked 'cancel'
                        } else if (targetedCancel && sweetAlert.isVisible()) {
                            sweetAlert.disableButtons();
                            dismissWith(sweetAlert.DismissReason.cancel);
                        }
                        break;
                    default:
                }
            };
            var buttons = domCache.popup.querySelectorAll('button');
            for(var i = 0; i < buttons.length; i++){
                buttons[i].onclick = onButtonEvent;
                buttons[i].onmouseover = onButtonEvent;
                buttons[i].onmouseout = onButtonEvent;
                buttons[i].onmousedown = onButtonEvent;
            }
            // Closing popup by close button
            domCache.closeButton.onclick = function() {
                dismissWith(sweetAlert.DismissReason.close);
            };
            if (params.toast) // Closing popup by internal click
            domCache.popup.onclick = function(e) {
                if (params.showConfirmButton || params.showCancelButton || params.showCloseButton || params.input) return;
                sweetAlert.closePopup(params.onClose, params.onAfterClose);
                dismissWith(sweetAlert.DismissReason.close);
            };
            else {
                var ignoreOutsideClick = false;
                // Ignore click events that had mousedown on the popup but mouseup on the container
                // This can happen when the user drags a slider
                domCache.popup.onmousedown = function() {
                    domCache.container.onmouseup = function(e) {
                        domCache.container.onmouseup = undefined;
                        // We only check if the mouseup target is the container because usually it doesn't
                        // have any other direct children aside of the popup
                        if (e.target === domCache.container) ignoreOutsideClick = true;
                    };
                };
                // Ignore click events that had mousedown on the container but mouseup on the popup
                domCache.container.onmousedown = function() {
                    domCache.popup.onmouseup = function(e) {
                        domCache.popup.onmouseup = undefined;
                        // We also need to check if the mouseup target is a child of the popup
                        if (e.target === domCache.popup || domCache.popup.contains(e.target)) ignoreOutsideClick = true;
                    };
                };
                domCache.container.onclick = function(e) {
                    if (ignoreOutsideClick) {
                        ignoreOutsideClick = false;
                        return;
                    }
                    if (e.target !== domCache.container) return;
                    if (callIfFunction(params.allowOutsideClick)) dismissWith(sweetAlert.DismissReason.backdrop);
                };
            }
            // Reverse buttons (Confirm on the right side)
            if (params.reverseButtons) domCache.confirmButton.parentNode.insertBefore(domCache.cancelButton, domCache.confirmButton);
            else domCache.confirmButton.parentNode.insertBefore(domCache.confirmButton, domCache.cancelButton);
            // Focus handling
            var setFocus = function setFocus(index, increment) {
                var focusableElements = getFocusableElements(params.focusCancel);
                // search for visible elements and select the next possible match
                for(var _i = 0; _i < focusableElements.length; _i++){
                    index = index + increment;
                    // rollover to first item
                    if (index === focusableElements.length) index = 0;
                    else if (index === -1) index = focusableElements.length - 1;
                    // determine if element is visible
                    var el = focusableElements[index];
                    if (isVisible(el)) return el.focus();
                }
            };
            var handleKeyDown = function handleKeyDown(event) {
                var e = event || window.event;
                var arrowKeys = [
                    'ArrowLeft',
                    'ArrowRight',
                    'ArrowUp',
                    'ArrowDown',
                    'Left',
                    'Right',
                    'Up',
                    'Down' // IE11
                ];
                if (e.key === 'Enter' && !e.isComposing) {
                    if (e.target === sweetAlert.getInput()) {
                        if ([
                            'textarea',
                            'file'
                        ].indexOf(params.input) !== -1) return; // do not submit
                        sweetAlert.clickConfirm();
                        e.preventDefault();
                    }
                } else if (e.key === 'Tab') {
                    var targetElement = e.target || e.srcElement;
                    var focusableElements = getFocusableElements(params.focusCancel);
                    var btnIndex = -1; // Find the button - note, this is a nodelist, not an array.
                    for(var _i2 = 0; _i2 < focusableElements.length; _i2++)if (targetElement === focusableElements[_i2]) {
                        btnIndex = _i2;
                        break;
                    }
                    if (!e.shiftKey) // Cycle to the next button
                    setFocus(btnIndex, 1);
                    else // Cycle to the prev button
                    setFocus(btnIndex, -1);
                    e.stopPropagation();
                    e.preventDefault();
                // ARROWS - switch focus between buttons
                } else if (arrowKeys.indexOf(e.key) !== -1) {
                    // focus Cancel button if Confirm button is currently focused
                    if (document.activeElement === domCache.confirmButton && isVisible(domCache.cancelButton)) domCache.cancelButton.focus();
                    else if (document.activeElement === domCache.cancelButton && isVisible(domCache.confirmButton)) domCache.confirmButton.focus();
                // ESC
                } else if ((e.key === 'Escape' || e.key === 'Esc') && callIfFunction(params.allowEscapeKey) === true) dismissWith(sweetAlert.DismissReason.esc);
            };
            if (params.toast && globalState.windowOnkeydownOverridden) {
                window.onkeydown = globalState.previousWindowKeyDown;
                globalState.windowOnkeydownOverridden = false;
            }
            if (!params.toast && !globalState.windowOnkeydownOverridden) {
                globalState.previousWindowKeyDown = window.onkeydown;
                globalState.windowOnkeydownOverridden = true;
                window.onkeydown = handleKeyDown;
            }
            sweetAlert.enableButtons();
            sweetAlert.hideLoading();
            sweetAlert.resetValidationError();
            if (params.input) addClass(document.body, swalClasses['has-input']);
            // inputs
            var inputTypes = [
                'input',
                'file',
                'range',
                'select',
                'radio',
                'checkbox',
                'textarea'
            ];
            var input = void 0;
            for(var _i3 = 0; _i3 < inputTypes.length; _i3++){
                var inputClass = swalClasses[inputTypes[_i3]];
                var inputContainer = getChildByClass(domCache.content, inputClass);
                input = sweetAlert.getInput(inputTypes[_i3]);
                // set attributes
                if (input) {
                    for(var j in input.attributes)if (input.attributes.hasOwnProperty(j)) {
                        var attrName = input.attributes[j].name;
                        if (attrName !== 'type' && attrName !== 'value') input.removeAttribute(attrName);
                    }
                    for(var attr in params.inputAttributes)input.setAttribute(attr, params.inputAttributes[attr]);
                }
                // set class
                inputContainer.className = inputClass;
                if (params.inputClass) addClass(inputContainer, params.inputClass);
                hide(inputContainer);
            }
            var populateInputOptions = void 0;
            switch(params.input){
                case 'text':
                case 'email':
                case 'password':
                case 'number':
                case 'tel':
                case 'url':
                    input = getChildByClass(domCache.content, swalClasses.input);
                    input.value = params.inputValue;
                    input.placeholder = params.inputPlaceholder;
                    input.type = params.input;
                    show(input);
                    break;
                case 'file':
                    input = getChildByClass(domCache.content, swalClasses.file);
                    input.placeholder = params.inputPlaceholder;
                    input.type = params.input;
                    show(input);
                    break;
                case 'range':
                    var range = getChildByClass(domCache.content, swalClasses.range);
                    var rangeInput = range.querySelector('input');
                    var rangeOutput = range.querySelector('output');
                    rangeInput.value = params.inputValue;
                    rangeInput.type = params.input;
                    rangeOutput.value = params.inputValue;
                    show(range);
                    break;
                case 'select':
                    var select = getChildByClass(domCache.content, swalClasses.select);
                    select.innerHTML = '';
                    if (params.inputPlaceholder) {
                        var placeholder = document.createElement('option');
                        placeholder.innerHTML = params.inputPlaceholder;
                        placeholder.value = '';
                        placeholder.disabled = true;
                        placeholder.selected = true;
                        select.appendChild(placeholder);
                    }
                    populateInputOptions = function populateInputOptions(inputOptions) {
                        inputOptions.forEach(function(_ref) {
                            var _ref2 = _slicedToArray(_ref, 2), optionValue = _ref2[0], optionLabel = _ref2[1];
                            var option = document.createElement('option');
                            option.value = optionValue;
                            option.innerHTML = optionLabel;
                            if (params.inputValue.toString() === optionValue.toString()) option.selected = true;
                            select.appendChild(option);
                        });
                        show(select);
                        select.focus();
                    };
                    break;
                case 'radio':
                    var radio = getChildByClass(domCache.content, swalClasses.radio);
                    radio.innerHTML = '';
                    populateInputOptions = function populateInputOptions(inputOptions) {
                        inputOptions.forEach(function(_ref3) {
                            var _ref4 = _slicedToArray(_ref3, 2), radioValue = _ref4[0], radioLabel = _ref4[1];
                            var radioInput = document.createElement('input');
                            var radioLabelElement = document.createElement('label');
                            radioInput.type = 'radio';
                            radioInput.name = swalClasses.radio;
                            radioInput.value = radioValue;
                            if (params.inputValue.toString() === radioValue.toString()) radioInput.checked = true;
                            radioLabelElement.innerHTML = radioLabel;
                            radioLabelElement.insertBefore(radioInput, radioLabelElement.firstChild);
                            radio.appendChild(radioLabelElement);
                        });
                        show(radio);
                        var radios = radio.querySelectorAll('input');
                        if (radios.length) radios[0].focus();
                    };
                    break;
                case 'checkbox':
                    var checkbox = getChildByClass(domCache.content, swalClasses.checkbox);
                    var checkboxInput = sweetAlert.getInput('checkbox');
                    checkboxInput.type = 'checkbox';
                    checkboxInput.value = 1;
                    checkboxInput.id = swalClasses.checkbox;
                    checkboxInput.checked = Boolean(params.inputValue);
                    var label = checkbox.getElementsByTagName('span');
                    if (label.length) checkbox.removeChild(label[0]);
                    label = document.createElement('span');
                    label.innerHTML = params.inputPlaceholder;
                    checkbox.appendChild(label);
                    show(checkbox);
                    break;
                case 'textarea':
                    var textarea = getChildByClass(domCache.content, swalClasses.textarea);
                    textarea.value = params.inputValue;
                    textarea.placeholder = params.inputPlaceholder;
                    show(textarea);
                    break;
                case null:
                    break;
                default:
                    error('Unexpected type of input! Expected "text", "email", "password", "number", "tel", "select", "radio", "checkbox", "textarea", "file" or "url", got "' + params.input + '"');
                    break;
            }
            if (params.input === 'select' || params.input === 'radio') {
                var processInputOptions = function processInputOptions(inputOptions) {
                    return populateInputOptions(formatInputOptions(inputOptions));
                };
                if (params.inputOptions instanceof Promise) {
                    sweetAlert.showLoading();
                    params.inputOptions.then(function(inputOptions) {
                        sweetAlert.hideLoading();
                        processInputOptions(inputOptions);
                    });
                } else if (_typeof$3(params.inputOptions) === 'object') processInputOptions(params.inputOptions);
                else error('Unexpected type of inputOptions! Expected object, Map or Promise, got ' + _typeof$3(params.inputOptions));
            } else if ([
                'text',
                'email',
                'number',
                'tel',
                'textarea'
            ].indexOf(params.input) !== -1 && params.inputValue instanceof Promise) {
                sweetAlert.showLoading();
                hide(input);
                params.inputValue.then(function(inputValue) {
                    input.value = params.input === 'number' ? parseFloat(inputValue) || 0 : inputValue + '';
                    show(input);
                    sweetAlert.hideLoading();
                }).catch(function(err) {
                    error('Error in inputValue promise: ' + err);
                    input.value = '';
                    show(input);
                    sweetAlert.hideLoading();
                });
            }
            openPopup(params.animation, params.onBeforeOpen, params.onOpen);
            if (!params.toast) {
                if (!callIfFunction(params.allowEnterKey)) {
                    if (document.activeElement) document.activeElement.blur();
                } else if (params.focusCancel && isVisible(domCache.cancelButton)) domCache.cancelButton.focus();
                else if (params.focusConfirm && isVisible(domCache.confirmButton)) domCache.confirmButton.focus();
                else setFocus(-1, 1);
            }
            // fix scroll
            domCache.container.scrollTop = 0;
        });
    };
    // Assign static methods from src/staticMethods/*.js
    _extends$4(sweetAlert, staticMethods);
    /**
 * Show spinner instead of Confirm button and disable Cancel button
 */ sweetAlert.hideLoading = sweetAlert.disableLoading = function() {
        if (currentContext) {
            var _currentContext = currentContext, params = _currentContext.params, domCache = _currentContext.domCache;
            if (!params.showConfirmButton) {
                hide(domCache.confirmButton);
                if (!params.showCancelButton) hide(domCache.actions);
            }
            removeClass([
                domCache.popup,
                domCache.actions
            ], swalClasses.loading);
            domCache.popup.removeAttribute('aria-busy');
            domCache.popup.removeAttribute('data-loading');
            domCache.confirmButton.disabled = false;
            domCache.cancelButton.disabled = false;
        }
    };
    // Get input element by specified type or, if type isn't specified, by params.input
    sweetAlert.getInput = function(inputType) {
        if (currentContext) {
            var _currentContext2 = currentContext, params = _currentContext2.params, domCache = _currentContext2.domCache;
            inputType = inputType || params.input;
            if (!inputType) return null;
            switch(inputType){
                case 'select':
                case 'textarea':
                case 'file':
                    return getChildByClass(domCache.content, swalClasses[inputType]);
                case 'checkbox':
                    return domCache.popup.querySelector('.' + swalClasses.checkbox + ' input');
                case 'radio':
                    return domCache.popup.querySelector('.' + swalClasses.radio + ' input:checked') || domCache.popup.querySelector('.' + swalClasses.radio + ' input:first-child');
                case 'range':
                    return domCache.popup.querySelector('.' + swalClasses.range + ' input');
                default:
                    return getChildByClass(domCache.content, swalClasses.input);
            }
        }
    };
    sweetAlert.enableButtons = function() {
        if (currentContext) {
            var _currentContext3 = currentContext, domCache = _currentContext3.domCache;
            domCache.confirmButton.disabled = false;
            domCache.cancelButton.disabled = false;
        }
    };
    sweetAlert.disableButtons = function() {
        if (currentContext) {
            var _currentContext4 = currentContext, domCache = _currentContext4.domCache;
            domCache.confirmButton.disabled = true;
            domCache.cancelButton.disabled = true;
        }
    };
    sweetAlert.enableConfirmButton = function() {
        if (currentContext) {
            var _currentContext5 = currentContext, domCache = _currentContext5.domCache;
            domCache.confirmButton.disabled = false;
        }
    };
    sweetAlert.disableConfirmButton = function() {
        if (currentContext) {
            var _currentContext6 = currentContext, domCache = _currentContext6.domCache;
            domCache.confirmButton.disabled = true;
        }
    };
    sweetAlert.enableInput = function() {
        if (currentContext) {
            var input = sweetAlert.getInput();
            if (!input) return false;
            if (input.type === 'radio') {
                var radiosContainer = input.parentNode.parentNode;
                var radios = radiosContainer.querySelectorAll('input');
                for(var i = 0; i < radios.length; i++)radios[i].disabled = false;
            } else input.disabled = false;
        }
    };
    sweetAlert.disableInput = function() {
        if (currentContext) {
            var input = sweetAlert.getInput();
            if (!input) return false;
            if (input && input.type === 'radio') {
                var radiosContainer = input.parentNode.parentNode;
                var radios = radiosContainer.querySelectorAll('input');
                for(var i = 0; i < radios.length; i++)radios[i].disabled = true;
            } else input.disabled = true;
        }
    };
    // Show block with validation error
    sweetAlert.showValidationError = function(error$$1) {
        if (currentContext) {
            var _currentContext7 = currentContext, domCache = _currentContext7.domCache;
            domCache.validationError.innerHTML = error$$1;
            var popupComputedStyle = window.getComputedStyle(domCache.popup);
            domCache.validationError.style.marginLeft = '-' + popupComputedStyle.getPropertyValue('padding-left');
            domCache.validationError.style.marginRight = '-' + popupComputedStyle.getPropertyValue('padding-right');
            show(domCache.validationError);
            var input = sweetAlert.getInput();
            if (input) {
                input.setAttribute('aria-invalid', true);
                input.setAttribute('aria-describedBy', swalClasses.validationerror);
                focusInput(input);
                addClass(input, swalClasses.inputerror);
            }
        }
    };
    // Hide block with validation error
    sweetAlert.resetValidationError = function() {
        if (currentContext) {
            var _currentContext8 = currentContext, domCache = _currentContext8.domCache;
            if (domCache.validationError) hide(domCache.validationError);
            var input = sweetAlert.getInput();
            if (input) {
                input.removeAttribute('aria-invalid');
                input.removeAttribute('aria-describedBy');
                removeClass(input, swalClasses.inputerror);
            }
        }
    };
    sweetAlert.getProgressSteps = function() {
        if (currentContext) {
            var _currentContext9 = currentContext, params = _currentContext9.params;
            return params.progressSteps;
        }
    };
    sweetAlert.setProgressSteps = function(progressSteps) {
        if (currentContext) {
            var _currentContext10 = currentContext, params = _currentContext10.params;
            params.progressSteps = progressSteps;
            setParameters(params);
        }
    };
    sweetAlert.showProgressSteps = function() {
        if (currentContext) {
            var _currentContext11 = currentContext, domCache = _currentContext11.domCache;
            show(domCache.progressSteps);
        }
    };
    sweetAlert.hideProgressSteps = function() {
        if (currentContext) {
            var _currentContext12 = currentContext, domCache = _currentContext12.domCache;
            hide(domCache.progressSteps);
        }
    };
    sweetAlert.DismissReason = DismissReason;
    sweetAlert.noop = function() {};
    sweetAlert.version = version;
    sweetAlert.default = sweetAlert;
    /**
 * Set default params if `window._swalDefaults` is an object
 */ if (typeof window !== 'undefined' && _typeof$3(window._swalDefaults) === 'object') sweetAlert.setDefaults(window._swalDefaults);
    return sweetAlert;
});
if (typeof window !== 'undefined' && window.Sweetalert2) window.sweetAlert = window.swal = window.Sweetalert2;
"undefined" != typeof document && function(e, t) {
    var n = e.createElement("style");
    if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
    else try {
        n.innerHTML = t;
    } catch (e) {
        n.innerText = t;
    }
}(document, "@-webkit-keyframes swal2-show {\n  0% {\n    -webkit-transform: scale(0.7);\n            transform: scale(0.7); }\n  45% {\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05); }\n  80% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@keyframes swal2-show {\n  0% {\n    -webkit-transform: scale(0.7);\n            transform: scale(0.7); }\n  45% {\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05); }\n  80% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@-webkit-keyframes swal2-hide {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1; }\n  100% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n    opacity: 0; } }\n\n@keyframes swal2-hide {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1; }\n  100% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n    opacity: 0; } }\n\n@-webkit-keyframes swal2-animate-success-line-tip {\n  0% {\n    top: 1.1875em;\n    left: .0625em;\n    width: 0; }\n  54% {\n    top: 1.0625em;\n    left: .125em;\n    width: 0; }\n  70% {\n    top: 2.1875em;\n    left: -.375em;\n    width: 3.125em; }\n  84% {\n    top: 3em;\n    left: 1.3125em;\n    width: 1.0625em; }\n  100% {\n    top: 2.8125em;\n    left: .875em;\n    width: 1.5625em; } }\n\n@keyframes swal2-animate-success-line-tip {\n  0% {\n    top: 1.1875em;\n    left: .0625em;\n    width: 0; }\n  54% {\n    top: 1.0625em;\n    left: .125em;\n    width: 0; }\n  70% {\n    top: 2.1875em;\n    left: -.375em;\n    width: 3.125em; }\n  84% {\n    top: 3em;\n    left: 1.3125em;\n    width: 1.0625em; }\n  100% {\n    top: 2.8125em;\n    left: .875em;\n    width: 1.5625em; } }\n\n@-webkit-keyframes swal2-animate-success-line-long {\n  0% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0; }\n  65% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0; }\n  84% {\n    top: 2.1875em;\n    right: 0;\n    width: 3.4375em; }\n  100% {\n    top: 2.375em;\n    right: .5em;\n    width: 2.9375em; } }\n\n@keyframes swal2-animate-success-line-long {\n  0% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0; }\n  65% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0; }\n  84% {\n    top: 2.1875em;\n    right: 0;\n    width: 3.4375em; }\n  100% {\n    top: 2.375em;\n    right: .5em;\n    width: 2.9375em; } }\n\n@-webkit-keyframes swal2-rotate-success-circular-line {\n  0% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  5% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  12% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); }\n  100% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); } }\n\n@keyframes swal2-rotate-success-circular-line {\n  0% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  5% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  12% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); }\n  100% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); } }\n\n@-webkit-keyframes swal2-animate-error-x-mark {\n  0% {\n    margin-top: 1.625em;\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    opacity: 0; }\n  50% {\n    margin-top: 1.625em;\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    opacity: 0; }\n  80% {\n    margin-top: -.375em;\n    -webkit-transform: scale(1.15);\n            transform: scale(1.15); }\n  100% {\n    margin-top: 0;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1; } }\n\n@keyframes swal2-animate-error-x-mark {\n  0% {\n    margin-top: 1.625em;\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    opacity: 0; }\n  50% {\n    margin-top: 1.625em;\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    opacity: 0; }\n  80% {\n    margin-top: -.375em;\n    -webkit-transform: scale(1.15);\n            transform: scale(1.15); }\n  100% {\n    margin-top: 0;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1; } }\n\n@-webkit-keyframes swal2-animate-error-icon {\n  0% {\n    -webkit-transform: rotateX(100deg);\n            transform: rotateX(100deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform: rotateX(0deg);\n            transform: rotateX(0deg);\n    opacity: 1; } }\n\n@keyframes swal2-animate-error-icon {\n  0% {\n    -webkit-transform: rotateX(100deg);\n            transform: rotateX(100deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform: rotateX(0deg);\n            transform: rotateX(0deg);\n    opacity: 1; } }\n\nbody.swal2-toast-shown.swal2-has-input > .swal2-container > .swal2-toast {\n  flex-direction: column;\n  align-items: stretch; }\n  body.swal2-toast-shown.swal2-has-input > .swal2-container > .swal2-toast .swal2-actions {\n    flex: 1;\n    align-self: stretch;\n    justify-content: flex-end;\n    height: 2.2em; }\n  body.swal2-toast-shown.swal2-has-input > .swal2-container > .swal2-toast .swal2-loading {\n    justify-content: center; }\n  body.swal2-toast-shown.swal2-has-input > .swal2-container > .swal2-toast .swal2-input {\n    height: 2em;\n    margin: .3125em auto;\n    font-size: 1em; }\n  body.swal2-toast-shown.swal2-has-input > .swal2-container > .swal2-toast .swal2-validationerror {\n    font-size: 1em; }\n\nbody.swal2-toast-shown > .swal2-container {\n  position: fixed;\n  background-color: transparent; }\n  body.swal2-toast-shown > .swal2-container.swal2-shown {\n    background-color: transparent; }\n  body.swal2-toast-shown > .swal2-container.swal2-top {\n    top: 0;\n    right: auto;\n    bottom: auto;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n            transform: translateX(-50%); }\n  body.swal2-toast-shown > .swal2-container.swal2-top-end, body.swal2-toast-shown > .swal2-container.swal2-top-right {\n    top: 0;\n    right: 0;\n    bottom: auto;\n    left: auto; }\n  body.swal2-toast-shown > .swal2-container.swal2-top-start, body.swal2-toast-shown > .swal2-container.swal2-top-left {\n    top: 0;\n    right: auto;\n    bottom: auto;\n    left: 0; }\n  body.swal2-toast-shown > .swal2-container.swal2-center-start, body.swal2-toast-shown > .swal2-container.swal2-center-left {\n    top: 50%;\n    right: auto;\n    bottom: auto;\n    left: 0;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%); }\n  body.swal2-toast-shown > .swal2-container.swal2-center {\n    top: 50%;\n    right: auto;\n    bottom: auto;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%); }\n  body.swal2-toast-shown > .swal2-container.swal2-center-end, body.swal2-toast-shown > .swal2-container.swal2-center-right {\n    top: 50%;\n    right: 0;\n    bottom: auto;\n    left: auto;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%); }\n  body.swal2-toast-shown > .swal2-container.swal2-bottom-start, body.swal2-toast-shown > .swal2-container.swal2-bottom-left {\n    top: auto;\n    right: auto;\n    bottom: 0;\n    left: 0; }\n  body.swal2-toast-shown > .swal2-container.swal2-bottom {\n    top: auto;\n    right: auto;\n    bottom: 0;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n            transform: translateX(-50%); }\n  body.swal2-toast-shown > .swal2-container.swal2-bottom-end, body.swal2-toast-shown > .swal2-container.swal2-bottom-right {\n    top: auto;\n    right: 0;\n    bottom: 0;\n    left: auto; }\n\n.swal2-popup.swal2-toast {\n  flex-direction: row;\n  align-items: center;\n  width: auto;\n  padding: 0.625em;\n  box-shadow: 0 0 0.625em #d9d9d9;\n  overflow-y: hidden; }\n  .swal2-popup.swal2-toast .swal2-header {\n    flex-direction: row; }\n  .swal2-popup.swal2-toast .swal2-title {\n    justify-content: flex-start;\n    margin: 0 .6em;\n    font-size: 1em; }\n  .swal2-popup.swal2-toast .swal2-close {\n    position: initial; }\n  .swal2-popup.swal2-toast .swal2-content {\n    justify-content: flex-start;\n    font-size: 1em; }\n  .swal2-popup.swal2-toast .swal2-icon {\n    width: 2em;\n    min-width: 2em;\n    height: 2em;\n    margin: 0; }\n    .swal2-popup.swal2-toast .swal2-icon-text {\n      font-size: 2em;\n      font-weight: bold;\n      line-height: 1em; }\n    .swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring {\n      width: 2em;\n      height: 2em; }\n    .swal2-popup.swal2-toast .swal2-icon.swal2-error [class^='swal2-x-mark-line'] {\n      top: .875em;\n      width: 1.375em; }\n      .swal2-popup.swal2-toast .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class$='left'] {\n        left: .3125em; }\n      .swal2-popup.swal2-toast .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class$='right'] {\n        right: .3125em; }\n  .swal2-popup.swal2-toast .swal2-actions {\n    height: auto;\n    margin: 0 .3125em; }\n  .swal2-popup.swal2-toast .swal2-styled {\n    margin: 0 .3125em;\n    padding: .3125em .625em;\n    font-size: 1em; }\n    .swal2-popup.swal2-toast .swal2-styled:focus {\n      box-shadow: 0 0 0 0.0625em #fff, 0 0 0 0.125em rgba(50, 100, 150, 0.4); }\n  .swal2-popup.swal2-toast .swal2-success {\n    border-color: #a5dc86; }\n    .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'] {\n      position: absolute;\n      width: 2em;\n      height: 2.8125em;\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n      border-radius: 50%; }\n      .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'][class$='left'] {\n        top: -.25em;\n        left: -.9375em;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg);\n        -webkit-transform-origin: 2em 2em;\n                transform-origin: 2em 2em;\n        border-radius: 4em 0 0 4em; }\n      .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'][class$='right'] {\n        top: -.25em;\n        left: .9375em;\n        -webkit-transform-origin: 0 2em;\n                transform-origin: 0 2em;\n        border-radius: 0 4em 4em 0; }\n    .swal2-popup.swal2-toast .swal2-success .swal2-success-ring {\n      width: 2em;\n      height: 2em; }\n    .swal2-popup.swal2-toast .swal2-success .swal2-success-fix {\n      top: 0;\n      left: .4375em;\n      width: .4375em;\n      height: 2.6875em; }\n    .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'] {\n      height: .3125em; }\n      .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class$='tip'] {\n        top: 1.125em;\n        left: .1875em;\n        width: .75em; }\n      .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class$='long'] {\n        top: .9375em;\n        right: .1875em;\n        width: 1.375em; }\n  .swal2-popup.swal2-toast.swal2-show {\n    -webkit-animation: showSweetToast .5s;\n            animation: showSweetToast .5s; }\n  .swal2-popup.swal2-toast.swal2-hide {\n    -webkit-animation: hideSweetToast .2s forwards;\n            animation: hideSweetToast .2s forwards; }\n  .swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-tip {\n    -webkit-animation: animate-toast-success-tip .75s;\n            animation: animate-toast-success-tip .75s; }\n  .swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-long {\n    -webkit-animation: animate-toast-success-long .75s;\n            animation: animate-toast-success-long .75s; }\n\n@-webkit-keyframes showSweetToast {\n  0% {\n    -webkit-transform: translateY(-0.625em) rotateZ(2deg);\n            transform: translateY(-0.625em) rotateZ(2deg);\n    opacity: 0; }\n  33% {\n    -webkit-transform: translateY(0) rotateZ(-2deg);\n            transform: translateY(0) rotateZ(-2deg);\n    opacity: .5; }\n  66% {\n    -webkit-transform: translateY(0.3125em) rotateZ(2deg);\n            transform: translateY(0.3125em) rotateZ(2deg);\n    opacity: .7; }\n  100% {\n    -webkit-transform: translateY(0) rotateZ(0);\n            transform: translateY(0) rotateZ(0);\n    opacity: 1; } }\n\n@keyframes showSweetToast {\n  0% {\n    -webkit-transform: translateY(-0.625em) rotateZ(2deg);\n            transform: translateY(-0.625em) rotateZ(2deg);\n    opacity: 0; }\n  33% {\n    -webkit-transform: translateY(0) rotateZ(-2deg);\n            transform: translateY(0) rotateZ(-2deg);\n    opacity: .5; }\n  66% {\n    -webkit-transform: translateY(0.3125em) rotateZ(2deg);\n            transform: translateY(0.3125em) rotateZ(2deg);\n    opacity: .7; }\n  100% {\n    -webkit-transform: translateY(0) rotateZ(0);\n            transform: translateY(0) rotateZ(0);\n    opacity: 1; } }\n\n@-webkit-keyframes hideSweetToast {\n  0% {\n    opacity: 1; }\n  33% {\n    opacity: .5; }\n  100% {\n    -webkit-transform: rotateZ(1deg);\n            transform: rotateZ(1deg);\n    opacity: 0; } }\n\n@keyframes hideSweetToast {\n  0% {\n    opacity: 1; }\n  33% {\n    opacity: .5; }\n  100% {\n    -webkit-transform: rotateZ(1deg);\n            transform: rotateZ(1deg);\n    opacity: 0; } }\n\n@-webkit-keyframes animate-toast-success-tip {\n  0% {\n    top: .5625em;\n    left: .0625em;\n    width: 0; }\n  54% {\n    top: .125em;\n    left: .125em;\n    width: 0; }\n  70% {\n    top: .625em;\n    left: -.25em;\n    width: 1.625em; }\n  84% {\n    top: 1.0625em;\n    left: .75em;\n    width: .5em; }\n  100% {\n    top: 1.125em;\n    left: .1875em;\n    width: .75em; } }\n\n@keyframes animate-toast-success-tip {\n  0% {\n    top: .5625em;\n    left: .0625em;\n    width: 0; }\n  54% {\n    top: .125em;\n    left: .125em;\n    width: 0; }\n  70% {\n    top: .625em;\n    left: -.25em;\n    width: 1.625em; }\n  84% {\n    top: 1.0625em;\n    left: .75em;\n    width: .5em; }\n  100% {\n    top: 1.125em;\n    left: .1875em;\n    width: .75em; } }\n\n@-webkit-keyframes animate-toast-success-long {\n  0% {\n    top: 1.625em;\n    right: 1.375em;\n    width: 0; }\n  65% {\n    top: 1.25em;\n    right: .9375em;\n    width: 0; }\n  84% {\n    top: .9375em;\n    right: 0;\n    width: 1.125em; }\n  100% {\n    top: .9375em;\n    right: .1875em;\n    width: 1.375em; } }\n\n@keyframes animate-toast-success-long {\n  0% {\n    top: 1.625em;\n    right: 1.375em;\n    width: 0; }\n  65% {\n    top: 1.25em;\n    right: .9375em;\n    width: 0; }\n  84% {\n    top: .9375em;\n    right: 0;\n    width: 1.125em; }\n  100% {\n    top: .9375em;\n    right: .1875em;\n    width: 1.375em; } }\n\nhtml.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown),\nbody.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {\n  height: auto;\n  overflow-y: hidden; }\n\nbody.swal2-no-backdrop .swal2-shown {\n  top: auto;\n  right: auto;\n  bottom: auto;\n  left: auto;\n  background-color: transparent; }\n  body.swal2-no-backdrop .swal2-shown > .swal2-modal {\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4); }\n  body.swal2-no-backdrop .swal2-shown.swal2-top {\n    top: 0;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n            transform: translateX(-50%); }\n  body.swal2-no-backdrop .swal2-shown.swal2-top-start, body.swal2-no-backdrop .swal2-shown.swal2-top-left {\n    top: 0;\n    left: 0; }\n  body.swal2-no-backdrop .swal2-shown.swal2-top-end, body.swal2-no-backdrop .swal2-shown.swal2-top-right {\n    top: 0;\n    right: 0; }\n  body.swal2-no-backdrop .swal2-shown.swal2-center {\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%); }\n  body.swal2-no-backdrop .swal2-shown.swal2-center-start, body.swal2-no-backdrop .swal2-shown.swal2-center-left {\n    top: 50%;\n    left: 0;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%); }\n  body.swal2-no-backdrop .swal2-shown.swal2-center-end, body.swal2-no-backdrop .swal2-shown.swal2-center-right {\n    top: 50%;\n    right: 0;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%); }\n  body.swal2-no-backdrop .swal2-shown.swal2-bottom {\n    bottom: 0;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n            transform: translateX(-50%); }\n  body.swal2-no-backdrop .swal2-shown.swal2-bottom-start, body.swal2-no-backdrop .swal2-shown.swal2-bottom-left {\n    bottom: 0;\n    left: 0; }\n  body.swal2-no-backdrop .swal2-shown.swal2-bottom-end, body.swal2-no-backdrop .swal2-shown.swal2-bottom-right {\n    right: 0;\n    bottom: 0; }\n\n.swal2-container {\n  display: flex;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  background-color: transparent;\n  z-index: 1060;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch; }\n  .swal2-container.swal2-top {\n    align-items: flex-start; }\n  .swal2-container.swal2-top-start, .swal2-container.swal2-top-left {\n    align-items: flex-start;\n    justify-content: flex-start; }\n  .swal2-container.swal2-top-end, .swal2-container.swal2-top-right {\n    align-items: flex-start;\n    justify-content: flex-end; }\n  .swal2-container.swal2-center {\n    align-items: center; }\n  .swal2-container.swal2-center-start, .swal2-container.swal2-center-left {\n    align-items: center;\n    justify-content: flex-start; }\n  .swal2-container.swal2-center-end, .swal2-container.swal2-center-right {\n    align-items: center;\n    justify-content: flex-end; }\n  .swal2-container.swal2-bottom {\n    align-items: flex-end; }\n  .swal2-container.swal2-bottom-start, .swal2-container.swal2-bottom-left {\n    align-items: flex-end;\n    justify-content: flex-start; }\n  .swal2-container.swal2-bottom-end, .swal2-container.swal2-bottom-right {\n    align-items: flex-end;\n    justify-content: flex-end; }\n  .swal2-container.swal2-grow-fullscreen > .swal2-modal {\n    display: flex !important;\n    flex: 1;\n    align-self: stretch;\n    justify-content: center; }\n  .swal2-container.swal2-grow-row > .swal2-modal {\n    display: flex !important;\n    flex: 1;\n    align-content: center;\n    justify-content: center; }\n  .swal2-container.swal2-grow-column {\n    flex: 1;\n    flex-direction: column; }\n    .swal2-container.swal2-grow-column.swal2-top, .swal2-container.swal2-grow-column.swal2-center, .swal2-container.swal2-grow-column.swal2-bottom {\n      align-items: center; }\n    .swal2-container.swal2-grow-column.swal2-top-start, .swal2-container.swal2-grow-column.swal2-center-start, .swal2-container.swal2-grow-column.swal2-bottom-start, .swal2-container.swal2-grow-column.swal2-top-left, .swal2-container.swal2-grow-column.swal2-center-left, .swal2-container.swal2-grow-column.swal2-bottom-left {\n      align-items: flex-start; }\n    .swal2-container.swal2-grow-column.swal2-top-end, .swal2-container.swal2-grow-column.swal2-center-end, .swal2-container.swal2-grow-column.swal2-bottom-end, .swal2-container.swal2-grow-column.swal2-top-right, .swal2-container.swal2-grow-column.swal2-center-right, .swal2-container.swal2-grow-column.swal2-bottom-right {\n      align-items: flex-end; }\n    .swal2-container.swal2-grow-column > .swal2-modal {\n      display: flex !important;\n      flex: 1;\n      align-content: center;\n      justify-content: center; }\n  .swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right) > .swal2-modal {\n    margin: auto; }\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    .swal2-container .swal2-modal {\n      margin: 0 !important; } }\n  .swal2-container.swal2-fade {\n    transition: background-color .1s; }\n  .swal2-container.swal2-shown {\n    background-color: rgba(0, 0, 0, 0.4); }\n\n.swal2-popup {\n  display: none;\n  position: relative;\n  flex-direction: column;\n  justify-content: center;\n  width: 32em;\n  max-width: 100%;\n  padding: 1.25em;\n  border-radius: 0.3125em;\n  background: #fff;\n  font-family: inherit;\n  font-size: 1rem;\n  box-sizing: border-box; }\n  .swal2-popup:focus {\n    outline: none; }\n  .swal2-popup.swal2-loading {\n    overflow-y: hidden; }\n  .swal2-popup .swal2-header {\n    display: flex;\n    flex-direction: column;\n    align-items: center; }\n  .swal2-popup .swal2-title {\n    display: block;\n    position: relative;\n    max-width: 100%;\n    margin: 0 0 0.4em;\n    padding: 0;\n    color: #595959;\n    font-size: 1.875em;\n    font-weight: 600;\n    text-align: center;\n    text-transform: none;\n    word-wrap: break-word; }\n  .swal2-popup .swal2-actions {\n    align-items: center;\n    justify-content: center;\n    margin: 1.25em auto 0; }\n    .swal2-popup .swal2-actions:not(.swal2-loading) .swal2-styled[disabled] {\n      opacity: .4; }\n    .swal2-popup .swal2-actions:not(.swal2-loading) .swal2-styled:hover {\n      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)); }\n    .swal2-popup .swal2-actions:not(.swal2-loading) .swal2-styled:active {\n      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)); }\n    .swal2-popup .swal2-actions.swal2-loading .swal2-styled.swal2-confirm {\n      width: 2.5em;\n      height: 2.5em;\n      margin: .46875em;\n      padding: 0;\n      border: .25em solid transparent;\n      border-radius: 100%;\n      border-color: transparent;\n      background-color: transparent !important;\n      color: transparent;\n      cursor: default;\n      box-sizing: border-box;\n      -webkit-animation: swal2-rotate-loading 1.5s linear 0s infinite normal;\n              animation: swal2-rotate-loading 1.5s linear 0s infinite normal;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none; }\n    .swal2-popup .swal2-actions.swal2-loading .swal2-styled.swal2-cancel {\n      margin-right: 30px;\n      margin-left: 30px; }\n    .swal2-popup .swal2-actions.swal2-loading :not(.swal2-styled).swal2-confirm::after {\n      display: inline-block;\n      width: 15px;\n      height: 15px;\n      margin-left: 5px;\n      border: 3px solid #999999;\n      border-radius: 50%;\n      border-right-color: transparent;\n      box-shadow: 1px 1px 1px #fff;\n      content: '';\n      -webkit-animation: swal2-rotate-loading 1.5s linear 0s infinite normal;\n              animation: swal2-rotate-loading 1.5s linear 0s infinite normal; }\n  .swal2-popup .swal2-styled {\n    margin: 0 .3125em;\n    padding: .625em 2em;\n    font-weight: 500;\n    box-shadow: none; }\n    .swal2-popup .swal2-styled:not([disabled]) {\n      cursor: pointer; }\n    .swal2-popup .swal2-styled.swal2-confirm {\n      border: 0;\n      border-radius: 0.25em;\n      background: initial;\n      background-color: #3085d6;\n      color: #fff;\n      font-size: 1.0625em; }\n    .swal2-popup .swal2-styled.swal2-cancel {\n      border: 0;\n      border-radius: 0.25em;\n      background: initial;\n      background-color: #aaa;\n      color: #fff;\n      font-size: 1.0625em; }\n    .swal2-popup .swal2-styled:focus {\n      outline: none;\n      box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(50, 100, 150, 0.4); }\n    .swal2-popup .swal2-styled::-moz-focus-inner {\n      border: 0; }\n  .swal2-popup .swal2-footer {\n    justify-content: center;\n    margin: 1.25em 0 0;\n    padding-top: 1em;\n    border-top: 1px solid #eee;\n    color: #545454;\n    font-size: 1em; }\n  .swal2-popup .swal2-image {\n    max-width: 100%;\n    margin: 1.25em auto; }\n  .swal2-popup .swal2-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    justify-content: center;\n    width: 1.2em;\n    min-width: 1.2em;\n    height: 1.2em;\n    margin: 0;\n    padding: 0;\n    transition: color 0.1s ease-out;\n    border: none;\n    border-radius: 0;\n    background: transparent;\n    color: #cccccc;\n    font-family: serif;\n    font-size: calc(2.5em - 0.25em);\n    line-height: 1.2em;\n    cursor: pointer; }\n    .swal2-popup .swal2-close:hover {\n      -webkit-transform: none;\n              transform: none;\n      color: #f27474; }\n  .swal2-popup > .swal2-input,\n  .swal2-popup > .swal2-file,\n  .swal2-popup > .swal2-textarea,\n  .swal2-popup > .swal2-select,\n  .swal2-popup > .swal2-radio,\n  .swal2-popup > .swal2-checkbox {\n    display: none; }\n  .swal2-popup .swal2-content {\n    justify-content: center;\n    margin: 0;\n    padding: 0;\n    color: #545454;\n    font-size: 1.125em;\n    font-weight: 300;\n    line-height: normal;\n    word-wrap: break-word; }\n  .swal2-popup #swal2-content {\n    text-align: center; }\n  .swal2-popup .swal2-input,\n  .swal2-popup .swal2-file,\n  .swal2-popup .swal2-textarea,\n  .swal2-popup .swal2-select,\n  .swal2-popup .swal2-radio,\n  .swal2-popup .swal2-checkbox {\n    margin: 1em auto; }\n  .swal2-popup .swal2-input,\n  .swal2-popup .swal2-file,\n  .swal2-popup .swal2-textarea {\n    width: 100%;\n    transition: border-color .3s, box-shadow .3s;\n    border: 1px solid #d9d9d9;\n    border-radius: 0.1875em;\n    font-size: 1.125em;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\n    box-sizing: border-box; }\n    .swal2-popup .swal2-input.swal2-inputerror,\n    .swal2-popup .swal2-file.swal2-inputerror,\n    .swal2-popup .swal2-textarea.swal2-inputerror {\n      border-color: #f27474 !important;\n      box-shadow: 0 0 2px #f27474 !important; }\n    .swal2-popup .swal2-input:focus,\n    .swal2-popup .swal2-file:focus,\n    .swal2-popup .swal2-textarea:focus {\n      border: 1px solid #b4dbed;\n      outline: none;\n      box-shadow: 0 0 3px #c4e6f5; }\n    .swal2-popup .swal2-input::-webkit-input-placeholder,\n    .swal2-popup .swal2-file::-webkit-input-placeholder,\n    .swal2-popup .swal2-textarea::-webkit-input-placeholder {\n      color: #cccccc; }\n    .swal2-popup .swal2-input:-ms-input-placeholder,\n    .swal2-popup .swal2-file:-ms-input-placeholder,\n    .swal2-popup .swal2-textarea:-ms-input-placeholder {\n      color: #cccccc; }\n    .swal2-popup .swal2-input::-ms-input-placeholder,\n    .swal2-popup .swal2-file::-ms-input-placeholder,\n    .swal2-popup .swal2-textarea::-ms-input-placeholder {\n      color: #cccccc; }\n    .swal2-popup .swal2-input::placeholder,\n    .swal2-popup .swal2-file::placeholder,\n    .swal2-popup .swal2-textarea::placeholder {\n      color: #cccccc; }\n  .swal2-popup .swal2-range input {\n    width: 80%; }\n  .swal2-popup .swal2-range output {\n    width: 20%;\n    font-weight: 600;\n    text-align: center; }\n  .swal2-popup .swal2-range input,\n  .swal2-popup .swal2-range output {\n    height: 2.625em;\n    margin: 1em auto;\n    padding: 0;\n    font-size: 1.125em;\n    line-height: 2.625em; }\n  .swal2-popup .swal2-input {\n    height: 2.625em;\n    padding: 0.75em; }\n    .swal2-popup .swal2-input[type='number'] {\n      max-width: 10em; }\n  .swal2-popup .swal2-file {\n    font-size: 1.125em; }\n  .swal2-popup .swal2-textarea {\n    height: 6.75em;\n    padding: 0.75em; }\n  .swal2-popup .swal2-select {\n    min-width: 50%;\n    max-width: 100%;\n    padding: .375em .625em;\n    color: #545454;\n    font-size: 1.125em; }\n  .swal2-popup .swal2-radio,\n  .swal2-popup .swal2-checkbox {\n    align-items: center;\n    justify-content: center; }\n    .swal2-popup .swal2-radio label,\n    .swal2-popup .swal2-checkbox label {\n      margin: 0 .6em;\n      font-size: 1.125em; }\n    .swal2-popup .swal2-radio input,\n    .swal2-popup .swal2-checkbox input {\n      margin: 0 .4em; }\n  .swal2-popup .swal2-validationerror {\n    display: none;\n    align-items: center;\n    justify-content: center;\n    padding: 0.625em;\n    background: #f0f0f0;\n    color: #666666;\n    font-size: 1em;\n    font-weight: 300;\n    overflow: hidden; }\n    .swal2-popup .swal2-validationerror::before {\n      display: inline-block;\n      width: 1.5em;\n      height: 1.5em;\n      margin: 0 .625em;\n      border-radius: 50%;\n      background-color: #f27474;\n      color: #fff;\n      font-weight: 600;\n      line-height: 1.5em;\n      text-align: center;\n      content: '!';\n      zoom: normal; }\n\n@supports (-ms-accelerator: true) {\n  .swal2-range input {\n    width: 100% !important; }\n  .swal2-range output {\n    display: none; } }\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .swal2-range input {\n    width: 100% !important; }\n  .swal2-range output {\n    display: none; } }\n\n.swal2-icon {\n  position: relative;\n  justify-content: center;\n  width: 5em;\n  height: 5em;\n  margin: 1.25em auto 1.875em;\n  border: .25em solid transparent;\n  border-radius: 50%;\n  line-height: 5em;\n  cursor: default;\n  box-sizing: content-box;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  zoom: normal; }\n  .swal2-icon-text {\n    font-size: 3.75em; }\n  .swal2-icon.swal2-error {\n    border-color: #f27474; }\n    .swal2-icon.swal2-error .swal2-x-mark {\n      position: relative;\n      flex-grow: 1; }\n    .swal2-icon.swal2-error [class^='swal2-x-mark-line'] {\n      display: block;\n      position: absolute;\n      top: 2.3125em;\n      width: 2.9375em;\n      height: .3125em;\n      border-radius: .125em;\n      background-color: #f27474; }\n      .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class$='left'] {\n        left: 1.0625em;\n        -webkit-transform: rotate(45deg);\n                transform: rotate(45deg); }\n      .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class$='right'] {\n        right: 1em;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg); }\n  .swal2-icon.swal2-warning {\n    border-color: #facea8;\n    color: #f8bb86; }\n  .swal2-icon.swal2-info {\n    border-color: #9de0f6;\n    color: #3fc3ee; }\n  .swal2-icon.swal2-question {\n    border-color: #c9dae1;\n    color: #87adbd; }\n  .swal2-icon.swal2-success {\n    border-color: #a5dc86; }\n    .swal2-icon.swal2-success [class^='swal2-success-circular-line'] {\n      position: absolute;\n      width: 3.75em;\n      height: 7.5em;\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n      border-radius: 50%; }\n      .swal2-icon.swal2-success [class^='swal2-success-circular-line'][class$='left'] {\n        top: -.4375em;\n        left: -2.0635em;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg);\n        -webkit-transform-origin: 3.75em 3.75em;\n                transform-origin: 3.75em 3.75em;\n        border-radius: 7.5em 0 0 7.5em; }\n      .swal2-icon.swal2-success [class^='swal2-success-circular-line'][class$='right'] {\n        top: -.6875em;\n        left: 1.875em;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg);\n        -webkit-transform-origin: 0 3.75em;\n                transform-origin: 0 3.75em;\n        border-radius: 0 7.5em 7.5em 0; }\n    .swal2-icon.swal2-success .swal2-success-ring {\n      position: absolute;\n      top: -.25em;\n      left: -.25em;\n      width: 100%;\n      height: 100%;\n      border: 0.25em solid rgba(165, 220, 134, 0.3);\n      border-radius: 50%;\n      z-index: 2;\n      box-sizing: content-box; }\n    .swal2-icon.swal2-success .swal2-success-fix {\n      position: absolute;\n      top: .5em;\n      left: 1.625em;\n      width: .4375em;\n      height: 5.625em;\n      -webkit-transform: rotate(-45deg);\n              transform: rotate(-45deg);\n      z-index: 1; }\n    .swal2-icon.swal2-success [class^='swal2-success-line'] {\n      display: block;\n      position: absolute;\n      height: .3125em;\n      border-radius: .125em;\n      background-color: #a5dc86;\n      z-index: 2; }\n      .swal2-icon.swal2-success [class^='swal2-success-line'][class$='tip'] {\n        top: 2.875em;\n        left: .875em;\n        width: 1.5625em;\n        -webkit-transform: rotate(45deg);\n                transform: rotate(45deg); }\n      .swal2-icon.swal2-success [class^='swal2-success-line'][class$='long'] {\n        top: 2.375em;\n        right: .5em;\n        width: 2.9375em;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg); }\n\n.swal2-progresssteps {\n  align-items: center;\n  margin: 0 0 1.25em;\n  padding: 0;\n  font-weight: 600; }\n  .swal2-progresssteps li {\n    display: inline-block;\n    position: relative; }\n  .swal2-progresssteps .swal2-progresscircle {\n    width: 2em;\n    height: 2em;\n    border-radius: 2em;\n    background: #3085d6;\n    color: #fff;\n    line-height: 2em;\n    text-align: center;\n    z-index: 20; }\n    .swal2-progresssteps .swal2-progresscircle:first-child {\n      margin-left: 0; }\n    .swal2-progresssteps .swal2-progresscircle:last-child {\n      margin-right: 0; }\n    .swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep {\n      background: #3085d6; }\n      .swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep ~ .swal2-progresscircle {\n        background: #add8e6; }\n      .swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep ~ .swal2-progressline {\n        background: #add8e6; }\n  .swal2-progresssteps .swal2-progressline {\n    width: 2.5em;\n    height: .4em;\n    margin: 0 -1px;\n    background: #3085d6;\n    z-index: 10; }\n\n[class^='swal2'] {\n  -webkit-tap-highlight-color: transparent; }\n\n.swal2-show {\n  -webkit-animation: swal2-show 0.3s;\n          animation: swal2-show 0.3s; }\n  .swal2-show.swal2-noanimation {\n    -webkit-animation: none;\n            animation: none; }\n\n.swal2-hide {\n  -webkit-animation: swal2-hide 0.15s forwards;\n          animation: swal2-hide 0.15s forwards; }\n  .swal2-hide.swal2-noanimation {\n    -webkit-animation: none;\n            animation: none; }\n\n[dir='rtl'] .swal2-close {\n  right: auto;\n  left: 0; }\n\n.swal2-animate-success-icon .swal2-success-line-tip {\n  -webkit-animation: swal2-animate-success-line-tip 0.75s;\n          animation: swal2-animate-success-line-tip 0.75s; }\n\n.swal2-animate-success-icon .swal2-success-line-long {\n  -webkit-animation: swal2-animate-success-line-long 0.75s;\n          animation: swal2-animate-success-line-long 0.75s; }\n\n.swal2-animate-success-icon .swal2-success-circular-line-right {\n  -webkit-animation: swal2-rotate-success-circular-line 4.25s ease-in;\n          animation: swal2-rotate-success-circular-line 4.25s ease-in; }\n\n.swal2-animate-error-icon {\n  -webkit-animation: swal2-animate-error-icon 0.5s;\n          animation: swal2-animate-error-icon 0.5s; }\n  .swal2-animate-error-icon .swal2-x-mark {\n    -webkit-animation: swal2-animate-error-x-mark 0.5s;\n            animation: swal2-animate-error-x-mark 0.5s; }\n\n@-webkit-keyframes swal2-rotate-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes swal2-rotate-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }");


const $b4af53e1575c5f4a$var$MySwal = (0, (/*@__PURE__*/$parcel$interopDefault($c372e7bb106ee43b$exports))).mixin({
    customClass: 'kassel-app-sweetalert'
});
var $b4af53e1575c5f4a$export$2e2bcd8739ae039 = $b4af53e1575c5f4a$var$MySwal;


// import videoSource from '../../../../RecorderAssets/game-of-thrones-1080p.mp4';
// import videoSource from '../../../../RecorderAssets/game-of-thrones-1080p-original.mp4';
var $1f335c6bff41c671$exports = {};
$1f335c6bff41c671$exports = $parcel$resolve("3QLMC");


const $d39cc430308b5205$export$26cbf8c37e721e67 = 'DefaultOpening';
const $d39cc430308b5205$export$5b6610bdbcc26c4f = (0, (/*@__PURE__*/$parcel$interopDefault($1f335c6bff41c671$exports)));
const $d39cc430308b5205$export$180f22624eb9e7e6 = 'A GIF with Catelyn Stark from Game of Thrones screaming in sorrow.';
const $d39cc430308b5205$export$f16af92caec6693c = 'vyTd1-VGYdU';
const $d39cc430308b5205$export$cb3d07a9e503e9e2 = 'Game of Thrones';
const $d39cc430308b5205$export$ca6f3c3553bace4c = 'https://kassellabs.us-east-1.linodeobjects.com/renderer-assets/game-of-thrones/game-of-thrones-1080p.mp4';
const $d39cc430308b5205$export$dd437a4492d64c21 = {
    GoT: "https://game-of-thrones-intros.firebaseio.com/"
};
const $d39cc430308b5205$export$73e713523066047d = $d39cc430308b5205$export$dd437a4492d64c21.GoT;
const $d39cc430308b5205$export$73ddb093a72d1f39 = 'GoT';
const $d39cc430308b5205$export$b6aaa66cc55c3181 = "https://queue.kassellabs.io";
if (!$d39cc430308b5205$export$73e713523066047d) throw new Error('Firebase URL can\'t be empty');
const $d39cc430308b5205$export$fbb44a8f9a47c90f = 26;
const $d39cc430308b5205$export$dc31da6a5e0e9565 = 150;
const $d39cc430308b5205$export$30f705544d29b60e = 40;
const $d39cc430308b5205$export$888108240e4c7c6d = 1;
const $d39cc430308b5205$export$87d6643ee8fe08fb = 0;
const $d39cc430308b5205$export$b53eb602ff8a7d04 = 97.73;
const $d39cc430308b5205$export$bc5effe1949c621f = 0;
const $d39cc430308b5205$export$9f4e2b01bf51f143 = "default";
const $d39cc430308b5205$export$240b20df485e8ed6 = {
    DEFAULT: 'default',
    LOCAL: 'local',
    RENDERER: 'renderer'
};
const $d39cc430308b5205$export$7392ea15d6a929a4 = $d39cc430308b5205$export$240b20df485e8ed6.DEFAULT === $d39cc430308b5205$export$9f4e2b01bf51f143;
const $d39cc430308b5205$export$e4cd0dd02a748dad = $d39cc430308b5205$export$240b20df485e8ed6.LOCAL === $d39cc430308b5205$export$9f4e2b01bf51f143;
const $d39cc430308b5205$export$5c1c1b03b1861229 = $d39cc430308b5205$export$240b20df485e8ed6.RENDERER === $d39cc430308b5205$export$9f4e2b01bf51f143;
if ($d39cc430308b5205$export$7392ea15d6a929a4 && !$d39cc430308b5205$export$b6aaa66cc55c3181) throw new Error('Queue API URL can\'t be empty');
if (!$d39cc430308b5205$export$7392ea15d6a929a4) console.log('Application mode loaded: ', $d39cc430308b5205$export$9f4e2b01bf51f143);
const $d39cc430308b5205$export$7467e90a3cb2bd05 = "https://payment.kassellabs.io/";


const $c7e4996cc1f99e7d$var$sanitizeHTML = (text)=>(0, (/*@__PURE__*/$parcel$interopDefault($726d757834788151$exports))).sanitize(text, {
        ALLOWED_TAGS: []
    });
const $c7e4996cc1f99e7d$var$showErrorAlert = ({ text: text, ...config })=>(0, $b4af53e1575c5f4a$export$2e2bcd8739ae039)({
        titleText: 'ERROR',
        showCancelButton: true,
        cancelButtonText: 'OK',
        cancelButtonAriaLabel: 'OK',
        confirmButtonText: 'HOME PAGE',
        confirmButtonAriaLabel: 'HOME PAGE',
        imageUrl: (0, $d39cc430308b5205$export$5b6610bdbcc26c4f),
        imageAlt: (0, $d39cc430308b5205$export$180f22624eb9e7e6),
        html: `${$c7e4996cc1f99e7d$var$sanitizeHTML(text)} <br/> Sorry for the inconvenience! We have been notified.`,
        ...config
    }).then((result)=>{
        if (result.value) window.location.href = '/';
        return result;
    });
var $c7e4996cc1f99e7d$export$2e2bcd8739ae039 = $c7e4996cc1f99e7d$var$showErrorAlert;




var $1c9bd35df1aeff0f$exports = {};

$1c9bd35df1aeff0f$exports = (parcelRequire("bRlFp"));


class $3f57eb746d1e51af$export$2e2bcd8739ae039 {
    constructor(maxValue){
        this.maxValue = maxValue;
        this.value = 0;
    }
    increment() {
        this.value += 1;
    }
    reset() {
        this.value = 0;
    }
    isMaxValue() {
        return this.value >= this.maxValue;
    }
}


const $fe3196be52085d52$var$REQUEST_TIMEOUT = 20000;
const $fe3196be52085d52$var$MAX_TRIES = 3;
const $fe3196be52085d52$var$Tries = new (0, $3f57eb746d1e51af$export$2e2bcd8739ae039)($fe3196be52085d52$var$MAX_TRIES);
const $fe3196be52085d52$var$_successInterceptor = (res)=>res;
const $fe3196be52085d52$var$_sendRavenNotification = (errorData)=>{
    Raven.captureException(new Error(JSON.stringify(errorData)));
};
const $fe3196be52085d52$var$_retryLastRequest = ({ config: config })=>{
    const options = {
        method: config.method,
        url: config.url,
        data: config.data ? JSON.parse(config.data) : null,
        params: config.params
    };
    return $fe3196be52085d52$var$Http().request(options).then((response)=>{
        $fe3196be52085d52$var$Tries.reset();
        return response;
    });
};
const $fe3196be52085d52$var$_errorInterceptor = (error)=>{
    if ($fe3196be52085d52$var$Tries.isMaxValue()) {
        $fe3196be52085d52$var$Tries.reset();
        Raven.captureBreadcrumb({
            message: `Error on request. Error code: ${error.code}`,
            level: 'error',
            data: {
                response: error.response
            }
        });
        $fe3196be52085d52$var$_sendRavenNotification(error);
        throw error;
    }
    $fe3196be52085d52$var$Tries.increment();
    return $fe3196be52085d52$var$_retryLastRequest(error);
};
function $fe3196be52085d52$var$Http(baseURL) {
    const http = (0, (/*@__PURE__*/$parcel$interopDefault($1c9bd35df1aeff0f$exports))).create({
        baseURL: baseURL,
        timeout: $fe3196be52085d52$var$REQUEST_TIMEOUT
    });
    http.interceptors.response.use($fe3196be52085d52$var$_successInterceptor, $fe3196be52085d52$var$_errorInterceptor);
    return http;
}
var $fe3196be52085d52$export$2e2bcd8739ae039 = $fe3196be52085d52$var$Http;


const $327d6f860e79ae2e$var$SERVER_TIMESTAMP = {
    '.sv': 'timestamp'
};
const $327d6f860e79ae2e$export$f7cc423f6e25ae12 = (key)=>{
    const result = {
        baseURL: (0, $d39cc430308b5205$export$73e713523066047d)
    };
    // is creating a new opening
    if (!key) return result;
    const prefix = key.slice(0, 3);
    const firebaseUrl = (0, $d39cc430308b5205$export$dd437a4492d64c21)[prefix];
    if (!firebaseUrl) throw new Error(`Firebase url for prefix not set: ${prefix}`);
    result.baseURL = firebaseUrl;
    result.key = key.substr(3);
    return result;
};
const $327d6f860e79ae2e$export$b7294a37fbc70cd0 = (key)=>{
    switch(key){
        case 'DefaultOpening':
            return 'GoTLobFELbLcKngC-pONqI';
        // TODO other season
        default:
            return key;
    }
};
const $327d6f860e79ae2e$var$openingsCache = {};
const $327d6f860e79ae2e$export$2e9bbdd7d6aa42af = (key)=>`/openings/-${key}.json`;
const $327d6f860e79ae2e$export$28353d84e8900851 = async (initialKey)=>{
    const openingFromCache = $327d6f860e79ae2e$var$openingsCache[initialKey];
    if (openingFromCache) // Raven.captureBreadcrumb({
    //   message: 'Getting intro from cache.',
    //   category: 'info',
    //   data: openingFromCache,
    // });
    return openingFromCache;
    const rawkey = $327d6f860e79ae2e$export$b7294a37fbc70cd0(initialKey);
    const { baseURL: baseURL, key: key } = $327d6f860e79ae2e$export$f7cc423f6e25ae12(rawkey);
    const http = (0, $fe3196be52085d52$export$2e2bcd8739ae039)(baseURL);
    const url = $327d6f860e79ae2e$export$2e9bbdd7d6aa42af(key);
    Raven.captureBreadcrumb({
        message: 'Loading intro from Firebase.',
        category: 'info',
        data: {
            initialKey: initialKey
        }
    });
    const response = await http.get(url);
    const opening = response.data;
    // const opening = {
    //   created: 1528165309973,
    //   texts: {
    //     text0: 'Sean Bean',
    //     text1: 'Mark Addy',
    //     text2: 'Nikolai Coster - Waldau',
    //     text3: 'Michelle Fairley',
    //     text4: 'Lena Headey',
    //     text5: 'Emilia Clarke',
    //     text6: 'Iain Glen',
    //     text7: 'Harry Lloyd\nKit Harington',
    //     text8: 'Sophie Turner\nMaisie Williams\nRichard Madden',
    //     text9: 'Alfie Allen\nIsaac Hempstead Wright\nJack Gleeson\nRory McCann',
    //     text10: 'and\nPeter Dinklage',
    //     text11: 'Nina Gold\nRobert Sterne',
    //     text12: 'Costume Designer\nMichele Clapton',
    //     text13: 'music by\nRamin Djawadi',
    //     text14: 'editor\nOral Norrie Ottey',
    //     text15: 'production designer\nGemma Jackson',
    //     text16: 'director of photography\nAlik Sakharov',
    //     text17: 'co-executive producer\nGeorge r.r. Martin',
    //     text18: 'co-executive producers\nVince Gerardis\nRalph Vicinanza',
    //     text19: 'co-executive producer\nGuymon Casady',
    //     text20: 'co-executive producer\nCarolyn Strauss',
    //     text21: 'producer\nMark Huffam',
    //     text22: 'producer\nFrank Doelger',
    //     text23: 'executive producers\nDavid Benioff\nD.B. Weiss',
    //     text24: 'created by\nDavid Benioff & D.B. Weiss',
    //     text25: 'based on\nA Song Of Ice And Fire\nby george r.r. martin',
    //     text26: 'Game of Thrones',
    //     text27: 'written by\nDavid Benioff & D.B. Weiss',
    //     text28: 'directed by\nTim Van Patten',
    //   },
    // };
    if (!opening) {
        const error = new Error(`Opening not found: ${initialKey}`);
        Raven.captureException(error);
        return opening;
    }
    // Remove created for when the opening is compared to the form it should ignore this property.
    delete opening.created;
    $327d6f860e79ae2e$var$openingsCache[initialKey] = opening;
    return opening;
};
const $327d6f860e79ae2e$export$dd5d218bf36d9f89 = async (opening)=>{
    const http = (0, $fe3196be52085d52$export$2e2bcd8739ae039)((0, $d39cc430308b5205$export$73e713523066047d));
    opening.created = $327d6f860e79ae2e$var$SERVER_TIMESTAMP;
    const response = await http.post('/openings.json', opening);
    const key = `${(0, $d39cc430308b5205$export$73ddb093a72d1f39)}${response.data.name.substr(1)}`;
    return key;
};


const $999f1b9a09e79f0c$var$firebaseOpeningEncode = (opening)=>{
    const encodedOpening = {
        ...opening
    };
    encodedOpening.texts = opening.texts.reduce((texts, current, index)=>{
        const key = `text${index}`;
        return {
            ...texts,
            [key]: current
        };
    }, {});
    return encodedOpening;
};
var $999f1b9a09e79f0c$export$2e2bcd8739ae039 = $999f1b9a09e79f0c$var$firebaseOpeningEncode;


var $b62a9abcf18d7d2c$exports = {};
$b62a9abcf18d7d2c$exports = JSON.parse("{\"DefaultOpening\":[\"Sean Bean\",\"Mark Addy\",\"Nikolai Coster - Waldau\",\"Michelle Fairley\",\"Lena Headey\",\"Emilia Clarke\",\"Iain Glen\",\"Harry Lloyd\\nKit Harington\",\"Sophie Turner\\nMaisie Williams\\nRichard Madden\",\"Alfie Allen\\nIsaac Hempstead Wright\\nJack Gleeson\\nRory McCann\",\"and\\nPeter Dinklage\",\"Nina Gold\\nRobert Sterne\",\"Costume Designer\\nMichele Clapton\",\"music by\\nRamin Djawadi\",\"editor\\nOral Norrie Ottey\",\"production designer\\nGemma Jackson\",\"director of photography\\nAlik Sakharov\",\"co-executive producer\\nGeorge r.r. Martin\",\"co-executive producers\\nVince Gerardis\\nRalph Vicinanza\",\"co-executive producer\\nGuymon Casady\",\"co-executive producer\\nCarolyn Strauss\",\"producer\\nMark Huffam\",\"producer\\nFrank Doelger\",\"executive producers\\nDavid Benioff\\nD.B. Weiss\",\"created by\\nDavid Benioff & D.B. Weiss\",\"based on\\nA Song Of Ice And Fire\\nby george r.r. martin\",\"#\",\"written by\\nDavid Benioff & D.B. Weiss\",\"directed by\\nTim Van Patten\"]}");


const $87127865826734e4$var$OpeningContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext();
class $87127865826734e4$var$OpeningProvider extends (0, $bh6RR.Component) {
    static propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).node
    };
    state = {
        opening: null,
        key: null,
        playNewOpening: async (opening, history)=>{
            let openingBefore = this.state.opening;
            if (!this.state.opening) {
                const defaultOpening = {
                    texts: (0, $b62a9abcf18d7d2c$exports.DefaultOpening)
                };
                openingBefore = (0, $999f1b9a09e79f0c$export$2e2bcd8739ae039)(defaultOpening);
            }
            const isOpeningUnchanged = (0, (/*@__PURE__*/$parcel$interopDefault($1DYgm)))(opening, openingBefore);
            if (isOpeningUnchanged) {
                const key = this.state.key || (0, $d39cc430308b5205$export$26cbf8c37e721e67);
                history.push(`/${key}`);
                return;
            }
            let key;
            try {
                key = await (0, $327d6f860e79ae2e$export$dd5d218bf36d9f89)(opening);
            } catch (error) {
                (0, $c7e4996cc1f99e7d$export$2e2bcd8739ae039)({
                    text: 'There was an error saving your intro.'
                });
                return;
            }
            history.push(`/${key}`);
        },
        loadOpening: async (openingKey, history)=>{
            let opening;
            try {
                opening = await (0, $327d6f860e79ae2e$export$28353d84e8900851)(openingKey);
            } catch (error) {
                (0, $c7e4996cc1f99e7d$export$2e2bcd8739ae039)({
                    text: `We could not load the introduction "${openingKey}".`,
                    cancelButtonText: 'RELOAD PAGE'
                }).then((result)=>{
                    if (!result.value) window.location.reload();
                });
                return;
            }
            if (!opening) {
                (0, $c7e4996cc1f99e7d$export$2e2bcd8739ae039)({
                    text: `The introduction with the key "${openingKey}" was not found.`
                }).then((result)=>{
                    if (!result.value) history.push('/');
                });
                return;
            }
            this.setState({
                opening: opening,
                key: openingKey
            });
        },
        clearOpening: ()=>{
            this.setState({
                opening: null,
                key: null
            });
        }
    };
    render() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($87127865826734e4$var$OpeningContext.Provider, {
            value: this.state,
            children: this.props.children
        });
    }
}
$87127865826734e4$var$OpeningProvider.Consumer = $87127865826734e4$var$OpeningContext.Consumer;
var $87127865826734e4$export$2e2bcd8739ae039 = $87127865826734e4$var$OpeningProvider;




var $bh6RR = parcelRequire("bh6RR");

var $9ee85db91d407c9f$exports = {};
"use strict";
Object.defineProperty($9ee85db91d407c9f$exports, "__esModule", {
    value: true
});
$9ee85db91d407c9f$exports.getFullScreenEnabled = void 0;

var $bh6RR = parcelRequire("bh6RR");
const $9ee85db91d407c9f$var$key = {
    fullscreenEnabled: 0,
    fullscreenElement: 1,
    requestFullscreen: 2,
    exitFullscreen: 3,
    fullscreenchange: 4,
    fullscreenerror: 5
};
const $9ee85db91d407c9f$var$webkit = [
    'webkitFullscreenEnabled',
    'webkitFullscreenElement',
    'webkitRequestFullscreen',
    'webkitExitFullscreen',
    'webkitfullscreenchange',
    'webkitfullscreenerror'
];
const $9ee85db91d407c9f$var$moz = [
    'mozFullScreenEnabled',
    'mozFullScreenElement',
    'mozRequestFullScreen',
    'mozCancelFullScreen',
    'mozfullscreenchange',
    'mozfullscreenerror'
];
const $9ee85db91d407c9f$var$ms = [
    'msFullscreenEnabled',
    'msFullscreenElement',
    'msRequestFullscreen',
    'msExitFullscreen',
    'MSFullscreenChange',
    'MSFullscreenError'
];
const $9ee85db91d407c9f$var$document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
const $9ee85db91d407c9f$var$vendor = 'fullscreenEnabled' in $9ee85db91d407c9f$var$document && Object.keys($9ee85db91d407c9f$var$key) || $9ee85db91d407c9f$var$webkit[0] in $9ee85db91d407c9f$var$document && $9ee85db91d407c9f$var$webkit || $9ee85db91d407c9f$var$moz[0] in $9ee85db91d407c9f$var$document && $9ee85db91d407c9f$var$moz || $9ee85db91d407c9f$var$ms[0] in $9ee85db91d407c9f$var$document && $9ee85db91d407c9f$var$ms || [];
class $9ee85db91d407c9f$var$fscreen {
    static requestFullscreen(element) {
        return element[$9ee85db91d407c9f$var$vendor[$9ee85db91d407c9f$var$key.requestFullscreen]]();
    }
    static requestFullscreenFunction(element) {
        return element[$9ee85db91d407c9f$var$vendor[$9ee85db91d407c9f$var$key.requestFullscreen]];
    }
    static get exitFullscreen() {
        return $9ee85db91d407c9f$var$document[$9ee85db91d407c9f$var$vendor[$9ee85db91d407c9f$var$key.exitFullscreen]].bind($9ee85db91d407c9f$var$document);
    }
    static addEventListener(type, handler, options) {
        return $9ee85db91d407c9f$var$document.addEventListener($9ee85db91d407c9f$var$vendor[$9ee85db91d407c9f$var$key[type]], handler, options);
    }
    static removeEventListener(type, handler, options) {
        return $9ee85db91d407c9f$var$document.removeEventListener($9ee85db91d407c9f$var$vendor[$9ee85db91d407c9f$var$key[type]], handler, options);
    }
    static get fullscreenEnabled() {
        return Boolean($9ee85db91d407c9f$var$document[$9ee85db91d407c9f$var$vendor[$9ee85db91d407c9f$var$key.fullscreenEnabled]]);
    }
    static set fullscreenEnabled(val) {}
    static get fullscreenElement() {
        return $9ee85db91d407c9f$var$document[$9ee85db91d407c9f$var$vendor[$9ee85db91d407c9f$var$key.fullscreenElement]];
    }
    static set fullscreenElement(val) {}
    static get onfullscreenchange() {
        return $9ee85db91d407c9f$var$document[`on${$9ee85db91d407c9f$var$vendor[$9ee85db91d407c9f$var$key.fullscreenchange]}`.toLowerCase()];
    }
    static set onfullscreenchange(handler) {
        $9ee85db91d407c9f$var$document[`on${$9ee85db91d407c9f$var$vendor[$9ee85db91d407c9f$var$key.fullscreenchange]}`.toLowerCase()] = handler;
    }
    static get onfullscreenerror() {
        return $9ee85db91d407c9f$var$document[`on${$9ee85db91d407c9f$var$vendor[$9ee85db91d407c9f$var$key.fullscreenerror]}`.toLowerCase()];
    }
    static set onfullscreenerror(handler) {
        $9ee85db91d407c9f$var$document[`on${$9ee85db91d407c9f$var$vendor[$9ee85db91d407c9f$var$key.fullscreenerror]}`.toLowerCase()] = handler;
    }
}
const $9ee85db91d407c9f$var$getFullScreenEnabled = ()=>{
    return $9ee85db91d407c9f$var$fscreen.fullscreenEnabled;
};
$9ee85db91d407c9f$exports.getFullScreenEnabled = $9ee85db91d407c9f$var$getFullScreenEnabled;
class $9ee85db91d407c9f$var$FullScreen extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.detectFullScreen = ()=>{
            if (this.props.onChange) this.props.onChange(!!$9ee85db91d407c9f$var$fscreen.fullscreenElement);
            if (this.props.onOpen && !!$9ee85db91d407c9f$var$fscreen.fullscreenElement) this.props.onOpen();
            if (this.props.onClose && !$9ee85db91d407c9f$var$fscreen.fullscreenElement) this.props.onClose();
        };
        this.enterFullScreen = ()=>{
            $9ee85db91d407c9f$var$fscreen.requestFullscreen(this.node);
        };
        this.leaveFullScreen = ()=>{
            $9ee85db91d407c9f$var$fscreen.exitFullscreen();
        };
    }
    componentDidMount() {
        $9ee85db91d407c9f$var$fscreen.addEventListener('fullscreenchange', this.detectFullScreen, {});
    }
    componentWillUnmount() {
        $9ee85db91d407c9f$var$fscreen.removeEventListener('fullscreenchange', this.detectFullScreen, {});
    }
    componentDidUpdate() {
        this.handleProps(this.props);
    }
    handleProps(props) {
        const enabled = $9ee85db91d407c9f$var$fscreen.fullscreenElement;
        if (enabled && !props.enabled) this.leaveFullScreen();
        else if (!enabled && props.enabled) this.enterFullScreen();
    }
    render() {
        return $bh6RR.createElement("div", {
            className: "FullScreen",
            ref: (node)=>this.node = node,
            style: {
                height: '100%',
                width: '100%'
            }
        }, this.props.children);
    }
}
$9ee85db91d407c9f$exports.default = $9ee85db91d407c9f$var$FullScreen;
$9ee85db91d407c9f$var$FullScreen.defaultProps = {
    enabled: false
};






var $bh6RR = parcelRequire("bh6RR");





parcelRequire("bh6RR");
const $f9ab4a733f3d6263$var$isLetter = (char)=>/[a-z]/i.test(char);
const $f9ab4a733f3d6263$var$isUpperCase = (char)=>char.toUpperCase() === char && $f9ab4a733f3d6263$var$isLetter(char);
const $f9ab4a733f3d6263$var$isLowerCase = (char)=>char.toLowerCase() === char && $f9ab4a733f3d6263$var$isLetter(char);
const $f9ab4a733f3d6263$var$wordHasUpperCase = (word)=>word.split('').some((char)=>$f9ab4a733f3d6263$var$isUpperCase(char));
const $f9ab4a733f3d6263$var$renderWordPart = (wordPart, key, className)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
        className: className,
        children: wordPart
    }, key);
const $f9ab4a733f3d6263$var$isSameCase = (a, b)=>$f9ab4a733f3d6263$var$isUpperCase(a) && $f9ab4a733f3d6263$var$isUpperCase(b) || $f9ab4a733f3d6263$var$isLowerCase(a) && $f9ab4a733f3d6263$var$isLowerCase(b) || !$f9ab4a733f3d6263$var$isLetter(a) || !$f9ab4a733f3d6263$var$isLetter(b);
const $f9ab4a733f3d6263$var$renderLogoWord = (word, index, array)=>{
    const arrayLength = array.length;
    const { length: length } = word;
    const isFirstWord = 0 === index;
    const isLastWord = index === arrayLength - 1;
    const isWordLengthGreaterThan3 = length > 3;
    const hasUpperCase = $f9ab4a733f3d6263$var$wordHasUpperCase(word);
    const isSingleChar = 1 === length;
    if (!(isWordLengthGreaterThan3 || hasUpperCase || isFirstWord || isLastWord)) return $f9ab4a733f3d6263$var$renderWordPart(word, `sw${index}`, 'small-text');
    if (!hasUpperCase) return $f9ab4a733f3d6263$var$renderWordPart(word, `rw${index}`, 'rest-of-word');
    if (hasUpperCase && isSingleChar) return $f9ab4a733f3d6263$var$renderWordPart(word, `cw${index}`, 'capitalize');
    const UPPERCASE = 1;
    const LOWERCASE = 2;
    const firstCharIsUpperCase = $f9ab4a733f3d6263$var$isUpperCase(word[0]);
    let findingType = firstCharIsUpperCase ? UPPERCASE : LOWERCASE;
    let lastBreakCharAt = 0;
    let wordParts = [];
    const lastChar = word[length - 1];
    const isLastCharsSameCase = $f9ab4a733f3d6263$var$isSameCase(word[isSingleChar ? 0 : length - 2], lastChar);
    for(let i = 1; i < length; i += 1){
        const char = word[i];
        const isLastChar = i === length - 1;
        const isFindingUpper = findingType === UPPERCASE;
        const isFindingLower = findingType === LOWERCASE;
        const matchUpper = findingType === UPPERCASE && $f9ab4a733f3d6263$var$isUpperCase(char);
        const matchLower = findingType === LOWERCASE && $f9ab4a733f3d6263$var$isLowerCase(char);
        if ((matchUpper || matchLower) && !isLastChar) continue;
        const breakAt = isLastChar && isLastCharsSameCase ? i + 1 : i;
        const wordPart = word.slice(lastBreakCharAt, breakAt);
        let wordRendered = null;
        if (isFindingUpper) {
            wordRendered = $f9ab4a733f3d6263$var$renderWordPart(wordPart, `wpc${index}-${i}`, 'capitalize');
            findingType = LOWERCASE;
        }
        if (isFindingLower) {
            wordRendered = $f9ab4a733f3d6263$var$renderWordPart(wordPart, `wpr${index}-${i}`, 'rest-of-word');
            findingType = UPPERCASE;
        }
        lastBreakCharAt = i;
        wordParts = wordParts.concat(wordRendered);
    }
    if (!isLastCharsSameCase) {
        let wordRendered = null;
        if ($f9ab4a733f3d6263$var$isUpperCase(lastChar)) {
            wordRendered = $f9ab4a733f3d6263$var$renderWordPart(lastChar, `wpc${index}l`, 'capitalize');
            findingType = LOWERCASE;
        }
        if ($f9ab4a733f3d6263$var$isLowerCase(lastChar)) {
            wordRendered = $f9ab4a733f3d6263$var$renderWordPart(lastChar, `wpr${index}l`, 'rest-of-word');
            findingType = UPPERCASE;
        }
        wordParts = wordParts.concat(wordRendered);
    }
    return wordParts;
};
const $f9ab4a733f3d6263$export$d13a1218bd1d6c6f = (text = '')=>{
    let textParts = [];
    const words = text.split(' ');
    for(let i = 0; i < words.length; i += 1){
        const wordRendered = $f9ab4a733f3d6263$var$renderLogoWord(words[i], i, words);
        textParts = textParts.concat(wordRendered);
        const isNotLastWord = i !== words.length - 1;
        if (isNotLastWord) textParts = textParts.concat($f9ab4a733f3d6263$var$renderWordPart(' ', `s${i}`));
    }
    const minFontSize = 1.7;
    const fontSizeByLength = 2.5 - 0.08 * (text.length - 15);
    const fontSizeMinOrCalculated = fontSizeByLength > minFontSize ? fontSizeByLength : minFontSize;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "rendered-logo",
        style: {
            fontSize: `${fontSizeMinOrCalculated}em`
        },
        children: textParts
    });
};
const $f9ab4a733f3d6263$var$renderAnimationText = (text, index)=>{
    if (26 !== index) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: text
    });
    return $f9ab4a733f3d6263$export$d13a1218bd1d6c6f(text);
};
var $f9ab4a733f3d6263$export$2e2bcd8739ae039 = $f9ab4a733f3d6263$var$renderAnimationText;


class $e85104d277b77d32$var$VideoOverlay extends (0, $bh6RR.Component) {
    static propTypes = {
        configurations: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        opening: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        playing: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
        playStart: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool
    };
    _renderTexts() {
        const { configurations: configurations, opening: opening } = this.props;
        const textsDiv = [];
        for(let i = 0; i < (0, $b62a9abcf18d7d2c$exports.DefaultOpening).length; i += 1){
            const key = `text${i}`;
            const renderedText = (0, $f9ab4a733f3d6263$export$2e2bcd8739ae039)(opening.texts[key], i);
            textsDiv.push(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                id: key,
                style: configurations.texts[i],
                children: renderedText
            }, key));
        }
        return textsDiv;
    }
    render() {
        const { configurations: configurations, playing: playing, playStart: playStart } = this.props;
        const animate = playStart ? 'animate' : '';
        const pauseAnimation = playing ? '' : 'pause-animation';
        const classnames = `video-overlay ${animate} ${pauseAnimation}`;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: classnames,
            style: configurations.overlay,
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "video-overlay__content",
                style: configurations.overlay_content,
                children: this._renderTexts()
            })
        });
    }
}
const $e85104d277b77d32$var$mapContextToProps = (context)=>({
        opening: context.opening
    });
var $e85104d277b77d32$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($17bc0d4f42435b88$exports)))((0, $87127865826734e4$export$2e2bcd8739ae039), $e85104d277b77d32$var$mapContextToProps)($e85104d277b77d32$var$VideoOverlay);





parcelRequire("bh6RR");

var $49faf1c91b9d52e7$exports = {};
$49faf1c91b9d52e7$exports = $parcel$resolve("dwZxY");


const $717f6f9cd6378efa$var$LoadingLayer = ({ isLoading: isLoading })=>{
    if (!isLoading) return null;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "loading-layer",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "logo",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($49faf1c91b9d52e7$exports))),
                    alt: "Game of Thrones Intro Creator logo",
                    width: "500",
                    height: "221"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "circle"
            })
        ]
    });
};
$717f6f9cd6378efa$var$LoadingLayer.propTypes = {
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool
};
var $717f6f9cd6378efa$export$2e2bcd8739ae039 = $717f6f9cd6378efa$var$LoadingLayer;



var $bh6RR = parcelRequire("bh6RR");
const $2ef9ff2da13ee5ca$var$AnimationConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext();
var $2ef9ff2da13ee5ca$export$2e2bcd8739ae039 = $2ef9ff2da13ee5ca$var$AnimationConfigContext;



parcelRequire("bh6RR");

const $b020b184d701f9e3$var$PlayVideoButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "play-video-button",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
            className: "button big",
            onClick: onClick,
            children: "Play"
        })
    });
$b020b184d701f9e3$var$PlayVideoButton.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func
};
var $b020b184d701f9e3$export$2e2bcd8739ae039 = $b020b184d701f9e3$var$PlayVideoButton;



parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");


class $e232dbecdbe60ad5$var$FakeVideo extends (0, $bh6RR.Component) {
    static propTypes = {
        onPlay: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        onReady: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        onEnd: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func
    };
    componentDidMount() {
        this._setupFakePlayer();
    }
    shouldComponentUpdate() {
        return false;
    }
    _playCallback = ()=>{
        this.props.onPlay();
        if (window.introStartCallback) window.introStartCallback();
    };
    _endCallback = ()=>{
        this.props.onEnd();
        if (window.introEndedCallback) window.introEndedCallback();
    };
    _setupFakePlayer() {
        window.playApp = ()=>{
            this._playCallback();
            setTimeout(()=>{
                this._endCallback();
            }, ((0, $d39cc430308b5205$export$b53eb602ff8a7d04) - (0, $d39cc430308b5205$export$87d6643ee8fe08fb)) * (0, $d39cc430308b5205$export$888108240e4c7c6d) * 1000);
        };
        this.props.onReady();
    }
    play() {
    // just to not call undefined function.
    }
    render() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "fake-video"
        });
    }
}
var $e232dbecdbe60ad5$export$2e2bcd8739ae039 = $e232dbecdbe60ad5$var$FakeVideo;


/* eslint-disable no-console */ 

var $bh6RR = parcelRequire("bh6RR");

var $c60576c11a83bb1a$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $c60576c11a83bb1a$exports = factory();
})(window, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "dist/";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./src/main.js");
    /******/ }({
        /***/ "./node_modules/babel-runtime/core-js/array/from.js": /*!**********************************************************!*\
  !*** ./node_modules/babel-runtime/core-js/array/from.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = {
                "default": __webpack_require__(/*! core-js/library/fn/array/from */ "./node_modules/core-js/library/fn/array/from.js"),
                __esModule: true
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/core-js/get-iterator.js": /*!************************************************************!*\
  !*** ./node_modules/babel-runtime/core-js/get-iterator.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = {
                "default": __webpack_require__(/*! core-js/library/fn/get-iterator */ "./node_modules/core-js/library/fn/get-iterator.js"),
                __esModule: true
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/core-js/json/stringify.js": /*!**************************************************************!*\
  !*** ./node_modules/babel-runtime/core-js/json/stringify.js ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = {
                "default": __webpack_require__(/*! core-js/library/fn/json/stringify */ "./node_modules/core-js/library/fn/json/stringify.js"),
                __esModule: true
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/core-js/object/assign.js": /*!*************************************************************!*\
  !*** ./node_modules/babel-runtime/core-js/object/assign.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = {
                "default": __webpack_require__(/*! core-js/library/fn/object/assign */ "./node_modules/core-js/library/fn/object/assign.js"),
                __esModule: true
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/core-js/object/create.js": /*!*************************************************************!*\
  !*** ./node_modules/babel-runtime/core-js/object/create.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = {
                "default": __webpack_require__(/*! core-js/library/fn/object/create */ "./node_modules/core-js/library/fn/object/create.js"),
                __esModule: true
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/core-js/object/define-property.js": /*!**********************************************************************!*\
  !*** ./node_modules/babel-runtime/core-js/object/define-property.js ***!
  \**********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = {
                "default": __webpack_require__(/*! core-js/library/fn/object/define-property */ "./node_modules/core-js/library/fn/object/define-property.js"),
                __esModule: true
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js": /*!**********************************************************************************!*\
  !*** ./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js ***!
  \**********************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = {
                "default": __webpack_require__(/*! core-js/library/fn/object/get-own-property-descriptor */ "./node_modules/core-js/library/fn/object/get-own-property-descriptor.js"),
                __esModule: true
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/core-js/object/keys.js": /*!***********************************************************!*\
  !*** ./node_modules/babel-runtime/core-js/object/keys.js ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = {
                "default": __webpack_require__(/*! core-js/library/fn/object/keys */ "./node_modules/core-js/library/fn/object/keys.js"),
                __esModule: true
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/core-js/object/set-prototype-of.js": /*!***********************************************************************!*\
  !*** ./node_modules/babel-runtime/core-js/object/set-prototype-of.js ***!
  \***********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = {
                "default": __webpack_require__(/*! core-js/library/fn/object/set-prototype-of */ "./node_modules/core-js/library/fn/object/set-prototype-of.js"),
                __esModule: true
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/core-js/symbol.js": /*!******************************************************!*\
  !*** ./node_modules/babel-runtime/core-js/symbol.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = {
                "default": __webpack_require__(/*! core-js/library/fn/symbol */ "./node_modules/core-js/library/fn/symbol/index.js"),
                __esModule: true
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/core-js/symbol/iterator.js": /*!***************************************************************!*\
  !*** ./node_modules/babel-runtime/core-js/symbol/iterator.js ***!
  \***************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = {
                "default": __webpack_require__(/*! core-js/library/fn/symbol/iterator */ "./node_modules/core-js/library/fn/symbol/iterator.js"),
                __esModule: true
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/helpers/classCallCheck.js": /*!**************************************************************!*\
  !*** ./node_modules/babel-runtime/helpers/classCallCheck.js ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.__esModule = true;
            exports.default = function(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/helpers/createClass.js": /*!***********************************************************!*\
  !*** ./node_modules/babel-runtime/helpers/createClass.js ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.__esModule = true;
            var _defineProperty = __webpack_require__(/*! ../core-js/object/define-property */ "./node_modules/babel-runtime/core-js/object/define-property.js");
            var _defineProperty2 = _interopRequireDefault(_defineProperty);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
        /***/ },
        /***/ "./node_modules/babel-runtime/helpers/extends.js": /*!*******************************************************!*\
  !*** ./node_modules/babel-runtime/helpers/extends.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.__esModule = true;
            var _assign = __webpack_require__(/*! ../core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
            var _assign2 = _interopRequireDefault(_assign);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _assign2.default || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/helpers/inherits.js": /*!********************************************************!*\
  !*** ./node_modules/babel-runtime/helpers/inherits.js ***!
  \********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.__esModule = true;
            var _setPrototypeOf = __webpack_require__(/*! ../core-js/object/set-prototype-of */ "./node_modules/babel-runtime/core-js/object/set-prototype-of.js");
            var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
            var _create = __webpack_require__(/*! ../core-js/object/create */ "./node_modules/babel-runtime/core-js/object/create.js");
            var _create2 = _interopRequireDefault(_create);
            var _typeof2 = __webpack_require__(/*! ../helpers/typeof */ "./node_modules/babel-runtime/helpers/typeof.js");
            var _typeof3 = _interopRequireDefault(_typeof2);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = function(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
                subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js": /*!*************************************************************************!*\
  !*** ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js ***!
  \*************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.__esModule = true;
            var _typeof2 = __webpack_require__(/*! ../helpers/typeof */ "./node_modules/babel-runtime/helpers/typeof.js");
            var _typeof3 = _interopRequireDefault(_typeof2);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = function(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self1;
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/helpers/toConsumableArray.js": /*!*****************************************************************!*\
  !*** ./node_modules/babel-runtime/helpers/toConsumableArray.js ***!
  \*****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.__esModule = true;
            var _from = __webpack_require__(/*! ../core-js/array/from */ "./node_modules/babel-runtime/core-js/array/from.js");
            var _from2 = _interopRequireDefault(_from);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = function(arr) {
                if (Array.isArray(arr)) {
                    for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                    return arr2;
                } else return (0, _from2.default)(arr);
            };
        /***/ },
        /***/ "./node_modules/babel-runtime/helpers/typeof.js": /*!******************************************************!*\
  !*** ./node_modules/babel-runtime/helpers/typeof.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.__esModule = true;
            var _iterator = __webpack_require__(/*! ../core-js/symbol/iterator */ "./node_modules/babel-runtime/core-js/symbol/iterator.js");
            var _iterator2 = _interopRequireDefault(_iterator);
            var _symbol = __webpack_require__(/*! ../core-js/symbol */ "./node_modules/babel-runtime/core-js/symbol.js");
            var _symbol2 = _interopRequireDefault(_symbol);
            var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
            };
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function(obj) {
                return typeof obj === "undefined" ? "undefined" : _typeof(obj);
            } : function(obj) {
                return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
            };
        /***/ },
        /***/ "./node_modules/clappr-zepto/zepto.js": /*!********************************************!*\
  !*** ./node_modules/clappr-zepto/zepto.js ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            /* Zepto v1.2.0 - zepto ajax callbacks deferred event ie selector - zeptojs.com/license */ var Zepto = function() {
                var undefined1, key, $, classList, emptyArray = [], concat = emptyArray.concat, filter = emptyArray.filter, slice = emptyArray.slice, document1 = window.document, elementDisplay = {}, classCache = {}, cssNumber = {
                    'column-count': 1,
                    'columns': 1,
                    'font-weight': 1,
                    'line-height': 1,
                    'opacity': 1,
                    'z-index': 1,
                    'zoom': 1
                }, fragmentRE = /^\s*<(\w+|!)[^>]*>/, singleTagRE = /^<(\w+)\s*\/?>(?:<\/\1>|)$/, tagExpanderRE = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig, rootNodeRE = /^(?:body|html)$/i, capitalRE = /([A-Z])/g, // special attributes that should be get/set via method calls
                methodAttributes = [
                    'val',
                    'css',
                    'html',
                    'text',
                    'data',
                    'width',
                    'height',
                    'offset'
                ], adjacencyOperators = [
                    'after',
                    'prepend',
                    'before',
                    'append'
                ], table = document1.createElement('table'), tableRow = document1.createElement('tr'), containers = {
                    'tr': document1.createElement('tbody'),
                    'tbody': table,
                    'thead': table,
                    'tfoot': table,
                    'td': tableRow,
                    'th': tableRow,
                    '*': document1.createElement('div')
                }, readyRE = /complete|loaded|interactive/, simpleSelectorRE = /^[\w-]*$/, class2type = {}, toString = class2type.toString, zepto = {}, camelize, uniq, tempParent = document1.createElement('div'), propMap = {
                    'tabindex': 'tabIndex',
                    'readonly': 'readOnly',
                    'for': 'htmlFor',
                    'class': 'className',
                    'maxlength': 'maxLength',
                    'cellspacing': 'cellSpacing',
                    'cellpadding': 'cellPadding',
                    'rowspan': 'rowSpan',
                    'colspan': 'colSpan',
                    'usemap': 'useMap',
                    'frameborder': 'frameBorder',
                    'contenteditable': 'contentEditable'
                }, isArray = Array.isArray || function(object) {
                    return object instanceof Array;
                };
                zepto.matches = function(element, selector) {
                    if (!selector || !element || element.nodeType !== 1) return false;
                    var matchesSelector = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.matchesSelector;
                    if (matchesSelector) return matchesSelector.call(element, selector);
                    // fall back to performing a selector:
                    var match, parent = element.parentNode, temp = !parent;
                    if (temp) (parent = tempParent).appendChild(element);
                    match = ~zepto.qsa(parent, selector).indexOf(element);
                    temp && tempParent.removeChild(element);
                    return match;
                };
                function type(obj) {
                    return obj == null ? String(obj) : class2type[toString.call(obj)] || "object";
                }
                function isFunction(value) {
                    return type(value) == "function";
                }
                function isWindow(obj) {
                    return obj != null && obj == obj.window;
                }
                function isDocument(obj) {
                    return obj != null && obj.nodeType == obj.DOCUMENT_NODE;
                }
                function isObject(obj) {
                    return type(obj) == "object";
                }
                function isPlainObject(obj) {
                    return isObject(obj) && !isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype;
                }
                function likeArray(obj) {
                    var length = !!obj && 'length' in obj && obj.length, type = $.type(obj);
                    return 'function' != type && !isWindow(obj) && ('array' == type || length === 0 || typeof length == 'number' && length > 0 && length - 1 in obj);
                }
                function compact(array) {
                    return filter.call(array, function(item) {
                        return item != null;
                    });
                }
                function flatten(array) {
                    return array.length > 0 ? $.fn.concat.apply([], array) : array;
                }
                camelize = function(str) {
                    return str.replace(/-+(.)?/g, function(match, chr) {
                        return chr ? chr.toUpperCase() : '';
                    });
                };
                function dasherize(str) {
                    return str.replace(/::/g, '/').replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2').replace(/([a-z\d])([A-Z])/g, '$1_$2').replace(/_/g, '-').toLowerCase();
                }
                uniq = function(array) {
                    return filter.call(array, function(item, idx) {
                        return array.indexOf(item) == idx;
                    });
                };
                function classRE(name) {
                    return name in classCache ? classCache[name] : classCache[name] = new RegExp('(^|\\s)' + name + '(\\s|$)');
                }
                function maybeAddPx(name, value) {
                    return typeof value == "number" && !cssNumber[dasherize(name)] ? value + "px" : value;
                }
                function defaultDisplay(nodeName) {
                    var element, display;
                    if (!elementDisplay[nodeName]) {
                        element = document1.createElement(nodeName);
                        document1.body.appendChild(element);
                        display = getComputedStyle(element, '').getPropertyValue("display");
                        element.parentNode.removeChild(element);
                        display == "none" && (display = "block");
                        elementDisplay[nodeName] = display;
                    }
                    return elementDisplay[nodeName];
                }
                function children(element) {
                    return 'children' in element ? slice.call(element.children) : $.map(element.childNodes, function(node) {
                        if (node.nodeType == 1) return node;
                    });
                }
                function Z(dom, selector) {
                    var i, len = dom ? dom.length : 0;
                    for(i = 0; i < len; i++)this[i] = dom[i];
                    this.length = len;
                    this.selector = selector || '';
                }
                // `$.zepto.fragment` takes a html string and an optional tag name
                // to generate DOM nodes from the given html string.
                // The generated DOM nodes are returned as an array.
                // This function can be overridden in plugins for example to make
                // it compatible with browsers that don't support the DOM fully.
                zepto.fragment = function(html, name, properties) {
                    var dom, nodes, container;
                    // A special case optimization for a single tag
                    if (singleTagRE.test(html)) dom = $(document1.createElement(RegExp.$1));
                    if (!dom) {
                        if (html.replace) html = html.replace(tagExpanderRE, "<$1></$2>");
                        if (name === undefined1) name = fragmentRE.test(html) && RegExp.$1;
                        if (!(name in containers)) name = '*';
                        container = containers[name];
                        container.innerHTML = '' + html;
                        dom = $.each(slice.call(container.childNodes), function() {
                            container.removeChild(this);
                        });
                    }
                    if (isPlainObject(properties)) {
                        nodes = $(dom);
                        $.each(properties, function(key, value) {
                            if (methodAttributes.indexOf(key) > -1) nodes[key](value);
                            else nodes.attr(key, value);
                        });
                    }
                    return dom;
                };
                // `$.zepto.Z` swaps out the prototype of the given `dom` array
                // of nodes with `$.fn` and thus supplying all the Zepto functions
                // to the array. This method can be overridden in plugins.
                zepto.Z = function(dom, selector) {
                    return new Z(dom, selector);
                };
                // `$.zepto.isZ` should return `true` if the given object is a Zepto
                // collection. This method can be overridden in plugins.
                zepto.isZ = function(object) {
                    return object instanceof zepto.Z;
                };
                // `$.zepto.init` is Zepto's counterpart to jQuery's `$.fn.init` and
                // takes a CSS selector and an optional context (and handles various
                // special cases).
                // This method can be overridden in plugins.
                zepto.init = function(selector, context) {
                    var dom;
                    // If nothing given, return an empty Zepto collection
                    if (!selector) return zepto.Z();
                    else if (typeof selector == 'string') {
                        selector = selector.trim();
                        // If it's a html fragment, create nodes from it
                        // Note: In both Chrome 21 and Firefox 15, DOM error 12
                        // is thrown if the fragment doesn't begin with <
                        if (selector[0] == '<' && fragmentRE.test(selector)) dom = zepto.fragment(selector, RegExp.$1, context), selector = null;
                        else if (context !== undefined1) return $(context).find(selector);
                        else dom = zepto.qsa(document1, selector);
                    } else if (isFunction(selector)) return $(document1).ready(selector);
                    else if (zepto.isZ(selector)) return selector;
                    else {
                        // normalize array if an array of nodes is given
                        if (isArray(selector)) dom = compact(selector);
                        else if (isObject(selector)) dom = [
                            selector
                        ], selector = null;
                        else if (fragmentRE.test(selector)) dom = zepto.fragment(selector.trim(), RegExp.$1, context), selector = null;
                        else if (context !== undefined1) return $(context).find(selector);
                        else dom = zepto.qsa(document1, selector);
                    }
                    // create a new Zepto collection from the nodes found
                    return zepto.Z(dom, selector);
                };
                // `$` will be the base `Zepto` object. When calling this
                // function just call `$.zepto.init, which makes the implementation
                // details of selecting nodes and creating Zepto collections
                // patchable in plugins.
                $ = function(selector, context) {
                    return zepto.init(selector, context);
                };
                function extend(target, source, deep) {
                    for(key in source)if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
                        if (isPlainObject(source[key]) && !isPlainObject(target[key])) target[key] = {};
                        if (isArray(source[key]) && !isArray(target[key])) target[key] = [];
                        extend(target[key], source[key], deep);
                    } else if (source[key] !== undefined1) target[key] = source[key];
                }
                // Copy all but undefined properties from one or more
                // objects to the `target` object.
                $.extend = function(target) {
                    var deep, args = slice.call(arguments, 1);
                    if (typeof target == 'boolean') {
                        deep = target;
                        target = args.shift();
                    }
                    args.forEach(function(arg) {
                        extend(target, arg, deep);
                    });
                    return target;
                };
                // `$.zepto.qsa` is Zepto's CSS selector implementation which
                // uses `document.querySelectorAll` and optimizes for some special cases, like `#id`.
                // This method can be overridden in plugins.
                zepto.qsa = function(element, selector) {
                    var found, maybeID = selector[0] == '#', maybeClass = !maybeID && selector[0] == '.', nameOnly = maybeID || maybeClass ? selector.slice(1) : selector, isSimple = simpleSelectorRE.test(nameOnly);
                    return element.getElementById && isSimple && maybeID ? (found = element.getElementById(nameOnly)) ? [
                        found
                    ] : [] : element.nodeType !== 1 && element.nodeType !== 9 && element.nodeType !== 11 ? [] : slice.call(isSimple && !maybeID && element.getElementsByClassName ? maybeClass ? element.getElementsByClassName(nameOnly) : element.getElementsByTagName(selector) : element.querySelectorAll(selector) // Or it's not simple, and we need to query all
                    );
                };
                function filtered(nodes, selector) {
                    return selector == null ? $(nodes) : $(nodes).filter(selector);
                }
                $.contains = document1.documentElement.contains ? function(parent, node) {
                    return parent !== node && parent.contains(node);
                } : function(parent, node) {
                    while(node && (node = node.parentNode))if (node === parent) return true;
                    return false;
                };
                function funcArg(context, arg, idx, payload) {
                    return isFunction(arg) ? arg.call(context, idx, payload) : arg;
                }
                function setAttribute(node, name, value) {
                    value == null ? node.removeAttribute(name) : node.setAttribute(name, value);
                }
                // access className property while respecting SVGAnimatedString
                function className(node, value) {
                    var klass = node.className || '', svg = klass && klass.baseVal !== undefined1;
                    if (value === undefined1) return svg ? klass.baseVal : klass;
                    svg ? klass.baseVal = value : node.className = value;
                }
                // "true"  => true
                // "false" => false
                // "null"  => null
                // "42"    => 42
                // "42.5"  => 42.5
                // "08"    => "08"
                // JSON    => parse if valid
                // String  => self
                function deserializeValue(value) {
                    try {
                        return value ? value == "true" || (value == "false" ? false : value == "null" ? null : +value + "" == value ? +value : /^[\[\{]/.test(value) ? $.parseJSON(value) : value) : value;
                    } catch (e) {
                        return value;
                    }
                }
                $.type = type;
                $.isFunction = isFunction;
                $.isWindow = isWindow;
                $.isArray = isArray;
                $.isPlainObject = isPlainObject;
                $.isEmptyObject = function(obj) {
                    var name;
                    for(name in obj)return false;
                    return true;
                };
                $.isNumeric = function(val) {
                    var num = Number(val), type = typeof val;
                    return val != null && type != 'boolean' && (type != 'string' || val.length) && !isNaN(num) && isFinite(num) || false;
                };
                $.inArray = function(elem, array, i) {
                    return emptyArray.indexOf.call(array, elem, i);
                };
                $.camelCase = camelize;
                $.trim = function(str) {
                    return str == null ? "" : String.prototype.trim.call(str);
                };
                // plugin compatibility
                $.uuid = 0;
                $.support = {};
                $.expr = {};
                $.noop = function() {};
                $.map = function(elements, callback) {
                    var value, values = [], i, key;
                    if (likeArray(elements)) for(i = 0; i < elements.length; i++){
                        value = callback(elements[i], i);
                        if (value != null) values.push(value);
                    }
                    else for(key in elements){
                        value = callback(elements[key], key);
                        if (value != null) values.push(value);
                    }
                    return flatten(values);
                };
                $.each = function(elements, callback) {
                    var i, key;
                    if (likeArray(elements)) {
                        for(i = 0; i < elements.length; i++)if (callback.call(elements[i], i, elements[i]) === false) return elements;
                    } else {
                        for(key in elements)if (callback.call(elements[key], key, elements[key]) === false) return elements;
                    }
                    return elements;
                };
                $.grep = function(elements, callback) {
                    return filter.call(elements, callback);
                };
                if (window.JSON) $.parseJSON = JSON.parse;
                // Populate the class2type map
                $.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
                    class2type["[object " + name + "]"] = name.toLowerCase();
                });
                // Define methods that will be available on all
                // Zepto collections
                $.fn = {
                    constructor: zepto.Z,
                    length: 0,
                    // Because a collection acts like an array
                    // copy over these useful array functions.
                    forEach: emptyArray.forEach,
                    reduce: emptyArray.reduce,
                    push: emptyArray.push,
                    sort: emptyArray.sort,
                    splice: emptyArray.splice,
                    indexOf: emptyArray.indexOf,
                    concat: function() {
                        var i, value, args = [];
                        for(i = 0; i < arguments.length; i++){
                            value = arguments[i];
                            args[i] = zepto.isZ(value) ? value.toArray() : value;
                        }
                        return concat.apply(zepto.isZ(this) ? this.toArray() : this, args);
                    },
                    // `map` and `slice` in the jQuery API work differently
                    // from their array counterparts
                    map: function(fn) {
                        return $($.map(this, function(el, i) {
                            return fn.call(el, i, el);
                        }));
                    },
                    slice: function() {
                        return $(slice.apply(this, arguments));
                    },
                    ready: function(callback) {
                        // need to check if document.body exists for IE as that browser reports
                        // document ready when it hasn't yet created the body element
                        if (readyRE.test(document1.readyState) && document1.body) callback($);
                        else document1.addEventListener('DOMContentLoaded', function() {
                            callback($);
                        }, false);
                        return this;
                    },
                    get: function(idx) {
                        return idx === undefined1 ? slice.call(this) : this[idx >= 0 ? idx : idx + this.length];
                    },
                    toArray: function() {
                        return this.get();
                    },
                    size: function() {
                        return this.length;
                    },
                    remove: function() {
                        return this.each(function() {
                            if (this.parentNode != null) this.parentNode.removeChild(this);
                        });
                    },
                    each: function(callback) {
                        emptyArray.every.call(this, function(el, idx) {
                            return callback.call(el, idx, el) !== false;
                        });
                        return this;
                    },
                    filter: function(selector) {
                        if (isFunction(selector)) return this.not(this.not(selector));
                        return $(filter.call(this, function(element) {
                            return zepto.matches(element, selector);
                        }));
                    },
                    add: function(selector, context) {
                        return $(uniq(this.concat($(selector, context))));
                    },
                    is: function(selector) {
                        return this.length > 0 && zepto.matches(this[0], selector);
                    },
                    not: function(selector) {
                        var nodes = [];
                        if (isFunction(selector) && selector.call !== undefined1) this.each(function(idx) {
                            if (!selector.call(this, idx)) nodes.push(this);
                        });
                        else {
                            var excludes = typeof selector == 'string' ? this.filter(selector) : likeArray(selector) && isFunction(selector.item) ? slice.call(selector) : $(selector);
                            this.forEach(function(el) {
                                if (excludes.indexOf(el) < 0) nodes.push(el);
                            });
                        }
                        return $(nodes);
                    },
                    has: function(selector) {
                        return this.filter(function() {
                            return isObject(selector) ? $.contains(this, selector) : $(this).find(selector).size();
                        });
                    },
                    eq: function(idx) {
                        return idx === -1 ? this.slice(idx) : this.slice(idx, +idx + 1);
                    },
                    first: function() {
                        var el = this[0];
                        return el && !isObject(el) ? el : $(el);
                    },
                    last: function() {
                        var el = this[this.length - 1];
                        return el && !isObject(el) ? el : $(el);
                    },
                    find: function(selector) {
                        var result, $this = this;
                        if (!selector) result = $();
                        else if (typeof selector == 'object') result = $(selector).filter(function() {
                            var node = this;
                            return emptyArray.some.call($this, function(parent) {
                                return $.contains(parent, node);
                            });
                        });
                        else if (this.length == 1) result = $(zepto.qsa(this[0], selector));
                        else result = this.map(function() {
                            return zepto.qsa(this, selector);
                        });
                        return result;
                    },
                    closest: function(selector, context) {
                        var nodes = [], collection = typeof selector == 'object' && $(selector);
                        this.each(function(_, node) {
                            while(node && !(collection ? collection.indexOf(node) >= 0 : zepto.matches(node, selector)))node = node !== context && !isDocument(node) && node.parentNode;
                            if (node && nodes.indexOf(node) < 0) nodes.push(node);
                        });
                        return $(nodes);
                    },
                    parents: function(selector) {
                        var ancestors = [], nodes = this;
                        while(nodes.length > 0)nodes = $.map(nodes, function(node) {
                            if ((node = node.parentNode) && !isDocument(node) && ancestors.indexOf(node) < 0) {
                                ancestors.push(node);
                                return node;
                            }
                        });
                        return filtered(ancestors, selector);
                    },
                    parent: function(selector) {
                        return filtered(uniq(this.pluck('parentNode')), selector);
                    },
                    children: function(selector) {
                        return filtered(this.map(function() {
                            return children(this);
                        }), selector);
                    },
                    contents: function() {
                        return this.map(function() {
                            return this.contentDocument || slice.call(this.childNodes);
                        });
                    },
                    siblings: function(selector) {
                        return filtered(this.map(function(i, el) {
                            return filter.call(children(el.parentNode), function(child) {
                                return child !== el;
                            });
                        }), selector);
                    },
                    empty: function() {
                        return this.each(function() {
                            this.innerHTML = '';
                        });
                    },
                    // `pluck` is borrowed from Prototype.js
                    pluck: function(property) {
                        return $.map(this, function(el) {
                            return el[property];
                        });
                    },
                    show: function() {
                        return this.each(function() {
                            this.style.display == "none" && (this.style.display = '');
                            if (getComputedStyle(this, '').getPropertyValue("display") == "none") this.style.display = defaultDisplay(this.nodeName);
                        });
                    },
                    replaceWith: function(newContent) {
                        return this.before(newContent).remove();
                    },
                    wrap: function(structure) {
                        var func = isFunction(structure);
                        if (this[0] && !func) var dom = $(structure).get(0), clone = dom.parentNode || this.length > 1;
                        return this.each(function(index) {
                            $(this).wrapAll(func ? structure.call(this, index) : clone ? dom.cloneNode(true) : dom);
                        });
                    },
                    wrapAll: function(structure) {
                        if (this[0]) {
                            $(this[0]).before(structure = $(structure));
                            var children;
                            // drill down to the inmost element
                            while((children = structure.children()).length)structure = children.first();
                            $(structure).append(this);
                        }
                        return this;
                    },
                    wrapInner: function(structure) {
                        var func = isFunction(structure);
                        return this.each(function(index) {
                            var self1 = $(this), contents = self1.contents(), dom = func ? structure.call(this, index) : structure;
                            contents.length ? contents.wrapAll(dom) : self1.append(dom);
                        });
                    },
                    unwrap: function() {
                        this.parent().each(function() {
                            $(this).replaceWith($(this).children());
                        });
                        return this;
                    },
                    clone: function() {
                        return this.map(function() {
                            return this.cloneNode(true);
                        });
                    },
                    hide: function() {
                        return this.css("display", "none");
                    },
                    toggle: function(setting) {
                        return this.each(function() {
                            var el = $(this);
                            (setting === undefined1 ? el.css("display") == "none" : setting) ? el.show() : el.hide();
                        });
                    },
                    prev: function(selector) {
                        return $(this.pluck('previousElementSibling')).filter(selector || '*');
                    },
                    next: function(selector) {
                        return $(this.pluck('nextElementSibling')).filter(selector || '*');
                    },
                    html: function(html) {
                        return 0 in arguments ? this.each(function(idx) {
                            var originHtml = this.innerHTML;
                            $(this).empty().append(funcArg(this, html, idx, originHtml));
                        }) : 0 in this ? this[0].innerHTML : null;
                    },
                    text: function(text) {
                        return 0 in arguments ? this.each(function(idx) {
                            var newText = funcArg(this, text, idx, this.textContent);
                            this.textContent = newText == null ? '' : '' + newText;
                        }) : 0 in this ? this.pluck('textContent').join("") : null;
                    },
                    attr: function(name, value) {
                        var result;
                        return typeof name == 'string' && !(1 in arguments) ? 0 in this && this[0].nodeType == 1 && (result = this[0].getAttribute(name)) != null ? result : undefined1 : this.each(function(idx) {
                            if (this.nodeType !== 1) return;
                            if (isObject(name)) for(key in name)setAttribute(this, key, name[key]);
                            else setAttribute(this, name, funcArg(this, value, idx, this.getAttribute(name)));
                        });
                    },
                    removeAttr: function(name) {
                        return this.each(function() {
                            this.nodeType === 1 && name.split(' ').forEach(function(attribute) {
                                setAttribute(this, attribute);
                            }, this);
                        });
                    },
                    prop: function(name, value) {
                        name = propMap[name] || name;
                        return 1 in arguments ? this.each(function(idx) {
                            this[name] = funcArg(this, value, idx, this[name]);
                        }) : this[0] && this[0][name];
                    },
                    removeProp: function(name) {
                        name = propMap[name] || name;
                        return this.each(function() {
                            delete this[name];
                        });
                    },
                    data: function(name, value) {
                        var attrName = 'data-' + name.replace(capitalRE, '-$1').toLowerCase();
                        var data = 1 in arguments ? this.attr(attrName, value) : this.attr(attrName);
                        return data !== null ? deserializeValue(data) : undefined1;
                    },
                    val: function(value) {
                        if (0 in arguments) {
                            if (value == null) value = "";
                            return this.each(function(idx) {
                                this.value = funcArg(this, value, idx, this.value);
                            });
                        } else return this[0] && (this[0].multiple ? $(this[0]).find('option').filter(function() {
                            return this.selected;
                        }).pluck('value') : this[0].value);
                    },
                    offset: function(coordinates) {
                        if (coordinates) return this.each(function(index) {
                            var $this = $(this), coords = funcArg(this, coordinates, index, $this.offset()), parentOffset = $this.offsetParent().offset(), props = {
                                top: coords.top - parentOffset.top,
                                left: coords.left - parentOffset.left
                            };
                            if ($this.css('position') == 'static') props['position'] = 'relative';
                            $this.css(props);
                        });
                        if (!this.length) return null;
                        if (document1.documentElement !== this[0] && !$.contains(document1.documentElement, this[0])) return {
                            top: 0,
                            left: 0
                        };
                        var obj = this[0].getBoundingClientRect();
                        return {
                            left: obj.left + window.pageXOffset,
                            top: obj.top + window.pageYOffset,
                            width: Math.round(obj.width),
                            height: Math.round(obj.height)
                        };
                    },
                    css: function(property, value) {
                        if (arguments.length < 2) {
                            var element = this[0];
                            if (typeof property == 'string') {
                                if (!element) return;
                                return element.style[camelize(property)] || getComputedStyle(element, '').getPropertyValue(property);
                            } else if (isArray(property)) {
                                if (!element) return;
                                var props = {};
                                var computedStyle = getComputedStyle(element, '');
                                $.each(property, function(_, prop) {
                                    props[prop] = element.style[camelize(prop)] || computedStyle.getPropertyValue(prop);
                                });
                                return props;
                            }
                        }
                        var css = '';
                        if (type(property) == 'string') {
                            if (!value && value !== 0) this.each(function() {
                                this.style.removeProperty(dasherize(property));
                            });
                            else css = dasherize(property) + ":" + maybeAddPx(property, value);
                        } else {
                            for(key in property)if (!property[key] && property[key] !== 0) this.each(function() {
                                this.style.removeProperty(dasherize(key));
                            });
                            else css += dasherize(key) + ':' + maybeAddPx(key, property[key]) + ';';
                        }
                        return this.each(function() {
                            this.style.cssText += ';' + css;
                        });
                    },
                    index: function(element) {
                        return element ? this.indexOf($(element)[0]) : this.parent().children().indexOf(this[0]);
                    },
                    hasClass: function(name) {
                        if (!name) return false;
                        return emptyArray.some.call(this, function(el) {
                            return this.test(className(el));
                        }, classRE(name));
                    },
                    addClass: function(name) {
                        if (!name) return this;
                        return this.each(function(idx) {
                            if (!('className' in this)) return;
                            classList = [];
                            var cls = className(this), newName = funcArg(this, name, idx, cls);
                            newName.split(/\s+/g).forEach(function(klass) {
                                if (!$(this).hasClass(klass)) classList.push(klass);
                            }, this);
                            classList.length && className(this, cls + (cls ? " " : "") + classList.join(" "));
                        });
                    },
                    removeClass: function(name) {
                        return this.each(function(idx) {
                            if (!('className' in this)) return;
                            if (name === undefined1) return className(this, '');
                            classList = className(this);
                            funcArg(this, name, idx, classList).split(/\s+/g).forEach(function(klass) {
                                classList = classList.replace(classRE(klass), " ");
                            });
                            className(this, classList.trim());
                        });
                    },
                    toggleClass: function(name, when) {
                        if (!name) return this;
                        return this.each(function(idx) {
                            var $this = $(this), names = funcArg(this, name, idx, className(this));
                            names.split(/\s+/g).forEach(function(klass) {
                                (when === undefined1 ? !$this.hasClass(klass) : when) ? $this.addClass(klass) : $this.removeClass(klass);
                            });
                        });
                    },
                    scrollTop: function(value) {
                        if (!this.length) return;
                        var hasScrollTop = 'scrollTop' in this[0];
                        if (value === undefined1) return hasScrollTop ? this[0].scrollTop : this[0].pageYOffset;
                        return this.each(hasScrollTop ? function() {
                            this.scrollTop = value;
                        } : function() {
                            this.scrollTo(this.scrollX, value);
                        });
                    },
                    scrollLeft: function(value) {
                        if (!this.length) return;
                        var hasScrollLeft = 'scrollLeft' in this[0];
                        if (value === undefined1) return hasScrollLeft ? this[0].scrollLeft : this[0].pageXOffset;
                        return this.each(hasScrollLeft ? function() {
                            this.scrollLeft = value;
                        } : function() {
                            this.scrollTo(value, this.scrollY);
                        });
                    },
                    position: function() {
                        if (!this.length) return;
                        var elem = this[0], // Get *real* offsetParent
                        offsetParent = this.offsetParent(), // Get correct offsets
                        offset = this.offset(), parentOffset = rootNodeRE.test(offsetParent[0].nodeName) ? {
                            top: 0,
                            left: 0
                        } : offsetParent.offset();
                        // Subtract element margins
                        // note: when an element has margin: auto the offsetLeft and marginLeft
                        // are the same in Safari causing offset.left to incorrectly be 0
                        offset.top -= parseFloat($(elem).css('margin-top')) || 0;
                        offset.left -= parseFloat($(elem).css('margin-left')) || 0;
                        // Add offsetParent borders
                        parentOffset.top += parseFloat($(offsetParent[0]).css('border-top-width')) || 0;
                        parentOffset.left += parseFloat($(offsetParent[0]).css('border-left-width')) || 0;
                        // Subtract the two offsets
                        return {
                            top: offset.top - parentOffset.top,
                            left: offset.left - parentOffset.left
                        };
                    },
                    offsetParent: function() {
                        return this.map(function() {
                            var parent = this.offsetParent || document1.body;
                            while(parent && !rootNodeRE.test(parent.nodeName) && $(parent).css("position") == "static")parent = parent.offsetParent;
                            return parent;
                        });
                    }
                };
                // for now
                $.fn.detach = $.fn.remove;
                [
                    'width',
                    'height'
                ].forEach(function(dimension) {
                    var dimensionProperty = dimension.replace(/./, function(m) {
                        return m[0].toUpperCase();
                    });
                    $.fn[dimension] = function(value) {
                        var offset, el = this[0];
                        if (value === undefined1) return isWindow(el) ? el['inner' + dimensionProperty] : isDocument(el) ? el.documentElement['scroll' + dimensionProperty] : (offset = this.offset()) && offset[dimension];
                        else return this.each(function(idx) {
                            el = $(this);
                            el.css(dimension, funcArg(this, value, idx, el[dimension]()));
                        });
                    };
                });
                function traverseNode(node, fun) {
                    fun(node);
                    for(var i = 0, len = node.childNodes.length; i < len; i++)traverseNode(node.childNodes[i], fun);
                }
                // Generate the `after`, `prepend`, `before`, `append`,
                // `insertAfter`, `insertBefore`, `appendTo`, and `prependTo` methods.
                adjacencyOperators.forEach(function(operator, operatorIndex) {
                    var inside = operatorIndex % 2 //=> prepend, append
                    ;
                    $.fn[operator] = function() {
                        // arguments can be nodes, arrays of nodes, Zepto objects and HTML strings
                        var argType, nodes = $.map(arguments, function(arg) {
                            var arr = [];
                            argType = type(arg);
                            if (argType == "array") {
                                arg.forEach(function(el) {
                                    if (el.nodeType !== undefined1) return arr.push(el);
                                    else if ($.zepto.isZ(el)) return arr = arr.concat(el.get());
                                    arr = arr.concat(zepto.fragment(el));
                                });
                                return arr;
                            }
                            return argType == "object" || arg == null ? arg : zepto.fragment(arg);
                        }), parent, copyByClone = this.length > 1;
                        if (nodes.length < 1) return this;
                        return this.each(function(_, target) {
                            parent = inside ? target : target.parentNode;
                            // convert all methods to a "before" operation
                            target = operatorIndex == 0 ? target.nextSibling : operatorIndex == 1 ? target.firstChild : operatorIndex == 2 ? target : null;
                            var parentInDocument = $.contains(document1.documentElement, parent);
                            nodes.forEach(function(node) {
                                if (copyByClone) node = node.cloneNode(true);
                                else if (!parent) return $(node).remove();
                                parent.insertBefore(node, target);
                                if (parentInDocument) traverseNode(node, function(el) {
                                    if (el.nodeName != null && el.nodeName.toUpperCase() === 'SCRIPT' && (!el.type || el.type === 'text/javascript') && !el.src) {
                                        var target = el.ownerDocument ? el.ownerDocument.defaultView : window;
                                        target['eval'].call(target, el.innerHTML);
                                    }
                                });
                            });
                        });
                    };
                    // after    => insertAfter
                    // prepend  => prependTo
                    // before   => insertBefore
                    // append   => appendTo
                    $.fn[inside ? operator + 'To' : 'insert' + (operatorIndex ? 'Before' : 'After')] = function(html) {
                        $(html)[operator](this);
                        return this;
                    };
                });
                zepto.Z.prototype = Z.prototype = $.fn;
                // Export internal API functions in the `$.zepto` namespace
                zepto.uniq = uniq;
                zepto.deserializeValue = deserializeValue;
                $.zepto = zepto;
                return $;
            }();
            window.Zepto = Zepto;
            window.$ === undefined && (window.$ = Zepto);
            (function($) {
                var jsonpID = +new Date(), document1 = window.document, key, name, rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, scriptTypeRE = /^(?:text|application)\/javascript/i, xmlTypeRE = /^(?:text|application)\/xml/i, jsonType = 'application/json', htmlType = 'text/html', blankRE = /^\s*$/, originAnchor = document1.createElement('a');
                originAnchor.href = window.location.href;
                // trigger a custom event and return false if it was cancelled
                function triggerAndReturn(context, eventName, data) {
                    var event = $.Event(eventName);
                    $(context).trigger(event, data);
                    return !event.isDefaultPrevented();
                }
                // trigger an Ajax "global" event
                function triggerGlobal(settings, context, eventName, data) {
                    if (settings.global) return triggerAndReturn(context || document1, eventName, data);
                }
                // Number of active Ajax requests
                $.active = 0;
                function ajaxStart(settings) {
                    if (settings.global && $.active++ === 0) triggerGlobal(settings, null, 'ajaxStart');
                }
                function ajaxStop(settings) {
                    if (settings.global && !--$.active) triggerGlobal(settings, null, 'ajaxStop');
                }
                // triggers an extra global event "ajaxBeforeSend" that's like "ajaxSend" but cancelable
                function ajaxBeforeSend(xhr, settings) {
                    var context = settings.context;
                    if (settings.beforeSend.call(context, xhr, settings) === false || triggerGlobal(settings, context, 'ajaxBeforeSend', [
                        xhr,
                        settings
                    ]) === false) return false;
                    triggerGlobal(settings, context, 'ajaxSend', [
                        xhr,
                        settings
                    ]);
                }
                function ajaxSuccess(data, xhr, settings, deferred) {
                    var context = settings.context, status = 'success';
                    settings.success.call(context, data, status, xhr);
                    if (deferred) deferred.resolveWith(context, [
                        data,
                        status,
                        xhr
                    ]);
                    triggerGlobal(settings, context, 'ajaxSuccess', [
                        xhr,
                        settings,
                        data
                    ]);
                    ajaxComplete(status, xhr, settings);
                }
                // type: "timeout", "error", "abort", "parsererror"
                function ajaxError(error, type, xhr, settings, deferred) {
                    var context = settings.context;
                    settings.error.call(context, xhr, type, error);
                    if (deferred) deferred.rejectWith(context, [
                        xhr,
                        type,
                        error
                    ]);
                    triggerGlobal(settings, context, 'ajaxError', [
                        xhr,
                        settings,
                        error || type
                    ]);
                    ajaxComplete(type, xhr, settings);
                }
                // status: "success", "notmodified", "error", "timeout", "abort", "parsererror"
                function ajaxComplete(status, xhr, settings) {
                    var context = settings.context;
                    settings.complete.call(context, xhr, status);
                    triggerGlobal(settings, context, 'ajaxComplete', [
                        xhr,
                        settings
                    ]);
                    ajaxStop(settings);
                }
                function ajaxDataFilter(data, type, settings) {
                    if (settings.dataFilter == empty) return data;
                    var context = settings.context;
                    return settings.dataFilter.call(context, data, type);
                }
                // Empty function, used as default callback
                function empty() {}
                $.ajaxJSONP = function(options, deferred) {
                    if (!('type' in options)) return $.ajax(options);
                    var _callbackName = options.jsonpCallback, callbackName = ($.isFunction(_callbackName) ? _callbackName() : _callbackName) || 'Zepto' + jsonpID++, script = document1.createElement('script'), originalCallback = window[callbackName], responseData, abort = function(errorType) {
                        $(script).triggerHandler('error', errorType || 'abort');
                    }, xhr = {
                        abort: abort
                    }, abortTimeout;
                    if (deferred) deferred.promise(xhr);
                    $(script).on('load error', function(e, errorType) {
                        clearTimeout(abortTimeout);
                        $(script).off().remove();
                        if (e.type == 'error' || !responseData) ajaxError(null, errorType || 'error', xhr, options, deferred);
                        else ajaxSuccess(responseData[0], xhr, options, deferred);
                        window[callbackName] = originalCallback;
                        if (responseData && $.isFunction(originalCallback)) originalCallback(responseData[0]);
                        originalCallback = responseData = undefined;
                    });
                    if (ajaxBeforeSend(xhr, options) === false) {
                        abort('abort');
                        return xhr;
                    }
                    window[callbackName] = function() {
                        responseData = arguments;
                    };
                    script.src = options.url.replace(/\?(.+)=\?/, '?$1=' + callbackName);
                    document1.head.appendChild(script);
                    if (options.timeout > 0) abortTimeout = setTimeout(function() {
                        abort('timeout');
                    }, options.timeout);
                    return xhr;
                };
                $.ajaxSettings = {
                    // Default type of request
                    type: 'GET',
                    // Callback that is executed before request
                    beforeSend: empty,
                    // Callback that is executed if the request succeeds
                    success: empty,
                    // Callback that is executed the the server drops error
                    error: empty,
                    // Callback that is executed on request complete (both: error and success)
                    complete: empty,
                    // The context for the callbacks
                    context: null,
                    // Whether to trigger "global" Ajax events
                    global: true,
                    // Transport
                    xhr: function() {
                        return new window.XMLHttpRequest();
                    },
                    // MIME types mapping
                    // IIS returns Javascript as "application/x-javascript"
                    accepts: {
                        script: 'text/javascript, application/javascript, application/x-javascript',
                        json: jsonType,
                        xml: 'application/xml, text/xml',
                        html: htmlType,
                        text: 'text/plain'
                    },
                    // Whether the request is to another domain
                    crossDomain: false,
                    // Default timeout
                    timeout: 0,
                    // Whether data should be serialized to string
                    processData: true,
                    // Whether the browser should be allowed to cache GET responses
                    cache: true,
                    //Used to handle the raw response data of XMLHttpRequest.
                    //This is a pre-filtering function to sanitize the response.
                    //The sanitized response should be returned
                    dataFilter: empty
                };
                function mimeToDataType(mime) {
                    if (mime) mime = mime.split(';', 2)[0];
                    return mime && (mime == htmlType ? 'html' : mime == jsonType ? 'json' : scriptTypeRE.test(mime) ? 'script' : xmlTypeRE.test(mime) && 'xml') || 'text';
                }
                function appendQuery(url, query) {
                    if (query == '') return url;
                    return (url + '&' + query).replace(/[&?]{1,2}/, '?');
                }
                // serialize payload and append it to the URL for GET requests
                function serializeData(options) {
                    if (options.processData && options.data && $.type(options.data) != "string") options.data = $.param(options.data, options.traditional);
                    if (options.data && (!options.type || options.type.toUpperCase() == 'GET' || 'jsonp' == options.dataType)) options.url = appendQuery(options.url, options.data), options.data = undefined;
                }
                $.ajax = function(options) {
                    var settings = $.extend({}, options || {}), deferred = $.Deferred && $.Deferred(), urlAnchor, hashIndex;
                    for(key in $.ajaxSettings)if (settings[key] === undefined) settings[key] = $.ajaxSettings[key];
                    ajaxStart(settings);
                    if (!settings.crossDomain) {
                        urlAnchor = document1.createElement('a');
                        urlAnchor.href = settings.url;
                        // cleans up URL for .href (IE only), see https://github.com/madrobby/zepto/pull/1049
                        urlAnchor.href = urlAnchor.href;
                        settings.crossDomain = originAnchor.protocol + '//' + originAnchor.host !== urlAnchor.protocol + '//' + urlAnchor.host;
                    }
                    if (!settings.url) settings.url = window.location.toString();
                    if ((hashIndex = settings.url.indexOf('#')) > -1) settings.url = settings.url.slice(0, hashIndex);
                    serializeData(settings);
                    var dataType = settings.dataType, hasPlaceholder = /\?.+=\?/.test(settings.url);
                    if (hasPlaceholder) dataType = 'jsonp';
                    if (settings.cache === false || (!options || options.cache !== true) && ('script' == dataType || 'jsonp' == dataType)) settings.url = appendQuery(settings.url, '_=' + Date.now());
                    if ('jsonp' == dataType) {
                        if (!hasPlaceholder) settings.url = appendQuery(settings.url, settings.jsonp ? settings.jsonp + '=?' : settings.jsonp === false ? '' : 'callback=?');
                        return $.ajaxJSONP(settings, deferred);
                    }
                    var mime = settings.accepts[dataType], headers = {}, setHeader = function(name, value) {
                        headers[name.toLowerCase()] = [
                            name,
                            value
                        ];
                    }, protocol = /^([\w-]+:)\/\//.test(settings.url) ? RegExp.$1 : window.location.protocol, xhr = settings.xhr(), nativeSetHeader = xhr.setRequestHeader, abortTimeout;
                    if (deferred) deferred.promise(xhr);
                    if (!settings.crossDomain) setHeader('X-Requested-With', 'XMLHttpRequest');
                    setHeader('Accept', mime || '*/*');
                    if (mime = settings.mimeType || mime) {
                        if (mime.indexOf(',') > -1) mime = mime.split(',', 2)[0];
                        xhr.overrideMimeType && xhr.overrideMimeType(mime);
                    }
                    if (settings.contentType || settings.contentType !== false && settings.data && settings.type.toUpperCase() != 'GET') setHeader('Content-Type', settings.contentType || 'application/x-www-form-urlencoded');
                    if (settings.headers) for(name in settings.headers)setHeader(name, settings.headers[name]);
                    xhr.setRequestHeader = setHeader;
                    xhr.onreadystatechange = function() {
                        if (xhr.readyState == 4) {
                            xhr.onreadystatechange = empty;
                            clearTimeout(abortTimeout);
                            var result, error = false;
                            if (xhr.status >= 200 && xhr.status < 300 || xhr.status == 304 || xhr.status == 0 && protocol == 'file:') {
                                dataType = dataType || mimeToDataType(settings.mimeType || xhr.getResponseHeader('content-type'));
                                if (xhr.responseType == 'arraybuffer' || xhr.responseType == 'blob') result = xhr.response;
                                else {
                                    result = xhr.responseText;
                                    try {
                                        // http://perfectionkills.com/global-eval-what-are-the-options/
                                        // sanitize response accordingly if data filter callback provided
                                        result = ajaxDataFilter(result, dataType, settings);
                                        if (dataType == 'script') (0, eval)(result);
                                        else if (dataType == 'xml') result = xhr.responseXML;
                                        else if (dataType == 'json') result = blankRE.test(result) ? null : $.parseJSON(result);
                                    } catch (e) {
                                        error = e;
                                    }
                                    if (error) return ajaxError(error, 'parsererror', xhr, settings, deferred);
                                }
                                ajaxSuccess(result, xhr, settings, deferred);
                            } else ajaxError(xhr.statusText || null, xhr.status ? 'error' : 'abort', xhr, settings, deferred);
                        }
                    };
                    if (ajaxBeforeSend(xhr, settings) === false) {
                        xhr.abort();
                        ajaxError(null, 'abort', xhr, settings, deferred);
                        return xhr;
                    }
                    var async = 'async' in settings ? settings.async : true;
                    xhr.open(settings.type, settings.url, async, settings.username, settings.password);
                    if (settings.xhrFields) for(name in settings.xhrFields)xhr[name] = settings.xhrFields[name];
                    for(name in headers)nativeSetHeader.apply(xhr, headers[name]);
                    if (settings.timeout > 0) abortTimeout = setTimeout(function() {
                        xhr.onreadystatechange = empty;
                        xhr.abort();
                        ajaxError(null, 'timeout', xhr, settings, deferred);
                    }, settings.timeout);
                    // avoid sending empty string (#319)
                    xhr.send(settings.data ? settings.data : null);
                    return xhr;
                };
                // handle optional data/success arguments
                function parseArguments(url, data, success, dataType) {
                    if ($.isFunction(data)) dataType = success, success = data, data = undefined;
                    if (!$.isFunction(success)) dataType = success, success = undefined;
                    return {
                        url: url,
                        data: data,
                        success: success,
                        dataType: dataType
                    };
                }
                $.get = function() {
                    return $.ajax(parseArguments.apply(null, arguments));
                };
                $.post = function() {
                    var options = parseArguments.apply(null, arguments);
                    options.type = 'POST';
                    return $.ajax(options);
                };
                $.getJSON = function() {
                    var options = parseArguments.apply(null, arguments);
                    options.dataType = 'json';
                    return $.ajax(options);
                };
                $.fn.load = function(url, data, success) {
                    if (!this.length) return this;
                    var self1 = this, parts = url.split(/\s/), selector, options = parseArguments(url, data, success), callback = options.success;
                    if (parts.length > 1) options.url = parts[0], selector = parts[1];
                    options.success = function(response) {
                        self1.html(selector ? $('<div>').html(response.replace(rscript, "")).find(selector) : response);
                        callback && callback.apply(self1, arguments);
                    };
                    $.ajax(options);
                    return this;
                };
                var escape = encodeURIComponent;
                function serialize(params, obj, traditional, scope) {
                    var type, array = $.isArray(obj), hash = $.isPlainObject(obj);
                    $.each(obj, function(key, value) {
                        type = $.type(value);
                        if (scope) key = traditional ? scope : scope + '[' + (hash || type == 'object' || type == 'array' ? key : '') + ']';
                        // handle data in serializeArray() format
                        if (!scope && array) params.add(value.name, value.value);
                        else if (type == "array" || !traditional && type == "object") serialize(params, value, traditional, key);
                        else params.add(key, value);
                    });
                }
                $.param = function(obj, traditional) {
                    var params = [];
                    params.add = function(key, value) {
                        if ($.isFunction(value)) value = value();
                        if (value == null) value = "";
                        this.push(escape(key) + '=' + escape(value));
                    };
                    serialize(params, obj, traditional);
                    return params.join('&').replace(/%20/g, '+');
                };
            })(Zepto);
            (function($) {
                // Create a collection of callbacks to be fired in a sequence, with configurable behaviour
                // Option flags:
                //   - once: Callbacks fired at most one time.
                //   - memory: Remember the most recent context and arguments
                //   - stopOnFalse: Cease iterating over callback list
                //   - unique: Permit adding at most one instance of the same callback
                $.Callbacks = function(options) {
                    options = $.extend({}, options);
                    var memory, fired, firing, firingStart, firingLength, firingIndex, list = [], stack = !options.once && [], fire = function(data) {
                        memory = options.memory && data;
                        fired = true;
                        firingIndex = firingStart || 0;
                        firingStart = 0;
                        firingLength = list.length;
                        firing = true;
                        for(; list && firingIndex < firingLength; ++firingIndex)if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                            memory = false;
                            break;
                        }
                        firing = false;
                        if (list) {
                            if (stack) stack.length && fire(stack.shift());
                            else if (memory) list.length = 0;
                            else Callbacks.disable();
                        }
                    }, Callbacks = {
                        add: function() {
                            if (list) {
                                var start = list.length, add = function(args) {
                                    $.each(args, function(_, arg) {
                                        if (typeof arg === "function") {
                                            if (!options.unique || !Callbacks.has(arg)) list.push(arg);
                                        } else if (arg && arg.length && typeof arg !== 'string') add(arg);
                                    });
                                };
                                add(arguments);
                                if (firing) firingLength = list.length;
                                else if (memory) {
                                    firingStart = start;
                                    fire(memory);
                                }
                            }
                            return this;
                        },
                        remove: function() {
                            if (list) $.each(arguments, function(_, arg) {
                                var index;
                                while((index = $.inArray(arg, list, index)) > -1){
                                    list.splice(index, 1);
                                    // Handle firing indexes
                                    if (firing) {
                                        if (index <= firingLength) --firingLength;
                                        if (index <= firingIndex) --firingIndex;
                                    }
                                }
                            });
                            return this;
                        },
                        has: function(fn) {
                            return !!(list && (fn ? $.inArray(fn, list) > -1 : list.length));
                        },
                        empty: function() {
                            firingLength = list.length = 0;
                            return this;
                        },
                        disable: function() {
                            list = stack = memory = undefined;
                            return this;
                        },
                        disabled: function() {
                            return !list;
                        },
                        lock: function() {
                            stack = undefined;
                            if (!memory) Callbacks.disable();
                            return this;
                        },
                        locked: function() {
                            return !stack;
                        },
                        fireWith: function(context, args) {
                            if (list && (!fired || stack)) {
                                args = args || [];
                                args = [
                                    context,
                                    args.slice ? args.slice() : args
                                ];
                                if (firing) stack.push(args);
                                else fire(args);
                            }
                            return this;
                        },
                        fire: function() {
                            return Callbacks.fireWith(this, arguments);
                        },
                        fired: function() {
                            return !!fired;
                        }
                    };
                    return Callbacks;
                };
            })(Zepto);
            (function($) {
                var slice = Array.prototype.slice;
                function Deferred(func) {
                    var tuples = [
                        // action, add listener, listener list, final state
                        [
                            "resolve",
                            "done",
                            $.Callbacks({
                                once: 1,
                                memory: 1
                            }),
                            "resolved"
                        ],
                        [
                            "reject",
                            "fail",
                            $.Callbacks({
                                once: 1,
                                memory: 1
                            }),
                            "rejected"
                        ],
                        [
                            "notify",
                            "progress",
                            $.Callbacks({
                                memory: 1
                            })
                        ]
                    ], state = "pending", promise = {
                        state: function() {
                            return state;
                        },
                        always: function() {
                            deferred.done(arguments).fail(arguments);
                            return this;
                        },
                        then: function() {
                            var fns = arguments;
                            return Deferred(function(defer) {
                                $.each(tuples, function(i, tuple) {
                                    var fn = $.isFunction(fns[i]) && fns[i];
                                    deferred[tuple[1]](function() {
                                        var returned = fn && fn.apply(this, arguments);
                                        if (returned && $.isFunction(returned.promise)) returned.promise().done(defer.resolve).fail(defer.reject).progress(defer.notify);
                                        else {
                                            var context = this === promise ? defer.promise() : this, values = fn ? [
                                                returned
                                            ] : arguments;
                                            defer[tuple[0] + "With"](context, values);
                                        }
                                    });
                                });
                                fns = null;
                            }).promise();
                        },
                        promise: function(obj) {
                            return obj != null ? $.extend(obj, promise) : promise;
                        }
                    }, deferred = {};
                    $.each(tuples, function(i, tuple) {
                        var list = tuple[2], stateString = tuple[3];
                        promise[tuple[1]] = list.add;
                        if (stateString) list.add(function() {
                            state = stateString;
                        }, tuples[i ^ 1][2].disable, tuples[2][2].lock);
                        deferred[tuple[0]] = function() {
                            deferred[tuple[0] + "With"](this === deferred ? promise : this, arguments);
                            return this;
                        };
                        deferred[tuple[0] + "With"] = list.fireWith;
                    });
                    promise.promise(deferred);
                    if (func) func.call(deferred, deferred);
                    return deferred;
                }
                $.when = function(sub) {
                    var resolveValues = slice.call(arguments), len = resolveValues.length, i = 0, remain = len !== 1 || sub && $.isFunction(sub.promise) ? len : 0, deferred = remain === 1 ? sub : Deferred(), progressValues, progressContexts, resolveContexts, updateFn = function(i, ctx, val) {
                        return function(value) {
                            ctx[i] = this;
                            val[i] = arguments.length > 1 ? slice.call(arguments) : value;
                            if (val === progressValues) deferred.notifyWith(ctx, val);
                            else if (!--remain) deferred.resolveWith(ctx, val);
                        };
                    };
                    if (len > 1) {
                        progressValues = new Array(len);
                        progressContexts = new Array(len);
                        resolveContexts = new Array(len);
                        for(; i < len; ++i)if (resolveValues[i] && $.isFunction(resolveValues[i].promise)) resolveValues[i].promise().done(updateFn(i, resolveContexts, resolveValues)).fail(deferred.reject).progress(updateFn(i, progressContexts, progressValues));
                        else --remain;
                    }
                    if (!remain) deferred.resolveWith(resolveContexts, resolveValues);
                    return deferred.promise();
                };
                $.Deferred = Deferred;
            })(Zepto);
            (function($) {
                var _zid = 1, undefined1, slice = Array.prototype.slice, isFunction = $.isFunction, isString = function(obj) {
                    return typeof obj == 'string';
                }, handlers = {}, specialEvents = {}, focusinSupported = 'onfocusin' in window, focus = {
                    focus: 'focusin',
                    blur: 'focusout'
                }, hover = {
                    mouseenter: 'mouseover',
                    mouseleave: 'mouseout'
                };
                specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = 'MouseEvents';
                function zid(element) {
                    return element._zid || (element._zid = _zid++);
                }
                function findHandlers(element, event, fn, selector) {
                    event = parse(event);
                    if (event.ns) var matcher = matcherFor(event.ns);
                    return (handlers[zid(element)] || []).filter(function(handler) {
                        return handler && (!event.e || handler.e == event.e) && (!event.ns || matcher.test(handler.ns)) && (!fn || zid(handler.fn) === zid(fn)) && (!selector || handler.sel == selector);
                    });
                }
                function parse(event) {
                    var parts = ('' + event).split('.');
                    return {
                        e: parts[0],
                        ns: parts.slice(1).sort().join(' ')
                    };
                }
                function matcherFor(ns) {
                    return new RegExp('(?:^| )' + ns.replace(' ', ' .* ?') + '(?: |$)');
                }
                function eventCapture(handler, captureSetting) {
                    return handler.del && !focusinSupported && handler.e in focus || !!captureSetting;
                }
                function realEvent(type) {
                    return hover[type] || focusinSupported && focus[type] || type;
                }
                function add(element, events, fn, data, selector, delegator, capture) {
                    var id = zid(element), set = handlers[id] || (handlers[id] = []);
                    events.split(/\s/).forEach(function(event) {
                        if (event == 'ready') return $(document).ready(fn);
                        var handler = parse(event);
                        handler.fn = fn;
                        handler.sel = selector;
                        // emulate mouseenter, mouseleave
                        if (handler.e in hover) fn = function(e) {
                            var related = e.relatedTarget;
                            if (!related || related !== this && !$.contains(this, related)) return handler.fn.apply(this, arguments);
                        };
                        handler.del = delegator;
                        var callback = delegator || fn;
                        handler.proxy = function(e) {
                            e = compatible(e);
                            if (e.isImmediatePropagationStopped()) return;
                            e.data = data;
                            var result = callback.apply(element, e._args == undefined1 ? [
                                e
                            ] : [
                                e
                            ].concat(e._args));
                            if (result === false) e.preventDefault(), e.stopPropagation();
                            return result;
                        };
                        handler.i = set.length;
                        set.push(handler);
                        if ('addEventListener' in element) element.addEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
                    });
                }
                function remove(element, events, fn, selector, capture) {
                    var id = zid(element);
                    (events || '').split(/\s/).forEach(function(event) {
                        findHandlers(element, event, fn, selector).forEach(function(handler) {
                            delete handlers[id][handler.i];
                            if ('removeEventListener' in element) element.removeEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
                        });
                    });
                }
                $.event = {
                    add: add,
                    remove: remove
                };
                $.proxy = function(fn, context) {
                    var args = 2 in arguments && slice.call(arguments, 2);
                    if (isFunction(fn)) {
                        var proxyFn = function() {
                            return fn.apply(context, args ? args.concat(slice.call(arguments)) : arguments);
                        };
                        proxyFn._zid = zid(fn);
                        return proxyFn;
                    } else if (isString(context)) {
                        if (args) {
                            args.unshift(fn[context], fn);
                            return $.proxy.apply(null, args);
                        } else return $.proxy(fn[context], fn);
                    } else throw new TypeError("expected function");
                };
                $.fn.bind = function(event, data, callback) {
                    return this.on(event, data, callback);
                };
                $.fn.unbind = function(event, callback) {
                    return this.off(event, callback);
                };
                $.fn.one = function(event, selector, data, callback) {
                    return this.on(event, selector, data, callback, 1);
                };
                var returnTrue = function() {
                    return true;
                }, returnFalse = function() {
                    return false;
                }, ignoreProperties = /^([A-Z]|returnValue$|layer[XY]$|webkitMovement[XY]$)/, eventMethods = {
                    preventDefault: 'isDefaultPrevented',
                    stopImmediatePropagation: 'isImmediatePropagationStopped',
                    stopPropagation: 'isPropagationStopped'
                };
                function compatible(event, source) {
                    if (source || !event.isDefaultPrevented) {
                        source || (source = event);
                        $.each(eventMethods, function(name, predicate) {
                            var sourceMethod = source[name];
                            event[name] = function() {
                                this[predicate] = returnTrue;
                                return sourceMethod && sourceMethod.apply(source, arguments);
                            };
                            event[predicate] = returnFalse;
                        });
                        event.timeStamp || (event.timeStamp = Date.now());
                        if (source.defaultPrevented !== undefined1 ? source.defaultPrevented : 'returnValue' in source ? source.returnValue === false : source.getPreventDefault && source.getPreventDefault()) event.isDefaultPrevented = returnTrue;
                    }
                    return event;
                }
                function createProxy(event) {
                    var key, proxy = {
                        originalEvent: event
                    };
                    for(key in event)if (!ignoreProperties.test(key) && event[key] !== undefined1) proxy[key] = event[key];
                    return compatible(proxy, event);
                }
                $.fn.delegate = function(selector, event, callback) {
                    return this.on(event, selector, callback);
                };
                $.fn.undelegate = function(selector, event, callback) {
                    return this.off(event, selector, callback);
                };
                $.fn.live = function(event, callback) {
                    $(document.body).delegate(this.selector, event, callback);
                    return this;
                };
                $.fn.die = function(event, callback) {
                    $(document.body).undelegate(this.selector, event, callback);
                    return this;
                };
                $.fn.on = function(event, selector, data, callback, one) {
                    var autoRemove, delegator, $this = this;
                    if (event && !isString(event)) {
                        $.each(event, function(type, fn) {
                            $this.on(type, selector, data, fn, one);
                        });
                        return $this;
                    }
                    if (!isString(selector) && !isFunction(callback) && callback !== false) callback = data, data = selector, selector = undefined1;
                    if (callback === undefined1 || data === false) callback = data, data = undefined1;
                    if (callback === false) callback = returnFalse;
                    return $this.each(function(_, element) {
                        if (one) autoRemove = function(e) {
                            remove(element, e.type, callback);
                            return callback.apply(this, arguments);
                        };
                        if (selector) delegator = function(e) {
                            var evt, match = $(e.target).closest(selector, element).get(0);
                            if (match && match !== element) {
                                evt = $.extend(createProxy(e), {
                                    currentTarget: match,
                                    liveFired: element
                                });
                                return (autoRemove || callback).apply(match, [
                                    evt
                                ].concat(slice.call(arguments, 1)));
                            }
                        };
                        add(element, event, callback, data, selector, delegator || autoRemove);
                    });
                };
                $.fn.off = function(event, selector, callback) {
                    var $this = this;
                    if (event && !isString(event)) {
                        $.each(event, function(type, fn) {
                            $this.off(type, selector, fn);
                        });
                        return $this;
                    }
                    if (!isString(selector) && !isFunction(callback) && callback !== false) callback = selector, selector = undefined1;
                    if (callback === false) callback = returnFalse;
                    return $this.each(function() {
                        remove(this, event, callback, selector);
                    });
                };
                $.fn.trigger = function(event, args) {
                    event = isString(event) || $.isPlainObject(event) ? $.Event(event) : compatible(event);
                    event._args = args;
                    return this.each(function() {
                        // handle focus(), blur() by calling them directly
                        if (event.type in focus && typeof this[event.type] == "function") this[event.type]();
                        else if ('dispatchEvent' in this) this.dispatchEvent(event);
                        else $(this).triggerHandler(event, args);
                    });
                };
                // triggers event handlers on current element just as if an event occurred,
                // doesn't trigger an actual event, doesn't bubble
                $.fn.triggerHandler = function(event, args) {
                    var e, result;
                    this.each(function(i, element) {
                        e = createProxy(isString(event) ? $.Event(event) : event);
                        e._args = args;
                        e.target = element;
                        $.each(findHandlers(element, event.type || event), function(i, handler) {
                            result = handler.proxy(e);
                            if (e.isImmediatePropagationStopped()) return false;
                        });
                    });
                    return result;
                };
                "focusin focusout focus blur load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select keydown keypress keyup error".split(' ').forEach(function(event) {
                    $.fn[event] = function(callback) {
                        return 0 in arguments ? this.bind(event, callback) : this.trigger(event);
                    };
                });
                $.Event = function(type, props) {
                    if (!isString(type)) props = type, type = props.type;
                    var event = document.createEvent(specialEvents[type] || 'Events'), bubbles = true;
                    if (props) for(var name in props)name == 'bubbles' ? bubbles = !!props[name] : event[name] = props[name];
                    event.initEvent(type, bubbles, true);
                    return compatible(event);
                };
            })(Zepto);
            (function() {
                // getComputedStyle shouldn't freak out when called
                // without a valid element as argument
                try {
                    getComputedStyle(undefined);
                } catch (e) {
                    var nativeGetComputedStyle = getComputedStyle;
                    window.getComputedStyle = function(element, pseudoElement) {
                        try {
                            return nativeGetComputedStyle(element, pseudoElement);
                        } catch (e) {
                            return null;
                        }
                    };
                }
            })();
            (function($) {
                var zepto = $.zepto, oldQsa = zepto.qsa, oldMatches = zepto.matches;
                function visible(elem) {
                    elem = $(elem);
                    return !!(elem.width() || elem.height()) && elem.css("display") !== "none";
                }
                // Implements a subset from:
                // http://api.jquery.com/category/selectors/jquery-selector-extensions/
                //
                // Each filter function receives the current index, all nodes in the
                // considered set, and a value if there were parentheses. The value
                // of `this` is the node currently being considered. The function returns the
                // resulting node(s), null, or undefined.
                //
                // Complex selectors are not supported:
                //   li:has(label:contains("foo")) + li:has(label:contains("bar"))
                //   ul.inner:first > li
                var filters = $.expr[':'] = {
                    visible: function() {
                        if (visible(this)) return this;
                    },
                    hidden: function() {
                        if (!visible(this)) return this;
                    },
                    selected: function() {
                        if (this.selected) return this;
                    },
                    checked: function() {
                        if (this.checked) return this;
                    },
                    parent: function() {
                        return this.parentNode;
                    },
                    first: function(idx) {
                        if (idx === 0) return this;
                    },
                    last: function(idx, nodes) {
                        if (idx === nodes.length - 1) return this;
                    },
                    eq: function(idx, _, value) {
                        if (idx === value) return this;
                    },
                    contains: function(idx, _, text) {
                        if ($(this).text().indexOf(text) > -1) return this;
                    },
                    has: function(idx, _, sel) {
                        if (zepto.qsa(this, sel).length) return this;
                    }
                };
                var filterRe = new RegExp('(.*):(\\w+)(?:\\(([^)]+)\\))?$\\s*'), childRe = /^\s*>/, classTag = 'Zepto' + +new Date();
                function process(sel, fn) {
                    // quote the hash in `a[href^=#]` expression
                    sel = sel.replace(/=#\]/g, '="#"]');
                    var filter, arg, match = filterRe.exec(sel);
                    if (match && match[2] in filters) {
                        filter = filters[match[2]], arg = match[3];
                        sel = match[1];
                        if (arg) {
                            var num = Number(arg);
                            if (isNaN(num)) arg = arg.replace(/^["']|["']$/g, '');
                            else arg = num;
                        }
                    }
                    return fn(sel, filter, arg);
                }
                zepto.qsa = function(node, selector) {
                    return process(selector, function(sel, filter, arg) {
                        try {
                            var taggedParent;
                            if (!sel && filter) sel = '*';
                            else if (childRe.test(sel)) // support "> *" child queries by tagging the parent node with a
                            // unique class and prepending that classname onto the selector
                            taggedParent = $(node).addClass(classTag), sel = '.' + classTag + ' ' + sel;
                            var nodes = oldQsa(node, sel);
                        } catch (e) {
                            console.error('error performing selector: %o', selector);
                            throw e;
                        } finally{
                            if (taggedParent) taggedParent.removeClass(classTag);
                        }
                        return !filter ? nodes : zepto.uniq($.map(nodes, function(n, i) {
                            return filter.call(n, i, nodes, arg);
                        }));
                    });
                };
                zepto.matches = function(node, selector) {
                    return process(selector, function(sel, filter, arg) {
                        return (!sel || oldMatches(node, sel)) && (!filter || filter.call(node, null, arg) === node);
                    });
                };
            })(Zepto);
            module1.exports = Zepto;
        /***/ },
        /***/ "./node_modules/core-js/library/fn/array/from.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/library/fn/array/from.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ../../modules/es6.string.iterator */ "./node_modules/core-js/library/modules/es6.string.iterator.js");
            __webpack_require__(/*! ../../modules/es6.array.from */ "./node_modules/core-js/library/modules/es6.array.from.js");
            module1.exports = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Array.from;
        /***/ },
        /***/ "./node_modules/core-js/library/fn/get-iterator.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/library/fn/get-iterator.js ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ../modules/web.dom.iterable */ "./node_modules/core-js/library/modules/web.dom.iterable.js");
            __webpack_require__(/*! ../modules/es6.string.iterator */ "./node_modules/core-js/library/modules/es6.string.iterator.js");
            module1.exports = __webpack_require__(/*! ../modules/core.get-iterator */ "./node_modules/core-js/library/modules/core.get-iterator.js");
        /***/ },
        /***/ "./node_modules/core-js/library/fn/json/stringify.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/library/fn/json/stringify.js ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var core = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js"), $JSON = core.JSON || (core.JSON = {
                stringify: JSON.stringify
            });
            module1.exports = function stringify(it) {
                return $JSON.stringify.apply($JSON, arguments);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/fn/object/assign.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/library/fn/object/assign.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ../../modules/es6.object.assign */ "./node_modules/core-js/library/modules/es6.object.assign.js");
            module1.exports = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Object.assign;
        /***/ },
        /***/ "./node_modules/core-js/library/fn/object/create.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/library/fn/object/create.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ../../modules/es6.object.create */ "./node_modules/core-js/library/modules/es6.object.create.js");
            var $Object = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Object;
            module1.exports = function create(P, D) {
                return $Object.create(P, D);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/fn/object/define-property.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/library/fn/object/define-property.js ***!
  \*******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ../../modules/es6.object.define-property */ "./node_modules/core-js/library/modules/es6.object.define-property.js");
            var $Object = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Object;
            module1.exports = function defineProperty(it, key, desc) {
                return $Object.defineProperty(it, key, desc);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/fn/object/get-own-property-descriptor.js": /*!*******************************************************************************!*\
  !*** ./node_modules/core-js/library/fn/object/get-own-property-descriptor.js ***!
  \*******************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ../../modules/es6.object.get-own-property-descriptor */ "./node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js");
            var $Object = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Object;
            module1.exports = function getOwnPropertyDescriptor(it, key) {
                return $Object.getOwnPropertyDescriptor(it, key);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/fn/object/keys.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/library/fn/object/keys.js ***!
  \********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ../../modules/es6.object.keys */ "./node_modules/core-js/library/modules/es6.object.keys.js");
            module1.exports = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Object.keys;
        /***/ },
        /***/ "./node_modules/core-js/library/fn/object/set-prototype-of.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/library/fn/object/set-prototype-of.js ***!
  \********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ../../modules/es6.object.set-prototype-of */ "./node_modules/core-js/library/modules/es6.object.set-prototype-of.js");
            module1.exports = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Object.setPrototypeOf;
        /***/ },
        /***/ "./node_modules/core-js/library/fn/symbol/index.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/library/fn/symbol/index.js ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ../../modules/es6.symbol */ "./node_modules/core-js/library/modules/es6.symbol.js");
            __webpack_require__(/*! ../../modules/es6.object.to-string */ "./node_modules/core-js/library/modules/es6.object.to-string.js");
            __webpack_require__(/*! ../../modules/es7.symbol.async-iterator */ "./node_modules/core-js/library/modules/es7.symbol.async-iterator.js");
            __webpack_require__(/*! ../../modules/es7.symbol.observable */ "./node_modules/core-js/library/modules/es7.symbol.observable.js");
            module1.exports = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Symbol;
        /***/ },
        /***/ "./node_modules/core-js/library/fn/symbol/iterator.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/fn/symbol/iterator.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ../../modules/es6.string.iterator */ "./node_modules/core-js/library/modules/es6.string.iterator.js");
            __webpack_require__(/*! ../../modules/web.dom.iterable */ "./node_modules/core-js/library/modules/web.dom.iterable.js");
            module1.exports = __webpack_require__(/*! ../../modules/_wks-ext */ "./node_modules/core-js/library/modules/_wks-ext.js").f('iterator');
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_a-function.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_a-function.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = function(it) {
                if (typeof it != 'function') throw TypeError(it + ' is not a function!');
                return it;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_add-to-unscopables.js": /*!*********************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_add-to-unscopables.js ***!
  \*********************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = function() {};
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_an-object.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_an-object.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/library/modules/_is-object.js");
            module1.exports = function(it) {
                if (!isObject(it)) throw TypeError(it + ' is not an object!');
                return it;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_array-includes.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_array-includes.js ***!
  \*****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // false -> Array#indexOf
            // true  -> Array#includes
            var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js"), toLength = __webpack_require__(/*! ./_to-length */ "./node_modules/core-js/library/modules/_to-length.js"), toIndex = __webpack_require__(/*! ./_to-index */ "./node_modules/core-js/library/modules/_to-index.js");
            module1.exports = function(IS_INCLUDES) {
                return function($this, el, fromIndex) {
                    var O = toIObject($this), length = toLength(O.length), index = toIndex(fromIndex, length), value;
                    // Array#includes uses SameValueZero equality algorithm
                    if (IS_INCLUDES && el != el) while(length > index){
                        value = O[index++];
                        if (value != value) return true;
                    // Array#toIndex ignores holes, Array#includes - not
                    }
                    else for(; length > index; index++)if (IS_INCLUDES || index in O) {
                        if (O[index] === el) return IS_INCLUDES || index || 0;
                    }
                    return !IS_INCLUDES && -1;
                };
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_classof.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_classof.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // getting tag from 19.1.3.6 Object.prototype.toString()
            var cof = __webpack_require__(/*! ./_cof */ "./node_modules/core-js/library/modules/_cof.js"), TAG = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('toStringTag'), ARG = cof(function() {
                return arguments;
            }()) == 'Arguments';
            // fallback for IE11 Script Access Denied error
            var tryGet = function(it, key) {
                try {
                    return it[key];
                } catch (e) {}
            };
            module1.exports = function(it) {
                var O, T, B;
                return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T : ARG ? cof(O) : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_cof.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/library/modules/_cof.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var toString = {}.toString;
            module1.exports = function(it) {
                return toString.call(it).slice(8, -1);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_core.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/library/modules/_core.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var core = module1.exports = {
                version: '2.4.0'
            };
            if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_create-property.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_create-property.js ***!
  \******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $defineProperty = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js"), createDesc = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/library/modules/_property-desc.js");
            module1.exports = function(object, index, value) {
                if (index in object) $defineProperty.f(object, index, createDesc(0, value));
                else object[index] = value;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_ctx.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/library/modules/_ctx.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // optional / simple context binding
            var aFunction = __webpack_require__(/*! ./_a-function */ "./node_modules/core-js/library/modules/_a-function.js");
            module1.exports = function(fn, that, length) {
                aFunction(fn);
                if (that === undefined) return fn;
                switch(length){
                    case 1:
                        return function(a) {
                            return fn.call(that, a);
                        };
                    case 2:
                        return function(a, b) {
                            return fn.call(that, a, b);
                        };
                    case 3:
                        return function(a, b, c) {
                            return fn.call(that, a, b, c);
                        };
                }
                return function() {
                    return fn.apply(that, arguments);
                };
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_defined.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_defined.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            // 7.2.1 RequireObjectCoercible(argument)
            module1.exports = function(it) {
                if (it == undefined) throw TypeError("Can't call method on  " + it);
                return it;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_descriptors.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_descriptors.js ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // Thank's IE8 for his funny defineProperty
            module1.exports = !__webpack_require__(/*! ./_fails */ "./node_modules/core-js/library/modules/_fails.js")(function() {
                return Object.defineProperty({}, 'a', {
                    get: function() {
                        return 7;
                    }
                }).a != 7;
            });
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_dom-create.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_dom-create.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/library/modules/_is-object.js"), document1 = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js").document, is = isObject(document1) && isObject(document1.createElement);
            module1.exports = function(it) {
                return is ? document1.createElement(it) : {};
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_enum-bug-keys.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_enum-bug-keys.js ***!
  \****************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            // IE 8- don't enum bug keys
            module1.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_enum-keys.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_enum-keys.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // all enumerable object keys, includes symbols
            var getKeys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/library/modules/_object-keys.js"), gOPS = __webpack_require__(/*! ./_object-gops */ "./node_modules/core-js/library/modules/_object-gops.js"), pIE = __webpack_require__(/*! ./_object-pie */ "./node_modules/core-js/library/modules/_object-pie.js");
            module1.exports = function(it) {
                var result = getKeys(it), getSymbols = gOPS.f;
                if (getSymbols) {
                    var symbols = getSymbols(it), isEnum = pIE.f, i = 0, key;
                    while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
                }
                return result;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_export.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_export.js ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js"), core = __webpack_require__(/*! ./_core */ "./node_modules/core-js/library/modules/_core.js"), ctx = __webpack_require__(/*! ./_ctx */ "./node_modules/core-js/library/modules/_ctx.js"), hide = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js"), PROTOTYPE = 'prototype';
            var $export = function(type, name, source) {
                var IS_FORCED = type & $export.F, IS_GLOBAL = type & $export.G, IS_STATIC = type & $export.S, IS_PROTO = type & $export.P, IS_BIND = type & $export.B, IS_WRAP = type & $export.W, exports = IS_GLOBAL ? core : core[name] || (core[name] = {}), expProto = exports[PROTOTYPE], target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE], key, own, out;
                if (IS_GLOBAL) source = name;
                for(key in source){
                    // contains in native
                    own = !IS_FORCED && target && target[key] !== undefined;
                    if (own && key in exports) continue;
                    // export native or passed
                    out = own ? target[key] : source[key];
                    // prevent global pollution for namespaces
                    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? ctx(out, global) : IS_WRAP && target[key] == out ? function(C) {
                        var F = function(a, b, c) {
                            if (this instanceof C) {
                                switch(arguments.length){
                                    case 0:
                                        return new C;
                                    case 1:
                                        return new C(a);
                                    case 2:
                                        return new C(a, b);
                                }
                                return new C(a, b, c);
                            }
                            return C.apply(this, arguments);
                        };
                        F[PROTOTYPE] = C[PROTOTYPE];
                        return F;
                    // make static versions for prototype methods
                    }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
                    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
                    if (IS_PROTO) {
                        (exports.virtual || (exports.virtual = {}))[key] = out;
                        // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
                        if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
                    }
                }
            };
            // type bitmap
            $export.F = 1; // forced
            $export.G = 2; // global
            $export.S = 4; // static
            $export.P = 8; // proto
            $export.B = 16; // bind
            $export.W = 32; // wrap
            $export.U = 64; // safe
            $export.R = 128; // real proto method for `library` 
            module1.exports = $export;
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_fails.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_fails.js ***!
  \********************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = function(exec) {
                try {
                    return !!exec();
                } catch (e) {
                    return true;
                }
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_global.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_global.js ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
            var global = module1.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
            if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_has.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/library/modules/_has.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var hasOwnProperty = {}.hasOwnProperty;
            module1.exports = function(it, key) {
                return hasOwnProperty.call(it, key);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_hide.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/library/modules/_hide.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var dP = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js"), createDesc = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/library/modules/_property-desc.js");
            module1.exports = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js") ? function(object, key, value) {
                return dP.f(object, key, createDesc(1, value));
            } : function(object, key, value) {
                object[key] = value;
                return object;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_html.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/library/modules/_html.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js").document && document.documentElement;
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_ie8-dom-define.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_ie8-dom-define.js ***!
  \*****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = !__webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__(/*! ./_fails */ "./node_modules/core-js/library/modules/_fails.js")(function() {
                return Object.defineProperty(__webpack_require__(/*! ./_dom-create */ "./node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', {
                    get: function() {
                        return 7;
                    }
                }).a != 7;
            });
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_iobject.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_iobject.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // fallback for non-array-like ES3 and non-enumerable old V8 strings
            var cof = __webpack_require__(/*! ./_cof */ "./node_modules/core-js/library/modules/_cof.js");
            module1.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
                return cof(it) == 'String' ? it.split('') : Object(it);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_is-array-iter.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_is-array-iter.js ***!
  \****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // check on default Array iterator
            var Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/library/modules/_iterators.js"), ITERATOR = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('iterator'), ArrayProto = Array.prototype;
            module1.exports = function(it) {
                return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_is-array.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_is-array.js ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 7.2.2 IsArray(argument)
            var cof = __webpack_require__(/*! ./_cof */ "./node_modules/core-js/library/modules/_cof.js");
            module1.exports = Array.isArray || function isArray(arg) {
                return cof(arg) == 'Array';
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_is-object.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_is-object.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = function(it) {
                return typeof it === 'object' ? it !== null : typeof it === 'function';
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_iter-call.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_iter-call.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // call something on iterator step with safe closing on error
            var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js");
            module1.exports = function(iterator, fn, value, entries) {
                try {
                    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
                // 7.4.6 IteratorClose(iterator, completion)
                } catch (e) {
                    var ret = iterator['return'];
                    if (ret !== undefined) anObject(ret.call(iterator));
                    throw e;
                }
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_iter-create.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_iter-create.js ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var create = __webpack_require__(/*! ./_object-create */ "./node_modules/core-js/library/modules/_object-create.js"), descriptor = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/library/modules/_property-desc.js"), setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ "./node_modules/core-js/library/modules/_set-to-string-tag.js"), IteratorPrototype = {};
            // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
            __webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('iterator'), function() {
                return this;
            });
            module1.exports = function(Constructor, NAME, next) {
                Constructor.prototype = create(IteratorPrototype, {
                    next: descriptor(1, next)
                });
                setToStringTag(Constructor, NAME + ' Iterator');
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_iter-define.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_iter-define.js ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var LIBRARY = __webpack_require__(/*! ./_library */ "./node_modules/core-js/library/modules/_library.js"), $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js"), redefine = __webpack_require__(/*! ./_redefine */ "./node_modules/core-js/library/modules/_redefine.js"), hide = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js"), has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js"), Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/library/modules/_iterators.js"), $iterCreate = __webpack_require__(/*! ./_iter-create */ "./node_modules/core-js/library/modules/_iter-create.js"), setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ "./node_modules/core-js/library/modules/_set-to-string-tag.js"), getPrototypeOf = __webpack_require__(/*! ./_object-gpo */ "./node_modules/core-js/library/modules/_object-gpo.js"), ITERATOR = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('iterator'), BUGGY = !([].keys && 'next' in [].keys() // Safari has buggy iterators w/o `next`
            ), FF_ITERATOR = '@@iterator', KEYS = 'keys', VALUES = 'values';
            var returnThis = function() {
                return this;
            };
            module1.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
                $iterCreate(Constructor, NAME, next);
                var getMethod = function(kind) {
                    if (!BUGGY && kind in proto) return proto[kind];
                    switch(kind){
                        case KEYS:
                            return function keys() {
                                return new Constructor(this, kind);
                            };
                        case VALUES:
                            return function values() {
                                return new Constructor(this, kind);
                            };
                    }
                    return function entries() {
                        return new Constructor(this, kind);
                    };
                };
                var TAG = NAME + ' Iterator', DEF_VALUES = DEFAULT == VALUES, VALUES_BUG = false, proto = Base.prototype, $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT], $default = $native || getMethod(DEFAULT), $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined, $anyNative = NAME == 'Array' ? proto.entries || $native : $native, methods, key, IteratorPrototype;
                // Fix native
                if ($anyNative) {
                    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
                    if (IteratorPrototype !== Object.prototype) {
                        // Set @@toStringTag to native iterators
                        setToStringTag(IteratorPrototype, TAG, true);
                        // fix for some old engines
                        if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
                    }
                }
                // fix Array#{values, @@iterator}.name in V8 / FF
                if (DEF_VALUES && $native && $native.name !== VALUES) {
                    VALUES_BUG = true;
                    $default = function values() {
                        return $native.call(this);
                    };
                }
                // Define iterator
                if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) hide(proto, ITERATOR, $default);
                // Plug for library
                Iterators[NAME] = $default;
                Iterators[TAG] = returnThis;
                if (DEFAULT) {
                    methods = {
                        values: DEF_VALUES ? $default : getMethod(VALUES),
                        keys: IS_SET ? $default : getMethod(KEYS),
                        entries: $entries
                    };
                    if (FORCED) {
                        for(key in methods)if (!(key in proto)) redefine(proto, key, methods[key]);
                    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
                }
                return methods;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_iter-detect.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_iter-detect.js ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var ITERATOR = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('iterator'), SAFE_CLOSING = false;
            try {
                var riter = [
                    7
                ][ITERATOR]();
                riter['return'] = function() {
                    SAFE_CLOSING = true;
                };
                Array.from(riter, function() {
                    throw 2;
                });
            } catch (e) {}
            module1.exports = function(exec, skipClosing) {
                if (!skipClosing && !SAFE_CLOSING) return false;
                var safe = false;
                try {
                    var arr = [
                        7
                    ], iter = arr[ITERATOR]();
                    iter.next = function() {
                        return {
                            done: safe = true
                        };
                    };
                    arr[ITERATOR] = function() {
                        return iter;
                    };
                    exec(arr);
                } catch (e) {}
                return safe;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_iter-step.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_iter-step.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = function(done, value) {
                return {
                    value: value,
                    done: !!done
                };
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_iterators.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_iterators.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = {};
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_keyof.js": /*!********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_keyof.js ***!
  \********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var getKeys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/library/modules/_object-keys.js"), toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js");
            module1.exports = function(object, el) {
                var O = toIObject(object), keys = getKeys(O), length = keys.length, index = 0, key;
                while(length > index)if (O[key = keys[index++]] === el) return key;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_library.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_library.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = true;
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_meta.js": /*!*******************************************************!*\
  !*** ./node_modules/core-js/library/modules/_meta.js ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var META = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/library/modules/_uid.js")('meta'), isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/library/modules/_is-object.js"), has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js"), setDesc = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js").f, id = 0;
            var isExtensible = Object.isExtensible || function() {
                return true;
            };
            var FREEZE = !__webpack_require__(/*! ./_fails */ "./node_modules/core-js/library/modules/_fails.js")(function() {
                return isExtensible(Object.preventExtensions({}));
            });
            var setMeta = function(it) {
                setDesc(it, META, {
                    value: {
                        i: 'O' + ++id,
                        w: {} // weak collections IDs
                    }
                });
            };
            var fastKey = function(it, create) {
                // return primitive with prefix
                if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
                if (!has(it, META)) {
                    // can't set metadata to uncaught frozen object
                    if (!isExtensible(it)) return 'F';
                    // not necessary to add metadata
                    if (!create) return 'E';
                    // add missing metadata
                    setMeta(it);
                // return object ID
                }
                return it[META].i;
            };
            var getWeak = function(it, create) {
                if (!has(it, META)) {
                    // can't set metadata to uncaught frozen object
                    if (!isExtensible(it)) return true;
                    // not necessary to add metadata
                    if (!create) return false;
                    // add missing metadata
                    setMeta(it);
                // return hash weak collections IDs
                }
                return it[META].w;
            };
            // add metadata on freeze-family methods calling
            var onFreeze = function(it) {
                if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
                return it;
            };
            var meta = module1.exports = {
                KEY: META,
                NEED: false,
                fastKey: fastKey,
                getWeak: getWeak,
                onFreeze: onFreeze
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-assign.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-assign.js ***!
  \****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // 19.1.2.1 Object.assign(target, source, ...)
            var getKeys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/library/modules/_object-keys.js"), gOPS = __webpack_require__(/*! ./_object-gops */ "./node_modules/core-js/library/modules/_object-gops.js"), pIE = __webpack_require__(/*! ./_object-pie */ "./node_modules/core-js/library/modules/_object-pie.js"), toObject = __webpack_require__(/*! ./_to-object */ "./node_modules/core-js/library/modules/_to-object.js"), IObject = __webpack_require__(/*! ./_iobject */ "./node_modules/core-js/library/modules/_iobject.js"), $assign = Object.assign;
            // should work with symbols and should have deterministic property order (V8 bug)
            module1.exports = !$assign || __webpack_require__(/*! ./_fails */ "./node_modules/core-js/library/modules/_fails.js")(function() {
                var A = {}, B = {}, S = Symbol(), K = 'abcdefghijklmnopqrst';
                A[S] = 7;
                K.split('').forEach(function(k) {
                    B[k] = k;
                });
                return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
            }) ? function assign(target, source) {
                var T = toObject(target), aLen = arguments.length, index = 1, getSymbols = gOPS.f, isEnum = pIE.f;
                while(aLen > index){
                    var S = IObject(arguments[index++]), keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S), length = keys.length, j = 0, key;
                    while(length > j)if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
                }
                return T;
            } : $assign;
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-create.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-create.js ***!
  \****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
            var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js"), dPs = __webpack_require__(/*! ./_object-dps */ "./node_modules/core-js/library/modules/_object-dps.js"), enumBugKeys = __webpack_require__(/*! ./_enum-bug-keys */ "./node_modules/core-js/library/modules/_enum-bug-keys.js"), IE_PROTO = __webpack_require__(/*! ./_shared-key */ "./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO'), Empty = function() {}, PROTOTYPE = 'prototype';
            // Create object with fake `null` prototype: use iframe Object with cleared prototype
            var createDict = function() {
                // Thrash, waste and sodomy: IE GC bug
                var iframe = __webpack_require__(/*! ./_dom-create */ "./node_modules/core-js/library/modules/_dom-create.js")('iframe'), i = enumBugKeys.length, lt = '<', gt = '>', iframeDocument;
                iframe.style.display = 'none';
                __webpack_require__(/*! ./_html */ "./node_modules/core-js/library/modules/_html.js").appendChild(iframe);
                iframe.src = 'javascript:'; // eslint-disable-line no-script-url
                // createDict = iframe.contentWindow.Object;
                // html.removeChild(iframe);
                iframeDocument = iframe.contentWindow.document;
                iframeDocument.open();
                iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
                iframeDocument.close();
                createDict = iframeDocument.F;
                while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
                return createDict();
            };
            module1.exports = Object.create || function create(O, Properties) {
                var result;
                if (O !== null) {
                    Empty[PROTOTYPE] = anObject(O);
                    result = new Empty;
                    Empty[PROTOTYPE] = null;
                    // add "__proto__" for Object.getPrototypeOf polyfill
                    result[IE_PROTO] = O;
                } else result = createDict();
                return Properties === undefined ? result : dPs(result, Properties);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-dp.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-dp.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js"), IE8_DOM_DEFINE = __webpack_require__(/*! ./_ie8-dom-define */ "./node_modules/core-js/library/modules/_ie8-dom-define.js"), toPrimitive = __webpack_require__(/*! ./_to-primitive */ "./node_modules/core-js/library/modules/_to-primitive.js"), dP = Object.defineProperty;
            exports.f = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
                anObject(O);
                P = toPrimitive(P, true);
                anObject(Attributes);
                if (IE8_DOM_DEFINE) try {
                    return dP(O, P, Attributes);
                } catch (e) {}
                if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
                if ('value' in Attributes) O[P] = Attributes.value;
                return O;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-dps.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-dps.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var dP = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js"), anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js"), getKeys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/library/modules/_object-keys.js");
            module1.exports = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
                anObject(O);
                var keys = getKeys(Properties), length = keys.length, i = 0, P;
                while(length > i)dP.f(O, P = keys[i++], Properties[P]);
                return O;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-gopd.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-gopd.js ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var pIE = __webpack_require__(/*! ./_object-pie */ "./node_modules/core-js/library/modules/_object-pie.js"), createDesc = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/library/modules/_property-desc.js"), toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js"), toPrimitive = __webpack_require__(/*! ./_to-primitive */ "./node_modules/core-js/library/modules/_to-primitive.js"), has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js"), IE8_DOM_DEFINE = __webpack_require__(/*! ./_ie8-dom-define */ "./node_modules/core-js/library/modules/_ie8-dom-define.js"), gOPD = Object.getOwnPropertyDescriptor;
            exports.f = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
                O = toIObject(O);
                P = toPrimitive(P, true);
                if (IE8_DOM_DEFINE) try {
                    return gOPD(O, P);
                } catch (e) {}
                if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-gopn-ext.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-gopn-ext.js ***!
  \******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
            var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js"), gOPN = __webpack_require__(/*! ./_object-gopn */ "./node_modules/core-js/library/modules/_object-gopn.js").f, toString = {}.toString;
            var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
            var getWindowNames = function(it) {
                try {
                    return gOPN(it);
                } catch (e) {
                    return windowNames.slice();
                }
            };
            module1.exports.f = function getOwnPropertyNames(it) {
                return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-gopn.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-gopn.js ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
            var $keys = __webpack_require__(/*! ./_object-keys-internal */ "./node_modules/core-js/library/modules/_object-keys-internal.js"), hiddenKeys = __webpack_require__(/*! ./_enum-bug-keys */ "./node_modules/core-js/library/modules/_enum-bug-keys.js").concat('length', 'prototype');
            exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                return $keys(O, hiddenKeys);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-gops.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-gops.js ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            exports.f = Object.getOwnPropertySymbols;
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-gpo.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-gpo.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
            var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js"), toObject = __webpack_require__(/*! ./_to-object */ "./node_modules/core-js/library/modules/_to-object.js"), IE_PROTO = __webpack_require__(/*! ./_shared-key */ "./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO'), ObjectProto = Object.prototype;
            module1.exports = Object.getPrototypeOf || function(O) {
                O = toObject(O);
                if (has(O, IE_PROTO)) return O[IE_PROTO];
                if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
                return O instanceof Object ? ObjectProto : null;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-keys-internal.js": /*!***********************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-keys-internal.js ***!
  \***********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js"), toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js"), arrayIndexOf = __webpack_require__(/*! ./_array-includes */ "./node_modules/core-js/library/modules/_array-includes.js")(false), IE_PROTO = __webpack_require__(/*! ./_shared-key */ "./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
            module1.exports = function(object, names) {
                var O = toIObject(object), i = 0, result = [], key;
                for(key in O)if (key != IE_PROTO) has(O, key) && result.push(key);
                // Don't enum bug & hidden keys
                while(names.length > i)if (has(O, key = names[i++])) ~arrayIndexOf(result, key) || result.push(key);
                return result;
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-keys.js": /*!**************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-keys.js ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 19.1.2.14 / 15.2.3.14 Object.keys(O)
            var $keys = __webpack_require__(/*! ./_object-keys-internal */ "./node_modules/core-js/library/modules/_object-keys-internal.js"), enumBugKeys = __webpack_require__(/*! ./_enum-bug-keys */ "./node_modules/core-js/library/modules/_enum-bug-keys.js");
            module1.exports = Object.keys || function keys(O) {
                return $keys(O, enumBugKeys);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-pie.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-pie.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            exports.f = ({}).propertyIsEnumerable;
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_object-sap.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_object-sap.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // most Object methods by ES6 should accept primitives
            var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js"), core = __webpack_require__(/*! ./_core */ "./node_modules/core-js/library/modules/_core.js"), fails = __webpack_require__(/*! ./_fails */ "./node_modules/core-js/library/modules/_fails.js");
            module1.exports = function(KEY, exec) {
                var fn = (core.Object || {})[KEY] || Object[KEY], exp = {};
                exp[KEY] = exec(fn);
                $export($export.S + $export.F * fails(function() {
                    fn(1);
                }), 'Object', exp);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_property-desc.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_property-desc.js ***!
  \****************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = function(bitmap, value) {
                return {
                    enumerable: !(bitmap & 1),
                    configurable: !(bitmap & 2),
                    writable: !(bitmap & 4),
                    value: value
                };
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_redefine.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_redefine.js ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js");
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_set-proto.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_set-proto.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // Works with __proto__ only. Old v8 can't work with null proto objects.
            /* eslint-disable no-proto */ var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/library/modules/_is-object.js"), anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js");
            var check = function(O, proto) {
                anObject(O);
                if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
            };
            module1.exports = {
                set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
                    try {
                        set = __webpack_require__(/*! ./_ctx */ "./node_modules/core-js/library/modules/_ctx.js")(Function.call, __webpack_require__(/*! ./_object-gopd */ "./node_modules/core-js/library/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
                        set(test, []);
                        buggy = !(test instanceof Array);
                    } catch (e) {
                        buggy = true;
                    }
                    return function setPrototypeOf(O, proto) {
                        check(O, proto);
                        if (buggy) O.__proto__ = proto;
                        else set(O, proto);
                        return O;
                    };
                }({}, false) : undefined),
                check: check
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_set-to-string-tag.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_set-to-string-tag.js ***!
  \********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var def = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js").f, has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js"), TAG = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('toStringTag');
            module1.exports = function(it, tag, stat) {
                if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
                    configurable: true,
                    value: tag
                });
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_shared-key.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_shared-key.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var shared = __webpack_require__(/*! ./_shared */ "./node_modules/core-js/library/modules/_shared.js")('keys'), uid = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/library/modules/_uid.js");
            module1.exports = function(key) {
                return shared[key] || (shared[key] = uid(key));
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_shared.js": /*!*********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_shared.js ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js"), SHARED = '__core-js_shared__', store = global[SHARED] || (global[SHARED] = {});
            module1.exports = function(key) {
                return store[key] || (store[key] = {});
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_string-at.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_string-at.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var toInteger = __webpack_require__(/*! ./_to-integer */ "./node_modules/core-js/library/modules/_to-integer.js"), defined = __webpack_require__(/*! ./_defined */ "./node_modules/core-js/library/modules/_defined.js");
            // true  -> String#at
            // false -> String#codePointAt
            module1.exports = function(TO_STRING) {
                return function(that, pos) {
                    var s = String(defined(that)), i = toInteger(pos), l = s.length, a, b;
                    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
                    a = s.charCodeAt(i);
                    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
                };
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_to-index.js": /*!***********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_to-index.js ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var toInteger = __webpack_require__(/*! ./_to-integer */ "./node_modules/core-js/library/modules/_to-integer.js"), max = Math.max, min = Math.min;
            module1.exports = function(index, length) {
                index = toInteger(index);
                return index < 0 ? max(index + length, 0) : min(index, length);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_to-integer.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_to-integer.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            // 7.1.4 ToInteger
            var ceil = Math.ceil, floor = Math.floor;
            module1.exports = function(it) {
                return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_to-iobject.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_to-iobject.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // to indexed object, toObject with fallback for non-array-like ES3 strings
            var IObject = __webpack_require__(/*! ./_iobject */ "./node_modules/core-js/library/modules/_iobject.js"), defined = __webpack_require__(/*! ./_defined */ "./node_modules/core-js/library/modules/_defined.js");
            module1.exports = function(it) {
                return IObject(defined(it));
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_to-length.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_to-length.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 7.1.15 ToLength
            var toInteger = __webpack_require__(/*! ./_to-integer */ "./node_modules/core-js/library/modules/_to-integer.js"), min = Math.min;
            module1.exports = function(it) {
                return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_to-object.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_to-object.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 7.1.13 ToObject(argument)
            var defined = __webpack_require__(/*! ./_defined */ "./node_modules/core-js/library/modules/_defined.js");
            module1.exports = function(it) {
                return Object(defined(it));
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_to-primitive.js": /*!***************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_to-primitive.js ***!
  \***************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 7.1.1 ToPrimitive(input [, PreferredType])
            var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/library/modules/_is-object.js");
            // instead of the ES6 spec version, we didn't implement @@toPrimitive case
            // and the second argument - flag - preferred type is a string
            module1.exports = function(it, S) {
                if (!isObject(it)) return it;
                var fn, val;
                if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
                if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                throw TypeError("Can't convert object to primitive value");
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_uid.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/library/modules/_uid.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var id = 0, px = Math.random();
            module1.exports = function(key) {
                return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_wks-define.js": /*!*************************************************************!*\
  !*** ./node_modules/core-js/library/modules/_wks-define.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js"), core = __webpack_require__(/*! ./_core */ "./node_modules/core-js/library/modules/_core.js"), LIBRARY = __webpack_require__(/*! ./_library */ "./node_modules/core-js/library/modules/_library.js"), wksExt = __webpack_require__(/*! ./_wks-ext */ "./node_modules/core-js/library/modules/_wks-ext.js"), defineProperty = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js").f;
            module1.exports = function(name) {
                var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
                if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
                    value: wksExt.f(name)
                });
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_wks-ext.js": /*!**********************************************************!*\
  !*** ./node_modules/core-js/library/modules/_wks-ext.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports.f = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js");
        /***/ },
        /***/ "./node_modules/core-js/library/modules/_wks.js": /*!******************************************************!*\
  !*** ./node_modules/core-js/library/modules/_wks.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var store = __webpack_require__(/*! ./_shared */ "./node_modules/core-js/library/modules/_shared.js")('wks'), uid = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/library/modules/_uid.js"), Symbol1 = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js").Symbol, USE_SYMBOL = typeof Symbol1 == 'function';
            var $exports = module1.exports = function(name) {
                return store[name] || (store[name] = USE_SYMBOL && Symbol1[name] || (USE_SYMBOL ? Symbol1 : uid)('Symbol.' + name));
            };
            $exports.store = store;
        /***/ },
        /***/ "./node_modules/core-js/library/modules/core.get-iterator-method.js": /*!**************************************************************************!*\
  !*** ./node_modules/core-js/library/modules/core.get-iterator-method.js ***!
  \**************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var classof = __webpack_require__(/*! ./_classof */ "./node_modules/core-js/library/modules/_classof.js"), ITERATOR = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('iterator'), Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/library/modules/_iterators.js");
            module1.exports = __webpack_require__(/*! ./_core */ "./node_modules/core-js/library/modules/_core.js").getIteratorMethod = function(it) {
                if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/core.get-iterator.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/library/modules/core.get-iterator.js ***!
  \*******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js"), get = __webpack_require__(/*! ./core.get-iterator-method */ "./node_modules/core-js/library/modules/core.get-iterator-method.js");
            module1.exports = __webpack_require__(/*! ./_core */ "./node_modules/core-js/library/modules/_core.js").getIterator = function(it) {
                var iterFn = get(it);
                if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
                return anObject(iterFn.call(it));
            };
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es6.array.from.js": /*!****************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es6.array.from.js ***!
  \****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var ctx = __webpack_require__(/*! ./_ctx */ "./node_modules/core-js/library/modules/_ctx.js"), $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js"), toObject = __webpack_require__(/*! ./_to-object */ "./node_modules/core-js/library/modules/_to-object.js"), call = __webpack_require__(/*! ./_iter-call */ "./node_modules/core-js/library/modules/_iter-call.js"), isArrayIter = __webpack_require__(/*! ./_is-array-iter */ "./node_modules/core-js/library/modules/_is-array-iter.js"), toLength = __webpack_require__(/*! ./_to-length */ "./node_modules/core-js/library/modules/_to-length.js"), createProperty = __webpack_require__(/*! ./_create-property */ "./node_modules/core-js/library/modules/_create-property.js"), getIterFn = __webpack_require__(/*! ./core.get-iterator-method */ "./node_modules/core-js/library/modules/core.get-iterator-method.js");
            $export($export.S + $export.F * !__webpack_require__(/*! ./_iter-detect */ "./node_modules/core-js/library/modules/_iter-detect.js")(function(iter) {
                Array.from(iter);
            }), 'Array', {
                // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
                from: function from(arrayLike /*, mapfn = undefined, thisArg = undefined*/ ) {
                    var O = toObject(arrayLike), C = typeof this == 'function' ? this : Array, aLen = arguments.length, mapfn = aLen > 1 ? arguments[1] : undefined, mapping = mapfn !== undefined, index = 0, iterFn = getIterFn(O), length, result, step, iterator;
                    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
                    // if object isn't iterable or it's array with default iterator - use simple case
                    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++)createProperty(result, index, mapping ? call(iterator, mapfn, [
                        step.value,
                        index
                    ], true) : step.value);
                    else {
                        length = toLength(O.length);
                        for(result = new C(length); length > index; index++)createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
                    }
                    result.length = index;
                    return result;
                }
            });
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es6.array.iterator.js": /*!********************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es6.array.iterator.js ***!
  \********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var addToUnscopables = __webpack_require__(/*! ./_add-to-unscopables */ "./node_modules/core-js/library/modules/_add-to-unscopables.js"), step = __webpack_require__(/*! ./_iter-step */ "./node_modules/core-js/library/modules/_iter-step.js"), Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/library/modules/_iterators.js"), toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js");
            // 22.1.3.4 Array.prototype.entries()
            // 22.1.3.13 Array.prototype.keys()
            // 22.1.3.29 Array.prototype.values()
            // 22.1.3.30 Array.prototype[@@iterator]()
            module1.exports = __webpack_require__(/*! ./_iter-define */ "./node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function(iterated, kind) {
                this._t = toIObject(iterated); // target
                this._i = 0; // next index
                this._k = kind; // kind
            // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
            }, function() {
                var O = this._t, kind = this._k, index = this._i++;
                if (!O || index >= O.length) {
                    this._t = undefined;
                    return step(1);
                }
                if (kind == 'keys') return step(0, index);
                if (kind == 'values') return step(0, O[index]);
                return step(0, [
                    index,
                    O[index]
                ]);
            }, 'values');
            // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
            Iterators.Arguments = Iterators.Array;
            addToUnscopables('keys');
            addToUnscopables('values');
            addToUnscopables('entries');
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es6.object.assign.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es6.object.assign.js ***!
  \*******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 19.1.3.1 Object.assign(target, source)
            var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
            $export($export.S + $export.F, 'Object', {
                assign: __webpack_require__(/*! ./_object-assign */ "./node_modules/core-js/library/modules/_object-assign.js")
            });
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es6.object.create.js": /*!*******************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es6.object.create.js ***!
  \*******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
            // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
            $export($export.S, 'Object', {
                create: __webpack_require__(/*! ./_object-create */ "./node_modules/core-js/library/modules/_object-create.js")
            });
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es6.object.define-property.js": /*!****************************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es6.object.define-property.js ***!
  \****************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
            // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
            $export($export.S + $export.F * !__webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js"), 'Object', {
                defineProperty: __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js").f
            });
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js": /*!****************************************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js ***!
  \****************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
            var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js"), $getOwnPropertyDescriptor = __webpack_require__(/*! ./_object-gopd */ "./node_modules/core-js/library/modules/_object-gopd.js").f;
            __webpack_require__(/*! ./_object-sap */ "./node_modules/core-js/library/modules/_object-sap.js")('getOwnPropertyDescriptor', function() {
                return function getOwnPropertyDescriptor(it, key) {
                    return $getOwnPropertyDescriptor(toIObject(it), key);
                };
            });
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es6.object.keys.js": /*!*****************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es6.object.keys.js ***!
  \*****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 19.1.2.14 Object.keys(O)
            var toObject = __webpack_require__(/*! ./_to-object */ "./node_modules/core-js/library/modules/_to-object.js"), $keys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/library/modules/_object-keys.js");
            __webpack_require__(/*! ./_object-sap */ "./node_modules/core-js/library/modules/_object-sap.js")('keys', function() {
                return function keys(it) {
                    return $keys(toObject(it));
                };
            });
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es6.object.set-prototype-of.js": /*!*****************************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es6.object.set-prototype-of.js ***!
  \*****************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            // 19.1.3.19 Object.setPrototypeOf(O, proto)
            var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
            $export($export.S, 'Object', {
                setPrototypeOf: __webpack_require__(/*! ./_set-proto */ "./node_modules/core-js/library/modules/_set-proto.js").set
            });
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es6.object.to-string.js": /*!**********************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es6.object.to-string.js ***!
  \**********************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es6.string.iterator.js": /*!*********************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es6.string.iterator.js ***!
  \*********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $at = __webpack_require__(/*! ./_string-at */ "./node_modules/core-js/library/modules/_string-at.js")(true);
            // 21.1.3.27 String.prototype[@@iterator]()
            __webpack_require__(/*! ./_iter-define */ "./node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function(iterated) {
                this._t = String(iterated); // target
                this._i = 0; // next index
            // 21.1.5.2.1 %StringIteratorPrototype%.next()
            }, function() {
                var O = this._t, index = this._i, point;
                if (index >= O.length) return {
                    value: undefined,
                    done: true
                };
                point = $at(O, index);
                this._i += point.length;
                return {
                    value: point,
                    done: false
                };
            });
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es6.symbol.js": /*!************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es6.symbol.js ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // ECMAScript 6 symbols shim
            var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js"), has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js"), DESCRIPTORS = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js"), $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js"), redefine = __webpack_require__(/*! ./_redefine */ "./node_modules/core-js/library/modules/_redefine.js"), META = __webpack_require__(/*! ./_meta */ "./node_modules/core-js/library/modules/_meta.js").KEY, $fails = __webpack_require__(/*! ./_fails */ "./node_modules/core-js/library/modules/_fails.js"), shared = __webpack_require__(/*! ./_shared */ "./node_modules/core-js/library/modules/_shared.js"), setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ "./node_modules/core-js/library/modules/_set-to-string-tag.js"), uid = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/library/modules/_uid.js"), wks = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js"), wksExt = __webpack_require__(/*! ./_wks-ext */ "./node_modules/core-js/library/modules/_wks-ext.js"), wksDefine = __webpack_require__(/*! ./_wks-define */ "./node_modules/core-js/library/modules/_wks-define.js"), keyOf = __webpack_require__(/*! ./_keyof */ "./node_modules/core-js/library/modules/_keyof.js"), enumKeys = __webpack_require__(/*! ./_enum-keys */ "./node_modules/core-js/library/modules/_enum-keys.js"), isArray = __webpack_require__(/*! ./_is-array */ "./node_modules/core-js/library/modules/_is-array.js"), anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js"), toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js"), toPrimitive = __webpack_require__(/*! ./_to-primitive */ "./node_modules/core-js/library/modules/_to-primitive.js"), createDesc = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/library/modules/_property-desc.js"), _create = __webpack_require__(/*! ./_object-create */ "./node_modules/core-js/library/modules/_object-create.js"), gOPNExt = __webpack_require__(/*! ./_object-gopn-ext */ "./node_modules/core-js/library/modules/_object-gopn-ext.js"), $GOPD = __webpack_require__(/*! ./_object-gopd */ "./node_modules/core-js/library/modules/_object-gopd.js"), $DP = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js"), $keys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/library/modules/_object-keys.js"), gOPD = $GOPD.f, dP = $DP.f, gOPN = gOPNExt.f, $Symbol = global.Symbol, $JSON = global.JSON, _stringify = $JSON && $JSON.stringify, PROTOTYPE = 'prototype', HIDDEN = wks('_hidden'), TO_PRIMITIVE = wks('toPrimitive'), isEnum = {}.propertyIsEnumerable, SymbolRegistry = shared('symbol-registry'), AllSymbols = shared('symbols'), OPSymbols = shared('op-symbols'), ObjectProto = Object[PROTOTYPE], USE_NATIVE = typeof $Symbol == 'function', QObject = global.QObject;
            // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
            var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
            // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
            var setSymbolDesc = DESCRIPTORS && $fails(function() {
                return _create(dP({}, 'a', {
                    get: function() {
                        return dP(this, 'a', {
                            value: 7
                        }).a;
                    }
                })).a != 7;
            }) ? function(it, key, D) {
                var protoDesc = gOPD(ObjectProto, key);
                if (protoDesc) delete ObjectProto[key];
                dP(it, key, D);
                if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
            } : dP;
            var wrap = function(tag) {
                var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
                sym._k = tag;
                return sym;
            };
            var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it) {
                return typeof it == 'symbol';
            } : function(it) {
                return it instanceof $Symbol;
            };
            var $defineProperty = function defineProperty(it, key, D) {
                if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
                anObject(it);
                key = toPrimitive(key, true);
                anObject(D);
                if (has(AllSymbols, key)) {
                    if (!D.enumerable) {
                        if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
                        it[HIDDEN][key] = true;
                    } else {
                        if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
                        D = _create(D, {
                            enumerable: createDesc(0, false)
                        });
                    }
                    return setSymbolDesc(it, key, D);
                }
                return dP(it, key, D);
            };
            var $defineProperties = function defineProperties(it, P) {
                anObject(it);
                var keys = enumKeys(P = toIObject(P)), i = 0, l = keys.length, key;
                while(l > i)$defineProperty(it, key = keys[i++], P[key]);
                return it;
            };
            var $create = function create(it, P) {
                return P === undefined ? _create(it) : $defineProperties(_create(it), P);
            };
            var $propertyIsEnumerable = function propertyIsEnumerable(key) {
                var E = isEnum.call(this, key = toPrimitive(key, true));
                if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
                return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
            };
            var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
                it = toIObject(it);
                key = toPrimitive(key, true);
                if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
                var D = gOPD(it, key);
                if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
                return D;
            };
            var $getOwnPropertyNames = function getOwnPropertyNames(it) {
                var names = gOPN(toIObject(it)), result = [], i = 0, key;
                while(names.length > i)if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
                return result;
            };
            var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
                var IS_OP = it === ObjectProto, names = gOPN(IS_OP ? OPSymbols : toIObject(it)), result = [], i = 0, key;
                while(names.length > i)if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
                return result;
            };
            // 19.4.1.1 Symbol([description])
            if (!USE_NATIVE) {
                $Symbol = function Symbol1() {
                    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
                    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
                    var $set = function(value) {
                        if (this === ObjectProto) $set.call(OPSymbols, value);
                        if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                        setSymbolDesc(this, tag, createDesc(1, value));
                    };
                    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
                        configurable: true,
                        set: $set
                    });
                    return wrap(tag);
                };
                redefine($Symbol[PROTOTYPE], 'toString', function toString() {
                    return this._k;
                });
                $GOPD.f = $getOwnPropertyDescriptor;
                $DP.f = $defineProperty;
                __webpack_require__(/*! ./_object-gopn */ "./node_modules/core-js/library/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
                __webpack_require__(/*! ./_object-pie */ "./node_modules/core-js/library/modules/_object-pie.js").f = $propertyIsEnumerable;
                __webpack_require__(/*! ./_object-gops */ "./node_modules/core-js/library/modules/_object-gops.js").f = $getOwnPropertySymbols;
                if (DESCRIPTORS && !__webpack_require__(/*! ./_library */ "./node_modules/core-js/library/modules/_library.js")) redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
                wksExt.f = function(name) {
                    return wrap(wks(name));
                };
            }
            $export($export.G + $export.W + $export.F * !USE_NATIVE, {
                Symbol: $Symbol
            });
            for(var symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
            'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), i = 0; symbols.length > i;)wks(symbols[i++]);
            for(var symbols = $keys(wks.store), i = 0; symbols.length > i;)wksDefine(symbols[i++]);
            $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
                // 19.4.2.1 Symbol.for(key)
                'for': function(key) {
                    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
                },
                // 19.4.2.5 Symbol.keyFor(sym)
                keyFor: function keyFor(key) {
                    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
                    throw TypeError(key + ' is not a symbol!');
                },
                useSetter: function() {
                    setter = true;
                },
                useSimple: function() {
                    setter = false;
                }
            });
            $export($export.S + $export.F * !USE_NATIVE, 'Object', {
                // 19.1.2.2 Object.create(O [, Properties])
                create: $create,
                // 19.1.2.4 Object.defineProperty(O, P, Attributes)
                defineProperty: $defineProperty,
                // 19.1.2.3 Object.defineProperties(O, Properties)
                defineProperties: $defineProperties,
                // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
                getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
                // 19.1.2.7 Object.getOwnPropertyNames(O)
                getOwnPropertyNames: $getOwnPropertyNames,
                // 19.1.2.8 Object.getOwnPropertySymbols(O)
                getOwnPropertySymbols: $getOwnPropertySymbols
            });
            // 24.3.2 JSON.stringify(value [, replacer [, space]])
            $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function() {
                var S = $Symbol();
                // MS Edge converts symbol values to JSON as {}
                // WebKit converts symbol values to JSON as null
                // V8 throws on boxed symbols
                return _stringify([
                    S
                ]) != '[null]' || _stringify({
                    a: S
                }) != '{}' || _stringify(Object(S)) != '{}';
            })), 'JSON', {
                stringify: function stringify(it) {
                    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
                    var args = [
                        it
                    ], i = 1, replacer, $replacer;
                    while(arguments.length > i)args.push(arguments[i++]);
                    replacer = args[1];
                    if (typeof replacer == 'function') $replacer = replacer;
                    if ($replacer || !isArray(replacer)) replacer = function(key, value) {
                        if ($replacer) value = $replacer.call(this, key, value);
                        if (!isSymbol(value)) return value;
                    };
                    args[1] = replacer;
                    return _stringify.apply($JSON, args);
                }
            });
            // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
            $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
            // 19.4.3.5 Symbol.prototype[@@toStringTag]
            setToStringTag($Symbol, 'Symbol');
            // 20.2.1.9 Math[@@toStringTag]
            setToStringTag(Math, 'Math', true);
            // 24.3.3 JSON[@@toStringTag]
            setToStringTag(global.JSON, 'JSON', true);
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es7.symbol.async-iterator.js": /*!***************************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es7.symbol.async-iterator.js ***!
  \***************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ./_wks-define */ "./node_modules/core-js/library/modules/_wks-define.js")('asyncIterator');
        /***/ },
        /***/ "./node_modules/core-js/library/modules/es7.symbol.observable.js": /*!***********************************************************************!*\
  !*** ./node_modules/core-js/library/modules/es7.symbol.observable.js ***!
  \***********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ./_wks-define */ "./node_modules/core-js/library/modules/_wks-define.js")('observable');
        /***/ },
        /***/ "./node_modules/core-js/library/modules/web.dom.iterable.js": /*!******************************************************************!*\
  !*** ./node_modules/core-js/library/modules/web.dom.iterable.js ***!
  \******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(/*! ./es6.array.iterator */ "./node_modules/core-js/library/modules/es6.array.iterator.js");
            var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js"), hide = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js"), Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/library/modules/_iterators.js"), TO_STRING_TAG = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('toStringTag');
            for(var collections = [
                'NodeList',
                'DOMTokenList',
                'MediaList',
                'StyleSheetList',
                'CSSRuleList'
            ], i = 0; i < 5; i++){
                var NAME = collections[i], Collection = global[NAME], proto = Collection && Collection.prototype;
                if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
                Iterators[NAME] = Iterators.Array;
            }
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/components/container/public/style.scss": /*!*****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/components/container/public/style.scss ***!
  \*****************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                ".container[data-container] {\n  position: absolute;\n  background-color: black;\n  height: 100%;\n  width: 100%;\n  max-width: 100%; }\n  .container[data-container] .chromeless {\n    cursor: default; }\n\n[data-player]:not(.nocursor) .container[data-container]:not(.chromeless).pointer-enabled {\n  cursor: pointer; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/components/core/public/style.scss": /*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/components/core/public/style.scss ***!
  \************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                "[data-player] {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n  position: relative;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-style: normal;\n  font-weight: normal;\n  text-align: center;\n  overflow: hidden;\n  font-size: 100%;\n  font-family: \"Roboto\", \"Open Sans\", Arial, sans-serif;\n  text-shadow: 0 0 0;\n  box-sizing: border-box; }\n  [data-player] div, [data-player] span, [data-player] applet, [data-player] object, [data-player] iframe,\n  [data-player] h1, [data-player] h2, [data-player] h3, [data-player] h4, [data-player] h5, [data-player] h6, [data-player] p, [data-player] blockquote, [data-player] pre,\n  [data-player] a, [data-player] abbr, [data-player] acronym, [data-player] address, [data-player] big, [data-player] cite, [data-player] code,\n  [data-player] del, [data-player] dfn, [data-player] em, [data-player] img, [data-player] ins, [data-player] kbd, [data-player] q, [data-player] s, [data-player] samp,\n  [data-player] small, [data-player] strike, [data-player] strong, [data-player] sub, [data-player] sup, [data-player] tt, [data-player] var,\n  [data-player] b, [data-player] u, [data-player] i, [data-player] center,\n  [data-player] dl, [data-player] dt, [data-player] dd, [data-player] ol, [data-player] ul, [data-player] li,\n  [data-player] fieldset, [data-player] form, [data-player] label, [data-player] legend,\n  [data-player] table, [data-player] caption, [data-player] tbody, [data-player] tfoot, [data-player] thead, [data-player] tr, [data-player] th, [data-player] td,\n  [data-player] article, [data-player] aside, [data-player] canvas, [data-player] details, [data-player] embed,\n  [data-player] figure, [data-player] figcaption, [data-player] footer, [data-player] header, [data-player] hgroup,\n  [data-player] menu, [data-player] nav, [data-player] output, [data-player] ruby, [data-player] section, [data-player] summary,\n  [data-player] time, [data-player] mark, [data-player] audio, [data-player] video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font: inherit;\n    font-size: 100%;\n    vertical-align: baseline; }\n  [data-player] table {\n    border-collapse: collapse;\n    border-spacing: 0; }\n  [data-player] caption, [data-player] th, [data-player] td {\n    text-align: left;\n    font-weight: normal;\n    vertical-align: middle; }\n  [data-player] q, [data-player] blockquote {\n    quotes: none; }\n    [data-player] q:before, [data-player] q:after, [data-player] blockquote:before, [data-player] blockquote:after {\n      content: \"\";\n      content: none; }\n  [data-player] a img {\n    border: none; }\n  [data-player]:focus {\n    outline: 0; }\n  [data-player] * {\n    max-width: none;\n    box-sizing: inherit;\n    float: none; }\n  [data-player] div {\n    display: block; }\n  [data-player].fullscreen {\n    width: 100% !important;\n    height: 100% !important;\n    top: 0;\n    left: 0; }\n  [data-player].nocursor {\n    cursor: none; }\n\n.clappr-style {\n  display: none !important; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/playbacks/base_flash_playback/public/flash.scss": /*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/playbacks/base_flash_playback/public/flash.scss ***!
  \**************************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                ".clappr-flash-playback[data-flash-playback] {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  pointer-events: none; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/playbacks/html5_video/public/style.scss": /*!******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/playbacks/html5_video/public/style.scss ***!
  \******************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                "[data-html5-video] {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  display: block; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/playbacks/html_img/public/style.scss": /*!***************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/playbacks/html_img/public/style.scss ***!
  \***************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                "[data-html-img] {\n  max-width: 100%;\n  max-height: 100%; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/playbacks/no_op/public/style.scss": /*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/playbacks/no_op/public/style.scss ***!
  \************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                "[data-no-op] {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  text-align: center; }\n\n[data-no-op] p[data-no-op-msg] {\n  position: absolute;\n  text-align: center;\n  font-size: 25px;\n  left: 0;\n  right: 0;\n  color: white;\n  padding: 10px;\n  /* center vertically */\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  max-height: 100%;\n  overflow: auto; }\n\n[data-no-op] canvas[data-no-op-canvas] {\n  background-color: #777;\n  height: 100%;\n  width: 100%; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/closed_captions/public/closed_captions.scss": /*!******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/closed_captions/public/closed_captions.scss ***!
  \******************************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                ".cc-controls[data-cc-controls] {\n  float: right;\n  position: relative;\n  display: none; }\n  .cc-controls[data-cc-controls].available {\n    display: block; }\n  .cc-controls[data-cc-controls] .cc-button {\n    padding: 6px !important; }\n    .cc-controls[data-cc-controls] .cc-button.enabled {\n      display: block;\n      opacity: 1.0; }\n      .cc-controls[data-cc-controls] .cc-button.enabled:hover {\n        opacity: 1.0;\n        text-shadow: none; }\n  .cc-controls[data-cc-controls] > ul {\n    list-style-type: none;\n    position: absolute;\n    bottom: 25px;\n    border: 1px solid black;\n    display: none;\n    background-color: #e6e6e6; }\n  .cc-controls[data-cc-controls] li {\n    font-size: 10px; }\n    .cc-controls[data-cc-controls] li[data-title] {\n      background-color: #c3c2c2;\n      padding: 5px; }\n    .cc-controls[data-cc-controls] li a {\n      color: #444;\n      padding: 2px 10px;\n      display: block;\n      text-decoration: none; }\n      .cc-controls[data-cc-controls] li a:hover {\n        background-color: #555;\n        color: white; }\n        .cc-controls[data-cc-controls] li a:hover a {\n          color: white;\n          text-decoration: none; }\n    .cc-controls[data-cc-controls] li.current a {\n      color: #f00; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/dvr_controls/public/dvr_controls.scss": /*!************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/dvr_controls/public/dvr_controls.scss ***!
  \************************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                ".dvr-controls[data-dvr-controls] {\n  display: inline-block;\n  float: left;\n  color: #fff;\n  line-height: 32px;\n  font-size: 10px;\n  font-weight: bold;\n  margin-left: 6px; }\n  .dvr-controls[data-dvr-controls] .live-info {\n    cursor: default;\n    font-family: \"Roboto\", \"Open Sans\", Arial, sans-serif;\n    text-transform: uppercase; }\n    .dvr-controls[data-dvr-controls] .live-info:before {\n      content: \"\";\n      display: inline-block;\n      position: relative;\n      width: 7px;\n      height: 7px;\n      border-radius: 3.5px;\n      margin-right: 3.5px;\n      background-color: #ff0101; }\n    .dvr-controls[data-dvr-controls] .live-info.disabled {\n      opacity: 0.3; }\n      .dvr-controls[data-dvr-controls] .live-info.disabled:before {\n        background-color: #fff; }\n  .dvr-controls[data-dvr-controls] .live-button {\n    cursor: pointer;\n    outline: none;\n    display: none;\n    border: 0;\n    color: #fff;\n    background-color: transparent;\n    height: 32px;\n    padding: 0;\n    opacity: 0.7;\n    font-family: \"Roboto\", \"Open Sans\", Arial, sans-serif;\n    text-transform: uppercase;\n    transition: all 0.1s ease; }\n    .dvr-controls[data-dvr-controls] .live-button:before {\n      content: \"\";\n      display: inline-block;\n      position: relative;\n      width: 7px;\n      height: 7px;\n      border-radius: 3.5px;\n      margin-right: 3.5px;\n      background-color: #fff; }\n    .dvr-controls[data-dvr-controls] .live-button:hover {\n      opacity: 1;\n      text-shadow: rgba(255, 255, 255, 0.75) 0 0 5px; }\n\n.dvr .dvr-controls[data-dvr-controls] .live-info {\n  display: none; }\n\n.dvr .dvr-controls[data-dvr-controls] .live-button {\n  display: block; }\n\n.dvr.media-control.live[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n  background-color: #005aff; }\n\n.media-control.live[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n  background-color: #ff0101; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/error_screen/public/error_screen.scss": /*!************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/error_screen/public/error_screen.scss ***!
  \************************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                "div.player-error-screen {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #CCCACA;\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 2000;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n  div.player-error-screen__content[data-error-screen] {\n    font-size: 14px;\n    color: #CCCACA;\n    margin-top: 45px; }\n  div.player-error-screen__title[data-error-screen] {\n    font-weight: bold;\n    line-height: 30px;\n    font-size: 18px; }\n  div.player-error-screen__message[data-error-screen] {\n    width: 90%;\n    margin: 0 auto; }\n  div.player-error-screen__code[data-error-screen] {\n    font-size: 13px;\n    margin-top: 15px; }\n  div.player-error-screen__reload {\n    cursor: pointer;\n    width: 30px;\n    margin: 15px auto 0; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/media_control/public/media-control.scss": /*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/media_control/public/media-control.scss ***!
  \**************************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var escape = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/url/escape.js */ "./node_modules/css-loader/lib/url/escape.js");
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                ".media-control-notransition {\n  transition: none !important; }\n\n.media-control[data-media-control] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  pointer-events: none; }\n  .media-control[data-media-control].dragging {\n    pointer-events: auto;\n    cursor: -webkit-grabbing !important;\n    cursor: grabbing !important;\n    cursor: url(" + escape(__webpack_require__(/*! ./closed-hand.cur */ "./src/plugins/media_control/public/closed-hand.cur")) + "), move; }\n    .media-control[data-media-control].dragging * {\n      cursor: -webkit-grabbing !important;\n      cursor: grabbing !important;\n      cursor: url(" + escape(__webpack_require__(/*! ./closed-hand.cur */ "./src/plugins/media_control/public/closed-hand.cur")) + "), move; }\n  .media-control[data-media-control] .media-control-background[data-background] {\n    position: absolute;\n    height: 40%;\n    width: 100%;\n    bottom: 0;\n    background: linear-gradient(transparent, rgba(0, 0, 0, 0.9));\n    transition: opacity 0.6s ease-out; }\n  .media-control[data-media-control] .media-control-icon {\n    line-height: 0;\n    letter-spacing: 0;\n    speak: none;\n    color: #fff;\n    opacity: 0.5;\n    vertical-align: middle;\n    text-align: left;\n    transition: all 0.1s ease; }\n  .media-control[data-media-control] .media-control-icon:hover {\n    color: white;\n    opacity: 0.75;\n    text-shadow: rgba(255, 255, 255, 0.8) 0 0 5px; }\n  .media-control[data-media-control].media-control-hide .media-control-background[data-background] {\n    opacity: 0; }\n  .media-control[data-media-control].media-control-hide .media-control-layer[data-controls] {\n    bottom: -50px; }\n    .media-control[data-media-control].media-control-hide .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-scrubber[data-seekbar] {\n      opacity: 0; }\n  .media-control[data-media-control] .media-control-layer[data-controls] {\n    position: absolute;\n    bottom: 7px;\n    width: 100%;\n    height: 32px;\n    font-size: 0;\n    vertical-align: middle;\n    pointer-events: auto;\n    transition: bottom 0.4s ease-out; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .media-control-left-panel[data-media-control] {\n      position: absolute;\n      top: 0;\n      left: 4px;\n      height: 100%; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .media-control-center-panel[data-media-control] {\n      height: 100%;\n      text-align: center;\n      line-height: 32px; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .media-control-right-panel[data-media-control] {\n      position: absolute;\n      top: 0;\n      right: 4px;\n      height: 100%; }\n    .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button {\n      background-color: transparent;\n      border: 0;\n      margin: 0 6px;\n      padding: 0;\n      cursor: pointer;\n      display: inline-block;\n      width: 32px;\n      height: 100%; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button svg {\n        width: 100%;\n        height: 22px; }\n        .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button svg path {\n          fill: white; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button:focus {\n        outline: none; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-play] {\n        float: left;\n        height: 100%; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-pause] {\n        float: left;\n        height: 100%; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-stop] {\n        float: left;\n        height: 100%; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-fullscreen] {\n        float: right;\n        background-color: transparent;\n        border: 0;\n        height: 100%; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-hd-indicator] {\n        background-color: transparent;\n        border: 0;\n        cursor: default;\n        display: none;\n        float: right;\n        height: 100%; }\n        .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-hd-indicator].enabled {\n          display: block;\n          opacity: 1.0; }\n          .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-hd-indicator].enabled:hover {\n            opacity: 1.0;\n            text-shadow: none; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-playpause] {\n        float: left; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-playstop] {\n        float: left; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-position], .media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-duration] {\n      display: inline-block;\n      font-size: 10px;\n      color: white;\n      cursor: default;\n      line-height: 32px;\n      position: relative; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-position] {\n      margin: 0 6px 0 7px; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-duration] {\n      color: rgba(255, 255, 255, 0.5);\n      margin-right: 6px; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-duration]:before {\n        content: \"|\";\n        margin-right: 7px; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] {\n      position: absolute;\n      top: -20px;\n      left: 0;\n      display: inline-block;\n      vertical-align: middle;\n      width: 100%;\n      height: 25px;\n      cursor: pointer; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] {\n        width: 100%;\n        height: 1px;\n        position: relative;\n        top: 12px;\n        background-color: #666666; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-1[data-seekbar] {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 0;\n          height: 100%;\n          background-color: #c2c2c2;\n          transition: all 0.1s ease-out; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 0;\n          height: 100%;\n          background-color: #005aff;\n          transition: all 0.1s ease-out; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n          opacity: 0;\n          position: absolute;\n          top: -3px;\n          width: 5px;\n          height: 7px;\n          background-color: rgba(255, 255, 255, 0.5);\n          transition: opacity 0.1s ease; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar]:hover .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n        opacity: 1; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar].seek-disabled {\n        cursor: default; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar].seek-disabled:hover .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n          opacity: 0; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-scrubber[data-seekbar] {\n        position: absolute;\n        -webkit-transform: translateX(-50%);\n                transform: translateX(-50%);\n        top: 2px;\n        left: 0;\n        width: 20px;\n        height: 20px;\n        opacity: 1;\n        transition: all 0.1s ease-out; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-seekbar] {\n          position: absolute;\n          left: 6px;\n          top: 6px;\n          width: 8px;\n          height: 8px;\n          border-radius: 10px;\n          box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.2);\n          background-color: white; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] {\n      float: right;\n      display: inline-block;\n      height: 32px;\n      cursor: pointer;\n      margin: 0 6px;\n      box-sizing: border-box; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] {\n        float: left;\n        bottom: 0; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume] {\n          background-color: transparent;\n          border: 0;\n          box-sizing: content-box;\n          width: 32px;\n          height: 32px;\n          opacity: 0.5; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume]:hover {\n            opacity: 0.75; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume] svg {\n            height: 24px;\n            position: relative;\n            top: 3px; }\n            .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume] svg path {\n              fill: white; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume].muted svg {\n            margin-left: 2px; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] {\n        float: left;\n        position: relative;\n        overflow: hidden;\n        top: 6px;\n        width: 42px;\n        height: 18px;\n        padding: 3px 0;\n        transition: width .2s ease-out; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-background[data-volume] {\n          height: 1px;\n          position: relative;\n          top: 7px;\n          margin: 0 3px;\n          background-color: #666666; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-background[data-volume] .bar-fill-1[data-volume] {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 0;\n            height: 100%;\n            background-color: #c2c2c2;\n            transition: all 0.1s ease-out; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-background[data-volume] .bar-fill-2[data-volume] {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 0;\n            height: 100%;\n            background-color: #005aff;\n            transition: all 0.1s ease-out; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-background[data-volume] .bar-hover[data-volume] {\n            opacity: 0;\n            position: absolute;\n            top: -3px;\n            width: 5px;\n            height: 7px;\n            background-color: rgba(255, 255, 255, 0.5);\n            transition: opacity 0.1s ease; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-scrubber[data-volume] {\n          position: absolute;\n          -webkit-transform: translateX(-50%);\n                  transform: translateX(-50%);\n          top: 0px;\n          left: 0;\n          width: 20px;\n          height: 20px;\n          opacity: 1;\n          transition: all 0.1s ease-out; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-scrubber[data-volume] .bar-scrubber-icon[data-volume] {\n            position: absolute;\n            left: 6px;\n            top: 6px;\n            width: 8px;\n            height: 8px;\n            border-radius: 10px;\n            box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.2);\n            background-color: white; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .segmented-bar-element[data-volume] {\n          float: left;\n          width: 4px;\n          padding-left: 2px;\n          height: 12px;\n          opacity: 0.5;\n          box-shadow: inset 2px 0 0 white;\n          transition: -webkit-transform .2s ease-out;\n          transition: transform .2s ease-out;\n          transition: transform .2s ease-out, -webkit-transform .2s ease-out; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .segmented-bar-element[data-volume].fill {\n            box-shadow: inset 2px 0 0 #fff;\n            opacity: 1; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .segmented-bar-element[data-volume]:nth-of-type(1) {\n            padding-left: 0; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .segmented-bar-element[data-volume]:hover {\n            -webkit-transform: scaleY(1.5);\n                    transform: scaleY(1.5); }\n  .media-control[data-media-control].w320 .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume].volume-bar-hide {\n    width: 0;\n    height: 12px;\n    top: 9px;\n    padding: 0; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/poster/public/poster.scss": /*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/poster/public/poster.scss ***!
  \************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                ".player-poster[data-poster] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 998;\n  top: 0;\n  left: 0;\n  background-color: #000;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%; }\n  .player-poster[data-poster].clickable {\n    cursor: pointer; }\n  .player-poster[data-poster]:hover .play-wrapper[data-poster] {\n    opacity: 1; }\n  .player-poster[data-poster] .play-wrapper[data-poster] {\n    width: 100%;\n    height: 25%;\n    margin: 0 auto;\n    opacity: 0.75;\n    transition: opacity 0.1s ease; }\n    .player-poster[data-poster] .play-wrapper[data-poster] svg {\n      height: 100%; }\n      .player-poster[data-poster] .play-wrapper[data-poster] svg path {\n        fill: #fff; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/seek_time/public/seek_time.scss": /*!******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/seek_time/public/seek_time.scss ***!
  \******************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                ".seek-time[data-seek-time] {\n  position: absolute;\n  white-space: nowrap;\n  height: 20px;\n  line-height: 20px;\n  font-size: 0;\n  left: -100%;\n  bottom: 55px;\n  background-color: rgba(2, 2, 2, 0.5);\n  z-index: 9999;\n  transition: opacity 0.1s ease; }\n  .seek-time[data-seek-time].hidden[data-seek-time] {\n    opacity: 0; }\n  .seek-time[data-seek-time] [data-seek-time] {\n    display: inline-block;\n    color: white;\n    font-size: 10px;\n    padding-left: 7px;\n    padding-right: 7px;\n    vertical-align: top; }\n  .seek-time[data-seek-time] [data-duration] {\n    display: inline-block;\n    color: rgba(255, 255, 255, 0.5);\n    font-size: 10px;\n    padding-right: 7px;\n    vertical-align: top; }\n    .seek-time[data-seek-time] [data-duration]:before {\n      content: \"|\";\n      margin-right: 7px; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/spinner_three_bounce/public/spinner.scss": /*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/spinner_three_bounce/public/spinner.scss ***!
  \***************************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                ".spinner-three-bounce[data-spinner] {\n  position: absolute;\n  margin: 0 auto;\n  width: 70px;\n  text-align: center;\n  z-index: 999;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  /* center vertically */\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%); }\n  .spinner-three-bounce[data-spinner] > div {\n    width: 18px;\n    height: 18px;\n    background-color: #FFFFFF;\n    border-radius: 100%;\n    display: inline-block;\n    -webkit-animation: bouncedelay 1.4s infinite ease-in-out;\n            animation: bouncedelay 1.4s infinite ease-in-out;\n    /* Prevent first frame from flickering when animation starts */\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both; }\n  .spinner-three-bounce[data-spinner] [data-bounce1] {\n    -webkit-animation-delay: -0.32s;\n            animation-delay: -0.32s; }\n  .spinner-three-bounce[data-spinner] [data-bounce2] {\n    -webkit-animation-delay: -0.16s;\n            animation-delay: -0.16s; }\n\n@-webkit-keyframes bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  40% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@keyframes bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  40% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/watermark/public/watermark.scss": /*!******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/watermark/public/watermark.scss ***!
  \******************************************************************************************************************************************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                ".clappr-watermark[data-watermark] {\n  position: absolute;\n  min-width: 70px;\n  max-width: 200px;\n  width: 12%;\n  text-align: center;\n  z-index: 10; }\n\n.clappr-watermark[data-watermark] a {\n  outline: none;\n  cursor: pointer; }\n\n.clappr-watermark[data-watermark] img {\n  max-width: 100%; }\n\n.clappr-watermark[data-watermark-bottom-left] {\n  bottom: 10px;\n  left: 10px; }\n\n.clappr-watermark[data-watermark-bottom-right] {\n  bottom: 10px;\n  right: 42px; }\n\n.clappr-watermark[data-watermark-top-left] {\n  top: 10px;\n  left: 10px; }\n\n.clappr-watermark[data-watermark-top-right] {\n  top: 10px;\n  right: 37px; }\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./node_modules/css-loader/lib/css-base.js": /*!*************************************************!*\
  !*** ./node_modules/css-loader/lib/css-base.js ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            /*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ // css base code, injected by the css-loader
            module1.exports = function(useSourceMap) {
                var list = [];
                // return the list of modules as css string
                list.toString = function toString() {
                    return this.map(function(item) {
                        var content = cssWithMappingToString(item, useSourceMap);
                        if (item[2]) return "@media " + item[2] + "{" + content + "}";
                        else return content;
                    }).join("");
                };
                // import a list of modules into the list
                list.i = function(modules, mediaQuery) {
                    if (typeof modules === "string") modules = [
                        [
                            null,
                            modules,
                            ""
                        ]
                    ];
                    var alreadyImportedModules = {};
                    for(var i = 0; i < this.length; i++){
                        var id = this[i][0];
                        if (typeof id === "number") alreadyImportedModules[id] = true;
                    }
                    for(i = 0; i < modules.length; i++){
                        var item = modules[i];
                        // skip already imported module
                        // this implementation is not 100% perfect for weird media query combinations
                        //  when a module is imported multiple times with different media queries.
                        //  I hope this will never occur (Hey this way we have smaller bundles)
                        if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
                            if (mediaQuery && !item[2]) item[2] = mediaQuery;
                            else if (mediaQuery) item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
                            list.push(item);
                        }
                    }
                };
                return list;
            };
            function cssWithMappingToString(item, useSourceMap) {
                var content = item[1] || '';
                var cssMapping = item[3];
                if (!cssMapping) return content;
                if (useSourceMap && typeof btoa === 'function') {
                    var sourceMapping = toComment(cssMapping);
                    var sourceURLs = cssMapping.sources.map(function(source) {
                        return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
                    });
                    return [
                        content
                    ].concat(sourceURLs).concat([
                        sourceMapping
                    ]).join('\n');
                }
                return [
                    content
                ].join('\n');
            }
            // Adapted from convert-source-map (MIT)
            function toComment(sourceMap) {
                // eslint-disable-next-line no-undef
                var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
                var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
                return '/*# ' + data + ' */';
            }
        /***/ },
        /***/ "./node_modules/css-loader/lib/url/escape.js": /*!***************************************************!*\
  !*** ./node_modules/css-loader/lib/url/escape.js ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = function escape(url) {
                if (typeof url !== 'string') return url;
                // If url is already wrapped in quotes, remove them
                if (/^['"].*['"]$/.test(url)) url = url.slice(1, -1);
                // Should url be wrapped?
                // See https://drafts.csswg.org/css-values-3/#urls
                if (/["'() \t\n]/.test(url)) return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"';
                return url;
            };
        /***/ },
        /***/ "./node_modules/hls.js/dist/hls.js": /*!*****************************************!*\
  !*** ./node_modules/hls.js/dist/hls.js ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            typeof window !== "undefined" && function webpackUniversalModuleDefinition(root, factory) {
                module1.exports = factory();
            }(this, function() {
                return /******/ function(modules) {
                    /******/ // The module cache
                    /******/ var installedModules = {};
                    /******/ /******/ // The require function
                    /******/ function __webpack_require__(moduleId) {
                        /******/ /******/ // Check if module is in cache
                        /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                        /******/ // Create a new module (and put it into the cache)
                        /******/ var module1 = installedModules[moduleId] = {
                            /******/ i: moduleId,
                            /******/ l: false,
                            /******/ exports: {}
                        };
                        /******/ /******/ // Execute the module function
                        /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                        /******/ /******/ // Flag the module as loaded
                        /******/ module1.l = true;
                        /******/ /******/ // Return the exports of the module
                        /******/ return module1.exports;
                    /******/ }
                    /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
                    /******/ __webpack_require__.m = modules;
                    /******/ /******/ // expose the module cache
                    /******/ __webpack_require__.c = installedModules;
                    /******/ /******/ // define getter function for harmony exports
                    /******/ __webpack_require__.d = function(exports, name, getter) {
                        /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                            enumerable: true,
                            get: getter
                        });
                    /******/ };
                    /******/ /******/ // define __esModule on exports
                    /******/ __webpack_require__.r = function(exports) {
                        /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                            value: 'Module'
                        });
                        /******/ Object.defineProperty(exports, '__esModule', {
                            value: true
                        });
                    /******/ };
                    /******/ /******/ // create a fake namespace object
                    /******/ // mode & 1: value is a module id, require it
                    /******/ // mode & 2: merge all properties of value into the ns
                    /******/ // mode & 4: return value when already ns object
                    /******/ // mode & 8|1: behave like require
                    /******/ __webpack_require__.t = function(value, mode) {
                        /******/ if (mode & 1) value = __webpack_require__(value);
                        /******/ if (mode & 8) return value;
                        /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
                        /******/ var ns = Object.create(null);
                        /******/ __webpack_require__.r(ns);
                        /******/ Object.defineProperty(ns, 'default', {
                            enumerable: true,
                            value: value
                        });
                        /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                            return value[key];
                        }).bind(null, key));
                        /******/ return ns;
                    /******/ };
                    /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
                    /******/ __webpack_require__.n = function(module1) {
                        /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                            return module1['default'];
                        } : /******/ function getModuleExports() {
                            return module1;
                        };
                        /******/ __webpack_require__.d(getter, 'a', getter);
                        /******/ return getter;
                    /******/ };
                    /******/ /******/ // Object.prototype.hasOwnProperty.call
                    /******/ __webpack_require__.o = function(object, property) {
                        return Object.prototype.hasOwnProperty.call(object, property);
                    };
                    /******/ /******/ // __webpack_public_path__
                    /******/ __webpack_require__.p = "/dist/";
                    /******/ /******/ /******/ // Load entry module and return exports
                    /******/ return __webpack_require__(__webpack_require__.s = "./src/hls.ts");
                /******/ }({
                    /***/ "./node_modules/eventemitter3/index.js": /*!*********************************************!*\
  !*** ./node_modules/eventemitter3/index.js ***!
  \*********************************************/ /*! no static exports found */ /*! ModuleConcatenation bailout: Module is not an ECMAScript module */ /***/ function(module1, exports, __webpack_require__) {
                        "use strict";
                        var has = Object.prototype.hasOwnProperty, prefix = '~';
                        /**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
                        //
                        // We try to not inherit from `Object.prototype`. In some engines creating an
                        // instance in this way is faster than calling `Object.create(null)` directly.
                        // If `Object.create(null)` is not supported we prefix the event names with a
                        // character to make sure that the built-in object properties are not
                        // overridden or used as an attack vector.
                        //
                        if (Object.create) {
                            Events.prototype = Object.create(null);
                            //
                            // This hack is needed because the `__proto__` property is still inherited in
                            // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
                            //
                            if (!new Events().__proto__) prefix = false;
                        }
                        /**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
                            this.fn = fn;
                            this.context = context;
                            this.once = once || false;
                        }
                        /**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
                            if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
                            var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
                            if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
                            else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
                            else emitter._events[evt] = [
                                emitter._events[evt],
                                listener
                            ];
                            return emitter;
                        }
                        /**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
                            if (--emitter._eventsCount === 0) emitter._events = new Events();
                            else delete emitter._events[evt];
                        }
                        /**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
                            this._events = new Events();
                            this._eventsCount = 0;
                        }
                        /**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
                            var names = [], events, name;
                            if (this._eventsCount === 0) return names;
                            for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
                            if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
                            return names;
                        };
                        /**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
                            var evt = prefix ? prefix + event : event, handlers = this._events[evt];
                            if (!handlers) return [];
                            if (handlers.fn) return [
                                handlers.fn
                            ];
                            for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
                            return ee;
                        };
                        /**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
                            var evt = prefix ? prefix + event : event, listeners = this._events[evt];
                            if (!listeners) return 0;
                            if (listeners.fn) return 1;
                            return listeners.length;
                        };
                        /**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
                            var evt = prefix ? prefix + event : event;
                            if (!this._events[evt]) return false;
                            var listeners = this._events[evt], len = arguments.length, args, i;
                            if (listeners.fn) {
                                if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                                switch(len){
                                    case 1:
                                        return listeners.fn.call(listeners.context), true;
                                    case 2:
                                        return listeners.fn.call(listeners.context, a1), true;
                                    case 3:
                                        return listeners.fn.call(listeners.context, a1, a2), true;
                                    case 4:
                                        return listeners.fn.call(listeners.context, a1, a2, a3), true;
                                    case 5:
                                        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                                    case 6:
                                        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                                }
                                for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                                listeners.fn.apply(listeners.context, args);
                            } else {
                                var length = listeners.length, j;
                                for(i = 0; i < length; i++){
                                    if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                                    switch(len){
                                        case 1:
                                            listeners[i].fn.call(listeners[i].context);
                                            break;
                                        case 2:
                                            listeners[i].fn.call(listeners[i].context, a1);
                                            break;
                                        case 3:
                                            listeners[i].fn.call(listeners[i].context, a1, a2);
                                            break;
                                        case 4:
                                            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                                            break;
                                        default:
                                            if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                                            listeners[i].fn.apply(listeners[i].context, args);
                                    }
                                }
                            }
                            return true;
                        };
                        /**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
                            return addListener(this, event, fn, context, false);
                        };
                        /**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
                            return addListener(this, event, fn, context, true);
                        };
                        /**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
                            var evt = prefix ? prefix + event : event;
                            if (!this._events[evt]) return this;
                            if (!fn) {
                                clearEvent(this, evt);
                                return this;
                            }
                            var listeners = this._events[evt];
                            if (listeners.fn) {
                                if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
                            } else {
                                for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                                //
                                // Reset the array, or remove it completely if we have no more listeners.
                                //
                                if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                                else clearEvent(this, evt);
                            }
                            return this;
                        };
                        /**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
                            var evt;
                            if (event) {
                                evt = prefix ? prefix + event : event;
                                if (this._events[evt]) clearEvent(this, evt);
                            } else {
                                this._events = new Events();
                                this._eventsCount = 0;
                            }
                            return this;
                        };
                        //
                        // Alias methods names because people roll like that.
                        //
                        EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
                        EventEmitter.prototype.addListener = EventEmitter.prototype.on;
                        //
                        // Expose the prefix.
                        //
                        EventEmitter.prefixed = prefix;
                        //
                        // Allow `EventEmitter` to be imported as module namespace.
                        //
                        EventEmitter.EventEmitter = EventEmitter;
                        module1.exports = EventEmitter;
                    /***/ },
                    /***/ "./node_modules/url-toolkit/src/url-toolkit.js": /*!*****************************************************!*\
  !*** ./node_modules/url-toolkit/src/url-toolkit.js ***!
  \*****************************************************/ /*! no static exports found */ /*! ModuleConcatenation bailout: Module is not an ECMAScript module */ /***/ function(module1, exports, __webpack_require__) {
                        // see https://tools.ietf.org/html/rfc1808
                        /* jshint ignore:start */ (function(root) {
                            /* jshint ignore:end */ var URL_REGEX = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/\?#]*\/)*.*?)??(;.*?)?(\?.*?)?(#.*?)?$/;
                            var FIRST_SEGMENT_REGEX = /^([^\/?#]*)(.*)$/;
                            var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
                            var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g;
                            var URLToolkit = {
                                // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
                                // E.g
                                // With opts.alwaysNormalize = false (default, spec compliant)
                                // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
                                // With opts.alwaysNormalize = true (not spec compliant)
                                // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
                                buildAbsoluteURL: function(baseURL, relativeURL, opts) {
                                    opts = opts || {};
                                    // remove any remaining space and CRLF
                                    baseURL = baseURL.trim();
                                    relativeURL = relativeURL.trim();
                                    if (!relativeURL) {
                                        // 2a) If the embedded URL is entirely empty, it inherits the
                                        // entire base URL (i.e., is set equal to the base URL)
                                        // and we are done.
                                        if (!opts.alwaysNormalize) return baseURL;
                                        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
                                        if (!basePartsForNormalise) throw new Error('Error trying to parse base URL.');
                                        basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
                                        return URLToolkit.buildURLFromParts(basePartsForNormalise);
                                    }
                                    var relativeParts = URLToolkit.parseURL(relativeURL);
                                    if (!relativeParts) throw new Error('Error trying to parse relative URL.');
                                    if (relativeParts.scheme) {
                                        // 2b) If the embedded URL starts with a scheme name, it is
                                        // interpreted as an absolute URL and we are done.
                                        if (!opts.alwaysNormalize) return relativeURL;
                                        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
                                        return URLToolkit.buildURLFromParts(relativeParts);
                                    }
                                    var baseParts = URLToolkit.parseURL(baseURL);
                                    if (!baseParts) throw new Error('Error trying to parse base URL.');
                                    if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
                                        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
                                        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
                                        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
                                        baseParts.netLoc = pathParts[1];
                                        baseParts.path = pathParts[2];
                                    }
                                    if (baseParts.netLoc && !baseParts.path) baseParts.path = '/';
                                    var builtParts = {
                                        // 2c) Otherwise, the embedded URL inherits the scheme of
                                        // the base URL.
                                        scheme: baseParts.scheme,
                                        netLoc: relativeParts.netLoc,
                                        path: null,
                                        params: relativeParts.params,
                                        query: relativeParts.query,
                                        fragment: relativeParts.fragment
                                    };
                                    if (!relativeParts.netLoc) {
                                        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
                                        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
                                        // (if any) of the base URL.
                                        builtParts.netLoc = baseParts.netLoc;
                                        // 4) If the embedded URL path is preceded by a slash "/", the
                                        // path is not relative and we skip to Step 7.
                                        if (relativeParts.path[0] !== '/') {
                                            if (!relativeParts.path) {
                                                // 5) If the embedded URL path is empty (and not preceded by a
                                                // slash), then the embedded URL inherits the base URL path
                                                builtParts.path = baseParts.path;
                                                // 5a) if the embedded URL's <params> is non-empty, we skip to
                                                // step 7; otherwise, it inherits the <params> of the base
                                                // URL (if any) and
                                                if (!relativeParts.params) {
                                                    builtParts.params = baseParts.params;
                                                    // 5b) if the embedded URL's <query> is non-empty, we skip to
                                                    // step 7; otherwise, it inherits the <query> of the base
                                                    // URL (if any) and we skip to step 7.
                                                    if (!relativeParts.query) builtParts.query = baseParts.query;
                                                }
                                            } else {
                                                // 6) The last segment of the base URL's path (anything
                                                // following the rightmost slash "/", or the entire path if no
                                                // slash is present) is removed and the embedded URL's path is
                                                // appended in its place.
                                                var baseURLPath = baseParts.path;
                                                var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
                                                builtParts.path = URLToolkit.normalizePath(newPath);
                                            }
                                        }
                                    }
                                    if (builtParts.path === null) builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
                                    return URLToolkit.buildURLFromParts(builtParts);
                                },
                                parseURL: function(url) {
                                    var parts = URL_REGEX.exec(url);
                                    if (!parts) return null;
                                    return {
                                        scheme: parts[1] || '',
                                        netLoc: parts[2] || '',
                                        path: parts[3] || '',
                                        params: parts[4] || '',
                                        query: parts[5] || '',
                                        fragment: parts[6] || ''
                                    };
                                },
                                normalizePath: function(path) {
                                    // The following operations are
                                    // then applied, in order, to the new path:
                                    // 6a) All occurrences of "./", where "." is a complete path
                                    // segment, are removed.
                                    // 6b) If the path ends with "." as a complete path segment,
                                    // that "." is removed.
                                    path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
                                    // 6c) All occurrences of "<segment>/../", where <segment> is a
                                    // complete path segment not equal to "..", are removed.
                                    // Removal of these path segments is performed iteratively,
                                    // removing the leftmost matching pattern on each iteration,
                                    // until no matching pattern remains.
                                    // 6d) If the path ends with "<segment>/..", where <segment> is a
                                    // complete path segment not equal to "..", that
                                    // "<segment>/.." is removed.
                                    while(path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length); // jshint ignore:line
                                    return path.split('').reverse().join('');
                                },
                                buildURLFromParts: function(parts) {
                                    return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
                                }
                            };
                            module1.exports = URLToolkit;
                        })(this);
                    /* jshint ignore:end */ /***/ },
                    /***/ "./node_modules/webworkify-webpack/index.js": /*!**************************************************!*\
  !*** ./node_modules/webworkify-webpack/index.js ***!
  \**************************************************/ /*! no static exports found */ /*! ModuleConcatenation bailout: Module is not an ECMAScript module */ /***/ function(module1, exports, __webpack_require__) {
                        function webpackBootstrapFunc(modules) {
                            /******/ // The module cache
                            /******/ var installedModules = {};
                            /******/ // The require function
                            /******/ function __webpack_require__(moduleId) {
                                /******/ // Check if module is in cache
                                /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                                /******/ // Create a new module (and put it into the cache)
                                /******/ var module1 = installedModules[moduleId] = {
                                    /******/ i: moduleId,
                                    /******/ l: false,
                                    /******/ exports: {}
                                };
                                /******/ // Execute the module function
                                /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                                /******/ // Flag the module as loaded
                                /******/ module1.l = true;
                                /******/ // Return the exports of the module
                                /******/ return module1.exports;
                            /******/ }
                            /******/ // expose the modules object (__webpack_modules__)
                            /******/ __webpack_require__.m = modules;
                            /******/ // expose the module cache
                            /******/ __webpack_require__.c = installedModules;
                            /******/ // identity function for calling harmony imports with the correct context
                            /******/ __webpack_require__.i = function(value) {
                                return value;
                            };
                            /******/ // define getter function for harmony exports
                            /******/ __webpack_require__.d = function(exports, name, getter) {
                                /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                                    /******/ configurable: false,
                                    /******/ enumerable: true,
                                    /******/ get: getter
                                });
                            /******/ };
                            /******/ // define __esModule on exports
                            /******/ __webpack_require__.r = function(exports) {
                                /******/ Object.defineProperty(exports, '__esModule', {
                                    value: true
                                });
                            /******/ };
                            /******/ // getDefaultExport function for compatibility with non-harmony modules
                            /******/ __webpack_require__.n = function(module1) {
                                /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                                    return module1['default'];
                                } : /******/ function getModuleExports() {
                                    return module1;
                                };
                                /******/ __webpack_require__.d(getter, 'a', getter);
                                /******/ return getter;
                            /******/ };
                            /******/ // Object.prototype.hasOwnProperty.call
                            /******/ __webpack_require__.o = function(object, property) {
                                return Object.prototype.hasOwnProperty.call(object, property);
                            };
                            /******/ // __webpack_public_path__
                            /******/ __webpack_require__.p = "/";
                            /******/ // on error function for async loading
                            /******/ __webpack_require__.oe = function(err) {
                                console.error(err);
                                throw err;
                            };
                            var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                            return f.default || f // try to call default if defined to also support babel esmodule exports
                            ;
                        }
                        var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
                        var dependencyRegExp = '\\(\\s*(\/\\*.*?\\*\/)?\\s*.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
                        ;
                        // http://stackoverflow.com/a/2593661/130442
                        function quoteRegExp(str) {
                            return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
                        }
                        function isNumeric(n) {
                            return !isNaN(1 * n); // 1 * n converts integers, integers as string ("123"), 1e3 and "1e3" to integers and strings to NaN
                        }
                        function getModuleDependencies(sources, module1, queueName) {
                            var retval = {};
                            retval[queueName] = [];
                            var fnString = module1.toString();
                            var wrapperSignature = fnString.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/);
                            if (!wrapperSignature) return retval;
                            var webpackRequireName = wrapperSignature[1];
                            // main bundle deps
                            var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                            var match;
                            while(match = re.exec(fnString)){
                                if (match[3] === 'dll-reference') continue;
                                retval[queueName].push(match[3]);
                            }
                            // dll deps
                            re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                            while(match = re.exec(fnString)){
                                if (!sources[match[2]]) {
                                    retval[queueName].push(match[1]);
                                    sources[match[2]] = __webpack_require__(match[1]).m;
                                }
                                retval[match[2]] = retval[match[2]] || [];
                                retval[match[2]].push(match[4]);
                            }
                            // convert 1e3 back to 1000 - this can be important after uglify-js converted 1000 to 1e3
                            var keys = Object.keys(retval);
                            for(var i = 0; i < keys.length; i++){
                                for(var j = 0; j < retval[keys[i]].length; j++)if (isNumeric(retval[keys[i]][j])) retval[keys[i]][j] = 1 * retval[keys[i]][j];
                            }
                            return retval;
                        }
                        function hasValuesInQueues(queues) {
                            var keys = Object.keys(queues);
                            return keys.reduce(function(hasValues, key) {
                                return hasValues || queues[key].length > 0;
                            }, false);
                        }
                        function getRequiredModules(sources, moduleId) {
                            var modulesQueue = {
                                main: [
                                    moduleId
                                ]
                            };
                            var requiredModules = {
                                main: []
                            };
                            var seenModules = {
                                main: {}
                            };
                            while(hasValuesInQueues(modulesQueue)){
                                var queues = Object.keys(modulesQueue);
                                for(var i = 0; i < queues.length; i++){
                                    var queueName = queues[i];
                                    var queue = modulesQueue[queueName];
                                    var moduleToCheck = queue.pop();
                                    seenModules[queueName] = seenModules[queueName] || {};
                                    if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                                    seenModules[queueName][moduleToCheck] = true;
                                    requiredModules[queueName] = requiredModules[queueName] || [];
                                    requiredModules[queueName].push(moduleToCheck);
                                    var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                                    var newModulesKeys = Object.keys(newModules);
                                    for(var j = 0; j < newModulesKeys.length; j++){
                                        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                                        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                                    }
                                }
                            }
                            return requiredModules;
                        }
                        module1.exports = function(moduleId, options) {
                            options = options || {};
                            var sources = {
                                main: __webpack_require__.m
                            };
                            var requiredModules = options.all ? {
                                main: Object.keys(sources.main)
                            } : getRequiredModules(sources, moduleId);
                            var src = '';
                            Object.keys(requiredModules).filter(function(m) {
                                return m !== 'main';
                            }).forEach(function(module1) {
                                var entryModule = 0;
                                while(requiredModules[module1][entryModule])entryModule++;
                                requiredModules[module1].push(entryModule);
                                sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                                src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                                    return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                                }).join(',') + '});\n';
                            });
                            src = src + 'new ((' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                                return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                            }).join(',') + '}))(self);';
                            var blob = new window.Blob([
                                src
                            ], {
                                type: 'text/javascript'
                            });
                            if (options.bare) return blob;
                            var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                            var workerUrl = URL1.createObjectURL(blob);
                            var worker = new window.Worker(workerUrl);
                            worker.objectURL = workerUrl;
                            return worker;
                        };
                    /***/ },
                    /***/ "./src/crypt/decrypter.js": /*!********************************************!*\
  !*** ./src/crypt/decrypter.js + 3 modules ***!
  \********************************************/ /*! exports provided: default */ /*! ModuleConcatenation bailout: Cannot concat with ./src/errors.ts because of ./src/hls.ts */ /*! ModuleConcatenation bailout: Cannot concat with ./src/events.js because of ./src/hls.ts */ /*! ModuleConcatenation bailout: Cannot concat with ./src/utils/get-self-scope.js because of ./src/hls.ts */ /*! ModuleConcatenation bailout: Cannot concat with ./src/utils/logger.js because of ./src/hls.ts */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                        "use strict";
                        __webpack_require__.r(__webpack_exports__);
                        // CONCATENATED MODULE: ./src/crypt/aes-crypto.js
                        var AESCrypto = /*#__PURE__*/ function() {
                            function AESCrypto(subtle, iv) {
                                this.subtle = subtle;
                                this.aesIV = iv;
                            }
                            var _proto = AESCrypto.prototype;
                            _proto.decrypt = function decrypt(data, key) {
                                return this.subtle.decrypt({
                                    name: 'AES-CBC',
                                    iv: this.aesIV
                                }, key, data);
                            };
                            return AESCrypto;
                        }();
                        // CONCATENATED MODULE: ./src/crypt/fast-aes-key.js
                        var FastAESKey = /*#__PURE__*/ function() {
                            function FastAESKey(subtle, key) {
                                this.subtle = subtle;
                                this.key = key;
                            }
                            var _proto = FastAESKey.prototype;
                            _proto.expandKey = function expandKey() {
                                return this.subtle.importKey('raw', this.key, {
                                    name: 'AES-CBC'
                                }, false, [
                                    'encrypt',
                                    'decrypt'
                                ]);
                            };
                            return FastAESKey;
                        }();
                        /* harmony default export */ var fast_aes_key = FastAESKey;
                        // CONCATENATED MODULE: ./src/crypt/aes-decryptor.js
                        // PKCS7
                        function removePadding(buffer) {
                            var outputBytes = buffer.byteLength;
                            var paddingBytes = outputBytes && new DataView(buffer).getUint8(outputBytes - 1);
                            if (paddingBytes) return buffer.slice(0, outputBytes - paddingBytes);
                            else return buffer;
                        }
                        var AESDecryptor = /*#__PURE__*/ function() {
                            function AESDecryptor() {
                                // Static after running initTable
                                this.rcon = [
                                    0x0,
                                    0x1,
                                    0x2,
                                    0x4,
                                    0x8,
                                    0x10,
                                    0x20,
                                    0x40,
                                    0x80,
                                    0x1b,
                                    0x36
                                ];
                                this.subMix = [
                                    new Uint32Array(256),
                                    new Uint32Array(256),
                                    new Uint32Array(256),
                                    new Uint32Array(256)
                                ];
                                this.invSubMix = [
                                    new Uint32Array(256),
                                    new Uint32Array(256),
                                    new Uint32Array(256),
                                    new Uint32Array(256)
                                ];
                                this.sBox = new Uint32Array(256);
                                this.invSBox = new Uint32Array(256); // Changes during runtime
                                this.key = new Uint32Array(0);
                                this.initTable();
                            } // Using view.getUint32() also swaps the byte order.
                            var _proto = AESDecryptor.prototype;
                            _proto.uint8ArrayToUint32Array_ = function uint8ArrayToUint32Array_(arrayBuffer) {
                                var view = new DataView(arrayBuffer);
                                var newArray = new Uint32Array(4);
                                for(var i = 0; i < 4; i++)newArray[i] = view.getUint32(i * 4);
                                return newArray;
                            };
                            _proto.initTable = function initTable() {
                                var sBox = this.sBox;
                                var invSBox = this.invSBox;
                                var subMix = this.subMix;
                                var subMix0 = subMix[0];
                                var subMix1 = subMix[1];
                                var subMix2 = subMix[2];
                                var subMix3 = subMix[3];
                                var invSubMix = this.invSubMix;
                                var invSubMix0 = invSubMix[0];
                                var invSubMix1 = invSubMix[1];
                                var invSubMix2 = invSubMix[2];
                                var invSubMix3 = invSubMix[3];
                                var d = new Uint32Array(256);
                                var x = 0;
                                var xi = 0;
                                var i = 0;
                                for(i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
                                else d[i] = i << 1 ^ 0x11b;
                                for(i = 0; i < 256; i++){
                                    var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                                    sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                                    sBox[x] = sx;
                                    invSBox[sx] = x; // Compute multiplication
                                    var x2 = d[x];
                                    var x4 = d[x2];
                                    var x8 = d[x4]; // Compute sub/invSub bytes, mix columns tables
                                    var t = d[sx] * 0x101 ^ sx * 0x1010100;
                                    subMix0[x] = t << 24 | t >>> 8;
                                    subMix1[x] = t << 16 | t >>> 16;
                                    subMix2[x] = t << 8 | t >>> 24;
                                    subMix3[x] = t; // Compute inv sub bytes, inv mix columns tables
                                    t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                                    invSubMix0[sx] = t << 24 | t >>> 8;
                                    invSubMix1[sx] = t << 16 | t >>> 16;
                                    invSubMix2[sx] = t << 8 | t >>> 24;
                                    invSubMix3[sx] = t; // Compute next counter
                                    if (!x) x = xi = 1;
                                    else {
                                        x = x2 ^ d[d[d[x8 ^ x2]]];
                                        xi ^= d[d[xi]];
                                    }
                                }
                            };
                            _proto.expandKey = function expandKey(keyBuffer) {
                                // convert keyBuffer to Uint32Array
                                var key = this.uint8ArrayToUint32Array_(keyBuffer);
                                var sameKey = true;
                                var offset = 0;
                                while(offset < key.length && sameKey){
                                    sameKey = key[offset] === this.key[offset];
                                    offset++;
                                }
                                if (sameKey) return;
                                this.key = key;
                                var keySize = this.keySize = key.length;
                                if (keySize !== 4 && keySize !== 6 && keySize !== 8) throw new Error('Invalid aes key size=' + keySize);
                                var ksRows = this.ksRows = (keySize + 6 + 1) * 4;
                                var ksRow;
                                var invKsRow;
                                var keySchedule = this.keySchedule = new Uint32Array(ksRows);
                                var invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
                                var sbox = this.sBox;
                                var rcon = this.rcon;
                                var invSubMix = this.invSubMix;
                                var invSubMix0 = invSubMix[0];
                                var invSubMix1 = invSubMix[1];
                                var invSubMix2 = invSubMix[2];
                                var invSubMix3 = invSubMix[3];
                                var prev;
                                var t;
                                for(ksRow = 0; ksRow < ksRows; ksRow++){
                                    if (ksRow < keySize) {
                                        prev = keySchedule[ksRow] = key[ksRow];
                                        continue;
                                    }
                                    t = prev;
                                    if (ksRow % keySize === 0) {
                                        // Rot word
                                        t = t << 8 | t >>> 24; // Sub word
                                        t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff]; // Mix Rcon
                                        t ^= rcon[ksRow / keySize | 0] << 24;
                                    } else if (keySize > 6 && ksRow % keySize === 4) // Sub word
                                    t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
                                    keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
                                }
                                for(invKsRow = 0; invKsRow < ksRows; invKsRow++){
                                    ksRow = ksRows - invKsRow;
                                    if (invKsRow & 3) t = keySchedule[ksRow];
                                    else t = keySchedule[ksRow - 4];
                                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                                    else invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
                                    invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
                                }
                            } // Adding this as a method greatly improves performance.
                            ;
                            _proto.networkToHostOrderSwap = function networkToHostOrderSwap(word) {
                                return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
                            };
                            _proto.decrypt = function decrypt(inputArrayBuffer, offset, aesIV, removePKCS7Padding) {
                                var nRounds = this.keySize + 6;
                                var invKeySchedule = this.invKeySchedule;
                                var invSBOX = this.invSBox;
                                var invSubMix = this.invSubMix;
                                var invSubMix0 = invSubMix[0];
                                var invSubMix1 = invSubMix[1];
                                var invSubMix2 = invSubMix[2];
                                var invSubMix3 = invSubMix[3];
                                var initVector = this.uint8ArrayToUint32Array_(aesIV);
                                var initVector0 = initVector[0];
                                var initVector1 = initVector[1];
                                var initVector2 = initVector[2];
                                var initVector3 = initVector[3];
                                var inputInt32 = new Int32Array(inputArrayBuffer);
                                var outputInt32 = new Int32Array(inputInt32.length);
                                var t0, t1, t2, t3;
                                var s0, s1, s2, s3;
                                var inputWords0, inputWords1, inputWords2, inputWords3;
                                var ksRow, i;
                                var swapWord = this.networkToHostOrderSwap;
                                while(offset < inputInt32.length){
                                    inputWords0 = swapWord(inputInt32[offset]);
                                    inputWords1 = swapWord(inputInt32[offset + 1]);
                                    inputWords2 = swapWord(inputInt32[offset + 2]);
                                    inputWords3 = swapWord(inputInt32[offset + 3]);
                                    s0 = inputWords0 ^ invKeySchedule[0];
                                    s1 = inputWords3 ^ invKeySchedule[1];
                                    s2 = inputWords2 ^ invKeySchedule[2];
                                    s3 = inputWords1 ^ invKeySchedule[3];
                                    ksRow = 4; // Iterate through the rounds of decryption
                                    for(i = 1; i < nRounds; i++){
                                        t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
                                        t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
                                        t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
                                        t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3]; // Update state
                                        s0 = t0;
                                        s1 = t1;
                                        s2 = t2;
                                        s3 = t3;
                                        ksRow = ksRow + 4;
                                    } // Shift rows, sub bytes, add round key
                                    t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
                                    t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
                                    t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
                                    t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
                                    ksRow = ksRow + 3; // Write
                                    outputInt32[offset] = swapWord(t0 ^ initVector0);
                                    outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
                                    outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
                                    outputInt32[offset + 3] = swapWord(t1 ^ initVector3); // reset initVector to last 4 unsigned int
                                    initVector0 = inputWords0;
                                    initVector1 = inputWords1;
                                    initVector2 = inputWords2;
                                    initVector3 = inputWords3;
                                    offset = offset + 4;
                                }
                                return removePKCS7Padding ? removePadding(outputInt32.buffer) : outputInt32.buffer;
                            };
                            _proto.destroy = function destroy() {
                                this.key = undefined;
                                this.keySize = undefined;
                                this.ksRows = undefined;
                                this.sBox = undefined;
                                this.invSBox = undefined;
                                this.subMix = undefined;
                                this.invSubMix = undefined;
                                this.keySchedule = undefined;
                                this.invKeySchedule = undefined;
                                this.rcon = undefined;
                            };
                            return AESDecryptor;
                        }();
                        /* harmony default export */ var aes_decryptor = AESDecryptor;
                        // EXTERNAL MODULE: ./src/errors.ts
                        var errors = __webpack_require__("./src/errors.ts");
                        // EXTERNAL MODULE: ./src/utils/logger.js
                        var logger = __webpack_require__("./src/utils/logger.js");
                        // EXTERNAL MODULE: ./src/events.js
                        var events = __webpack_require__("./src/events.js");
                        // EXTERNAL MODULE: ./src/utils/get-self-scope.js
                        var get_self_scope = __webpack_require__("./src/utils/get-self-scope.js");
                        // CONCATENATED MODULE: ./src/crypt/decrypter.js
                        // see https://stackoverflow.com/a/11237259/589493
                        var global = Object(get_self_scope["getSelfScope"])(); // safeguard for code that might run both on worker and main thread
                        var decrypter_Decrypter = /*#__PURE__*/ function() {
                            function Decrypter(observer, config, _temp) {
                                var _ref = _temp === void 0 ? {} : _temp, _ref$removePKCS7Paddi = _ref.removePKCS7Padding, removePKCS7Padding = _ref$removePKCS7Paddi === void 0 ? true : _ref$removePKCS7Paddi;
                                this.logEnabled = true;
                                this.observer = observer;
                                this.config = config;
                                this.removePKCS7Padding = removePKCS7Padding; // built in decryptor expects PKCS7 padding
                                if (removePKCS7Padding) try {
                                    var browserCrypto = global.crypto;
                                    if (browserCrypto) this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
                                } catch (e) {}
                                this.disableWebCrypto = !this.subtle;
                            }
                            var _proto = Decrypter.prototype;
                            _proto.isSync = function isSync() {
                                return this.disableWebCrypto && this.config.enableSoftwareAES;
                            };
                            _proto.decrypt = function decrypt(data, key, iv, callback) {
                                var _this = this;
                                if (this.disableWebCrypto && this.config.enableSoftwareAES) {
                                    if (this.logEnabled) {
                                        logger["logger"].log('JS AES decrypt');
                                        this.logEnabled = false;
                                    }
                                    var decryptor = this.decryptor;
                                    if (!decryptor) this.decryptor = decryptor = new aes_decryptor();
                                    decryptor.expandKey(key);
                                    callback(decryptor.decrypt(data, 0, iv, this.removePKCS7Padding));
                                } else {
                                    if (this.logEnabled) {
                                        logger["logger"].log('WebCrypto AES decrypt');
                                        this.logEnabled = false;
                                    }
                                    var subtle = this.subtle;
                                    if (this.key !== key) {
                                        this.key = key;
                                        this.fastAesKey = new fast_aes_key(subtle, key);
                                    }
                                    this.fastAesKey.expandKey().then(function(aesKey) {
                                        // decrypt using web crypto
                                        var crypto = new AESCrypto(subtle, iv);
                                        crypto.decrypt(data, aesKey).catch(function(err) {
                                            _this.onWebCryptoError(err, data, key, iv, callback);
                                        }).then(function(result) {
                                            callback(result);
                                        });
                                    }).catch(function(err) {
                                        _this.onWebCryptoError(err, data, key, iv, callback);
                                    });
                                }
                            };
                            _proto.onWebCryptoError = function onWebCryptoError(err, data, key, iv, callback) {
                                if (this.config.enableSoftwareAES) {
                                    logger["logger"].log('WebCrypto Error, disable WebCrypto API');
                                    this.disableWebCrypto = true;
                                    this.logEnabled = true;
                                    this.decrypt(data, key, iv, callback);
                                } else {
                                    logger["logger"].error("decrypting error : " + err.message);
                                    this.observer.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].MEDIA_ERROR,
                                        details: errors["ErrorDetails"].FRAG_DECRYPT_ERROR,
                                        fatal: true,
                                        reason: err.message
                                    });
                                }
                            };
                            _proto.destroy = function destroy() {
                                var decryptor = this.decryptor;
                                if (decryptor) {
                                    decryptor.destroy();
                                    this.decryptor = undefined;
                                }
                            };
                            return Decrypter;
                        }();
                        /* harmony default export */ var decrypter = __webpack_exports__["default"] = decrypter_Decrypter;
                    /***/ },
                    /***/ "./src/demux/demuxer-inline.js": /*!**************************************************!*\
  !*** ./src/demux/demuxer-inline.js + 12 modules ***!
  \**************************************************/ /*! exports provided: default */ /*! ModuleConcatenation bailout: Cannot concat with ./src/crypt/decrypter.js because of ./src/hls.ts */ /*! ModuleConcatenation bailout: Cannot concat with ./src/demux/id3.js because of ./src/hls.ts */ /*! ModuleConcatenation bailout: Cannot concat with ./src/demux/mp4demuxer.js because of ./src/hls.ts */ /*! ModuleConcatenation bailout: Cannot concat with ./src/errors.ts because of ./src/hls.ts */ /*! ModuleConcatenation bailout: Cannot concat with ./src/events.js because of ./src/hls.ts */ /*! ModuleConcatenation bailout: Cannot concat with ./src/polyfills/number-isFinite.js because of ./src/hls.ts */ /*! ModuleConcatenation bailout: Cannot concat with ./src/utils/get-self-scope.js because of ./src/hls.ts */ /*! ModuleConcatenation bailout: Cannot concat with ./src/utils/logger.js because of ./src/hls.ts */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                        "use strict";
                        __webpack_require__.r(__webpack_exports__);
                        // EXTERNAL MODULE: ./src/events.js
                        var events = __webpack_require__("./src/events.js");
                        // EXTERNAL MODULE: ./src/errors.ts
                        var errors = __webpack_require__("./src/errors.ts");
                        // EXTERNAL MODULE: ./src/crypt/decrypter.js + 3 modules
                        var crypt_decrypter = __webpack_require__("./src/crypt/decrypter.js");
                        // EXTERNAL MODULE: ./src/polyfills/number-isFinite.js
                        var number_isFinite = __webpack_require__("./src/polyfills/number-isFinite.js");
                        // EXTERNAL MODULE: ./src/utils/logger.js
                        var logger = __webpack_require__("./src/utils/logger.js");
                        // EXTERNAL MODULE: ./src/utils/get-self-scope.js
                        var get_self_scope = __webpack_require__("./src/utils/get-self-scope.js");
                        // CONCATENATED MODULE: ./src/demux/adts.js
                        /**
 * ADTS parser helper
 * @link https://wiki.multimedia.cx/index.php?title=ADTS
 */ function getAudioConfig(observer, data, offset, audioCodec) {
                            var adtsObjectType, // :int
                            adtsSampleingIndex, // :int
                            adtsExtensionSampleingIndex, // :int
                            adtsChanelConfig, // :int
                            config, userAgent = navigator.userAgent.toLowerCase(), manifestCodec = audioCodec, adtsSampleingRates = [
                                96000,
                                88200,
                                64000,
                                48000,
                                44100,
                                32000,
                                24000,
                                22050,
                                16000,
                                12000,
                                11025,
                                8000,
                                7350
                            ]; // byte 2
                            adtsObjectType = ((data[offset + 2] & 0xC0) >>> 6) + 1;
                            adtsSampleingIndex = (data[offset + 2] & 0x3C) >>> 2;
                            if (adtsSampleingIndex > adtsSampleingRates.length - 1) {
                                observer.trigger(events["default"].ERROR, {
                                    type: errors["ErrorTypes"].MEDIA_ERROR,
                                    details: errors["ErrorDetails"].FRAG_PARSING_ERROR,
                                    fatal: true,
                                    reason: "invalid ADTS sampling index:" + adtsSampleingIndex
                                });
                                return;
                            }
                            adtsChanelConfig = (data[offset + 2] & 0x01) << 2; // byte 3
                            adtsChanelConfig |= (data[offset + 3] & 0xC0) >>> 6;
                            logger["logger"].log("manifest codec:" + audioCodec + ",ADTS data:type:" + adtsObjectType + ",sampleingIndex:" + adtsSampleingIndex + "[" + adtsSampleingRates[adtsSampleingIndex] + "Hz],channelConfig:" + adtsChanelConfig); // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
                            if (/firefox/i.test(userAgent)) {
                                if (adtsSampleingIndex >= 6) {
                                    adtsObjectType = 5;
                                    config = new Array(4); // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
                                    // there is a factor 2 between frame sample rate and output sample rate
                                    // multiply frequency by 2 (see table below, equivalent to substract 3)
                                    adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
                                } else {
                                    adtsObjectType = 2;
                                    config = new Array(2);
                                    adtsExtensionSampleingIndex = adtsSampleingIndex;
                                } // Android : always use AAC
                            } else if (userAgent.indexOf('android') !== -1) {
                                adtsObjectType = 2;
                                config = new Array(2);
                                adtsExtensionSampleingIndex = adtsSampleingIndex;
                            } else {
                                /*  for other browsers (Chrome/Vivaldi/Opera ...)
        always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
    */ adtsObjectType = 5;
                                config = new Array(4); // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
                                if (audioCodec && (audioCodec.indexOf('mp4a.40.29') !== -1 || audioCodec.indexOf('mp4a.40.5') !== -1) || !audioCodec && adtsSampleingIndex >= 6) // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
                                // there is a factor 2 between frame sample rate and output sample rate
                                // multiply frequency by 2 (see table below, equivalent to substract 3)
                                adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
                                else {
                                    // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
                                    // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
                                    if (audioCodec && audioCodec.indexOf('mp4a.40.2') !== -1 && (adtsSampleingIndex >= 6 && adtsChanelConfig === 1 || /vivaldi/i.test(userAgent)) || !audioCodec && adtsChanelConfig === 1) {
                                        adtsObjectType = 2;
                                        config = new Array(2);
                                    }
                                    adtsExtensionSampleingIndex = adtsSampleingIndex;
                                }
                            }
                            /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
      ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
    Audio Profile / Audio Object Type
    0: Null
    1: AAC Main
    2: AAC LC (Low Complexity)
    3: AAC SSR (Scalable Sample Rate)
    4: AAC LTP (Long Term Prediction)
    5: SBR (Spectral Band Replication)
    6: AAC Scalable
   sampling freq
    0: 96000 Hz
    1: 88200 Hz
    2: 64000 Hz
    3: 48000 Hz
    4: 44100 Hz
    5: 32000 Hz
    6: 24000 Hz
    7: 22050 Hz
    8: 16000 Hz
    9: 12000 Hz
    10: 11025 Hz
    11: 8000 Hz
    12: 7350 Hz
    13: Reserved
    14: Reserved
    15: frequency is written explictly
    Channel Configurations
    These are the channel configurations:
    0: Defined in AOT Specifc Config
    1: 1 channel: front-center
    2: 2 channels: front-left, front-right
  */ // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
                            config[0] = adtsObjectType << 3; // samplingFrequencyIndex
                            config[0] |= (adtsSampleingIndex & 0x0E) >> 1;
                            config[1] |= (adtsSampleingIndex & 0x01) << 7; // channelConfiguration
                            config[1] |= adtsChanelConfig << 3;
                            if (adtsObjectType === 5) {
                                // adtsExtensionSampleingIndex
                                config[1] |= (adtsExtensionSampleingIndex & 0x0E) >> 1;
                                config[2] = (adtsExtensionSampleingIndex & 0x01) << 7; // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
                                //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
                                config[2] |= 8;
                                config[3] = 0;
                            }
                            return {
                                config: config,
                                samplerate: adtsSampleingRates[adtsSampleingIndex],
                                channelCount: adtsChanelConfig,
                                codec: 'mp4a.40.' + adtsObjectType,
                                manifestCodec: manifestCodec
                            };
                        }
                        function isHeaderPattern(data, offset) {
                            return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
                        }
                        function getHeaderLength(data, offset) {
                            return data[offset + 1] & 0x01 ? 7 : 9;
                        }
                        function getFullFrameLength(data, offset) {
                            return (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xE0) >>> 5;
                        }
                        function isHeader(data, offset) {
                            // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
                            // Layer bits (position 14 and 15) in header should be always 0 for ADTS
                            // More info https://wiki.multimedia.cx/index.php?title=ADTS
                            if (offset + 1 < data.length && isHeaderPattern(data, offset)) return true;
                            return false;
                        }
                        function adts_probe(data, offset) {
                            // same as isHeader but we also check that ADTS frame follows last ADTS frame
                            // or end of data is reached
                            if (isHeader(data, offset)) {
                                // ADTS header Length
                                var headerLength = getHeaderLength(data, offset); // ADTS frame Length
                                var frameLength = headerLength;
                                if (offset + 5 < data.length) frameLength = getFullFrameLength(data, offset);
                                var newOffset = offset + frameLength;
                                if (newOffset === data.length || newOffset + 1 < data.length && isHeaderPattern(data, newOffset)) return true;
                            }
                            return false;
                        }
                        function initTrackConfig(track, observer, data, offset, audioCodec) {
                            if (!track.samplerate) {
                                var config = getAudioConfig(observer, data, offset, audioCodec);
                                track.config = config.config;
                                track.samplerate = config.samplerate;
                                track.channelCount = config.channelCount;
                                track.codec = config.codec;
                                track.manifestCodec = config.manifestCodec;
                                logger["logger"].log("parsed codec:" + track.codec + ",rate:" + config.samplerate + ",nb channel:" + config.channelCount);
                            }
                        }
                        function getFrameDuration(samplerate) {
                            return 92160000 / samplerate;
                        }
                        function parseFrameHeader(data, offset, pts, frameIndex, frameDuration) {
                            var headerLength, frameLength, stamp;
                            var length = data.length; // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
                            headerLength = getHeaderLength(data, offset); // retrieve frame size
                            frameLength = getFullFrameLength(data, offset);
                            frameLength -= headerLength;
                            if (frameLength > 0 && offset + headerLength + frameLength <= length) {
                                stamp = pts + frameIndex * frameDuration; // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
                                return {
                                    headerLength: headerLength,
                                    frameLength: frameLength,
                                    stamp: stamp
                                };
                            }
                            return undefined;
                        }
                        function appendFrame(track, data, offset, pts, frameIndex) {
                            var frameDuration = getFrameDuration(track.samplerate);
                            var header = parseFrameHeader(data, offset, pts, frameIndex, frameDuration);
                            if (header) {
                                var stamp = header.stamp;
                                var headerLength = header.headerLength;
                                var frameLength = header.frameLength; // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
                                var aacSample = {
                                    unit: data.subarray(offset + headerLength, offset + headerLength + frameLength),
                                    pts: stamp,
                                    dts: stamp
                                };
                                track.samples.push(aacSample);
                                return {
                                    sample: aacSample,
                                    length: frameLength + headerLength
                                };
                            }
                            return undefined;
                        }
                        // EXTERNAL MODULE: ./src/demux/id3.js
                        var id3 = __webpack_require__("./src/demux/id3.js");
                        // CONCATENATED MODULE: ./src/demux/aacdemuxer.js
                        /**
 * AAC demuxer
 */ var aacdemuxer_AACDemuxer = /*#__PURE__*/ function() {
                            function AACDemuxer(observer, remuxer, config) {
                                this.observer = observer;
                                this.config = config;
                                this.remuxer = remuxer;
                            }
                            var _proto = AACDemuxer.prototype;
                            _proto.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
                                this._audioTrack = {
                                    container: 'audio/adts',
                                    type: 'audio',
                                    id: 0,
                                    sequenceNumber: 0,
                                    isAAC: true,
                                    samples: [],
                                    len: 0,
                                    manifestCodec: audioCodec,
                                    duration: duration,
                                    inputTimeScale: 90000
                                };
                            };
                            _proto.resetTimeStamp = function resetTimeStamp() {};
                            AACDemuxer.probe = function probe(data) {
                                if (!data) return false;
                                 // Check for the ADTS sync word
                                // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
                                // Layer bits (position 14 and 15) in header should be always 0 for ADTS
                                // More info https://wiki.multimedia.cx/index.php?title=ADTS
                                var id3Data = id3["default"].getID3Data(data, 0) || [];
                                var offset = id3Data.length;
                                for(var length = data.length; offset < length; offset++)if (adts_probe(data, offset)) {
                                    logger["logger"].log('ADTS sync word found !');
                                    return true;
                                }
                                return false;
                            } // feed incoming data to the front of the parsing pipeline
                            ;
                            _proto.append = function append(data, timeOffset, contiguous, accurateTimeOffset) {
                                var track = this._audioTrack;
                                var id3Data = id3["default"].getID3Data(data, 0) || [];
                                var timestamp = id3["default"].getTimeStamp(id3Data);
                                var pts = Object(number_isFinite["isFiniteNumber"])(timestamp) ? timestamp * 90 : timeOffset * 90000;
                                var frameIndex = 0;
                                var stamp = pts;
                                var length = data.length;
                                var offset = id3Data.length;
                                var id3Samples = [
                                    {
                                        pts: stamp,
                                        dts: stamp,
                                        data: id3Data
                                    }
                                ];
                                while(offset < length - 1){
                                    if (isHeader(data, offset) && offset + 5 < length) {
                                        initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
                                        var frame = appendFrame(track, data, offset, pts, frameIndex);
                                        if (frame) {
                                            offset += frame.length;
                                            stamp = frame.sample.pts;
                                            frameIndex++;
                                        } else {
                                            logger["logger"].log('Unable to parse AAC frame');
                                            break;
                                        }
                                    } else if (id3["default"].isHeader(data, offset)) {
                                        id3Data = id3["default"].getID3Data(data, offset);
                                        id3Samples.push({
                                            pts: stamp,
                                            dts: stamp,
                                            data: id3Data
                                        });
                                        offset += id3Data.length;
                                    } else // nothing found, keep looking
                                    offset++;
                                }
                                this.remuxer.remux(track, {
                                    samples: []
                                }, {
                                    samples: id3Samples,
                                    inputTimeScale: 90000
                                }, {
                                    samples: []
                                }, timeOffset, contiguous, accurateTimeOffset);
                            };
                            _proto.destroy = function destroy() {};
                            return AACDemuxer;
                        }();
                        /* harmony default export */ var aacdemuxer = aacdemuxer_AACDemuxer;
                        // EXTERNAL MODULE: ./src/demux/mp4demuxer.js
                        var mp4demuxer = __webpack_require__("./src/demux/mp4demuxer.js");
                        // CONCATENATED MODULE: ./src/demux/mpegaudio.js
                        /**
 *  MPEG parser helper
 */ var MpegAudio = {
                            BitratesMap: [
                                32,
                                64,
                                96,
                                128,
                                160,
                                192,
                                224,
                                256,
                                288,
                                320,
                                352,
                                384,
                                416,
                                448,
                                32,
                                48,
                                56,
                                64,
                                80,
                                96,
                                112,
                                128,
                                160,
                                192,
                                224,
                                256,
                                320,
                                384,
                                32,
                                40,
                                48,
                                56,
                                64,
                                80,
                                96,
                                112,
                                128,
                                160,
                                192,
                                224,
                                256,
                                320,
                                32,
                                48,
                                56,
                                64,
                                80,
                                96,
                                112,
                                128,
                                144,
                                160,
                                176,
                                192,
                                224,
                                256,
                                8,
                                16,
                                24,
                                32,
                                40,
                                48,
                                56,
                                64,
                                80,
                                96,
                                112,
                                128,
                                144,
                                160
                            ],
                            SamplingRateMap: [
                                44100,
                                48000,
                                32000,
                                22050,
                                24000,
                                16000,
                                11025,
                                12000,
                                8000
                            ],
                            SamplesCoefficients: [
                                [
                                    0,
                                    72,
                                    144,
                                    12 // Layer1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    0 // Layer1
                                ],
                                [
                                    0,
                                    72,
                                    144,
                                    12 // Layer1
                                ],
                                [
                                    0,
                                    144,
                                    144,
                                    12 // Layer1
                                ]
                            ],
                            BytesInSlot: [
                                0,
                                1,
                                1,
                                4 // Layer1
                            ],
                            appendFrame: function appendFrame(track, data, offset, pts, frameIndex) {
                                // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
                                if (offset + 24 > data.length) return undefined;
                                var header = this.parseHeader(data, offset);
                                if (header && offset + header.frameLength <= data.length) {
                                    var frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
                                    var stamp = pts + frameIndex * frameDuration;
                                    var sample = {
                                        unit: data.subarray(offset, offset + header.frameLength),
                                        pts: stamp,
                                        dts: stamp
                                    };
                                    track.config = [];
                                    track.channelCount = header.channelCount;
                                    track.samplerate = header.sampleRate;
                                    track.samples.push(sample);
                                    return {
                                        sample: sample,
                                        length: header.frameLength
                                    };
                                }
                                return undefined;
                            },
                            parseHeader: function parseHeader(data, offset) {
                                var headerB = data[offset + 1] >> 3 & 3;
                                var headerC = data[offset + 1] >> 1 & 3;
                                var headerE = data[offset + 2] >> 4 & 15;
                                var headerF = data[offset + 2] >> 2 & 3;
                                var headerG = data[offset + 2] >> 1 & 1;
                                if (headerB !== 1 && headerE !== 0 && headerE !== 15 && headerF !== 3) {
                                    var columnInBitrates = headerB === 3 ? 3 - headerC : headerC === 3 ? 3 : 4;
                                    var bitRate = MpegAudio.BitratesMap[columnInBitrates * 14 + headerE - 1] * 1000;
                                    var columnInSampleRates = headerB === 3 ? 0 : headerB === 2 ? 1 : 2;
                                    var sampleRate = MpegAudio.SamplingRateMap[columnInSampleRates * 3 + headerF];
                                    var channelCount = data[offset + 3] >> 6 === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
                                    var sampleCoefficient = MpegAudio.SamplesCoefficients[headerB][headerC];
                                    var bytesInSlot = MpegAudio.BytesInSlot[headerC];
                                    var samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
                                    var frameLength = parseInt(sampleCoefficient * bitRate / sampleRate + headerG, 10) * bytesInSlot;
                                    return {
                                        sampleRate: sampleRate,
                                        channelCount: channelCount,
                                        frameLength: frameLength,
                                        samplesPerFrame: samplesPerFrame
                                    };
                                }
                                return undefined;
                            },
                            isHeaderPattern: function isHeaderPattern(data, offset) {
                                return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
                            },
                            isHeader: function isHeader(data, offset) {
                                // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
                                // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
                                // More info http://www.mp3-tech.org/programmer/frame_header.html
                                if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) return true;
                                return false;
                            },
                            probe: function probe(data, offset) {
                                // same as isHeader but we also check that MPEG frame follows last MPEG frame
                                // or end of data is reached
                                if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) {
                                    // MPEG header Length
                                    var headerLength = 4; // MPEG frame Length
                                    var header = this.parseHeader(data, offset);
                                    var frameLength = headerLength;
                                    if (header && header.frameLength) frameLength = header.frameLength;
                                    var newOffset = offset + frameLength;
                                    if (newOffset === data.length || newOffset + 1 < data.length && this.isHeaderPattern(data, newOffset)) return true;
                                }
                                return false;
                            }
                        };
                        /* harmony default export */ var mpegaudio = MpegAudio;
                        // CONCATENATED MODULE: ./src/demux/exp-golomb.js
                        /**
 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
*/ var exp_golomb_ExpGolomb = /*#__PURE__*/ function() {
                            function ExpGolomb(data) {
                                this.data = data; // the number of bytes left to examine in this.data
                                this.bytesAvailable = data.byteLength; // the current word being examined
                                this.word = 0; // :uint
                                // the number of bits left to examine in the current word
                                this.bitsAvailable = 0; // :uint
                            } // ():void
                            var _proto = ExpGolomb.prototype;
                            _proto.loadWord = function loadWord() {
                                var data = this.data, bytesAvailable = this.bytesAvailable, position = data.byteLength - bytesAvailable, workingBytes = new Uint8Array(4), availableBytes = Math.min(4, bytesAvailable);
                                if (availableBytes === 0) throw new Error('no bytes available');
                                workingBytes.set(data.subarray(position, position + availableBytes));
                                this.word = new DataView(workingBytes.buffer).getUint32(0); // track the amount of this.data that has been processed
                                this.bitsAvailable = availableBytes * 8;
                                this.bytesAvailable -= availableBytes;
                            } // (count:int):void
                            ;
                            _proto.skipBits = function skipBits(count) {
                                var skipBytes; // :int
                                if (this.bitsAvailable > count) {
                                    this.word <<= count;
                                    this.bitsAvailable -= count;
                                } else {
                                    count -= this.bitsAvailable;
                                    skipBytes = count >> 3;
                                    count -= skipBytes >> 3;
                                    this.bytesAvailable -= skipBytes;
                                    this.loadWord();
                                    this.word <<= count;
                                    this.bitsAvailable -= count;
                                }
                            } // (size:int):uint
                            ;
                            _proto.readBits = function readBits(size) {
                                var bits = Math.min(this.bitsAvailable, size), // :uint
                                valu = this.word >>> 32 - bits; // :uint
                                if (size > 32) logger["logger"].error('Cannot read more than 32 bits at a time');
                                this.bitsAvailable -= bits;
                                if (this.bitsAvailable > 0) this.word <<= bits;
                                else if (this.bytesAvailable > 0) this.loadWord();
                                bits = size - bits;
                                if (bits > 0 && this.bitsAvailable) return valu << bits | this.readBits(bits);
                                else return valu;
                            } // ():uint
                            ;
                            _proto.skipLZ = function skipLZ() {
                                var leadingZeroCount; // :uint
                                for(leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount)if ((this.word & 0x80000000 >>> leadingZeroCount) !== 0) {
                                    // the first bit of working word is 1
                                    this.word <<= leadingZeroCount;
                                    this.bitsAvailable -= leadingZeroCount;
                                    return leadingZeroCount;
                                }
                                 // we exhausted word and still have not found a 1
                                this.loadWord();
                                return leadingZeroCount + this.skipLZ();
                            } // ():void
                            ;
                            _proto.skipUEG = function skipUEG() {
                                this.skipBits(1 + this.skipLZ());
                            } // ():void
                            ;
                            _proto.skipEG = function skipEG() {
                                this.skipBits(1 + this.skipLZ());
                            } // ():uint
                            ;
                            _proto.readUEG = function readUEG() {
                                var clz = this.skipLZ(); // :uint
                                return this.readBits(clz + 1) - 1;
                            } // ():int
                            ;
                            _proto.readEG = function readEG() {
                                var valu = this.readUEG(); // :int
                                if (0x01 & valu) // the number is odd if the low order bit is set
                                return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
                                else return -1 * (valu >>> 1); // divide by two then make it negative
                            } // Some convenience functions
                            ;
                            _proto.readBoolean = function readBoolean() {
                                return this.readBits(1) === 1;
                            } // ():int
                            ;
                            _proto.readUByte = function readUByte() {
                                return this.readBits(8);
                            } // ():int
                            ;
                            _proto.readUShort = function readUShort() {
                                return this.readBits(16);
                            } // ():int
                            ;
                            _proto.readUInt = function readUInt() {
                                return this.readBits(32);
                            };
                            _proto.skipScalingList = function skipScalingList(count) {
                                var lastScale = 8, nextScale = 8, j, deltaScale;
                                for(j = 0; j < count; j++){
                                    if (nextScale !== 0) {
                                        deltaScale = this.readEG();
                                        nextScale = (lastScale + deltaScale + 256) % 256;
                                    }
                                    lastScale = nextScale === 0 ? lastScale : nextScale;
                                }
                            };
                            _proto.readSPS = function readSPS() {
                                var frameCropLeftOffset = 0, frameCropRightOffset = 0, frameCropTopOffset = 0, frameCropBottomOffset = 0, profileIdc, profileCompat, levelIdc, numRefFramesInPicOrderCntCycle, picWidthInMbsMinus1, picHeightInMapUnitsMinus1, frameMbsOnlyFlag, scalingListCount, i, readUByte = this.readUByte.bind(this), readBits = this.readBits.bind(this), readUEG = this.readUEG.bind(this), readBoolean = this.readBoolean.bind(this), skipBits = this.skipBits.bind(this), skipEG = this.skipEG.bind(this), skipUEG = this.skipUEG.bind(this), skipScalingList = this.skipScalingList.bind(this);
                                readUByte();
                                profileIdc = readUByte(); // profile_idc
                                profileCompat = readBits(5); // constraint_set[0-4]_flag, u(5)
                                skipBits(3); // reserved_zero_3bits u(3),
                                levelIdc = readUByte(); // level_idc u(8)
                                skipUEG(); // seq_parameter_set_id
                                // some profiles have more optional data we don't need
                                if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
                                    var chromaFormatIdc = readUEG();
                                    if (chromaFormatIdc === 3) skipBits(1);
                                     // separate_colour_plane_flag
                                    skipUEG(); // bit_depth_luma_minus8
                                    skipUEG(); // bit_depth_chroma_minus8
                                    skipBits(1); // qpprime_y_zero_transform_bypass_flag
                                    if (readBoolean()) {
                                        // seq_scaling_matrix_present_flag
                                        scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
                                        for(i = 0; i < scalingListCount; i++)if (readBoolean()) {
                                            // seq_scaling_list_present_flag[ i ]
                                            if (i < 6) skipScalingList(16);
                                            else skipScalingList(64);
                                        }
                                    }
                                }
                                skipUEG(); // log2_max_frame_num_minus4
                                var picOrderCntType = readUEG();
                                if (picOrderCntType === 0) readUEG(); // log2_max_pic_order_cnt_lsb_minus4
                                else if (picOrderCntType === 1) {
                                    skipBits(1); // delta_pic_order_always_zero_flag
                                    skipEG(); // offset_for_non_ref_pic
                                    skipEG(); // offset_for_top_to_bottom_field
                                    numRefFramesInPicOrderCntCycle = readUEG();
                                    for(i = 0; i < numRefFramesInPicOrderCntCycle; i++)skipEG();
                                     // offset_for_ref_frame[ i ]
                                }
                                skipUEG(); // max_num_ref_frames
                                skipBits(1); // gaps_in_frame_num_value_allowed_flag
                                picWidthInMbsMinus1 = readUEG();
                                picHeightInMapUnitsMinus1 = readUEG();
                                frameMbsOnlyFlag = readBits(1);
                                if (frameMbsOnlyFlag === 0) skipBits(1);
                                 // mb_adaptive_frame_field_flag
                                skipBits(1); // direct_8x8_inference_flag
                                if (readBoolean()) {
                                    // frame_cropping_flag
                                    frameCropLeftOffset = readUEG();
                                    frameCropRightOffset = readUEG();
                                    frameCropTopOffset = readUEG();
                                    frameCropBottomOffset = readUEG();
                                }
                                var pixelRatio = [
                                    1,
                                    1
                                ];
                                if (readBoolean()) // vui_parameters_present_flag
                                {
                                    if (readBoolean()) {
                                        // aspect_ratio_info_present_flag
                                        var aspectRatioIdc = readUByte();
                                        switch(aspectRatioIdc){
                                            case 1:
                                                pixelRatio = [
                                                    1,
                                                    1
                                                ];
                                                break;
                                            case 2:
                                                pixelRatio = [
                                                    12,
                                                    11
                                                ];
                                                break;
                                            case 3:
                                                pixelRatio = [
                                                    10,
                                                    11
                                                ];
                                                break;
                                            case 4:
                                                pixelRatio = [
                                                    16,
                                                    11
                                                ];
                                                break;
                                            case 5:
                                                pixelRatio = [
                                                    40,
                                                    33
                                                ];
                                                break;
                                            case 6:
                                                pixelRatio = [
                                                    24,
                                                    11
                                                ];
                                                break;
                                            case 7:
                                                pixelRatio = [
                                                    20,
                                                    11
                                                ];
                                                break;
                                            case 8:
                                                pixelRatio = [
                                                    32,
                                                    11
                                                ];
                                                break;
                                            case 9:
                                                pixelRatio = [
                                                    80,
                                                    33
                                                ];
                                                break;
                                            case 10:
                                                pixelRatio = [
                                                    18,
                                                    11
                                                ];
                                                break;
                                            case 11:
                                                pixelRatio = [
                                                    15,
                                                    11
                                                ];
                                                break;
                                            case 12:
                                                pixelRatio = [
                                                    64,
                                                    33
                                                ];
                                                break;
                                            case 13:
                                                pixelRatio = [
                                                    160,
                                                    99
                                                ];
                                                break;
                                            case 14:
                                                pixelRatio = [
                                                    4,
                                                    3
                                                ];
                                                break;
                                            case 15:
                                                pixelRatio = [
                                                    3,
                                                    2
                                                ];
                                                break;
                                            case 16:
                                                pixelRatio = [
                                                    2,
                                                    1
                                                ];
                                                break;
                                            case 255:
                                                pixelRatio = [
                                                    readUByte() << 8 | readUByte(),
                                                    readUByte() << 8 | readUByte()
                                                ];
                                                break;
                                        }
                                    }
                                }
                                return {
                                    width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
                                    height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
                                    pixelRatio: pixelRatio
                                };
                            };
                            _proto.readSliceType = function readSliceType() {
                                // skip NALu type
                                this.readUByte(); // discard first_mb_in_slice
                                this.readUEG(); // return slice_type
                                return this.readUEG();
                            };
                            return ExpGolomb;
                        }();
                        /* harmony default export */ var exp_golomb = exp_golomb_ExpGolomb;
                        // CONCATENATED MODULE: ./src/demux/sample-aes.js
                        /**
 * SAMPLE-AES decrypter
*/ var sample_aes_SampleAesDecrypter = /*#__PURE__*/ function() {
                            function SampleAesDecrypter(observer, config, decryptdata, discardEPB) {
                                this.decryptdata = decryptdata;
                                this.discardEPB = discardEPB;
                                this.decrypter = new crypt_decrypter["default"](observer, config, {
                                    removePKCS7Padding: false
                                });
                            }
                            var _proto = SampleAesDecrypter.prototype;
                            _proto.decryptBuffer = function decryptBuffer(encryptedData, callback) {
                                this.decrypter.decrypt(encryptedData, this.decryptdata.key.buffer, this.decryptdata.iv.buffer, callback);
                            } // AAC - encrypt all full 16 bytes blocks starting from offset 16
                            ;
                            _proto.decryptAacSample = function decryptAacSample(samples, sampleIndex, callback, sync) {
                                var curUnit = samples[sampleIndex].unit;
                                var encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
                                var encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
                                var localthis = this;
                                this.decryptBuffer(encryptedBuffer, function(decryptedData) {
                                    decryptedData = new Uint8Array(decryptedData);
                                    curUnit.set(decryptedData, 16);
                                    if (!sync) localthis.decryptAacSamples(samples, sampleIndex + 1, callback);
                                });
                            };
                            _proto.decryptAacSamples = function decryptAacSamples(samples, sampleIndex, callback) {
                                for(;; sampleIndex++){
                                    if (sampleIndex >= samples.length) {
                                        callback();
                                        return;
                                    }
                                    if (samples[sampleIndex].unit.length < 32) continue;
                                    var sync = this.decrypter.isSync();
                                    this.decryptAacSample(samples, sampleIndex, callback, sync);
                                    if (!sync) return;
                                }
                            } // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
                            ;
                            _proto.getAvcEncryptedData = function getAvcEncryptedData(decodedData) {
                                var encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
                                var encryptedData = new Int8Array(encryptedDataLen);
                                var outputPos = 0;
                                for(var inputPos = 32; inputPos <= decodedData.length - 16; inputPos += 160, outputPos += 16)encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
                                return encryptedData;
                            };
                            _proto.getAvcDecryptedUnit = function getAvcDecryptedUnit(decodedData, decryptedData) {
                                decryptedData = new Uint8Array(decryptedData);
                                var inputPos = 0;
                                for(var outputPos = 32; outputPos <= decodedData.length - 16; outputPos += 160, inputPos += 16)decodedData.set(decryptedData.subarray(inputPos, inputPos + 16), outputPos);
                                return decodedData;
                            };
                            _proto.decryptAvcSample = function decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync) {
                                var decodedData = this.discardEPB(curUnit.data);
                                var encryptedData = this.getAvcEncryptedData(decodedData);
                                var localthis = this;
                                this.decryptBuffer(encryptedData.buffer, function(decryptedData) {
                                    curUnit.data = localthis.getAvcDecryptedUnit(decodedData, decryptedData);
                                    if (!sync) localthis.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
                                });
                            };
                            _proto.decryptAvcSamples = function decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
                                for(;; sampleIndex++, unitIndex = 0){
                                    if (sampleIndex >= samples.length) {
                                        callback();
                                        return;
                                    }
                                    var curUnits = samples[sampleIndex].units;
                                    for(;; unitIndex++){
                                        if (unitIndex >= curUnits.length) break;
                                        var curUnit = curUnits[unitIndex];
                                        if (curUnit.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) continue;
                                        var sync = this.decrypter.isSync();
                                        this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync);
                                        if (!sync) return;
                                    }
                                }
                            };
                            return SampleAesDecrypter;
                        }();
                        /* harmony default export */ var sample_aes = sample_aes_SampleAesDecrypter;
                        // CONCATENATED MODULE: ./src/demux/tsdemuxer.js
                        /**
 * highly optimized TS demuxer:
 * parse PAT, PMT
 * extract PES packet from audio and video PIDs
 * extract AVC/H264 NAL units and AAC/ADTS samples from PES packet
 * trigger the remuxer upon parsing completion
 * it also tries to workaround as best as it can audio codec switch (HE-AAC to AAC and vice versa), without having to restart the MediaSource.
 * it also controls the remuxing process :
 * upon discontinuity or level switch detection, it will also notifies the remuxer so that it can reset its state.
*/ // import Hex from '../utils/hex';
                        // We are using fixed track IDs for driving the MP4 remuxer
                        // instead of following the TS PIDs.
                        // There is no reason not to do this and some browsers/SourceBuffer-demuxers
                        // may not like if there are TrackID "switches"
                        // See https://github.com/video-dev/hls.js/issues/1331
                        // Here we are mapping our internal track types to constant MP4 track IDs
                        // With MSE currently one can only have one track of each, and we are muxing
                        // whatever video/audio rendition in them.
                        var RemuxerTrackIdConfig = {
                            video: 1,
                            audio: 2,
                            id3: 3,
                            text: 4
                        };
                        var tsdemuxer_TSDemuxer = /*#__PURE__*/ function() {
                            function TSDemuxer(observer, remuxer, config, typeSupported) {
                                this.observer = observer;
                                this.config = config;
                                this.typeSupported = typeSupported;
                                this.remuxer = remuxer;
                                this.sampleAes = null;
                            }
                            var _proto = TSDemuxer.prototype;
                            _proto.setDecryptData = function setDecryptData(decryptdata) {
                                if (decryptdata != null && decryptdata.key != null && decryptdata.method === 'SAMPLE-AES') this.sampleAes = new sample_aes(this.observer, this.config, decryptdata, this.discardEPB);
                                else this.sampleAes = null;
                            };
                            TSDemuxer.probe = function probe(data) {
                                var syncOffset = TSDemuxer._syncOffset(data);
                                if (syncOffset < 0) return false;
                                else {
                                    if (syncOffset) logger["logger"].warn("MPEG2-TS detected but first sync word found @ offset " + syncOffset + ", junk ahead ?");
                                    return true;
                                }
                            };
                            TSDemuxer._syncOffset = function _syncOffset(data) {
                                // scan 1000 first bytes
                                var scanwindow = Math.min(1000, data.length - 564);
                                var i = 0;
                                while(i < scanwindow){
                                    // a TS fragment should contain at least 3 TS packets, a PAT, a PMT, and one PID, each starting with 0x47
                                    if (data[i] === 0x47 && data[i + 188] === 0x47 && data[i + 376] === 0x47) return i;
                                    else i++;
                                }
                                return -1;
                            };
                            TSDemuxer.createTrack = function createTrack(type, duration) {
                                return {
                                    container: type === 'video' || type === 'audio' ? 'video/mp2t' : undefined,
                                    type: type,
                                    id: RemuxerTrackIdConfig[type],
                                    pid: -1,
                                    inputTimeScale: 90000,
                                    sequenceNumber: 0,
                                    samples: [],
                                    dropped: type === 'video' ? 0 : undefined,
                                    isAAC: type === 'audio' ? true : undefined,
                                    duration: type === 'audio' ? duration : undefined
                                };
                            };
                            _proto.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
                                this.pmtParsed = false;
                                this._pmtId = -1;
                                this._avcTrack = TSDemuxer.createTrack('video', duration);
                                this._audioTrack = TSDemuxer.createTrack('audio', duration);
                                this._id3Track = TSDemuxer.createTrack('id3', duration);
                                this._txtTrack = TSDemuxer.createTrack('text', duration); // flush any partial content
                                this.aacOverFlow = null;
                                this.aacLastPTS = null;
                                this.avcSample = null;
                                this.audioCodec = audioCodec;
                                this.videoCodec = videoCodec;
                                this._duration = duration;
                            };
                            _proto.resetTimeStamp = function resetTimeStamp() {} // feed incoming data to the front of the parsing pipeline
                            ;
                            _proto.append = function append(data, timeOffset, contiguous, accurateTimeOffset) {
                                var start, len = data.length, stt, pid, atf, offset, pes, unknownPIDs = false;
                                this.contiguous = contiguous;
                                var pmtParsed = this.pmtParsed, avcTrack = this._avcTrack, audioTrack = this._audioTrack, id3Track = this._id3Track, avcId = avcTrack.pid, audioId = audioTrack.pid, id3Id = id3Track.pid, pmtId = this._pmtId, avcData = avcTrack.pesData, audioData = audioTrack.pesData, id3Data = id3Track.pesData, parsePAT = this._parsePAT, parsePMT = this._parsePMT, parsePES = this._parsePES, parseAVCPES = this._parseAVCPES.bind(this), parseAACPES = this._parseAACPES.bind(this), parseMPEGPES = this._parseMPEGPES.bind(this), parseID3PES = this._parseID3PES.bind(this);
                                var syncOffset = TSDemuxer._syncOffset(data); // don't parse last TS packet if incomplete
                                len -= (len + syncOffset) % 188; // loop through TS packets
                                for(start = syncOffset; start < len; start += 188)if (data[start] === 0x47) {
                                    stt = !!(data[start + 1] & 0x40); // pid is a 13-bit field starting at the last bit of TS[1]
                                    pid = ((data[start + 1] & 0x1f) << 8) + data[start + 2];
                                    atf = (data[start + 3] & 0x30) >> 4; // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
                                    if (atf > 1) {
                                        offset = start + 5 + data[start + 4]; // continue if there is only adaptation field
                                        if (offset === start + 188) continue;
                                    } else offset = start + 4;
                                    switch(pid){
                                        case avcId:
                                            if (stt) {
                                                if (avcData && (pes = parsePES(avcData))) parseAVCPES(pes, false);
                                                avcData = {
                                                    data: [],
                                                    size: 0
                                                };
                                            }
                                            if (avcData) {
                                                avcData.data.push(data.subarray(offset, start + 188));
                                                avcData.size += start + 188 - offset;
                                            }
                                            break;
                                        case audioId:
                                            if (stt) {
                                                if (audioData && (pes = parsePES(audioData))) {
                                                    if (audioTrack.isAAC) parseAACPES(pes);
                                                    else parseMPEGPES(pes);
                                                }
                                                audioData = {
                                                    data: [],
                                                    size: 0
                                                };
                                            }
                                            if (audioData) {
                                                audioData.data.push(data.subarray(offset, start + 188));
                                                audioData.size += start + 188 - offset;
                                            }
                                            break;
                                        case id3Id:
                                            if (stt) {
                                                if (id3Data && (pes = parsePES(id3Data))) parseID3PES(pes);
                                                id3Data = {
                                                    data: [],
                                                    size: 0
                                                };
                                            }
                                            if (id3Data) {
                                                id3Data.data.push(data.subarray(offset, start + 188));
                                                id3Data.size += start + 188 - offset;
                                            }
                                            break;
                                        case 0:
                                            if (stt) offset += data[offset] + 1;
                                            pmtId = this._pmtId = parsePAT(data, offset);
                                            break;
                                        case pmtId:
                                            if (stt) offset += data[offset] + 1;
                                            var parsedPIDs = parsePMT(data, offset, this.typeSupported.mpeg === true || this.typeSupported.mp3 === true, this.sampleAes != null); // only update track id if track PID found while parsing PMT
                                            // this is to avoid resetting the PID to -1 in case
                                            // track PID transiently disappears from the stream
                                            // this could happen in case of transient missing audio samples for example
                                            // NOTE this is only the PID of the track as found in TS,
                                            // but we are not using this for MP4 track IDs.
                                            avcId = parsedPIDs.avc;
                                            if (avcId > 0) avcTrack.pid = avcId;
                                            audioId = parsedPIDs.audio;
                                            if (audioId > 0) {
                                                audioTrack.pid = audioId;
                                                audioTrack.isAAC = parsedPIDs.isAAC;
                                            }
                                            id3Id = parsedPIDs.id3;
                                            if (id3Id > 0) id3Track.pid = id3Id;
                                            if (unknownPIDs && !pmtParsed) {
                                                logger["logger"].log('reparse from beginning');
                                                unknownPIDs = false; // we set it to -188, the += 188 in the for loop will reset start to 0
                                                start = syncOffset - 188;
                                            }
                                            pmtParsed = this.pmtParsed = true;
                                            break;
                                        case 17:
                                        case 0x1fff:
                                            break;
                                        default:
                                            unknownPIDs = true;
                                            break;
                                    }
                                } else this.observer.trigger(events["default"].ERROR, {
                                    type: errors["ErrorTypes"].MEDIA_ERROR,
                                    details: errors["ErrorDetails"].FRAG_PARSING_ERROR,
                                    fatal: false,
                                    reason: 'TS packet did not start with 0x47'
                                });
                                 // try to parse last PES packets
                                if (avcData && (pes = parsePES(avcData))) {
                                    parseAVCPES(pes, true);
                                    avcTrack.pesData = null;
                                } else // either avcData null or PES truncated, keep it for next frag parsing
                                avcTrack.pesData = avcData;
                                if (audioData && (pes = parsePES(audioData))) {
                                    if (audioTrack.isAAC) parseAACPES(pes);
                                    else parseMPEGPES(pes);
                                    audioTrack.pesData = null;
                                } else {
                                    if (audioData && audioData.size) logger["logger"].log('last AAC PES packet truncated,might overlap between fragments');
                                     // either audioData null or PES truncated, keep it for next frag parsing
                                    audioTrack.pesData = audioData;
                                }
                                if (id3Data && (pes = parsePES(id3Data))) {
                                    parseID3PES(pes);
                                    id3Track.pesData = null;
                                } else // either id3Data null or PES truncated, keep it for next frag parsing
                                id3Track.pesData = id3Data;
                                if (this.sampleAes == null) this.remuxer.remux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
                                else this.decryptAndRemux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
                            };
                            _proto.decryptAndRemux = function decryptAndRemux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
                                if (audioTrack.samples && audioTrack.isAAC) {
                                    var localthis = this;
                                    this.sampleAes.decryptAacSamples(audioTrack.samples, 0, function() {
                                        localthis.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
                                    });
                                } else this.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
                            };
                            _proto.decryptAndRemuxAvc = function decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
                                if (videoTrack.samples) {
                                    var localthis = this;
                                    this.sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, function() {
                                        localthis.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
                                    });
                                } else this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
                            };
                            _proto.destroy = function destroy() {
                                this._initPTS = this._initDTS = undefined;
                                this._duration = 0;
                            };
                            _proto._parsePAT = function _parsePAT(data, offset) {
                                // skip the PSI header and parse the first PMT entry
                                return (data[offset + 10] & 0x1F) << 8 | data[offset + 11]; // logger.log('PMT PID:'  + this._pmtId);
                            };
                            _proto._parsePMT = function _parsePMT(data, offset, mpegSupported, isSampleAes) {
                                var sectionLength, tableEnd, programInfoLength, pid, result = {
                                    audio: -1,
                                    avc: -1,
                                    id3: -1,
                                    isAAC: true
                                };
                                sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
                                tableEnd = offset + 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
                                // long the program info descriptors are
                                programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11]; // advance the offset to the first entry in the mapping table
                                offset += 12 + programInfoLength;
                                while(offset < tableEnd){
                                    pid = (data[offset + 1] & 0x1F) << 8 | data[offset + 2];
                                    switch(data[offset]){
                                        case 0xcf:
                                            // SAMPLE-AES AAC
                                            if (!isSampleAes) {
                                                logger["logger"].log('unknown stream type:' + data[offset]);
                                                break;
                                            }
                                        /* falls through */ // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
                                        case 0x0f:
                                            // logger.log('AAC PID:'  + pid);
                                            if (result.audio === -1) result.audio = pid;
                                            break;
                                        // Packetized metadata (ID3)
                                        case 0x15:
                                            // logger.log('ID3 PID:'  + pid);
                                            if (result.id3 === -1) result.id3 = pid;
                                            break;
                                        case 0xdb:
                                            // SAMPLE-AES AVC
                                            if (!isSampleAes) {
                                                logger["logger"].log('unknown stream type:' + data[offset]);
                                                break;
                                            }
                                        /* falls through */ // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
                                        case 0x1b:
                                            // logger.log('AVC PID:'  + pid);
                                            if (result.avc === -1) result.avc = pid;
                                            break;
                                        // ISO/IEC 11172-3 (MPEG-1 audio)
                                        // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
                                        case 0x03:
                                        case 0x04:
                                            // logger.log('MPEG PID:'  + pid);
                                            if (!mpegSupported) logger["logger"].log('MPEG audio found, not supported in this browser for now');
                                            else if (result.audio === -1) {
                                                result.audio = pid;
                                                result.isAAC = false;
                                            }
                                            break;
                                        case 0x24:
                                            logger["logger"].warn('HEVC stream type found, not supported for now');
                                            break;
                                        default:
                                            logger["logger"].log('unknown stream type:' + data[offset]);
                                            break;
                                    } // move to the next table entry
                                    // skip past the elementary stream descriptors, if present
                                    offset += ((data[offset + 3] & 0x0F) << 8 | data[offset + 4]) + 5;
                                }
                                return result;
                            };
                            _proto._parsePES = function _parsePES(stream) {
                                var i = 0, frag, pesFlags, pesPrefix, pesLen, pesHdrLen, pesData, pesPts, pesDts, payloadStartOffset, data = stream.data; // safety check
                                if (!stream || stream.size === 0) return null;
                                 // we might need up to 19 bytes to read PES header
                                // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
                                // usually only one merge is needed (and this is rare ...)
                                while(data[0].length < 19 && data.length > 1){
                                    var newData = new Uint8Array(data[0].length + data[1].length);
                                    newData.set(data[0]);
                                    newData.set(data[1], data[0].length);
                                    data[0] = newData;
                                    data.splice(1, 1);
                                } // retrieve PTS/DTS from first fragment
                                frag = data[0];
                                pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
                                if (pesPrefix === 1) {
                                    pesLen = (frag[4] << 8) + frag[5]; // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
                                    // minus 6 : PES header size
                                    if (pesLen && pesLen > stream.size - 6) return null;
                                    pesFlags = frag[7];
                                    if (pesFlags & 0xC0) {
                                        /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
            as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
            as Bitwise operators treat their operands as a sequence of 32 bits */ pesPts = (frag[9] & 0x0E) * 536870912 + // 1 << 29
                                        (frag[10] & 0xFF) * 4194304 + // 1 << 22
                                        (frag[11] & 0xFE) * 16384 + // 1 << 14
                                        (frag[12] & 0xFF) * 128 + // 1 << 7
                                        (frag[13] & 0xFE) / 2; // check if greater than 2^32 -1
                                        if (pesPts > 4294967295) // decrement 2^33
                                        pesPts -= 8589934592;
                                        if (pesFlags & 0x40) {
                                            pesDts = (frag[14] & 0x0E) * 536870912 + // 1 << 29
                                            (frag[15] & 0xFF) * 4194304 + // 1 << 22
                                            (frag[16] & 0xFE) * 16384 + // 1 << 14
                                            (frag[17] & 0xFF) * 128 + // 1 << 7
                                            (frag[18] & 0xFE) / 2; // check if greater than 2^32 -1
                                            if (pesDts > 4294967295) // decrement 2^33
                                            pesDts -= 8589934592;
                                            if (pesPts - pesDts > 5400000) {
                                                logger["logger"].warn(Math.round((pesPts - pesDts) / 90000) + "s delta between PTS and DTS, align them");
                                                pesPts = pesDts;
                                            }
                                        } else pesDts = pesPts;
                                    }
                                    pesHdrLen = frag[8]; // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
                                    payloadStartOffset = pesHdrLen + 9;
                                    if (stream.size <= payloadStartOffset) return null;
                                    stream.size -= payloadStartOffset; // reassemble PES packet
                                    pesData = new Uint8Array(stream.size);
                                    for(var j = 0, dataLen = data.length; j < dataLen; j++){
                                        frag = data[j];
                                        var len = frag.byteLength;
                                        if (payloadStartOffset) {
                                            if (payloadStartOffset > len) {
                                                // trim full frag if PES header bigger than frag
                                                payloadStartOffset -= len;
                                                continue;
                                            } else {
                                                // trim partial frag if PES header smaller than frag
                                                frag = frag.subarray(payloadStartOffset);
                                                len -= payloadStartOffset;
                                                payloadStartOffset = 0;
                                            }
                                        }
                                        pesData.set(frag, i);
                                        i += len;
                                    }
                                    if (pesLen) // payload size : remove PES header + PES extension
                                    pesLen -= pesHdrLen + 3;
                                    return {
                                        data: pesData,
                                        pts: pesPts,
                                        dts: pesDts,
                                        len: pesLen
                                    };
                                } else return null;
                            };
                            _proto.pushAccesUnit = function pushAccesUnit(avcSample, avcTrack) {
                                if (avcSample.units.length && avcSample.frame) {
                                    var samples = avcTrack.samples;
                                    var nbSamples = samples.length; // if sample does not have PTS/DTS, patch with last sample PTS/DTS
                                    if (isNaN(avcSample.pts)) {
                                        if (nbSamples) {
                                            var lastSample = samples[nbSamples - 1];
                                            avcSample.pts = lastSample.pts;
                                            avcSample.dts = lastSample.dts;
                                        } else {
                                            // dropping samples, no timestamp found
                                            avcTrack.dropped++;
                                            return;
                                        }
                                    } // only push AVC sample if starting with a keyframe is not mandatory OR
                                    //    if keyframe already found in this fragment OR
                                    //       keyframe found in last fragment (track.sps) AND
                                    //          samples already appended (we already found a keyframe in this fragment) OR fragment is contiguous
                                    if (!this.config.forceKeyFrameOnDiscontinuity || avcSample.key === true || avcTrack.sps && (nbSamples || this.contiguous)) {
                                        avcSample.id = nbSamples;
                                        samples.push(avcSample);
                                    } else // dropped samples, track it
                                    avcTrack.dropped++;
                                }
                                if (avcSample.debug.length) logger["logger"].log(avcSample.pts + '/' + avcSample.dts + ':' + avcSample.debug);
                            };
                            _proto._parseAVCPES = function _parseAVCPES(pes, last) {
                                var _this = this;
                                // logger.log('parse new PES');
                                var track = this._avcTrack, units = this._parseAVCNALu(pes.data), debug = false, expGolombDecoder, avcSample = this.avcSample, push, spsfound = false, i, pushAccesUnit = this.pushAccesUnit.bind(this), createAVCSample = function createAVCSample(key, pts, dts, debug) {
                                    return {
                                        key: key,
                                        pts: pts,
                                        dts: dts,
                                        units: [],
                                        debug: debug
                                    };
                                }; // free pes.data to save up some memory
                                pes.data = null; // if new NAL units found and last sample still there, let's push ...
                                // this helps parsing streams with missing AUD (only do this if AUD never found)
                                if (avcSample && units.length && !track.audFound) {
                                    pushAccesUnit(avcSample, track);
                                    avcSample = this.avcSample = createAVCSample(false, pes.pts, pes.dts, '');
                                }
                                units.forEach(function(unit) {
                                    switch(unit.type){
                                        // NDR
                                        case 1:
                                            push = true;
                                            if (!avcSample) avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');
                                            if (debug) avcSample.debug += 'NDR ';
                                            avcSample.frame = true;
                                            var data = unit.data; // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
                                            if (spsfound && data.length > 4) {
                                                // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
                                                var sliceType = new exp_golomb(data).readSliceType(); // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
                                                // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
                                                // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
                                                // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
                                                // if (sliceType === 2 || sliceType === 7) {
                                                if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) avcSample.key = true;
                                            }
                                            break;
                                        // IDR
                                        case 5:
                                            push = true; // handle PES not starting with AUD
                                            if (!avcSample) avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');
                                            if (debug) avcSample.debug += 'IDR ';
                                            avcSample.key = true;
                                            avcSample.frame = true;
                                            break;
                                        // SEI
                                        case 6:
                                            push = true;
                                            if (debug && avcSample) avcSample.debug += 'SEI ';
                                            expGolombDecoder = new exp_golomb(_this.discardEPB(unit.data)); // skip frameType
                                            expGolombDecoder.readUByte();
                                            var payloadType = 0;
                                            var payloadSize = 0;
                                            var endOfCaptions = false;
                                            var b = 0;
                                            while(!endOfCaptions && expGolombDecoder.bytesAvailable > 1){
                                                payloadType = 0;
                                                do {
                                                    b = expGolombDecoder.readUByte();
                                                    payloadType += b;
                                                }while (b === 0xFF); // Parse payload size.
                                                payloadSize = 0;
                                                do {
                                                    b = expGolombDecoder.readUByte();
                                                    payloadSize += b;
                                                }while (b === 0xFF); // TODO: there can be more than one payload in an SEI packet...
                                                // TODO: need to read type and size in a while loop to get them all
                                                if (payloadType === 4 && expGolombDecoder.bytesAvailable !== 0) {
                                                    endOfCaptions = true;
                                                    var countryCode = expGolombDecoder.readUByte();
                                                    if (countryCode === 181) {
                                                        var providerCode = expGolombDecoder.readUShort();
                                                        if (providerCode === 49) {
                                                            var userStructure = expGolombDecoder.readUInt();
                                                            if (userStructure === 0x47413934) {
                                                                var userDataType = expGolombDecoder.readUByte(); // Raw CEA-608 bytes wrapped in CEA-708 packet
                                                                if (userDataType === 3) {
                                                                    var firstByte = expGolombDecoder.readUByte();
                                                                    var secondByte = expGolombDecoder.readUByte();
                                                                    var totalCCs = 31 & firstByte;
                                                                    var byteArray = [
                                                                        firstByte,
                                                                        secondByte
                                                                    ];
                                                                    for(i = 0; i < totalCCs; i++){
                                                                        // 3 bytes per CC
                                                                        byteArray.push(expGolombDecoder.readUByte());
                                                                        byteArray.push(expGolombDecoder.readUByte());
                                                                        byteArray.push(expGolombDecoder.readUByte());
                                                                    }
                                                                    _this._insertSampleInOrder(_this._txtTrack.samples, {
                                                                        type: 3,
                                                                        pts: pes.pts,
                                                                        bytes: byteArray
                                                                    });
                                                                }
                                                            }
                                                        }
                                                    }
                                                } else if (payloadType === 5 && expGolombDecoder.bytesAvailable !== 0) {
                                                    endOfCaptions = true;
                                                    if (payloadSize > 16) {
                                                        var uuidStrArray = [];
                                                        for(i = 0; i < 16; i++){
                                                            uuidStrArray.push(expGolombDecoder.readUByte().toString(16));
                                                            if (i === 3 || i === 5 || i === 7 || i === 9) uuidStrArray.push('-');
                                                        }
                                                        var length = payloadSize - 16;
                                                        var userDataPayloadBytes = new Uint8Array(length);
                                                        for(i = 0; i < length; i++)userDataPayloadBytes[i] = expGolombDecoder.readUByte();
                                                        _this._insertSampleInOrder(_this._txtTrack.samples, {
                                                            pts: pes.pts,
                                                            payloadType: payloadType,
                                                            uuid: uuidStrArray.join(''),
                                                            userDataBytes: userDataPayloadBytes,
                                                            userData: Object(id3["utf8ArrayToStr"])(userDataPayloadBytes.buffer)
                                                        });
                                                    }
                                                } else if (payloadSize < expGolombDecoder.bytesAvailable) for(i = 0; i < payloadSize; i++)expGolombDecoder.readUByte();
                                            }
                                            break;
                                        // SPS
                                        case 7:
                                            push = true;
                                            spsfound = true;
                                            if (debug && avcSample) avcSample.debug += 'SPS ';
                                            if (!track.sps) {
                                                expGolombDecoder = new exp_golomb(unit.data);
                                                var config = expGolombDecoder.readSPS();
                                                track.width = config.width;
                                                track.height = config.height;
                                                track.pixelRatio = config.pixelRatio;
                                                track.sps = [
                                                    unit.data
                                                ];
                                                track.duration = _this._duration;
                                                var codecarray = unit.data.subarray(1, 4);
                                                var codecstring = 'avc1.';
                                                for(i = 0; i < 3; i++){
                                                    var h = codecarray[i].toString(16);
                                                    if (h.length < 2) h = '0' + h;
                                                    codecstring += h;
                                                }
                                                track.codec = codecstring;
                                            }
                                            break;
                                        // PPS
                                        case 8:
                                            push = true;
                                            if (debug && avcSample) avcSample.debug += 'PPS ';
                                            if (!track.pps) track.pps = [
                                                unit.data
                                            ];
                                            break;
                                        // AUD
                                        case 9:
                                            push = false;
                                            track.audFound = true;
                                            if (avcSample) pushAccesUnit(avcSample, track);
                                            avcSample = _this.avcSample = createAVCSample(false, pes.pts, pes.dts, debug ? 'AUD ' : '');
                                            break;
                                        // Filler Data
                                        case 12:
                                            push = false;
                                            break;
                                        default:
                                            push = false;
                                            if (avcSample) avcSample.debug += 'unknown NAL ' + unit.type + ' ';
                                            break;
                                    }
                                    if (avcSample && push) {
                                        var _units = avcSample.units;
                                        _units.push(unit);
                                    }
                                }); // if last PES packet, push samples
                                if (last && avcSample) {
                                    pushAccesUnit(avcSample, track);
                                    this.avcSample = null;
                                }
                            };
                            _proto._insertSampleInOrder = function _insertSampleInOrder(arr, data) {
                                var len = arr.length;
                                if (len > 0) {
                                    if (data.pts >= arr[len - 1].pts) arr.push(data);
                                    else {
                                        for(var pos = len - 1; pos >= 0; pos--)if (data.pts < arr[pos].pts) {
                                            arr.splice(pos, 0, data);
                                            break;
                                        }
                                    }
                                } else arr.push(data);
                            };
                            _proto._getLastNalUnit = function _getLastNalUnit() {
                                var avcSample = this.avcSample, lastUnit; // try to fallback to previous sample if current one is empty
                                if (!avcSample || avcSample.units.length === 0) {
                                    var track = this._avcTrack, samples = track.samples;
                                    avcSample = samples[samples.length - 1];
                                }
                                if (avcSample) {
                                    var units = avcSample.units;
                                    lastUnit = units[units.length - 1];
                                }
                                return lastUnit;
                            };
                            _proto._parseAVCNALu = function _parseAVCNALu(array) {
                                var i = 0, len = array.byteLength, value, overflow, track = this._avcTrack, state = track.naluState || 0, lastState = state;
                                var units = [], unit, unitType, lastUnitStart = -1, lastUnitType; // logger.log('PES:' + Hex.hexDump(array));
                                if (state === -1) {
                                    // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
                                    lastUnitStart = 0; // NALu type is value read from offset 0
                                    lastUnitType = array[0] & 0x1f;
                                    state = 0;
                                    i = 1;
                                }
                                while(i < len){
                                    value = array[i++]; // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
                                    if (!state) {
                                        state = value ? 0 : 1;
                                        continue;
                                    }
                                    if (state === 1) {
                                        state = value ? 0 : 2;
                                        continue;
                                    } // here we have state either equal to 2 or 3
                                    if (!value) state = 3;
                                    else if (value === 1) {
                                        if (lastUnitStart >= 0) {
                                            unit = {
                                                data: array.subarray(lastUnitStart, i - state - 1),
                                                type: lastUnitType
                                            }; // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
                                            units.push(unit);
                                        } else {
                                            // lastUnitStart is undefined => this is the first start code found in this PES packet
                                            // first check if start code delimiter is overlapping between 2 PES packets,
                                            // ie it started in last packet (lastState not zero)
                                            // and ended at the beginning of this PES packet (i <= 4 - lastState)
                                            var lastUnit = this._getLastNalUnit();
                                            if (lastUnit) {
                                                if (lastState && i <= 4 - lastState) // start delimiter overlapping between PES packets
                                                // strip start delimiter bytes from the end of last NAL unit
                                                // check if lastUnit had a state different from zero
                                                {
                                                    if (lastUnit.state) // strip last bytes
                                                    lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
                                                } // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
                                                overflow = i - state - 1;
                                                if (overflow > 0) {
                                                    // logger.log('first NALU found with overflow:' + overflow);
                                                    var tmp = new Uint8Array(lastUnit.data.byteLength + overflow);
                                                    tmp.set(lastUnit.data, 0);
                                                    tmp.set(array.subarray(0, overflow), lastUnit.data.byteLength);
                                                    lastUnit.data = tmp;
                                                }
                                            }
                                        } // check if we can read unit type
                                        if (i < len) {
                                            unitType = array[i] & 0x1f; // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
                                            lastUnitStart = i;
                                            lastUnitType = unitType;
                                            state = 0;
                                        } else // not enough byte to read unit type. let's read it on next PES parsing
                                        state = -1;
                                    } else state = 0;
                                }
                                if (lastUnitStart >= 0 && state >= 0) {
                                    unit = {
                                        data: array.subarray(lastUnitStart, len),
                                        type: lastUnitType,
                                        state: state
                                    };
                                    units.push(unit); // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
                                } // no NALu found
                                if (units.length === 0) {
                                    // append pes.data to previous NAL unit
                                    var _lastUnit = this._getLastNalUnit();
                                    if (_lastUnit) {
                                        var _tmp = new Uint8Array(_lastUnit.data.byteLength + array.byteLength);
                                        _tmp.set(_lastUnit.data, 0);
                                        _tmp.set(array, _lastUnit.data.byteLength);
                                        _lastUnit.data = _tmp;
                                    }
                                }
                                track.naluState = state;
                                return units;
                            };
                            _proto.discardEPB = function discardEPB(data) {
                                var length = data.byteLength, EPBPositions = [], i = 1, newLength, newData; // Find all `Emulation Prevention Bytes`
                                while(i < length - 2)if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
                                    EPBPositions.push(i + 2);
                                    i += 2;
                                } else i++;
                                 // If no Emulation Prevention Bytes were found just return the original
                                // array
                                if (EPBPositions.length === 0) return data;
                                 // Create a new array to hold the NAL unit data
                                newLength = length - EPBPositions.length;
                                newData = new Uint8Array(newLength);
                                var sourceIndex = 0;
                                for(i = 0; i < newLength; sourceIndex++, i++){
                                    if (sourceIndex === EPBPositions[0]) {
                                        // Skip this byte
                                        sourceIndex++; // Remove this position index
                                        EPBPositions.shift();
                                    }
                                    newData[i] = data[sourceIndex];
                                }
                                return newData;
                            };
                            _proto._parseAACPES = function _parseAACPES(pes) {
                                var track = this._audioTrack, data = pes.data, pts = pes.pts, startOffset = 0, aacOverFlow = this.aacOverFlow, aacLastPTS = this.aacLastPTS, frameDuration, frameIndex, offset, stamp, len;
                                if (aacOverFlow) {
                                    var tmp = new Uint8Array(aacOverFlow.byteLength + data.byteLength);
                                    tmp.set(aacOverFlow, 0);
                                    tmp.set(data, aacOverFlow.byteLength); // logger.log(`AAC: append overflowing ${aacOverFlow.byteLength} bytes to beginning of new PES`);
                                    data = tmp;
                                } // look for ADTS header (0xFFFx)
                                for(offset = startOffset, len = data.length; offset < len - 1; offset++){
                                    if (isHeader(data, offset)) break;
                                } // if ADTS header does not start straight from the beginning of the PES payload, raise an error
                                if (offset) {
                                    var reason, fatal;
                                    if (offset < len - 1) {
                                        reason = "AAC PES did not start with ADTS header,offset:" + offset;
                                        fatal = false;
                                    } else {
                                        reason = 'no ADTS header found in AAC PES';
                                        fatal = true;
                                    }
                                    logger["logger"].warn("parsing error:" + reason);
                                    this.observer.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].MEDIA_ERROR,
                                        details: errors["ErrorDetails"].FRAG_PARSING_ERROR,
                                        fatal: fatal,
                                        reason: reason
                                    });
                                    if (fatal) return;
                                }
                                initTrackConfig(track, this.observer, data, offset, this.audioCodec);
                                frameIndex = 0;
                                frameDuration = getFrameDuration(track.samplerate); // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
                                // first sample PTS should be equal to last sample PTS + frameDuration
                                if (aacOverFlow && aacLastPTS) {
                                    var newPTS = aacLastPTS + frameDuration;
                                    if (Math.abs(newPTS - pts) > 1) {
                                        logger["logger"].log("AAC: align PTS for overlapping frames by " + Math.round((newPTS - pts) / 90));
                                        pts = newPTS;
                                    }
                                } // scan for aac samples
                                while(offset < len)if (isHeader(data, offset)) {
                                    if (offset + 5 < len) {
                                        var frame = appendFrame(track, data, offset, pts, frameIndex);
                                        if (frame) {
                                            offset += frame.length;
                                            stamp = frame.sample.pts;
                                            frameIndex++;
                                            continue;
                                        }
                                    } // We are at an ADTS header, but do not have enough data for a frame
                                    break;
                                } else // nothing found, keep looking
                                offset++;
                                if (offset < len) aacOverFlow = data.subarray(offset, len); // logger.log(`AAC: overflow detected:${len-offset}`);
                                else aacOverFlow = null;
                                this.aacOverFlow = aacOverFlow;
                                this.aacLastPTS = stamp;
                            };
                            _proto._parseMPEGPES = function _parseMPEGPES(pes) {
                                var data = pes.data;
                                var length = data.length;
                                var frameIndex = 0;
                                var offset = 0;
                                var pts = pes.pts;
                                while(offset < length)if (mpegaudio.isHeader(data, offset)) {
                                    var frame = mpegaudio.appendFrame(this._audioTrack, data, offset, pts, frameIndex);
                                    if (frame) {
                                        offset += frame.length;
                                        frameIndex++;
                                    } else break;
                                } else // nothing found, keep looking
                                offset++;
                            };
                            _proto._parseID3PES = function _parseID3PES(pes) {
                                this._id3Track.samples.push(pes);
                            };
                            return TSDemuxer;
                        }();
                        /* harmony default export */ var tsdemuxer = tsdemuxer_TSDemuxer;
                        // CONCATENATED MODULE: ./src/demux/mp3demuxer.js
                        /**
 * MP3 demuxer
 */ var mp3demuxer_MP3Demuxer = /*#__PURE__*/ function() {
                            function MP3Demuxer(observer, remuxer, config) {
                                this.observer = observer;
                                this.config = config;
                                this.remuxer = remuxer;
                            }
                            var _proto = MP3Demuxer.prototype;
                            _proto.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
                                this._audioTrack = {
                                    container: 'audio/mpeg',
                                    type: 'audio',
                                    id: -1,
                                    sequenceNumber: 0,
                                    isAAC: false,
                                    samples: [],
                                    len: 0,
                                    manifestCodec: audioCodec,
                                    duration: duration,
                                    inputTimeScale: 90000
                                };
                            };
                            _proto.resetTimeStamp = function resetTimeStamp() {};
                            MP3Demuxer.probe = function probe(data) {
                                // check if data contains ID3 timestamp and MPEG sync word
                                var offset, length;
                                var id3Data = id3["default"].getID3Data(data, 0);
                                if (id3Data && id3["default"].getTimeStamp(id3Data) !== undefined) {
                                    // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
                                    // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
                                    // More info http://www.mp3-tech.org/programmer/frame_header.html
                                    for(offset = id3Data.length, length = Math.min(data.length - 1, offset + 100); offset < length; offset++)if (mpegaudio.probe(data, offset)) {
                                        logger["logger"].log('MPEG Audio sync word found !');
                                        return true;
                                    }
                                }
                                return false;
                            } // feed incoming data to the front of the parsing pipeline
                            ;
                            _proto.append = function append(data, timeOffset, contiguous, accurateTimeOffset) {
                                var id3Data = id3["default"].getID3Data(data, 0);
                                var timestamp = id3["default"].getTimeStamp(id3Data);
                                var pts = timestamp ? 90 * timestamp : timeOffset * 90000;
                                var offset = id3Data.length;
                                var length = data.length;
                                var frameIndex = 0, stamp = 0;
                                var track = this._audioTrack;
                                var id3Samples = [
                                    {
                                        pts: pts,
                                        dts: pts,
                                        data: id3Data
                                    }
                                ];
                                while(offset < length){
                                    if (mpegaudio.isHeader(data, offset)) {
                                        var frame = mpegaudio.appendFrame(track, data, offset, pts, frameIndex);
                                        if (frame) {
                                            offset += frame.length;
                                            stamp = frame.sample.pts;
                                            frameIndex++;
                                        } else break;
                                    } else if (id3["default"].isHeader(data, offset)) {
                                        id3Data = id3["default"].getID3Data(data, offset);
                                        id3Samples.push({
                                            pts: stamp,
                                            dts: stamp,
                                            data: id3Data
                                        });
                                        offset += id3Data.length;
                                    } else // nothing found, keep looking
                                    offset++;
                                }
                                this.remuxer.remux(track, {
                                    samples: []
                                }, {
                                    samples: id3Samples,
                                    inputTimeScale: 90000
                                }, {
                                    samples: []
                                }, timeOffset, contiguous, accurateTimeOffset);
                            };
                            _proto.destroy = function destroy() {};
                            return MP3Demuxer;
                        }();
                        /* harmony default export */ var mp3demuxer = mp3demuxer_MP3Demuxer;
                        // CONCATENATED MODULE: ./src/remux/aac-helper.js
                        /**
 *  AAC helper
 */ var AAC = /*#__PURE__*/ function() {
                            function AAC() {}
                            AAC.getSilentFrame = function getSilentFrame(codec, channelCount) {
                                switch(codec){
                                    case 'mp4a.40.2':
                                        if (channelCount === 1) return new Uint8Array([
                                            0x00,
                                            0xc8,
                                            0x00,
                                            0x80,
                                            0x23,
                                            0x80
                                        ]);
                                        else if (channelCount === 2) return new Uint8Array([
                                            0x21,
                                            0x00,
                                            0x49,
                                            0x90,
                                            0x02,
                                            0x19,
                                            0x00,
                                            0x23,
                                            0x80
                                        ]);
                                        else if (channelCount === 3) return new Uint8Array([
                                            0x00,
                                            0xc8,
                                            0x00,
                                            0x80,
                                            0x20,
                                            0x84,
                                            0x01,
                                            0x26,
                                            0x40,
                                            0x08,
                                            0x64,
                                            0x00,
                                            0x8e
                                        ]);
                                        else if (channelCount === 4) return new Uint8Array([
                                            0x00,
                                            0xc8,
                                            0x00,
                                            0x80,
                                            0x20,
                                            0x84,
                                            0x01,
                                            0x26,
                                            0x40,
                                            0x08,
                                            0x64,
                                            0x00,
                                            0x80,
                                            0x2c,
                                            0x80,
                                            0x08,
                                            0x02,
                                            0x38
                                        ]);
                                        else if (channelCount === 5) return new Uint8Array([
                                            0x00,
                                            0xc8,
                                            0x00,
                                            0x80,
                                            0x20,
                                            0x84,
                                            0x01,
                                            0x26,
                                            0x40,
                                            0x08,
                                            0x64,
                                            0x00,
                                            0x82,
                                            0x30,
                                            0x04,
                                            0x99,
                                            0x00,
                                            0x21,
                                            0x90,
                                            0x02,
                                            0x38
                                        ]);
                                        else if (channelCount === 6) return new Uint8Array([
                                            0x00,
                                            0xc8,
                                            0x00,
                                            0x80,
                                            0x20,
                                            0x84,
                                            0x01,
                                            0x26,
                                            0x40,
                                            0x08,
                                            0x64,
                                            0x00,
                                            0x82,
                                            0x30,
                                            0x04,
                                            0x99,
                                            0x00,
                                            0x21,
                                            0x90,
                                            0x02,
                                            0x00,
                                            0xb2,
                                            0x00,
                                            0x20,
                                            0x08,
                                            0xe0
                                        ]);
                                        break;
                                    // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
                                    default:
                                        if (channelCount === 1) // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                                        return new Uint8Array([
                                            0x1,
                                            0x40,
                                            0x22,
                                            0x80,
                                            0xa3,
                                            0x4e,
                                            0xe6,
                                            0x80,
                                            0xba,
                                            0x8,
                                            0x0,
                                            0x0,
                                            0x0,
                                            0x1c,
                                            0x6,
                                            0xf1,
                                            0xc1,
                                            0xa,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5e
                                        ]);
                                        else if (channelCount === 2) // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                                        return new Uint8Array([
                                            0x1,
                                            0x40,
                                            0x22,
                                            0x80,
                                            0xa3,
                                            0x5e,
                                            0xe6,
                                            0x80,
                                            0xba,
                                            0x8,
                                            0x0,
                                            0x0,
                                            0x0,
                                            0x0,
                                            0x95,
                                            0x0,
                                            0x6,
                                            0xf1,
                                            0xa1,
                                            0xa,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5e
                                        ]);
                                        else if (channelCount === 3) // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                                        return new Uint8Array([
                                            0x1,
                                            0x40,
                                            0x22,
                                            0x80,
                                            0xa3,
                                            0x5e,
                                            0xe6,
                                            0x80,
                                            0xba,
                                            0x8,
                                            0x0,
                                            0x0,
                                            0x0,
                                            0x0,
                                            0x95,
                                            0x0,
                                            0x6,
                                            0xf1,
                                            0xa1,
                                            0xa,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5a,
                                            0x5e
                                        ]);
                                        break;
                                }
                                return null;
                            };
                            return AAC;
                        }();
                        /* harmony default export */ var aac_helper = AAC;
                        // CONCATENATED MODULE: ./src/remux/mp4-generator.js
                        /**
 * Generate MP4 Box
*/ var UINT32_MAX = Math.pow(2, 32) - 1;
                        var MP4 = /*#__PURE__*/ function() {
                            function MP4() {}
                            MP4.init = function init() {
                                MP4.types = {
                                    avc1: [],
                                    // codingname
                                    avcC: [],
                                    btrt: [],
                                    dinf: [],
                                    dref: [],
                                    esds: [],
                                    ftyp: [],
                                    hdlr: [],
                                    mdat: [],
                                    mdhd: [],
                                    mdia: [],
                                    mfhd: [],
                                    minf: [],
                                    moof: [],
                                    moov: [],
                                    mp4a: [],
                                    '.mp3': [],
                                    mvex: [],
                                    mvhd: [],
                                    pasp: [],
                                    sdtp: [],
                                    stbl: [],
                                    stco: [],
                                    stsc: [],
                                    stsd: [],
                                    stsz: [],
                                    stts: [],
                                    tfdt: [],
                                    tfhd: [],
                                    traf: [],
                                    trak: [],
                                    trun: [],
                                    trex: [],
                                    tkhd: [],
                                    vmhd: [],
                                    smhd: []
                                };
                                var i;
                                for(i in MP4.types)if (MP4.types.hasOwnProperty(i)) MP4.types[i] = [
                                    i.charCodeAt(0),
                                    i.charCodeAt(1),
                                    i.charCodeAt(2),
                                    i.charCodeAt(3)
                                ];
                                var videoHdlr = new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x76,
                                    0x69,
                                    0x64,
                                    0x65,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x56,
                                    0x69,
                                    0x64,
                                    0x65,
                                    0x6f,
                                    0x48,
                                    0x61,
                                    0x6e,
                                    0x64,
                                    0x6c,
                                    0x65,
                                    0x72,
                                    0x00 // name: 'VideoHandler'
                                ]);
                                var audioHdlr = new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x73,
                                    0x6f,
                                    0x75,
                                    0x6e,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x53,
                                    0x6f,
                                    0x75,
                                    0x6e,
                                    0x64,
                                    0x48,
                                    0x61,
                                    0x6e,
                                    0x64,
                                    0x6c,
                                    0x65,
                                    0x72,
                                    0x00 // name: 'SoundHandler'
                                ]);
                                MP4.HDLR_TYPES = {
                                    'video': videoHdlr,
                                    'audio': audioHdlr
                                };
                                var dref = new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x0c,
                                    0x75,
                                    0x72,
                                    0x6c,
                                    0x20,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01 // entry_flags
                                ]);
                                var stco = new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00 // entry_count
                                ]);
                                MP4.STTS = MP4.STSC = MP4.STCO = stco;
                                MP4.STSZ = new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00 // sample_count
                                ]);
                                MP4.VMHD = new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00 // opcolor
                                ]);
                                MP4.SMHD = new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00 // reserved
                                ]);
                                MP4.STSD = new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01
                                ]); // entry_count
                                var majorBrand = new Uint8Array([
                                    105,
                                    115,
                                    111,
                                    109
                                ]); // isom
                                var avc1Brand = new Uint8Array([
                                    97,
                                    118,
                                    99,
                                    49
                                ]); // avc1
                                var minorVersion = new Uint8Array([
                                    0,
                                    0,
                                    0,
                                    1
                                ]);
                                MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
                                MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
                            };
                            MP4.box = function box(type) {
                                var payload = Array.prototype.slice.call(arguments, 1), size = 8, i = payload.length, len = i, result; // calculate the total size we need to allocate
                                while(i--)size += payload[i].byteLength;
                                result = new Uint8Array(size);
                                result[0] = size >> 24 & 0xff;
                                result[1] = size >> 16 & 0xff;
                                result[2] = size >> 8 & 0xff;
                                result[3] = size & 0xff;
                                result.set(type, 4); // copy the payload into the result
                                for(i = 0, size = 8; i < len; i++){
                                    // copy payload[i] array @ offset size
                                    result.set(payload[i], size);
                                    size += payload[i].byteLength;
                                }
                                return result;
                            };
                            MP4.hdlr = function hdlr(type) {
                                return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
                            };
                            MP4.mdat = function mdat(data) {
                                return MP4.box(MP4.types.mdat, data);
                            };
                            MP4.mdhd = function mdhd(timescale, duration) {
                                duration *= timescale;
                                var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
                                var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
                                return MP4.box(MP4.types.mdhd, new Uint8Array([
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x02,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x03,
                                    timescale >> 24 & 0xFF,
                                    timescale >> 16 & 0xFF,
                                    timescale >> 8 & 0xFF,
                                    timescale & 0xFF,
                                    upperWordDuration >> 24,
                                    upperWordDuration >> 16 & 0xFF,
                                    upperWordDuration >> 8 & 0xFF,
                                    upperWordDuration & 0xFF,
                                    lowerWordDuration >> 24,
                                    lowerWordDuration >> 16 & 0xFF,
                                    lowerWordDuration >> 8 & 0xFF,
                                    lowerWordDuration & 0xFF,
                                    0x55,
                                    0xc4,
                                    0x00,
                                    0x00
                                ]));
                            };
                            MP4.mdia = function mdia(track) {
                                return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));
                            };
                            MP4.mfhd = function mfhd(sequenceNumber) {
                                return MP4.box(MP4.types.mfhd, new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    sequenceNumber >> 24,
                                    sequenceNumber >> 16 & 0xFF,
                                    sequenceNumber >> 8 & 0xFF,
                                    sequenceNumber & 0xFF // sequence_number
                                ]));
                            };
                            MP4.minf = function minf(track) {
                                if (track.type === 'audio') return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
                                else return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
                            };
                            MP4.moof = function moof(sn, baseMediaDecodeTime, track) {
                                return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
                            };
                            MP4.moov = function moov(tracks) {
                                var i = tracks.length, boxes = [];
                                while(i--)boxes[i] = MP4.trak(tracks[i]);
                                return MP4.box.apply(null, [
                                    MP4.types.moov,
                                    MP4.mvhd(tracks[0].timescale, tracks[0].duration)
                                ].concat(boxes).concat(MP4.mvex(tracks)));
                            };
                            MP4.mvex = function mvex(tracks) {
                                var i = tracks.length, boxes = [];
                                while(i--)boxes[i] = MP4.trex(tracks[i]);
                                return MP4.box.apply(null, [
                                    MP4.types.mvex
                                ].concat(boxes));
                            };
                            MP4.mvhd = function mvhd(timescale, duration) {
                                duration *= timescale;
                                var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
                                var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
                                var bytes = new Uint8Array([
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x02,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x03,
                                    timescale >> 24 & 0xFF,
                                    timescale >> 16 & 0xFF,
                                    timescale >> 8 & 0xFF,
                                    timescale & 0xFF,
                                    upperWordDuration >> 24,
                                    upperWordDuration >> 16 & 0xFF,
                                    upperWordDuration >> 8 & 0xFF,
                                    upperWordDuration & 0xFF,
                                    lowerWordDuration >> 24,
                                    lowerWordDuration >> 16 & 0xFF,
                                    lowerWordDuration >> 8 & 0xFF,
                                    lowerWordDuration & 0xFF,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x40,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0xff,
                                    0xff,
                                    0xff,
                                    0xff // next_track_ID
                                ]);
                                return MP4.box(MP4.types.mvhd, bytes);
                            };
                            MP4.sdtp = function sdtp(track) {
                                var samples = track.samples || [], bytes = new Uint8Array(4 + samples.length), flags, i; // leave the full box header (4 bytes) all zero
                                // write the sample table
                                for(i = 0; i < samples.length; i++){
                                    flags = samples[i].flags;
                                    bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
                                }
                                return MP4.box(MP4.types.sdtp, bytes);
                            };
                            MP4.stbl = function stbl(track) {
                                return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
                            };
                            MP4.avc1 = function avc1(track) {
                                var sps = [], pps = [], i, data, len; // assemble the SPSs
                                for(i = 0; i < track.sps.length; i++){
                                    data = track.sps[i];
                                    len = data.byteLength;
                                    sps.push(len >>> 8 & 0xFF);
                                    sps.push(len & 0xFF); // SPS
                                    sps = sps.concat(Array.prototype.slice.call(data));
                                } // assemble the PPSs
                                for(i = 0; i < track.pps.length; i++){
                                    data = track.pps[i];
                                    len = data.byteLength;
                                    pps.push(len >>> 8 & 0xFF);
                                    pps.push(len & 0xFF);
                                    pps = pps.concat(Array.prototype.slice.call(data));
                                }
                                var avcc = MP4.box(MP4.types.avcC, new Uint8Array([
                                    0x01,
                                    sps[3],
                                    sps[4],
                                    sps[5],
                                    255,
                                    0xE0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
                                ].concat(sps).concat([
                                    track.pps.length // numOfPictureParameterSets
                                ]).concat(pps))), // "PPS"
                                width = track.width, height = track.height, hSpacing = track.pixelRatio[0], vSpacing = track.pixelRatio[1];
                                return MP4.box(MP4.types.avc1, new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    width >> 8 & 0xFF,
                                    width & 0xff,
                                    height >> 8 & 0xFF,
                                    height & 0xff,
                                    0x00,
                                    0x48,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x48,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x12,
                                    0x64,
                                    0x61,
                                    0x69,
                                    0x6C,
                                    0x79,
                                    0x6D,
                                    0x6F,
                                    0x74,
                                    0x69,
                                    0x6F,
                                    0x6E,
                                    0x2F,
                                    0x68,
                                    0x6C,
                                    0x73,
                                    0x2E,
                                    0x6A,
                                    0x73,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x18,
                                    0x11,
                                    0x11
                                ]), avcc, MP4.box(MP4.types.btrt, new Uint8Array([
                                    0x00,
                                    0x1c,
                                    0x9c,
                                    0x80,
                                    0x00,
                                    0x2d,
                                    0xc6,
                                    0xc0,
                                    0x00,
                                    0x2d,
                                    0xc6,
                                    0xc0
                                ])), MP4.box(MP4.types.pasp, new Uint8Array([
                                    hSpacing >> 24,
                                    hSpacing >> 16 & 0xFF,
                                    hSpacing >> 8 & 0xFF,
                                    hSpacing & 0xFF,
                                    vSpacing >> 24,
                                    vSpacing >> 16 & 0xFF,
                                    vSpacing >> 8 & 0xFF,
                                    vSpacing & 0xFF
                                ])));
                            };
                            MP4.esds = function esds(track) {
                                var configlen = track.config.length;
                                return new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x03,
                                    0x17 + configlen,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x04,
                                    0x0f + configlen,
                                    0x40,
                                    0x15,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x05 // descriptor_type
                                ].concat([
                                    configlen
                                ]).concat(track.config).concat([
                                    0x06,
                                    0x01,
                                    0x02
                                ])); // GASpecificConfig)); // length + audio config descriptor
                            };
                            MP4.mp4a = function mp4a(track) {
                                var samplerate = track.samplerate;
                                return MP4.box(MP4.types.mp4a, new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    track.channelCount,
                                    0x00,
                                    0x10,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    samplerate >> 8 & 0xFF,
                                    samplerate & 0xff,
                                    0x00,
                                    0x00
                                ]), MP4.box(MP4.types.esds, MP4.esds(track)));
                            };
                            MP4.mp3 = function mp3(track) {
                                var samplerate = track.samplerate;
                                return MP4.box(MP4.types['.mp3'], new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    track.channelCount,
                                    0x00,
                                    0x10,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    samplerate >> 8 & 0xFF,
                                    samplerate & 0xff,
                                    0x00,
                                    0x00
                                ]));
                            };
                            MP4.stsd = function stsd(track) {
                                if (track.type === 'audio') {
                                    if (!track.isAAC && track.codec === 'mp3') return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
                                    return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
                                } else return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
                            };
                            MP4.tkhd = function tkhd(track) {
                                var id = track.id, duration = track.duration * track.timescale, width = track.width, height = track.height, upperWordDuration = Math.floor(duration / (UINT32_MAX + 1)), lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
                                return MP4.box(MP4.types.tkhd, new Uint8Array([
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x07,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x02,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x03,
                                    id >> 24 & 0xFF,
                                    id >> 16 & 0xFF,
                                    id >> 8 & 0xFF,
                                    id & 0xFF,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    upperWordDuration >> 24,
                                    upperWordDuration >> 16 & 0xFF,
                                    upperWordDuration >> 8 & 0xFF,
                                    upperWordDuration & 0xFF,
                                    lowerWordDuration >> 24,
                                    lowerWordDuration >> 16 & 0xFF,
                                    lowerWordDuration >> 8 & 0xFF,
                                    lowerWordDuration & 0xFF,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x40,
                                    0x00,
                                    0x00,
                                    0x00,
                                    width >> 8 & 0xFF,
                                    width & 0xFF,
                                    0x00,
                                    0x00,
                                    height >> 8 & 0xFF,
                                    height & 0xFF,
                                    0x00,
                                    0x00 // height
                                ]));
                            };
                            MP4.traf = function traf(track, baseMediaDecodeTime) {
                                var sampleDependencyTable = MP4.sdtp(track), id = track.id, upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1)), lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
                                return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    id >> 24,
                                    id >> 16 & 0XFF,
                                    id >> 8 & 0XFF,
                                    id & 0xFF
                                ])), MP4.box(MP4.types.tfdt, new Uint8Array([
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    upperWordBaseMediaDecodeTime >> 24,
                                    upperWordBaseMediaDecodeTime >> 16 & 0XFF,
                                    upperWordBaseMediaDecodeTime >> 8 & 0XFF,
                                    upperWordBaseMediaDecodeTime & 0xFF,
                                    lowerWordBaseMediaDecodeTime >> 24,
                                    lowerWordBaseMediaDecodeTime >> 16 & 0XFF,
                                    lowerWordBaseMediaDecodeTime >> 8 & 0XFF,
                                    lowerWordBaseMediaDecodeTime & 0xFF
                                ])), MP4.trun(track, sampleDependencyTable.length + 16 + // tfhd
                                20 + // tfdt
                                8 + // traf header
                                16 + // mfhd
                                8 + // moof header
                                8), sampleDependencyTable);
                            };
                            MP4.trak = function trak(track) {
                                track.duration = track.duration || 0xffffffff;
                                return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
                            };
                            MP4.trex = function trex(track) {
                                var id = track.id;
                                return MP4.box(MP4.types.trex, new Uint8Array([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    id >> 24,
                                    id >> 16 & 0XFF,
                                    id >> 8 & 0XFF,
                                    id & 0xFF,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x01,
                                    0x00,
                                    0x01 // default_sample_flags
                                ]));
                            };
                            MP4.trun = function trun(track, offset) {
                                var samples = track.samples || [], len = samples.length, arraylen = 12 + 16 * len, array = new Uint8Array(arraylen), i, sample, duration, size, flags, cts;
                                offset += 8 + arraylen;
                                array.set([
                                    0x00,
                                    0x00,
                                    0x0f,
                                    0x01,
                                    len >>> 24 & 0xFF,
                                    len >>> 16 & 0xFF,
                                    len >>> 8 & 0xFF,
                                    len & 0xFF,
                                    offset >>> 24 & 0xFF,
                                    offset >>> 16 & 0xFF,
                                    offset >>> 8 & 0xFF,
                                    offset & 0xFF // data_offset
                                ], 0);
                                for(i = 0; i < len; i++){
                                    sample = samples[i];
                                    duration = sample.duration;
                                    size = sample.size;
                                    flags = sample.flags;
                                    cts = sample.cts;
                                    array.set([
                                        duration >>> 24 & 0xFF,
                                        duration >>> 16 & 0xFF,
                                        duration >>> 8 & 0xFF,
                                        duration & 0xFF,
                                        size >>> 24 & 0xFF,
                                        size >>> 16 & 0xFF,
                                        size >>> 8 & 0xFF,
                                        size & 0xFF,
                                        flags.isLeading << 2 | flags.dependsOn,
                                        flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync,
                                        flags.degradPrio & 61440,
                                        flags.degradPrio & 0x0F,
                                        cts >>> 24 & 0xFF,
                                        cts >>> 16 & 0xFF,
                                        cts >>> 8 & 0xFF,
                                        cts & 0xFF // sample_composition_time_offset
                                    ], 12 + 16 * i);
                                }
                                return MP4.box(MP4.types.trun, array);
                            };
                            MP4.initSegment = function initSegment(tracks) {
                                if (!MP4.types) MP4.init();
                                var movie = MP4.moov(tracks), result;
                                result = new Uint8Array(MP4.FTYP.byteLength + movie.byteLength);
                                result.set(MP4.FTYP);
                                result.set(movie, MP4.FTYP.byteLength);
                                return result;
                            };
                            return MP4;
                        }();
                        /* harmony default export */ var mp4_generator = MP4;
                        // CONCATENATED MODULE: ./src/utils/timescale-conversion.ts
                        var MPEG_TS_CLOCK_FREQ_HZ = 90000;
                        function toTimescaleFromScale(value, destScale, srcScale, round) {
                            if (srcScale === void 0) srcScale = 1;
                            if (round === void 0) round = false;
                            return toTimescaleFromBase(value, destScale, 1 / srcScale);
                        }
                        function toTimescaleFromBase(value, destScale, srcBase, round) {
                            if (srcBase === void 0) srcBase = 1;
                            if (round === void 0) round = false;
                            var result = value * destScale * srcBase; // equivalent to `(value * scale) / (1 / base)`
                            return round ? Math.round(result) : result;
                        }
                        function toMsFromMpegTsClock(value, round) {
                            if (round === void 0) round = false;
                            return toTimescaleFromBase(value, 1000, 1 / MPEG_TS_CLOCK_FREQ_HZ, round);
                        }
                        function toMpegTsClockFromTimescale(value, srcScale) {
                            if (srcScale === void 0) srcScale = 1;
                            return toTimescaleFromBase(value, MPEG_TS_CLOCK_FREQ_HZ, 1 / srcScale);
                        }
                        // CONCATENATED MODULE: ./src/remux/mp4-remuxer.js
                        /**
 * fMP4 remuxer
*/ var MAX_SILENT_FRAME_DURATION_90KHZ = toMpegTsClockFromTimescale(10);
                        var PTS_DTS_SHIFT_TOLERANCE_90KHZ = toMpegTsClockFromTimescale(0.2);
                        var mp4_remuxer_MP4Remuxer = /*#__PURE__*/ function() {
                            function MP4Remuxer(observer, config, typeSupported, vendor) {
                                this.observer = observer;
                                this.config = config;
                                this.typeSupported = typeSupported;
                                var userAgent = navigator.userAgent;
                                this.isSafari = vendor && vendor.indexOf('Apple') > -1 && userAgent && !userAgent.match('CriOS');
                                this.ISGenerated = false;
                            }
                            var _proto = MP4Remuxer.prototype;
                            _proto.destroy = function destroy() {};
                            _proto.resetTimeStamp = function resetTimeStamp(defaultTimeStamp) {
                                this._initPTS = this._initDTS = defaultTimeStamp;
                            };
                            _proto.resetInitSegment = function resetInitSegment() {
                                this.ISGenerated = false;
                            };
                            _proto.remux = function remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
                                // generate Init Segment if needed
                                if (!this.ISGenerated) this.generateIS(audioTrack, videoTrack, timeOffset);
                                if (this.ISGenerated) {
                                    var nbAudioSamples = audioTrack.samples.length;
                                    var nbVideoSamples = videoTrack.samples.length;
                                    var audioTimeOffset = timeOffset;
                                    var videoTimeOffset = timeOffset;
                                    if (nbAudioSamples && nbVideoSamples) {
                                        // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
                                        // if first audio DTS is not aligned with first video DTS then we need to take that into account
                                        // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
                                        // drift between audio and video streams
                                        var audiovideoDeltaDts = (audioTrack.samples[0].pts - videoTrack.samples[0].pts) / videoTrack.inputTimeScale;
                                        audioTimeOffset += Math.max(0, audiovideoDeltaDts);
                                        videoTimeOffset += Math.max(0, -audiovideoDeltaDts);
                                    } // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is
                                    // calculated in remuxAudio.
                                    // logger.log('nb AAC samples:' + audioTrack.samples.length);
                                    if (nbAudioSamples) {
                                        // if initSegment was generated without video samples, regenerate it again
                                        if (!audioTrack.timescale) {
                                            logger["logger"].warn('regenerate InitSegment as audio detected');
                                            this.generateIS(audioTrack, videoTrack, timeOffset);
                                        }
                                        var audioData = this.remuxAudio(audioTrack, audioTimeOffset, contiguous, accurateTimeOffset); // logger.log('nb AVC samples:' + videoTrack.samples.length);
                                        if (nbVideoSamples) {
                                            var audioTrackLength;
                                            if (audioData) audioTrackLength = audioData.endPTS - audioData.startPTS;
                                             // if initSegment was generated without video samples, regenerate it again
                                            if (!videoTrack.timescale) {
                                                logger["logger"].warn('regenerate InitSegment as video detected');
                                                this.generateIS(audioTrack, videoTrack, timeOffset);
                                            }
                                            this.remuxVideo(videoTrack, videoTimeOffset, contiguous, audioTrackLength, accurateTimeOffset);
                                        }
                                    } else // logger.log('nb AVC samples:' + videoTrack.samples.length);
                                    if (nbVideoSamples) {
                                        var videoData = this.remuxVideo(videoTrack, videoTimeOffset, contiguous, 0, accurateTimeOffset);
                                        if (videoData && audioTrack.codec) this.remuxEmptyAudio(audioTrack, audioTimeOffset, contiguous, videoData);
                                    }
                                } // logger.log('nb ID3 samples:' + audioTrack.samples.length);
                                if (id3Track.samples.length) this.remuxID3(id3Track, timeOffset);
                                 // logger.log('nb ID3 samples:' + audioTrack.samples.length);
                                if (textTrack.samples.length) this.remuxText(textTrack, timeOffset);
                                 // notify end of parsing
                                this.observer.trigger(events["default"].FRAG_PARSED);
                            };
                            _proto.generateIS = function generateIS(audioTrack, videoTrack, timeOffset) {
                                var observer = this.observer, audioSamples = audioTrack.samples, videoSamples = videoTrack.samples, typeSupported = this.typeSupported, container = 'audio/mp4', tracks = {}, data = {
                                    tracks: tracks
                                }, computePTSDTS = this._initPTS === undefined, initPTS, initDTS;
                                if (computePTSDTS) initPTS = initDTS = Infinity;
                                if (audioTrack.config && audioSamples.length) {
                                    // let's use audio sampling rate as MP4 time scale.
                                    // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
                                    // using audio sampling rate here helps having an integer MP4 frame duration
                                    // this avoids potential rounding issue and AV sync issue
                                    audioTrack.timescale = audioTrack.samplerate;
                                    logger["logger"].log("audio sampling rate : " + audioTrack.samplerate);
                                    if (!audioTrack.isAAC) {
                                        if (typeSupported.mpeg) {
                                            // Chrome and Safari
                                            container = 'audio/mpeg';
                                            audioTrack.codec = '';
                                        } else if (typeSupported.mp3) // Firefox
                                        audioTrack.codec = 'mp3';
                                    }
                                    tracks.audio = {
                                        container: container,
                                        codec: audioTrack.codec,
                                        initSegment: !audioTrack.isAAC && typeSupported.mpeg ? new Uint8Array() : mp4_generator.initSegment([
                                            audioTrack
                                        ]),
                                        metadata: {
                                            channelCount: audioTrack.channelCount
                                        }
                                    };
                                    if (computePTSDTS) // remember first PTS of this demuxing context. for audio, PTS = DTS
                                    initPTS = initDTS = audioSamples[0].pts - audioTrack.inputTimeScale * timeOffset;
                                }
                                if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
                                    // let's use input time scale as MP4 video timescale
                                    // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
                                    var inputTimeScale = videoTrack.inputTimeScale;
                                    videoTrack.timescale = inputTimeScale;
                                    tracks.video = {
                                        container: 'video/mp4',
                                        codec: videoTrack.codec,
                                        initSegment: mp4_generator.initSegment([
                                            videoTrack
                                        ]),
                                        metadata: {
                                            width: videoTrack.width,
                                            height: videoTrack.height
                                        }
                                    };
                                    if (computePTSDTS) {
                                        initPTS = Math.min(initPTS, videoSamples[0].pts - inputTimeScale * timeOffset);
                                        initDTS = Math.min(initDTS, videoSamples[0].dts - inputTimeScale * timeOffset);
                                        this.observer.trigger(events["default"].INIT_PTS_FOUND, {
                                            initPTS: initPTS
                                        });
                                    }
                                }
                                if (Object.keys(tracks).length) {
                                    observer.trigger(events["default"].FRAG_PARSING_INIT_SEGMENT, data);
                                    this.ISGenerated = true;
                                    if (computePTSDTS) {
                                        this._initPTS = initPTS;
                                        this._initDTS = initDTS;
                                    }
                                } else observer.trigger(events["default"].ERROR, {
                                    type: errors["ErrorTypes"].MEDIA_ERROR,
                                    details: errors["ErrorDetails"].FRAG_PARSING_ERROR,
                                    fatal: false,
                                    reason: 'no audio/video samples found'
                                });
                            };
                            _proto.remuxVideo = function remuxVideo(track, timeOffset, contiguous, audioTrackLength, accurateTimeOffset) {
                                var offset = 8;
                                var mp4SampleDuration;
                                var mdat;
                                var moof;
                                var firstPTS;
                                var firstDTS;
                                var lastPTS;
                                var lastDTS;
                                var timeScale = track.timescale;
                                var inputSamples = track.samples;
                                var outputSamples = [];
                                var nbSamples = inputSamples.length;
                                var ptsNormalize = this._PTSNormalize;
                                var initPTS = this._initPTS; // if parsed fragment is contiguous with last one, let's use last DTS value as reference
                                var nextAvcDts = this.nextAvcDts;
                                var isSafari = this.isSafari;
                                if (nbSamples === 0) return;
                                 // Safari does not like overlapping DTS on consecutive fragments. let's use nextAvcDts to overcome this if fragments are consecutive
                                if (isSafari) // also consider consecutive fragments as being contiguous (even if a level switch occurs),
                                // for sake of clarity:
                                // consecutive fragments are frags with
                                //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
                                //  - less than 200 ms PTS gaps (timeScale/5)
                                contiguous |= inputSamples.length && nextAvcDts && (accurateTimeOffset && Math.abs(timeOffset - nextAvcDts / timeScale) < 0.1 || Math.abs(inputSamples[0].pts - nextAvcDts - initPTS) < timeScale / 5);
                                if (!contiguous) // if not contiguous, let's use target timeOffset
                                nextAvcDts = timeOffset * timeScale;
                                 // PTS is coded on 33bits, and can loop from -2^32 to 2^32
                                // ptsNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
                                inputSamples.forEach(function(sample) {
                                    sample.pts = ptsNormalize(sample.pts - initPTS, nextAvcDts);
                                    sample.dts = ptsNormalize(sample.dts - initPTS, nextAvcDts);
                                }); // sort video samples by DTS then PTS then demux id order
                                inputSamples.sort(function(a, b) {
                                    var deltadts = a.dts - b.dts;
                                    var deltapts = a.pts - b.pts;
                                    return deltadts || deltapts || a.id - b.id;
                                }); // handle broken streams with PTS < DTS, tolerance up 0.2 seconds
                                var PTSDTSshift = inputSamples.reduce(function(prev, curr) {
                                    return Math.max(Math.min(prev, curr.pts - curr.dts), -1 * PTS_DTS_SHIFT_TOLERANCE_90KHZ);
                                }, 0);
                                if (PTSDTSshift < 0) {
                                    logger["logger"].warn("PTS < DTS detected in video samples, shifting DTS by " + toMsFromMpegTsClock(PTSDTSshift, true) + " ms to overcome this issue");
                                    for(var i = 0; i < inputSamples.length; i++)inputSamples[i].dts += PTSDTSshift;
                                } // compute first DTS and last DTS, normalize them against reference value
                                var sample = inputSamples[0];
                                firstDTS = Math.max(sample.dts, 0);
                                firstPTS = Math.max(sample.pts, 0); // check timestamp continuity accross consecutive fragments (this is to remove inter-fragment gap/hole)
                                var delta = firstDTS - nextAvcDts; // if fragment are contiguous, detect hole/overlapping between fragments
                                if (contiguous) {
                                    if (delta) {
                                        if (delta > 1) logger["logger"].log("AVC: " + toMsFromMpegTsClock(delta, true) + " ms hole between fragments detected,filling it");
                                        else if (delta < -1) logger["logger"].log("AVC: " + toMsFromMpegTsClock(-delta, true) + " ms overlapping between fragments detected");
                                         // remove hole/gap : set DTS to next expected DTS
                                        firstDTS = nextAvcDts;
                                        inputSamples[0].dts = firstDTS; // offset PTS as well, ensure that PTS is smaller or equal than new DTS
                                        firstPTS = Math.max(firstPTS - delta, nextAvcDts);
                                        inputSamples[0].pts = firstPTS;
                                        logger["logger"].log("Video: PTS/DTS adjusted: " + toMsFromMpegTsClock(firstPTS, true) + "/" + toMsFromMpegTsClock(firstDTS, true) + ", delta: " + toMsFromMpegTsClock(delta, true) + " ms");
                                    }
                                } // compute lastPTS/lastDTS
                                sample = inputSamples[inputSamples.length - 1];
                                lastDTS = Math.max(sample.dts, 0);
                                lastPTS = Math.max(sample.pts, 0, lastDTS); // on Safari let's signal the same sample duration for all samples
                                // sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
                                // set this constant duration as being the avg delta between consecutive DTS.
                                if (isSafari) mp4SampleDuration = Math.round((lastDTS - firstDTS) / (inputSamples.length - 1));
                                var nbNalu = 0, naluLen = 0;
                                for(var _i = 0; _i < nbSamples; _i++){
                                    // compute total/avc sample length and nb of NAL units
                                    var _sample = inputSamples[_i], units = _sample.units, nbUnits = units.length, sampleLen = 0;
                                    for(var j = 0; j < nbUnits; j++)sampleLen += units[j].data.length;
                                    naluLen += sampleLen;
                                    nbNalu += nbUnits;
                                    _sample.length = sampleLen; // normalize PTS/DTS
                                    if (isSafari) // sample DTS is computed using a constant decoding offset (mp4SampleDuration) between samples
                                    _sample.dts = firstDTS + _i * mp4SampleDuration;
                                    else // ensure sample monotonic DTS
                                    _sample.dts = Math.max(_sample.dts, firstDTS);
                                     // ensure that computed value is greater or equal than sample DTS
                                    _sample.pts = Math.max(_sample.pts, _sample.dts);
                                }
                                /* concatenate the video data and construct the mdat in place
      (need 8 more bytes to fill length and mpdat type) */ var mdatSize = naluLen + 4 * nbNalu + 8;
                                try {
                                    mdat = new Uint8Array(mdatSize);
                                } catch (err) {
                                    this.observer.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].MUX_ERROR,
                                        details: errors["ErrorDetails"].REMUX_ALLOC_ERROR,
                                        fatal: false,
                                        bytes: mdatSize,
                                        reason: "fail allocating video mdat " + mdatSize
                                    });
                                    return;
                                }
                                var view = new DataView(mdat.buffer);
                                view.setUint32(0, mdatSize);
                                mdat.set(mp4_generator.types.mdat, 4);
                                for(var _i2 = 0; _i2 < nbSamples; _i2++){
                                    var avcSample = inputSamples[_i2], avcSampleUnits = avcSample.units, mp4SampleLength = 0, compositionTimeOffset = void 0; // convert NALU bitstream to MP4 format (prepend NALU with size field)
                                    for(var _j = 0, _nbUnits = avcSampleUnits.length; _j < _nbUnits; _j++){
                                        var unit = avcSampleUnits[_j], unitData = unit.data, unitDataLen = unit.data.byteLength;
                                        view.setUint32(offset, unitDataLen);
                                        offset += 4;
                                        mdat.set(unitData, offset);
                                        offset += unitDataLen;
                                        mp4SampleLength += 4 + unitDataLen;
                                    }
                                    if (!isSafari) {
                                        // expected sample duration is the Decoding Timestamp diff of consecutive samples
                                        if (_i2 < nbSamples - 1) mp4SampleDuration = inputSamples[_i2 + 1].dts - avcSample.dts;
                                        else {
                                            var config = this.config, lastFrameDuration = avcSample.dts - inputSamples[_i2 > 0 ? _i2 - 1 : _i2].dts;
                                            if (config.stretchShortVideoTrack) {
                                                // In some cases, a segment's audio track duration may exceed the video track duration.
                                                // Since we've already remuxed audio, and we know how long the audio track is, we look to
                                                // see if the delta to the next segment is longer than maxBufferHole.
                                                // If so, playback would potentially get stuck, so we artificially inflate
                                                // the duration of the last frame to minimize any potential gap between segments.
                                                var maxBufferHole = config.maxBufferHole, gapTolerance = Math.floor(maxBufferHole * timeScale), deltaToFrameEnd = (audioTrackLength ? firstPTS + audioTrackLength * timeScale : this.nextAudioPts) - avcSample.pts;
                                                if (deltaToFrameEnd > gapTolerance) {
                                                    // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
                                                    // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
                                                    mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
                                                    if (mp4SampleDuration < 0) mp4SampleDuration = lastFrameDuration;
                                                    logger["logger"].log("It is approximately " + toMsFromMpegTsClock(deltaToFrameEnd, false) + " ms to the next segment; using duration " + toMsFromMpegTsClock(mp4SampleDuration, false) + " ms for the last video frame.");
                                                } else mp4SampleDuration = lastFrameDuration;
                                            } else mp4SampleDuration = lastFrameDuration;
                                        }
                                        compositionTimeOffset = Math.round(avcSample.pts - avcSample.dts);
                                    } else compositionTimeOffset = Math.max(0, mp4SampleDuration * Math.round((avcSample.pts - avcSample.dts) / mp4SampleDuration));
                                     // console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${avcSample.pts}/${avcSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(avcSample.pts/4294967296).toFixed(3)}');
                                    outputSamples.push({
                                        size: mp4SampleLength,
                                        // constant duration
                                        duration: mp4SampleDuration,
                                        cts: compositionTimeOffset,
                                        flags: {
                                            isLeading: 0,
                                            isDependedOn: 0,
                                            hasRedundancy: 0,
                                            degradPrio: 0,
                                            dependsOn: avcSample.key ? 2 : 1,
                                            isNonSync: avcSample.key ? 0 : 1
                                        }
                                    });
                                } // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
                                this.nextAvcDts = lastDTS + mp4SampleDuration;
                                var dropped = track.dropped;
                                track.nbNalu = 0;
                                track.dropped = 0;
                                if (outputSamples.length && navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
                                    var flags = outputSamples[0].flags; // chrome workaround, mark first sample as being a Random Access Point to avoid sourcebuffer append issue
                                    // https://code.google.com/p/chromium/issues/detail?id=229412
                                    flags.dependsOn = 2;
                                    flags.isNonSync = 0;
                                }
                                track.samples = outputSamples;
                                moof = mp4_generator.moof(track.sequenceNumber++, firstDTS, track);
                                track.samples = [];
                                var data = {
                                    data1: moof,
                                    data2: mdat,
                                    startPTS: firstPTS / timeScale,
                                    endPTS: (lastPTS + mp4SampleDuration) / timeScale,
                                    startDTS: firstDTS / timeScale,
                                    endDTS: this.nextAvcDts / timeScale,
                                    type: 'video',
                                    hasAudio: false,
                                    hasVideo: true,
                                    nb: outputSamples.length,
                                    dropped: dropped
                                };
                                this.observer.trigger(events["default"].FRAG_PARSING_DATA, data);
                                return data;
                            };
                            _proto.remuxAudio = function remuxAudio(track, timeOffset, contiguous, accurateTimeOffset) {
                                var inputTimeScale = track.inputTimeScale;
                                var mp4timeScale = track.timescale;
                                var scaleFactor = inputTimeScale / mp4timeScale;
                                var mp4SampleDuration = track.isAAC ? 1024 : 1152;
                                var inputSampleDuration = mp4SampleDuration * scaleFactor;
                                var ptsNormalize = this._PTSNormalize;
                                var initPTS = this._initPTS;
                                var rawMPEG = !track.isAAC && this.typeSupported.mpeg;
                                var mp4Sample;
                                var fillFrame;
                                var mdat;
                                var moof;
                                var firstPTS;
                                var lastPTS;
                                var offset = rawMPEG ? 0 : 8;
                                var inputSamples = track.samples;
                                var outputSamples = [];
                                var nextAudioPts = this.nextAudioPts; // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
                                // for sake of clarity:
                                // consecutive fragments are frags with
                                //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
                                //  - less than 20 audio frames distance
                                // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
                                // this helps ensuring audio continuity
                                // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
                                contiguous |= inputSamples.length && nextAudioPts && (accurateTimeOffset && Math.abs(timeOffset - nextAudioPts / inputTimeScale) < 0.1 || Math.abs(inputSamples[0].pts - nextAudioPts - initPTS) < 20 * inputSampleDuration); // compute normalized PTS
                                inputSamples.forEach(function(sample) {
                                    sample.pts = sample.dts = ptsNormalize(sample.pts - initPTS, timeOffset * inputTimeScale);
                                }); // filter out sample with negative PTS that are not playable anyway
                                // if we don't remove these negative samples, they will shift all audio samples forward.
                                // leading to audio overlap between current / next fragment
                                inputSamples = inputSamples.filter(function(sample) {
                                    return sample.pts >= 0;
                                }); // in case all samples have negative PTS, and have been filtered out, return now
                                if (inputSamples.length === 0) return;
                                if (!contiguous) {
                                    if (!accurateTimeOffset) // if frag are mot contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
                                    nextAudioPts = inputSamples[0].pts;
                                    else // if timeOffset is accurate, let's use it as predicted next audio PTS
                                    nextAudioPts = timeOffset * inputTimeScale;
                                } // If the audio track is missing samples, the frames seem to get "left-shifted" within the
                                // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
                                // In an effort to prevent this from happening, we inject frames here where there are gaps.
                                // When possible, we inject a silent frame; when that's not possible, we duplicate the last
                                // frame.
                                if (track.isAAC) {
                                    var maxAudioFramesDrift = this.config.maxAudioFramesDrift;
                                    for(var i = 0, nextPts = nextAudioPts; i < inputSamples.length;){
                                        // First, let's see how far off this frame is from where we expect it to be
                                        var sample = inputSamples[i], delta;
                                        var pts = sample.pts;
                                        delta = pts - nextPts; // If we're overlapping by more than a duration, drop this sample
                                        if (delta <= -maxAudioFramesDrift * inputSampleDuration) {
                                            logger["logger"].warn("Dropping 1 audio frame @ " + toMsFromMpegTsClock(nextPts, true) + " ms due to " + toMsFromMpegTsClock(delta, true) + " ms overlap.");
                                            inputSamples.splice(i, 1); // Don't touch nextPtsNorm or i
                                        } else if (delta >= maxAudioFramesDrift * inputSampleDuration && delta < MAX_SILENT_FRAME_DURATION_90KHZ && nextPts) {
                                            var missing = Math.round(delta / inputSampleDuration);
                                            logger["logger"].warn("Injecting " + missing + " audio frames @ " + toMsFromMpegTsClock(nextPts, true) + " ms due to " + toMsFromMpegTsClock(nextPts, true) + " ms gap.");
                                            for(var j = 0; j < missing; j++){
                                                var newStamp = Math.max(nextPts, 0);
                                                fillFrame = aac_helper.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                                                if (!fillFrame) {
                                                    logger["logger"].log('Unable to get silent frame for given audio codec; duplicating last frame instead.');
                                                    fillFrame = sample.unit.subarray();
                                                }
                                                inputSamples.splice(i, 0, {
                                                    unit: fillFrame,
                                                    pts: newStamp,
                                                    dts: newStamp
                                                });
                                                nextPts += inputSampleDuration;
                                                i++;
                                            } // Adjust sample to next expected pts
                                            sample.pts = sample.dts = nextPts;
                                            nextPts += inputSampleDuration;
                                            i++;
                                        } else {
                                            // Otherwise, just adjust pts
                                            inputSampleDuration;
                                            sample.pts = sample.dts = nextPts;
                                            nextPts += inputSampleDuration;
                                            i++;
                                        }
                                    }
                                } // compute mdat size, as we eventually filtered/added some samples
                                var nbSamples = inputSamples.length;
                                var mdatSize = 0;
                                while(nbSamples--)mdatSize += inputSamples[nbSamples].unit.byteLength;
                                for(var _j2 = 0, _nbSamples = inputSamples.length; _j2 < _nbSamples; _j2++){
                                    var audioSample = inputSamples[_j2];
                                    var unit = audioSample.unit;
                                    var _pts = audioSample.pts; // logger.log(`Audio/PTS:${toMsFromMpegTsClock(pts, true)}`);
                                    // if not first sample
                                    if (lastPTS !== undefined) mp4Sample.duration = Math.round((_pts - lastPTS) / scaleFactor);
                                    else {
                                        var _delta = _pts - nextAudioPts;
                                        var numMissingFrames = 0; // if fragment are contiguous, detect hole/overlapping between fragments
                                        // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
                                        if (contiguous && track.isAAC) // log delta
                                        {
                                            if (_delta) {
                                                if (_delta > 0 && _delta < MAX_SILENT_FRAME_DURATION_90KHZ) {
                                                    // Q: why do we have to round here, shouldn't this always result in an integer if timestamps are correct,
                                                    // and if not, shouldn't we actually Math.ceil() instead?
                                                    numMissingFrames = Math.round((_pts - nextAudioPts) / inputSampleDuration);
                                                    logger["logger"].log(toMsFromMpegTsClock(_delta, true) + " ms hole between AAC samples detected,filling it");
                                                    if (numMissingFrames > 0) {
                                                        fillFrame = aac_helper.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                                                        if (!fillFrame) fillFrame = unit.subarray();
                                                        mdatSize += numMissingFrames * fillFrame.length;
                                                    } // if we have frame overlap, overlapping for more than half a frame duraion
                                                } else if (_delta < -12) {
                                                    // drop overlapping audio frames... browser will deal with it
                                                    logger["logger"].log("drop overlapping AAC sample, expected/parsed/delta: " + toMsFromMpegTsClock(nextAudioPts, true) + " ms / " + toMsFromMpegTsClock(_pts, true) + " ms / " + toMsFromMpegTsClock(-_delta, true) + " ms");
                                                    mdatSize -= unit.byteLength;
                                                    continue;
                                                } // set PTS/DTS to expected PTS/DTS
                                                _pts = nextAudioPts;
                                            }
                                        } // remember first PTS of our audioSamples
                                        firstPTS = _pts;
                                        if (mdatSize > 0) {
                                            mdatSize += offset;
                                            try {
                                                mdat = new Uint8Array(mdatSize);
                                            } catch (err) {
                                                this.observer.trigger(events["default"].ERROR, {
                                                    type: errors["ErrorTypes"].MUX_ERROR,
                                                    details: errors["ErrorDetails"].REMUX_ALLOC_ERROR,
                                                    fatal: false,
                                                    bytes: mdatSize,
                                                    reason: "fail allocating audio mdat " + mdatSize
                                                });
                                                return;
                                            }
                                            if (!rawMPEG) {
                                                var view = new DataView(mdat.buffer);
                                                view.setUint32(0, mdatSize);
                                                mdat.set(mp4_generator.types.mdat, 4);
                                            }
                                        } else // no audio samples
                                        return;
                                        for(var _i3 = 0; _i3 < numMissingFrames; _i3++){
                                            fillFrame = aac_helper.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                                            if (!fillFrame) {
                                                logger["logger"].log('Unable to get silent frame for given audio codec; duplicating this frame instead.');
                                                fillFrame = unit.subarray();
                                            }
                                            mdat.set(fillFrame, offset);
                                            offset += fillFrame.byteLength;
                                            mp4Sample = {
                                                size: fillFrame.byteLength,
                                                cts: 0,
                                                duration: 1024,
                                                flags: {
                                                    isLeading: 0,
                                                    isDependedOn: 0,
                                                    hasRedundancy: 0,
                                                    degradPrio: 0,
                                                    dependsOn: 1
                                                }
                                            };
                                            outputSamples.push(mp4Sample);
                                        }
                                    }
                                    mdat.set(unit, offset);
                                    var unitLen = unit.byteLength;
                                    offset += unitLen; // console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${audioSample.pts}/${audioSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(audioSample.pts/4294967296).toFixed(3)}');
                                    mp4Sample = {
                                        size: unitLen,
                                        cts: 0,
                                        duration: 0,
                                        flags: {
                                            isLeading: 0,
                                            isDependedOn: 0,
                                            hasRedundancy: 0,
                                            degradPrio: 0,
                                            dependsOn: 1
                                        }
                                    };
                                    outputSamples.push(mp4Sample);
                                    lastPTS = _pts;
                                }
                                var lastSampleDuration = 0;
                                nbSamples = outputSamples.length; // set last sample duration as being identical to previous sample
                                if (nbSamples >= 2) {
                                    lastSampleDuration = outputSamples[nbSamples - 2].duration;
                                    mp4Sample.duration = lastSampleDuration;
                                }
                                if (nbSamples) {
                                    // next audio sample PTS should be equal to last sample PTS + duration
                                    this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSampleDuration; // logger.log('Audio/PTS/PTSend:' + audioSample.pts.toFixed(0) + '/' + this.nextAacDts.toFixed(0));
                                    track.samples = outputSamples;
                                    if (rawMPEG) moof = new Uint8Array();
                                    else moof = mp4_generator.moof(track.sequenceNumber++, firstPTS / scaleFactor, track);
                                    track.samples = [];
                                    var start = firstPTS / inputTimeScale;
                                    var end = nextAudioPts / inputTimeScale;
                                    var audioData = {
                                        data1: moof,
                                        data2: mdat,
                                        startPTS: start,
                                        endPTS: end,
                                        startDTS: start,
                                        endDTS: end,
                                        type: 'audio',
                                        hasAudio: true,
                                        hasVideo: false,
                                        nb: nbSamples
                                    };
                                    this.observer.trigger(events["default"].FRAG_PARSING_DATA, audioData);
                                    return audioData;
                                }
                                return null;
                            };
                            _proto.remuxEmptyAudio = function remuxEmptyAudio(track, timeOffset, contiguous, videoData) {
                                var inputTimeScale = track.inputTimeScale;
                                var mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
                                var scaleFactor = inputTimeScale / mp4timeScale;
                                var nextAudioPts = this.nextAudioPts; // sync with video's timestamp
                                var startDTS = (nextAudioPts !== undefined ? nextAudioPts : videoData.startDTS * inputTimeScale) + this._initDTS;
                                var endDTS = videoData.endDTS * inputTimeScale + this._initDTS; // one sample's duration value
                                var sampleDuration = 1024;
                                var frameDuration = scaleFactor * sampleDuration; // samples count of this segment's duration
                                var nbSamples = Math.ceil((endDTS - startDTS) / frameDuration); // silent frame
                                var silentFrame = aac_helper.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                                logger["logger"].warn('remux empty Audio'); // Can't remux if we can't generate a silent frame...
                                if (!silentFrame) {
                                    logger["logger"].trace('Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!');
                                    return;
                                }
                                var samples = [];
                                for(var i = 0; i < nbSamples; i++){
                                    var stamp = startDTS + i * frameDuration;
                                    samples.push({
                                        unit: silentFrame,
                                        pts: stamp,
                                        dts: stamp
                                    });
                                }
                                track.samples = samples;
                                this.remuxAudio(track, timeOffset, contiguous);
                            };
                            _proto.remuxID3 = function remuxID3(track) {
                                var length = track.samples.length, sample;
                                var inputTimeScale = track.inputTimeScale;
                                var initPTS = this._initPTS;
                                var initDTS = this._initDTS; // consume samples
                                if (length) {
                                    for(var index = 0; index < length; index++){
                                        sample = track.samples[index]; // setting id3 pts, dts to relative time
                                        // using this._initPTS and this._initDTS to calculate relative time
                                        sample.pts = (sample.pts - initPTS) / inputTimeScale;
                                        sample.dts = (sample.dts - initDTS) / inputTimeScale;
                                    }
                                    this.observer.trigger(events["default"].FRAG_PARSING_METADATA, {
                                        samples: track.samples
                                    });
                                }
                                track.samples = [];
                            };
                            _proto.remuxText = function remuxText(track) {
                                track.samples.sort(function(a, b) {
                                    return a.pts - b.pts;
                                });
                                var length = track.samples.length, sample;
                                var inputTimeScale = track.inputTimeScale;
                                var initPTS = this._initPTS; // consume samples
                                if (length) {
                                    for(var index = 0; index < length; index++){
                                        sample = track.samples[index]; // setting text pts, dts to relative time
                                        // using this._initPTS and this._initDTS to calculate relative time
                                        sample.pts = (sample.pts - initPTS) / inputTimeScale;
                                    }
                                    this.observer.trigger(events["default"].FRAG_PARSING_USERDATA, {
                                        samples: track.samples
                                    });
                                }
                                track.samples = [];
                            };
                            _proto._PTSNormalize = function _PTSNormalize(value, reference) {
                                var offset;
                                if (reference === undefined) return value;
                                if (reference < value) // - 2^33
                                offset = -8589934592;
                                else // + 2^33
                                offset = 8589934592;
                                /* PTS is 33bit (from 0 to 2^33 -1)
      if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
      PTS looping occured. fill the gap */ while(Math.abs(value - reference) > 4294967296)value += offset;
                                return value;
                            };
                            return MP4Remuxer;
                        }();
                        /* harmony default export */ var mp4_remuxer = mp4_remuxer_MP4Remuxer;
                        // CONCATENATED MODULE: ./src/remux/passthrough-remuxer.js
                        /**
 * passthrough remuxer
*/ var passthrough_remuxer_PassThroughRemuxer = /*#__PURE__*/ function() {
                            function PassThroughRemuxer(observer) {
                                this.observer = observer;
                            }
                            var _proto = PassThroughRemuxer.prototype;
                            _proto.destroy = function destroy() {};
                            _proto.resetTimeStamp = function resetTimeStamp() {};
                            _proto.resetInitSegment = function resetInitSegment() {};
                            _proto.remux = function remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset, rawData) {
                                var observer = this.observer;
                                var streamType = '';
                                if (audioTrack) streamType += 'audio';
                                if (videoTrack) streamType += 'video';
                                observer.trigger(events["default"].FRAG_PARSING_DATA, {
                                    data1: rawData,
                                    startPTS: timeOffset,
                                    startDTS: timeOffset,
                                    type: streamType,
                                    hasAudio: !!audioTrack,
                                    hasVideo: !!videoTrack,
                                    nb: 1,
                                    dropped: 0
                                }); // notify end of parsing
                                observer.trigger(events["default"].FRAG_PARSED);
                            };
                            return PassThroughRemuxer;
                        }();
                        /* harmony default export */ var passthrough_remuxer = passthrough_remuxer_PassThroughRemuxer;
                        // CONCATENATED MODULE: ./src/demux/demuxer-inline.js
                        /**
 *
 * inline demuxer: probe fragments and instantiate
 * appropriate demuxer depending on content type (TSDemuxer, AACDemuxer, ...)
 *
 */ // see https://stackoverflow.com/a/11237259/589493
                        var global = Object(get_self_scope["getSelfScope"])(); // safeguard for code that might run both on worker and main thread
                        var now; // performance.now() not available on WebWorker, at least on Safari Desktop
                        try {
                            now = global.performance.now.bind(global.performance);
                        } catch (err) {
                            logger["logger"].debug('Unable to use Performance API on this environment');
                            now = global.Date.now;
                        }
                        var demuxer_inline_DemuxerInline = /*#__PURE__*/ function() {
                            function DemuxerInline(observer, typeSupported, config, vendor) {
                                this.observer = observer;
                                this.typeSupported = typeSupported;
                                this.config = config;
                                this.vendor = vendor;
                            }
                            var _proto = DemuxerInline.prototype;
                            _proto.destroy = function destroy() {
                                var demuxer = this.demuxer;
                                if (demuxer) demuxer.destroy();
                            };
                            _proto.push = function push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
                                var _this = this;
                                if (data.byteLength > 0 && decryptdata != null && decryptdata.key != null && decryptdata.method === 'AES-128') {
                                    var decrypter = this.decrypter;
                                    if (decrypter == null) decrypter = this.decrypter = new crypt_decrypter["default"](this.observer, this.config);
                                    var startTime = now();
                                    decrypter.decrypt(data, decryptdata.key.buffer, decryptdata.iv.buffer, function(decryptedData) {
                                        var endTime = now();
                                        _this.observer.trigger(events["default"].FRAG_DECRYPTED, {
                                            stats: {
                                                tstart: startTime,
                                                tdecrypt: endTime
                                            }
                                        });
                                        _this.pushDecrypted(new Uint8Array(decryptedData), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
                                    });
                                } else this.pushDecrypted(new Uint8Array(data), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
                            };
                            _proto.pushDecrypted = function pushDecrypted(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
                                var demuxer = this.demuxer;
                                if (!demuxer || // in case of continuity change, or track switch
                                // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
                                // so let's check that current demuxer is still valid
                                (discontinuity || trackSwitch) && !this.probe(data)) {
                                    var observer = this.observer;
                                    var typeSupported = this.typeSupported;
                                    var config = this.config; // probing order is TS/MP4/AAC/MP3
                                    var muxConfig = [
                                        {
                                            demux: tsdemuxer,
                                            remux: mp4_remuxer
                                        },
                                        {
                                            demux: mp4demuxer["default"],
                                            remux: passthrough_remuxer
                                        },
                                        {
                                            demux: aacdemuxer,
                                            remux: mp4_remuxer
                                        },
                                        {
                                            demux: mp3demuxer,
                                            remux: mp4_remuxer
                                        }
                                    ]; // probe for content type
                                    for(var i = 0, len = muxConfig.length; i < len; i++){
                                        var mux = muxConfig[i];
                                        var probe = mux.demux.probe;
                                        if (probe(data)) {
                                            var _remuxer = this.remuxer = new mux.remux(observer, config, typeSupported, this.vendor);
                                            demuxer = new mux.demux(observer, _remuxer, config, typeSupported);
                                            this.probe = probe;
                                            break;
                                        }
                                    }
                                    if (!demuxer) {
                                        observer.trigger(events["default"].ERROR, {
                                            type: errors["ErrorTypes"].MEDIA_ERROR,
                                            details: errors["ErrorDetails"].FRAG_PARSING_ERROR,
                                            fatal: true,
                                            reason: 'no demux matching with content found'
                                        });
                                        return;
                                    }
                                    this.demuxer = demuxer;
                                }
                                var remuxer = this.remuxer;
                                if (discontinuity || trackSwitch) {
                                    demuxer.resetInitSegment(initSegment, audioCodec, videoCodec, duration);
                                    remuxer.resetInitSegment();
                                }
                                if (discontinuity) {
                                    demuxer.resetTimeStamp(defaultInitPTS);
                                    remuxer.resetTimeStamp(defaultInitPTS);
                                }
                                if (typeof demuxer.setDecryptData === 'function') demuxer.setDecryptData(decryptdata);
                                demuxer.append(data, timeOffset, contiguous, accurateTimeOffset);
                            };
                            return DemuxerInline;
                        }();
                        /* harmony default export */ var demuxer_inline = __webpack_exports__["default"] = demuxer_inline_DemuxerInline;
                    /***/ },
                    /***/ "./src/demux/demuxer-worker.js": /*!*************************************!*\
  !*** ./src/demux/demuxer-worker.js ***!
  \*************************************/ /*! exports provided: default */ /*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./src/demux/demuxer.js (referenced with require.resolve) */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                        "use strict";
                        __webpack_require__.r(__webpack_exports__);
                        /* harmony import */ var _demux_demuxer_inline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../demux/demuxer-inline */ "./src/demux/demuxer-inline.js");
                        /* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../events */ "./src/events.js");
                        /* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
                        /* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! eventemitter3 */ "./node_modules/eventemitter3/index.js");
                        /* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(eventemitter3__WEBPACK_IMPORTED_MODULE_3__);
                        /* demuxer web worker.
 *  - listen to worker message, and trigger DemuxerInline upon reception of Fragments.
 *  - provides MP4 Boxes back to main thread using [transferable objects](https://developers.google.com/web/updates/2011/12/Transferable-Objects-Lightning-Fast) in order to minimize message passing overhead.
 */ var DemuxerWorker = function DemuxerWorker(self1) {
                            // observer setup
                            var observer = new eventemitter3__WEBPACK_IMPORTED_MODULE_3__["EventEmitter"]();
                            observer.trigger = function trigger(event) {
                                for(var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)data[_key - 1] = arguments[_key];
                                observer.emit.apply(observer, [
                                    event,
                                    event
                                ].concat(data));
                            };
                            observer.off = function off(event) {
                                for(var _len2 = arguments.length, data = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)data[_key2 - 1] = arguments[_key2];
                                observer.removeListener.apply(observer, [
                                    event
                                ].concat(data));
                            };
                            var forwardMessage = function forwardMessage(ev, data) {
                                self1.postMessage({
                                    event: ev,
                                    data: data
                                });
                            };
                            self1.addEventListener('message', function(ev) {
                                var data = ev.data; // console.log('demuxer cmd:' + data.cmd);
                                switch(data.cmd){
                                    case 'init':
                                        var config = JSON.parse(data.config);
                                        self1.demuxer = new _demux_demuxer_inline__WEBPACK_IMPORTED_MODULE_0__["default"](observer, data.typeSupported, config, data.vendor);
                                        Object(_utils_logger__WEBPACK_IMPORTED_MODULE_2__["enableLogs"])(config.debug); // signal end of worker init
                                        forwardMessage('init', null);
                                        break;
                                    case 'demux':
                                        self1.demuxer.push(data.data, data.decryptdata, data.initSegment, data.audioCodec, data.videoCodec, data.timeOffset, data.discontinuity, data.trackSwitch, data.contiguous, data.duration, data.accurateTimeOffset, data.defaultInitPTS);
                                        break;
                                    default:
                                        break;
                                }
                            }); // forward events to main thread
                            observer.on(_events__WEBPACK_IMPORTED_MODULE_1__["default"].FRAG_DECRYPTED, forwardMessage);
                            observer.on(_events__WEBPACK_IMPORTED_MODULE_1__["default"].FRAG_PARSING_INIT_SEGMENT, forwardMessage);
                            observer.on(_events__WEBPACK_IMPORTED_MODULE_1__["default"].FRAG_PARSED, forwardMessage);
                            observer.on(_events__WEBPACK_IMPORTED_MODULE_1__["default"].ERROR, forwardMessage);
                            observer.on(_events__WEBPACK_IMPORTED_MODULE_1__["default"].FRAG_PARSING_METADATA, forwardMessage);
                            observer.on(_events__WEBPACK_IMPORTED_MODULE_1__["default"].FRAG_PARSING_USERDATA, forwardMessage);
                            observer.on(_events__WEBPACK_IMPORTED_MODULE_1__["default"].INIT_PTS_FOUND, forwardMessage); // special case for FRAG_PARSING_DATA: pass data1/data2 as transferable object (no copy)
                            observer.on(_events__WEBPACK_IMPORTED_MODULE_1__["default"].FRAG_PARSING_DATA, function(ev, data) {
                                var transferable = [];
                                var message = {
                                    event: ev,
                                    data: data
                                };
                                if (data.data1) {
                                    message.data1 = data.data1.buffer;
                                    transferable.push(data.data1.buffer);
                                    delete data.data1;
                                }
                                if (data.data2) {
                                    message.data2 = data.data2.buffer;
                                    transferable.push(data.data2.buffer);
                                    delete data.data2;
                                }
                                self1.postMessage(message, transferable);
                            });
                        };
                        /* harmony default export */ __webpack_exports__["default"] = DemuxerWorker;
                    /***/ },
                    /***/ "./src/demux/id3.js": /*!**************************!*\
  !*** ./src/demux/id3.js ***!
  \**************************/ /*! exports provided: default, utf8ArrayToStr */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                        "use strict";
                        __webpack_require__.r(__webpack_exports__);
                        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "utf8ArrayToStr", function() {
                            return utf8ArrayToStr;
                        });
                        /* harmony import */ var _utils_get_self_scope__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/get-self-scope */ "./src/utils/get-self-scope.js");
                        /**
 * ID3 parser
 */ var ID3 = /*#__PURE__*/ function() {
                            function ID3() {}
                            /**
   * Returns true if an ID3 header can be found at offset in data
   * @param {Uint8Array} data - The data to search in
   * @param {number} offset - The offset at which to start searching
   * @return {boolean} - True if an ID3 header is found
   */ ID3.isHeader = function isHeader(data, offset) {
                                /*
    * http://id3.org/id3v2.3.0
    * [0]     = 'I'
    * [1]     = 'D'
    * [2]     = '3'
    * [3,4]   = {Version}
    * [5]     = {Flags}
    * [6-9]   = {ID3 Size}
    *
    * An ID3v2 tag can be detected with the following pattern:
    *  $49 44 33 yy yy xx zz zz zz zz
    * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
    */ if (offset + 10 <= data.length) {
                                    // look for 'ID3' identifier
                                    if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) // check version is within range
                                    {
                                        if (data[offset + 3] < 0xFF && data[offset + 4] < 0xFF) {
                                            // check size is within range
                                            if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) return true;
                                        }
                                    }
                                }
                                return false;
                            };
                            ID3.isFooter = function isFooter(data, offset) {
                                /*
    * The footer is a copy of the header, but with a different identifier
    */ if (offset + 10 <= data.length) {
                                    // look for '3DI' identifier
                                    if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) // check version is within range
                                    {
                                        if (data[offset + 3] < 0xFF && data[offset + 4] < 0xFF) {
                                            // check size is within range
                                            if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) return true;
                                        }
                                    }
                                }
                                return false;
                            };
                            ID3.getID3Data = function getID3Data(data, offset) {
                                var front = offset;
                                var length = 0;
                                while(ID3.isHeader(data, offset)){
                                    // ID3 header is 10 bytes
                                    length += 10;
                                    var size = ID3._readSize(data, offset + 6);
                                    length += size;
                                    if (ID3.isFooter(data, offset + 10)) // ID3 footer is 10 bytes
                                    length += 10;
                                    offset += length;
                                }
                                if (length > 0) return data.subarray(front, front + length);
                                return undefined;
                            };
                            ID3._readSize = function _readSize(data, offset) {
                                var size = 0;
                                size = (data[offset] & 0x7f) << 21;
                                size |= (data[offset + 1] & 0x7f) << 14;
                                size |= (data[offset + 2] & 0x7f) << 7;
                                size |= data[offset + 3] & 0x7f;
                                return size;
                            };
                            ID3.getTimeStamp = function getTimeStamp(data) {
                                var frames = ID3.getID3Frames(data);
                                for(var i = 0; i < frames.length; i++){
                                    var frame = frames[i];
                                    if (ID3.isTimeStampFrame(frame)) return ID3._readTimeStamp(frame);
                                }
                                return undefined;
                            };
                            ID3.isTimeStampFrame = function isTimeStampFrame(frame) {
                                return frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp';
                            };
                            ID3._getFrameData = function _getFrameData(data) {
                                /*
    Frame ID       $xx xx xx xx (four characters)
    Size           $xx xx xx xx
    Flags          $xx xx
    */ var type = String.fromCharCode(data[0], data[1], data[2], data[3]);
                                var size = ID3._readSize(data, 4); // skip frame id, size, and flags
                                var offset = 10;
                                return {
                                    type: type,
                                    size: size,
                                    data: data.subarray(offset, offset + size)
                                };
                            };
                            ID3.getID3Frames = function getID3Frames(id3Data) {
                                var offset = 0;
                                var frames = [];
                                while(ID3.isHeader(id3Data, offset)){
                                    var size = ID3._readSize(id3Data, offset + 6); // skip past ID3 header
                                    offset += 10;
                                    var end = offset + size; // loop through frames in the ID3 tag
                                    while(offset + 8 < end){
                                        var frameData = ID3._getFrameData(id3Data.subarray(offset));
                                        var frame = ID3._decodeFrame(frameData);
                                        if (frame) frames.push(frame);
                                         // skip frame header and frame data
                                        offset += frameData.size + 10;
                                    }
                                    if (ID3.isFooter(id3Data, offset)) offset += 10;
                                }
                                return frames;
                            };
                            ID3._decodeFrame = function _decodeFrame(frame) {
                                if (frame.type === 'PRIV') return ID3._decodePrivFrame(frame);
                                else if (frame.type[0] === 'T') return ID3._decodeTextFrame(frame);
                                else if (frame.type[0] === 'W') return ID3._decodeURLFrame(frame);
                                return undefined;
                            };
                            ID3._readTimeStamp = function _readTimeStamp(timeStampFrame) {
                                if (timeStampFrame.data.byteLength === 8) {
                                    var data = new Uint8Array(timeStampFrame.data); // timestamp is 33 bit expressed as a big-endian eight-octet number,
                                    // with the upper 31 bits set to zero.
                                    var pts33Bit = data[3] & 0x1;
                                    var timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
                                    timestamp /= 45;
                                    if (pts33Bit) timestamp += 47721858.84;
                                     // 2^32 / 90
                                    return Math.round(timestamp);
                                }
                                return undefined;
                            };
                            ID3._decodePrivFrame = function _decodePrivFrame(frame) {
                                /*
    Format: <text string>\0<binary data>
    */ if (frame.size < 2) return undefined;
                                var owner = ID3._utf8ArrayToStr(frame.data, true);
                                var privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
                                return {
                                    key: frame.type,
                                    info: owner,
                                    data: privateData.buffer
                                };
                            };
                            ID3._decodeTextFrame = function _decodeTextFrame(frame) {
                                if (frame.size < 2) return undefined;
                                if (frame.type === 'TXXX') {
                                    /*
      Format:
      [0]   = {Text Encoding}
      [1-?] = {Description}\0{Value}
      */ var index = 1;
                                    var description = ID3._utf8ArrayToStr(frame.data.subarray(index), true);
                                    index += description.length + 1;
                                    var value = ID3._utf8ArrayToStr(frame.data.subarray(index));
                                    return {
                                        key: frame.type,
                                        info: description,
                                        data: value
                                    };
                                } else {
                                    /*
      Format:
      [0]   = {Text Encoding}
      [1-?] = {Value}
      */ var text = ID3._utf8ArrayToStr(frame.data.subarray(1));
                                    return {
                                        key: frame.type,
                                        data: text
                                    };
                                }
                            };
                            ID3._decodeURLFrame = function _decodeURLFrame(frame) {
                                if (frame.type === 'WXXX') {
                                    /*
      Format:
      [0]   = {Text Encoding}
      [1-?] = {Description}\0{URL}
      */ if (frame.size < 2) return undefined;
                                    var index = 1;
                                    var description = ID3._utf8ArrayToStr(frame.data.subarray(index));
                                    index += description.length + 1;
                                    var value = ID3._utf8ArrayToStr(frame.data.subarray(index));
                                    return {
                                        key: frame.type,
                                        info: description,
                                        data: value
                                    };
                                } else {
                                    /*
      Format:
      [0-?] = {URL}
      */ var url = ID3._utf8ArrayToStr(frame.data);
                                    return {
                                        key: frame.type,
                                        data: url
                                    };
                                }
                            } // http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
                            ;
                            ID3._utf8ArrayToStr = function _utf8ArrayToStr(array, exitOnNull) {
                                if (exitOnNull === void 0) exitOnNull = false;
                                var decoder = getTextDecoder();
                                if (decoder) {
                                    var decoded = decoder.decode(array);
                                    if (exitOnNull) {
                                        // grab up to the first null
                                        var idx = decoded.indexOf('\0');
                                        return idx !== -1 ? decoded.substring(0, idx) : decoded;
                                    } // remove any null characters
                                    return decoded.replace(/\0/g, '');
                                }
                                var len = array.length;
                                var c;
                                var char2;
                                var char3;
                                var out = '';
                                var i = 0;
                                while(i < len){
                                    c = array[i++];
                                    if (c === 0x00 && exitOnNull) return out;
                                    else if (c === 0x00 || c === 0x03) continue;
                                    switch(c >> 4){
                                        case 0:
                                        case 1:
                                        case 2:
                                        case 3:
                                        case 4:
                                        case 5:
                                        case 6:
                                        case 7:
                                            // 0xxxxxxx
                                            out += String.fromCharCode(c);
                                            break;
                                        case 12:
                                        case 13:
                                            // 110x xxxx   10xx xxxx
                                            char2 = array[i++];
                                            out += String.fromCharCode((c & 0x1F) << 6 | char2 & 0x3F);
                                            break;
                                        case 14:
                                            // 1110 xxxx  10xx xxxx  10xx xxxx
                                            char2 = array[i++];
                                            char3 = array[i++];
                                            out += String.fromCharCode((c & 0x0F) << 12 | (char2 & 0x3F) << 6 | (char3 & 0x3F) << 0);
                                            break;
                                        default:
                                    }
                                }
                                return out;
                            };
                            return ID3;
                        }();
                        var decoder;
                        function getTextDecoder() {
                            var global = Object(_utils_get_self_scope__WEBPACK_IMPORTED_MODULE_0__["getSelfScope"])(); // safeguard for code that might run both on worker and main thread
                            if (!decoder && typeof global.TextDecoder !== 'undefined') decoder = new global.TextDecoder('utf-8');
                            return decoder;
                        }
                        var utf8ArrayToStr = ID3._utf8ArrayToStr;
                        /* harmony default export */ __webpack_exports__["default"] = ID3;
                    /***/ },
                    /***/ "./src/demux/mp4demuxer.js": /*!*********************************!*\
  !*** ./src/demux/mp4demuxer.js ***!
  \*********************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                        "use strict";
                        __webpack_require__.r(__webpack_exports__);
                        /* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/logger */ "./src/utils/logger.js");
                        /* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../events */ "./src/events.js");
                        /**
 * MP4 demuxer
 */ var UINT32_MAX = Math.pow(2, 32) - 1;
                        var MP4Demuxer = /*#__PURE__*/ function() {
                            function MP4Demuxer(observer, remuxer) {
                                this.observer = observer;
                                this.remuxer = remuxer;
                            }
                            var _proto = MP4Demuxer.prototype;
                            _proto.resetTimeStamp = function resetTimeStamp(initPTS) {
                                this.initPTS = initPTS;
                            };
                            _proto.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
                                // jshint unused:false
                                if (initSegment && initSegment.byteLength) {
                                    var initData = this.initData = MP4Demuxer.parseInitSegment(initSegment); // default audio codec if nothing specified
                                    // TODO : extract that from initsegment
                                    if (audioCodec == null) audioCodec = 'mp4a.40.5';
                                    if (videoCodec == null) videoCodec = 'avc1.42e01e';
                                    var tracks = {};
                                    if (initData.audio && initData.video) tracks.audiovideo = {
                                        container: 'video/mp4',
                                        codec: audioCodec + ',' + videoCodec,
                                        initSegment: duration ? initSegment : null
                                    };
                                    else {
                                        if (initData.audio) tracks.audio = {
                                            container: 'audio/mp4',
                                            codec: audioCodec,
                                            initSegment: duration ? initSegment : null
                                        };
                                        if (initData.video) tracks.video = {
                                            container: 'video/mp4',
                                            codec: videoCodec,
                                            initSegment: duration ? initSegment : null
                                        };
                                    }
                                    this.observer.trigger(_events__WEBPACK_IMPORTED_MODULE_1__["default"].FRAG_PARSING_INIT_SEGMENT, {
                                        tracks: tracks
                                    });
                                } else {
                                    if (audioCodec) this.audioCodec = audioCodec;
                                    if (videoCodec) this.videoCodec = videoCodec;
                                }
                            };
                            MP4Demuxer.probe = function probe(data) {
                                // ensure we find a moof box in the first 16 kB
                                return MP4Demuxer.findBox({
                                    data: data,
                                    start: 0,
                                    end: Math.min(data.length, 16384)
                                }, [
                                    'moof'
                                ]).length > 0;
                            };
                            MP4Demuxer.bin2str = function bin2str(buffer) {
                                return String.fromCharCode.apply(null, buffer);
                            };
                            MP4Demuxer.readUint16 = function readUint16(buffer, offset) {
                                if (buffer.data) {
                                    offset += buffer.start;
                                    buffer = buffer.data;
                                }
                                var val = buffer[offset] << 8 | buffer[offset + 1];
                                return val < 0 ? 65536 + val : val;
                            };
                            MP4Demuxer.readUint32 = function readUint32(buffer, offset) {
                                if (buffer.data) {
                                    offset += buffer.start;
                                    buffer = buffer.data;
                                }
                                var val = buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
                                return val < 0 ? 4294967296 + val : val;
                            };
                            MP4Demuxer.writeUint32 = function writeUint32(buffer, offset, value) {
                                if (buffer.data) {
                                    offset += buffer.start;
                                    buffer = buffer.data;
                                }
                                buffer[offset] = value >> 24;
                                buffer[offset + 1] = value >> 16 & 0xff;
                                buffer[offset + 2] = value >> 8 & 0xff;
                                buffer[offset + 3] = value & 0xff;
                            } // Find the data for a box specified by its path
                            ;
                            MP4Demuxer.findBox = function findBox(data, path) {
                                var results = [], i, size, type, end, subresults, start, endbox;
                                if (data.data) {
                                    start = data.start;
                                    end = data.end;
                                    data = data.data;
                                } else {
                                    start = 0;
                                    end = data.byteLength;
                                }
                                if (!path.length) // short-circuit the search for empty paths
                                return null;
                                for(i = start; i < end;){
                                    size = MP4Demuxer.readUint32(data, i);
                                    type = MP4Demuxer.bin2str(data.subarray(i + 4, i + 8));
                                    endbox = size > 1 ? i + size : end;
                                    if (type === path[0]) {
                                        if (path.length === 1) // this is the end of the path and we've found the box we were
                                        // looking for
                                        results.push({
                                            data: data,
                                            start: i + 8,
                                            end: endbox
                                        });
                                        else {
                                            // recursively search for the next box along the path
                                            subresults = MP4Demuxer.findBox({
                                                data: data,
                                                start: i + 8,
                                                end: endbox
                                            }, path.slice(1));
                                            if (subresults.length) results = results.concat(subresults);
                                        }
                                    }
                                    i = endbox;
                                } // we've finished searching all of data
                                return results;
                            };
                            MP4Demuxer.parseSegmentIndex = function parseSegmentIndex(initSegment) {
                                var moov = MP4Demuxer.findBox(initSegment, [
                                    'moov'
                                ])[0];
                                var moovEndOffset = moov ? moov.end : null; // we need this in case we need to chop of garbage of the end of current data
                                var index = 0;
                                var sidx = MP4Demuxer.findBox(initSegment, [
                                    'sidx'
                                ]);
                                var references;
                                if (!sidx || !sidx[0]) return null;
                                references = [];
                                sidx = sidx[0];
                                var version = sidx.data[0]; // set initial offset, we skip the reference ID (not needed)
                                index = version === 0 ? 8 : 16;
                                var timescale = MP4Demuxer.readUint32(sidx, index);
                                index += 4; // TODO: parse earliestPresentationTime and firstOffset
                                // usually zero in our case
                                var earliestPresentationTime = 0;
                                var firstOffset = 0;
                                if (version === 0) index += 8;
                                else index += 16;
                                 // skip reserved
                                index += 2;
                                var startByte = sidx.end + firstOffset;
                                var referencesCount = MP4Demuxer.readUint16(sidx, index);
                                index += 2;
                                for(var i = 0; i < referencesCount; i++){
                                    var referenceIndex = index;
                                    var referenceInfo = MP4Demuxer.readUint32(sidx, referenceIndex);
                                    referenceIndex += 4;
                                    var referenceSize = referenceInfo & 0x7FFFFFFF;
                                    var referenceType = (referenceInfo & 0x80000000) >>> 31;
                                    if (referenceType === 1) {
                                        console.warn('SIDX has hierarchical references (not supported)');
                                        return;
                                    }
                                    var subsegmentDuration = MP4Demuxer.readUint32(sidx, referenceIndex);
                                    referenceIndex += 4;
                                    references.push({
                                        referenceSize: referenceSize,
                                        subsegmentDuration: subsegmentDuration,
                                        // unscaled
                                        info: {
                                            duration: subsegmentDuration / timescale,
                                            start: startByte,
                                            end: startByte + referenceSize - 1
                                        }
                                    });
                                    startByte += referenceSize; // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
                                    // for |sapDelta|.
                                    referenceIndex += 4; // skip to next ref
                                    index = referenceIndex;
                                }
                                return {
                                    earliestPresentationTime: earliestPresentationTime,
                                    timescale: timescale,
                                    version: version,
                                    referencesCount: referencesCount,
                                    references: references,
                                    moovEndOffset: moovEndOffset
                                };
                            };
                            MP4Demuxer.parseInitSegment = function parseInitSegment(initSegment) {
                                var result = [];
                                var traks = MP4Demuxer.findBox(initSegment, [
                                    'moov',
                                    'trak'
                                ]);
                                traks.forEach(function(trak) {
                                    var tkhd = MP4Demuxer.findBox(trak, [
                                        'tkhd'
                                    ])[0];
                                    if (tkhd) {
                                        var version = tkhd.data[tkhd.start];
                                        var index = version === 0 ? 12 : 20;
                                        var trackId = MP4Demuxer.readUint32(tkhd, index);
                                        var mdhd = MP4Demuxer.findBox(trak, [
                                            'mdia',
                                            'mdhd'
                                        ])[0];
                                        if (mdhd) {
                                            version = mdhd.data[mdhd.start];
                                            index = version === 0 ? 12 : 20;
                                            var timescale = MP4Demuxer.readUint32(mdhd, index);
                                            var hdlr = MP4Demuxer.findBox(trak, [
                                                'mdia',
                                                'hdlr'
                                            ])[0];
                                            if (hdlr) {
                                                var hdlrType = MP4Demuxer.bin2str(hdlr.data.subarray(hdlr.start + 8, hdlr.start + 12));
                                                var type = {
                                                    'soun': 'audio',
                                                    'vide': 'video'
                                                }[hdlrType];
                                                if (type) {
                                                    // extract codec info. TODO : parse codec details to be able to build MIME type
                                                    var codecBox = MP4Demuxer.findBox(trak, [
                                                        'mdia',
                                                        'minf',
                                                        'stbl',
                                                        'stsd'
                                                    ]);
                                                    if (codecBox.length) {
                                                        codecBox = codecBox[0];
                                                        var codecType = MP4Demuxer.bin2str(codecBox.data.subarray(codecBox.start + 12, codecBox.start + 16));
                                                        _utils_logger__WEBPACK_IMPORTED_MODULE_0__["logger"].log("MP4Demuxer:" + type + ":" + codecType + " found");
                                                    }
                                                    result[trackId] = {
                                                        timescale: timescale,
                                                        type: type
                                                    };
                                                    result[type] = {
                                                        timescale: timescale,
                                                        id: trackId
                                                    };
                                                }
                                            }
                                        }
                                    }
                                });
                                return result;
                            };
                            MP4Demuxer.getStartDTS = function getStartDTS(initData, fragment) {
                                var trafs, baseTimes, result; // we need info from two childrend of each track fragment box
                                trafs = MP4Demuxer.findBox(fragment, [
                                    'moof',
                                    'traf'
                                ]); // determine the start times for each track
                                baseTimes = [].concat.apply([], trafs.map(function(traf) {
                                    return MP4Demuxer.findBox(traf, [
                                        'tfhd'
                                    ]).map(function(tfhd) {
                                        var id, scale, baseTime; // get the track id from the tfhd
                                        id = MP4Demuxer.readUint32(tfhd, 4); // assume a 90kHz clock if no timescale was specified
                                        scale = initData[id].timescale || 90e3; // get the base media decode time from the tfdt
                                        baseTime = MP4Demuxer.findBox(traf, [
                                            'tfdt'
                                        ]).map(function(tfdt) {
                                            var version, result;
                                            version = tfdt.data[tfdt.start];
                                            result = MP4Demuxer.readUint32(tfdt, 4);
                                            if (version === 1) {
                                                result *= Math.pow(2, 32);
                                                result += MP4Demuxer.readUint32(tfdt, 8);
                                            }
                                            return result;
                                        })[0]; // convert base time to seconds
                                        return baseTime / scale;
                                    });
                                })); // return the minimum
                                result = Math.min.apply(null, baseTimes);
                                return isFinite(result) ? result : 0;
                            };
                            MP4Demuxer.offsetStartDTS = function offsetStartDTS(initData, fragment, timeOffset) {
                                MP4Demuxer.findBox(fragment, [
                                    'moof',
                                    'traf'
                                ]).map(function(traf) {
                                    return MP4Demuxer.findBox(traf, [
                                        'tfhd'
                                    ]).map(function(tfhd) {
                                        // get the track id from the tfhd
                                        var id = MP4Demuxer.readUint32(tfhd, 4); // assume a 90kHz clock if no timescale was specified
                                        var timescale = initData[id].timescale || 90e3; // get the base media decode time from the tfdt
                                        MP4Demuxer.findBox(traf, [
                                            'tfdt'
                                        ]).map(function(tfdt) {
                                            var version = tfdt.data[tfdt.start];
                                            var baseMediaDecodeTime = MP4Demuxer.readUint32(tfdt, 4);
                                            if (version === 0) MP4Demuxer.writeUint32(tfdt, 4, baseMediaDecodeTime - timeOffset * timescale);
                                            else {
                                                baseMediaDecodeTime *= Math.pow(2, 32);
                                                baseMediaDecodeTime += MP4Demuxer.readUint32(tfdt, 8);
                                                baseMediaDecodeTime -= timeOffset * timescale;
                                                baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
                                                var upper = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
                                                var lower = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
                                                MP4Demuxer.writeUint32(tfdt, 4, upper);
                                                MP4Demuxer.writeUint32(tfdt, 8, lower);
                                            }
                                        });
                                    });
                                });
                            } // feed incoming data to the front of the parsing pipeline
                            ;
                            _proto.append = function append(data, timeOffset, contiguous, accurateTimeOffset) {
                                var initData = this.initData;
                                if (!initData) {
                                    this.resetInitSegment(data, this.audioCodec, this.videoCodec, false);
                                    initData = this.initData;
                                }
                                var startDTS, initPTS = this.initPTS;
                                if (initPTS === undefined) {
                                    var _startDTS = MP4Demuxer.getStartDTS(initData, data);
                                    this.initPTS = initPTS = _startDTS - timeOffset;
                                    this.observer.trigger(_events__WEBPACK_IMPORTED_MODULE_1__["default"].INIT_PTS_FOUND, {
                                        initPTS: initPTS
                                    });
                                }
                                MP4Demuxer.offsetStartDTS(initData, data, initPTS);
                                startDTS = MP4Demuxer.getStartDTS(initData, data);
                                this.remuxer.remux(initData.audio, initData.video, null, null, startDTS, contiguous, accurateTimeOffset, data);
                            };
                            _proto.destroy = function destroy() {};
                            return MP4Demuxer;
                        }();
                        /* harmony default export */ __webpack_exports__["default"] = MP4Demuxer;
                    /***/ },
                    /***/ "./src/errors.ts": /*!***********************!*\
  !*** ./src/errors.ts ***!
  \***********************/ /*! exports provided: ErrorTypes, ErrorDetails */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                        "use strict";
                        __webpack_require__.r(__webpack_exports__);
                        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorTypes", function() {
                            return ErrorTypes;
                        });
                        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorDetails", function() {
                            return ErrorDetails;
                        });
                        var ErrorTypes;
                        /**
 * @enum {ErrorDetails}
 * @typedef {string} ErrorDetail
 */ (function(ErrorTypes) {
                            ErrorTypes["NETWORK_ERROR"] = "networkError";
                            ErrorTypes["MEDIA_ERROR"] = "mediaError";
                            ErrorTypes["KEY_SYSTEM_ERROR"] = "keySystemError";
                            ErrorTypes["MUX_ERROR"] = "muxError";
                            ErrorTypes["OTHER_ERROR"] = "otherError";
                        })(ErrorTypes || (ErrorTypes = {}));
                        var ErrorDetails;
                        (function(ErrorDetails) {
                            ErrorDetails["KEY_SYSTEM_NO_KEYS"] = "keySystemNoKeys";
                            ErrorDetails["KEY_SYSTEM_NO_ACCESS"] = "keySystemNoAccess";
                            ErrorDetails["KEY_SYSTEM_NO_SESSION"] = "keySystemNoSession";
                            ErrorDetails["KEY_SYSTEM_LICENSE_REQUEST_FAILED"] = "keySystemLicenseRequestFailed";
                            ErrorDetails["KEY_SYSTEM_NO_INIT_DATA"] = "keySystemNoInitData";
                            ErrorDetails["MANIFEST_LOAD_ERROR"] = "manifestLoadError";
                            ErrorDetails["MANIFEST_LOAD_TIMEOUT"] = "manifestLoadTimeOut";
                            ErrorDetails["MANIFEST_PARSING_ERROR"] = "manifestParsingError";
                            ErrorDetails["MANIFEST_INCOMPATIBLE_CODECS_ERROR"] = "manifestIncompatibleCodecsError";
                            ErrorDetails["LEVEL_LOAD_ERROR"] = "levelLoadError";
                            ErrorDetails["LEVEL_LOAD_TIMEOUT"] = "levelLoadTimeOut";
                            ErrorDetails["LEVEL_SWITCH_ERROR"] = "levelSwitchError";
                            ErrorDetails["AUDIO_TRACK_LOAD_ERROR"] = "audioTrackLoadError";
                            ErrorDetails["AUDIO_TRACK_LOAD_TIMEOUT"] = "audioTrackLoadTimeOut";
                            ErrorDetails["FRAG_LOAD_ERROR"] = "fragLoadError";
                            ErrorDetails["FRAG_LOAD_TIMEOUT"] = "fragLoadTimeOut";
                            ErrorDetails["FRAG_DECRYPT_ERROR"] = "fragDecryptError";
                            ErrorDetails["FRAG_PARSING_ERROR"] = "fragParsingError";
                            ErrorDetails["REMUX_ALLOC_ERROR"] = "remuxAllocError";
                            ErrorDetails["KEY_LOAD_ERROR"] = "keyLoadError";
                            ErrorDetails["KEY_LOAD_TIMEOUT"] = "keyLoadTimeOut";
                            ErrorDetails["BUFFER_ADD_CODEC_ERROR"] = "bufferAddCodecError";
                            ErrorDetails["BUFFER_APPEND_ERROR"] = "bufferAppendError";
                            ErrorDetails["BUFFER_APPENDING_ERROR"] = "bufferAppendingError";
                            ErrorDetails["BUFFER_STALLED_ERROR"] = "bufferStalledError";
                            ErrorDetails["BUFFER_FULL_ERROR"] = "bufferFullError";
                            ErrorDetails["BUFFER_SEEK_OVER_HOLE"] = "bufferSeekOverHole";
                            ErrorDetails["BUFFER_NUDGE_ON_STALL"] = "bufferNudgeOnStall";
                            ErrorDetails["INTERNAL_EXCEPTION"] = "internalException";
                        })(ErrorDetails || (ErrorDetails = {}));
                    /***/ },
                    /***/ "./src/events.js": /*!***********************!*\
  !*** ./src/events.js ***!
  \***********************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                        "use strict";
                        __webpack_require__.r(__webpack_exports__);
                        /**
 * @readonly
 * @enum {string}
 */ var HlsEvents = {
                            // fired before MediaSource is attaching to media element - data: { media }
                            MEDIA_ATTACHING: 'hlsMediaAttaching',
                            // fired when MediaSource has been succesfully attached to media element - data: { }
                            MEDIA_ATTACHED: 'hlsMediaAttached',
                            // fired before detaching MediaSource from media element - data: { }
                            MEDIA_DETACHING: 'hlsMediaDetaching',
                            // fired when MediaSource has been detached from media element - data: { }
                            MEDIA_DETACHED: 'hlsMediaDetached',
                            // fired when we buffer is going to be reset - data: { }
                            BUFFER_RESET: 'hlsBufferReset',
                            // fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
                            BUFFER_CODECS: 'hlsBufferCodecs',
                            // fired when sourcebuffers have been created - data: { tracks : tracks }
                            BUFFER_CREATED: 'hlsBufferCreated',
                            // fired when we append a segment to the buffer - data: { segment: segment object }
                            BUFFER_APPENDING: 'hlsBufferAppending',
                            // fired when we are done with appending a media segment to the buffer - data : { parent : segment parent that triggered BUFFER_APPENDING, pending : nb of segments waiting for appending for this segment parent}
                            BUFFER_APPENDED: 'hlsBufferAppended',
                            // fired when the stream is finished and we want to notify the media buffer that there will be no more data - data: { }
                            BUFFER_EOS: 'hlsBufferEos',
                            // fired when the media buffer should be flushed - data { startOffset, endOffset }
                            BUFFER_FLUSHING: 'hlsBufferFlushing',
                            // fired when the media buffer has been flushed - data: { }
                            BUFFER_FLUSHED: 'hlsBufferFlushed',
                            // fired to signal that a manifest loading starts - data: { url : manifestURL}
                            MANIFEST_LOADING: 'hlsManifestLoading',
                            // fired after manifest has been loaded - data: { levels : [available quality levels], audioTracks : [ available audio tracks], url : manifestURL, stats : { trequest, tfirst, tload, mtime}}
                            MANIFEST_LOADED: 'hlsManifestLoaded',
                            // fired after manifest has been parsed - data: { levels : [available quality levels], firstLevel : index of first quality level appearing in Manifest}
                            MANIFEST_PARSED: 'hlsManifestParsed',
                            // fired when a level switch is requested - data: { level : id of new level }
                            LEVEL_SWITCHING: 'hlsLevelSwitching',
                            // fired when a level switch is effective - data: { level : id of new level }
                            LEVEL_SWITCHED: 'hlsLevelSwitched',
                            // fired when a level playlist loading starts - data: { url : level URL, level : id of level being loaded}
                            LEVEL_LOADING: 'hlsLevelLoading',
                            // fired when a level playlist loading finishes - data: { details : levelDetails object, level : id of loaded level, stats : { trequest, tfirst, tload, mtime} }
                            LEVEL_LOADED: 'hlsLevelLoaded',
                            // fired when a level's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, level : id of updated level }
                            LEVEL_UPDATED: 'hlsLevelUpdated',
                            // fired when a level's PTS information has been updated after parsing a fragment - data: { details : levelDetails object, level : id of updated level, drift: PTS drift observed when parsing last fragment }
                            LEVEL_PTS_UPDATED: 'hlsLevelPtsUpdated',
                            // fired to notify that audio track lists has been updated - data: { audioTracks : audioTracks }
                            AUDIO_TRACKS_UPDATED: 'hlsAudioTracksUpdated',
                            // fired when an audio track switching is requested - data: { id : audio track id }
                            AUDIO_TRACK_SWITCHING: 'hlsAudioTrackSwitching',
                            // fired when an audio track switch actually occurs - data: { id : audio track id }
                            AUDIO_TRACK_SWITCHED: 'hlsAudioTrackSwitched',
                            // fired when an audio track loading starts - data: { url : audio track URL, id : audio track id }
                            AUDIO_TRACK_LOADING: 'hlsAudioTrackLoading',
                            // fired when an audio track loading finishes - data: { details : levelDetails object, id : audio track id, stats : { trequest, tfirst, tload, mtime } }
                            AUDIO_TRACK_LOADED: 'hlsAudioTrackLoaded',
                            // fired to notify that subtitle track lists has been updated - data: { subtitleTracks : subtitleTracks }
                            SUBTITLE_TRACKS_UPDATED: 'hlsSubtitleTracksUpdated',
                            // fired when an subtitle track switch occurs - data: { id : subtitle track id }
                            SUBTITLE_TRACK_SWITCH: 'hlsSubtitleTrackSwitch',
                            // fired when a subtitle track loading starts - data: { url : subtitle track URL, id : subtitle track id }
                            SUBTITLE_TRACK_LOADING: 'hlsSubtitleTrackLoading',
                            // fired when a subtitle track loading finishes - data: { details : levelDetails object, id : subtitle track id, stats : { trequest, tfirst, tload, mtime } }
                            SUBTITLE_TRACK_LOADED: 'hlsSubtitleTrackLoaded',
                            // fired when a subtitle fragment has been processed - data: { success : boolean, frag : the processed frag }
                            SUBTITLE_FRAG_PROCESSED: 'hlsSubtitleFragProcessed',
                            // fired when the first timestamp is found - data: { id : demuxer id, initPTS: initPTS, frag : fragment object }
                            INIT_PTS_FOUND: 'hlsInitPtsFound',
                            // fired when a fragment loading starts - data: { frag : fragment object }
                            FRAG_LOADING: 'hlsFragLoading',
                            // fired when a fragment loading is progressing - data: { frag : fragment object, { trequest, tfirst, loaded } }
                            FRAG_LOAD_PROGRESS: 'hlsFragLoadProgress',
                            // Identifier for fragment load aborting for emergency switch down - data: { frag : fragment object }
                            FRAG_LOAD_EMERGENCY_ABORTED: 'hlsFragLoadEmergencyAborted',
                            // fired when a fragment loading is completed - data: { frag : fragment object, payload : fragment payload, stats : { trequest, tfirst, tload, length } }
                            FRAG_LOADED: 'hlsFragLoaded',
                            // fired when a fragment has finished decrypting - data: { id : demuxer id, frag: fragment object, payload : fragment payload, stats : { tstart, tdecrypt } }
                            FRAG_DECRYPTED: 'hlsFragDecrypted',
                            // fired when Init Segment has been extracted from fragment - data: { id : demuxer id, frag: fragment object, moov : moov MP4 box, codecs : codecs found while parsing fragment }
                            FRAG_PARSING_INIT_SEGMENT: 'hlsFragParsingInitSegment',
                            // fired when parsing sei text is completed - data: { id : demuxer id, frag: fragment object, samples : [ sei samples pes ] }
                            FRAG_PARSING_USERDATA: 'hlsFragParsingUserdata',
                            // fired when parsing id3 is completed - data: { id : demuxer id, frag: fragment object, samples : [ id3 samples pes ] }
                            FRAG_PARSING_METADATA: 'hlsFragParsingMetadata',
                            // fired when data have been extracted from fragment - data: { id : demuxer id, frag: fragment object, data1 : moof MP4 box or TS fragments, data2 : mdat MP4 box or null}
                            FRAG_PARSING_DATA: 'hlsFragParsingData',
                            // fired when fragment parsing is completed - data: { id : demuxer id, frag: fragment object }
                            FRAG_PARSED: 'hlsFragParsed',
                            // fired when fragment remuxed MP4 boxes have all been appended into SourceBuffer - data: { id : demuxer id, frag : fragment object, stats : { trequest, tfirst, tload, tparsed, tbuffered, length, bwEstimate } }
                            FRAG_BUFFERED: 'hlsFragBuffered',
                            // fired when fragment matching with current media position is changing - data : { id : demuxer id, frag : fragment object }
                            FRAG_CHANGED: 'hlsFragChanged',
                            // Identifier for a FPS drop event - data: { curentDropped, currentDecoded, totalDroppedFrames }
                            FPS_DROP: 'hlsFpsDrop',
                            // triggered when FPS drop triggers auto level capping - data: { level, droppedlevel }
                            FPS_DROP_LEVEL_CAPPING: 'hlsFpsDropLevelCapping',
                            // Identifier for an error event - data: { type : error type, details : error details, fatal : if true, hls.js cannot/will not try to recover, if false, hls.js will try to recover,other error specific data }
                            ERROR: 'hlsError',
                            // fired when hls.js instance starts destroying. Different from MEDIA_DETACHED as one could want to detach and reattach a media to the instance of hls.js to handle mid-rolls for example - data: { }
                            DESTROYING: 'hlsDestroying',
                            // fired when a decrypt key loading starts - data: { frag : fragment object }
                            KEY_LOADING: 'hlsKeyLoading',
                            // fired when a decrypt key loading is completed - data: { frag : fragment object, payload : key payload, stats : { trequest, tfirst, tload, length } }
                            KEY_LOADED: 'hlsKeyLoaded',
                            // fired upon stream controller state transitions - data: { previousState, nextState }
                            STREAM_STATE_TRANSITION: 'hlsStreamStateTransition',
                            // fired when the live back buffer is reached defined by the liveBackBufferLength config option - data : { bufferEnd: number }
                            LIVE_BACK_BUFFER_REACHED: 'hlsLiveBackBufferReached'
                        };
                        /* harmony default export */ __webpack_exports__["default"] = HlsEvents;
                    /***/ },
                    /***/ "./src/hls.ts": /*!*********************************!*\
  !*** ./src/hls.ts + 50 modules ***!
  \*********************************/ /*! exports provided: default */ /*! ModuleConcatenation bailout: Cannot concat with ./src/crypt/decrypter.js because of ./src/demux/demuxer-worker.js */ /*! ModuleConcatenation bailout: Cannot concat with ./src/demux/demuxer-inline.js because of ./src/demux/demuxer-worker.js */ /*! ModuleConcatenation bailout: Cannot concat with ./src/demux/id3.js because of ./src/demux/demuxer-worker.js */ /*! ModuleConcatenation bailout: Cannot concat with ./src/demux/mp4demuxer.js because of ./src/demux/demuxer-worker.js */ /*! ModuleConcatenation bailout: Cannot concat with ./src/errors.ts because of ./src/demux/demuxer-worker.js */ /*! ModuleConcatenation bailout: Cannot concat with ./src/events.js because of ./src/demux/demuxer-worker.js */ /*! ModuleConcatenation bailout: Cannot concat with ./src/polyfills/number-isFinite.js because of ./src/demux/demuxer-worker.js */ /*! ModuleConcatenation bailout: Cannot concat with ./src/utils/get-self-scope.js because of ./src/demux/demuxer-worker.js */ /*! ModuleConcatenation bailout: Cannot concat with ./src/utils/logger.js because of ./src/demux/demuxer-worker.js */ /*! ModuleConcatenation bailout: Cannot concat with ./node_modules/eventemitter3/index.js (<- Module is not an ECMAScript module) */ /*! ModuleConcatenation bailout: Cannot concat with ./node_modules/url-toolkit/src/url-toolkit.js (<- Module is not an ECMAScript module) */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                        "use strict";
                        __webpack_require__.r(__webpack_exports__);
                        var cues_namespaceObject = {};
                        __webpack_require__.r(cues_namespaceObject);
                        __webpack_require__.d(cues_namespaceObject, "newCue", function() {
                            return newCue;
                        });
                        // EXTERNAL MODULE: ./node_modules/url-toolkit/src/url-toolkit.js
                        var url_toolkit = __webpack_require__("./node_modules/url-toolkit/src/url-toolkit.js");
                        // EXTERNAL MODULE: ./src/errors.ts
                        var errors = __webpack_require__("./src/errors.ts");
                        // EXTERNAL MODULE: ./src/polyfills/number-isFinite.js
                        var number_isFinite = __webpack_require__("./src/polyfills/number-isFinite.js");
                        // EXTERNAL MODULE: ./src/events.js
                        var events = __webpack_require__("./src/events.js");
                        // EXTERNAL MODULE: ./src/utils/logger.js
                        var logger = __webpack_require__("./src/utils/logger.js");
                        // CONCATENATED MODULE: ./src/event-handler.ts
                        /*
*
* All objects in the event handling chain should inherit from this class
*
*/ var FORBIDDEN_EVENT_NAMES = {
                            'hlsEventGeneric': true,
                            'hlsHandlerDestroying': true,
                            'hlsHandlerDestroyed': true
                        };
                        var event_handler_EventHandler = /*#__PURE__*/ function() {
                            function EventHandler(hls) {
                                this.hls = void 0;
                                this.handledEvents = void 0;
                                this.useGenericHandler = void 0;
                                this.hls = hls;
                                this.onEvent = this.onEvent.bind(this);
                                for(var _len = arguments.length, events = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)events[_key - 1] = arguments[_key];
                                this.handledEvents = events;
                                this.useGenericHandler = true;
                                this.registerListeners();
                            }
                            var _proto = EventHandler.prototype;
                            _proto.destroy = function destroy() {
                                this.onHandlerDestroying();
                                this.unregisterListeners();
                                this.onHandlerDestroyed();
                            };
                            _proto.onHandlerDestroying = function onHandlerDestroying() {};
                            _proto.onHandlerDestroyed = function onHandlerDestroyed() {};
                            _proto.isEventHandler = function isEventHandler() {
                                return typeof this.handledEvents === 'object' && this.handledEvents.length && typeof this.onEvent === 'function';
                            };
                            _proto.registerListeners = function registerListeners() {
                                if (this.isEventHandler()) this.handledEvents.forEach(function(event) {
                                    if (FORBIDDEN_EVENT_NAMES[event]) throw new Error('Forbidden event-name: ' + event);
                                    this.hls.on(event, this.onEvent);
                                }, this);
                            };
                            _proto.unregisterListeners = function unregisterListeners() {
                                if (this.isEventHandler()) this.handledEvents.forEach(function(event) {
                                    this.hls.off(event, this.onEvent);
                                }, this);
                            };
                            _proto.onEvent = function onEvent(event, data) {
                                this.onEventGeneric(event, data);
                            };
                            _proto.onEventGeneric = function onEventGeneric(event, data) {
                                var eventToFunction = function eventToFunction(event, data) {
                                    var funcName = 'on' + event.replace('hls', '');
                                    if (typeof this[funcName] !== 'function') throw new Error("Event " + event + " has no generic handler in this " + this.constructor.name + " class (tried " + funcName + ")");
                                    return this[funcName].bind(this, data);
                                };
                                try {
                                    eventToFunction.call(this, event, data).call();
                                } catch (err) {
                                    logger["logger"].error("An internal error happened while handling event " + event + ". Error message: \"" + err.message + "\". Here is a stacktrace:", err);
                                    this.hls.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].OTHER_ERROR,
                                        details: errors["ErrorDetails"].INTERNAL_EXCEPTION,
                                        fatal: false,
                                        event: event,
                                        err: err
                                    });
                                }
                            };
                            return EventHandler;
                        }();
                        /* harmony default export */ var event_handler = event_handler_EventHandler;
                        // CONCATENATED MODULE: ./src/types/loader.ts
                        /**
 * `type` property values for this loaders' context object
 * @enum
 *
 */ var PlaylistContextType;
                        /**
 * @enum {string}
 */ (function(PlaylistContextType) {
                            PlaylistContextType["MANIFEST"] = "manifest";
                            PlaylistContextType["LEVEL"] = "level";
                            PlaylistContextType["AUDIO_TRACK"] = "audioTrack";
                            PlaylistContextType["SUBTITLE_TRACK"] = "subtitleTrack";
                        })(PlaylistContextType || (PlaylistContextType = {}));
                        var PlaylistLevelType;
                        (function(PlaylistLevelType) {
                            PlaylistLevelType["MAIN"] = "main";
                            PlaylistLevelType["AUDIO"] = "audio";
                            PlaylistLevelType["SUBTITLE"] = "subtitle";
                        })(PlaylistLevelType || (PlaylistLevelType = {}));
                        // EXTERNAL MODULE: ./src/demux/mp4demuxer.js
                        var mp4demuxer = __webpack_require__("./src/demux/mp4demuxer.js");
                        // CONCATENATED MODULE: ./src/loader/level-key.ts
                        function _defineProperties(target, props) {
                            for(var i = 0; i < props.length; i++){
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function _createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) _defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        var level_key_LevelKey = /*#__PURE__*/ function() {
                            function LevelKey(baseURI, relativeURI) {
                                this._uri = null;
                                this.baseuri = void 0;
                                this.reluri = void 0;
                                this.method = null;
                                this.key = null;
                                this.iv = null;
                                this.baseuri = baseURI;
                                this.reluri = relativeURI;
                            }
                            _createClass(LevelKey, [
                                {
                                    key: "uri",
                                    get: function get() {
                                        if (!this._uri && this.reluri) this._uri = Object(url_toolkit["buildAbsoluteURL"])(this.baseuri, this.reluri, {
                                            alwaysNormalize: true
                                        });
                                        return this._uri;
                                    }
                                }
                            ]);
                            return LevelKey;
                        }();
                        // CONCATENATED MODULE: ./src/loader/fragment.ts
                        function fragment_defineProperties(target, props) {
                            for(var i = 0; i < props.length; i++){
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function fragment_createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) fragment_defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) fragment_defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        var ElementaryStreamTypes;
                        (function(ElementaryStreamTypes) {
                            ElementaryStreamTypes["AUDIO"] = "audio";
                            ElementaryStreamTypes["VIDEO"] = "video";
                        })(ElementaryStreamTypes || (ElementaryStreamTypes = {}));
                        var fragment_Fragment = /*#__PURE__*/ function() {
                            function Fragment() {
                                var _this$_elementaryStre;
                                this._url = null;
                                this._byteRange = null;
                                this._decryptdata = null;
                                this._elementaryStreams = (_this$_elementaryStre = {}, _this$_elementaryStre[ElementaryStreamTypes.AUDIO] = false, _this$_elementaryStre[ElementaryStreamTypes.VIDEO] = false, _this$_elementaryStre);
                                this.deltaPTS = 0;
                                this.rawProgramDateTime = null;
                                this.programDateTime = null;
                                this.title = null;
                                this.tagList = [];
                                this.cc = void 0;
                                this.type = void 0;
                                this.relurl = void 0;
                                this.baseurl = void 0;
                                this.duration = void 0;
                                this.start = void 0;
                                this.sn = 0;
                                this.urlId = 0;
                                this.level = 0;
                                this.levelkey = void 0;
                                this.loader = void 0;
                            }
                            var _proto = Fragment.prototype;
                            // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
                            _proto.setByteRange = function setByteRange(value, previousFrag) {
                                var params = value.split('@', 2);
                                var byteRange = [];
                                if (params.length === 1) byteRange[0] = previousFrag ? previousFrag.byteRangeEndOffset : 0;
                                else byteRange[0] = parseInt(params[1]);
                                byteRange[1] = parseInt(params[0]) + byteRange[0];
                                this._byteRange = byteRange;
                            };
                            /**
   * @param {ElementaryStreamTypes} type
   */ _proto.addElementaryStream = function addElementaryStream(type) {
                                this._elementaryStreams[type] = true;
                            };
                            _proto.hasElementaryStream = function hasElementaryStream(type) {
                                return this._elementaryStreams[type] === true;
                            };
                            _proto.createInitializationVector = function createInitializationVector(segmentNumber) {
                                var uint8View = new Uint8Array(16);
                                for(var i = 12; i < 16; i++)uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
                                return uint8View;
                            };
                            _proto.setDecryptDataFromLevelKey = function setDecryptDataFromLevelKey(levelkey, segmentNumber) {
                                var decryptdata = levelkey;
                                if (levelkey && levelkey.method && levelkey.uri && !levelkey.iv) {
                                    decryptdata = new level_key_LevelKey(levelkey.baseuri, levelkey.reluri);
                                    decryptdata.method = levelkey.method;
                                    decryptdata.iv = this.createInitializationVector(segmentNumber);
                                }
                                return decryptdata;
                            };
                            fragment_createClass(Fragment, [
                                {
                                    key: "url",
                                    get: function get() {
                                        if (!this._url && this.relurl) this._url = Object(url_toolkit["buildAbsoluteURL"])(this.baseurl, this.relurl, {
                                            alwaysNormalize: true
                                        });
                                        return this._url;
                                    },
                                    set: function set(value) {
                                        this._url = value;
                                    }
                                },
                                {
                                    key: "byteRange",
                                    get: function get() {
                                        if (!this._byteRange) return [];
                                        return this._byteRange;
                                    }
                                },
                                {
                                    key: "byteRangeStartOffset",
                                    get: function get() {
                                        return this.byteRange[0];
                                    }
                                },
                                {
                                    key: "byteRangeEndOffset",
                                    get: function get() {
                                        return this.byteRange[1];
                                    }
                                },
                                {
                                    key: "decryptdata",
                                    get: function get() {
                                        if (!this.levelkey && !this._decryptdata) return null;
                                        if (!this._decryptdata && this.levelkey) {
                                            var sn = this.sn;
                                            if (typeof sn !== 'number') {
                                                // We are fetching decryption data for a initialization segment
                                                // If the segment was encrypted with AES-128
                                                // It must have an IV defined. We cannot substitute the Segment Number in.
                                                if (this.levelkey && this.levelkey.method === 'AES-128' && !this.levelkey.iv) logger["logger"].warn("missing IV for initialization segment with method=\"" + this.levelkey.method + "\" - compliance issue");
                                                /*
          Be converted to a Number.
          'initSegment' will become NaN.
          NaN, which when converted through ToInt32() -> +0.
          ---
          Explicitly set sn to resulting value from implicit conversions 'initSegment' values for IV generation.
          */ sn = 0;
                                            }
                                            this._decryptdata = this.setDecryptDataFromLevelKey(this.levelkey, sn);
                                        }
                                        return this._decryptdata;
                                    }
                                },
                                {
                                    key: "endProgramDateTime",
                                    get: function get() {
                                        if (this.programDateTime === null) return null;
                                        if (!Object(number_isFinite["isFiniteNumber"])(this.programDateTime)) return null;
                                        var duration = !Object(number_isFinite["isFiniteNumber"])(this.duration) ? 0 : this.duration;
                                        return this.programDateTime + duration * 1000;
                                    }
                                },
                                {
                                    key: "encrypted",
                                    get: function get() {
                                        return !!(this.decryptdata && this.decryptdata.uri !== null && this.decryptdata.key === null);
                                    }
                                }
                            ]);
                            return Fragment;
                        }();
                        // CONCATENATED MODULE: ./src/loader/level.js
                        function level_defineProperties(target, props) {
                            for(var i = 0; i < props.length; i++){
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function level_createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) level_defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) level_defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        var level_Level = /*#__PURE__*/ function() {
                            function Level(baseUrl) {
                                // Please keep properties in alphabetical order
                                this.endCC = 0;
                                this.endSN = 0;
                                this.fragments = [];
                                this.initSegment = null;
                                this.live = true;
                                this.needSidxRanges = false;
                                this.startCC = 0;
                                this.startSN = 0;
                                this.startTimeOffset = null;
                                this.targetduration = 0;
                                this.totalduration = 0;
                                this.type = null;
                                this.url = baseUrl;
                                this.version = null;
                            }
                            level_createClass(Level, [
                                {
                                    key: "hasProgramDateTime",
                                    get: function get() {
                                        return !!(this.fragments[0] && Object(number_isFinite["isFiniteNumber"])(this.fragments[0].programDateTime));
                                    }
                                }
                            ]);
                            return Level;
                        }();
                        // CONCATENATED MODULE: ./src/utils/attr-list.js
                        var DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/; // eslint-disable-line no-useless-escape
                        var ATTR_LIST_REGEX = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g; // eslint-disable-line no-useless-escape
                        // adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
                        var AttrList = /*#__PURE__*/ function() {
                            function AttrList(attrs) {
                                if (typeof attrs === 'string') attrs = AttrList.parseAttrList(attrs);
                                for(var attr in attrs)if (attrs.hasOwnProperty(attr)) this[attr] = attrs[attr];
                            }
                            var _proto = AttrList.prototype;
                            _proto.decimalInteger = function decimalInteger(attrName) {
                                var intValue = parseInt(this[attrName], 10);
                                if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;
                                return intValue;
                            };
                            _proto.hexadecimalInteger = function hexadecimalInteger(attrName) {
                                if (this[attrName]) {
                                    var stringValue = (this[attrName] || '0x').slice(2);
                                    stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;
                                    var value = new Uint8Array(stringValue.length / 2);
                                    for(var i = 0; i < stringValue.length / 2; i++)value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
                                    return value;
                                } else return null;
                            };
                            _proto.hexadecimalIntegerAsNumber = function hexadecimalIntegerAsNumber(attrName) {
                                var intValue = parseInt(this[attrName], 16);
                                if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;
                                return intValue;
                            };
                            _proto.decimalFloatingPoint = function decimalFloatingPoint(attrName) {
                                return parseFloat(this[attrName]);
                            };
                            _proto.enumeratedString = function enumeratedString(attrName) {
                                return this[attrName];
                            };
                            _proto.decimalResolution = function decimalResolution(attrName) {
                                var res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
                                if (res === null) return undefined;
                                return {
                                    width: parseInt(res[1], 10),
                                    height: parseInt(res[2], 10)
                                };
                            };
                            AttrList.parseAttrList = function parseAttrList(input) {
                                var match, attrs = {};
                                ATTR_LIST_REGEX.lastIndex = 0;
                                while((match = ATTR_LIST_REGEX.exec(input)) !== null){
                                    var value = match[2], quote = '"';
                                    if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1) value = value.slice(1, -1);
                                    attrs[match[1]] = value;
                                }
                                return attrs;
                            };
                            return AttrList;
                        }();
                        /* harmony default export */ var attr_list = AttrList;
                        // CONCATENATED MODULE: ./src/utils/codecs.ts
                        // from http://mp4ra.org/codecs.html
                        var sampleEntryCodesISO = {
                            audio: {
                                'a3ds': true,
                                'ac-3': true,
                                'ac-4': true,
                                'alac': true,
                                'alaw': true,
                                'dra1': true,
                                'dts+': true,
                                'dts-': true,
                                'dtsc': true,
                                'dtse': true,
                                'dtsh': true,
                                'ec-3': true,
                                'enca': true,
                                'g719': true,
                                'g726': true,
                                'm4ae': true,
                                'mha1': true,
                                'mha2': true,
                                'mhm1': true,
                                'mhm2': true,
                                'mlpa': true,
                                'mp4a': true,
                                'raw ': true,
                                'Opus': true,
                                'samr': true,
                                'sawb': true,
                                'sawp': true,
                                'sevc': true,
                                'sqcp': true,
                                'ssmv': true,
                                'twos': true,
                                'ulaw': true
                            },
                            video: {
                                'avc1': true,
                                'avc2': true,
                                'avc3': true,
                                'avc4': true,
                                'avcp': true,
                                'drac': true,
                                'dvav': true,
                                'dvhe': true,
                                'encv': true,
                                'hev1': true,
                                'hvc1': true,
                                'mjp2': true,
                                'mp4v': true,
                                'mvc1': true,
                                'mvc2': true,
                                'mvc3': true,
                                'mvc4': true,
                                'resv': true,
                                'rv60': true,
                                's263': true,
                                'svc1': true,
                                'svc2': true,
                                'vc-1': true,
                                'vp08': true,
                                'vp09': true
                            }
                        };
                        function isCodecType(codec, type) {
                            var typeCodes = sampleEntryCodesISO[type];
                            return !!typeCodes && typeCodes[codec.slice(0, 4)] === true;
                        }
                        function isCodecSupportedInMp4(codec, type) {
                            return MediaSource.isTypeSupported((type || 'video') + "/mp4;codecs=\"" + codec + "\"");
                        }
                        // CONCATENATED MODULE: ./src/loader/m3u8-parser.ts
                        /**
 * M3U8 parser
 * @module
 */ // https://regex101.com is your friend
                        var MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g;
                        var MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
                        var LEVEL_PLAYLIST_REGEX_FAST = new RegExp([
                            /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
                            /|(?!#)([\S+ ?]+)/.source,
                            /|#EXT-X-BYTERANGE:*(.+)/.source,
                            /|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
                            /|#.*/.source // All other non-segment oriented tags will match with all groups empty
                        ].join(''), 'g');
                        var LEVEL_PLAYLIST_REGEX_SLOW = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)([^:]*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/;
                        var MP4_REGEX_SUFFIX = /\.(mp4|m4s|m4v|m4a)$/i;
                        var m3u8_parser_M3U8Parser = /*#__PURE__*/ function() {
                            function M3U8Parser() {}
                            M3U8Parser.findGroup = function findGroup(groups, mediaGroupId) {
                                for(var i = 0; i < groups.length; i++){
                                    var group = groups[i];
                                    if (group.id === mediaGroupId) return group;
                                }
                            };
                            M3U8Parser.convertAVC1ToAVCOTI = function convertAVC1ToAVCOTI(codec) {
                                var avcdata = codec.split('.');
                                var result;
                                if (avcdata.length > 2) {
                                    result = avcdata.shift() + '.';
                                    result += parseInt(avcdata.shift()).toString(16);
                                    result += ('000' + parseInt(avcdata.shift()).toString(16)).substr(-4);
                                } else result = codec;
                                return result;
                            };
                            M3U8Parser.resolve = function resolve(url, baseUrl) {
                                return url_toolkit["buildAbsoluteURL"](baseUrl, url, {
                                    alwaysNormalize: true
                                });
                            };
                            M3U8Parser.parseMasterPlaylist = function parseMasterPlaylist(string, baseurl) {
                                // TODO(typescript-level)
                                var levels = [];
                                MASTER_PLAYLIST_REGEX.lastIndex = 0; // TODO(typescript-level)
                                function setCodecs(codecs, level) {
                                    [
                                        'video',
                                        'audio'
                                    ].forEach(function(type) {
                                        var filtered = codecs.filter(function(codec) {
                                            return isCodecType(codec, type);
                                        });
                                        if (filtered.length) {
                                            var preferred = filtered.filter(function(codec) {
                                                return codec.lastIndexOf('avc1', 0) === 0 || codec.lastIndexOf('mp4a', 0) === 0;
                                            });
                                            level[type + "Codec"] = preferred.length > 0 ? preferred[0] : filtered[0]; // remove from list
                                            codecs = codecs.filter(function(codec) {
                                                return filtered.indexOf(codec) === -1;
                                            });
                                        }
                                    });
                                    level.unknownCodecs = codecs;
                                }
                                var result;
                                while((result = MASTER_PLAYLIST_REGEX.exec(string)) != null){
                                    // TODO(typescript-level)
                                    var level = {};
                                    var attrs = level.attrs = new attr_list(result[1]);
                                    level.url = M3U8Parser.resolve(result[2], baseurl);
                                    var resolution = attrs.decimalResolution('RESOLUTION');
                                    if (resolution) {
                                        level.width = resolution.width;
                                        level.height = resolution.height;
                                    }
                                    level.bitrate = attrs.decimalInteger('AVERAGE-BANDWIDTH') || attrs.decimalInteger('BANDWIDTH');
                                    level.name = attrs.NAME;
                                    setCodecs([].concat((attrs.CODECS || '').split(/[ ,]+/)), level);
                                    if (level.videoCodec && level.videoCodec.indexOf('avc1') !== -1) level.videoCodec = M3U8Parser.convertAVC1ToAVCOTI(level.videoCodec);
                                    levels.push(level);
                                }
                                return levels;
                            };
                            M3U8Parser.parseMasterPlaylistMedia = function parseMasterPlaylistMedia(string, baseurl, type, audioGroups) {
                                if (audioGroups === void 0) audioGroups = [];
                                var result;
                                var medias = [];
                                var id = 0;
                                MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
                                while((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null){
                                    var attrs = new attr_list(result[1]);
                                    if (attrs.TYPE === type) {
                                        var media = {
                                            id: id++,
                                            groupId: attrs['GROUP-ID'],
                                            name: attrs.NAME || attrs.LANGUAGE,
                                            type: type,
                                            default: attrs.DEFAULT === 'YES',
                                            autoselect: attrs.AUTOSELECT === 'YES',
                                            forced: attrs.FORCED === 'YES',
                                            lang: attrs.LANGUAGE
                                        };
                                        if (attrs.URI) media.url = M3U8Parser.resolve(attrs.URI, baseurl);
                                        if (audioGroups.length) {
                                            // If there are audio groups signalled in the manifest, let's look for a matching codec string for this track
                                            var groupCodec = M3U8Parser.findGroup(audioGroups, media.groupId); // If we don't find the track signalled, lets use the first audio groups codec we have
                                            // Acting as a best guess
                                            media.audioCodec = groupCodec ? groupCodec.codec : audioGroups[0].codec;
                                        }
                                        medias.push(media);
                                    }
                                }
                                return medias;
                            };
                            M3U8Parser.parseLevelPlaylist = function parseLevelPlaylist(string, baseurl, id, type, levelUrlId) {
                                var currentSN = 0;
                                var totalduration = 0;
                                var level = new level_Level(baseurl);
                                var discontinuityCounter = 0;
                                var prevFrag = null;
                                var frag = new fragment_Fragment();
                                var result;
                                var i;
                                var levelkey;
                                var firstPdtIndex = null;
                                LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
                                while((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null){
                                    var duration = result[1];
                                    if (duration) {
                                        // INF
                                        frag.duration = parseFloat(duration); // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                                        var title = (' ' + result[2]).slice(1);
                                        frag.title = title || null;
                                        frag.tagList.push(title ? [
                                            'INF',
                                            duration,
                                            title
                                        ] : [
                                            'INF',
                                            duration
                                        ]);
                                    } else if (result[3]) // url
                                    {
                                        if (Object(number_isFinite["isFiniteNumber"])(frag.duration)) {
                                            var sn = currentSN++;
                                            frag.type = type;
                                            frag.start = totalduration;
                                            if (levelkey) frag.levelkey = levelkey;
                                            frag.sn = sn;
                                            frag.level = id;
                                            frag.cc = discontinuityCounter;
                                            frag.urlId = levelUrlId;
                                            frag.baseurl = baseurl; // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                                            frag.relurl = (' ' + result[3]).slice(1);
                                            assignProgramDateTime(frag, prevFrag);
                                            level.fragments.push(frag);
                                            prevFrag = frag;
                                            totalduration += frag.duration;
                                            frag = new fragment_Fragment();
                                        }
                                    } else if (result[4]) {
                                        // X-BYTERANGE
                                        var data = (' ' + result[4]).slice(1);
                                        if (prevFrag) frag.setByteRange(data, prevFrag);
                                        else frag.setByteRange(data);
                                    } else if (result[5]) {
                                        // PROGRAM-DATE-TIME
                                        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                                        frag.rawProgramDateTime = (' ' + result[5]).slice(1);
                                        frag.tagList.push([
                                            'PROGRAM-DATE-TIME',
                                            frag.rawProgramDateTime
                                        ]);
                                        if (firstPdtIndex === null) firstPdtIndex = level.fragments.length;
                                    } else {
                                        result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
                                        if (!result) {
                                            logger["logger"].warn('No matches on slow regex match for level playlist!');
                                            continue;
                                        }
                                        for(i = 1; i < result.length; i++){
                                            if (typeof result[i] !== 'undefined') break;
                                        } // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                                        var value1 = (' ' + result[i + 1]).slice(1);
                                        var value2 = (' ' + result[i + 2]).slice(1);
                                        switch(result[i]){
                                            case '#':
                                                frag.tagList.push(value2 ? [
                                                    value1,
                                                    value2
                                                ] : [
                                                    value1
                                                ]);
                                                break;
                                            case 'PLAYLIST-TYPE':
                                                level.type = value1.toUpperCase();
                                                break;
                                            case 'MEDIA-SEQUENCE':
                                                currentSN = level.startSN = parseInt(value1);
                                                break;
                                            case 'TARGETDURATION':
                                                level.targetduration = parseFloat(value1);
                                                break;
                                            case 'VERSION':
                                                level.version = parseInt(value1);
                                                break;
                                            case 'EXTM3U':
                                                break;
                                            case 'ENDLIST':
                                                level.live = false;
                                                break;
                                            case 'DIS':
                                                discontinuityCounter++;
                                                frag.tagList.push([
                                                    'DIS'
                                                ]);
                                                break;
                                            case 'DISCONTINUITY-SEQ':
                                                discontinuityCounter = parseInt(value1);
                                                break;
                                            case 'KEY':
                                                // https://tools.ietf.org/html/draft-pantos-http-live-streaming-08#section-3.4.4
                                                var decryptparams = value1;
                                                var keyAttrs = new attr_list(decryptparams);
                                                var decryptmethod = keyAttrs.enumeratedString('METHOD');
                                                var decrypturi = keyAttrs.URI;
                                                var decryptiv = keyAttrs.hexadecimalInteger('IV');
                                                if (decryptmethod) {
                                                    levelkey = new level_key_LevelKey(baseurl, decrypturi);
                                                    if (decrypturi && [
                                                        'AES-128',
                                                        'SAMPLE-AES',
                                                        'SAMPLE-AES-CENC'
                                                    ].indexOf(decryptmethod) >= 0) {
                                                        levelkey.method = decryptmethod;
                                                        levelkey.key = null; // Initialization Vector (IV)
                                                        levelkey.iv = decryptiv;
                                                    }
                                                }
                                                break;
                                            case 'START':
                                                var startAttrs = new attr_list(value1);
                                                var startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET'); // TIME-OFFSET can be 0
                                                if (Object(number_isFinite["isFiniteNumber"])(startTimeOffset)) level.startTimeOffset = startTimeOffset;
                                                break;
                                            case 'MAP':
                                                var mapAttrs = new attr_list(value1);
                                                frag.relurl = mapAttrs.URI;
                                                if (mapAttrs.BYTERANGE) frag.setByteRange(mapAttrs.BYTERANGE);
                                                frag.baseurl = baseurl;
                                                frag.level = id;
                                                frag.type = type;
                                                frag.sn = 'initSegment';
                                                level.initSegment = frag;
                                                frag = new fragment_Fragment();
                                                frag.rawProgramDateTime = level.initSegment.rawProgramDateTime;
                                                break;
                                            default:
                                                logger["logger"].warn("line parsed but not handled: " + result);
                                                break;
                                        }
                                    }
                                }
                                frag = prevFrag; // logger.log('found ' + level.fragments.length + ' fragments');
                                if (frag && !frag.relurl) {
                                    level.fragments.pop();
                                    totalduration -= frag.duration;
                                }
                                level.totalduration = totalduration;
                                level.averagetargetduration = totalduration / level.fragments.length;
                                level.endSN = currentSN - 1;
                                level.startCC = level.fragments[0] ? level.fragments[0].cc : 0;
                                level.endCC = discontinuityCounter;
                                if (!level.initSegment && level.fragments.length) // this is a bit lurky but HLS really has no other way to tell us
                                // if the fragments are TS or MP4, except if we download them :/
                                // but this is to be able to handle SIDX.
                                {
                                    if (level.fragments.every(function(frag) {
                                        return MP4_REGEX_SUFFIX.test(frag.relurl);
                                    })) {
                                        logger["logger"].warn('MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX');
                                        frag = new fragment_Fragment();
                                        frag.relurl = level.fragments[0].relurl;
                                        frag.baseurl = baseurl;
                                        frag.level = id;
                                        frag.type = type;
                                        frag.sn = 'initSegment';
                                        level.initSegment = frag;
                                        level.needSidxRanges = true;
                                    }
                                }
                                /**
     * Backfill any missing PDT values
       "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
       one or more Media Segment URIs, the client SHOULD extrapolate
       backward from that tag (using EXTINF durations and/or media
       timestamps) to associate dates with those segments."
     * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
     * computed.
     */ if (firstPdtIndex) backfillProgramDateTimes(level.fragments, firstPdtIndex);
                                return level;
                            };
                            return M3U8Parser;
                        }();
                        function backfillProgramDateTimes(fragments, startIndex) {
                            var fragPrev = fragments[startIndex];
                            for(var i = startIndex - 1; i >= 0; i--){
                                var frag = fragments[i];
                                frag.programDateTime = fragPrev.programDateTime - frag.duration * 1000;
                                fragPrev = frag;
                            }
                        }
                        function assignProgramDateTime(frag, prevFrag) {
                            if (frag.rawProgramDateTime) frag.programDateTime = Date.parse(frag.rawProgramDateTime);
                            else if (prevFrag && prevFrag.programDateTime) frag.programDateTime = prevFrag.endProgramDateTime;
                            if (!Object(number_isFinite["isFiniteNumber"])(frag.programDateTime)) {
                                frag.programDateTime = null;
                                frag.rawProgramDateTime = null;
                            }
                        }
                        // CONCATENATED MODULE: ./src/loader/playlist-loader.ts
                        function _inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /**
 * PlaylistLoader - delegate for media manifest/playlist loading tasks. Takes care of parsing media to internal data-models.
 *
 * Once loaded, dispatches events with parsed data-models of manifest/levels/audio/subtitle tracks.
 *
 * Uses loader(s) set in config to do actual internal loading of resource tasks.
 *
 * @module
 *
 */ var _window = window, performance1 = _window.performance;
                        /**
 * @constructor
 */ var playlist_loader_PlaylistLoader = /*#__PURE__*/ function(_EventHandler) {
                            _inheritsLoose(PlaylistLoader, _EventHandler);
                            /**
   * @constructs
   * @param {Hls} hls
   */ function PlaylistLoader(hls) {
                                var _this;
                                _this = _EventHandler.call(this, hls, events["default"].MANIFEST_LOADING, events["default"].LEVEL_LOADING, events["default"].AUDIO_TRACK_LOADING, events["default"].SUBTITLE_TRACK_LOADING) || this;
                                _this.loaders = {};
                                return _this;
                            }
                            /**
   * @param {PlaylistContextType} type
   * @returns {boolean}
   */ PlaylistLoader.canHaveQualityLevels = function canHaveQualityLevels(type) {
                                return type !== PlaylistContextType.AUDIO_TRACK && type !== PlaylistContextType.SUBTITLE_TRACK;
                            };
                            PlaylistLoader.mapContextToLevelType = function mapContextToLevelType(context) {
                                var type = context.type;
                                switch(type){
                                    case PlaylistContextType.AUDIO_TRACK:
                                        return PlaylistLevelType.AUDIO;
                                    case PlaylistContextType.SUBTITLE_TRACK:
                                        return PlaylistLevelType.SUBTITLE;
                                    default:
                                        return PlaylistLevelType.MAIN;
                                }
                            };
                            PlaylistLoader.getResponseUrl = function getResponseUrl(response, context) {
                                var url = response.url; // responseURL not supported on some browsers (it is used to detect URL redirection)
                                // data-uri mode also not supported (but no need to detect redirection)
                                if (url === undefined || url.indexOf('data:') === 0) // fallback to initial URL
                                url = context.url;
                                return url;
                            };
                            var _proto = PlaylistLoader.prototype;
                            _proto.createInternalLoader = function createInternalLoader(context) {
                                var config = this.hls.config;
                                var PLoader = config.pLoader;
                                var Loader = config.loader; // TODO(typescript-config): Verify once config is typed that InternalLoader always returns a Loader
                                var InternalLoader = PLoader || Loader;
                                var loader = new InternalLoader(config); // TODO - Do we really need to assign the instance or if the dep has been lost
                                context.loader = loader;
                                this.loaders[context.type] = loader;
                                return loader;
                            };
                            _proto.getInternalLoader = function getInternalLoader(context) {
                                return this.loaders[context.type];
                            };
                            _proto.resetInternalLoader = function resetInternalLoader(contextType) {
                                if (this.loaders[contextType]) delete this.loaders[contextType];
                            };
                            _proto.destroyInternalLoaders = function destroyInternalLoaders() {
                                for(var contextType in this.loaders){
                                    var loader = this.loaders[contextType];
                                    if (loader) loader.destroy();
                                    this.resetInternalLoader(contextType);
                                }
                            };
                            _proto.destroy = function destroy() {
                                this.destroyInternalLoaders();
                                _EventHandler.prototype.destroy.call(this);
                            };
                            _proto.onManifestLoading = function onManifestLoading(data) {
                                this.load({
                                    url: data.url,
                                    type: PlaylistContextType.MANIFEST,
                                    level: 0,
                                    id: null,
                                    responseType: 'text'
                                });
                            };
                            _proto.onLevelLoading = function onLevelLoading(data) {
                                this.load({
                                    url: data.url,
                                    type: PlaylistContextType.LEVEL,
                                    level: data.level,
                                    id: data.id,
                                    responseType: 'text'
                                });
                            };
                            _proto.onAudioTrackLoading = function onAudioTrackLoading(data) {
                                this.load({
                                    url: data.url,
                                    type: PlaylistContextType.AUDIO_TRACK,
                                    level: null,
                                    id: data.id,
                                    responseType: 'text'
                                });
                            };
                            _proto.onSubtitleTrackLoading = function onSubtitleTrackLoading(data) {
                                this.load({
                                    url: data.url,
                                    type: PlaylistContextType.SUBTITLE_TRACK,
                                    level: null,
                                    id: data.id,
                                    responseType: 'text'
                                });
                            };
                            _proto.load = function load(context) {
                                var config = this.hls.config;
                                logger["logger"].debug("Loading playlist of type " + context.type + ", level: " + context.level + ", id: " + context.id); // Check if a loader for this context already exists
                                var loader = this.getInternalLoader(context);
                                if (loader) {
                                    var loaderContext = loader.context;
                                    if (loaderContext && loaderContext.url === context.url) {
                                        // same URL can't overlap
                                        logger["logger"].trace('playlist request ongoing');
                                        return false;
                                    } else {
                                        logger["logger"].warn("aborting previous loader for type: " + context.type);
                                        loader.abort();
                                    }
                                }
                                var maxRetry;
                                var timeout;
                                var retryDelay;
                                var maxRetryDelay; // apply different configs for retries depending on
                                // context (manifest, level, audio/subs playlist)
                                switch(context.type){
                                    case PlaylistContextType.MANIFEST:
                                        maxRetry = config.manifestLoadingMaxRetry;
                                        timeout = config.manifestLoadingTimeOut;
                                        retryDelay = config.manifestLoadingRetryDelay;
                                        maxRetryDelay = config.manifestLoadingMaxRetryTimeout;
                                        break;
                                    case PlaylistContextType.LEVEL:
                                        // Disable internal loader retry logic, since we are managing retries in Level Controller
                                        maxRetry = 0;
                                        maxRetryDelay = 0;
                                        retryDelay = 0;
                                        timeout = config.levelLoadingTimeOut; // TODO Introduce retry settings for audio-track and subtitle-track, it should not use level retry config
                                        break;
                                    default:
                                        maxRetry = config.levelLoadingMaxRetry;
                                        timeout = config.levelLoadingTimeOut;
                                        retryDelay = config.levelLoadingRetryDelay;
                                        maxRetryDelay = config.levelLoadingMaxRetryTimeout;
                                        break;
                                }
                                loader = this.createInternalLoader(context);
                                var loaderConfig = {
                                    timeout: timeout,
                                    maxRetry: maxRetry,
                                    retryDelay: retryDelay,
                                    maxRetryDelay: maxRetryDelay
                                };
                                var loaderCallbacks = {
                                    onSuccess: this.loadsuccess.bind(this),
                                    onError: this.loaderror.bind(this),
                                    onTimeout: this.loadtimeout.bind(this)
                                };
                                logger["logger"].debug("Calling internal loader delegate for URL: " + context.url);
                                loader.load(context, loaderConfig, loaderCallbacks);
                                return true;
                            };
                            _proto.loadsuccess = function loadsuccess(response, stats, context, networkDetails) {
                                if (networkDetails === void 0) networkDetails = null;
                                if (context.isSidxRequest) {
                                    this._handleSidxRequest(response, context);
                                    this._handlePlaylistLoaded(response, stats, context, networkDetails);
                                    return;
                                }
                                this.resetInternalLoader(context.type);
                                if (typeof response.data !== 'string') throw new Error('expected responseType of "text" for PlaylistLoader');
                                var string = response.data;
                                stats.tload = performance1.now(); // stats.mtime = new Date(target.getResponseHeader('Last-Modified'));
                                // Validate if it is an M3U8 at all
                                if (string.indexOf('#EXTM3U') !== 0) {
                                    this._handleManifestParsingError(response, context, 'no EXTM3U delimiter', networkDetails);
                                    return;
                                } // Check if chunk-list or master. handle empty chunk list case (first EXTINF not signaled, but TARGETDURATION present)
                                if (string.indexOf('#EXTINF:') > 0 || string.indexOf('#EXT-X-TARGETDURATION:') > 0) this._handleTrackOrLevelPlaylist(response, stats, context, networkDetails);
                                else this._handleMasterPlaylist(response, stats, context, networkDetails);
                            };
                            _proto.loaderror = function loaderror(response, context, networkDetails) {
                                if (networkDetails === void 0) networkDetails = null;
                                this._handleNetworkError(context, networkDetails, false, response);
                            };
                            _proto.loadtimeout = function loadtimeout(stats, context, networkDetails) {
                                if (networkDetails === void 0) networkDetails = null;
                                this._handleNetworkError(context, networkDetails, true);
                            } // TODO(typescript-config): networkDetails can currently be a XHR or Fetch impl,
                            ;
                            _proto._handleMasterPlaylist = function _handleMasterPlaylist(response, stats, context, networkDetails) {
                                var hls = this.hls;
                                var string = response.data;
                                var url = PlaylistLoader.getResponseUrl(response, context);
                                var levels = m3u8_parser_M3U8Parser.parseMasterPlaylist(string, url);
                                if (!levels.length) {
                                    this._handleManifestParsingError(response, context, 'no level found in manifest', networkDetails);
                                    return;
                                } // multi level playlist, parse level info
                                var audioGroups = levels.map(function(level) {
                                    return {
                                        id: level.attrs.AUDIO,
                                        codec: level.audioCodec
                                    };
                                });
                                var audioTracks = m3u8_parser_M3U8Parser.parseMasterPlaylistMedia(string, url, 'AUDIO', audioGroups);
                                var subtitles = m3u8_parser_M3U8Parser.parseMasterPlaylistMedia(string, url, 'SUBTITLES');
                                if (audioTracks.length) {
                                    // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
                                    var embeddedAudioFound = false;
                                    audioTracks.forEach(function(audioTrack) {
                                        if (!audioTrack.url) embeddedAudioFound = true;
                                    }); // if no embedded audio track defined, but audio codec signaled in quality level,
                                    // we need to signal this main audio track this could happen with playlists with
                                    // alt audio rendition in which quality levels (main)
                                    // contains both audio+video. but with mixed audio track not signaled
                                    if (embeddedAudioFound === false && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
                                        logger["logger"].log('audio codec signaled in quality level, but no embedded audio track signaled, create one');
                                        audioTracks.unshift({
                                            type: 'main',
                                            name: 'main',
                                            default: false,
                                            autoselect: false,
                                            forced: false,
                                            id: -1
                                        });
                                    }
                                }
                                hls.trigger(events["default"].MANIFEST_LOADED, {
                                    levels: levels,
                                    audioTracks: audioTracks,
                                    subtitles: subtitles,
                                    url: url,
                                    stats: stats,
                                    networkDetails: networkDetails
                                });
                            };
                            _proto._handleTrackOrLevelPlaylist = function _handleTrackOrLevelPlaylist(response, stats, context, networkDetails) {
                                var hls = this.hls;
                                var id = context.id, level = context.level, type = context.type;
                                var url = PlaylistLoader.getResponseUrl(response, context); // if the values are null, they will result in the else conditional
                                var levelUrlId = Object(number_isFinite["isFiniteNumber"])(id) ? id : 0;
                                var levelId = Object(number_isFinite["isFiniteNumber"])(level) ? level : levelUrlId;
                                var levelType = PlaylistLoader.mapContextToLevelType(context);
                                var levelDetails = m3u8_parser_M3U8Parser.parseLevelPlaylist(response.data, url, levelId, levelType, levelUrlId); // set stats on level structure
                                // TODO(jstackhouse): why? mixing concerns, is it just treated as value bag?
                                levelDetails.tload = stats.tload; // We have done our first request (Manifest-type) and receive
                                // not a master playlist but a chunk-list (track/level)
                                // We fire the manifest-loaded event anyway with the parsed level-details
                                // by creating a single-level structure for it.
                                if (type === PlaylistContextType.MANIFEST) {
                                    var singleLevel = {
                                        url: url,
                                        details: levelDetails
                                    };
                                    hls.trigger(events["default"].MANIFEST_LOADED, {
                                        levels: [
                                            singleLevel
                                        ],
                                        audioTracks: [],
                                        url: url,
                                        stats: stats,
                                        networkDetails: networkDetails
                                    });
                                } // save parsing time
                                stats.tparsed = performance1.now(); // in case we need SIDX ranges
                                // return early after calling load for
                                // the SIDX box.
                                if (levelDetails.needSidxRanges) {
                                    var sidxUrl = levelDetails.initSegment.url;
                                    this.load({
                                        url: sidxUrl,
                                        isSidxRequest: true,
                                        type: type,
                                        level: level,
                                        levelDetails: levelDetails,
                                        id: id,
                                        rangeStart: 0,
                                        rangeEnd: 2048,
                                        responseType: 'arraybuffer'
                                    });
                                    return;
                                } // extend the context with the new levelDetails property
                                context.levelDetails = levelDetails;
                                this._handlePlaylistLoaded(response, stats, context, networkDetails);
                            };
                            _proto._handleSidxRequest = function _handleSidxRequest(response, context) {
                                if (typeof response.data === 'string') throw new Error('sidx request must be made with responseType of array buffer');
                                var sidxInfo = mp4demuxer["default"].parseSegmentIndex(new Uint8Array(response.data)); // if provided fragment does not contain sidx, early return
                                if (!sidxInfo) return;
                                var sidxReferences = sidxInfo.references;
                                var levelDetails = context.levelDetails;
                                sidxReferences.forEach(function(segmentRef, index) {
                                    var segRefInfo = segmentRef.info;
                                    if (!levelDetails) return;
                                    var frag = levelDetails.fragments[index];
                                    if (frag.byteRange.length === 0) frag.setByteRange(String(1 + segRefInfo.end - segRefInfo.start) + '@' + String(segRefInfo.start));
                                });
                                if (levelDetails) levelDetails.initSegment.setByteRange(String(sidxInfo.moovEndOffset) + '@0');
                            };
                            _proto._handleManifestParsingError = function _handleManifestParsingError(response, context, reason, networkDetails) {
                                this.hls.trigger(events["default"].ERROR, {
                                    type: errors["ErrorTypes"].NETWORK_ERROR,
                                    details: errors["ErrorDetails"].MANIFEST_PARSING_ERROR,
                                    fatal: true,
                                    url: response.url,
                                    reason: reason,
                                    networkDetails: networkDetails
                                });
                            };
                            _proto._handleNetworkError = function _handleNetworkError(context, networkDetails, timeout, response) {
                                if (timeout === void 0) timeout = false;
                                if (response === void 0) response = null;
                                logger["logger"].info("A network error occured while loading a " + context.type + "-type playlist");
                                var details;
                                var fatal;
                                var loader = this.getInternalLoader(context);
                                switch(context.type){
                                    case PlaylistContextType.MANIFEST:
                                        details = timeout ? errors["ErrorDetails"].MANIFEST_LOAD_TIMEOUT : errors["ErrorDetails"].MANIFEST_LOAD_ERROR;
                                        fatal = true;
                                        break;
                                    case PlaylistContextType.LEVEL:
                                        details = timeout ? errors["ErrorDetails"].LEVEL_LOAD_TIMEOUT : errors["ErrorDetails"].LEVEL_LOAD_ERROR;
                                        fatal = false;
                                        break;
                                    case PlaylistContextType.AUDIO_TRACK:
                                        details = timeout ? errors["ErrorDetails"].AUDIO_TRACK_LOAD_TIMEOUT : errors["ErrorDetails"].AUDIO_TRACK_LOAD_ERROR;
                                        fatal = false;
                                        break;
                                    default:
                                        // details = ...?
                                        fatal = false;
                                }
                                if (loader) {
                                    loader.abort();
                                    this.resetInternalLoader(context.type);
                                } // TODO(typescript-events): when error events are handled, type this
                                var errorData = {
                                    type: errors["ErrorTypes"].NETWORK_ERROR,
                                    details: details,
                                    fatal: fatal,
                                    url: context.url,
                                    loader: loader,
                                    context: context,
                                    networkDetails: networkDetails
                                };
                                if (response) errorData.response = response;
                                this.hls.trigger(events["default"].ERROR, errorData);
                            };
                            _proto._handlePlaylistLoaded = function _handlePlaylistLoaded(response, stats, context, networkDetails) {
                                var type = context.type, level = context.level, id = context.id, levelDetails = context.levelDetails;
                                if (!levelDetails || !levelDetails.targetduration) {
                                    this._handleManifestParsingError(response, context, 'invalid target duration', networkDetails);
                                    return;
                                }
                                var canHaveLevels = PlaylistLoader.canHaveQualityLevels(context.type);
                                if (canHaveLevels) this.hls.trigger(events["default"].LEVEL_LOADED, {
                                    details: levelDetails,
                                    level: level || 0,
                                    id: id || 0,
                                    stats: stats,
                                    networkDetails: networkDetails
                                });
                                else switch(type){
                                    case PlaylistContextType.AUDIO_TRACK:
                                        this.hls.trigger(events["default"].AUDIO_TRACK_LOADED, {
                                            details: levelDetails,
                                            id: id,
                                            stats: stats,
                                            networkDetails: networkDetails
                                        });
                                        break;
                                    case PlaylistContextType.SUBTITLE_TRACK:
                                        this.hls.trigger(events["default"].SUBTITLE_TRACK_LOADED, {
                                            details: levelDetails,
                                            id: id,
                                            stats: stats,
                                            networkDetails: networkDetails
                                        });
                                        break;
                                }
                            };
                            return PlaylistLoader;
                        }(event_handler);
                        /* harmony default export */ var playlist_loader = playlist_loader_PlaylistLoader;
                        // CONCATENATED MODULE: ./src/loader/fragment-loader.js
                        function fragment_loader_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /*
 * Fragment Loader
*/ var fragment_loader_FragmentLoader = /*#__PURE__*/ function(_EventHandler) {
                            fragment_loader_inheritsLoose(FragmentLoader, _EventHandler);
                            function FragmentLoader(hls) {
                                var _this;
                                _this = _EventHandler.call(this, hls, events["default"].FRAG_LOADING) || this;
                                _this.loaders = {};
                                return _this;
                            }
                            var _proto = FragmentLoader.prototype;
                            _proto.destroy = function destroy() {
                                var loaders = this.loaders;
                                for(var loaderName in loaders){
                                    var loader = loaders[loaderName];
                                    if (loader) loader.destroy();
                                }
                                this.loaders = {};
                                _EventHandler.prototype.destroy.call(this);
                            };
                            _proto.onFragLoading = function onFragLoading(data) {
                                var frag = data.frag, type = frag.type, loaders = this.loaders, config = this.hls.config, FragmentILoader = config.fLoader, DefaultILoader = config.loader; // reset fragment state
                                frag.loaded = 0;
                                var loader = loaders[type];
                                if (loader) {
                                    logger["logger"].warn("abort previous fragment loader for type: " + type);
                                    loader.abort();
                                }
                                loader = loaders[type] = frag.loader = config.fLoader ? new FragmentILoader(config) : new DefaultILoader(config);
                                var loaderContext, loaderConfig, loaderCallbacks;
                                loaderContext = {
                                    url: frag.url,
                                    frag: frag,
                                    responseType: 'arraybuffer',
                                    progressData: false
                                };
                                var start = frag.byteRangeStartOffset, end = frag.byteRangeEndOffset;
                                if (Object(number_isFinite["isFiniteNumber"])(start) && Object(number_isFinite["isFiniteNumber"])(end)) {
                                    loaderContext.rangeStart = start;
                                    loaderContext.rangeEnd = end;
                                }
                                loaderConfig = {
                                    timeout: config.fragLoadingTimeOut,
                                    maxRetry: 0,
                                    retryDelay: 0,
                                    maxRetryDelay: config.fragLoadingMaxRetryTimeout
                                };
                                loaderCallbacks = {
                                    onSuccess: this.loadsuccess.bind(this),
                                    onError: this.loaderror.bind(this),
                                    onTimeout: this.loadtimeout.bind(this),
                                    onProgress: this.loadprogress.bind(this)
                                };
                                loader.load(loaderContext, loaderConfig, loaderCallbacks);
                            };
                            _proto.loadsuccess = function loadsuccess(response, stats, context, networkDetails) {
                                if (networkDetails === void 0) networkDetails = null;
                                var payload = response.data, frag = context.frag; // detach fragment loader on load success
                                frag.loader = undefined;
                                this.loaders[frag.type] = undefined;
                                this.hls.trigger(events["default"].FRAG_LOADED, {
                                    payload: payload,
                                    frag: frag,
                                    stats: stats,
                                    networkDetails: networkDetails
                                });
                            };
                            _proto.loaderror = function loaderror(response, context, networkDetails) {
                                if (networkDetails === void 0) networkDetails = null;
                                var frag = context.frag;
                                var loader = frag.loader;
                                if (loader) loader.abort();
                                this.loaders[frag.type] = undefined;
                                this.hls.trigger(events["default"].ERROR, {
                                    type: errors["ErrorTypes"].NETWORK_ERROR,
                                    details: errors["ErrorDetails"].FRAG_LOAD_ERROR,
                                    fatal: false,
                                    frag: context.frag,
                                    response: response,
                                    networkDetails: networkDetails
                                });
                            };
                            _proto.loadtimeout = function loadtimeout(stats, context, networkDetails) {
                                if (networkDetails === void 0) networkDetails = null;
                                var frag = context.frag;
                                var loader = frag.loader;
                                if (loader) loader.abort();
                                this.loaders[frag.type] = undefined;
                                this.hls.trigger(events["default"].ERROR, {
                                    type: errors["ErrorTypes"].NETWORK_ERROR,
                                    details: errors["ErrorDetails"].FRAG_LOAD_TIMEOUT,
                                    fatal: false,
                                    frag: context.frag,
                                    networkDetails: networkDetails
                                });
                            } // data will be used for progressive parsing
                            ;
                            _proto.loadprogress = function loadprogress(stats, context, data, networkDetails) {
                                if (networkDetails === void 0) networkDetails = null;
                                // jshint ignore:line
                                var frag = context.frag;
                                frag.loaded = stats.loaded;
                                this.hls.trigger(events["default"].FRAG_LOAD_PROGRESS, {
                                    frag: frag,
                                    stats: stats,
                                    networkDetails: networkDetails
                                });
                            };
                            return FragmentLoader;
                        }(event_handler);
                        /* harmony default export */ var fragment_loader = fragment_loader_FragmentLoader;
                        // CONCATENATED MODULE: ./src/loader/key-loader.ts
                        function key_loader_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /*
 * Decrypt key Loader
*/ var key_loader_KeyLoader = /*#__PURE__*/ function(_EventHandler) {
                            key_loader_inheritsLoose(KeyLoader, _EventHandler);
                            function KeyLoader(hls) {
                                var _this;
                                _this = _EventHandler.call(this, hls, events["default"].KEY_LOADING) || this;
                                _this.loaders = {};
                                _this.decryptkey = null;
                                _this.decrypturl = null;
                                return _this;
                            }
                            var _proto = KeyLoader.prototype;
                            _proto.destroy = function destroy() {
                                for(var loaderName in this.loaders){
                                    var loader = this.loaders[loaderName];
                                    if (loader) loader.destroy();
                                }
                                this.loaders = {};
                                _EventHandler.prototype.destroy.call(this);
                            };
                            _proto.onKeyLoading = function onKeyLoading(data) {
                                var frag = data.frag;
                                var type = frag.type;
                                var loader = this.loaders[type];
                                if (!frag.decryptdata) {
                                    logger["logger"].warn('Missing decryption data on fragment in onKeyLoading');
                                    return;
                                } // Load the key if the uri is different from previous one, or if the decrypt key has not yet been retrieved
                                var uri = frag.decryptdata.uri;
                                if (uri !== this.decrypturl || this.decryptkey === null) {
                                    var config = this.hls.config;
                                    if (loader) {
                                        logger["logger"].warn("abort previous key loader for type:" + type);
                                        loader.abort();
                                    }
                                    if (!uri) {
                                        logger["logger"].warn('key uri is falsy');
                                        return;
                                    }
                                    frag.loader = this.loaders[type] = new config.loader(config);
                                    this.decrypturl = uri;
                                    this.decryptkey = null;
                                    var loaderContext = {
                                        url: uri,
                                        frag: frag,
                                        responseType: 'arraybuffer'
                                    }; // maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
                                    // key-loader will trigger an error and rely on stream-controller to handle retry logic.
                                    // this will also align retry logic with fragment-loader
                                    var loaderConfig = {
                                        timeout: config.fragLoadingTimeOut,
                                        maxRetry: 0,
                                        retryDelay: config.fragLoadingRetryDelay,
                                        maxRetryDelay: config.fragLoadingMaxRetryTimeout
                                    };
                                    var loaderCallbacks = {
                                        onSuccess: this.loadsuccess.bind(this),
                                        onError: this.loaderror.bind(this),
                                        onTimeout: this.loadtimeout.bind(this)
                                    };
                                    frag.loader.load(loaderContext, loaderConfig, loaderCallbacks);
                                } else if (this.decryptkey) {
                                    // Return the key if it's already been loaded
                                    frag.decryptdata.key = this.decryptkey;
                                    this.hls.trigger(events["default"].KEY_LOADED, {
                                        frag: frag
                                    });
                                }
                            };
                            _proto.loadsuccess = function loadsuccess(response, stats, context) {
                                var frag = context.frag;
                                if (!frag.decryptdata) {
                                    logger["logger"].error('after key load, decryptdata unset');
                                    return;
                                }
                                this.decryptkey = frag.decryptdata.key = new Uint8Array(response.data); // detach fragment loader on load success
                                frag.loader = undefined;
                                delete this.loaders[frag.type];
                                this.hls.trigger(events["default"].KEY_LOADED, {
                                    frag: frag
                                });
                            };
                            _proto.loaderror = function loaderror(response, context) {
                                var frag = context.frag;
                                var loader = frag.loader;
                                if (loader) loader.abort();
                                delete this.loaders[frag.type];
                                this.hls.trigger(events["default"].ERROR, {
                                    type: errors["ErrorTypes"].NETWORK_ERROR,
                                    details: errors["ErrorDetails"].KEY_LOAD_ERROR,
                                    fatal: false,
                                    frag: frag,
                                    response: response
                                });
                            };
                            _proto.loadtimeout = function loadtimeout(stats, context) {
                                var frag = context.frag;
                                var loader = frag.loader;
                                if (loader) loader.abort();
                                delete this.loaders[frag.type];
                                this.hls.trigger(events["default"].ERROR, {
                                    type: errors["ErrorTypes"].NETWORK_ERROR,
                                    details: errors["ErrorDetails"].KEY_LOAD_TIMEOUT,
                                    fatal: false,
                                    frag: frag
                                });
                            };
                            return KeyLoader;
                        }(event_handler);
                        /* harmony default export */ var key_loader = key_loader_KeyLoader;
                        // CONCATENATED MODULE: ./src/controller/fragment-tracker.js
                        function fragment_tracker_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        var FragmentState = {
                            NOT_LOADED: 'NOT_LOADED',
                            APPENDING: 'APPENDING',
                            PARTIAL: 'PARTIAL',
                            OK: 'OK'
                        };
                        var fragment_tracker_FragmentTracker = /*#__PURE__*/ function(_EventHandler) {
                            fragment_tracker_inheritsLoose(FragmentTracker, _EventHandler);
                            function FragmentTracker(hls) {
                                var _this;
                                _this = _EventHandler.call(this, hls, events["default"].BUFFER_APPENDED, events["default"].FRAG_BUFFERED, events["default"].FRAG_LOADED) || this;
                                _this.bufferPadding = 0.2;
                                _this.fragments = Object.create(null);
                                _this.timeRanges = Object.create(null);
                                _this.config = hls.config;
                                return _this;
                            }
                            var _proto = FragmentTracker.prototype;
                            _proto.destroy = function destroy() {
                                this.fragments = Object.create(null);
                                this.timeRanges = Object.create(null);
                                this.config = null;
                                event_handler.prototype.destroy.call(this);
                                _EventHandler.prototype.destroy.call(this);
                            };
                            _proto.getBufferedFrag = function getBufferedFrag(position, levelType) {
                                var fragments = this.fragments;
                                var bufferedFrags = Object.keys(fragments).filter(function(key) {
                                    var fragmentEntity = fragments[key];
                                    if (fragmentEntity.body.type !== levelType) return false;
                                    if (!fragmentEntity.buffered) return false;
                                    var frag = fragmentEntity.body;
                                    return frag.startPTS <= position && position <= frag.endPTS;
                                });
                                if (bufferedFrags.length === 0) return null;
                                else {
                                    // https://github.com/video-dev/hls.js/pull/1545#discussion_r166229566
                                    var bufferedFragKey = bufferedFrags.pop();
                                    return fragments[bufferedFragKey].body;
                                }
                            };
                            _proto.detectEvictedFragments = function detectEvictedFragments(elementaryStream, timeRange) {
                                var _this2 = this;
                                var fragmentTimes, time; // Check if any flagged fragments have been unloaded
                                Object.keys(this.fragments).forEach(function(key) {
                                    var fragmentEntity = _this2.fragments[key];
                                    if (fragmentEntity.buffered === true) {
                                        var esData = fragmentEntity.range[elementaryStream];
                                        if (esData) {
                                            fragmentTimes = esData.time;
                                            for(var i = 0; i < fragmentTimes.length; i++){
                                                time = fragmentTimes[i];
                                                if (_this2.isTimeBuffered(time.startPTS, time.endPTS, timeRange) === false) {
                                                    // Unregister partial fragment as it needs to load again to be reused
                                                    _this2.removeFragment(fragmentEntity.body);
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                });
                            };
                            _proto.detectPartialFragments = function detectPartialFragments(fragment) {
                                var _this3 = this;
                                var fragKey = this.getFragmentKey(fragment);
                                var fragmentEntity = this.fragments[fragKey];
                                if (fragmentEntity) {
                                    fragmentEntity.buffered = true;
                                    Object.keys(this.timeRanges).forEach(function(elementaryStream) {
                                        if (fragment.hasElementaryStream(elementaryStream)) {
                                            var timeRange = _this3.timeRanges[elementaryStream]; // Check for malformed fragments
                                            // Gaps need to be calculated for each elementaryStream
                                            fragmentEntity.range[elementaryStream] = _this3.getBufferedTimes(fragment.startPTS, fragment.endPTS, timeRange);
                                        }
                                    });
                                }
                            };
                            _proto.getBufferedTimes = function getBufferedTimes(startPTS, endPTS, timeRange) {
                                var fragmentTimes = [];
                                var startTime, endTime;
                                var fragmentPartial = false;
                                for(var i = 0; i < timeRange.length; i++){
                                    startTime = timeRange.start(i) - this.bufferPadding;
                                    endTime = timeRange.end(i) + this.bufferPadding;
                                    if (startPTS >= startTime && endPTS <= endTime) {
                                        // Fragment is entirely contained in buffer
                                        // No need to check the other timeRange times since it's completely playable
                                        fragmentTimes.push({
                                            startPTS: Math.max(startPTS, timeRange.start(i)),
                                            endPTS: Math.min(endPTS, timeRange.end(i))
                                        });
                                        break;
                                    } else if (startPTS < endTime && endPTS > startTime) {
                                        // Check for intersection with buffer
                                        // Get playable sections of the fragment
                                        fragmentTimes.push({
                                            startPTS: Math.max(startPTS, timeRange.start(i)),
                                            endPTS: Math.min(endPTS, timeRange.end(i))
                                        });
                                        fragmentPartial = true;
                                    } else if (endPTS <= startTime) break;
                                }
                                return {
                                    time: fragmentTimes,
                                    partial: fragmentPartial
                                };
                            };
                            _proto.getFragmentKey = function getFragmentKey(fragment) {
                                return fragment.type + "_" + fragment.level + "_" + fragment.urlId + "_" + fragment.sn;
                            };
                            _proto.getPartialFragment = function getPartialFragment(time) {
                                var _this4 = this;
                                var timePadding, startTime, endTime;
                                var bestFragment = null;
                                var bestOverlap = 0;
                                Object.keys(this.fragments).forEach(function(key) {
                                    var fragmentEntity = _this4.fragments[key];
                                    if (_this4.isPartial(fragmentEntity)) {
                                        startTime = fragmentEntity.body.startPTS - _this4.bufferPadding;
                                        endTime = fragmentEntity.body.endPTS + _this4.bufferPadding;
                                        if (time >= startTime && time <= endTime) {
                                            // Use the fragment that has the most padding from start and end time
                                            timePadding = Math.min(time - startTime, endTime - time);
                                            if (bestOverlap <= timePadding) {
                                                bestFragment = fragmentEntity.body;
                                                bestOverlap = timePadding;
                                            }
                                        }
                                    }
                                });
                                return bestFragment;
                            };
                            _proto.getState = function getState(fragment) {
                                var fragKey = this.getFragmentKey(fragment);
                                var fragmentEntity = this.fragments[fragKey];
                                var state = FragmentState.NOT_LOADED;
                                if (fragmentEntity !== undefined) {
                                    if (!fragmentEntity.buffered) state = FragmentState.APPENDING;
                                    else if (this.isPartial(fragmentEntity) === true) state = FragmentState.PARTIAL;
                                    else state = FragmentState.OK;
                                }
                                return state;
                            };
                            _proto.isPartial = function isPartial(fragmentEntity) {
                                return fragmentEntity.buffered === true && (fragmentEntity.range.video !== undefined && fragmentEntity.range.video.partial === true || fragmentEntity.range.audio !== undefined && fragmentEntity.range.audio.partial === true);
                            };
                            _proto.isTimeBuffered = function isTimeBuffered(startPTS, endPTS, timeRange) {
                                var startTime, endTime;
                                for(var i = 0; i < timeRange.length; i++){
                                    startTime = timeRange.start(i) - this.bufferPadding;
                                    endTime = timeRange.end(i) + this.bufferPadding;
                                    if (startPTS >= startTime && endPTS <= endTime) return true;
                                    if (endPTS <= startTime) // No need to check the rest of the timeRange as it is in order
                                    return false;
                                }
                                return false;
                            };
                            _proto.onFragLoaded = function onFragLoaded(e) {
                                var fragment = e.frag; // don't track initsegment (for which sn is not a number)
                                // don't track frags used for bitrateTest, they're irrelevant.
                                if (!Object(number_isFinite["isFiniteNumber"])(fragment.sn) || fragment.bitrateTest) return;
                                this.fragments[this.getFragmentKey(fragment)] = {
                                    body: fragment,
                                    range: Object.create(null),
                                    buffered: false
                                };
                            };
                            _proto.onBufferAppended = function onBufferAppended(e) {
                                var _this5 = this;
                                // Store the latest timeRanges loaded in the buffer
                                this.timeRanges = e.timeRanges;
                                Object.keys(this.timeRanges).forEach(function(elementaryStream) {
                                    var timeRange = _this5.timeRanges[elementaryStream];
                                    _this5.detectEvictedFragments(elementaryStream, timeRange);
                                });
                            };
                            _proto.onFragBuffered = function onFragBuffered(e) {
                                this.detectPartialFragments(e.frag);
                            };
                            _proto.hasFragment = function hasFragment(fragment) {
                                var fragKey = this.getFragmentKey(fragment);
                                return this.fragments[fragKey] !== undefined;
                            };
                            _proto.removeFragment = function removeFragment(fragment) {
                                var fragKey = this.getFragmentKey(fragment);
                                delete this.fragments[fragKey];
                            };
                            _proto.removeAllFragments = function removeAllFragments() {
                                this.fragments = Object.create(null);
                            };
                            return FragmentTracker;
                        }(event_handler);
                        // CONCATENATED MODULE: ./src/utils/binary-search.ts
                        var BinarySearch = {
                            /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param {Array<T>} list The array to search.
   * @param {BinarySearchComparison<T>} comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @return {T | null} The object if it is found or null otherwise.
   */ search: function search(list, comparisonFn) {
                                var minIndex = 0;
                                var maxIndex = list.length - 1;
                                var currentIndex = null;
                                var currentElement = null;
                                while(minIndex <= maxIndex){
                                    currentIndex = (minIndex + maxIndex) / 2 | 0;
                                    currentElement = list[currentIndex];
                                    var comparisonResult = comparisonFn(currentElement);
                                    if (comparisonResult > 0) minIndex = currentIndex + 1;
                                    else if (comparisonResult < 0) maxIndex = currentIndex - 1;
                                    else return currentElement;
                                }
                                return null;
                            }
                        };
                        /* harmony default export */ var binary_search = BinarySearch;
                        // CONCATENATED MODULE: ./src/utils/buffer-helper.ts
                        /**
 * @module BufferHelper
 *
 * Providing methods dealing with buffer length retrieval for example.
 *
 * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
 *
 * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
*/ var BufferHelper = /*#__PURE__*/ function() {
                            function BufferHelper() {}
                            /**
   * Return true if `media`'s buffered include `position`
   * @param {Bufferable} media
   * @param {number} position
   * @returns {boolean}
   */ BufferHelper.isBuffered = function isBuffered(media, position) {
                                try {
                                    if (media) {
                                        var buffered = media.buffered;
                                        for(var i = 0; i < buffered.length; i++){
                                            if (position >= buffered.start(i) && position <= buffered.end(i)) return true;
                                        }
                                    }
                                } catch (error) {
                                // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
                                // This SourceBuffer has been removed from the parent media source
                                }
                                return false;
                            };
                            BufferHelper.bufferInfo = function bufferInfo(media, pos, maxHoleDuration) {
                                try {
                                    if (media) {
                                        var vbuffered = media.buffered;
                                        var buffered = [];
                                        var i;
                                        for(i = 0; i < vbuffered.length; i++)buffered.push({
                                            start: vbuffered.start(i),
                                            end: vbuffered.end(i)
                                        });
                                        return this.bufferedInfo(buffered, pos, maxHoleDuration);
                                    }
                                } catch (error) {
                                // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
                                // This SourceBuffer has been removed from the parent media source
                                }
                                return {
                                    len: 0,
                                    start: pos,
                                    end: pos,
                                    nextStart: undefined
                                };
                            };
                            BufferHelper.bufferedInfo = function bufferedInfo(buffered, pos, maxHoleDuration) {
                                // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
                                buffered.sort(function(a, b) {
                                    var diff = a.start - b.start;
                                    if (diff) return diff;
                                    else return b.end - a.end;
                                });
                                var buffered2 = [];
                                if (maxHoleDuration) // there might be some small holes between buffer time range
                                // consider that holes smaller than maxHoleDuration are irrelevant and build another
                                // buffer time range representations that discards those holes
                                for(var i = 0; i < buffered.length; i++){
                                    var buf2len = buffered2.length;
                                    if (buf2len) {
                                        var buf2end = buffered2[buf2len - 1].end; // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
                                        if (buffered[i].start - buf2end < maxHoleDuration) // merge overlapping time ranges
                                        // update lastRange.end only if smaller than item.end
                                        // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
                                        // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
                                        {
                                            if (buffered[i].end > buf2end) buffered2[buf2len - 1].end = buffered[i].end;
                                        } else // big hole
                                        buffered2.push(buffered[i]);
                                    } else // first value
                                    buffered2.push(buffered[i]);
                                }
                                else buffered2 = buffered;
                                var bufferLen = 0; // bufferStartNext can possibly be undefined based on the conditional logic below
                                var bufferStartNext; // bufferStart and bufferEnd are buffer boundaries around current video position
                                var bufferStart = pos;
                                var bufferEnd = pos;
                                for(var _i = 0; _i < buffered2.length; _i++){
                                    var start = buffered2[_i].start, end = buffered2[_i].end; // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
                                    if (pos + maxHoleDuration >= start && pos < end) {
                                        // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
                                        bufferStart = start;
                                        bufferEnd = end;
                                        bufferLen = bufferEnd - pos;
                                    } else if (pos + maxHoleDuration < start) {
                                        bufferStartNext = start;
                                        break;
                                    }
                                }
                                return {
                                    len: bufferLen,
                                    start: bufferStart,
                                    end: bufferEnd,
                                    nextStart: bufferStartNext
                                };
                            };
                            return BufferHelper;
                        }();
                        // EXTERNAL MODULE: ./node_modules/eventemitter3/index.js
                        var eventemitter3 = __webpack_require__("./node_modules/eventemitter3/index.js");
                        // EXTERNAL MODULE: ./node_modules/webworkify-webpack/index.js
                        var webworkify_webpack = __webpack_require__("./node_modules/webworkify-webpack/index.js");
                        // EXTERNAL MODULE: ./src/demux/demuxer-inline.js + 12 modules
                        var demuxer_inline = __webpack_require__("./src/demux/demuxer-inline.js");
                        // CONCATENATED MODULE: ./src/utils/mediasource-helper.ts
                        /**
 * MediaSource helper
 */ function getMediaSource() {
                            return window.MediaSource || window.WebKitMediaSource;
                        }
                        // EXTERNAL MODULE: ./src/utils/get-self-scope.js
                        var get_self_scope = __webpack_require__("./src/utils/get-self-scope.js");
                        // CONCATENATED MODULE: ./src/observer.ts
                        function observer_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /**
 * Simple adapter sub-class of Nodejs-like EventEmitter.
 */ var Observer = /*#__PURE__*/ function(_EventEmitter) {
                            observer_inheritsLoose(Observer, _EventEmitter);
                            function Observer() {
                                return _EventEmitter.apply(this, arguments) || this;
                            }
                            var _proto = Observer.prototype;
                            /**
   * We simply want to pass along the event-name itself
   * in every call to a handler, which is the purpose of our `trigger` method
   * extending the standard API.
   */ _proto.trigger = function trigger(event) {
                                for(var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)data[_key - 1] = arguments[_key];
                                this.emit.apply(this, [
                                    event,
                                    event
                                ].concat(data));
                            };
                            return Observer;
                        }(eventemitter3["EventEmitter"]);
                        // CONCATENATED MODULE: ./src/demux/demuxer.js
                        // see https://stackoverflow.com/a/11237259/589493
                        var global = Object(get_self_scope["getSelfScope"])(); // safeguard for code that might run both on worker and main thread
                        var demuxer_MediaSource = getMediaSource() || {
                            isTypeSupported: function isTypeSupported() {
                                return false;
                            }
                        };
                        var demuxer_Demuxer = /*#__PURE__*/ function() {
                            function Demuxer(hls, id) {
                                var _this = this;
                                this.hls = hls;
                                this.id = id;
                                var observer = this.observer = new Observer();
                                var config = hls.config;
                                var forwardMessage = function forwardMessage(ev, data) {
                                    data = data || {};
                                    data.frag = _this.frag;
                                    data.id = _this.id;
                                    hls.trigger(ev, data);
                                }; // forward events to main thread
                                observer.on(events["default"].FRAG_DECRYPTED, forwardMessage);
                                observer.on(events["default"].FRAG_PARSING_INIT_SEGMENT, forwardMessage);
                                observer.on(events["default"].FRAG_PARSING_DATA, forwardMessage);
                                observer.on(events["default"].FRAG_PARSED, forwardMessage);
                                observer.on(events["default"].ERROR, forwardMessage);
                                observer.on(events["default"].FRAG_PARSING_METADATA, forwardMessage);
                                observer.on(events["default"].FRAG_PARSING_USERDATA, forwardMessage);
                                observer.on(events["default"].INIT_PTS_FOUND, forwardMessage);
                                var typeSupported = {
                                    mp4: demuxer_MediaSource.isTypeSupported('video/mp4'),
                                    mpeg: demuxer_MediaSource.isTypeSupported('audio/mpeg'),
                                    mp3: demuxer_MediaSource.isTypeSupported('audio/mp4; codecs="mp3"')
                                }; // navigator.vendor is not always available in Web Worker
                                // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
                                var vendor = navigator.vendor;
                                if (config.enableWorker && typeof Worker !== 'undefined') {
                                    logger["logger"].log('demuxing in webworker');
                                    var w;
                                    try {
                                        w = this.w = webworkify_webpack(/*require.resolve*/ /*! ../demux/demuxer-worker.js */ "./src/demux/demuxer-worker.js");
                                        this.onwmsg = this.onWorkerMessage.bind(this);
                                        w.addEventListener('message', this.onwmsg);
                                        w.onerror = function(event) {
                                            hls.trigger(events["default"].ERROR, {
                                                type: errors["ErrorTypes"].OTHER_ERROR,
                                                details: errors["ErrorDetails"].INTERNAL_EXCEPTION,
                                                fatal: true,
                                                event: 'demuxerWorker',
                                                err: {
                                                    message: event.message + ' (' + event.filename + ':' + event.lineno + ')'
                                                }
                                            });
                                        };
                                        w.postMessage({
                                            cmd: 'init',
                                            typeSupported: typeSupported,
                                            vendor: vendor,
                                            id: id,
                                            config: JSON.stringify(config)
                                        });
                                    } catch (err) {
                                        logger["logger"].warn('Error in worker:', err);
                                        logger["logger"].error('Error while initializing DemuxerWorker, fallback on DemuxerInline');
                                        if (w) // revoke the Object URL that was used to create demuxer worker, so as not to leak it
                                        global.URL.revokeObjectURL(w.objectURL);
                                        this.demuxer = new demuxer_inline["default"](observer, typeSupported, config, vendor);
                                        this.w = undefined;
                                    }
                                } else this.demuxer = new demuxer_inline["default"](observer, typeSupported, config, vendor);
                            }
                            var _proto = Demuxer.prototype;
                            _proto.destroy = function destroy() {
                                var w = this.w;
                                if (w) {
                                    w.removeEventListener('message', this.onwmsg);
                                    w.terminate();
                                    this.w = null;
                                } else {
                                    var demuxer = this.demuxer;
                                    if (demuxer) {
                                        demuxer.destroy();
                                        this.demuxer = null;
                                    }
                                }
                                var observer = this.observer;
                                if (observer) {
                                    observer.removeAllListeners();
                                    this.observer = null;
                                }
                            };
                            _proto.push = function push(data, initSegment, audioCodec, videoCodec, frag, duration, accurateTimeOffset, defaultInitPTS) {
                                var w = this.w;
                                var timeOffset = Object(number_isFinite["isFiniteNumber"])(frag.startPTS) ? frag.startPTS : frag.start;
                                var decryptdata = frag.decryptdata;
                                var lastFrag = this.frag;
                                var discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
                                var trackSwitch = !(lastFrag && frag.level === lastFrag.level);
                                var nextSN = lastFrag && frag.sn === lastFrag.sn + 1;
                                var contiguous = !trackSwitch && nextSN;
                                if (discontinuity) logger["logger"].log(this.id + ":discontinuity detected");
                                if (trackSwitch) logger["logger"].log(this.id + ":switch detected");
                                this.frag = frag;
                                if (w) // post fragment payload as transferable objects for ArrayBuffer (no copy)
                                w.postMessage({
                                    cmd: 'demux',
                                    data: data,
                                    decryptdata: decryptdata,
                                    initSegment: initSegment,
                                    audioCodec: audioCodec,
                                    videoCodec: videoCodec,
                                    timeOffset: timeOffset,
                                    discontinuity: discontinuity,
                                    trackSwitch: trackSwitch,
                                    contiguous: contiguous,
                                    duration: duration,
                                    accurateTimeOffset: accurateTimeOffset,
                                    defaultInitPTS: defaultInitPTS
                                }, data instanceof ArrayBuffer ? [
                                    data
                                ] : []);
                                else {
                                    var demuxer = this.demuxer;
                                    if (demuxer) demuxer.push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
                                }
                            };
                            _proto.onWorkerMessage = function onWorkerMessage(ev) {
                                var data = ev.data, hls = this.hls;
                                switch(data.event){
                                    case 'init':
                                        // revoke the Object URL that was used to create demuxer worker, so as not to leak it
                                        global.URL.revokeObjectURL(this.w.objectURL);
                                        break;
                                    // special case for FRAG_PARSING_DATA: data1 and data2 are transferable objects
                                    case events["default"].FRAG_PARSING_DATA:
                                        data.data.data1 = new Uint8Array(data.data1);
                                        if (data.data2) data.data.data2 = new Uint8Array(data.data2);
                                    /* falls through */ default:
                                        data.data = data.data || {};
                                        data.data.frag = this.frag;
                                        data.data.id = this.id;
                                        hls.trigger(data.event, data.data);
                                        break;
                                }
                            };
                            return Demuxer;
                        }();
                        /* harmony default export */ var demux_demuxer = demuxer_Demuxer;
                        // CONCATENATED MODULE: ./src/controller/level-helper.js
                        /**
 * @module LevelHelper
 *
 * Providing methods dealing with playlist sliding and drift
 *
 * TODO: Create an actual `Level` class/model that deals with all this logic in an object-oriented-manner.
 *
 * */ function addGroupId(level, type, id) {
                            switch(type){
                                case 'audio':
                                    if (!level.audioGroupIds) level.audioGroupIds = [];
                                    level.audioGroupIds.push(id);
                                    break;
                                case 'text':
                                    if (!level.textGroupIds) level.textGroupIds = [];
                                    level.textGroupIds.push(id);
                                    break;
                            }
                        }
                        function updatePTS(fragments, fromIdx, toIdx) {
                            var fragFrom = fragments[fromIdx], fragTo = fragments[toIdx], fragToPTS = fragTo.startPTS; // if we know startPTS[toIdx]
                            if (Object(number_isFinite["isFiniteNumber"])(fragToPTS)) {
                                // update fragment duration.
                                // it helps to fix drifts between playlist reported duration and fragment real duration
                                if (toIdx > fromIdx) {
                                    fragFrom.duration = fragToPTS - fragFrom.start;
                                    if (fragFrom.duration < 0) logger["logger"].warn("negative duration computed for frag " + fragFrom.sn + ",level " + fragFrom.level + ", there should be some duration drift between playlist and fragment!");
                                } else {
                                    fragTo.duration = fragFrom.start - fragToPTS;
                                    if (fragTo.duration < 0) logger["logger"].warn("negative duration computed for frag " + fragTo.sn + ",level " + fragTo.level + ", there should be some duration drift between playlist and fragment!");
                                }
                            } else // we dont know startPTS[toIdx]
                            if (toIdx > fromIdx) fragTo.start = fragFrom.start + fragFrom.duration;
                            else fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
                        }
                        function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
                            // update frag PTS/DTS
                            var maxStartPTS = startPTS;
                            if (Object(number_isFinite["isFiniteNumber"])(frag.startPTS)) {
                                // delta PTS between audio and video
                                var deltaPTS = Math.abs(frag.startPTS - startPTS);
                                if (!Object(number_isFinite["isFiniteNumber"])(frag.deltaPTS)) frag.deltaPTS = deltaPTS;
                                else frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
                                maxStartPTS = Math.max(startPTS, frag.startPTS);
                                startPTS = Math.min(startPTS, frag.startPTS);
                                endPTS = Math.max(endPTS, frag.endPTS);
                                startDTS = Math.min(startDTS, frag.startDTS);
                                endDTS = Math.max(endDTS, frag.endDTS);
                            }
                            var drift = startPTS - frag.start;
                            frag.start = frag.startPTS = startPTS;
                            frag.maxStartPTS = maxStartPTS;
                            frag.endPTS = endPTS;
                            frag.startDTS = startDTS;
                            frag.endDTS = endDTS;
                            frag.duration = endPTS - startPTS;
                            var sn = frag.sn; // exit if sn out of range
                            if (!details || sn < details.startSN || sn > details.endSN) return 0;
                            var fragIdx, fragments, i;
                            fragIdx = sn - details.startSN;
                            fragments = details.fragments; // update frag reference in fragments array
                            // rationale is that fragments array might not contain this frag object.
                            // this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
                            // if we don't update frag, we won't be able to propagate PTS info on the playlist
                            // resulting in invalid sliding computation
                            fragments[fragIdx] = frag; // adjust fragment PTS/duration from seqnum-1 to frag 0
                            for(i = fragIdx; i > 0; i--)updatePTS(fragments, i, i - 1);
                             // adjust fragment PTS/duration from seqnum to last frag
                            for(i = fragIdx; i < fragments.length - 1; i++)updatePTS(fragments, i, i + 1);
                            details.PTSKnown = true;
                            return drift;
                        }
                        function mergeDetails(oldDetails, newDetails) {
                            // potentially retrieve cached initsegment
                            if (newDetails.initSegment && oldDetails.initSegment) newDetails.initSegment = oldDetails.initSegment;
                             // check if old/new playlists have fragments in common
                            // loop through overlapping SN and update startPTS , cc, and duration if any found
                            var ccOffset = 0;
                            var PTSFrag;
                            mapFragmentIntersection(oldDetails, newDetails, function(oldFrag, newFrag) {
                                ccOffset = oldFrag.cc - newFrag.cc;
                                if (Object(number_isFinite["isFiniteNumber"])(oldFrag.startPTS)) {
                                    newFrag.start = newFrag.startPTS = oldFrag.startPTS;
                                    newFrag.endPTS = oldFrag.endPTS;
                                    newFrag.duration = oldFrag.duration;
                                    newFrag.backtracked = oldFrag.backtracked;
                                    newFrag.dropped = oldFrag.dropped;
                                    PTSFrag = newFrag;
                                } // PTS is known when there are overlapping segments
                                newDetails.PTSKnown = true;
                            });
                            if (!newDetails.PTSKnown) return;
                            if (ccOffset) {
                                logger["logger"].log('discontinuity sliding from playlist, take drift into account');
                                var newFragments = newDetails.fragments;
                                for(var i = 0; i < newFragments.length; i++)newFragments[i].cc += ccOffset;
                            } // if at least one fragment contains PTS info, recompute PTS information for all fragments
                            if (PTSFrag) updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
                            else // ensure that delta is within oldFragments range
                            // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
                            // in that case we also need to adjust start offset of all fragments
                            adjustSliding(oldDetails, newDetails);
                             // if we are here, it means we have fragments overlapping between
                            // old and new level. reliable PTS info is thus relying on old level
                            newDetails.PTSKnown = oldDetails.PTSKnown;
                        }
                        function mergeSubtitlePlaylists(oldPlaylist, newPlaylist, referenceStart) {
                            if (referenceStart === void 0) referenceStart = 0;
                            var lastIndex = -1;
                            mapFragmentIntersection(oldPlaylist, newPlaylist, function(oldFrag, newFrag, index) {
                                newFrag.start = oldFrag.start;
                                lastIndex = index;
                            });
                            var frags = newPlaylist.fragments;
                            if (lastIndex < 0) {
                                frags.forEach(function(frag) {
                                    frag.start += referenceStart;
                                });
                                return;
                            }
                            for(var i = lastIndex + 1; i < frags.length; i++)frags[i].start = frags[i - 1].start + frags[i - 1].duration;
                        }
                        function mapFragmentIntersection(oldPlaylist, newPlaylist, intersectionFn) {
                            if (!oldPlaylist || !newPlaylist) return;
                            var start = Math.max(oldPlaylist.startSN, newPlaylist.startSN) - newPlaylist.startSN;
                            var end = Math.min(oldPlaylist.endSN, newPlaylist.endSN) - newPlaylist.startSN;
                            var delta = newPlaylist.startSN - oldPlaylist.startSN;
                            for(var i = start; i <= end; i++){
                                var oldFrag = oldPlaylist.fragments[delta + i];
                                var newFrag = newPlaylist.fragments[i];
                                if (!oldFrag || !newFrag) break;
                                intersectionFn(oldFrag, newFrag, i);
                            }
                        }
                        function adjustSliding(oldPlaylist, newPlaylist) {
                            var delta = newPlaylist.startSN - oldPlaylist.startSN;
                            var oldFragments = oldPlaylist.fragments;
                            var newFragments = newPlaylist.fragments;
                            if (delta < 0 || delta > oldFragments.length) return;
                            for(var i = 0; i < newFragments.length; i++)newFragments[i].start += oldFragments[delta].start;
                        }
                        function computeReloadInterval(currentPlaylist, newPlaylist, lastRequestTime) {
                            var reloadInterval = 1000 * (newPlaylist.averagetargetduration ? newPlaylist.averagetargetduration : newPlaylist.targetduration);
                            var minReloadInterval = reloadInterval / 2;
                            if (currentPlaylist && newPlaylist.endSN === currentPlaylist.endSN) // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
                            // changed then it MUST wait for a period of one-half the target
                            // duration before retrying.
                            reloadInterval = minReloadInterval;
                            if (lastRequestTime) reloadInterval = Math.max(minReloadInterval, reloadInterval - (window.performance.now() - lastRequestTime));
                             // in any case, don't reload more than half of target duration
                            return Math.round(reloadInterval);
                        }
                        // CONCATENATED MODULE: ./src/utils/time-ranges.ts
                        /**
 *  TimeRanges to string helper
 */ var TimeRanges = {
                            toString: function toString(r) {
                                var log = '';
                                var len = r.length;
                                for(var i = 0; i < len; i++)log += '[' + r.start(i).toFixed(3) + ',' + r.end(i).toFixed(3) + ']';
                                return log;
                            }
                        };
                        /* harmony default export */ var time_ranges = TimeRanges;
                        // CONCATENATED MODULE: ./src/utils/discontinuities.js
                        function findFirstFragWithCC(fragments, cc) {
                            var firstFrag = null;
                            for(var i = 0; i < fragments.length; i += 1){
                                var currentFrag = fragments[i];
                                if (currentFrag && currentFrag.cc === cc) {
                                    firstFrag = currentFrag;
                                    break;
                                }
                            }
                            return firstFrag;
                        }
                        function findFragWithCC(fragments, CC) {
                            return binary_search.search(fragments, function(candidate) {
                                if (candidate.cc < CC) return 1;
                                else if (candidate.cc > CC) return -1;
                                else return 0;
                            });
                        }
                        function shouldAlignOnDiscontinuities(lastFrag, lastLevel, details) {
                            var shouldAlign = false;
                            if (lastLevel && lastLevel.details && details) {
                                if (details.endCC > details.startCC || lastFrag && lastFrag.cc < details.startCC) shouldAlign = true;
                            }
                            return shouldAlign;
                        } // Find the first frag in the previous level which matches the CC of the first frag of the new level
                        function findDiscontinuousReferenceFrag(prevDetails, curDetails) {
                            var prevFrags = prevDetails.fragments;
                            var curFrags = curDetails.fragments;
                            if (!curFrags.length || !prevFrags.length) {
                                logger["logger"].log('No fragments to align');
                                return;
                            }
                            var prevStartFrag = findFirstFragWithCC(prevFrags, curFrags[0].cc);
                            if (!prevStartFrag || prevStartFrag && !prevStartFrag.startPTS) {
                                logger["logger"].log('No frag in previous level to align on');
                                return;
                            }
                            return prevStartFrag;
                        }
                        function adjustPts(sliding, details) {
                            details.fragments.forEach(function(frag) {
                                if (frag) {
                                    var start = frag.start + sliding;
                                    frag.start = frag.startPTS = start;
                                    frag.endPTS = start + frag.duration;
                                }
                            });
                            details.PTSKnown = true;
                        }
                        /**
 * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
 * contiguous stream with the last fragments.
 * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
 * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
 * and an extra download.
 * @param lastFrag
 * @param lastLevel
 * @param details
 */ function alignStream(lastFrag, lastLevel, details) {
                            alignDiscontinuities(lastFrag, details, lastLevel);
                            if (!details.PTSKnown && lastLevel) // If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
                            // Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
                            // discontinuity sequence.
                            alignPDT(details, lastLevel.details);
                        }
                        /**
 * Computes the PTS if a new level's fragments using the PTS of a fragment in the last level which shares the same
 * discontinuity sequence.
 * @param lastLevel - The details of the last loaded level
 * @param details - The details of the new level
 */ function alignDiscontinuities(lastFrag, details, lastLevel) {
                            if (shouldAlignOnDiscontinuities(lastFrag, lastLevel, details)) {
                                var referenceFrag = findDiscontinuousReferenceFrag(lastLevel.details, details);
                                if (referenceFrag) {
                                    logger["logger"].log('Adjusting PTS using last level due to CC increase within current level');
                                    adjustPts(referenceFrag.start, details);
                                }
                            }
                        }
                        /**
 * Computes the PTS of a new level's fragments using the difference in Program Date Time from the last level.
 * @param details - The details of the new level
 * @param lastDetails - The details of the last loaded level
 */ function alignPDT(details, lastDetails) {
                            if (lastDetails && lastDetails.fragments.length) {
                                if (!details.hasProgramDateTime || !lastDetails.hasProgramDateTime) return;
                                 // if last level sliding is 1000 and its first frag PROGRAM-DATE-TIME is 2017-08-20 1:10:00 AM
                                // and if new details first frag PROGRAM DATE-TIME is 2017-08-20 1:10:08 AM
                                // then we can deduce that playlist B sliding is 1000+8 = 1008s
                                var lastPDT = lastDetails.fragments[0].programDateTime;
                                var newPDT = details.fragments[0].programDateTime; // date diff is in ms. frag.start is in seconds
                                var sliding = (newPDT - lastPDT) / 1000 + lastDetails.fragments[0].start;
                                if (Object(number_isFinite["isFiniteNumber"])(sliding)) {
                                    logger["logger"].log("adjusting PTS using programDateTime delta, sliding:" + sliding.toFixed(3));
                                    adjustPts(sliding, details);
                                }
                            }
                        }
                        // CONCATENATED MODULE: ./src/controller/fragment-finders.ts
                        /**
 * Returns first fragment whose endPdt value exceeds the given PDT.
 * @param {Array<Fragment>} fragments - The array of candidate fragments
 * @param {number|null} [PDTValue = null] - The PDT value which must be exceeded
 * @param {number} [maxFragLookUpTolerance = 0] - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns {*|null} fragment - The best matching fragment
 */ function findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
                            if (PDTValue === null || !Array.isArray(fragments) || !fragments.length || !Object(number_isFinite["isFiniteNumber"])(PDTValue)) return null;
                             // if less than start
                            var startPDT = fragments[0].programDateTime;
                            if (PDTValue < (startPDT || 0)) return null;
                            var endPDT = fragments[fragments.length - 1].endProgramDateTime;
                            if (PDTValue >= (endPDT || 0)) return null;
                            maxFragLookUpTolerance = maxFragLookUpTolerance || 0;
                            for(var seg = 0; seg < fragments.length; ++seg){
                                var frag = fragments[seg];
                                if (pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) return frag;
                            }
                            return null;
                        }
                        /**
 * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
 * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
 * breaking any traps which would cause the same fragment to be continuously selected within a small range.
 * @param {*} fragPrevious - The last frag successfully appended
 * @param {Array<Fragment>} fragments - The array of candidate fragments
 * @param {number} [bufferEnd = 0] - The end of the contiguous buffered range the playhead is currently within
 * @param {number} maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns {*} foundFrag - The best matching fragment
 */ function findFragmentByPTS(fragPrevious, fragments, bufferEnd, maxFragLookUpTolerance) {
                            if (bufferEnd === void 0) bufferEnd = 0;
                            if (maxFragLookUpTolerance === void 0) maxFragLookUpTolerance = 0;
                            var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : null; // Prefer the next fragment if it's within tolerance
                            if (fragNext && !fragment_finders_fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext)) return fragNext;
                            return binary_search.search(fragments, fragment_finders_fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
                        }
                        /**
 * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
 * @param {*} candidate - The fragment to test
 * @param {number} [bufferEnd = 0] - The end of the current buffered range the playhead is currently within
 * @param {number} [maxFragLookUpTolerance = 0] - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns {number} - 0 if it matches, 1 if too low, -1 if too high
 */ function fragment_finders_fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, candidate) {
                            if (bufferEnd === void 0) bufferEnd = 0;
                            if (maxFragLookUpTolerance === void 0) maxFragLookUpTolerance = 0;
                            // offset should be within fragment boundary - config.maxFragLookUpTolerance
                            // this is to cope with situations like
                            // bufferEnd = 9.991
                            // frag[Ø] : [0,10]
                            // frag[1] : [10,20]
                            // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
                            //              frag start               frag start+duration
                            //                  |-----------------------------|
                            //              <--->                         <--->
                            //  ...--------><-----------------------------><---------....
                            // previous frag         matching fragment         next frag
                            //  return -1             return 0                 return 1
                            // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
                            // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
                            var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
                            if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) return 1;
                            else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
                            return -1;
                            return 0;
                        }
                        /**
 * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
 * This function tests the candidate's program date time values, as represented in Unix time
 * @param {*} candidate - The fragment to test
 * @param {number} [pdtBufferEnd = 0] - The Unix time representing the end of the current buffered range
 * @param {number} [maxFragLookUpTolerance = 0] - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns {boolean} True if contiguous, false otherwise
 */ function pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
                            var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1000; // endProgramDateTime can be null, default to zero
                            var endProgramDateTime = candidate.endProgramDateTime || 0;
                            return endProgramDateTime - candidateLookupTolerance > pdtBufferEnd;
                        }
                        // CONCATENATED MODULE: ./src/controller/gap-controller.js
                        var STALL_MINIMUM_DURATION_MS = 250;
                        var MAX_START_GAP_JUMP = 2.0;
                        var SKIP_BUFFER_HOLE_STEP_SECONDS = 0.1;
                        var SKIP_BUFFER_RANGE_START = 0.05;
                        var gap_controller_GapController = /*#__PURE__*/ function() {
                            function GapController(config, media, fragmentTracker, hls) {
                                this.config = config;
                                this.media = media;
                                this.fragmentTracker = fragmentTracker;
                                this.hls = hls;
                                this.nudgeRetry = 0;
                                this.stallReported = false;
                                this.stalled = null;
                                this.moved = false;
                                this.seeking = false;
                            }
                            /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param {number} lastCurrentTime Previously read playhead position
   */ var _proto = GapController.prototype;
                            _proto.poll = function poll(lastCurrentTime) {
                                var config = this.config, media = this.media, stalled = this.stalled;
                                var currentTime = media.currentTime, seeking = media.seeking;
                                var seeked = this.seeking && !seeking;
                                var beginSeek = !this.seeking && seeking;
                                this.seeking = seeking; // The playhead is moving, no-op
                                if (currentTime !== lastCurrentTime) {
                                    this.moved = true;
                                    if (stalled !== null) {
                                        // The playhead is now moving, but was previously stalled
                                        if (this.stallReported) {
                                            var _stalledDuration = self.performance.now() - stalled;
                                            logger["logger"].warn("playback not stuck anymore @" + currentTime + ", after " + Math.round(_stalledDuration) + "ms");
                                            this.stallReported = false;
                                        }
                                        this.stalled = null;
                                        this.nudgeRetry = 0;
                                    }
                                    return;
                                } // Clear stalled state when beginning or finishing seeking so that we don't report stalls coming out of a seek
                                if (beginSeek || seeked) this.stalled = null;
                                 // The playhead should not be moving
                                if (media.paused || media.ended || media.playbackRate === 0 || !media.buffered.length) return;
                                var bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
                                var isBuffered = bufferInfo.len > 0;
                                var nextStart = bufferInfo.nextStart || 0; // There is no playable buffer (waiting for buffer append)
                                if (!isBuffered && !nextStart) return;
                                if (seeking) {
                                    // Waiting for seeking in a buffered range to complete
                                    var hasEnoughBuffer = bufferInfo.len > MAX_START_GAP_JUMP; // Next buffered range is too far ahead to jump to while still seeking
                                    var noBufferGap = !nextStart || nextStart - currentTime > MAX_START_GAP_JUMP;
                                    if (hasEnoughBuffer || noBufferGap) return;
                                     // Reset moved state when seeking to a point in or before a gap
                                    this.moved = false;
                                } // Skip start gaps if we haven't played, but the last poll detected the start of a stall
                                // The addition poll gives the browser a chance to jump the gap for us
                                if (!this.moved && this.stalled) {
                                    // Jump start gaps within jump threshold
                                    var startJump = Math.max(nextStart, bufferInfo.start || 0) - currentTime;
                                    if (startJump > 0 && startJump <= MAX_START_GAP_JUMP) {
                                        this._trySkipBufferHole(null);
                                        return;
                                    }
                                } // Start tracking stall time
                                var tnow = self.performance.now();
                                if (stalled === null) {
                                    this.stalled = tnow;
                                    return;
                                }
                                var stalledDuration = tnow - stalled;
                                if (!seeking && stalledDuration >= STALL_MINIMUM_DURATION_MS) // Report stalling after trying to fix
                                this._reportStall(bufferInfo.len);
                                var bufferedWithHoles = BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
                                this._tryFixBufferStall(bufferedWithHoles, stalledDuration);
                            };
                            _proto._tryFixBufferStall = function _tryFixBufferStall(bufferInfo, stalledDurationMs) {
                                var config = this.config, fragmentTracker = this.fragmentTracker, media = this.media;
                                var currentTime = media.currentTime;
                                var partial = fragmentTracker.getPartialFragment(currentTime);
                                if (partial) {
                                    // Try to skip over the buffer hole caused by a partial fragment
                                    // This method isn't limited by the size of the gap between buffered ranges
                                    var targetTime = this._trySkipBufferHole(partial); // we return here in this case, meaning
                                    // the branch below only executes when we don't handle a partial fragment
                                    if (targetTime) return;
                                } // if we haven't had to skip over a buffer hole of a partial fragment
                                // we may just have to "nudge" the playlist as the browser decoding/rendering engine
                                // needs to cross some sort of threshold covering all source-buffers content
                                // to start playing properly.
                                if (bufferInfo.len > config.maxBufferHole && stalledDurationMs > config.highBufferWatchdogPeriod * 1000) {
                                    logger["logger"].warn('Trying to nudge playhead over buffer-hole'); // Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
                                    // We only try to jump the hole if it's under the configured size
                                    // Reset stalled so to rearm watchdog timer
                                    this.stalled = null;
                                    this._tryNudgeBuffer();
                                }
                            };
                            _proto._reportStall = function _reportStall(bufferLen) {
                                var hls = this.hls, media = this.media, stallReported = this.stallReported;
                                if (!stallReported) {
                                    // Report stalled error once
                                    this.stallReported = true;
                                    logger["logger"].warn("Playback stalling at @" + media.currentTime + " due to low buffer");
                                    hls.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].MEDIA_ERROR,
                                        details: errors["ErrorDetails"].BUFFER_STALLED_ERROR,
                                        fatal: false,
                                        buffer: bufferLen
                                    });
                                }
                            };
                            _proto._trySkipBufferHole = function _trySkipBufferHole(partial) {
                                var config = this.config, hls = this.hls, media = this.media;
                                var currentTime = media.currentTime;
                                var lastEndTime = 0; // Check if currentTime is between unbuffered regions of partial fragments
                                for(var i = 0; i < media.buffered.length; i++){
                                    var startTime = media.buffered.start(i);
                                    if (currentTime + config.maxBufferHole >= lastEndTime && currentTime < startTime) {
                                        var targetTime = Math.max(startTime + SKIP_BUFFER_RANGE_START, media.currentTime + SKIP_BUFFER_HOLE_STEP_SECONDS);
                                        logger["logger"].warn("skipping hole, adjusting currentTime from " + currentTime + " to " + targetTime);
                                        this.moved = true;
                                        this.stalled = null;
                                        media.currentTime = targetTime;
                                        if (partial) hls.trigger(events["default"].ERROR, {
                                            type: errors["ErrorTypes"].MEDIA_ERROR,
                                            details: errors["ErrorDetails"].BUFFER_SEEK_OVER_HOLE,
                                            fatal: false,
                                            reason: "fragment loaded with buffer holes, seeking from " + currentTime + " to " + targetTime,
                                            frag: partial
                                        });
                                        return targetTime;
                                    }
                                    lastEndTime = media.buffered.end(i);
                                }
                                return 0;
                            };
                            _proto._tryNudgeBuffer = function _tryNudgeBuffer() {
                                var config = this.config, hls = this.hls, media = this.media;
                                var currentTime = media.currentTime;
                                var nudgeRetry = (this.nudgeRetry || 0) + 1;
                                this.nudgeRetry = nudgeRetry;
                                if (nudgeRetry < config.nudgeMaxRetry) {
                                    var targetTime = currentTime + nudgeRetry * config.nudgeOffset; // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
                                    logger["logger"].warn("Nudging 'currentTime' from " + currentTime + " to " + targetTime);
                                    media.currentTime = targetTime;
                                    hls.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].MEDIA_ERROR,
                                        details: errors["ErrorDetails"].BUFFER_NUDGE_ON_STALL,
                                        fatal: false
                                    });
                                } else {
                                    logger["logger"].error("Playhead still not moving while enough data buffered @" + currentTime + " after " + config.nudgeMaxRetry + " nudges");
                                    hls.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].MEDIA_ERROR,
                                        details: errors["ErrorDetails"].BUFFER_STALLED_ERROR,
                                        fatal: true
                                    });
                                }
                            };
                            return GapController;
                        }();
                        // CONCATENATED MODULE: ./src/task-loop.ts
                        function _assertThisInitialized(self1) {
                            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return self1;
                        }
                        function task_loop_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /**
 * Sub-class specialization of EventHandler base class.
 *
 * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
 * scheduled asynchroneously, avoiding recursive calls in the same tick.
 *
 * The task itself is implemented in `doTick`. It can be requested and called for single execution
 * using the `tick` method.
 *
 * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
 * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
 *
 * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
 * and cancelled with `clearNextTick`.
 *
 * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
 *
 * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
 *
 * Further explanations:
 *
 * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
 * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
 *
 * When the task execution (`tick` method) is called in re-entrant way this is detected and
 * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
 * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
 */ var TaskLoop = /*#__PURE__*/ function(_EventHandler) {
                            task_loop_inheritsLoose(TaskLoop, _EventHandler);
                            function TaskLoop(hls) {
                                var _this;
                                for(var _len = arguments.length, events = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)events[_key - 1] = arguments[_key];
                                _this = _EventHandler.call.apply(_EventHandler, [
                                    this,
                                    hls
                                ].concat(events)) || this;
                                _this._boundTick = void 0;
                                _this._tickTimer = null;
                                _this._tickInterval = null;
                                _this._tickCallCount = 0;
                                _this._boundTick = _this.tick.bind(_assertThisInitialized(_this));
                                return _this;
                            }
                            /**
   * @override
   */ var _proto = TaskLoop.prototype;
                            _proto.onHandlerDestroying = function onHandlerDestroying() {
                                // clear all timers before unregistering from event bus
                                this.clearNextTick();
                                this.clearInterval();
                            };
                            _proto.hasInterval = function hasInterval() {
                                return !!this._tickInterval;
                            };
                            _proto.hasNextTick = function hasNextTick() {
                                return !!this._tickTimer;
                            };
                            _proto.setInterval = function setInterval1(millis) {
                                if (!this._tickInterval) {
                                    this._tickInterval = self.setInterval(this._boundTick, millis);
                                    return true;
                                }
                                return false;
                            };
                            _proto.clearInterval = function clearInterval1() {
                                if (this._tickInterval) {
                                    self.clearInterval(this._tickInterval);
                                    this._tickInterval = null;
                                    return true;
                                }
                                return false;
                            };
                            _proto.clearNextTick = function clearNextTick() {
                                if (this._tickTimer) {
                                    self.clearTimeout(this._tickTimer);
                                    this._tickTimer = null;
                                    return true;
                                }
                                return false;
                            };
                            _proto.tick = function tick() {
                                this._tickCallCount++;
                                if (this._tickCallCount === 1) {
                                    this.doTick(); // re-entrant call to tick from previous doTick call stack
                                    // -> schedule a call on the next main loop iteration to process this task processing request
                                    if (this._tickCallCount > 1) {
                                        // make sure only one timer exists at any time at max
                                        this.clearNextTick();
                                        this._tickTimer = self.setTimeout(this._boundTick, 0);
                                    }
                                    this._tickCallCount = 0;
                                }
                            };
                            _proto.doTick = function doTick() {};
                            return TaskLoop;
                        }(event_handler);
                        // CONCATENATED MODULE: ./src/controller/base-stream-controller.js
                        function base_stream_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        var State = {
                            STOPPED: 'STOPPED',
                            STARTING: 'STARTING',
                            IDLE: 'IDLE',
                            PAUSED: 'PAUSED',
                            KEY_LOADING: 'KEY_LOADING',
                            FRAG_LOADING: 'FRAG_LOADING',
                            FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
                            WAITING_TRACK: 'WAITING_TRACK',
                            PARSING: 'PARSING',
                            PARSED: 'PARSED',
                            BUFFER_FLUSHING: 'BUFFER_FLUSHING',
                            ENDED: 'ENDED',
                            ERROR: 'ERROR',
                            WAITING_INIT_PTS: 'WAITING_INIT_PTS',
                            WAITING_LEVEL: 'WAITING_LEVEL'
                        };
                        var base_stream_controller_BaseStreamController = /*#__PURE__*/ function(_TaskLoop) {
                            base_stream_controller_inheritsLoose(BaseStreamController, _TaskLoop);
                            function BaseStreamController() {
                                return _TaskLoop.apply(this, arguments) || this;
                            }
                            var _proto = BaseStreamController.prototype;
                            _proto.doTick = function doTick() {};
                            _proto.startLoad = function startLoad() {};
                            _proto.stopLoad = function stopLoad() {
                                var frag = this.fragCurrent;
                                if (frag) {
                                    if (frag.loader) frag.loader.abort();
                                    this.fragmentTracker.removeFragment(frag);
                                }
                                if (this.demuxer) {
                                    this.demuxer.destroy();
                                    this.demuxer = null;
                                }
                                this.fragCurrent = null;
                                this.fragPrevious = null;
                                this.clearInterval();
                                this.clearNextTick();
                                this.state = State.STOPPED;
                            };
                            _proto._streamEnded = function _streamEnded(bufferInfo, levelDetails) {
                                var fragCurrent = this.fragCurrent, fragmentTracker = this.fragmentTracker; // we just got done loading the final fragment and there is no other buffered range after ...
                                // rationale is that in case there are any buffered ranges after, it means that there are unbuffered portion in between
                                // so we should not switch to ENDED in that case, to be able to buffer them
                                // dont switch to ENDED if we need to backtrack last fragment
                                if (!levelDetails.live && fragCurrent && !fragCurrent.backtracked && fragCurrent.sn === levelDetails.endSN && !bufferInfo.nextStart) {
                                    var fragState = fragmentTracker.getState(fragCurrent);
                                    return fragState === FragmentState.PARTIAL || fragState === FragmentState.OK;
                                }
                                return false;
                            };
                            _proto.onMediaSeeking = function onMediaSeeking() {
                                var config = this.config, media = this.media, mediaBuffer = this.mediaBuffer, state = this.state;
                                var currentTime = media ? media.currentTime : null;
                                var bufferInfo = BufferHelper.bufferInfo(mediaBuffer || media, currentTime, this.config.maxBufferHole);
                                if (Object(number_isFinite["isFiniteNumber"])(currentTime)) logger["logger"].log("media seeking to " + currentTime.toFixed(3));
                                if (state === State.FRAG_LOADING) {
                                    var fragCurrent = this.fragCurrent; // check if we are seeking to a unbuffered area AND if frag loading is in progress
                                    if (bufferInfo.len === 0 && fragCurrent) {
                                        var tolerance = config.maxFragLookUpTolerance;
                                        var fragStartOffset = fragCurrent.start - tolerance;
                                        var fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance; // check if we seek position will be out of currently loaded frag range : if out cancel frag load, if in, don't do anything
                                        if (currentTime < fragStartOffset || currentTime > fragEndOffset) {
                                            if (fragCurrent.loader) {
                                                logger["logger"].log('seeking outside of buffer while fragment load in progress, cancel fragment load');
                                                fragCurrent.loader.abort();
                                            }
                                            this.fragCurrent = null;
                                            this.fragPrevious = null; // switch to IDLE state to load new fragment
                                            this.state = State.IDLE;
                                        } else logger["logger"].log('seeking outside of buffer but within currently loaded fragment range');
                                    }
                                } else if (state === State.ENDED) {
                                    // if seeking to unbuffered area, clean up fragPrevious
                                    if (bufferInfo.len === 0) {
                                        this.fragPrevious = null;
                                        this.fragCurrent = null;
                                    } // switch to IDLE state to check for potential new fragment
                                    this.state = State.IDLE;
                                }
                                if (media) this.lastCurrentTime = currentTime;
                                 // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
                                if (!this.loadedmetadata) this.nextLoadPosition = this.startPosition = currentTime;
                                 // tick to speed up processing
                                this.tick();
                            };
                            _proto.onMediaEnded = function onMediaEnded() {
                                // reset startPosition and lastCurrentTime to restart playback @ stream beginning
                                this.startPosition = this.lastCurrentTime = 0;
                            };
                            _proto.onHandlerDestroying = function onHandlerDestroying() {
                                this.stopLoad();
                                _TaskLoop.prototype.onHandlerDestroying.call(this);
                            };
                            _proto.onHandlerDestroyed = function onHandlerDestroyed() {
                                this.state = State.STOPPED;
                                this.fragmentTracker = null;
                            };
                            _proto.computeLivePosition = function computeLivePosition(sliding, levelDetails) {
                                var targetLatency = this.config.liveSyncDuration !== undefined ? this.config.liveSyncDuration : this.config.liveSyncDurationCount * levelDetails.targetduration;
                                return sliding + Math.max(0, levelDetails.totalduration - targetLatency);
                            };
                            return BaseStreamController;
                        }(TaskLoop);
                        // CONCATENATED MODULE: ./src/controller/stream-controller.js
                        function stream_controller_defineProperties(target, props) {
                            for(var i = 0; i < props.length; i++){
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function stream_controller_createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) stream_controller_defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) stream_controller_defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        function stream_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /*
 * Stream Controller
*/ var TICK_INTERVAL = 100; // how often to tick in ms
                        var stream_controller_StreamController = /*#__PURE__*/ function(_BaseStreamController) {
                            stream_controller_inheritsLoose(StreamController, _BaseStreamController);
                            function StreamController(hls, fragmentTracker) {
                                var _this;
                                _this = _BaseStreamController.call(this, hls, events["default"].MEDIA_ATTACHED, events["default"].MEDIA_DETACHING, events["default"].MANIFEST_LOADING, events["default"].MANIFEST_PARSED, events["default"].LEVEL_LOADED, events["default"].KEY_LOADED, events["default"].FRAG_LOADED, events["default"].FRAG_LOAD_EMERGENCY_ABORTED, events["default"].FRAG_PARSING_INIT_SEGMENT, events["default"].FRAG_PARSING_DATA, events["default"].FRAG_PARSED, events["default"].ERROR, events["default"].AUDIO_TRACK_SWITCHING, events["default"].AUDIO_TRACK_SWITCHED, events["default"].BUFFER_CREATED, events["default"].BUFFER_APPENDED, events["default"].BUFFER_FLUSHED) || this;
                                _this.fragmentTracker = fragmentTracker;
                                _this.config = hls.config;
                                _this.audioCodecSwap = false;
                                _this._state = State.STOPPED;
                                _this.stallReported = false;
                                _this.gapController = null;
                                _this.altAudio = false;
                                return _this;
                            }
                            var _proto = StreamController.prototype;
                            _proto.startLoad = function startLoad(startPosition) {
                                if (this.levels) {
                                    var lastCurrentTime = this.lastCurrentTime, hls = this.hls;
                                    this.stopLoad();
                                    this.setInterval(TICK_INTERVAL);
                                    this.level = -1;
                                    this.fragLoadError = 0;
                                    if (!this.startFragRequested) {
                                        // determine load level
                                        var startLevel = hls.startLevel;
                                        if (startLevel === -1) {
                                            // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
                                            startLevel = 0;
                                            this.bitrateTest = true;
                                        } // set new level to playlist loader : this will trigger start level load
                                        // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
                                        this.level = hls.nextLoadLevel = startLevel;
                                        this.loadedmetadata = false;
                                    } // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
                                    if (lastCurrentTime > 0 && startPosition === -1) {
                                        logger["logger"].log("override startPosition with lastCurrentTime @" + lastCurrentTime.toFixed(3));
                                        startPosition = lastCurrentTime;
                                    }
                                    this.state = State.IDLE;
                                    this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
                                    this.tick();
                                } else {
                                    this.forceStartLoad = true;
                                    this.state = State.STOPPED;
                                }
                            };
                            _proto.stopLoad = function stopLoad() {
                                this.forceStartLoad = false;
                                _BaseStreamController.prototype.stopLoad.call(this);
                            };
                            _proto.doTick = function doTick() {
                                switch(this.state){
                                    case State.BUFFER_FLUSHING:
                                        // in buffer flushing state, reset fragLoadError counter
                                        this.fragLoadError = 0;
                                        break;
                                    case State.IDLE:
                                        this._doTickIdle();
                                        break;
                                    case State.WAITING_LEVEL:
                                        var level = this.levels[this.level]; // check if playlist is already loaded
                                        if (level && level.details) this.state = State.IDLE;
                                        break;
                                    case State.FRAG_LOADING_WAITING_RETRY:
                                        var now = window.performance.now();
                                        var retryDate = this.retryDate; // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                                        if (!retryDate || now >= retryDate || this.media && this.media.seeking) {
                                            logger["logger"].log('mediaController: retryDate reached, switch back to IDLE state');
                                            this.state = State.IDLE;
                                        }
                                        break;
                                    case State.ERROR:
                                    case State.STOPPED:
                                    case State.FRAG_LOADING:
                                    case State.PARSING:
                                    case State.PARSED:
                                    case State.ENDED:
                                        break;
                                    default:
                                        break;
                                } // check buffer
                                this._checkBuffer(); // check/update current fragment
                                this._checkFragmentChanged();
                            } // Ironically the "idle" state is the on we do the most logic in it seems ....
                            ;
                            _proto._doTickIdle = function _doTickIdle() {
                                var hls = this.hls, config = hls.config, media = this.media; // if start level not parsed yet OR
                                // if video not attached AND start fragment already requested OR start frag prefetch disable
                                // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
                                if (this.levelLastLoaded === undefined || !media && (this.startFragRequested || !config.startFragPrefetch)) return;
                                 // if we have not yet loaded any fragment, start loading from start position
                                var pos;
                                if (this.loadedmetadata) pos = media.currentTime;
                                else pos = this.nextLoadPosition;
                                 // determine next load level
                                var level = hls.nextLoadLevel, levelInfo = this.levels[level];
                                if (!levelInfo) return;
                                var levelBitrate = levelInfo.bitrate, maxBufLen; // compute max Buffer Length that we could get from this load level, based on level bitrate.
                                if (levelBitrate) maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
                                else maxBufLen = config.maxBufferLength;
                                maxBufLen = Math.min(maxBufLen, config.maxMaxBufferLength); // determine next candidate fragment to be loaded, based on current position and end of buffer position
                                // ensure up to `config.maxMaxBufferLength` of buffer upfront
                                var bufferInfo = BufferHelper.bufferInfo(this.mediaBuffer ? this.mediaBuffer : media, pos, config.maxBufferHole), bufferLen = bufferInfo.len; // Stay idle if we are still with buffer margins
                                if (bufferLen >= maxBufLen) return;
                                 // if buffer length is less than maxBufLen try to load a new fragment ...
                                logger["logger"].trace("buffer length of " + bufferLen.toFixed(3) + " is below max of " + maxBufLen.toFixed(3) + ". checking for more payload ..."); // set next load level : this will trigger a playlist load if needed
                                this.level = hls.nextLoadLevel = level;
                                var levelDetails = levelInfo.details; // if level info not retrieved yet, switch state and wait for level retrieval
                                // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
                                // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
                                if (!levelDetails || levelDetails.live && this.levelLastLoaded !== level) {
                                    this.state = State.WAITING_LEVEL;
                                    return;
                                }
                                if (this._streamEnded(bufferInfo, levelDetails)) {
                                    var data = {};
                                    if (this.altAudio) data.type = 'video';
                                    this.hls.trigger(events["default"].BUFFER_EOS, data);
                                    this.state = State.ENDED;
                                    return;
                                } // if we have the levelDetails for the selected variant, lets continue enrichen our stream (load keys/fragments or trigger EOS, etc..)
                                this._fetchPayloadOrEos(pos, bufferInfo, levelDetails);
                            };
                            _proto._fetchPayloadOrEos = function _fetchPayloadOrEos(pos, bufferInfo, levelDetails) {
                                var fragPrevious = this.fragPrevious, level = this.level, fragments = levelDetails.fragments, fragLen = fragments.length; // empty playlist
                                if (fragLen === 0) return;
                                 // find fragment index, contiguous with end of buffer position
                                var start = fragments[0].start, end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration, bufferEnd = bufferInfo.end, frag;
                                if (levelDetails.initSegment && !levelDetails.initSegment.data) frag = levelDetails.initSegment;
                                else {
                                    // in case of live playlist we need to ensure that requested position is not located before playlist start
                                    if (levelDetails.live) {
                                        var initialLiveManifestSize = this.config.initialLiveManifestSize;
                                        if (fragLen < initialLiveManifestSize) {
                                            logger["logger"].warn("Can not start playback of a level, reason: not enough fragments " + fragLen + " < " + initialLiveManifestSize);
                                            return;
                                        }
                                        frag = this._ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen); // if it explicitely returns null don't load any fragment and exit function now
                                        if (frag === null) return;
                                    } else // VoD playlist: if bufferEnd before start of playlist, load first fragment
                                    if (bufferEnd < start) frag = fragments[0];
                                }
                                if (!frag) frag = this._findFragment(start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails);
                                if (frag) {
                                    if (frag.encrypted) {
                                        logger["logger"].log("Loading key for " + frag.sn + " of [" + levelDetails.startSN + " ," + levelDetails.endSN + "],level " + level);
                                        this._loadKey(frag);
                                    } else {
                                        logger["logger"].log("Loading " + frag.sn + " of [" + levelDetails.startSN + " ," + levelDetails.endSN + "],level " + level + ", currentTime:" + pos.toFixed(3) + ",bufferEnd:" + bufferEnd.toFixed(3));
                                        this._loadFragment(frag);
                                    }
                                }
                            };
                            _proto._ensureFragmentAtLivePoint = function _ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen) {
                                var config = this.hls.config, media = this.media;
                                var frag; // check if requested position is within seekable boundaries :
                                // logger.log(`start/pos/bufEnd/seeking:${start.toFixed(3)}/${pos.toFixed(3)}/${bufferEnd.toFixed(3)}/${this.media.seeking}`);
                                var maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
                                if (bufferEnd < Math.max(start - config.maxFragLookUpTolerance, end - maxLatency)) {
                                    var liveSyncPosition = this.liveSyncPosition = this.computeLivePosition(start, levelDetails);
                                    bufferEnd = liveSyncPosition;
                                    if (media && !media.paused && media.readyState && media.duration > liveSyncPosition && liveSyncPosition > media.currentTime) {
                                        logger["logger"].log("buffer end: " + bufferEnd.toFixed(3) + " is located too far from the end of live sliding playlist, reset currentTime to : " + liveSyncPosition.toFixed(3));
                                        media.currentTime = liveSyncPosition;
                                    }
                                    this.nextLoadPosition = liveSyncPosition;
                                } // if end of buffer greater than live edge, don't load any fragment
                                // this could happen if live playlist intermittently slides in the past.
                                // level 1 loaded [182580161,182580167]
                                // level 1 loaded [182580162,182580169]
                                // Loading 182580168 of [182580162 ,182580169],level 1 ..
                                // Loading 182580169 of [182580162 ,182580169],level 1 ..
                                // level 1 loaded [182580162,182580168] <============= here we should have bufferEnd > end. in that case break to avoid reloading 182580168
                                // level 1 loaded [182580164,182580171]
                                //
                                // don't return null in case media not loaded yet (readystate === 0)
                                if (levelDetails.PTSKnown && bufferEnd > end && media && media.readyState) return null;
                                if (this.startFragRequested && !levelDetails.PTSKnown) {
                                    /* we are switching level on live playlist, but we don't have any PTS info for that quality level ...
         try to load frag matching with next SN.
         even if SN are not synchronized between playlists, loading this frag will help us
         compute playlist sliding and find the right one after in case it was not the right consecutive one */ if (fragPrevious) {
                                        if (levelDetails.hasProgramDateTime) {
                                            // Relies on PDT in order to switch bitrates (Support EXT-X-DISCONTINUITY without EXT-X-DISCONTINUITY-SEQUENCE)
                                            logger["logger"].log("live playlist, switching playlist, load frag with same PDT: " + fragPrevious.programDateTime);
                                            frag = findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, config.maxFragLookUpTolerance);
                                        } else {
                                            // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
                                            var targetSN = fragPrevious.sn + 1;
                                            if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
                                                var fragNext = fragments[targetSN - levelDetails.startSN];
                                                if (fragPrevious.cc === fragNext.cc) {
                                                    frag = fragNext;
                                                    logger["logger"].log("live playlist, switching playlist, load frag with next SN: " + frag.sn);
                                                }
                                            } // next frag SN not available (or not with same continuity counter)
                                            // look for a frag sharing the same CC
                                            if (!frag) {
                                                frag = binary_search.search(fragments, function(frag) {
                                                    return fragPrevious.cc - frag.cc;
                                                });
                                                if (frag) logger["logger"].log("live playlist, switching playlist, load frag with same CC: " + frag.sn);
                                            }
                                        }
                                    }
                                    if (!frag) {
                                        /* we have no idea about which fragment should be loaded.
           so let's load mid fragment. it will help computing playlist sliding and find the right one
        */ frag = fragments[Math.min(fragLen - 1, Math.round(fragLen / 2))];
                                        logger["logger"].log("live playlist, switching playlist, unknown, load middle frag : " + frag.sn);
                                    }
                                }
                                return frag;
                            };
                            _proto._findFragment = function _findFragment(start, fragPreviousLoad, fragmentIndexRange, fragments, bufferEnd, end, levelDetails) {
                                var config = this.hls.config;
                                var fragNextLoad;
                                if (bufferEnd < end) {
                                    var lookupTolerance = bufferEnd > end - config.maxFragLookUpTolerance ? 0 : config.maxFragLookUpTolerance; // Remove the tolerance if it would put the bufferEnd past the actual end of stream
                                    // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
                                    fragNextLoad = findFragmentByPTS(fragPreviousLoad, fragments, bufferEnd, lookupTolerance);
                                } else // reach end of playlist
                                fragNextLoad = fragments[fragmentIndexRange - 1];
                                if (fragNextLoad) {
                                    var curSNIdx = fragNextLoad.sn - levelDetails.startSN;
                                    var sameLevel = fragPreviousLoad && fragNextLoad.level === fragPreviousLoad.level;
                                    var prevSnFrag = fragments[curSNIdx - 1];
                                    var nextSnFrag = fragments[curSNIdx + 1]; // logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
                                    if (fragPreviousLoad && fragNextLoad.sn === fragPreviousLoad.sn) {
                                        if (sameLevel && !fragNextLoad.backtracked) {
                                            if (fragNextLoad.sn < levelDetails.endSN) {
                                                var deltaPTS = fragPreviousLoad.deltaPTS; // if there is a significant delta between audio and video, larger than max allowed hole,
                                                // and if previous remuxed fragment did not start with a keyframe. (fragPrevious.dropped)
                                                // let's try to load previous fragment again to get last keyframe
                                                // then we will reload again current fragment (that way we should be able to fill the buffer hole ...)
                                                if (deltaPTS && deltaPTS > config.maxBufferHole && fragPreviousLoad.dropped && curSNIdx) {
                                                    fragNextLoad = prevSnFrag;
                                                    logger["logger"].warn('Previous fragment was dropped with large PTS gap between audio and video. Maybe fragment is not starting with a keyframe? Loading previous one to try to overcome this');
                                                } else {
                                                    fragNextLoad = nextSnFrag;
                                                    logger["logger"].log("Re-loading fragment with SN: " + fragNextLoad.sn);
                                                }
                                            } else fragNextLoad = null;
                                        } else if (fragNextLoad.backtracked) {
                                            // Only backtrack a max of 1 consecutive fragment to prevent sliding back too far when little or no frags start with keyframes
                                            if (nextSnFrag && nextSnFrag.backtracked) {
                                                logger["logger"].warn("Already backtracked from fragment " + nextSnFrag.sn + ", will not backtrack to fragment " + fragNextLoad.sn + ". Loading fragment " + nextSnFrag.sn);
                                                fragNextLoad = nextSnFrag;
                                            } else {
                                                // If a fragment has dropped frames and it's in a same level/sequence, load the previous fragment to try and find the keyframe
                                                // Reset the dropped count now since it won't be reset until we parse the fragment again, which prevents infinite backtracking on the same segment
                                                logger["logger"].warn('Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe');
                                                fragNextLoad.dropped = 0;
                                                if (prevSnFrag) {
                                                    fragNextLoad = prevSnFrag;
                                                    fragNextLoad.backtracked = true;
                                                } else if (curSNIdx) // can't backtrack on very first fragment
                                                fragNextLoad = null;
                                            }
                                        }
                                    }
                                }
                                return fragNextLoad;
                            };
                            _proto._loadKey = function _loadKey(frag) {
                                this.state = State.KEY_LOADING;
                                this.hls.trigger(events["default"].KEY_LOADING, {
                                    frag: frag
                                });
                            };
                            _proto._loadFragment = function _loadFragment(frag) {
                                // Check if fragment is not loaded
                                var fragState = this.fragmentTracker.getState(frag);
                                this.fragCurrent = frag;
                                if (frag.sn !== 'initSegment') this.startFragRequested = true;
                                 // Don't update nextLoadPosition for fragments which are not buffered
                                if (Object(number_isFinite["isFiniteNumber"])(frag.sn) && !frag.bitrateTest) this.nextLoadPosition = frag.start + frag.duration;
                                 // Allow backtracked fragments to load
                                if (frag.backtracked || fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) {
                                    frag.autoLevel = this.hls.autoLevelEnabled;
                                    frag.bitrateTest = this.bitrateTest;
                                    this.hls.trigger(events["default"].FRAG_LOADING, {
                                        frag: frag
                                    }); // lazy demuxer init, as this could take some time ... do it during frag loading
                                    if (!this.demuxer) this.demuxer = new demux_demuxer(this.hls, 'main');
                                    this.state = State.FRAG_LOADING;
                                } else if (fragState === FragmentState.APPENDING) // Lower the buffer size and try again
                                {
                                    if (this._reduceMaxBufferLength(frag.duration)) this.fragmentTracker.removeFragment(frag);
                                }
                            };
                            _proto.getBufferedFrag = function getBufferedFrag(position) {
                                return this.fragmentTracker.getBufferedFrag(position, PlaylistLevelType.MAIN);
                            };
                            _proto.followingBufferedFrag = function followingBufferedFrag(frag) {
                                if (frag) // try to get range of next fragment (500ms after this range)
                                return this.getBufferedFrag(frag.endPTS + 0.5);
                                return null;
                            };
                            _proto._checkFragmentChanged = function _checkFragmentChanged() {
                                var fragPlayingCurrent, currentTime, video = this.media;
                                if (video && video.readyState && video.seeking === false) {
                                    currentTime = video.currentTime;
                                    /* if video element is in seeked state, currentTime can only increase.
        (assuming that playback rate is positive ...)
        As sometimes currentTime jumps back to zero after a
        media decode error, check this, to avoid seeking back to
        wrong position after a media decode error
      */ if (currentTime > this.lastCurrentTime) this.lastCurrentTime = currentTime;
                                    if (BufferHelper.isBuffered(video, currentTime)) fragPlayingCurrent = this.getBufferedFrag(currentTime);
                                    else if (BufferHelper.isBuffered(video, currentTime + 0.1)) /* ensure that FRAG_CHANGED event is triggered at startup,
          when first video frame is displayed and playback is paused.
          add a tolerance of 100ms, in case current position is not buffered,
          check if current pos+100ms is buffered and use that buffer range
          for FRAG_CHANGED event reporting */ fragPlayingCurrent = this.getBufferedFrag(currentTime + 0.1);
                                    if (fragPlayingCurrent) {
                                        var fragPlaying = fragPlayingCurrent;
                                        if (fragPlaying !== this.fragPlaying) {
                                            this.hls.trigger(events["default"].FRAG_CHANGED, {
                                                frag: fragPlaying
                                            });
                                            var fragPlayingLevel = fragPlaying.level;
                                            if (!this.fragPlaying || this.fragPlaying.level !== fragPlayingLevel) this.hls.trigger(events["default"].LEVEL_SWITCHED, {
                                                level: fragPlayingLevel
                                            });
                                            this.fragPlaying = fragPlaying;
                                        }
                                    }
                                }
                            };
                            _proto.immediateLevelSwitch = function immediateLevelSwitch() {
                                logger["logger"].log('immediateLevelSwitch');
                                if (!this.immediateSwitch) {
                                    this.immediateSwitch = true;
                                    var media = this.media, previouslyPaused;
                                    if (media) {
                                        previouslyPaused = media.paused;
                                        media.pause();
                                    } else // don't restart playback after instant level switch in case media not attached
                                    previouslyPaused = true;
                                    this.previouslyPaused = previouslyPaused;
                                }
                                var fragCurrent = this.fragCurrent;
                                if (fragCurrent && fragCurrent.loader) fragCurrent.loader.abort();
                                this.fragCurrent = null; // flush everything
                                this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                            };
                            _proto.immediateLevelSwitchEnd = function immediateLevelSwitchEnd() {
                                var media = this.media;
                                if (media && media.buffered.length) {
                                    this.immediateSwitch = false;
                                    if (BufferHelper.isBuffered(media, media.currentTime)) // only nudge if currentTime is buffered
                                    media.currentTime -= 0.0001;
                                    if (!this.previouslyPaused) media.play();
                                }
                            };
                            _proto.nextLevelSwitch = function nextLevelSwitch() {
                                var media = this.media; // ensure that media is defined and that metadata are available (to retrieve currentTime)
                                if (media && media.readyState) {
                                    var fetchdelay, fragPlayingCurrent, nextBufferedFrag;
                                    fragPlayingCurrent = this.getBufferedFrag(media.currentTime);
                                    if (fragPlayingCurrent && fragPlayingCurrent.startPTS > 1) // flush buffer preceding current fragment (flush until current fragment start offset)
                                    // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
                                    this.flushMainBuffer(0, fragPlayingCurrent.startPTS - 1);
                                    if (!media.paused) {
                                        // add a safety delay of 1s
                                        var nextLevelId = this.hls.nextLoadLevel, nextLevel = this.levels[nextLevelId], fragLastKbps = this.fragLastKbps;
                                        if (fragLastKbps && this.fragCurrent) fetchdelay = this.fragCurrent.duration * nextLevel.bitrate / (1000 * fragLastKbps) + 1;
                                        else fetchdelay = 0;
                                    } else fetchdelay = 0;
                                     // logger.log('fetchdelay:'+fetchdelay);
                                    // find buffer range that will be reached once new fragment will be fetched
                                    nextBufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
                                    if (nextBufferedFrag) {
                                        // we can flush buffer range following this one without stalling playback
                                        nextBufferedFrag = this.followingBufferedFrag(nextBufferedFrag);
                                        if (nextBufferedFrag) {
                                            // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
                                            var fragCurrent = this.fragCurrent;
                                            if (fragCurrent && fragCurrent.loader) fragCurrent.loader.abort();
                                            this.fragCurrent = null; // start flush position is the start PTS of next buffered frag.
                                            // we use frag.naxStartPTS which is max(audio startPTS, video startPTS).
                                            // in case there is a small PTS Delta between audio and video, using maxStartPTS avoids flushing last samples from current fragment
                                            this.flushMainBuffer(nextBufferedFrag.maxStartPTS, Number.POSITIVE_INFINITY);
                                        }
                                    }
                                }
                            };
                            _proto.flushMainBuffer = function flushMainBuffer(startOffset, endOffset) {
                                this.state = State.BUFFER_FLUSHING;
                                var flushScope = {
                                    startOffset: startOffset,
                                    endOffset: endOffset
                                }; // if alternate audio tracks are used, only flush video, otherwise flush everything
                                if (this.altAudio) flushScope.type = 'video';
                                this.hls.trigger(events["default"].BUFFER_FLUSHING, flushScope);
                            };
                            _proto.onMediaAttached = function onMediaAttached(data) {
                                var media = this.media = this.mediaBuffer = data.media;
                                this.onvseeking = this.onMediaSeeking.bind(this);
                                this.onvseeked = this.onMediaSeeked.bind(this);
                                this.onvended = this.onMediaEnded.bind(this);
                                media.addEventListener('seeking', this.onvseeking);
                                media.addEventListener('seeked', this.onvseeked);
                                media.addEventListener('ended', this.onvended);
                                var config = this.config;
                                if (this.levels && config.autoStartLoad) this.hls.startLoad(config.startPosition);
                                this.gapController = new gap_controller_GapController(config, media, this.fragmentTracker, this.hls);
                            };
                            _proto.onMediaDetaching = function onMediaDetaching() {
                                var media = this.media;
                                if (media && media.ended) {
                                    logger["logger"].log('MSE detaching and video ended, reset startPosition');
                                    this.startPosition = this.lastCurrentTime = 0;
                                } // reset fragment backtracked flag
                                var levels = this.levels;
                                if (levels) levels.forEach(function(level) {
                                    if (level.details) level.details.fragments.forEach(function(fragment) {
                                        fragment.backtracked = undefined;
                                    });
                                });
                                 // remove video listeners
                                if (media) {
                                    media.removeEventListener('seeking', this.onvseeking);
                                    media.removeEventListener('seeked', this.onvseeked);
                                    media.removeEventListener('ended', this.onvended);
                                    this.onvseeking = this.onvseeked = this.onvended = null;
                                }
                                this.fragmentTracker.removeAllFragments();
                                this.media = this.mediaBuffer = null;
                                this.loadedmetadata = false;
                                this.stopLoad();
                            };
                            _proto.onMediaSeeked = function onMediaSeeked() {
                                var media = this.media;
                                var currentTime = media ? media.currentTime : undefined;
                                if (Object(number_isFinite["isFiniteNumber"])(currentTime)) logger["logger"].log("media seeked to " + currentTime.toFixed(3));
                                 // tick to speed up FRAGMENT_PLAYING triggering
                                this.tick();
                            };
                            _proto.onManifestLoading = function onManifestLoading() {
                                // reset buffer on manifest loading
                                logger["logger"].log('trigger BUFFER_RESET');
                                this.hls.trigger(events["default"].BUFFER_RESET);
                                this.fragmentTracker.removeAllFragments();
                                this.stalled = false;
                                this.startPosition = this.lastCurrentTime = 0;
                            };
                            _proto.onManifestParsed = function onManifestParsed(data) {
                                var aac = false, heaac = false, codec;
                                data.levels.forEach(function(level) {
                                    // detect if we have different kind of audio codecs used amongst playlists
                                    codec = level.audioCodec;
                                    if (codec) {
                                        if (codec.indexOf('mp4a.40.2') !== -1) aac = true;
                                        if (codec.indexOf('mp4a.40.5') !== -1) heaac = true;
                                    }
                                });
                                this.audioCodecSwitch = aac && heaac;
                                if (this.audioCodecSwitch) logger["logger"].log('both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
                                this.altAudio = data.altAudio;
                                this.levels = data.levels;
                                this.startFragRequested = false;
                                var config = this.config;
                                if (config.autoStartLoad || this.forceStartLoad) this.hls.startLoad(config.startPosition);
                            };
                            _proto.onLevelLoaded = function onLevelLoaded(data) {
                                var newDetails = data.details;
                                var newLevelId = data.level;
                                var lastLevel = this.levels[this.levelLastLoaded];
                                var curLevel = this.levels[newLevelId];
                                var duration = newDetails.totalduration;
                                var sliding = 0;
                                logger["logger"].log("level " + newLevelId + " loaded [" + newDetails.startSN + "," + newDetails.endSN + "],duration:" + duration);
                                if (newDetails.live) {
                                    var curDetails = curLevel.details;
                                    if (curDetails && newDetails.fragments.length > 0) {
                                        // we already have details for that level, merge them
                                        mergeDetails(curDetails, newDetails);
                                        sliding = newDetails.fragments[0].start;
                                        this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
                                        if (newDetails.PTSKnown && Object(number_isFinite["isFiniteNumber"])(sliding)) logger["logger"].log("live playlist sliding:" + sliding.toFixed(3));
                                        else {
                                            logger["logger"].log('live playlist - outdated PTS, unknown sliding');
                                            alignStream(this.fragPrevious, lastLevel, newDetails);
                                        }
                                    } else {
                                        logger["logger"].log('live playlist - first load, unknown sliding');
                                        newDetails.PTSKnown = false;
                                        alignStream(this.fragPrevious, lastLevel, newDetails);
                                    }
                                } else newDetails.PTSKnown = false;
                                 // override level info
                                curLevel.details = newDetails;
                                this.levelLastLoaded = newLevelId;
                                this.hls.trigger(events["default"].LEVEL_UPDATED, {
                                    details: newDetails,
                                    level: newLevelId
                                });
                                if (this.startFragRequested === false) {
                                    // compute start position if set to -1. use it straight away if value is defined
                                    if (this.startPosition === -1 || this.lastCurrentTime === -1) {
                                        // first, check if start time offset has been set in playlist, if yes, use this value
                                        var startTimeOffset = newDetails.startTimeOffset;
                                        if (Object(number_isFinite["isFiniteNumber"])(startTimeOffset)) {
                                            if (startTimeOffset < 0) {
                                                logger["logger"].log("negative start time offset " + startTimeOffset + ", count from end of last fragment");
                                                startTimeOffset = sliding + duration + startTimeOffset;
                                            }
                                            logger["logger"].log("start time offset found in playlist, adjust startPosition to " + startTimeOffset);
                                            this.startPosition = startTimeOffset;
                                        } else // if live playlist, set start position to be fragment N-this.config.liveSyncDurationCount (usually 3)
                                        if (newDetails.live) {
                                            this.startPosition = this.computeLivePosition(sliding, newDetails);
                                            logger["logger"].log("configure startPosition to " + this.startPosition);
                                        } else this.startPosition = 0;
                                        this.lastCurrentTime = this.startPosition;
                                    }
                                    this.nextLoadPosition = this.startPosition;
                                } // only switch batck to IDLE state if we were waiting for level to start downloading a new fragment
                                if (this.state === State.WAITING_LEVEL) this.state = State.IDLE;
                                 // trigger handler right now
                                this.tick();
                            };
                            _proto.onKeyLoaded = function onKeyLoaded() {
                                if (this.state === State.KEY_LOADING) {
                                    this.state = State.IDLE;
                                    this.tick();
                                }
                            };
                            _proto.onFragLoaded = function onFragLoaded(data) {
                                var fragCurrent = this.fragCurrent, hls = this.hls, levels = this.levels, media = this.media;
                                var fragLoaded = data.frag;
                                if (this.state === State.FRAG_LOADING && fragCurrent && fragLoaded.type === 'main' && fragLoaded.level === fragCurrent.level && fragLoaded.sn === fragCurrent.sn) {
                                    var stats = data.stats;
                                    var currentLevel = levels[fragCurrent.level];
                                    var details = currentLevel.details; // reset frag bitrate test in any case after frag loaded event
                                    // if this frag was loaded to perform a bitrate test AND if hls.nextLoadLevel is greater than 0
                                    // then this means that we should be able to load a fragment at a higher quality level
                                    this.bitrateTest = false;
                                    this.stats = stats;
                                    logger["logger"].log("Loaded " + fragCurrent.sn + " of [" + details.startSN + " ," + details.endSN + "],level " + fragCurrent.level);
                                    if (fragLoaded.bitrateTest && hls.nextLoadLevel) {
                                        // switch back to IDLE state ... we just loaded a fragment to determine adequate start bitrate and initialize autoswitch algo
                                        this.state = State.IDLE;
                                        this.startFragRequested = false;
                                        stats.tparsed = stats.tbuffered = window.performance.now();
                                        hls.trigger(events["default"].FRAG_BUFFERED, {
                                            stats: stats,
                                            frag: fragCurrent,
                                            id: 'main'
                                        });
                                        this.tick();
                                    } else if (fragLoaded.sn === 'initSegment') {
                                        this.state = State.IDLE;
                                        stats.tparsed = stats.tbuffered = window.performance.now();
                                        details.initSegment.data = data.payload;
                                        hls.trigger(events["default"].FRAG_BUFFERED, {
                                            stats: stats,
                                            frag: fragCurrent,
                                            id: 'main'
                                        });
                                        this.tick();
                                    } else {
                                        logger["logger"].log("Parsing " + fragCurrent.sn + " of [" + details.startSN + " ," + details.endSN + "],level " + fragCurrent.level + ", cc " + fragCurrent.cc);
                                        this.state = State.PARSING;
                                        this.pendingBuffering = true;
                                        this.appended = false; // Bitrate test frags are not usually buffered so the fragment tracker ignores them. If Hls.js decides to buffer
                                        // it (and therefore ends up at this line), then the fragment tracker needs to be manually informed.
                                        if (fragLoaded.bitrateTest) {
                                            fragLoaded.bitrateTest = false;
                                            this.fragmentTracker.onFragLoaded({
                                                frag: fragLoaded
                                            });
                                        } // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live) and if media is not seeking (this is to overcome potential timestamp drifts between playlists and fragments)
                                        var accurateTimeOffset = !(media && media.seeking) && (details.PTSKnown || !details.live);
                                        var initSegmentData = details.initSegment ? details.initSegment.data : [];
                                        var audioCodec = this._getAudioCodec(currentLevel); // transmux the MPEG-TS data to ISO-BMFF segments
                                        var demuxer = this.demuxer = this.demuxer || new demux_demuxer(this.hls, 'main');
                                        demuxer.push(data.payload, initSegmentData, audioCodec, currentLevel.videoCodec, fragCurrent, details.totalduration, accurateTimeOffset);
                                    }
                                }
                                this.fragLoadError = 0;
                            };
                            _proto.onFragParsingInitSegment = function onFragParsingInitSegment(data) {
                                var fragCurrent = this.fragCurrent;
                                var fragNew = data.frag;
                                if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
                                    var tracks = data.tracks, trackName, track; // if audio track is expected to come from audio stream controller, discard any coming from main
                                    if (tracks.audio && this.altAudio) delete tracks.audio;
                                     // include levelCodec in audio and video tracks
                                    track = tracks.audio;
                                    if (track) {
                                        var audioCodec = this.levels[this.level].audioCodec, ua = navigator.userAgent.toLowerCase();
                                        if (audioCodec && this.audioCodecSwap) {
                                            logger["logger"].log('swapping playlist audio codec');
                                            if (audioCodec.indexOf('mp4a.40.5') !== -1) audioCodec = 'mp4a.40.2';
                                            else audioCodec = 'mp4a.40.5';
                                        } // in case AAC and HE-AAC audio codecs are signalled in manifest
                                        // force HE-AAC , as it seems that most browsers prefers that way,
                                        // except for mono streams OR on FF
                                        // these conditions might need to be reviewed ...
                                        if (this.audioCodecSwitch) // don't force HE-AAC if mono stream
                                        {
                                            if (track.metadata.channelCount !== 1 && // don't force HE-AAC if firefox
                                            ua.indexOf('firefox') === -1) audioCodec = 'mp4a.40.5';
                                        } // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
                                        if (ua.indexOf('android') !== -1 && track.container !== 'audio/mpeg') {
                                            // Exclude mpeg audio
                                            audioCodec = 'mp4a.40.2';
                                            logger["logger"].log("Android: force audio codec to " + audioCodec);
                                        }
                                        track.levelCodec = audioCodec;
                                        track.id = data.id;
                                    }
                                    track = tracks.video;
                                    if (track) {
                                        track.levelCodec = this.levels[this.level].videoCodec;
                                        track.id = data.id;
                                    }
                                    this.hls.trigger(events["default"].BUFFER_CODECS, tracks); // loop through tracks that are going to be provided to bufferController
                                    for(trackName in tracks){
                                        track = tracks[trackName];
                                        logger["logger"].log("main track:" + trackName + ",container:" + track.container + ",codecs[level/parsed]=[" + track.levelCodec + "/" + track.codec + "]");
                                        var initSegment = track.initSegment;
                                        if (initSegment) {
                                            this.appended = true; // arm pending Buffering flag before appending a segment
                                            this.pendingBuffering = true;
                                            this.hls.trigger(events["default"].BUFFER_APPENDING, {
                                                type: trackName,
                                                data: initSegment,
                                                parent: 'main',
                                                content: 'initSegment'
                                            });
                                        }
                                    } // trigger handler right now
                                    this.tick();
                                }
                            };
                            _proto.onFragParsingData = function onFragParsingData(data) {
                                var _this2 = this;
                                var fragCurrent = this.fragCurrent;
                                var fragNew = data.frag;
                                if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && !(data.type === 'audio' && this.altAudio) && // filter out main audio if audio track is loaded through audio stream controller
                                this.state === State.PARSING) {
                                    var level = this.levels[this.level], frag = fragCurrent;
                                    if (!Object(number_isFinite["isFiniteNumber"])(data.endPTS)) {
                                        data.endPTS = data.startPTS + fragCurrent.duration;
                                        data.endDTS = data.startDTS + fragCurrent.duration;
                                    }
                                    if (data.hasAudio === true) frag.addElementaryStream(ElementaryStreamTypes.AUDIO);
                                    if (data.hasVideo === true) frag.addElementaryStream(ElementaryStreamTypes.VIDEO);
                                    logger["logger"].log("Parsed " + data.type + ",PTS:[" + data.startPTS.toFixed(3) + "," + data.endPTS.toFixed(3) + "],DTS:[" + data.startDTS.toFixed(3) + "/" + data.endDTS.toFixed(3) + "],nb:" + data.nb + ",dropped:" + (data.dropped || 0)); // Detect gaps in a fragment  and try to fix it by finding a keyframe in the previous fragment (see _findFragments)
                                    if (data.type === 'video') {
                                        frag.dropped = data.dropped;
                                        if (frag.dropped) {
                                            if (!frag.backtracked) {
                                                var levelDetails = level.details;
                                                if (levelDetails && frag.sn === levelDetails.startSN) logger["logger"].warn('missing video frame(s) on first frag, appending with gap', frag.sn);
                                                else {
                                                    logger["logger"].warn('missing video frame(s), backtracking fragment', frag.sn); // Return back to the IDLE state without appending to buffer
                                                    // Causes findFragments to backtrack a segment and find the keyframe
                                                    // Audio fragments arriving before video sets the nextLoadPosition, causing _findFragments to skip the backtracked fragment
                                                    this.fragmentTracker.removeFragment(frag);
                                                    frag.backtracked = true;
                                                    this.nextLoadPosition = data.startPTS;
                                                    this.state = State.IDLE;
                                                    this.fragPrevious = frag;
                                                    this.tick();
                                                    return;
                                                }
                                            } else logger["logger"].warn('Already backtracked on this fragment, appending with the gap', frag.sn);
                                        } else // Only reset the backtracked flag if we've loaded the frag without any dropped frames
                                        frag.backtracked = false;
                                    }
                                    var drift = updateFragPTSDTS(level.details, frag, data.startPTS, data.endPTS, data.startDTS, data.endDTS), hls = this.hls;
                                    hls.trigger(events["default"].LEVEL_PTS_UPDATED, {
                                        details: level.details,
                                        level: this.level,
                                        drift: drift,
                                        type: data.type,
                                        start: data.startPTS,
                                        end: data.endPTS
                                    }); // has remuxer dropped video frames located before first keyframe ?
                                    [
                                        data.data1,
                                        data.data2
                                    ].forEach(function(buffer) {
                                        // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
                                        // in that case it is useless to append following segments
                                        if (buffer && buffer.length && _this2.state === State.PARSING) {
                                            _this2.appended = true; // arm pending Buffering flag before appending a segment
                                            _this2.pendingBuffering = true;
                                            hls.trigger(events["default"].BUFFER_APPENDING, {
                                                type: data.type,
                                                data: buffer,
                                                parent: 'main',
                                                content: 'data'
                                            });
                                        }
                                    }); // trigger handler right now
                                    this.tick();
                                }
                            };
                            _proto.onFragParsed = function onFragParsed(data) {
                                var fragCurrent = this.fragCurrent;
                                var fragNew = data.frag;
                                if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
                                    this.stats.tparsed = window.performance.now();
                                    this.state = State.PARSED;
                                    this._checkAppendedParsed();
                                }
                            };
                            _proto.onAudioTrackSwitching = function onAudioTrackSwitching(data) {
                                // if any URL found on new audio track, it is an alternate audio track
                                var altAudio = !!data.url, trackId = data.id; // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
                                // don't do anything if we switch to alt audio: audio stream controller is handling it.
                                // we will just have to change buffer scheduling on audioTrackSwitched
                                if (!altAudio) {
                                    if (this.mediaBuffer !== this.media) {
                                        logger["logger"].log('switching on main audio, use media.buffered to schedule main fragment loading');
                                        this.mediaBuffer = this.media;
                                        var fragCurrent = this.fragCurrent; // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
                                        if (fragCurrent.loader) {
                                            logger["logger"].log('switching to main audio track, cancel main fragment load');
                                            fragCurrent.loader.abort();
                                        }
                                        this.fragCurrent = null;
                                        this.fragPrevious = null; // destroy demuxer to force init segment generation (following audio switch)
                                        if (this.demuxer) {
                                            this.demuxer.destroy();
                                            this.demuxer = null;
                                        } // switch to IDLE state to load new fragment
                                        this.state = State.IDLE;
                                    }
                                    var hls = this.hls; // switching to main audio, flush all audio and trigger track switched
                                    hls.trigger(events["default"].BUFFER_FLUSHING, {
                                        startOffset: 0,
                                        endOffset: Number.POSITIVE_INFINITY,
                                        type: 'audio'
                                    });
                                    hls.trigger(events["default"].AUDIO_TRACK_SWITCHED, {
                                        id: trackId
                                    });
                                    this.altAudio = false;
                                }
                            };
                            _proto.onAudioTrackSwitched = function onAudioTrackSwitched(data) {
                                var trackId = data.id, altAudio = !!this.hls.audioTracks[trackId].url;
                                if (altAudio) {
                                    var videoBuffer = this.videoBuffer; // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
                                    if (videoBuffer && this.mediaBuffer !== videoBuffer) {
                                        logger["logger"].log('switching on alternate audio, use video.buffered to schedule main fragment loading');
                                        this.mediaBuffer = videoBuffer;
                                    }
                                }
                                this.altAudio = altAudio;
                                this.tick();
                            };
                            _proto.onBufferCreated = function onBufferCreated(data) {
                                var tracks = data.tracks, mediaTrack, name, alternate = false;
                                for(var type in tracks){
                                    var track = tracks[type];
                                    if (track.id === 'main') {
                                        name = type;
                                        mediaTrack = track; // keep video source buffer reference
                                        if (type === 'video') this.videoBuffer = tracks[type].buffer;
                                    } else alternate = true;
                                }
                                if (alternate && mediaTrack) {
                                    logger["logger"].log("alternate track found, use " + name + ".buffered to schedule main fragment loading");
                                    this.mediaBuffer = mediaTrack.buffer;
                                } else this.mediaBuffer = this.media;
                            };
                            _proto.onBufferAppended = function onBufferAppended(data) {
                                if (data.parent === 'main') {
                                    var state = this.state;
                                    if (state === State.PARSING || state === State.PARSED) {
                                        // check if all buffers have been appended
                                        this.pendingBuffering = data.pending > 0;
                                        this._checkAppendedParsed();
                                    }
                                }
                            };
                            _proto._checkAppendedParsed = function _checkAppendedParsed() {
                                // trigger handler right now
                                if (this.state === State.PARSED && (!this.appended || !this.pendingBuffering)) {
                                    var frag = this.fragCurrent;
                                    if (frag) {
                                        var media = this.mediaBuffer ? this.mediaBuffer : this.media;
                                        logger["logger"].log("main buffered : " + time_ranges.toString(media.buffered));
                                        this.fragPrevious = frag;
                                        var stats = this.stats;
                                        stats.tbuffered = window.performance.now(); // we should get rid of this.fragLastKbps
                                        this.fragLastKbps = Math.round(8 * stats.total / (stats.tbuffered - stats.tfirst));
                                        this.hls.trigger(events["default"].FRAG_BUFFERED, {
                                            stats: stats,
                                            frag: frag,
                                            id: 'main'
                                        });
                                        this.state = State.IDLE;
                                    }
                                    this.tick();
                                }
                            };
                            _proto.onError = function onError(data) {
                                var frag = data.frag || this.fragCurrent; // don't handle frag error not related to main fragment
                                if (frag && frag.type !== 'main') return;
                                 // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
                                var mediaBuffered = !!this.media && BufferHelper.isBuffered(this.media, this.media.currentTime) && BufferHelper.isBuffered(this.media, this.media.currentTime + 0.5);
                                switch(data.details){
                                    case errors["ErrorDetails"].FRAG_LOAD_ERROR:
                                    case errors["ErrorDetails"].FRAG_LOAD_TIMEOUT:
                                    case errors["ErrorDetails"].KEY_LOAD_ERROR:
                                    case errors["ErrorDetails"].KEY_LOAD_TIMEOUT:
                                        if (!data.fatal) {
                                            // keep retrying until the limit will be reached
                                            if (this.fragLoadError + 1 <= this.config.fragLoadingMaxRetry) {
                                                // exponential backoff capped to config.fragLoadingMaxRetryTimeout
                                                var delay = Math.min(Math.pow(2, this.fragLoadError) * this.config.fragLoadingRetryDelay, this.config.fragLoadingMaxRetryTimeout);
                                                logger["logger"].warn("mediaController: frag loading failed, retry in " + delay + " ms");
                                                this.retryDate = window.performance.now() + delay; // retry loading state
                                                // if loadedmetadata is not set, it means that we are emergency switch down on first frag
                                                // in that case, reset startFragRequested flag
                                                if (!this.loadedmetadata) {
                                                    this.startFragRequested = false;
                                                    this.nextLoadPosition = this.startPosition;
                                                }
                                                this.fragLoadError++;
                                                this.state = State.FRAG_LOADING_WAITING_RETRY;
                                            } else {
                                                logger["logger"].error("mediaController: " + data.details + " reaches max retry, redispatch as fatal ..."); // switch error to fatal
                                                data.fatal = true;
                                                this.state = State.ERROR;
                                            }
                                        }
                                        break;
                                    case errors["ErrorDetails"].LEVEL_LOAD_ERROR:
                                    case errors["ErrorDetails"].LEVEL_LOAD_TIMEOUT:
                                        if (this.state !== State.ERROR) {
                                            if (data.fatal) {
                                                // if fatal error, stop processing
                                                this.state = State.ERROR;
                                                logger["logger"].warn("streamController: " + data.details + ",switch to " + this.state + " state ...");
                                            } else // in case of non fatal error while loading level, if level controller is not retrying to load level , switch back to IDLE
                                            if (!data.levelRetry && this.state === State.WAITING_LEVEL) this.state = State.IDLE;
                                        }
                                        break;
                                    case errors["ErrorDetails"].BUFFER_FULL_ERROR:
                                        // if in appending state
                                        if (data.parent === 'main' && (this.state === State.PARSING || this.state === State.PARSED)) {
                                            // reduce max buf len if current position is buffered
                                            if (mediaBuffered) {
                                                this._reduceMaxBufferLength(this.config.maxBufferLength);
                                                this.state = State.IDLE;
                                            } else {
                                                // current position is not buffered, but browser is still complaining about buffer full error
                                                // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
                                                // in that case flush the whole buffer to recover
                                                logger["logger"].warn('buffer full error also media.currentTime is not buffered, flush everything');
                                                this.fragCurrent = null; // flush everything
                                                this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                                            }
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            };
                            _proto._reduceMaxBufferLength = function _reduceMaxBufferLength(minLength) {
                                var config = this.config;
                                if (config.maxMaxBufferLength >= minLength) {
                                    // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
                                    config.maxMaxBufferLength /= 2;
                                    logger["logger"].warn("main:reduce max buffer length to " + config.maxMaxBufferLength + "s");
                                    return true;
                                }
                                return false;
                            };
                            _proto._checkBuffer = function _checkBuffer() {
                                var media = this.media;
                                if (!media || media.readyState === 0) // Exit early if we don't have media or if the media hasn't bufferd anything yet (readyState 0)
                                return;
                                var mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media;
                                var buffered = mediaBuffer.buffered;
                                if (!this.loadedmetadata && buffered.length) {
                                    this.loadedmetadata = true;
                                    this._seekToStartPos();
                                } else if (this.immediateSwitch) this.immediateLevelSwitchEnd();
                                else this.gapController.poll(this.lastCurrentTime, buffered);
                            };
                            _proto.onFragLoadEmergencyAborted = function onFragLoadEmergencyAborted() {
                                this.state = State.IDLE; // if loadedmetadata is not set, it means that we are emergency switch down on first frag
                                // in that case, reset startFragRequested flag
                                if (!this.loadedmetadata) {
                                    this.startFragRequested = false;
                                    this.nextLoadPosition = this.startPosition;
                                }
                                this.tick();
                            };
                            _proto.onBufferFlushed = function onBufferFlushed() {
                                /* after successful buffer flushing, filter flushed fragments from bufferedFrags
      use mediaBuffered instead of media (so that we will check against video.buffered ranges in case of alt audio track)
    */ var media = this.mediaBuffer ? this.mediaBuffer : this.media;
                                if (media) // filter fragments potentially evicted from buffer. this is to avoid memleak on live streams
                                this.fragmentTracker.detectEvictedFragments(ElementaryStreamTypes.VIDEO, media.buffered);
                                 // move to IDLE once flush complete. this should trigger new fragment loading
                                this.state = State.IDLE; // reset reference to frag
                                this.fragPrevious = null;
                            };
                            _proto.swapAudioCodec = function swapAudioCodec() {
                                this.audioCodecSwap = !this.audioCodecSwap;
                            };
                            _proto._seekToStartPos = function _seekToStartPos() {
                                var media = this.media;
                                var currentTime = media.currentTime; // only adjust currentTime if different from startPosition or if startPosition not buffered
                                // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
                                var startPosition = media.seeking ? currentTime : this.startPosition; // if currentTime not matching with expected startPosition or startPosition not buffered but close to first buffered
                                if (currentTime !== startPosition && startPosition >= 0) {
                                    // if startPosition not buffered, let's seek to buffered.start(0)
                                    logger["logger"].log("target start position not buffered, seek to buffered.start(0) " + startPosition + " from current time " + currentTime + " ");
                                    media.currentTime = startPosition;
                                }
                            };
                            _proto._getAudioCodec = function _getAudioCodec(currentLevel) {
                                var audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
                                if (this.audioCodecSwap) {
                                    logger["logger"].log('swapping playlist audio codec');
                                    if (audioCodec) {
                                        if (audioCodec.indexOf('mp4a.40.5') !== -1) audioCodec = 'mp4a.40.2';
                                        else audioCodec = 'mp4a.40.5';
                                    }
                                }
                                return audioCodec;
                            };
                            stream_controller_createClass(StreamController, [
                                {
                                    key: "state",
                                    set: function set(nextState) {
                                        if (this.state !== nextState) {
                                            var previousState = this.state;
                                            this._state = nextState;
                                            logger["logger"].log("main stream-controller: " + previousState + "->" + nextState);
                                            this.hls.trigger(events["default"].STREAM_STATE_TRANSITION, {
                                                previousState: previousState,
                                                nextState: nextState
                                            });
                                        }
                                    },
                                    get: function get() {
                                        return this._state;
                                    }
                                },
                                {
                                    key: "currentLevel",
                                    get: function get() {
                                        var media = this.media;
                                        if (media) {
                                            var frag = this.getBufferedFrag(media.currentTime);
                                            if (frag) return frag.level;
                                        }
                                        return -1;
                                    }
                                },
                                {
                                    key: "nextBufferedFrag",
                                    get: function get() {
                                        var media = this.media;
                                        if (media) // first get end range of current fragment
                                        return this.followingBufferedFrag(this.getBufferedFrag(media.currentTime));
                                        else return null;
                                    }
                                },
                                {
                                    key: "nextLevel",
                                    get: function get() {
                                        var frag = this.nextBufferedFrag;
                                        if (frag) return frag.level;
                                        else return -1;
                                    }
                                },
                                {
                                    key: "liveSyncPosition",
                                    get: function get() {
                                        return this._liveSyncPosition;
                                    },
                                    set: function set(value) {
                                        this._liveSyncPosition = value;
                                    }
                                }
                            ]);
                            return StreamController;
                        }(base_stream_controller_BaseStreamController);
                        /* harmony default export */ var stream_controller = stream_controller_StreamController;
                        // CONCATENATED MODULE: ./src/controller/level-controller.js
                        function level_controller_defineProperties(target, props) {
                            for(var i = 0; i < props.length; i++){
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function level_controller_createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) level_controller_defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) level_controller_defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        function level_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /*
 * Level Controller
*/ var level_controller_window = window, level_controller_performance = level_controller_window.performance;
                        var chromeOrFirefox;
                        var level_controller_LevelController = /*#__PURE__*/ function(_EventHandler) {
                            level_controller_inheritsLoose(LevelController, _EventHandler);
                            function LevelController(hls) {
                                var _this;
                                _this = _EventHandler.call(this, hls, events["default"].MANIFEST_LOADED, events["default"].LEVEL_LOADED, events["default"].AUDIO_TRACK_SWITCHED, events["default"].FRAG_LOADED, events["default"].ERROR) || this;
                                _this.canload = false;
                                _this.currentLevelIndex = null;
                                _this.manualLevelIndex = -1;
                                _this.timer = null;
                                chromeOrFirefox = /chrome|firefox/.test(navigator.userAgent.toLowerCase());
                                return _this;
                            }
                            var _proto = LevelController.prototype;
                            _proto.onHandlerDestroying = function onHandlerDestroying() {
                                this.clearTimer();
                                this.manualLevelIndex = -1;
                            };
                            _proto.clearTimer = function clearTimer() {
                                if (this.timer !== null) {
                                    clearTimeout(this.timer);
                                    this.timer = null;
                                }
                            };
                            _proto.startLoad = function startLoad() {
                                var levels = this._levels;
                                this.canload = true;
                                this.levelRetryCount = 0; // clean up live level details to force reload them, and reset load errors
                                if (levels) levels.forEach(function(level) {
                                    level.loadError = 0;
                                    var levelDetails = level.details;
                                    if (levelDetails && levelDetails.live) level.details = undefined;
                                });
                                 // speed up live playlist refresh if timer exists
                                if (this.timer !== null) this.loadLevel();
                            };
                            _proto.stopLoad = function stopLoad() {
                                this.canload = false;
                            };
                            _proto.onManifestLoaded = function onManifestLoaded(data) {
                                var levels = [];
                                var audioTracks = [];
                                var bitrateStart;
                                var levelSet = {};
                                var levelFromSet = null;
                                var videoCodecFound = false;
                                var audioCodecFound = false; // regroup redundant levels together
                                data.levels.forEach(function(level) {
                                    var attributes = level.attrs;
                                    level.loadError = 0;
                                    level.fragmentError = false;
                                    videoCodecFound = videoCodecFound || !!level.videoCodec;
                                    audioCodecFound = audioCodecFound || !!level.audioCodec; // erase audio codec info if browser does not support mp4a.40.34.
                                    // demuxer will autodetect codec and fallback to mpeg/audio
                                    if (chromeOrFirefox && level.audioCodec && level.audioCodec.indexOf('mp4a.40.34') !== -1) level.audioCodec = undefined;
                                    levelFromSet = levelSet[level.bitrate]; // FIXME: we would also have to match the resolution here
                                    if (!levelFromSet) {
                                        level.url = [
                                            level.url
                                        ];
                                        level.urlId = 0;
                                        levelSet[level.bitrate] = level;
                                        levels.push(level);
                                    } else levelFromSet.url.push(level.url);
                                    if (attributes) {
                                        if (attributes.AUDIO) {
                                            audioCodecFound = true;
                                            addGroupId(levelFromSet || level, 'audio', attributes.AUDIO);
                                        }
                                        if (attributes.SUBTITLES) addGroupId(levelFromSet || level, 'text', attributes.SUBTITLES);
                                    }
                                }); // remove audio-only level if we also have levels with audio+video codecs signalled
                                if (videoCodecFound && audioCodecFound) levels = levels.filter(function(_ref) {
                                    var videoCodec = _ref.videoCodec;
                                    return !!videoCodec;
                                });
                                 // only keep levels with supported audio/video codecs
                                levels = levels.filter(function(_ref2) {
                                    var audioCodec = _ref2.audioCodec, videoCodec = _ref2.videoCodec;
                                    return (!audioCodec || isCodecSupportedInMp4(audioCodec, 'audio')) && (!videoCodec || isCodecSupportedInMp4(videoCodec, 'video'));
                                });
                                if (data.audioTracks) {
                                    audioTracks = data.audioTracks.filter(function(track) {
                                        return !track.audioCodec || isCodecSupportedInMp4(track.audioCodec, 'audio');
                                    }); // Reassign id's after filtering since they're used as array indices
                                    audioTracks.forEach(function(track, index) {
                                        track.id = index;
                                    });
                                }
                                if (levels.length > 0) {
                                    // start bitrate is the first bitrate of the manifest
                                    bitrateStart = levels[0].bitrate; // sort level on bitrate
                                    levels.sort(function(a, b) {
                                        return a.bitrate - b.bitrate;
                                    });
                                    this._levels = levels; // find index of first level in sorted levels
                                    for(var i = 0; i < levels.length; i++)if (levels[i].bitrate === bitrateStart) {
                                        this._firstLevel = i;
                                        logger["logger"].log("manifest loaded," + levels.length + " level(s) found, first bitrate:" + bitrateStart);
                                        break;
                                    }
                                     // Audio is only alternate if manifest include a URI along with the audio group tag
                                    this.hls.trigger(events["default"].MANIFEST_PARSED, {
                                        levels: levels,
                                        audioTracks: audioTracks,
                                        firstLevel: this._firstLevel,
                                        stats: data.stats,
                                        audio: audioCodecFound,
                                        video: videoCodecFound,
                                        altAudio: audioTracks.some(function(t) {
                                            return !!t.url;
                                        })
                                    });
                                } else this.hls.trigger(events["default"].ERROR, {
                                    type: errors["ErrorTypes"].MEDIA_ERROR,
                                    details: errors["ErrorDetails"].MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                                    fatal: true,
                                    url: this.hls.url,
                                    reason: 'no level with compatible codecs found in manifest'
                                });
                            };
                            _proto.setLevelInternal = function setLevelInternal(newLevel) {
                                var levels = this._levels;
                                var hls = this.hls; // check if level idx is valid
                                if (newLevel >= 0 && newLevel < levels.length) {
                                    // stopping live reloading timer if any
                                    this.clearTimer();
                                    if (this.currentLevelIndex !== newLevel) {
                                        logger["logger"].log("switching to level " + newLevel);
                                        this.currentLevelIndex = newLevel;
                                        var levelProperties = levels[newLevel];
                                        levelProperties.level = newLevel;
                                        hls.trigger(events["default"].LEVEL_SWITCHING, levelProperties);
                                    }
                                    var level = levels[newLevel];
                                    var levelDetails = level.details; // check if we need to load playlist for this level
                                    if (!levelDetails || levelDetails.live) {
                                        // level not retrieved yet, or live playlist we need to (re)load it
                                        var urlId = level.urlId;
                                        hls.trigger(events["default"].LEVEL_LOADING, {
                                            url: level.url[urlId],
                                            level: newLevel,
                                            id: urlId
                                        });
                                    }
                                } else // invalid level id given, trigger error
                                hls.trigger(events["default"].ERROR, {
                                    type: errors["ErrorTypes"].OTHER_ERROR,
                                    details: errors["ErrorDetails"].LEVEL_SWITCH_ERROR,
                                    level: newLevel,
                                    fatal: false,
                                    reason: 'invalid level idx'
                                });
                            };
                            _proto.onError = function onError(data) {
                                if (data.fatal) {
                                    if (data.type === errors["ErrorTypes"].NETWORK_ERROR) this.clearTimer();
                                    return;
                                }
                                var levelError = false, fragmentError = false;
                                var levelIndex; // try to recover not fatal errors
                                switch(data.details){
                                    case errors["ErrorDetails"].FRAG_LOAD_ERROR:
                                    case errors["ErrorDetails"].FRAG_LOAD_TIMEOUT:
                                    case errors["ErrorDetails"].KEY_LOAD_ERROR:
                                    case errors["ErrorDetails"].KEY_LOAD_TIMEOUT:
                                        levelIndex = data.frag.level;
                                        fragmentError = true;
                                        break;
                                    case errors["ErrorDetails"].LEVEL_LOAD_ERROR:
                                    case errors["ErrorDetails"].LEVEL_LOAD_TIMEOUT:
                                        levelIndex = data.context.level;
                                        levelError = true;
                                        break;
                                    case errors["ErrorDetails"].REMUX_ALLOC_ERROR:
                                        levelIndex = data.level;
                                        levelError = true;
                                        break;
                                }
                                if (levelIndex !== undefined) this.recoverLevel(data, levelIndex, levelError, fragmentError);
                            };
                            _proto.recoverLevel = function recoverLevel(errorEvent, levelIndex, levelError, fragmentError) {
                                var _this2 = this;
                                var config = this.hls.config;
                                var errorDetails = errorEvent.details;
                                var level = this._levels[levelIndex];
                                var redundantLevels, delay, nextLevel;
                                level.loadError++;
                                level.fragmentError = fragmentError;
                                if (levelError) {
                                    if (this.levelRetryCount + 1 <= config.levelLoadingMaxRetry) {
                                        // exponential backoff capped to max retry timeout
                                        delay = Math.min(Math.pow(2, this.levelRetryCount) * config.levelLoadingRetryDelay, config.levelLoadingMaxRetryTimeout); // Schedule level reload
                                        this.timer = setTimeout(function() {
                                            return _this2.loadLevel();
                                        }, delay); // boolean used to inform stream controller not to switch back to IDLE on non fatal error
                                        errorEvent.levelRetry = true;
                                        this.levelRetryCount++;
                                        logger["logger"].warn("level controller, " + errorDetails + ", retry in " + delay + " ms, current retry count is " + this.levelRetryCount);
                                    } else {
                                        logger["logger"].error("level controller, cannot recover from " + errorDetails + " error");
                                        this.currentLevelIndex = null; // stopping live reloading timer if any
                                        this.clearTimer(); // switch error to fatal
                                        errorEvent.fatal = true;
                                        return;
                                    }
                                } // Try any redundant streams if available for both errors: level and fragment
                                // If level.loadError reaches redundantLevels it means that we tried them all, no hope  => let's switch down
                                if (levelError || fragmentError) {
                                    redundantLevels = level.url.length;
                                    if (redundantLevels > 1 && level.loadError < redundantLevels) {
                                        level.urlId = (level.urlId + 1) % redundantLevels;
                                        level.details = undefined;
                                        logger["logger"].warn("level controller, " + errorDetails + " for level " + levelIndex + ": switching to redundant URL-id " + level.urlId); // console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
                                    // console.log('New video quality level audio group id:', level.attrs.AUDIO);
                                    } else {
                                        // Search for available level
                                        if (this.manualLevelIndex === -1) {
                                            // When lowest level has been reached, let's start hunt from the top
                                            nextLevel = levelIndex === 0 ? this._levels.length - 1 : levelIndex - 1;
                                            logger["logger"].warn("level controller, " + errorDetails + ": switch to " + nextLevel);
                                            this.hls.nextAutoLevel = this.currentLevelIndex = nextLevel;
                                        } else if (fragmentError) {
                                            // Allow fragment retry as long as configuration allows.
                                            // reset this._level so that another call to set level() will trigger again a frag load
                                            logger["logger"].warn("level controller, " + errorDetails + ": reload a fragment");
                                            this.currentLevelIndex = null;
                                        }
                                    }
                                }
                            } // reset errors on the successful load of a fragment
                            ;
                            _proto.onFragLoaded = function onFragLoaded(_ref3) {
                                var frag = _ref3.frag;
                                if (frag !== undefined && frag.type === 'main') {
                                    var level = this._levels[frag.level];
                                    if (level !== undefined) {
                                        level.fragmentError = false;
                                        level.loadError = 0;
                                        this.levelRetryCount = 0;
                                    }
                                }
                            };
                            _proto.onLevelLoaded = function onLevelLoaded(data) {
                                var _this3 = this;
                                var level = data.level, details = data.details; // only process level loaded events matching with expected level
                                if (level !== this.currentLevelIndex) return;
                                var curLevel = this._levels[level]; // reset level load error counter on successful level loaded only if there is no issues with fragments
                                if (!curLevel.fragmentError) {
                                    curLevel.loadError = 0;
                                    this.levelRetryCount = 0;
                                } // if current playlist is a live playlist, arm a timer to reload it
                                if (details.live) {
                                    var reloadInterval = computeReloadInterval(curLevel.details, details, data.stats.trequest);
                                    logger["logger"].log("live playlist, reload in " + Math.round(reloadInterval) + " ms");
                                    this.timer = setTimeout(function() {
                                        return _this3.loadLevel();
                                    }, reloadInterval);
                                } else this.clearTimer();
                            };
                            _proto.onAudioTrackSwitched = function onAudioTrackSwitched(data) {
                                var audioGroupId = this.hls.audioTracks[data.id].groupId;
                                var currentLevel = this.hls.levels[this.currentLevelIndex];
                                if (!currentLevel) return;
                                if (currentLevel.audioGroupIds) {
                                    var urlId = -1;
                                    for(var i = 0; i < currentLevel.audioGroupIds.length; i++)if (currentLevel.audioGroupIds[i] === audioGroupId) {
                                        urlId = i;
                                        break;
                                    }
                                    if (urlId !== currentLevel.urlId) {
                                        currentLevel.urlId = urlId;
                                        this.startLoad();
                                    }
                                }
                            };
                            _proto.loadLevel = function loadLevel() {
                                logger["logger"].debug('call to loadLevel');
                                if (this.currentLevelIndex !== null && this.canload) {
                                    var levelObject = this._levels[this.currentLevelIndex];
                                    if (typeof levelObject === 'object' && levelObject.url.length > 0) {
                                        var level = this.currentLevelIndex;
                                        var id = levelObject.urlId;
                                        var url = levelObject.url[id];
                                        logger["logger"].log("Attempt loading level index " + level + " with URL-id " + id); // console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
                                        // console.log('New video quality level audio group id:', levelObject.attrs.AUDIO, level);
                                        this.hls.trigger(events["default"].LEVEL_LOADING, {
                                            url: url,
                                            level: level,
                                            id: id
                                        });
                                    }
                                }
                            };
                            level_controller_createClass(LevelController, [
                                {
                                    key: "levels",
                                    get: function get() {
                                        return this._levels;
                                    }
                                },
                                {
                                    key: "level",
                                    get: function get() {
                                        return this.currentLevelIndex;
                                    },
                                    set: function set(newLevel) {
                                        var levels = this._levels;
                                        if (levels) {
                                            newLevel = Math.min(newLevel, levels.length - 1);
                                            if (this.currentLevelIndex !== newLevel || !levels[newLevel].details) this.setLevelInternal(newLevel);
                                        }
                                    }
                                },
                                {
                                    key: "manualLevel",
                                    get: function get() {
                                        return this.manualLevelIndex;
                                    },
                                    set: function set(newLevel) {
                                        this.manualLevelIndex = newLevel;
                                        if (this._startLevel === undefined) this._startLevel = newLevel;
                                        if (newLevel !== -1) this.level = newLevel;
                                    }
                                },
                                {
                                    key: "firstLevel",
                                    get: function get() {
                                        return this._firstLevel;
                                    },
                                    set: function set(newLevel) {
                                        this._firstLevel = newLevel;
                                    }
                                },
                                {
                                    key: "startLevel",
                                    get: function get() {
                                        // hls.startLevel takes precedence over config.startLevel
                                        // if none of these values are defined, fallback on this._firstLevel (first quality level appearing in variant manifest)
                                        if (this._startLevel === undefined) {
                                            var configStartLevel = this.hls.config.startLevel;
                                            if (configStartLevel !== undefined) return configStartLevel;
                                            else return this._firstLevel;
                                        } else return this._startLevel;
                                    },
                                    set: function set(newLevel) {
                                        this._startLevel = newLevel;
                                    }
                                },
                                {
                                    key: "nextLoadLevel",
                                    get: function get() {
                                        if (this.manualLevelIndex !== -1) return this.manualLevelIndex;
                                        else return this.hls.nextAutoLevel;
                                    },
                                    set: function set(nextLevel) {
                                        this.level = nextLevel;
                                        if (this.manualLevelIndex === -1) this.hls.nextAutoLevel = nextLevel;
                                    }
                                }
                            ]);
                            return LevelController;
                        }(event_handler);
                        // EXTERNAL MODULE: ./src/demux/id3.js
                        var id3 = __webpack_require__("./src/demux/id3.js");
                        // CONCATENATED MODULE: ./src/utils/texttrack-utils.ts
                        function sendAddTrackEvent(track, videoEl) {
                            var event;
                            try {
                                event = new Event('addtrack');
                            } catch (err) {
                                // for IE11
                                event = document.createEvent('Event');
                                event.initEvent('addtrack', false, false);
                            }
                            event.track = track;
                            videoEl.dispatchEvent(event);
                        }
                        function clearCurrentCues(track) {
                            if (track && track.cues) while(track.cues.length > 0)track.removeCue(track.cues[0]);
                        }
                        /**
 *  Given a list of Cues, finds the closest cue matching the given time.
 *  Modified verison of binary search O(log(n)).
 *
 * @export
 * @param {(TextTrackCueList | TextTrackCue[])} cues - List of cues.
 * @param {number} time - Target time, to find closest cue to.
 * @returns {TextTrackCue}
 */ function getClosestCue(cues, time) {
                            // If the offset is less than the first element, the first element is the closest.
                            if (time < cues[0].endTime) return cues[0];
                             // If the offset is greater than the last cue, the last is the closest.
                            if (time > cues[cues.length - 1].endTime) return cues[cues.length - 1];
                            var left = 0;
                            var right = cues.length - 1;
                            while(left <= right){
                                var mid = Math.floor((right + left) / 2);
                                if (time < cues[mid].endTime) right = mid - 1;
                                else if (time > cues[mid].endTime) left = mid + 1;
                                else // If it's not lower or higher, it must be equal.
                                return cues[mid];
                            } // At this point, left and right have swapped.
                            // No direct match was found, left or right element must be the closest. Check which one has the smallest diff.
                            return cues[left].endTime - time < time - cues[right].endTime ? cues[left] : cues[right];
                        }
                        // CONCATENATED MODULE: ./src/controller/id3-track-controller.js
                        function id3_track_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /*
 * id3 metadata track controller
*/ var id3_track_controller_ID3TrackController = /*#__PURE__*/ function(_EventHandler) {
                            id3_track_controller_inheritsLoose(ID3TrackController, _EventHandler);
                            function ID3TrackController(hls) {
                                var _this;
                                _this = _EventHandler.call(this, hls, events["default"].MEDIA_ATTACHED, events["default"].MEDIA_DETACHING, events["default"].FRAG_PARSING_METADATA, events["default"].LIVE_BACK_BUFFER_REACHED) || this;
                                _this.id3Track = undefined;
                                _this.media = undefined;
                                return _this;
                            }
                            var _proto = ID3TrackController.prototype;
                            _proto.destroy = function destroy() {
                                event_handler.prototype.destroy.call(this);
                            } // Add ID3 metatadata text track.
                            ;
                            _proto.onMediaAttached = function onMediaAttached(data) {
                                this.media = data.media;
                                this.media;
                            };
                            _proto.onMediaDetaching = function onMediaDetaching() {
                                clearCurrentCues(this.id3Track);
                                this.id3Track = undefined;
                                this.media = undefined;
                            };
                            _proto.getID3Track = function getID3Track(textTracks) {
                                for(var i = 0; i < textTracks.length; i++){
                                    var textTrack = textTracks[i];
                                    if (textTrack.kind === 'metadata' && textTrack.label === 'id3') {
                                        // send 'addtrack' when reusing the textTrack for metadata,
                                        // same as what we do for captions
                                        sendAddTrackEvent(textTrack, this.media);
                                        return textTrack;
                                    }
                                }
                                return this.media.addTextTrack('metadata', 'id3');
                            };
                            _proto.onFragParsingMetadata = function onFragParsingMetadata(data) {
                                var fragment = data.frag;
                                var samples = data.samples; // create track dynamically
                                if (!this.id3Track) {
                                    this.id3Track = this.getID3Track(this.media.textTracks);
                                    this.id3Track.mode = 'hidden';
                                } // Attempt to recreate Safari functionality by creating
                                // WebKitDataCue objects when available and store the decoded
                                // ID3 data in the value property of the cue
                                var Cue = window.WebKitDataCue || window.VTTCue || window.TextTrackCue;
                                for(var i = 0; i < samples.length; i++){
                                    var frames = id3["default"].getID3Frames(samples[i].data);
                                    if (frames) {
                                        var startTime = samples[i].pts;
                                        var endTime = i < samples.length - 1 ? samples[i + 1].pts : fragment.endPTS;
                                        if (startTime === endTime) // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
                                        endTime += 0.0001;
                                        else if (startTime > endTime) {
                                            logger["logger"].warn('detected an id3 sample with endTime < startTime, adjusting endTime to (startTime + 0.25)');
                                            endTime = startTime + 0.25;
                                        }
                                        for(var j = 0; j < frames.length; j++){
                                            var frame = frames[j]; // Safari doesn't put the timestamp frame in the TextTrack
                                            if (!id3["default"].isTimeStampFrame(frame)) {
                                                var cue = new Cue(startTime, endTime, '');
                                                cue.value = frame;
                                                this.id3Track.addCue(cue);
                                            }
                                        }
                                    }
                                }
                            };
                            _proto.onLiveBackBufferReached = function onLiveBackBufferReached(_ref) {
                                var bufferEnd = _ref.bufferEnd;
                                var id3Track = this.id3Track;
                                if (!id3Track || !id3Track.cues || !id3Track.cues.length) return;
                                var foundCue = getClosestCue(id3Track.cues, bufferEnd);
                                if (!foundCue) return;
                                while(id3Track.cues[0] !== foundCue)id3Track.removeCue(id3Track.cues[0]);
                            };
                            return ID3TrackController;
                        }(event_handler);
                        /* harmony default export */ var id3_track_controller = id3_track_controller_ID3TrackController;
                        // CONCATENATED MODULE: ./src/is-supported.ts
                        function is_supported_isSupported() {
                            var mediaSource = getMediaSource();
                            if (!mediaSource) return false;
                            var sourceBuffer = self.SourceBuffer || self.WebKitSourceBuffer;
                            var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'); // if SourceBuffer is exposed ensure its API is valid
                            // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
                            var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
                            return !!isTypeSupported && !!sourceBufferValidAPI;
                        }
                        // CONCATENATED MODULE: ./src/utils/ewma.ts
                        /*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */ var EWMA = /*#__PURE__*/ function() {
                            //  About half of the estimated value will be from the last |halfLife| samples by weight.
                            function EWMA(halfLife) {
                                this.alpha_ = void 0;
                                this.estimate_ = void 0;
                                this.totalWeight_ = void 0;
                                // Larger values of alpha expire historical data more slowly.
                                this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
                                this.estimate_ = 0;
                                this.totalWeight_ = 0;
                            }
                            var _proto = EWMA.prototype;
                            _proto.sample = function sample(weight, value) {
                                var adjAlpha = Math.pow(this.alpha_, weight);
                                this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
                                this.totalWeight_ += weight;
                            };
                            _proto.getTotalWeight = function getTotalWeight() {
                                return this.totalWeight_;
                            };
                            _proto.getEstimate = function getEstimate() {
                                if (this.alpha_) {
                                    var zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
                                    return this.estimate_ / zeroFactor;
                                } else return this.estimate_;
                            };
                            return EWMA;
                        }();
                        /* harmony default export */ var ewma = EWMA;
                        // CONCATENATED MODULE: ./src/utils/ewma-bandwidth-estimator.ts
                        /*
 * EWMA Bandwidth Estimator
 *  - heavily inspired from shaka-player
 * Tracks bandwidth samples and estimates available bandwidth.
 * Based on the minimum of two exponentially-weighted moving averages with
 * different half-lives.
 */ var ewma_bandwidth_estimator_EwmaBandWidthEstimator = /*#__PURE__*/ function() {
                            // TODO(typescript-hls)
                            function EwmaBandWidthEstimator(hls, slow, fast, defaultEstimate) {
                                this.hls = void 0;
                                this.defaultEstimate_ = void 0;
                                this.minWeight_ = void 0;
                                this.minDelayMs_ = void 0;
                                this.slow_ = void 0;
                                this.fast_ = void 0;
                                this.hls = hls;
                                this.defaultEstimate_ = defaultEstimate;
                                this.minWeight_ = 0.001;
                                this.minDelayMs_ = 50;
                                this.slow_ = new ewma(slow);
                                this.fast_ = new ewma(fast);
                            }
                            var _proto = EwmaBandWidthEstimator.prototype;
                            _proto.sample = function sample(durationMs, numBytes) {
                                durationMs = Math.max(durationMs, this.minDelayMs_);
                                var numBits = 8 * numBytes, // weight is duration in seconds
                                durationS = durationMs / 1000, // value is bandwidth in bits/s
                                bandwidthInBps = numBits / durationS;
                                this.fast_.sample(durationS, bandwidthInBps);
                                this.slow_.sample(durationS, bandwidthInBps);
                            };
                            _proto.canEstimate = function canEstimate() {
                                var fast = this.fast_;
                                return fast && fast.getTotalWeight() >= this.minWeight_;
                            };
                            _proto.getEstimate = function getEstimate() {
                                if (this.canEstimate()) // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
                                // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
                                // Take the minimum of these two estimates.  This should have the effect of
                                // adapting down quickly, but up more slowly.
                                return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
                                else return this.defaultEstimate_;
                            };
                            _proto.destroy = function destroy() {};
                            return EwmaBandWidthEstimator;
                        }();
                        /* harmony default export */ var ewma_bandwidth_estimator = ewma_bandwidth_estimator_EwmaBandWidthEstimator;
                        // CONCATENATED MODULE: ./src/controller/abr-controller.js
                        function abr_controller_defineProperties(target, props) {
                            for(var i = 0; i < props.length; i++){
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function abr_controller_createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) abr_controller_defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) abr_controller_defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        function abr_controller_assertThisInitialized(self1) {
                            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return self1;
                        }
                        function abr_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /*
 * simple ABR Controller
 *  - compute next level based on last fragment bw heuristics
 *  - implement an abandon rules triggered if we have less than 2 frag buffered and if computed bw shows that we risk buffer stalling
 */ var abr_controller_window = window, abr_controller_performance = abr_controller_window.performance;
                        var abr_controller_AbrController = /*#__PURE__*/ function(_EventHandler) {
                            abr_controller_inheritsLoose(AbrController, _EventHandler);
                            function AbrController(hls) {
                                var _this;
                                _this = _EventHandler.call(this, hls, events["default"].FRAG_LOADING, events["default"].FRAG_LOADED, events["default"].FRAG_BUFFERED, events["default"].ERROR) || this;
                                _this.lastLoadedFragLevel = 0;
                                _this._nextAutoLevel = -1;
                                _this.hls = hls;
                                _this.timer = null;
                                _this._bwEstimator = null;
                                _this.onCheck = _this._abandonRulesCheck.bind(abr_controller_assertThisInitialized(_this));
                                return _this;
                            }
                            var _proto = AbrController.prototype;
                            _proto.destroy = function destroy() {
                                this.clearTimer();
                                event_handler.prototype.destroy.call(this);
                            };
                            _proto.onFragLoading = function onFragLoading(data) {
                                var frag = data.frag;
                                if (frag.type === 'main') {
                                    if (!this.timer) {
                                        this.fragCurrent = frag;
                                        this.timer = setInterval(this.onCheck, 100);
                                    } // lazy init of BwEstimator, rationale is that we use different params for Live/VoD
                                    // so we need to wait for stream manifest / playlist type to instantiate it.
                                    if (!this._bwEstimator) {
                                        var hls = this.hls;
                                        var config = hls.config;
                                        var level = frag.level;
                                        var isLive = hls.levels[level].details.live;
                                        var ewmaFast;
                                        var ewmaSlow;
                                        if (isLive) {
                                            ewmaFast = config.abrEwmaFastLive;
                                            ewmaSlow = config.abrEwmaSlowLive;
                                        } else {
                                            ewmaFast = config.abrEwmaFastVoD;
                                            ewmaSlow = config.abrEwmaSlowVoD;
                                        }
                                        this._bwEstimator = new ewma_bandwidth_estimator(hls, ewmaSlow, ewmaFast, config.abrEwmaDefaultEstimate);
                                    }
                                }
                            };
                            _proto._abandonRulesCheck = function _abandonRulesCheck() {
                                /*
      monitor fragment retrieval time...
      we compute expected time of arrival of the complete fragment.
      we compare it to expected time of buffer starvation
    */ var hls = this.hls;
                                var video = hls.media;
                                var frag = this.fragCurrent;
                                if (!frag) return;
                                var loader = frag.loader;
                                var minAutoLevel = hls.minAutoLevel; // if loader has been destroyed or loading has been aborted, stop timer and return
                                if (!loader || loader.stats && loader.stats.aborted) {
                                    logger["logger"].warn('frag loader destroy or aborted, disarm abandonRules');
                                    this.clearTimer(); // reset forced auto level value so that next level will be selected
                                    this._nextAutoLevel = -1;
                                    return;
                                }
                                var stats = loader.stats;
                                /* only monitor frag retrieval time if
    (video not paused OR first fragment being loaded(ready state === HAVE_NOTHING = 0)) AND autoswitching enabled AND not lowest level (=> means that we have several levels) */ if (video && stats && (!video.paused && video.playbackRate !== 0 || !video.readyState) && frag.autoLevel && frag.level) {
                                    var requestDelay = abr_controller_performance.now() - stats.trequest;
                                    var playbackRate = Math.abs(video.playbackRate); // monitor fragment load progress after half of expected fragment duration,to stabilize bitrate
                                    if (requestDelay > 500 * frag.duration / playbackRate) {
                                        var levels = hls.levels;
                                        var loadRate = Math.max(1, stats.bw ? stats.bw / 8 : stats.loaded * 1000 / requestDelay); // byte/s; at least 1 byte/s to avoid division by zero
                                        // compute expected fragment length using frag duration and level bitrate. also ensure that expected len is gte than already loaded size
                                        var level = levels[frag.level];
                                        var levelBitrate = level.realBitrate ? Math.max(level.realBitrate, level.bitrate) : level.bitrate;
                                        var expectedLen = stats.total ? stats.total : Math.max(stats.loaded, Math.round(frag.duration * levelBitrate / 8));
                                        var pos = video.currentTime;
                                        var fragLoadedDelay = (expectedLen - stats.loaded) / loadRate;
                                        var bufferStarvationDelay = (BufferHelper.bufferInfo(video, pos, hls.config.maxBufferHole).end - pos) / playbackRate; // consider emergency switch down only if we have less than 2 frag buffered AND
                                        // time to finish loading current fragment is bigger than buffer starvation delay
                                        // ie if we risk buffer starvation if bw does not increase quickly
                                        if (bufferStarvationDelay < 2 * frag.duration / playbackRate && fragLoadedDelay > bufferStarvationDelay) {
                                            var fragLevelNextLoadedDelay;
                                            var nextLoadLevel; // lets iterate through lower level and try to find the biggest one that could avoid rebuffering
                                            // we start from current level - 1 and we step down , until we find a matching level
                                            for(nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--){
                                                // compute time to load next fragment at lower level
                                                // 0.8 : consider only 80% of current bw to be conservative
                                                // 8 = bits per byte (bps/Bps)
                                                var levelNextBitrate = levels[nextLoadLevel].realBitrate ? Math.max(levels[nextLoadLevel].realBitrate, levels[nextLoadLevel].bitrate) : levels[nextLoadLevel].bitrate;
                                                var _fragLevelNextLoadedDelay = frag.duration * levelNextBitrate / (6.4 * loadRate);
                                                if (_fragLevelNextLoadedDelay < bufferStarvationDelay) break;
                                            } // only emergency switch down if it takes less time to load new fragment at lowest level instead
                                            // of finishing loading current one ...
                                            if (fragLevelNextLoadedDelay < fragLoadedDelay) {
                                                logger["logger"].warn("loading too slow, abort fragment loading and switch to level " + nextLoadLevel + ":fragLoadedDelay[" + nextLoadLevel + "]<fragLoadedDelay[" + (frag.level - 1) + "];bufferStarvationDelay:" + fragLevelNextLoadedDelay.toFixed(1) + "<" + fragLoadedDelay.toFixed(1) + ":" + bufferStarvationDelay.toFixed(1)); // force next load level in auto mode
                                                hls.nextLoadLevel = nextLoadLevel; // update bw estimate for this fragment before cancelling load (this will help reducing the bw)
                                                this._bwEstimator.sample(requestDelay, stats.loaded); // abort fragment loading
                                                loader.abort(); // stop abandon rules timer
                                                this.clearTimer();
                                                hls.trigger(events["default"].FRAG_LOAD_EMERGENCY_ABORTED, {
                                                    frag: frag,
                                                    stats: stats
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                            _proto.onFragLoaded = function onFragLoaded(data) {
                                var frag = data.frag;
                                if (frag.type === 'main' && Object(number_isFinite["isFiniteNumber"])(frag.sn)) {
                                    // stop monitoring bw once frag loaded
                                    this.clearTimer(); // store level id after successful fragment load
                                    this.lastLoadedFragLevel = frag.level; // reset forced auto level value so that next level will be selected
                                    this._nextAutoLevel = -1; // compute level average bitrate
                                    if (this.hls.config.abrMaxWithRealBitrate) {
                                        var level = this.hls.levels[frag.level];
                                        var loadedBytes = (level.loaded ? level.loaded.bytes : 0) + data.stats.loaded;
                                        var loadedDuration = (level.loaded ? level.loaded.duration : 0) + data.frag.duration;
                                        level.loaded = {
                                            bytes: loadedBytes,
                                            duration: loadedDuration
                                        };
                                        level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
                                    } // if fragment has been loaded to perform a bitrate test,
                                    if (data.frag.bitrateTest) {
                                        var stats = data.stats;
                                        stats.tparsed = stats.tbuffered = stats.tload;
                                        this.onFragBuffered(data);
                                    }
                                }
                            };
                            _proto.onFragBuffered = function onFragBuffered(data) {
                                var stats = data.stats;
                                var frag = data.frag; // only update stats on first frag buffering
                                // if same frag is loaded multiple times, it might be in browser cache, and loaded quickly
                                // and leading to wrong bw estimation
                                // on bitrate test, also only update stats once (if tload = tbuffered == on FRAG_LOADED)
                                if (stats.aborted !== true && frag.type === 'main' && Object(number_isFinite["isFiniteNumber"])(frag.sn) && (!frag.bitrateTest || stats.tload === stats.tbuffered)) {
                                    // use tparsed-trequest instead of tbuffered-trequest to compute fragLoadingProcessing; rationale is that  buffer appending only happens once media is attached
                                    // in case we use config.startFragPrefetch while media is not attached yet, fragment might be parsed while media not attached yet, but it will only be buffered on media attached
                                    // as a consequence it could happen really late in the process. meaning that appending duration might appears huge ... leading to underestimated throughput estimation
                                    var fragLoadingProcessingMs = stats.tparsed - stats.trequest;
                                    logger["logger"].log("latency/loading/parsing/append/kbps:" + Math.round(stats.tfirst - stats.trequest) + "/" + Math.round(stats.tload - stats.tfirst) + "/" + Math.round(stats.tparsed - stats.tload) + "/" + Math.round(stats.tbuffered - stats.tparsed) + "/" + Math.round(8 * stats.loaded / (stats.tbuffered - stats.trequest)));
                                    this._bwEstimator.sample(fragLoadingProcessingMs, stats.loaded);
                                    stats.bwEstimate = this._bwEstimator.getEstimate(); // if fragment has been loaded to perform a bitrate test, (hls.startLevel = -1), store bitrate test delay duration
                                    if (frag.bitrateTest) this.bitrateTestDelay = fragLoadingProcessingMs / 1000;
                                    else this.bitrateTestDelay = 0;
                                }
                            };
                            _proto.onError = function onError(data) {
                                // stop timer in case of frag loading error
                                switch(data.details){
                                    case errors["ErrorDetails"].FRAG_LOAD_ERROR:
                                    case errors["ErrorDetails"].FRAG_LOAD_TIMEOUT:
                                        this.clearTimer();
                                        break;
                                    default:
                                        break;
                                }
                            };
                            _proto.clearTimer = function clearTimer() {
                                clearInterval(this.timer);
                                this.timer = null;
                            } // return next auto level
                            ;
                            _proto._findBestLevel = function _findBestLevel(currentLevel, currentFragDuration, currentBw, minAutoLevel, maxAutoLevel, maxFetchDuration, bwFactor, bwUpFactor, levels) {
                                for(var i = maxAutoLevel; i >= minAutoLevel; i--){
                                    var levelInfo = levels[i];
                                    if (!levelInfo) continue;
                                    var levelDetails = levelInfo.details;
                                    var avgDuration = levelDetails ? levelDetails.totalduration / levelDetails.fragments.length : currentFragDuration;
                                    var live = levelDetails ? levelDetails.live : false;
                                    var adjustedbw = void 0; // follow algorithm captured from stagefright :
                                    // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
                                    // Pick the highest bandwidth stream below or equal to estimated bandwidth.
                                    // consider only 80% of the available bandwidth, but if we are switching up,
                                    // be even more conservative (70%) to avoid overestimating and immediately
                                    // switching back.
                                    if (i <= currentLevel) adjustedbw = bwFactor * currentBw;
                                    else adjustedbw = bwUpFactor * currentBw;
                                    var bitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate;
                                    var fetchDuration = bitrate * avgDuration / adjustedbw;
                                    logger["logger"].trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: " + i + "/" + Math.round(adjustedbw) + "/" + bitrate + "/" + avgDuration + "/" + maxFetchDuration + "/" + fetchDuration); // if adjusted bw is greater than level bitrate AND
                                    if (adjustedbw > bitrate && // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
                                    // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that _findBestLevel will return -1
                                    (!fetchDuration || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration)) // as we are looping from highest to lowest, this will return the best achievable quality level
                                    return i;
                                } // not enough time budget even with quality level 0 ... rebuffering might happen
                                return -1;
                            };
                            abr_controller_createClass(AbrController, [
                                {
                                    key: "nextAutoLevel",
                                    get: function get() {
                                        var forcedAutoLevel = this._nextAutoLevel;
                                        var bwEstimator = this._bwEstimator; // in case next auto level has been forced, and bw not available or not reliable, return forced value
                                        if (forcedAutoLevel !== -1 && (!bwEstimator || !bwEstimator.canEstimate())) return forcedAutoLevel;
                                         // compute next level using ABR logic
                                        var nextABRAutoLevel = this._nextABRAutoLevel; // if forced auto level has been defined, use it to cap ABR computed quality level
                                        if (forcedAutoLevel !== -1) nextABRAutoLevel = Math.min(forcedAutoLevel, nextABRAutoLevel);
                                        return nextABRAutoLevel;
                                    },
                                    set: function set(nextLevel) {
                                        this._nextAutoLevel = nextLevel;
                                    }
                                },
                                {
                                    key: "_nextABRAutoLevel",
                                    get: function get() {
                                        var hls = this.hls;
                                        var maxAutoLevel = hls.maxAutoLevel, levels = hls.levels, config = hls.config, minAutoLevel = hls.minAutoLevel;
                                        var video = hls.media;
                                        var currentLevel = this.lastLoadedFragLevel;
                                        var currentFragDuration = this.fragCurrent ? this.fragCurrent.duration : 0;
                                        var pos = video ? video.currentTime : 0; // playbackRate is the absolute value of the playback rate; if video.playbackRate is 0, we use 1 to load as
                                        // if we're playing back at the normal rate.
                                        var playbackRate = video && video.playbackRate !== 0 ? Math.abs(video.playbackRate) : 1.0;
                                        var avgbw = this._bwEstimator ? this._bwEstimator.getEstimate() : config.abrEwmaDefaultEstimate; // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
                                        var bufferStarvationDelay = (BufferHelper.bufferInfo(video, pos, config.maxBufferHole).end - pos) / playbackRate; // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
                                        var bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, config.abrBandWidthFactor, config.abrBandWidthUpFactor, levels);
                                        if (bestLevel >= 0) return bestLevel;
                                        else {
                                            logger["logger"].trace('rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering'); // not possible to get rid of rebuffering ... let's try to find level that will guarantee less than maxStarvationDelay of rebuffering
                                            // if no matching level found, logic will return 0
                                            var maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay;
                                            var bwFactor = config.abrBandWidthFactor;
                                            var bwUpFactor = config.abrBandWidthUpFactor;
                                            if (bufferStarvationDelay === 0) {
                                                // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
                                                var bitrateTestDelay = this.bitrateTestDelay;
                                                if (bitrateTestDelay) {
                                                    // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
                                                    // max video loading delay used in  automatic start level selection :
                                                    // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
                                                    // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
                                                    // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
                                                    var maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
                                                    maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
                                                    logger["logger"].trace("bitrate test took " + Math.round(1000 * bitrateTestDelay) + "ms, set first fragment max fetchDuration to " + Math.round(1000 * maxStarvationDelay) + " ms"); // don't use conservative factor on bitrate test
                                                    bwFactor = bwUpFactor = 1;
                                                }
                                            }
                                            bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay + maxStarvationDelay, bwFactor, bwUpFactor, levels);
                                            return Math.max(bestLevel, 0);
                                        }
                                    }
                                }
                            ]);
                            return AbrController;
                        }(event_handler);
                        /* harmony default export */ var abr_controller = abr_controller_AbrController;
                        // CONCATENATED MODULE: ./src/controller/buffer-controller.ts
                        function buffer_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /*
 * Buffer Controller
 */ var buffer_controller_MediaSource = getMediaSource();
                        var buffer_controller_BufferController = /*#__PURE__*/ function(_EventHandler) {
                            buffer_controller_inheritsLoose(BufferController, _EventHandler);
                            // the value that we have set mediasource.duration to
                            // (the actual duration may be tweaked slighly by the browser)
                            // the value that we want to set mediaSource.duration to
                            // the target duration of the current media playlist
                            // current stream state: true - for live broadcast, false - for VoD content
                            // cache the self generated object url to detect hijack of video tag
                            // signals that the sourceBuffers need to be flushed
                            // signals that mediaSource should have endOfStream called
                            // this is optional because this property is removed from the class sometimes
                            // The number of BUFFER_CODEC events received before any sourceBuffers are created
                            // The total number of BUFFER_CODEC events received
                            // A reference to the attached media element
                            // A reference to the active media source
                            // List of pending segments to be appended to source buffer
                            // A guard to see if we are currently appending to the source buffer
                            // counters
                            function BufferController(hls) {
                                var _this;
                                _this = _EventHandler.call(this, hls, events["default"].MEDIA_ATTACHING, events["default"].MEDIA_DETACHING, events["default"].MANIFEST_PARSED, events["default"].BUFFER_RESET, events["default"].BUFFER_APPENDING, events["default"].BUFFER_CODECS, events["default"].BUFFER_EOS, events["default"].BUFFER_FLUSHING, events["default"].LEVEL_PTS_UPDATED, events["default"].LEVEL_UPDATED) || this;
                                _this._msDuration = null;
                                _this._levelDuration = null;
                                _this._levelTargetDuration = 10;
                                _this._live = null;
                                _this._objectUrl = null;
                                _this._needsFlush = false;
                                _this._needsEos = false;
                                _this.config = void 0;
                                _this.audioTimestampOffset = void 0;
                                _this.bufferCodecEventsExpected = 0;
                                _this._bufferCodecEventsTotal = 0;
                                _this.media = null;
                                _this.mediaSource = null;
                                _this.segments = [];
                                _this.parent = void 0;
                                _this.appending = false;
                                _this.appended = 0;
                                _this.appendError = 0;
                                _this.flushBufferCounter = 0;
                                _this.tracks = {};
                                _this.pendingTracks = {};
                                _this.sourceBuffer = {};
                                _this.flushRange = [];
                                _this._onMediaSourceOpen = function() {
                                    logger["logger"].log('media source opened');
                                    _this.hls.trigger(events["default"].MEDIA_ATTACHED, {
                                        media: _this.media
                                    });
                                    var mediaSource = _this.mediaSource;
                                    if (mediaSource) // once received, don't listen anymore to sourceopen event
                                    mediaSource.removeEventListener('sourceopen', _this._onMediaSourceOpen);
                                    _this.checkPendingTracks();
                                };
                                _this._onMediaSourceClose = function() {
                                    logger["logger"].log('media source closed');
                                };
                                _this._onMediaSourceEnded = function() {
                                    logger["logger"].log('media source ended');
                                };
                                _this._onSBUpdateEnd = function() {
                                    // update timestampOffset
                                    if (_this.audioTimestampOffset && _this.sourceBuffer.audio) {
                                        var audioBuffer = _this.sourceBuffer.audio;
                                        logger["logger"].warn("change mpeg audio timestamp offset from " + audioBuffer.timestampOffset + " to " + _this.audioTimestampOffset);
                                        audioBuffer.timestampOffset = _this.audioTimestampOffset;
                                        delete _this.audioTimestampOffset;
                                    }
                                    if (_this._needsFlush) _this.doFlush();
                                    if (_this._needsEos) _this.checkEos();
                                    _this.appending = false;
                                    var parent = _this.parent; // count nb of pending segments waiting for appending on this sourcebuffer
                                    var pending = _this.segments.reduce(function(counter, segment) {
                                        return segment.parent === parent ? counter + 1 : counter;
                                    }, 0); // this.sourceBuffer is better to use than media.buffered as it is closer to the PTS data from the fragments
                                    var timeRanges = {};
                                    var sbSet = _this.sourceBuffer;
                                    for(var streamType in sbSet){
                                        var sb = sbSet[streamType];
                                        if (!sb) throw Error("handling source buffer update end error: source buffer for " + streamType + " uninitilized and unable to update buffered TimeRanges.");
                                        timeRanges[streamType] = sb.buffered;
                                    }
                                    _this.hls.trigger(events["default"].BUFFER_APPENDED, {
                                        parent: parent,
                                        pending: pending,
                                        timeRanges: timeRanges
                                    }); // don't append in flushing mode
                                    if (!_this._needsFlush) _this.doAppending();
                                    _this.updateMediaElementDuration(); // appending goes first
                                    if (pending === 0) _this.flushLiveBackBuffer();
                                };
                                _this._onSBUpdateError = function(event) {
                                    logger["logger"].error('sourceBuffer error:', event); // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
                                    // this error might not always be fatal (it is fatal if decode error is set, in that case
                                    // it will be followed by a mediaElement error ...)
                                    _this.hls.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].MEDIA_ERROR,
                                        details: errors["ErrorDetails"].BUFFER_APPENDING_ERROR,
                                        fatal: false
                                    }); // we don't need to do more than that, as accordin to the spec, updateend will be fired just after
                                };
                                _this.config = hls.config;
                                return _this;
                            }
                            var _proto = BufferController.prototype;
                            _proto.destroy = function destroy() {
                                event_handler.prototype.destroy.call(this);
                            };
                            _proto.onLevelPtsUpdated = function onLevelPtsUpdated(data) {
                                var type = data.type;
                                var audioTrack = this.tracks.audio; // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
                                // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
                                // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos). At the time of change we issue
                                // `SourceBuffer.abort()` and adjusting `SourceBuffer.timestampOffset` if `SourceBuffer.updating` is false or awaiting `updateend`
                                // event if SB is in updating state.
                                // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
                                if (type === 'audio' && audioTrack && audioTrack.container === 'audio/mpeg') {
                                    // Chrome audio mp3 track
                                    var audioBuffer = this.sourceBuffer.audio;
                                    if (!audioBuffer) throw Error('Level PTS Updated and source buffer for audio uninitalized');
                                    var delta = Math.abs(audioBuffer.timestampOffset - data.start); // adjust timestamp offset if time delta is greater than 100ms
                                    if (delta > 0.1) {
                                        var updating = audioBuffer.updating;
                                        try {
                                            audioBuffer.abort();
                                        } catch (err) {
                                            logger["logger"].warn('can not abort audio buffer: ' + err);
                                        }
                                        if (!updating) {
                                            logger["logger"].warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + data.start);
                                            audioBuffer.timestampOffset = data.start;
                                        } else this.audioTimestampOffset = data.start;
                                    }
                                }
                            };
                            _proto.onManifestParsed = function onManifestParsed(data) {
                                // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
                                // sourcebuffers will be created all at once when the expected nb of tracks will be reached
                                // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
                                // it will contain the expected nb of source buffers, no need to compute it
                                this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = data.altAudio ? 2 : 1;
                                logger["logger"].log(this.bufferCodecEventsExpected + " bufferCodec event(s) expected");
                            };
                            _proto.onMediaAttaching = function onMediaAttaching(data) {
                                var media = this.media = data.media;
                                if (media && buffer_controller_MediaSource) {
                                    // setup the media source
                                    var ms = this.mediaSource = new buffer_controller_MediaSource(); // Media Source listeners
                                    ms.addEventListener('sourceopen', this._onMediaSourceOpen);
                                    ms.addEventListener('sourceended', this._onMediaSourceEnded);
                                    ms.addEventListener('sourceclose', this._onMediaSourceClose); // link video and media Source
                                    media.src = window.URL.createObjectURL(ms); // cache the locally generated object url
                                    this._objectUrl = media.src;
                                }
                            };
                            _proto.onMediaDetaching = function onMediaDetaching() {
                                logger["logger"].log('media source detaching');
                                var ms = this.mediaSource;
                                if (ms) {
                                    if (ms.readyState === 'open') try {
                                        // endOfStream could trigger exception if any sourcebuffer is in updating state
                                        // we don't really care about checking sourcebuffer state here,
                                        // as we are anyway detaching the MediaSource
                                        // let's just avoid this exception to propagate
                                        ms.endOfStream();
                                    } catch (err) {
                                        logger["logger"].warn("onMediaDetaching:" + err.message + " while calling endOfStream");
                                    }
                                    ms.removeEventListener('sourceopen', this._onMediaSourceOpen);
                                    ms.removeEventListener('sourceended', this._onMediaSourceEnded);
                                    ms.removeEventListener('sourceclose', this._onMediaSourceClose); // Detach properly the MediaSource from the HTMLMediaElement as
                                    // suggested in https://github.com/w3c/media-source/issues/53.
                                    if (this.media) {
                                        if (this._objectUrl) window.URL.revokeObjectURL(this._objectUrl);
                                         // clean up video tag src only if it's our own url. some external libraries might
                                        // hijack the video tag and change its 'src' without destroying the Hls instance first
                                        if (this.media.src === this._objectUrl) {
                                            this.media.removeAttribute('src');
                                            this.media.load();
                                        } else logger["logger"].warn('media.src was changed by a third party - skip cleanup');
                                    }
                                    this.mediaSource = null;
                                    this.media = null;
                                    this._objectUrl = null;
                                    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal;
                                    this.pendingTracks = {};
                                    this.tracks = {};
                                    this.sourceBuffer = {};
                                    this.flushRange = [];
                                    this.segments = [];
                                    this.appended = 0;
                                }
                                this.hls.trigger(events["default"].MEDIA_DETACHED);
                            };
                            _proto.checkPendingTracks = function checkPendingTracks() {
                                var bufferCodecEventsExpected = this.bufferCodecEventsExpected, pendingTracks = this.pendingTracks; // Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
                                // This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
                                // data has been appended to existing ones.
                                // 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
                                var pendingTracksCount = Object.keys(pendingTracks).length;
                                if (pendingTracksCount && !bufferCodecEventsExpected || pendingTracksCount === 2) {
                                    // ok, let's create them now !
                                    this.createSourceBuffers(pendingTracks);
                                    this.pendingTracks = {}; // append any pending segments now !
                                    this.doAppending();
                                }
                            };
                            _proto.onBufferReset = function onBufferReset() {
                                var sourceBuffer = this.sourceBuffer;
                                for(var type in sourceBuffer){
                                    var sb = sourceBuffer[type];
                                    try {
                                        if (sb) {
                                            if (this.mediaSource) this.mediaSource.removeSourceBuffer(sb);
                                            sb.removeEventListener('updateend', this._onSBUpdateEnd);
                                            sb.removeEventListener('error', this._onSBUpdateError);
                                        }
                                    } catch (err) {}
                                }
                                this.sourceBuffer = {};
                                this.flushRange = [];
                                this.segments = [];
                                this.appended = 0;
                            };
                            _proto.onBufferCodecs = function onBufferCodecs(tracks) {
                                var _this2 = this;
                                // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
                                // if sourcebuffers already created, do nothing ...
                                if (Object.keys(this.sourceBuffer).length) return;
                                Object.keys(tracks).forEach(function(trackName) {
                                    _this2.pendingTracks[trackName] = tracks[trackName];
                                });
                                this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0);
                                if (this.mediaSource && this.mediaSource.readyState === 'open') this.checkPendingTracks();
                            };
                            _proto.createSourceBuffers = function createSourceBuffers(tracks) {
                                var sourceBuffer = this.sourceBuffer, mediaSource = this.mediaSource;
                                if (!mediaSource) throw Error('createSourceBuffers called when mediaSource was null');
                                for(var trackName in tracks)if (!sourceBuffer[trackName]) {
                                    var track = tracks[trackName];
                                    if (!track) throw Error("source buffer exists for track " + trackName + ", however track does not");
                                     // use levelCodec as first priority
                                    var codec = track.levelCodec || track.codec;
                                    var mimeType = track.container + ";codecs=" + codec;
                                    logger["logger"].log("creating sourceBuffer(" + mimeType + ")");
                                    try {
                                        var sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
                                        sb.addEventListener('updateend', this._onSBUpdateEnd);
                                        sb.addEventListener('error', this._onSBUpdateError);
                                        this.tracks[trackName] = {
                                            buffer: sb,
                                            codec: codec,
                                            id: track.id,
                                            container: track.container,
                                            levelCodec: track.levelCodec
                                        };
                                    } catch (err) {
                                        logger["logger"].error("error while trying to add sourceBuffer:" + err.message);
                                        this.hls.trigger(events["default"].ERROR, {
                                            type: errors["ErrorTypes"].MEDIA_ERROR,
                                            details: errors["ErrorDetails"].BUFFER_ADD_CODEC_ERROR,
                                            fatal: false,
                                            err: err,
                                            mimeType: mimeType
                                        });
                                    }
                                }
                                this.hls.trigger(events["default"].BUFFER_CREATED, {
                                    tracks: this.tracks
                                });
                            };
                            _proto.onBufferAppending = function onBufferAppending(data) {
                                if (!this._needsFlush) {
                                    if (!this.segments) this.segments = [
                                        data
                                    ];
                                    else this.segments.push(data);
                                    this.doAppending();
                                }
                            } // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
                            ;
                            _proto.onBufferEos = function onBufferEos(data) {
                                for(var type in this.sourceBuffer)if (!data.type || data.type === type) {
                                    var sb = this.sourceBuffer[type];
                                    if (sb && !sb.ended) {
                                        sb.ended = true;
                                        logger["logger"].log(type + " sourceBuffer now EOS");
                                    }
                                }
                                this.checkEos();
                            } // if all source buffers are marked as ended, signal endOfStream() to MediaSource.
                            ;
                            _proto.checkEos = function checkEos() {
                                var sourceBuffer = this.sourceBuffer, mediaSource = this.mediaSource;
                                if (!mediaSource || mediaSource.readyState !== 'open') {
                                    this._needsEos = false;
                                    return;
                                }
                                for(var type in sourceBuffer){
                                    var sb = sourceBuffer[type];
                                    if (!sb) continue;
                                    if (!sb.ended) return;
                                    if (sb.updating) {
                                        this._needsEos = true;
                                        return;
                                    }
                                }
                                logger["logger"].log('all media data are available, signal endOfStream() to MediaSource and stop loading fragment'); // Notify the media element that it now has all of the media data
                                try {
                                    mediaSource.endOfStream();
                                } catch (e) {
                                    logger["logger"].warn('exception while calling mediaSource.endOfStream()');
                                }
                                this._needsEos = false;
                            };
                            _proto.onBufferFlushing = function onBufferFlushing(data) {
                                if (data.type) this.flushRange.push({
                                    start: data.startOffset,
                                    end: data.endOffset,
                                    type: data.type
                                });
                                else {
                                    this.flushRange.push({
                                        start: data.startOffset,
                                        end: data.endOffset,
                                        type: 'video'
                                    });
                                    this.flushRange.push({
                                        start: data.startOffset,
                                        end: data.endOffset,
                                        type: 'audio'
                                    });
                                } // attempt flush immediately
                                this.flushBufferCounter = 0;
                                this.doFlush();
                            };
                            _proto.flushLiveBackBuffer = function flushLiveBackBuffer() {
                                // clear back buffer for live only
                                if (!this._live) return;
                                var liveBackBufferLength = this.config.liveBackBufferLength;
                                if (!isFinite(liveBackBufferLength) || liveBackBufferLength < 0) return;
                                if (!this.media) {
                                    logger["logger"].error('flushLiveBackBuffer called without attaching media');
                                    return;
                                }
                                var currentTime = this.media.currentTime;
                                var sourceBuffer = this.sourceBuffer;
                                var bufferTypes = Object.keys(sourceBuffer);
                                var targetBackBufferPosition = currentTime - Math.max(liveBackBufferLength, this._levelTargetDuration);
                                for(var index = bufferTypes.length - 1; index >= 0; index--){
                                    var bufferType = bufferTypes[index];
                                    var sb = sourceBuffer[bufferType];
                                    if (sb) {
                                        var buffered = sb.buffered; // when target buffer start exceeds actual buffer start
                                        if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) // remove buffer up until current time minus minimum back buffer length (removing buffer too close to current
                                        // time will lead to playback freezing)
                                        // credits for level target duration - https://github.com/videojs/http-streaming/blob/3132933b6aa99ddefab29c10447624efd6fd6e52/src/segment-loader.js#L91
                                        {
                                            if (this.removeBufferRange(bufferType, sb, 0, targetBackBufferPosition)) this.hls.trigger(events["default"].LIVE_BACK_BUFFER_REACHED, {
                                                bufferEnd: targetBackBufferPosition
                                            });
                                        }
                                    }
                                }
                            };
                            _proto.onLevelUpdated = function onLevelUpdated(_ref) {
                                var details = _ref.details;
                                if (details.fragments.length > 0) {
                                    this._levelDuration = details.totalduration + details.fragments[0].start;
                                    this._levelTargetDuration = details.averagetargetduration || details.targetduration || 10;
                                    this._live = details.live;
                                    this.updateMediaElementDuration();
                                }
                            };
                            _proto.updateMediaElementDuration = function updateMediaElementDuration() {
                                var config = this.config;
                                var duration;
                                if (this._levelDuration === null || !this.media || !this.mediaSource || !this.sourceBuffer || this.media.readyState === 0 || this.mediaSource.readyState !== 'open') return;
                                for(var type in this.sourceBuffer){
                                    var sb = this.sourceBuffer[type];
                                    if (sb && sb.updating === true) // can't set duration whilst a buffer is updating
                                    return;
                                }
                                duration = this.media.duration; // initialise to the value that the media source is reporting
                                if (this._msDuration === null) this._msDuration = this.mediaSource.duration;
                                if (this._live === true && config.liveDurationInfinity === true) {
                                    // Override duration to Infinity
                                    logger["logger"].log('Media Source duration is set to Infinity');
                                    this._msDuration = this.mediaSource.duration = Infinity;
                                } else if (this._levelDuration > this._msDuration && this._levelDuration > duration || !Object(number_isFinite["isFiniteNumber"])(duration)) {
                                    // levelDuration was the last value we set.
                                    // not using mediaSource.duration as the browser may tweak this value
                                    // only update Media Source duration if its value increase, this is to avoid
                                    // flushing already buffered portion when switching between quality level
                                    logger["logger"].log("Updating Media Source duration to " + this._levelDuration.toFixed(3));
                                    this._msDuration = this.mediaSource.duration = this._levelDuration;
                                }
                            };
                            _proto.doFlush = function doFlush() {
                                // loop through all buffer ranges to flush
                                while(this.flushRange.length){
                                    var range = this.flushRange[0]; // flushBuffer will abort any buffer append in progress and flush Audio/Video Buffer
                                    if (this.flushBuffer(range.start, range.end, range.type)) {
                                        // range flushed, remove from flush array
                                        this.flushRange.shift();
                                        this.flushBufferCounter = 0;
                                    } else {
                                        this._needsFlush = true; // avoid looping, wait for SB update end to retrigger a flush
                                        return;
                                    }
                                }
                                if (this.flushRange.length === 0) {
                                    // everything flushed
                                    this._needsFlush = false; // let's recompute this.appended, which is used to avoid flush looping
                                    var appended = 0;
                                    var sourceBuffer = this.sourceBuffer;
                                    try {
                                        for(var type in sourceBuffer){
                                            var sb = sourceBuffer[type];
                                            if (sb) appended += sb.buffered.length;
                                        }
                                    } catch (error) {
                                        // error could be thrown while accessing buffered, in case sourcebuffer has already been removed from MediaSource
                                        // this is harmess at this stage, catch this to avoid reporting an internal exception
                                        logger["logger"].error('error while accessing sourceBuffer.buffered');
                                    }
                                    this.appended = appended;
                                    this.hls.trigger(events["default"].BUFFER_FLUSHED);
                                }
                            };
                            _proto.doAppending = function doAppending() {
                                var config = this.config, hls = this.hls, segments = this.segments, sourceBuffer = this.sourceBuffer;
                                if (!Object.keys(sourceBuffer).length) // early exit if no source buffers have been initialized yet
                                return;
                                if (!this.media || this.media.error) {
                                    this.segments = [];
                                    logger["logger"].error('trying to append although a media error occured, flush segment and abort');
                                    return;
                                }
                                if (this.appending) // logger.log(`sb appending in progress`);
                                return;
                                var segment = segments.shift();
                                if (!segment) // handle undefined shift
                                return;
                                try {
                                    var sb = sourceBuffer[segment.type];
                                    if (!sb) {
                                        // in case we don't have any source buffer matching with this segment type,
                                        // it means that Mediasource fails to create sourcebuffer
                                        // discard this segment, and trigger update end
                                        this._onSBUpdateEnd();
                                        return;
                                    }
                                    if (sb.updating) {
                                        // if we are still updating the source buffer from the last segment, place this back at the front of the queue
                                        segments.unshift(segment);
                                        return;
                                    } // reset sourceBuffer ended flag before appending segment
                                    sb.ended = false; // logger.log(`appending ${segment.content} ${type} SB, size:${segment.data.length}, ${segment.parent}`);
                                    this.parent = segment.parent;
                                    sb.appendBuffer(segment.data);
                                    this.appendError = 0;
                                    this.appended++;
                                    this.appending = true;
                                } catch (err) {
                                    // in case any error occured while appending, put back segment in segments table
                                    logger["logger"].error("error while trying to append buffer:" + err.message);
                                    segments.unshift(segment);
                                    var event = {
                                        type: errors["ErrorTypes"].MEDIA_ERROR,
                                        parent: segment.parent,
                                        details: '',
                                        fatal: false
                                    };
                                    if (err.code === 22) {
                                        // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
                                        // let's stop appending any segments, and report BUFFER_FULL_ERROR error
                                        this.segments = [];
                                        event.details = errors["ErrorDetails"].BUFFER_FULL_ERROR;
                                    } else {
                                        this.appendError++;
                                        event.details = errors["ErrorDetails"].BUFFER_APPEND_ERROR;
                                        /* with UHD content, we could get loop of quota exceeded error until
          browser is able to evict some data from sourcebuffer. retrying help recovering this
        */ if (this.appendError > config.appendErrorMaxRetry) {
                                            logger["logger"].log("fail " + config.appendErrorMaxRetry + " times to append segment in sourceBuffer");
                                            this.segments = [];
                                            event.fatal = true;
                                        }
                                    }
                                    hls.trigger(events["default"].ERROR, event);
                                }
                            };
                            _proto.flushBuffer = function flushBuffer(startOffset, endOffset, sbType) {
                                var sourceBuffer = this.sourceBuffer; // exit if no sourceBuffers are initialized
                                if (!Object.keys(sourceBuffer).length) return true;
                                var currentTime = 'null';
                                if (this.media) currentTime = this.media.currentTime.toFixed(3);
                                logger["logger"].log("flushBuffer,pos/start/end: " + currentTime + "/" + startOffset + "/" + endOffset); // safeguard to avoid infinite looping : don't try to flush more than the nb of appended segments
                                if (this.flushBufferCounter >= this.appended) {
                                    logger["logger"].warn('abort flushing too many retries');
                                    return true;
                                }
                                var sb = sourceBuffer[sbType]; // we are going to flush buffer, mark source buffer as 'not ended'
                                if (sb) {
                                    sb.ended = false;
                                    if (!sb.updating) {
                                        if (this.removeBufferRange(sbType, sb, startOffset, endOffset)) {
                                            this.flushBufferCounter++;
                                            return false;
                                        }
                                    } else {
                                        logger["logger"].warn('cannot flush, sb updating in progress');
                                        return false;
                                    }
                                }
                                logger["logger"].log('buffer flushed'); // everything flushed !
                                return true;
                            };
                            _proto.removeBufferRange = function removeBufferRange(type, sb, startOffset, endOffset) {
                                try {
                                    for(var i = 0; i < sb.buffered.length; i++){
                                        var bufStart = sb.buffered.start(i);
                                        var bufEnd = sb.buffered.end(i);
                                        var removeStart = Math.max(bufStart, startOffset);
                                        var removeEnd = Math.min(bufEnd, endOffset);
                                        /* sometimes sourcebuffer.remove() does not flush
          the exact expected time range.
          to avoid rounding issues/infinite loop,
          only flush buffer range of length greater than 500ms.
        */ if (Math.min(removeEnd, bufEnd) - removeStart > 0.5) {
                                            var currentTime = 'null';
                                            if (this.media) currentTime = this.media.currentTime.toString();
                                            logger["logger"].log("sb remove " + type + " [" + removeStart + "," + removeEnd + "], of [" + bufStart + "," + bufEnd + "], pos:" + currentTime);
                                            sb.remove(removeStart, removeEnd);
                                            return true;
                                        }
                                    }
                                } catch (error) {
                                    logger["logger"].warn('removeBufferRange failed', error);
                                }
                                return false;
                            };
                            return BufferController;
                        }(event_handler);
                        /* harmony default export */ var buffer_controller = buffer_controller_BufferController;
                        // CONCATENATED MODULE: ./src/controller/cap-level-controller.js
                        function cap_level_controller_defineProperties(target, props) {
                            for(var i = 0; i < props.length; i++){
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function cap_level_controller_createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) cap_level_controller_defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) cap_level_controller_defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        function cap_level_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /*
 * cap stream level to media size dimension controller
*/ var cap_level_controller_CapLevelController = /*#__PURE__*/ function(_EventHandler) {
                            cap_level_controller_inheritsLoose(CapLevelController, _EventHandler);
                            function CapLevelController(hls) {
                                var _this;
                                _this = _EventHandler.call(this, hls, events["default"].FPS_DROP_LEVEL_CAPPING, events["default"].MEDIA_ATTACHING, events["default"].MANIFEST_PARSED, events["default"].BUFFER_CODECS, events["default"].MEDIA_DETACHING) || this;
                                _this.autoLevelCapping = Number.POSITIVE_INFINITY;
                                _this.firstLevel = null;
                                _this.levels = [];
                                _this.media = null;
                                _this.restrictedLevels = [];
                                _this.timer = null;
                                return _this;
                            }
                            var _proto = CapLevelController.prototype;
                            _proto.destroy = function destroy() {
                                if (this.hls.config.capLevelToPlayerSize) {
                                    this.media = null;
                                    this.stopCapping();
                                }
                            };
                            _proto.onFpsDropLevelCapping = function onFpsDropLevelCapping(data) {
                                // Don't add a restricted level more than once
                                if (CapLevelController.isLevelAllowed(data.droppedLevel, this.restrictedLevels)) this.restrictedLevels.push(data.droppedLevel);
                            };
                            _proto.onMediaAttaching = function onMediaAttaching(data) {
                                this.media = data.media instanceof window.HTMLVideoElement ? data.media : null;
                            };
                            _proto.onManifestParsed = function onManifestParsed(data) {
                                var hls = this.hls;
                                this.restrictedLevels = [];
                                this.levels = data.levels;
                                this.firstLevel = data.firstLevel;
                                if (hls.config.capLevelToPlayerSize && data.video) // Start capping immediately if the manifest has signaled video codecs
                                this.startCapping();
                            } // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
                            ;
                            _proto.onBufferCodecs = function onBufferCodecs(data) {
                                var hls = this.hls;
                                if (hls.config.capLevelToPlayerSize && data.video) // If the manifest did not signal a video codec capping has been deferred until we're certain video is present
                                this.startCapping();
                            };
                            _proto.onLevelsUpdated = function onLevelsUpdated(data) {
                                this.levels = data.levels;
                            };
                            _proto.onMediaDetaching = function onMediaDetaching() {
                                this.stopCapping();
                            };
                            _proto.detectPlayerSize = function detectPlayerSize() {
                                if (this.media) {
                                    var levelsLength = this.levels ? this.levels.length : 0;
                                    if (levelsLength) {
                                        var hls = this.hls;
                                        hls.autoLevelCapping = this.getMaxLevel(levelsLength - 1);
                                        if (hls.autoLevelCapping > this.autoLevelCapping) // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
                                        // usually happen when the user go to the fullscreen mode.
                                        hls.streamController.nextLevelSwitch();
                                        this.autoLevelCapping = hls.autoLevelCapping;
                                    }
                                }
                            };
                            _proto.getMaxLevel = function getMaxLevel(capLevelIndex) {
                                var _this2 = this;
                                if (!this.levels) return -1;
                                var validLevels = this.levels.filter(function(level, index) {
                                    return CapLevelController.isLevelAllowed(index, _this2.restrictedLevels) && index <= capLevelIndex;
                                });
                                return CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
                            };
                            _proto.startCapping = function startCapping() {
                                if (this.timer) // Don't reset capping if started twice; this can happen if the manifest signals a video codec
                                return;
                                this.autoLevelCapping = Number.POSITIVE_INFINITY;
                                this.hls.firstLevel = this.getMaxLevel(this.firstLevel);
                                clearInterval(this.timer);
                                this.timer = setInterval(this.detectPlayerSize.bind(this), 1000);
                                this.detectPlayerSize();
                            };
                            _proto.stopCapping = function stopCapping() {
                                this.restrictedLevels = [];
                                this.firstLevel = null;
                                this.autoLevelCapping = Number.POSITIVE_INFINITY;
                                if (this.timer) {
                                    this.timer = clearInterval(this.timer);
                                    this.timer = null;
                                }
                            };
                            CapLevelController.isLevelAllowed = function isLevelAllowed(level, restrictedLevels) {
                                if (restrictedLevels === void 0) restrictedLevels = [];
                                return restrictedLevels.indexOf(level) === -1;
                            };
                            CapLevelController.getMaxLevelByMediaSize = function getMaxLevelByMediaSize(levels, width, height) {
                                if (!levels || levels && !levels.length) return -1;
                                 // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
                                // to determine whether we've chosen the greatest bandwidth for the media's dimensions
                                var atGreatestBandiwdth = function atGreatestBandiwdth(curLevel, nextLevel) {
                                    if (!nextLevel) return true;
                                    return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
                                }; // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
                                // the max level
                                var maxLevelIndex = levels.length - 1;
                                for(var i = 0; i < levels.length; i += 1){
                                    var level = levels[i];
                                    if ((level.width >= width || level.height >= height) && atGreatestBandiwdth(level, levels[i + 1])) {
                                        maxLevelIndex = i;
                                        break;
                                    }
                                }
                                return maxLevelIndex;
                            };
                            cap_level_controller_createClass(CapLevelController, [
                                {
                                    key: "mediaWidth",
                                    get: function get() {
                                        var width;
                                        var media = this.media;
                                        if (media) {
                                            width = media.width || media.clientWidth || media.offsetWidth;
                                            width *= CapLevelController.contentScaleFactor;
                                        }
                                        return width;
                                    }
                                },
                                {
                                    key: "mediaHeight",
                                    get: function get() {
                                        var height;
                                        var media = this.media;
                                        if (media) {
                                            height = media.height || media.clientHeight || media.offsetHeight;
                                            height *= CapLevelController.contentScaleFactor;
                                        }
                                        return height;
                                    }
                                }
                            ], [
                                {
                                    key: "contentScaleFactor",
                                    get: function get() {
                                        var pixelRatio = 1;
                                        try {
                                            pixelRatio = window.devicePixelRatio;
                                        } catch (e) {}
                                        return pixelRatio;
                                    }
                                }
                            ]);
                            return CapLevelController;
                        }(event_handler);
                        /* harmony default export */ var cap_level_controller = cap_level_controller_CapLevelController;
                        // CONCATENATED MODULE: ./src/controller/fps-controller.js
                        function fps_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /*
 * FPS Controller
*/ var fps_controller_window = window, fps_controller_performance = fps_controller_window.performance;
                        var fps_controller_FPSController = /*#__PURE__*/ function(_EventHandler) {
                            fps_controller_inheritsLoose(FPSController, _EventHandler);
                            function FPSController(hls) {
                                return _EventHandler.call(this, hls, events["default"].MEDIA_ATTACHING) || this;
                            }
                            var _proto = FPSController.prototype;
                            _proto.destroy = function destroy() {
                                if (this.timer) clearInterval(this.timer);
                                this.isVideoPlaybackQualityAvailable = false;
                            };
                            _proto.onMediaAttaching = function onMediaAttaching(data) {
                                var config = this.hls.config;
                                if (config.capLevelOnFPSDrop) {
                                    var video = this.video = data.media instanceof window.HTMLVideoElement ? data.media : null;
                                    if (typeof video.getVideoPlaybackQuality === 'function') this.isVideoPlaybackQualityAvailable = true;
                                    clearInterval(this.timer);
                                    this.timer = setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
                                }
                            };
                            _proto.checkFPS = function checkFPS(video, decodedFrames, droppedFrames) {
                                var currentTime = fps_controller_performance.now();
                                if (decodedFrames) {
                                    if (this.lastTime) {
                                        var currentPeriod = currentTime - this.lastTime, currentDropped = droppedFrames - this.lastDroppedFrames, currentDecoded = decodedFrames - this.lastDecodedFrames, droppedFPS = 1000 * currentDropped / currentPeriod, hls = this.hls;
                                        hls.trigger(events["default"].FPS_DROP, {
                                            currentDropped: currentDropped,
                                            currentDecoded: currentDecoded,
                                            totalDroppedFrames: droppedFrames
                                        });
                                        if (droppedFPS > 0) // logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
                                        {
                                            if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
                                                var currentLevel = hls.currentLevel;
                                                logger["logger"].warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
                                                if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
                                                    currentLevel = currentLevel - 1;
                                                    hls.trigger(events["default"].FPS_DROP_LEVEL_CAPPING, {
                                                        level: currentLevel,
                                                        droppedLevel: hls.currentLevel
                                                    });
                                                    hls.autoLevelCapping = currentLevel;
                                                    hls.streamController.nextLevelSwitch();
                                                }
                                            }
                                        }
                                    }
                                    this.lastTime = currentTime;
                                    this.lastDroppedFrames = droppedFrames;
                                    this.lastDecodedFrames = decodedFrames;
                                }
                            };
                            _proto.checkFPSInterval = function checkFPSInterval() {
                                var video = this.video;
                                if (video) {
                                    if (this.isVideoPlaybackQualityAvailable) {
                                        var videoPlaybackQuality = video.getVideoPlaybackQuality();
                                        this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
                                    } else this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
                                }
                            };
                            return FPSController;
                        }(event_handler);
                        /* harmony default export */ var fps_controller = fps_controller_FPSController;
                        // CONCATENATED MODULE: ./src/utils/xhr-loader.js
                        /**
 * XHR based logger
*/ var xhr_loader_window = window, xhr_loader_performance = xhr_loader_window.performance, xhr_loader_XMLHttpRequest = xhr_loader_window.XMLHttpRequest;
                        var xhr_loader_XhrLoader = /*#__PURE__*/ function() {
                            function XhrLoader(config) {
                                if (config && config.xhrSetup) this.xhrSetup = config.xhrSetup;
                            }
                            var _proto = XhrLoader.prototype;
                            _proto.destroy = function destroy() {
                                this.abort();
                                this.loader = null;
                            };
                            _proto.abort = function abort() {
                                var loader = this.loader;
                                if (loader && loader.readyState !== 4) {
                                    this.stats.aborted = true;
                                    loader.abort();
                                }
                                window.clearTimeout(this.requestTimeout);
                                this.requestTimeout = null;
                                window.clearTimeout(this.retryTimeout);
                                this.retryTimeout = null;
                            };
                            _proto.load = function load(context, config, callbacks) {
                                this.context = context;
                                this.config = config;
                                this.callbacks = callbacks;
                                this.stats = {
                                    trequest: xhr_loader_performance.now(),
                                    retry: 0
                                };
                                this.retryDelay = config.retryDelay;
                                this.loadInternal();
                            };
                            _proto.loadInternal = function loadInternal() {
                                var xhr, context = this.context;
                                xhr = this.loader = new xhr_loader_XMLHttpRequest();
                                var stats = this.stats;
                                stats.tfirst = 0;
                                stats.loaded = 0;
                                var xhrSetup = this.xhrSetup;
                                try {
                                    if (xhrSetup) try {
                                        xhrSetup(xhr, context.url);
                                    } catch (e) {
                                        // fix xhrSetup: (xhr, url) => {xhr.setRequestHeader("Content-Language", "test");}
                                        // not working, as xhr.setRequestHeader expects xhr.readyState === OPEN
                                        xhr.open('GET', context.url, true);
                                        xhrSetup(xhr, context.url);
                                    }
                                    if (!xhr.readyState) xhr.open('GET', context.url, true);
                                } catch (e) {
                                    // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
                                    this.callbacks.onError({
                                        code: xhr.status,
                                        text: e.message
                                    }, context, xhr);
                                    return;
                                }
                                if (context.rangeEnd) xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
                                xhr.onreadystatechange = this.readystatechange.bind(this);
                                xhr.onprogress = this.loadprogress.bind(this);
                                xhr.responseType = context.responseType; // setup timeout before we perform request
                                this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout);
                                xhr.send();
                            };
                            _proto.readystatechange = function readystatechange(event) {
                                var xhr = event.currentTarget, readyState = xhr.readyState, stats = this.stats, context = this.context, config = this.config; // don't proceed if xhr has been aborted
                                if (stats.aborted) return;
                                 // >= HEADERS_RECEIVED
                                if (readyState >= 2) {
                                    // clear xhr timeout and rearm it if readyState less than 4
                                    window.clearTimeout(this.requestTimeout);
                                    if (stats.tfirst === 0) stats.tfirst = Math.max(xhr_loader_performance.now(), stats.trequest);
                                    if (readyState === 4) {
                                        var status = xhr.status; // http status between 200 to 299 are all successful
                                        if (status >= 200 && status < 300) {
                                            stats.tload = Math.max(stats.tfirst, xhr_loader_performance.now());
                                            var data, len;
                                            if (context.responseType === 'arraybuffer') {
                                                data = xhr.response;
                                                len = data.byteLength;
                                            } else {
                                                data = xhr.responseText;
                                                len = data.length;
                                            }
                                            stats.loaded = stats.total = len;
                                            var response = {
                                                url: xhr.responseURL,
                                                data: data
                                            };
                                            this.callbacks.onSuccess(response, stats, context, xhr);
                                        } else // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
                                        if (stats.retry >= config.maxRetry || status >= 400 && status < 499) {
                                            logger["logger"].error(status + " while loading " + context.url);
                                            this.callbacks.onError({
                                                code: status,
                                                text: xhr.statusText
                                            }, context, xhr);
                                        } else {
                                            // retry
                                            logger["logger"].warn(status + " while loading " + context.url + ", retrying in " + this.retryDelay + "..."); // aborts and resets internal state
                                            this.destroy(); // schedule retry
                                            this.retryTimeout = window.setTimeout(this.loadInternal.bind(this), this.retryDelay); // set exponential backoff
                                            this.retryDelay = Math.min(2 * this.retryDelay, config.maxRetryDelay);
                                            stats.retry++;
                                        }
                                    } else // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
                                    this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), config.timeout);
                                }
                            };
                            _proto.loadtimeout = function loadtimeout() {
                                logger["logger"].warn("timeout while loading " + this.context.url);
                                this.callbacks.onTimeout(this.stats, this.context, null);
                            };
                            _proto.loadprogress = function loadprogress(event) {
                                var xhr = event.currentTarget, stats = this.stats;
                                stats.loaded = event.loaded;
                                if (event.lengthComputable) stats.total = event.total;
                                var onProgress = this.callbacks.onProgress;
                                if (onProgress) // third arg is to provide on progress data
                                onProgress(stats, this.context, null, xhr);
                            };
                            return XhrLoader;
                        }();
                        /* harmony default export */ var xhr_loader = xhr_loader_XhrLoader;
                        // CONCATENATED MODULE: ./src/controller/audio-track-controller.js
                        function audio_track_controller_defineProperties(target, props) {
                            for(var i = 0; i < props.length; i++){
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function audio_track_controller_createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) audio_track_controller_defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) audio_track_controller_defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        function audio_track_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /**
 * @class AudioTrackController
 * @implements {EventHandler}
 *
 * Handles main manifest and audio-track metadata loaded,
 * owns and exposes the selectable audio-tracks data-models.
 *
 * Exposes internal interface to select available audio-tracks.
 *
 * Handles errors on loading audio-track playlists. Manages fallback mechanism
 * with redundants tracks (group-IDs).
 *
 * Handles level-loading and group-ID switches for video (fallback on video levels),
 * and eventually adapts the audio-track group-ID to match.
 *
 * @fires AUDIO_TRACK_LOADING
 * @fires AUDIO_TRACK_SWITCHING
 * @fires AUDIO_TRACKS_UPDATED
 * @fires ERROR
 *
 */ var audio_track_controller_AudioTrackController = /*#__PURE__*/ function(_TaskLoop) {
                            audio_track_controller_inheritsLoose(AudioTrackController, _TaskLoop);
                            function AudioTrackController(hls) {
                                var _this;
                                _this = _TaskLoop.call(this, hls, events["default"].MANIFEST_LOADING, events["default"].MANIFEST_PARSED, events["default"].AUDIO_TRACK_LOADED, events["default"].AUDIO_TRACK_SWITCHED, events["default"].LEVEL_LOADED, events["default"].ERROR) || this;
                                /**
     * @private
     * Currently selected index in `tracks`
     * @member {number} trackId
     */ _this._trackId = -1;
                                /**
     * @private
     * If should select tracks according to default track attribute
     * @member {boolean} _selectDefaultTrack
     */ _this._selectDefaultTrack = true;
                                /**
     * @public
     * All tracks available
     * @member {AudioTrack[]}
     */ _this.tracks = [];
                                /**
     * @public
     * List of blacklisted audio track IDs (that have caused failure)
     * @member {number[]}
     */ _this.trackIdBlacklist = Object.create(null);
                                /**
     * @public
     * The currently running group ID for audio
     * (we grab this on manifest-parsed and new level-loaded)
     * @member {string}
     */ _this.audioGroupId = null;
                                return _this;
                            }
                            /**
   * Reset audio tracks on new manifest loading.
   */ var _proto = AudioTrackController.prototype;
                            _proto.onManifestLoading = function onManifestLoading() {
                                this.tracks = [];
                                this._trackId = -1;
                                this._selectDefaultTrack = true;
                            };
                            _proto.onManifestParsed = function onManifestParsed(data) {
                                var tracks = this.tracks = data.audioTracks || [];
                                this.hls.trigger(events["default"].AUDIO_TRACKS_UPDATED, {
                                    audioTracks: tracks
                                });
                                this._selectAudioGroup(this.hls.nextLoadLevel);
                            };
                            _proto.onAudioTrackLoaded = function onAudioTrackLoaded(data) {
                                if (data.id >= this.tracks.length) {
                                    logger["logger"].warn('Invalid audio track id:', data.id);
                                    return;
                                }
                                logger["logger"].log("audioTrack " + data.id + " loaded");
                                this.tracks[data.id].details = data.details; // check if current playlist is a live playlist
                                // and if we have already our reload interval setup
                                if (data.details.live && !this.hasInterval()) {
                                    // if live playlist we will have to reload it periodically
                                    // set reload period to playlist target duration
                                    var updatePeriodMs = data.details.targetduration * 1000;
                                    this.setInterval(updatePeriodMs);
                                }
                                if (!data.details.live && this.hasInterval()) // playlist is not live and timer is scheduled: cancel it
                                this.clearInterval();
                            };
                            _proto.onAudioTrackSwitched = function onAudioTrackSwitched(data) {
                                var audioGroupId = this.tracks[data.id].groupId;
                                if (audioGroupId && this.audioGroupId !== audioGroupId) this.audioGroupId = audioGroupId;
                            };
                            _proto.onLevelLoaded = function onLevelLoaded(data) {
                                this._selectAudioGroup(data.level);
                            };
                            _proto.onError = function onError(data) {
                                // Only handle network errors
                                if (data.type !== errors["ErrorTypes"].NETWORK_ERROR) return;
                                 // If fatal network error, cancel update task
                                if (data.fatal) this.clearInterval();
                                 // If not an audio-track loading error don't handle further
                                if (data.details !== errors["ErrorDetails"].AUDIO_TRACK_LOAD_ERROR) return;
                                logger["logger"].warn('Network failure on audio-track id:', data.context.id);
                                this._handleLoadError();
                            };
                            /**
   * @private
   * @param {number} newId
   */ _proto._setAudioTrack = function _setAudioTrack(newId) {
                                // noop on same audio track id as already set
                                if (this._trackId === newId && this.tracks[this._trackId].details) {
                                    logger["logger"].debug('Same id as current audio-track passed, and track details available -> no-op');
                                    return;
                                } // check if level idx is valid
                                if (newId < 0 || newId >= this.tracks.length) {
                                    logger["logger"].warn('Invalid id passed to audio-track controller');
                                    return;
                                }
                                var audioTrack = this.tracks[newId];
                                logger["logger"].log("Now switching to audio-track index " + newId); // stopping live reloading timer if any
                                this.clearInterval();
                                this._trackId = newId;
                                var url = audioTrack.url, type = audioTrack.type, id = audioTrack.id;
                                this.hls.trigger(events["default"].AUDIO_TRACK_SWITCHING, {
                                    id: id,
                                    type: type,
                                    url: url
                                });
                                this._loadTrackDetailsIfNeeded(audioTrack);
                            };
                            _proto.doTick = function doTick() {
                                this._updateTrack(this._trackId);
                            };
                            _proto._selectAudioGroup = function _selectAudioGroup(levelId) {
                                var levelInfo = this.hls.levels[levelId];
                                if (!levelInfo || !levelInfo.audioGroupIds) return;
                                var audioGroupId = levelInfo.audioGroupIds[levelInfo.urlId];
                                if (this.audioGroupId !== audioGroupId) {
                                    this.audioGroupId = audioGroupId;
                                    this._selectInitialAudioTrack();
                                }
                            };
                            _proto._selectInitialAudioTrack = function _selectInitialAudioTrack() {
                                var _this2 = this;
                                var tracks = this.tracks;
                                if (!tracks.length) return;
                                var currentAudioTrack = this.tracks[this._trackId];
                                var name = null;
                                if (currentAudioTrack) name = currentAudioTrack.name;
                                 // Pre-select default tracks if there are any
                                if (this._selectDefaultTrack) {
                                    var defaultTracks = tracks.filter(function(track) {
                                        return track.default;
                                    });
                                    if (defaultTracks.length) tracks = defaultTracks;
                                    else logger["logger"].warn('No default audio tracks defined');
                                }
                                var trackFound = false;
                                var traverseTracks = function traverseTracks() {
                                    // Select track with right group ID
                                    tracks.forEach(function(track) {
                                        if (trackFound) return;
                                         // We need to match the (pre-)selected group ID
                                        // and the NAME of the current track.
                                        if ((!_this2.audioGroupId || track.groupId === _this2.audioGroupId) && (!name || name === track.name)) {
                                            // If there was a previous track try to stay with the same `NAME`.
                                            // It should be unique across tracks of same group, and consistent through redundant track groups.
                                            _this2._setAudioTrack(track.id);
                                            trackFound = true;
                                        }
                                    });
                                };
                                traverseTracks();
                                if (!trackFound) {
                                    name = null;
                                    traverseTracks();
                                }
                                if (!trackFound) {
                                    logger["logger"].error("No track found for running audio group-ID: " + this.audioGroupId);
                                    this.hls.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].MEDIA_ERROR,
                                        details: errors["ErrorDetails"].AUDIO_TRACK_LOAD_ERROR,
                                        fatal: true
                                    });
                                }
                            };
                            _proto._needsTrackLoading = function _needsTrackLoading(audioTrack) {
                                var details = audioTrack.details, url = audioTrack.url;
                                if (!details || details.live) // check if we face an audio track embedded in main playlist (audio track without URI attribute)
                                return !!url;
                                return false;
                            };
                            _proto._loadTrackDetailsIfNeeded = function _loadTrackDetailsIfNeeded(audioTrack) {
                                if (this._needsTrackLoading(audioTrack)) {
                                    var url = audioTrack.url, id = audioTrack.id; // track not retrieved yet, or live playlist we need to (re)load it
                                    logger["logger"].log("loading audio-track playlist for id: " + id);
                                    this.hls.trigger(events["default"].AUDIO_TRACK_LOADING, {
                                        url: url,
                                        id: id
                                    });
                                }
                            };
                            _proto._updateTrack = function _updateTrack(newId) {
                                // check if level idx is valid
                                if (newId < 0 || newId >= this.tracks.length) return;
                                 // stopping live reloading timer if any
                                this.clearInterval();
                                this._trackId = newId;
                                logger["logger"].log("trying to update audio-track " + newId);
                                var audioTrack = this.tracks[newId];
                                this._loadTrackDetailsIfNeeded(audioTrack);
                            };
                            _proto._handleLoadError = function _handleLoadError() {
                                // First, let's black list current track id
                                this.trackIdBlacklist[this._trackId] = true; // Let's try to fall back on a functional audio-track with the same group ID
                                var previousId = this._trackId;
                                var _this$tracks$previous = this.tracks[previousId], name = _this$tracks$previous.name, language = _this$tracks$previous.language, groupId = _this$tracks$previous.groupId;
                                logger["logger"].warn("Loading failed on audio track id: " + previousId + ", group-id: " + groupId + ", name/language: \"" + name + "\" / \"" + language + "\""); // Find a non-blacklisted track ID with the same NAME
                                // At least a track that is not blacklisted, thus on another group-ID.
                                var newId = previousId;
                                for(var i = 0; i < this.tracks.length; i++){
                                    if (this.trackIdBlacklist[i]) continue;
                                    var newTrack = this.tracks[i];
                                    if (newTrack.name === name) {
                                        newId = i;
                                        break;
                                    }
                                }
                                if (newId === previousId) {
                                    logger["logger"].warn("No fallback audio-track found for name/language: \"" + name + "\" / \"" + language + "\"");
                                    return;
                                }
                                logger["logger"].log('Attempting audio-track fallback id:', newId, 'group-id:', this.tracks[newId].groupId);
                                this._setAudioTrack(newId);
                            };
                            audio_track_controller_createClass(AudioTrackController, [
                                {
                                    key: "audioTracks",
                                    get: function get() {
                                        return this.tracks;
                                    }
                                },
                                {
                                    key: "audioTrack",
                                    get: function get() {
                                        return this._trackId;
                                    },
                                    set: function set(newId) {
                                        this._setAudioTrack(newId); // If audio track is selected from API then don't choose from the manifest default track
                                        this._selectDefaultTrack = false;
                                    }
                                }
                            ]);
                            return AudioTrackController;
                        }(TaskLoop);
                        /* harmony default export */ var audio_track_controller = audio_track_controller_AudioTrackController;
                        // CONCATENATED MODULE: ./src/controller/audio-stream-controller.js
                        function audio_stream_controller_defineProperties(target, props) {
                            for(var i = 0; i < props.length; i++){
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function audio_stream_controller_createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) audio_stream_controller_defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) audio_stream_controller_defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        function audio_stream_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /*
 * Audio Stream Controller
*/ var audio_stream_controller_window = window, audio_stream_controller_performance = audio_stream_controller_window.performance;
                        var audio_stream_controller_TICK_INTERVAL = 100; // how often to tick in ms
                        var audio_stream_controller_AudioStreamController = /*#__PURE__*/ function(_BaseStreamController) {
                            audio_stream_controller_inheritsLoose(AudioStreamController, _BaseStreamController);
                            function AudioStreamController(hls, fragmentTracker) {
                                var _this;
                                _this = _BaseStreamController.call(this, hls, events["default"].MEDIA_ATTACHED, events["default"].MEDIA_DETACHING, events["default"].AUDIO_TRACKS_UPDATED, events["default"].AUDIO_TRACK_SWITCHING, events["default"].AUDIO_TRACK_LOADED, events["default"].KEY_LOADED, events["default"].FRAG_LOADED, events["default"].FRAG_PARSING_INIT_SEGMENT, events["default"].FRAG_PARSING_DATA, events["default"].FRAG_PARSED, events["default"].ERROR, events["default"].BUFFER_RESET, events["default"].BUFFER_CREATED, events["default"].BUFFER_APPENDED, events["default"].BUFFER_FLUSHED, events["default"].INIT_PTS_FOUND) || this;
                                _this.fragmentTracker = fragmentTracker;
                                _this.config = hls.config;
                                _this.audioCodecSwap = false;
                                _this._state = State.STOPPED;
                                _this.initPTS = [];
                                _this.waitingFragment = null;
                                _this.videoTrackCC = null;
                                return _this;
                            } // Signal that video PTS was found
                            var _proto = AudioStreamController.prototype;
                            _proto.onInitPtsFound = function onInitPtsFound(data) {
                                var demuxerId = data.id, cc = data.frag.cc, initPTS = data.initPTS;
                                if (demuxerId === 'main') {
                                    // Always update the new INIT PTS
                                    // Can change due level switch
                                    this.initPTS[cc] = initPTS;
                                    this.videoTrackCC = cc;
                                    logger["logger"].log("InitPTS for cc: " + cc + " found from video track: " + initPTS); // If we are waiting we need to demux/remux the waiting frag
                                    // With the new initPTS
                                    if (this.state === State.WAITING_INIT_PTS) this.tick();
                                }
                            };
                            _proto.startLoad = function startLoad(startPosition) {
                                if (this.tracks) {
                                    var lastCurrentTime = this.lastCurrentTime;
                                    this.stopLoad();
                                    this.setInterval(audio_stream_controller_TICK_INTERVAL);
                                    this.fragLoadError = 0;
                                    if (lastCurrentTime > 0 && startPosition === -1) {
                                        logger["logger"].log("audio:override startPosition with lastCurrentTime @" + lastCurrentTime.toFixed(3));
                                        this.state = State.IDLE;
                                    } else {
                                        this.lastCurrentTime = this.startPosition ? this.startPosition : startPosition;
                                        this.state = State.STARTING;
                                    }
                                    this.nextLoadPosition = this.startPosition = this.lastCurrentTime;
                                    this.tick();
                                } else {
                                    this.startPosition = startPosition;
                                    this.state = State.STOPPED;
                                }
                            };
                            _proto.doTick = function doTick() {
                                var pos, track, trackDetails, hls = this.hls, config = hls.config; // logger.log('audioStream:' + this.state);
                                switch(this.state){
                                    case State.ERROR:
                                    case State.PAUSED:
                                    case State.BUFFER_FLUSHING:
                                        break;
                                    case State.STARTING:
                                        this.state = State.WAITING_TRACK;
                                        this.loadedmetadata = false;
                                        break;
                                    case State.IDLE:
                                        var tracks = this.tracks; // audio tracks not received => exit loop
                                        if (!tracks) break;
                                         // if video not attached AND
                                        // start fragment already requested OR start frag prefetch disable
                                        // exit loop
                                        // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
                                        if (!this.media && (this.startFragRequested || !config.startFragPrefetch)) break;
                                         // determine next candidate fragment to be loaded, based on current position and
                                        //  end of buffer position
                                        // if we have not yet loaded any fragment, start loading from start position
                                        if (this.loadedmetadata) pos = this.media.currentTime;
                                        else {
                                            pos = this.nextLoadPosition;
                                            if (pos === undefined) break;
                                        }
                                        var media = this.mediaBuffer ? this.mediaBuffer : this.media, videoBuffer = this.videoBuffer ? this.videoBuffer : this.media, bufferInfo = BufferHelper.bufferInfo(media, pos, config.maxBufferHole), mainBufferInfo = BufferHelper.bufferInfo(videoBuffer, pos, config.maxBufferHole), bufferLen = bufferInfo.len, bufferEnd = bufferInfo.end, fragPrevious = this.fragPrevious, // ensure we buffer at least config.maxBufferLength (default 30s) or config.maxMaxBufferLength (default: 600s)
                                        // whichever is smaller.
                                        // once we reach that threshold, don't buffer more than video (mainBufferInfo.len)
                                        maxConfigBuffer = Math.min(config.maxBufferLength, config.maxMaxBufferLength), maxBufLen = Math.max(maxConfigBuffer, mainBufferInfo.len), audioSwitch = this.audioSwitch, trackId = this.trackId; // if buffer length is less than maxBufLen try to load a new fragment
                                        if ((bufferLen < maxBufLen || audioSwitch) && trackId < tracks.length) {
                                            trackDetails = tracks[trackId].details; // if track info not retrieved yet, switch state and wait for track retrieval
                                            if (typeof trackDetails === 'undefined') {
                                                this.state = State.WAITING_TRACK;
                                                break;
                                            }
                                            if (!audioSwitch && this._streamEnded(bufferInfo, trackDetails)) {
                                                this.hls.trigger(events["default"].BUFFER_EOS, {
                                                    type: 'audio'
                                                });
                                                this.state = State.ENDED;
                                                return;
                                            } // find fragment index, contiguous with end of buffer position
                                            var fragments = trackDetails.fragments, fragLen = fragments.length, start = fragments[0].start, end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration, frag; // When switching audio track, reload audio as close as possible to currentTime
                                            if (audioSwitch) {
                                                if (trackDetails.live && !trackDetails.PTSKnown) {
                                                    logger["logger"].log('switching audiotrack, live stream, unknown PTS,load first fragment');
                                                    bufferEnd = 0;
                                                } else {
                                                    bufferEnd = pos; // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
                                                    if (trackDetails.PTSKnown && pos < start) {
                                                        // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
                                                        if (bufferInfo.end > start || bufferInfo.nextStart) {
                                                            logger["logger"].log('alt audio track ahead of main track, seek to start of alt audio track');
                                                            this.media.currentTime = start + 0.05;
                                                        } else return;
                                                    }
                                                }
                                            }
                                            if (trackDetails.initSegment && !trackDetails.initSegment.data) frag = trackDetails.initSegment;
                                            else if (bufferEnd <= start) {
                                                frag = fragments[0];
                                                if (this.videoTrackCC !== null && frag.cc !== this.videoTrackCC) // Ensure we find a fragment which matches the continuity of the video track
                                                frag = findFragWithCC(fragments, this.videoTrackCC);
                                                if (trackDetails.live && frag.loadIdx && frag.loadIdx === this.fragLoadIdx) {
                                                    // we just loaded this first fragment, and we are still lagging behind the start of the live playlist
                                                    // let's force seek to start
                                                    var nextBuffered = bufferInfo.nextStart ? bufferInfo.nextStart : start;
                                                    logger["logger"].log("no alt audio available @currentTime:" + this.media.currentTime + ", seeking @" + (nextBuffered + 0.05));
                                                    this.media.currentTime = nextBuffered + 0.05;
                                                    return;
                                                }
                                            } else {
                                                var foundFrag;
                                                var maxFragLookUpTolerance = config.maxFragLookUpTolerance;
                                                var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : undefined;
                                                var fragmentWithinToleranceTest = function fragmentWithinToleranceTest(candidate) {
                                                    // offset should be within fragment boundary - config.maxFragLookUpTolerance
                                                    // this is to cope with situations like
                                                    // bufferEnd = 9.991
                                                    // frag[Ø] : [0,10]
                                                    // frag[1] : [10,20]
                                                    // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
                                                    //              frag start               frag start+duration
                                                    //                  |-----------------------------|
                                                    //              <--->                         <--->
                                                    //  ...--------><-----------------------------><---------....
                                                    // previous frag         matching fragment         next frag
                                                    //  return -1             return 0                 return 1
                                                    // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
                                                    // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
                                                    var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration);
                                                    if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) return 1;
                                                    else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
                                                    return -1;
                                                    return 0;
                                                };
                                                if (bufferEnd < end) {
                                                    if (bufferEnd > end - maxFragLookUpTolerance) maxFragLookUpTolerance = 0;
                                                     // Prefer the next fragment if it's within tolerance
                                                    if (fragNext && !fragmentWithinToleranceTest(fragNext)) foundFrag = fragNext;
                                                    else foundFrag = binary_search.search(fragments, fragmentWithinToleranceTest);
                                                } else // reach end of playlist
                                                foundFrag = fragments[fragLen - 1];
                                                if (foundFrag) {
                                                    frag = foundFrag;
                                                    start = foundFrag.start; // logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
                                                    if (fragPrevious && frag.level === fragPrevious.level && frag.sn === fragPrevious.sn) {
                                                        if (frag.sn < trackDetails.endSN) {
                                                            frag = fragments[frag.sn + 1 - trackDetails.startSN];
                                                            logger["logger"].log("SN just loaded, load next one: " + frag.sn);
                                                        } else frag = null;
                                                    }
                                                }
                                            }
                                            if (frag) {
                                                // logger.log('      loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
                                                if (frag.encrypted) {
                                                    logger["logger"].log("Loading key for " + frag.sn + " of [" + trackDetails.startSN + " ," + trackDetails.endSN + "],track " + trackId);
                                                    this.state = State.KEY_LOADING;
                                                    hls.trigger(events["default"].KEY_LOADING, {
                                                        frag: frag
                                                    });
                                                } else {
                                                    logger["logger"].log("Loading " + frag.sn + ", cc: " + frag.cc + " of [" + trackDetails.startSN + " ," + trackDetails.endSN + "],track " + trackId + ", currentTime:" + pos + ",bufferEnd:" + bufferEnd.toFixed(3)); // only load if fragment is not loaded or if in audio switch
                                                    // we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
                                                    this.fragCurrent = frag;
                                                    if (audioSwitch || this.fragmentTracker.getState(frag) === FragmentState.NOT_LOADED) {
                                                        if (frag.sn !== 'initSegment') this.startFragRequested = true;
                                                        if (Object(number_isFinite["isFiniteNumber"])(frag.sn)) this.nextLoadPosition = frag.start + frag.duration;
                                                        hls.trigger(events["default"].FRAG_LOADING, {
                                                            frag: frag
                                                        });
                                                        this.state = State.FRAG_LOADING;
                                                    }
                                                }
                                            }
                                        }
                                        break;
                                    case State.WAITING_TRACK:
                                        track = this.tracks[this.trackId]; // check if playlist is already loaded
                                        if (track && track.details) this.state = State.IDLE;
                                        break;
                                    case State.FRAG_LOADING_WAITING_RETRY:
                                        var now = audio_stream_controller_performance.now();
                                        var retryDate = this.retryDate;
                                        media = this.media;
                                        var isSeeking = media && media.seeking; // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                                        if (!retryDate || now >= retryDate || isSeeking) {
                                            logger["logger"].log('audioStreamController: retryDate reached, switch back to IDLE state');
                                            this.state = State.IDLE;
                                        }
                                        break;
                                    case State.WAITING_INIT_PTS:
                                        var videoTrackCC = this.videoTrackCC;
                                        if (this.initPTS[videoTrackCC] === undefined) break;
                                         // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
                                        var waitingFrag = this.waitingFragment;
                                        if (waitingFrag) {
                                            var waitingFragCC = waitingFrag.frag.cc;
                                            if (videoTrackCC !== waitingFragCC) {
                                                track = this.tracks[this.trackId];
                                                if (track.details && track.details.live) {
                                                    logger["logger"].warn("Waiting fragment CC (" + waitingFragCC + ") does not match video track CC (" + videoTrackCC + ")");
                                                    this.waitingFragment = null;
                                                    this.state = State.IDLE;
                                                }
                                            } else {
                                                this.state = State.FRAG_LOADING;
                                                this.onFragLoaded(this.waitingFragment);
                                                this.waitingFragment = null;
                                            }
                                        } else this.state = State.IDLE;
                                        break;
                                    case State.STOPPED:
                                    case State.FRAG_LOADING:
                                    case State.PARSING:
                                    case State.PARSED:
                                    case State.ENDED:
                                        break;
                                    default:
                                        break;
                                }
                            };
                            _proto.onMediaAttached = function onMediaAttached(data) {
                                var media = this.media = this.mediaBuffer = data.media;
                                this.onvseeking = this.onMediaSeeking.bind(this);
                                this.onvended = this.onMediaEnded.bind(this);
                                media.addEventListener('seeking', this.onvseeking);
                                media.addEventListener('ended', this.onvended);
                                var config = this.config;
                                if (this.tracks && config.autoStartLoad) this.startLoad(config.startPosition);
                            };
                            _proto.onMediaDetaching = function onMediaDetaching() {
                                var media = this.media;
                                if (media && media.ended) {
                                    logger["logger"].log('MSE detaching and video ended, reset startPosition');
                                    this.startPosition = this.lastCurrentTime = 0;
                                } // remove video listeners
                                if (media) {
                                    media.removeEventListener('seeking', this.onvseeking);
                                    media.removeEventListener('ended', this.onvended);
                                    this.onvseeking = this.onvseeked = this.onvended = null;
                                }
                                this.media = this.mediaBuffer = this.videoBuffer = null;
                                this.loadedmetadata = false;
                                this.fragmentTracker.removeAllFragments();
                                this.stopLoad();
                            };
                            _proto.onAudioTracksUpdated = function onAudioTracksUpdated(data) {
                                logger["logger"].log('audio tracks updated');
                                this.tracks = data.audioTracks;
                            };
                            _proto.onAudioTrackSwitching = function onAudioTrackSwitching(data) {
                                // if any URL found on new audio track, it is an alternate audio track
                                var altAudio = !!data.url;
                                this.trackId = data.id;
                                this.fragCurrent = null;
                                this.state = State.PAUSED;
                                this.waitingFragment = null; // destroy useless demuxer when switching audio to main
                                if (!altAudio) {
                                    if (this.demuxer) {
                                        this.demuxer.destroy();
                                        this.demuxer = null;
                                    }
                                } else // switching to audio track, start timer if not already started
                                this.setInterval(audio_stream_controller_TICK_INTERVAL);
                                 // should we switch tracks ?
                                if (altAudio) {
                                    this.audioSwitch = true; // main audio track are handled by stream-controller, just do something if switching to alt audio track
                                    this.state = State.IDLE;
                                }
                                this.tick();
                            };
                            _proto.onAudioTrackLoaded = function onAudioTrackLoaded(data) {
                                var newDetails = data.details, trackId = data.id, track = this.tracks[trackId], duration = newDetails.totalduration, sliding = 0;
                                logger["logger"].log("track " + trackId + " loaded [" + newDetails.startSN + "," + newDetails.endSN + "],duration:" + duration);
                                if (newDetails.live) {
                                    var curDetails = track.details;
                                    if (curDetails && newDetails.fragments.length > 0) {
                                        // we already have details for that level, merge them
                                        mergeDetails(curDetails, newDetails);
                                        sliding = newDetails.fragments[0].start; // TODO
                                        // this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
                                        if (newDetails.PTSKnown) logger["logger"].log("live audio playlist sliding:" + sliding.toFixed(3));
                                        else logger["logger"].log('live audio playlist - outdated PTS, unknown sliding');
                                    } else {
                                        newDetails.PTSKnown = false;
                                        logger["logger"].log('live audio playlist - first load, unknown sliding');
                                    }
                                } else newDetails.PTSKnown = false;
                                track.details = newDetails; // compute start position
                                if (!this.startFragRequested) {
                                    // compute start position if set to -1. use it straight away if value is defined
                                    if (this.startPosition === -1) {
                                        // first, check if start time offset has been set in playlist, if yes, use this value
                                        var startTimeOffset = newDetails.startTimeOffset;
                                        if (Object(number_isFinite["isFiniteNumber"])(startTimeOffset)) {
                                            logger["logger"].log("start time offset found in playlist, adjust startPosition to " + startTimeOffset);
                                            this.startPosition = startTimeOffset;
                                        } else if (newDetails.live) {
                                            this.startPosition = this.computeLivePosition(sliding, newDetails);
                                            logger["logger"].log("compute startPosition for audio-track to " + this.startPosition);
                                        } else this.startPosition = 0;
                                    }
                                    this.nextLoadPosition = this.startPosition;
                                } // only switch batck to IDLE state if we were waiting for track to start downloading a new fragment
                                if (this.state === State.WAITING_TRACK) this.state = State.IDLE;
                                 // trigger handler right now
                                this.tick();
                            };
                            _proto.onKeyLoaded = function onKeyLoaded() {
                                if (this.state === State.KEY_LOADING) {
                                    this.state = State.IDLE;
                                    this.tick();
                                }
                            };
                            _proto.onFragLoaded = function onFragLoaded(data) {
                                var fragCurrent = this.fragCurrent, fragLoaded = data.frag;
                                if (this.state === State.FRAG_LOADING && fragCurrent && fragLoaded.type === 'audio' && fragLoaded.level === fragCurrent.level && fragLoaded.sn === fragCurrent.sn) {
                                    var track = this.tracks[this.trackId], details = track.details, duration = details.totalduration, trackId = fragCurrent.level, sn = fragCurrent.sn, cc = fragCurrent.cc, audioCodec = this.config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2', stats = this.stats = data.stats;
                                    if (sn === 'initSegment') {
                                        this.state = State.IDLE;
                                        stats.tparsed = stats.tbuffered = audio_stream_controller_performance.now();
                                        details.initSegment.data = data.payload;
                                        this.hls.trigger(events["default"].FRAG_BUFFERED, {
                                            stats: stats,
                                            frag: fragCurrent,
                                            id: 'audio'
                                        });
                                        this.tick();
                                    } else {
                                        this.state = State.PARSING; // transmux the MPEG-TS data to ISO-BMFF segments
                                        this.appended = false;
                                        if (!this.demuxer) this.demuxer = new demux_demuxer(this.hls, 'audio');
                                         // Check if we have video initPTS
                                        // If not we need to wait for it
                                        var initPTS = this.initPTS[cc];
                                        var initSegmentData = details.initSegment ? details.initSegment.data : [];
                                        if (details.initSegment || initPTS !== undefined) {
                                            this.pendingBuffering = true;
                                            logger["logger"].log("Demuxing " + sn + " of [" + details.startSN + " ," + details.endSN + "],track " + trackId); // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
                                            var accurateTimeOffset = false; // details.PTSKnown || !details.live;
                                            this.demuxer.push(data.payload, initSegmentData, audioCodec, null, fragCurrent, duration, accurateTimeOffset, initPTS);
                                        } else {
                                            logger["logger"].log("unknown video PTS for continuity counter " + cc + ", waiting for video PTS before demuxing audio frag " + sn + " of [" + details.startSN + " ," + details.endSN + "],track " + trackId);
                                            this.waitingFragment = data;
                                            this.state = State.WAITING_INIT_PTS;
                                        }
                                    }
                                }
                                this.fragLoadError = 0;
                            };
                            _proto.onFragParsingInitSegment = function onFragParsingInitSegment(data) {
                                var fragCurrent = this.fragCurrent;
                                var fragNew = data.frag;
                                if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
                                    var tracks = data.tracks, track; // delete any video track found on audio demuxer
                                    if (tracks.video) delete tracks.video;
                                     // include levelCodec in audio and video tracks
                                    track = tracks.audio;
                                    if (track) {
                                        track.levelCodec = track.codec;
                                        track.id = data.id;
                                        this.hls.trigger(events["default"].BUFFER_CODECS, tracks);
                                        logger["logger"].log("audio track:audio,container:" + track.container + ",codecs[level/parsed]=[" + track.levelCodec + "/" + track.codec + "]");
                                        var initSegment = track.initSegment;
                                        if (initSegment) {
                                            var appendObj = {
                                                type: 'audio',
                                                data: initSegment,
                                                parent: 'audio',
                                                content: 'initSegment'
                                            };
                                            if (this.audioSwitch) this.pendingData = [
                                                appendObj
                                            ];
                                            else {
                                                this.appended = true; // arm pending Buffering flag before appending a segment
                                                this.pendingBuffering = true;
                                                this.hls.trigger(events["default"].BUFFER_APPENDING, appendObj);
                                            }
                                        } // trigger handler right now
                                        this.tick();
                                    }
                                }
                            };
                            _proto.onFragParsingData = function onFragParsingData(data) {
                                var _this2 = this;
                                var fragCurrent = this.fragCurrent;
                                var fragNew = data.frag;
                                if (fragCurrent && data.id === 'audio' && data.type === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
                                    var trackId = this.trackId, track = this.tracks[trackId], hls = this.hls;
                                    if (!Object(number_isFinite["isFiniteNumber"])(data.endPTS)) {
                                        data.endPTS = data.startPTS + fragCurrent.duration;
                                        data.endDTS = data.startDTS + fragCurrent.duration;
                                    }
                                    fragCurrent.addElementaryStream(ElementaryStreamTypes.AUDIO);
                                    logger["logger"].log("parsed " + data.type + ",PTS:[" + data.startPTS.toFixed(3) + "," + data.endPTS.toFixed(3) + "],DTS:[" + data.startDTS.toFixed(3) + "/" + data.endDTS.toFixed(3) + "],nb:" + data.nb);
                                    updateFragPTSDTS(track.details, fragCurrent, data.startPTS, data.endPTS);
                                    var audioSwitch = this.audioSwitch, media = this.media, appendOnBufferFlush = false; // Only flush audio from old audio tracks when PTS is known on new audio track
                                    if (audioSwitch) {
                                        if (media && media.readyState) {
                                            var currentTime = media.currentTime;
                                            logger["logger"].log('switching audio track : currentTime:' + currentTime);
                                            if (currentTime >= data.startPTS) {
                                                logger["logger"].log('switching audio track : flushing all audio');
                                                this.state = State.BUFFER_FLUSHING;
                                                hls.trigger(events["default"].BUFFER_FLUSHING, {
                                                    startOffset: 0,
                                                    endOffset: Number.POSITIVE_INFINITY,
                                                    type: 'audio'
                                                });
                                                appendOnBufferFlush = true; // Lets announce that the initial audio track switch flush occur
                                                this.audioSwitch = false;
                                                hls.trigger(events["default"].AUDIO_TRACK_SWITCHED, {
                                                    id: trackId
                                                });
                                            }
                                        } else {
                                            // Lets announce that the initial audio track switch flush occur
                                            this.audioSwitch = false;
                                            hls.trigger(events["default"].AUDIO_TRACK_SWITCHED, {
                                                id: trackId
                                            });
                                        }
                                    }
                                    var pendingData = this.pendingData;
                                    if (!pendingData) {
                                        logger["logger"].warn('Apparently attempt to enqueue media payload without codec initialization data upfront');
                                        hls.trigger(events["default"].ERROR, {
                                            type: errors["ErrorTypes"].MEDIA_ERROR,
                                            details: null,
                                            fatal: true
                                        });
                                        return;
                                    }
                                    if (!this.audioSwitch) {
                                        [
                                            data.data1,
                                            data.data2
                                        ].forEach(function(buffer) {
                                            if (buffer && buffer.length) pendingData.push({
                                                type: data.type,
                                                data: buffer,
                                                parent: 'audio',
                                                content: 'data'
                                            });
                                        });
                                        if (!appendOnBufferFlush && pendingData.length) {
                                            pendingData.forEach(function(appendObj) {
                                                // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
                                                // in that case it is useless to append following segments
                                                if (_this2.state === State.PARSING) {
                                                    // arm pending Buffering flag before appending a segment
                                                    _this2.pendingBuffering = true;
                                                    _this2.hls.trigger(events["default"].BUFFER_APPENDING, appendObj);
                                                }
                                            });
                                            this.pendingData = [];
                                            this.appended = true;
                                        }
                                    } // trigger handler right now
                                    this.tick();
                                }
                            };
                            _proto.onFragParsed = function onFragParsed(data) {
                                var fragCurrent = this.fragCurrent;
                                var fragNew = data.frag;
                                if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
                                    this.stats.tparsed = audio_stream_controller_performance.now();
                                    this.state = State.PARSED;
                                    this._checkAppendedParsed();
                                }
                            };
                            _proto.onBufferReset = function onBufferReset() {
                                // reset reference to sourcebuffers
                                this.mediaBuffer = this.videoBuffer = null;
                                this.loadedmetadata = false;
                            };
                            _proto.onBufferCreated = function onBufferCreated(data) {
                                var audioTrack = data.tracks.audio;
                                if (audioTrack) {
                                    this.mediaBuffer = audioTrack.buffer;
                                    this.loadedmetadata = true;
                                }
                                if (data.tracks.video) this.videoBuffer = data.tracks.video.buffer;
                            };
                            _proto.onBufferAppended = function onBufferAppended(data) {
                                if (data.parent === 'audio') {
                                    var state = this.state;
                                    if (state === State.PARSING || state === State.PARSED) {
                                        // check if all buffers have been appended
                                        this.pendingBuffering = data.pending > 0;
                                        this._checkAppendedParsed();
                                    }
                                }
                            };
                            _proto._checkAppendedParsed = function _checkAppendedParsed() {
                                // trigger handler right now
                                if (this.state === State.PARSED && (!this.appended || !this.pendingBuffering)) {
                                    var frag = this.fragCurrent, stats = this.stats, hls = this.hls;
                                    if (frag) {
                                        this.fragPrevious = frag;
                                        stats.tbuffered = audio_stream_controller_performance.now();
                                        hls.trigger(events["default"].FRAG_BUFFERED, {
                                            stats: stats,
                                            frag: frag,
                                            id: 'audio'
                                        });
                                        var media = this.mediaBuffer ? this.mediaBuffer : this.media;
                                        if (media) logger["logger"].log("audio buffered : " + time_ranges.toString(media.buffered));
                                        if (this.audioSwitch && this.appended) {
                                            this.audioSwitch = false;
                                            hls.trigger(events["default"].AUDIO_TRACK_SWITCHED, {
                                                id: this.trackId
                                            });
                                        }
                                        this.state = State.IDLE;
                                    }
                                    this.tick();
                                }
                            };
                            _proto.onError = function onError(data) {
                                var frag = data.frag; // don't handle frag error not related to audio fragment
                                if (frag && frag.type !== 'audio') return;
                                switch(data.details){
                                    case errors["ErrorDetails"].FRAG_LOAD_ERROR:
                                    case errors["ErrorDetails"].FRAG_LOAD_TIMEOUT:
                                        var _frag = data.frag; // don't handle frag error not related to audio fragment
                                        if (_frag && _frag.type !== 'audio') break;
                                        if (!data.fatal) {
                                            var loadError = this.fragLoadError;
                                            if (loadError) loadError++;
                                            else loadError = 1;
                                            var config = this.config;
                                            if (loadError <= config.fragLoadingMaxRetry) {
                                                this.fragLoadError = loadError; // exponential backoff capped to config.fragLoadingMaxRetryTimeout
                                                var delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
                                                logger["logger"].warn("AudioStreamController: frag loading failed, retry in " + delay + " ms");
                                                this.retryDate = audio_stream_controller_performance.now() + delay; // retry loading state
                                                this.state = State.FRAG_LOADING_WAITING_RETRY;
                                            } else {
                                                logger["logger"].error("AudioStreamController: " + data.details + " reaches max retry, redispatch as fatal ..."); // switch error to fatal
                                                data.fatal = true;
                                                this.state = State.ERROR;
                                            }
                                        }
                                        break;
                                    case errors["ErrorDetails"].AUDIO_TRACK_LOAD_ERROR:
                                    case errors["ErrorDetails"].AUDIO_TRACK_LOAD_TIMEOUT:
                                    case errors["ErrorDetails"].KEY_LOAD_ERROR:
                                    case errors["ErrorDetails"].KEY_LOAD_TIMEOUT:
                                        //  when in ERROR state, don't switch back to IDLE state in case a non-fatal error is received
                                        if (this.state !== State.ERROR) {
                                            // if fatal error, stop processing, otherwise move to IDLE to retry loading
                                            this.state = data.fatal ? State.ERROR : State.IDLE;
                                            logger["logger"].warn("AudioStreamController: " + data.details + " while loading frag, now switching to " + this.state + " state ...");
                                        }
                                        break;
                                    case errors["ErrorDetails"].BUFFER_FULL_ERROR:
                                        // if in appending state
                                        if (data.parent === 'audio' && (this.state === State.PARSING || this.state === State.PARSED)) {
                                            var media = this.mediaBuffer, currentTime = this.media.currentTime, mediaBuffered = media && BufferHelper.isBuffered(media, currentTime) && BufferHelper.isBuffered(media, currentTime + 0.5); // reduce max buf len if current position is buffered
                                            if (mediaBuffered) {
                                                var _config = this.config;
                                                if (_config.maxMaxBufferLength >= _config.maxBufferLength) {
                                                    // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
                                                    _config.maxMaxBufferLength /= 2;
                                                    logger["logger"].warn("AudioStreamController: reduce max buffer length to " + _config.maxMaxBufferLength + "s");
                                                }
                                                this.state = State.IDLE;
                                            } else {
                                                // current position is not buffered, but browser is still complaining about buffer full error
                                                // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
                                                // in that case flush the whole audio buffer to recover
                                                logger["logger"].warn('AudioStreamController: buffer full error also media.currentTime is not buffered, flush audio buffer');
                                                this.fragCurrent = null; // flush everything
                                                this.state = State.BUFFER_FLUSHING;
                                                this.hls.trigger(events["default"].BUFFER_FLUSHING, {
                                                    startOffset: 0,
                                                    endOffset: Number.POSITIVE_INFINITY,
                                                    type: 'audio'
                                                });
                                            }
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            };
                            _proto.onBufferFlushed = function onBufferFlushed() {
                                var _this3 = this;
                                var pendingData = this.pendingData;
                                if (pendingData && pendingData.length) {
                                    logger["logger"].log('AudioStreamController: appending pending audio data after buffer flushed');
                                    pendingData.forEach(function(appendObj) {
                                        _this3.hls.trigger(events["default"].BUFFER_APPENDING, appendObj);
                                    });
                                    this.appended = true;
                                    this.pendingData = [];
                                    this.state = State.PARSED;
                                } else {
                                    // move to IDLE once flush complete. this should trigger new fragment loading
                                    this.state = State.IDLE; // reset reference to frag
                                    this.fragPrevious = null;
                                    this.tick();
                                }
                            };
                            audio_stream_controller_createClass(AudioStreamController, [
                                {
                                    key: "state",
                                    set: function set(nextState) {
                                        if (this.state !== nextState) {
                                            var previousState = this.state;
                                            this._state = nextState;
                                            logger["logger"].log("audio stream:" + previousState + "->" + nextState);
                                        }
                                    },
                                    get: function get() {
                                        return this._state;
                                    }
                                }
                            ]);
                            return AudioStreamController;
                        }(base_stream_controller_BaseStreamController);
                        /* harmony default export */ var audio_stream_controller = audio_stream_controller_AudioStreamController;
                        // CONCATENATED MODULE: ./src/utils/vttcue.js
                        /**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* harmony default export */ var vttcue = function() {
                            if (typeof window !== 'undefined' && window.VTTCue) return window.VTTCue;
                            var autoKeyword = 'auto';
                            var directionSetting = {
                                '': true,
                                lr: true,
                                rl: true
                            };
                            var alignSetting = {
                                start: true,
                                middle: true,
                                end: true,
                                left: true,
                                right: true
                            };
                            function findDirectionSetting(value) {
                                if (typeof value !== 'string') return false;
                                var dir = directionSetting[value.toLowerCase()];
                                return dir ? value.toLowerCase() : false;
                            }
                            function findAlignSetting(value) {
                                if (typeof value !== 'string') return false;
                                var align = alignSetting[value.toLowerCase()];
                                return align ? value.toLowerCase() : false;
                            }
                            function extend(obj) {
                                var i = 1;
                                for(; i < arguments.length; i++){
                                    var cobj = arguments[i];
                                    for(var p in cobj)obj[p] = cobj[p];
                                }
                                return obj;
                            }
                            function VTTCue(startTime, endTime, text) {
                                var cue = this;
                                var baseObj = {};
                                baseObj.enumerable = true;
                                /**
     * Shim implementation specific properties. These properties are not in
     * the spec.
     */ // Lets us know when the VTTCue's data has changed in such a way that we need
                                // to recompute its display state. This lets us compute its display state
                                // lazily.
                                cue.hasBeenReset = false;
                                /**
     * VTTCue and TextTrackCue properties
     * http://dev.w3.org/html5/webvtt/#vttcue-interface
     */ var _id = '';
                                var _pauseOnExit = false;
                                var _startTime = startTime;
                                var _endTime = endTime;
                                var _text = text;
                                var _region = null;
                                var _vertical = '';
                                var _snapToLines = true;
                                var _line = 'auto';
                                var _lineAlign = 'start';
                                var _position = 50;
                                var _positionAlign = 'middle';
                                var _size = 50;
                                var _align = 'middle';
                                Object.defineProperty(cue, 'id', extend({}, baseObj, {
                                    get: function get() {
                                        return _id;
                                    },
                                    set: function set(value) {
                                        _id = '' + value;
                                    }
                                }));
                                Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
                                    get: function get() {
                                        return _pauseOnExit;
                                    },
                                    set: function set(value) {
                                        _pauseOnExit = !!value;
                                    }
                                }));
                                Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
                                    get: function get() {
                                        return _startTime;
                                    },
                                    set: function set(value) {
                                        if (typeof value !== 'number') throw new TypeError('Start time must be set to a number.');
                                        _startTime = value;
                                        this.hasBeenReset = true;
                                    }
                                }));
                                Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
                                    get: function get() {
                                        return _endTime;
                                    },
                                    set: function set(value) {
                                        if (typeof value !== 'number') throw new TypeError('End time must be set to a number.');
                                        _endTime = value;
                                        this.hasBeenReset = true;
                                    }
                                }));
                                Object.defineProperty(cue, 'text', extend({}, baseObj, {
                                    get: function get() {
                                        return _text;
                                    },
                                    set: function set(value) {
                                        _text = '' + value;
                                        this.hasBeenReset = true;
                                    }
                                }));
                                Object.defineProperty(cue, 'region', extend({}, baseObj, {
                                    get: function get() {
                                        return _region;
                                    },
                                    set: function set(value) {
                                        _region = value;
                                        this.hasBeenReset = true;
                                    }
                                }));
                                Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
                                    get: function get() {
                                        return _vertical;
                                    },
                                    set: function set(value) {
                                        var setting = findDirectionSetting(value); // Have to check for false because the setting an be an empty string.
                                        if (setting === false) throw new SyntaxError('An invalid or illegal string was specified.');
                                        _vertical = setting;
                                        this.hasBeenReset = true;
                                    }
                                }));
                                Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
                                    get: function get() {
                                        return _snapToLines;
                                    },
                                    set: function set(value) {
                                        _snapToLines = !!value;
                                        this.hasBeenReset = true;
                                    }
                                }));
                                Object.defineProperty(cue, 'line', extend({}, baseObj, {
                                    get: function get() {
                                        return _line;
                                    },
                                    set: function set(value) {
                                        if (typeof value !== 'number' && value !== autoKeyword) throw new SyntaxError('An invalid number or illegal string was specified.');
                                        _line = value;
                                        this.hasBeenReset = true;
                                    }
                                }));
                                Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
                                    get: function get() {
                                        return _lineAlign;
                                    },
                                    set: function set(value) {
                                        var setting = findAlignSetting(value);
                                        if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');
                                        _lineAlign = setting;
                                        this.hasBeenReset = true;
                                    }
                                }));
                                Object.defineProperty(cue, 'position', extend({}, baseObj, {
                                    get: function get() {
                                        return _position;
                                    },
                                    set: function set(value) {
                                        if (value < 0 || value > 100) throw new Error('Position must be between 0 and 100.');
                                        _position = value;
                                        this.hasBeenReset = true;
                                    }
                                }));
                                Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
                                    get: function get() {
                                        return _positionAlign;
                                    },
                                    set: function set(value) {
                                        var setting = findAlignSetting(value);
                                        if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');
                                        _positionAlign = setting;
                                        this.hasBeenReset = true;
                                    }
                                }));
                                Object.defineProperty(cue, 'size', extend({}, baseObj, {
                                    get: function get() {
                                        return _size;
                                    },
                                    set: function set(value) {
                                        if (value < 0 || value > 100) throw new Error('Size must be between 0 and 100.');
                                        _size = value;
                                        this.hasBeenReset = true;
                                    }
                                }));
                                Object.defineProperty(cue, 'align', extend({}, baseObj, {
                                    get: function get() {
                                        return _align;
                                    },
                                    set: function set(value) {
                                        var setting = findAlignSetting(value);
                                        if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');
                                        _align = setting;
                                        this.hasBeenReset = true;
                                    }
                                }));
                                /**
     * Other <track> spec defined properties
     */ // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
                                cue.displayState = void 0;
                            }
                            /**
   * VTTCue methods
   */ VTTCue.prototype.getCueAsHTML = function() {
                                // Assume WebVTT.convertCueToDOMTree is on the global.
                                var WebVTT = window.WebVTT;
                                return WebVTT.convertCueToDOMTree(window, this.text);
                            };
                            return VTTCue;
                        }();
                        // CONCATENATED MODULE: ./src/utils/vttparser.js
                        /*
 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js#L1716
 */ var StringDecoder = function StringDecoder() {
                            return {
                                decode: function decode(data) {
                                    if (!data) return '';
                                    if (typeof data !== 'string') throw new Error('Error - expected string data.');
                                    return decodeURIComponent(encodeURIComponent(data));
                                }
                            };
                        };
                        function VTTParser() {
                            this.window = window;
                            this.state = 'INITIAL';
                            this.buffer = '';
                            this.decoder = new StringDecoder();
                            this.regionList = [];
                        } // Try to parse input as a time stamp.
                        function parseTimeStamp(input) {
                            function computeSeconds(h, m, s, f) {
                                return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
                            }
                            var m = input.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
                            if (!m) return null;
                            if (m[3]) // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
                            return computeSeconds(m[1], m[2], m[3].replace(':', ''), m[4]);
                            else if (m[1] > 59) // Timestamp takes the form of [hours]:[minutes].[milliseconds]
                            // First position is hours as it's over 59.
                            return computeSeconds(m[1], m[2], 0, m[4]);
                            else // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
                            return computeSeconds(0, m[1], m[2], m[4]);
                        } // A settings object holds key/value pairs and will ignore anything but the first
                        // assignment to a specific key.
                        function Settings() {
                            this.values = Object.create(null);
                        }
                        Settings.prototype = {
                            // Only accept the first assignment to any key.
                            set: function set(k, v) {
                                if (!this.get(k) && v !== '') this.values[k] = v;
                            },
                            // Return the value for a key, or a default value.
                            // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
                            // a number of possible default values as properties where 'defaultKey' is
                            // the key of the property that will be chosen; otherwise it's assumed to be
                            // a single value.
                            get: function get(k, dflt, defaultKey) {
                                if (defaultKey) return this.has(k) ? this.values[k] : dflt[defaultKey];
                                return this.has(k) ? this.values[k] : dflt;
                            },
                            // Check whether we have a value for a key.
                            has: function has(k) {
                                return k in this.values;
                            },
                            // Accept a setting if its one of the given alternatives.
                            alt: function alt(k, v, a) {
                                for(var n = 0; n < a.length; ++n)if (v === a[n]) {
                                    this.set(k, v);
                                    break;
                                }
                            },
                            // Accept a setting if its a valid (signed) integer.
                            integer: function integer(k, v) {
                                if (/^-?\d+$/.test(v)) // integer
                                this.set(k, parseInt(v, 10));
                            },
                            // Accept a setting if its a valid percentage.
                            percent: function percent(k, v) {
                                var m;
                                if (m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/)) {
                                    v = parseFloat(v);
                                    if (v >= 0 && v <= 100) {
                                        this.set(k, v);
                                        return true;
                                    }
                                }
                                return false;
                            }
                        }; // Helper function to parse input into groups separated by 'groupDelim', and
                        // interprete each group as a key/value pair separated by 'keyValueDelim'.
                        function parseOptions(input, callback, keyValueDelim, groupDelim) {
                            var groups = groupDelim ? input.split(groupDelim) : [
                                input
                            ];
                            for(var i in groups){
                                if (typeof groups[i] !== 'string') continue;
                                var kv = groups[i].split(keyValueDelim);
                                if (kv.length !== 2) continue;
                                var k = kv[0];
                                var v = kv[1];
                                callback(k, v);
                            }
                        }
                        var defaults = new vttcue(0, 0, 0); // 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
                        //  Safari doesn't yet support this change, but FF and Chrome do.
                        var center = defaults.align === 'middle' ? 'middle' : 'center';
                        function parseCue(input, cue, regionList) {
                            // Remember the original input if we need to throw an error.
                            var oInput = input; // 4.1 WebVTT timestamp
                            function consumeTimeStamp() {
                                var ts = parseTimeStamp(input);
                                if (ts === null) throw new Error('Malformed timestamp: ' + oInput);
                                 // Remove time stamp from input.
                                input = input.replace(/^[^\sa-zA-Z-]+/, '');
                                return ts;
                            } // 4.4.2 WebVTT cue settings
                            function consumeCueSettings(input, cue) {
                                var settings = new Settings();
                                parseOptions(input, function(k, v) {
                                    switch(k){
                                        case 'region':
                                            // Find the last region we parsed with the same region id.
                                            for(var i = regionList.length - 1; i >= 0; i--)if (regionList[i].id === v) {
                                                settings.set(k, regionList[i].region);
                                                break;
                                            }
                                            break;
                                        case 'vertical':
                                            settings.alt(k, v, [
                                                'rl',
                                                'lr'
                                            ]);
                                            break;
                                        case 'line':
                                            var vals = v.split(','), vals0 = vals[0];
                                            settings.integer(k, vals0);
                                            if (settings.percent(k, vals0)) settings.set('snapToLines', false);
                                            settings.alt(k, vals0, [
                                                'auto'
                                            ]);
                                            if (vals.length === 2) settings.alt('lineAlign', vals[1], [
                                                'start',
                                                center,
                                                'end'
                                            ]);
                                            break;
                                        case 'position':
                                            vals = v.split(',');
                                            settings.percent(k, vals[0]);
                                            if (vals.length === 2) settings.alt('positionAlign', vals[1], [
                                                'start',
                                                center,
                                                'end',
                                                'line-left',
                                                'line-right',
                                                'auto'
                                            ]);
                                            break;
                                        case 'size':
                                            settings.percent(k, v);
                                            break;
                                        case 'align':
                                            settings.alt(k, v, [
                                                'start',
                                                center,
                                                'end',
                                                'left',
                                                'right'
                                            ]);
                                            break;
                                    }
                                }, /:/, /\s/); // Apply default values for any missing fields.
                                cue.region = settings.get('region', null);
                                cue.vertical = settings.get('vertical', '');
                                var line = settings.get('line', 'auto');
                                if (line === 'auto' && defaults.line === -1) // set numeric line number for Safari
                                line = -1;
                                cue.line = line;
                                cue.lineAlign = settings.get('lineAlign', 'start');
                                cue.snapToLines = settings.get('snapToLines', true);
                                cue.size = settings.get('size', 100);
                                cue.align = settings.get('align', center);
                                var position = settings.get('position', 'auto');
                                if (position === 'auto' && defaults.position === 50) // set numeric position for Safari
                                position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
                                cue.position = position;
                            }
                            function skipWhitespace() {
                                input = input.replace(/^\s+/, '');
                            } // 4.1 WebVTT cue timings.
                            skipWhitespace();
                            cue.startTime = consumeTimeStamp(); // (1) collect cue start time
                            skipWhitespace();
                            if (input.substr(0, 3) !== '-->') // (3) next characters must match '-->'
                            throw new Error('Malformed time stamp (time stamps must be separated by \'-->\'): ' + oInput);
                            input = input.substr(3);
                            skipWhitespace();
                            cue.endTime = consumeTimeStamp(); // (5) collect cue end time
                            // 4.1 WebVTT cue settings list.
                            skipWhitespace();
                            consumeCueSettings(input, cue);
                        }
                        function fixLineBreaks(input) {
                            return input.replace(/<br(?: \/)?>/gi, '\n');
                        }
                        VTTParser.prototype = {
                            parse: function parse(data) {
                                var self1 = this; // If there is no data then we won't decode it, but will just try to parse
                                // whatever is in buffer already. This may occur in circumstances, for
                                // example when flush() is called.
                                if (data) // Try to decode the data that we received.
                                self1.buffer += self1.decoder.decode(data, {
                                    stream: true
                                });
                                function collectNextLine() {
                                    var buffer = self1.buffer;
                                    var pos = 0;
                                    buffer = fixLineBreaks(buffer);
                                    while(pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n')++pos;
                                    var line = buffer.substr(0, pos); // Advance the buffer early in case we fail below.
                                    if (buffer[pos] === '\r') ++pos;
                                    if (buffer[pos] === '\n') ++pos;
                                    self1.buffer = buffer.substr(pos);
                                    return line;
                                } // 3.2 WebVTT metadata header syntax
                                function parseHeader(input) {
                                    parseOptions(input, function(k, v) {
                                        k;
                                    }, /:/);
                                } // 5.1 WebVTT file parsing.
                                try {
                                    var line;
                                    if (self1.state === 'INITIAL') {
                                        // We can't start parsing until we have the first line.
                                        if (!/\r\n|\n/.test(self1.buffer)) return this;
                                        line = collectNextLine(); // strip of UTF-8 BOM if any
                                        // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
                                        var m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                                        if (!m || !m[0]) throw new Error('Malformed WebVTT signature.');
                                        self1.state = 'HEADER';
                                    }
                                    var alreadyCollectedLine = false;
                                    while(self1.buffer){
                                        // We can't parse a line until we have the full line.
                                        if (!/\r\n|\n/.test(self1.buffer)) return this;
                                        if (!alreadyCollectedLine) line = collectNextLine();
                                        else alreadyCollectedLine = false;
                                        switch(self1.state){
                                            case 'HEADER':
                                                // 13-18 - Allow a header (metadata) under the WEBVTT line.
                                                if (/:/.test(line)) parseHeader(line);
                                                else if (!line) // An empty line terminates the header and starts the body (cues).
                                                self1.state = 'ID';
                                                continue;
                                            case 'NOTE':
                                                // Ignore NOTE blocks.
                                                if (!line) self1.state = 'ID';
                                                continue;
                                            case 'ID':
                                                // Check for the start of NOTE blocks.
                                                if (/^NOTE($|[ \t])/.test(line)) {
                                                    self1.state = 'NOTE';
                                                    break;
                                                } // 19-29 - Allow any number of line terminators, then initialize new cue values.
                                                if (!line) continue;
                                                self1.cue = new vttcue(0, 0, '');
                                                self1.state = 'CUE'; // 30-39 - Check if self line contains an optional identifier or timing data.
                                                if (line.indexOf('-->') === -1) {
                                                    self1.cue.id = line;
                                                    continue;
                                                }
                                            // Process line as start of a cue.
                                            /* falls through */ case 'CUE':
                                                // 40 - Collect cue timings and settings.
                                                try {
                                                    parseCue(line, self1.cue, self1.regionList);
                                                } catch (e) {
                                                    // In case of an error ignore rest of the cue.
                                                    self1.cue = null;
                                                    self1.state = 'BADCUE';
                                                    continue;
                                                }
                                                self1.state = 'CUETEXT';
                                                continue;
                                            case 'CUETEXT':
                                                var hasSubstring = line.indexOf('-->') !== -1; // 34 - If we have an empty line then report the cue.
                                                // 35 - If we have the special substring '-->' then report the cue,
                                                // but do not collect the line as we need to process the current
                                                // one as a new cue.
                                                if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                                                    // We are done parsing self cue.
                                                    if (self1.oncue) self1.oncue(self1.cue);
                                                    self1.cue = null;
                                                    self1.state = 'ID';
                                                    continue;
                                                }
                                                if (self1.cue.text) self1.cue.text += '\n';
                                                self1.cue.text += line;
                                                continue;
                                            case 'BADCUE':
                                                // BADCUE
                                                // 54-62 - Collect and discard the remaining cue.
                                                if (!line) self1.state = 'ID';
                                                continue;
                                        }
                                    }
                                } catch (e) {
                                    // If we are currently parsing a cue, report what we have.
                                    if (self1.state === 'CUETEXT' && self1.cue && self1.oncue) self1.oncue(self1.cue);
                                    self1.cue = null; // Enter BADWEBVTT state if header was not parsed correctly otherwise
                                    // another exception occurred so enter BADCUE state.
                                    self1.state = self1.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
                                }
                                return this;
                            },
                            flush: function flush() {
                                var self1 = this;
                                try {
                                    // Finish decoding the stream.
                                    self1.buffer += self1.decoder.decode(); // Synthesize the end of the current cue or region.
                                    if (self1.cue || self1.state === 'HEADER') {
                                        self1.buffer += '\n\n';
                                        self1.parse();
                                    } // If we've flushed, parsed, and we're still on the INITIAL state then
                                    // that means we don't have enough of the stream to parse the first
                                    // line.
                                    if (self1.state === 'INITIAL') throw new Error('Malformed WebVTT signature.');
                                } catch (e) {
                                    throw e;
                                }
                                if (self1.onflush) self1.onflush();
                                return this;
                            }
                        };
                        /* harmony default export */ var vttparser = VTTParser;
                        // CONCATENATED MODULE: ./src/utils/cues.ts
                        function newCue(track, startTime, endTime, captionScreen) {
                            var row; // the type data states this is VTTCue, but it can potentially be a TextTrackCue on old browsers
                            var cue;
                            var indenting;
                            var indent;
                            var text;
                            var VTTCue = window.VTTCue || TextTrackCue;
                            for(var r = 0; r < captionScreen.rows.length; r++){
                                row = captionScreen.rows[r];
                                indenting = true;
                                indent = 0;
                                text = '';
                                if (!row.isEmpty()) {
                                    for(var c = 0; c < row.chars.length; c++)if (row.chars[c].uchar.match(/\s/) && indenting) indent++;
                                    else {
                                        text += row.chars[c].uchar;
                                        indenting = false;
                                    }
                                     // To be used for cleaning-up orphaned roll-up captions
                                    row.cueStartTime = startTime; // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
                                    if (startTime === endTime) endTime += 0.0001;
                                    cue = new VTTCue(startTime, endTime, fixLineBreaks(text.trim()));
                                    if (indent >= 16) indent--;
                                    else indent++;
                                     // VTTCue.line get's flakey when using controls, so let's now include line 13&14
                                    // also, drop line 1 since it's to close to the top
                                    if (navigator.userAgent.match(/Firefox\//)) cue.line = r + 1;
                                    else cue.line = r > 7 ? r - 2 : r + 1;
                                    cue.align = 'left'; // Clamp the position between 0 and 100 - if out of these bounds, Firefox throws an exception and captions break
                                    cue.position = Math.max(0, Math.min(100, 100 * (indent / 32)));
                                    track.addCue(cue);
                                }
                            }
                        }
                        // CONCATENATED MODULE: ./src/utils/cea-608-parser.ts
                        /**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */ /**
     *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
     */ var specialCea608CharsCodes = {
                            0x2a: 0xe1,
                            // lowercase a, acute accent
                            0x5c: 0xe9,
                            // lowercase e, acute accent
                            0x5e: 0xed,
                            // lowercase i, acute accent
                            0x5f: 0xf3,
                            // lowercase o, acute accent
                            0x60: 0xfa,
                            // lowercase u, acute accent
                            0x7b: 0xe7,
                            // lowercase c with cedilla
                            0x7c: 0xf7,
                            // division symbol
                            0x7d: 0xd1,
                            // uppercase N tilde
                            0x7e: 0xf1,
                            // lowercase n tilde
                            0x7f: 0x2588,
                            // Full block
                            // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                            // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
                            // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
                            0x80: 0xae,
                            // Registered symbol (R)
                            0x81: 0xb0,
                            // degree sign
                            0x82: 0xbd,
                            // 1/2 symbol
                            0x83: 0xbf,
                            // Inverted (open) question mark
                            0x84: 0x2122,
                            // Trademark symbol (TM)
                            0x85: 0xa2,
                            // Cents symbol
                            0x86: 0xa3,
                            // Pounds sterling
                            0x87: 0x266a,
                            // Music 8'th note
                            0x88: 0xe0,
                            // lowercase a, grave accent
                            0x89: 0x20,
                            // transparent space (regular)
                            0x8a: 0xe8,
                            // lowercase e, grave accent
                            0x8b: 0xe2,
                            // lowercase a, circumflex accent
                            0x8c: 0xea,
                            // lowercase e, circumflex accent
                            0x8d: 0xee,
                            // lowercase i, circumflex accent
                            0x8e: 0xf4,
                            // lowercase o, circumflex accent
                            0x8f: 0xfb,
                            // lowercase u, circumflex accent
                            // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                            // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
                            0x90: 0xc1,
                            // capital letter A with acute
                            0x91: 0xc9,
                            // capital letter E with acute
                            0x92: 0xd3,
                            // capital letter O with acute
                            0x93: 0xda,
                            // capital letter U with acute
                            0x94: 0xdc,
                            // capital letter U with diaresis
                            0x95: 0xfc,
                            // lowercase letter U with diaeresis
                            0x96: 0x2018,
                            // opening single quote
                            0x97: 0xa1,
                            // inverted exclamation mark
                            0x98: 0x2a,
                            // asterisk
                            0x99: 0x2019,
                            // closing single quote
                            0x9a: 0x2501,
                            // box drawings heavy horizontal
                            0x9b: 0xa9,
                            // copyright sign
                            0x9c: 0x2120,
                            // Service mark
                            0x9d: 0x2022,
                            // (round) bullet
                            0x9e: 0x201c,
                            // Left double quotation mark
                            0x9f: 0x201d,
                            // Right double quotation mark
                            0xa0: 0xc0,
                            // uppercase A, grave accent
                            0xa1: 0xc2,
                            // uppercase A, circumflex
                            0xa2: 0xc7,
                            // uppercase C with cedilla
                            0xa3: 0xc8,
                            // uppercase E, grave accent
                            0xa4: 0xca,
                            // uppercase E, circumflex
                            0xa5: 0xcb,
                            // capital letter E with diaresis
                            0xa6: 0xeb,
                            // lowercase letter e with diaresis
                            0xa7: 0xce,
                            // uppercase I, circumflex
                            0xa8: 0xcf,
                            // uppercase I, with diaresis
                            0xa9: 0xef,
                            // lowercase i, with diaresis
                            0xaa: 0xd4,
                            // uppercase O, circumflex
                            0xab: 0xd9,
                            // uppercase U, grave accent
                            0xac: 0xf9,
                            // lowercase u, grave accent
                            0xad: 0xdb,
                            // uppercase U, circumflex
                            0xae: 0xab,
                            // left-pointing double angle quotation mark
                            0xaf: 0xbb,
                            // right-pointing double angle quotation mark
                            // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                            // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
                            0xb0: 0xc3,
                            // Uppercase A, tilde
                            0xb1: 0xe3,
                            // Lowercase a, tilde
                            0xb2: 0xcd,
                            // Uppercase I, acute accent
                            0xb3: 0xcc,
                            // Uppercase I, grave accent
                            0xb4: 0xec,
                            // Lowercase i, grave accent
                            0xb5: 0xd2,
                            // Uppercase O, grave accent
                            0xb6: 0xf2,
                            // Lowercase o, grave accent
                            0xb7: 0xd5,
                            // Uppercase O, tilde
                            0xb8: 0xf5,
                            // Lowercase o, tilde
                            0xb9: 0x7b,
                            // Open curly brace
                            0xba: 0x7d,
                            // Closing curly brace
                            0xbb: 0x5c,
                            // Backslash
                            0xbc: 0x5e,
                            // Caret
                            0xbd: 0x5f,
                            // Underscore
                            0xbe: 0x7c,
                            // Pipe (vertical line)
                            0xbf: 0x223c,
                            // Tilde operator
                            0xc0: 0xc4,
                            // Uppercase A, umlaut
                            0xc1: 0xe4,
                            // Lowercase A, umlaut
                            0xc2: 0xd6,
                            // Uppercase O, umlaut
                            0xc3: 0xf6,
                            // Lowercase o, umlaut
                            0xc4: 0xdf,
                            // Esszett (sharp S)
                            0xc5: 0xa5,
                            // Yen symbol
                            0xc6: 0xa4,
                            // Generic currency sign
                            0xc7: 0x2503,
                            // Box drawings heavy vertical
                            0xc8: 0xc5,
                            // Uppercase A, ring
                            0xc9: 0xe5,
                            // Lowercase A, ring
                            0xca: 0xd8,
                            // Uppercase O, stroke
                            0xcb: 0xf8,
                            // Lowercase o, strok
                            0xcc: 0x250f,
                            // Box drawings heavy down and right
                            0xcd: 0x2513,
                            // Box drawings heavy down and left
                            0xce: 0x2517,
                            // Box drawings heavy up and right
                            0xcf: 0x251b // Box drawings heavy up and left
                        };
                        /**
 * Utils
 */ var getCharForByte = function getCharForByte(byte) {
                            var charCode = byte;
                            if (specialCea608CharsCodes.hasOwnProperty(byte)) charCode = specialCea608CharsCodes[byte];
                            return String.fromCharCode(charCode);
                        };
                        var NR_ROWS = 15, NR_COLS = 100; // Tables to look up row from PAC data
                        var rowsLowCh1 = {
                            0x11: 1,
                            0x12: 3,
                            0x15: 5,
                            0x16: 7,
                            0x17: 9,
                            0x10: 11,
                            0x13: 12,
                            0x14: 14
                        };
                        var rowsHighCh1 = {
                            0x11: 2,
                            0x12: 4,
                            0x15: 6,
                            0x16: 8,
                            0x17: 10,
                            0x13: 13,
                            0x14: 15
                        };
                        var rowsLowCh2 = {
                            0x19: 1,
                            0x1A: 3,
                            0x1D: 5,
                            0x1E: 7,
                            0x1F: 9,
                            0x18: 11,
                            0x1B: 12,
                            0x1C: 14
                        };
                        var rowsHighCh2 = {
                            0x19: 2,
                            0x1A: 4,
                            0x1D: 6,
                            0x1E: 8,
                            0x1F: 10,
                            0x1B: 13,
                            0x1C: 15
                        };
                        var backgroundColors = [
                            'white',
                            'green',
                            'blue',
                            'cyan',
                            'red',
                            'yellow',
                            'magenta',
                            'black',
                            'transparent'
                        ];
                        var VerboseFilter;
                        /**
 * Simple logger class to be able to write with time-stamps and filter on level.
 */ (function(VerboseFilter) {
                            VerboseFilter[VerboseFilter["ERROR"] = 0] = "ERROR";
                            VerboseFilter[VerboseFilter["TEXT"] = 1] = "TEXT";
                            VerboseFilter[VerboseFilter["WARNING"] = 2] = "WARNING";
                            VerboseFilter[VerboseFilter["INFO"] = 2] = "INFO";
                            VerboseFilter[VerboseFilter["DEBUG"] = 3] = "DEBUG";
                            VerboseFilter[VerboseFilter["DATA"] = 3] = "DATA";
                        })(VerboseFilter || (VerboseFilter = {}));
                        var cea_608_parser_logger = {
                            verboseFilter: {
                                'DATA': 3,
                                'DEBUG': 3,
                                'INFO': 2,
                                'WARNING': 2,
                                'TEXT': 1,
                                'ERROR': 0
                            },
                            time: null,
                            verboseLevel: 0,
                            // Only write errors
                            setTime: function setTime(newTime) {
                                this.time = newTime;
                            },
                            log: function log(severity, msg) {
                                var minLevel = this.verboseFilter[severity];
                                this.verboseLevel;
                            }
                        };
                        var numArrayToHexArray = function numArrayToHexArray(numArray) {
                            var hexArray = [];
                            for(var j = 0; j < numArray.length; j++)hexArray.push(numArray[j].toString(16));
                            return hexArray;
                        };
                        var PenState = /*#__PURE__*/ function() {
                            function PenState(foreground, underline, italics, background, flash) {
                                this.foreground = void 0;
                                this.underline = void 0;
                                this.italics = void 0;
                                this.background = void 0;
                                this.flash = void 0;
                                this.foreground = foreground || 'white';
                                this.underline = underline || false;
                                this.italics = italics || false;
                                this.background = background || 'black';
                                this.flash = flash || false;
                            }
                            var _proto = PenState.prototype;
                            _proto.reset = function reset() {
                                this.foreground = 'white';
                                this.underline = false;
                                this.italics = false;
                                this.background = 'black';
                                this.flash = false;
                            };
                            _proto.setStyles = function setStyles(styles) {
                                var attribs = [
                                    'foreground',
                                    'underline',
                                    'italics',
                                    'background',
                                    'flash'
                                ];
                                for(var i = 0; i < attribs.length; i++){
                                    var style = attribs[i];
                                    if (styles.hasOwnProperty(style)) this[style] = styles[style];
                                }
                            };
                            _proto.isDefault = function isDefault() {
                                return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
                            };
                            _proto.equals = function equals(other) {
                                return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
                            };
                            _proto.copy = function copy(newPenState) {
                                this.foreground = newPenState.foreground;
                                this.underline = newPenState.underline;
                                this.italics = newPenState.italics;
                                this.background = newPenState.background;
                                this.flash = newPenState.flash;
                            };
                            _proto.toString = function toString() {
                                return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
                            };
                            return PenState;
                        }();
                        /**
 * Unicode character with styling and background.
 * @constructor
 */ var StyledUnicodeChar = /*#__PURE__*/ function() {
                            function StyledUnicodeChar(uchar, foreground, underline, italics, background, flash) {
                                this.uchar = void 0;
                                this.penState = void 0;
                                this.uchar = uchar || ' '; // unicode character
                                this.penState = new PenState(foreground, underline, italics, background, flash);
                            }
                            var _proto2 = StyledUnicodeChar.prototype;
                            _proto2.reset = function reset() {
                                this.uchar = ' ';
                                this.penState.reset();
                            };
                            _proto2.setChar = function setChar(uchar, newPenState) {
                                this.uchar = uchar;
                                this.penState.copy(newPenState);
                            };
                            _proto2.setPenState = function setPenState(newPenState) {
                                this.penState.copy(newPenState);
                            };
                            _proto2.equals = function equals(other) {
                                return this.uchar === other.uchar && this.penState.equals(other.penState);
                            };
                            _proto2.copy = function copy(newChar) {
                                this.uchar = newChar.uchar;
                                this.penState.copy(newChar.penState);
                            };
                            _proto2.isEmpty = function isEmpty() {
                                return this.uchar === ' ' && this.penState.isDefault();
                            };
                            return StyledUnicodeChar;
                        }();
                        /**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */ var Row = /*#__PURE__*/ function() {
                            function Row() {
                                this.chars = void 0;
                                this.pos = void 0;
                                this.currPenState = void 0;
                                this.cueStartTime = void 0;
                                this.chars = [];
                                for(var i = 0; i < NR_COLS; i++)this.chars.push(new StyledUnicodeChar());
                                this.pos = 0;
                                this.currPenState = new PenState();
                            }
                            var _proto3 = Row.prototype;
                            _proto3.equals = function equals(other) {
                                var equal = true;
                                for(var i = 0; i < NR_COLS; i++)if (!this.chars[i].equals(other.chars[i])) {
                                    equal = false;
                                    break;
                                }
                                return equal;
                            };
                            _proto3.copy = function copy(other) {
                                for(var i = 0; i < NR_COLS; i++)this.chars[i].copy(other.chars[i]);
                            };
                            _proto3.isEmpty = function isEmpty() {
                                var empty = true;
                                for(var i = 0; i < NR_COLS; i++)if (!this.chars[i].isEmpty()) {
                                    empty = false;
                                    break;
                                }
                                return empty;
                            };
                            _proto3.setCursor = function setCursor(absPos) {
                                if (this.pos !== absPos) this.pos = absPos;
                                if (this.pos < 0) {
                                    cea_608_parser_logger.log('ERROR', 'Negative cursor position ' + this.pos);
                                    this.pos = 0;
                                } else if (this.pos > NR_COLS) {
                                    cea_608_parser_logger.log('ERROR', 'Too large cursor position ' + this.pos);
                                    this.pos = NR_COLS;
                                }
                            };
                            _proto3.moveCursor = function moveCursor(relPos) {
                                var newPos = this.pos + relPos;
                                if (relPos > 1) for(var i = this.pos + 1; i < newPos + 1; i++)this.chars[i].setPenState(this.currPenState);
                                this.setCursor(newPos);
                            };
                            _proto3.backSpace = function backSpace() {
                                this.moveCursor(-1);
                                this.chars[this.pos].setChar(' ', this.currPenState);
                            };
                            _proto3.insertChar = function insertChar(byte) {
                                if (byte >= 0x90) // Extended char
                                this.backSpace();
                                var char = getCharForByte(byte);
                                if (this.pos >= NR_COLS) {
                                    cea_608_parser_logger.log('ERROR', 'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
                                    return;
                                }
                                this.chars[this.pos].setChar(char, this.currPenState);
                                this.moveCursor(1);
                            };
                            _proto3.clearFromPos = function clearFromPos(startPos) {
                                var i;
                                for(i = startPos; i < NR_COLS; i++)this.chars[i].reset();
                            };
                            _proto3.clear = function clear() {
                                this.clearFromPos(0);
                                this.pos = 0;
                                this.currPenState.reset();
                            };
                            _proto3.clearToEndOfRow = function clearToEndOfRow() {
                                this.clearFromPos(this.pos);
                            };
                            _proto3.getTextString = function getTextString() {
                                var chars = [];
                                var empty = true;
                                for(var i = 0; i < NR_COLS; i++){
                                    var char = this.chars[i].uchar;
                                    if (char !== ' ') empty = false;
                                    chars.push(char);
                                }
                                if (empty) return '';
                                else return chars.join('');
                            };
                            _proto3.setPenStyles = function setPenStyles(styles) {
                                this.currPenState.setStyles(styles);
                                var currChar = this.chars[this.pos];
                                currChar.setPenState(this.currPenState);
                            };
                            return Row;
                        }();
                        /**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
*/ var CaptionScreen = /*#__PURE__*/ function() {
                            function CaptionScreen() {
                                this.rows = void 0;
                                this.currRow = void 0;
                                this.nrRollUpRows = void 0;
                                this.lastOutputScreen = void 0;
                                this.rows = [];
                                for(var i = 0; i < NR_ROWS; i++)this.rows.push(new Row());
                                 // Note that we use zero-based numbering (0-14)
                                this.currRow = NR_ROWS - 1;
                                this.nrRollUpRows = null;
                                this.reset();
                            }
                            var _proto4 = CaptionScreen.prototype;
                            _proto4.reset = function reset() {
                                for(var i = 0; i < NR_ROWS; i++)this.rows[i].clear();
                                this.currRow = NR_ROWS - 1;
                            };
                            _proto4.equals = function equals(other) {
                                var equal = true;
                                for(var i = 0; i < NR_ROWS; i++)if (!this.rows[i].equals(other.rows[i])) {
                                    equal = false;
                                    break;
                                }
                                return equal;
                            };
                            _proto4.copy = function copy(other) {
                                for(var i = 0; i < NR_ROWS; i++)this.rows[i].copy(other.rows[i]);
                            };
                            _proto4.isEmpty = function isEmpty() {
                                var empty = true;
                                for(var i = 0; i < NR_ROWS; i++)if (!this.rows[i].isEmpty()) {
                                    empty = false;
                                    break;
                                }
                                return empty;
                            };
                            _proto4.backSpace = function backSpace() {
                                var row = this.rows[this.currRow];
                                row.backSpace();
                            };
                            _proto4.clearToEndOfRow = function clearToEndOfRow() {
                                var row = this.rows[this.currRow];
                                row.clearToEndOfRow();
                            };
                            _proto4.insertChar = function insertChar(char) {
                                var row = this.rows[this.currRow];
                                row.insertChar(char);
                            };
                            _proto4.setPen = function setPen(styles) {
                                var row = this.rows[this.currRow];
                                row.setPenStyles(styles);
                            };
                            _proto4.moveCursor = function moveCursor(relPos) {
                                var row = this.rows[this.currRow];
                                row.moveCursor(relPos);
                            };
                            _proto4.setCursor = function setCursor(absPos) {
                                cea_608_parser_logger.log('INFO', 'setCursor: ' + absPos);
                                var row = this.rows[this.currRow];
                                row.setCursor(absPos);
                            };
                            _proto4.setPAC = function setPAC(pacData) {
                                cea_608_parser_logger.log('INFO', 'pacData = ' + JSON.stringify(pacData));
                                var newRow = pacData.row - 1;
                                if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) newRow = this.nrRollUpRows - 1;
                                 // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
                                if (this.nrRollUpRows && this.currRow !== newRow) {
                                    // clear all rows first
                                    for(var i = 0; i < NR_ROWS; i++)this.rows[i].clear();
                                     // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
                                    // topRowIndex - the start of rows to copy (inclusive index)
                                    var topRowIndex = this.currRow + 1 - this.nrRollUpRows; // We only copy if the last position was already shown.
                                    // We use the cueStartTime value to check this.
                                    var lastOutputScreen = this.lastOutputScreen;
                                    if (lastOutputScreen) {
                                        var prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
                                        if (prevLineTime && cea_608_parser_logger.time && prevLineTime < cea_608_parser_logger.time) for(var _i = 0; _i < this.nrRollUpRows; _i++)this.rows[newRow - this.nrRollUpRows + _i + 1].copy(lastOutputScreen.rows[topRowIndex + _i]);
                                    }
                                }
                                this.currRow = newRow;
                                var row = this.rows[this.currRow];
                                if (pacData.indent !== null) {
                                    var indent = pacData.indent;
                                    var prevPos = Math.max(indent - 1, 0);
                                    row.setCursor(pacData.indent);
                                    pacData.color = row.chars[prevPos].penState.foreground;
                                }
                                var styles = {
                                    foreground: pacData.color,
                                    underline: pacData.underline,
                                    italics: pacData.italics,
                                    background: 'black',
                                    flash: false
                                };
                                this.setPen(styles);
                            };
                            _proto4.setBkgData = function setBkgData(bkgData) {
                                cea_608_parser_logger.log('INFO', 'bkgData = ' + JSON.stringify(bkgData));
                                this.backSpace();
                                this.setPen(bkgData);
                                this.insertChar(0x20); // Space
                            };
                            _proto4.setRollUpRows = function setRollUpRows(nrRows) {
                                this.nrRollUpRows = nrRows;
                            };
                            _proto4.rollUp = function rollUp() {
                                if (this.nrRollUpRows === null) {
                                    cea_608_parser_logger.log('DEBUG', 'roll_up but nrRollUpRows not set yet');
                                    return; // Not properly setup
                                }
                                cea_608_parser_logger.log('TEXT', this.getDisplayText());
                                var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
                                var topRow = this.rows.splice(topRowIndex, 1)[0];
                                topRow.clear();
                                this.rows.splice(this.currRow, 0, topRow);
                                cea_608_parser_logger.log('INFO', 'Rolling up'); // logger.log('TEXT', this.get_display_text())
                            };
                            _proto4.getDisplayText = function getDisplayText(asOneRow) {
                                asOneRow = asOneRow || false;
                                var displayText = [];
                                var text = '';
                                var rowNr = -1;
                                for(var i = 0; i < NR_ROWS; i++){
                                    var rowText = this.rows[i].getTextString();
                                    if (rowText) {
                                        rowNr = i + 1;
                                        if (asOneRow) displayText.push('Row ' + rowNr + ': \'' + rowText + '\'');
                                        else displayText.push(rowText.trim());
                                    }
                                }
                                if (displayText.length > 0) {
                                    if (asOneRow) text = '[' + displayText.join(' | ') + ']';
                                    else text = displayText.join('\n');
                                }
                                return text;
                            };
                            _proto4.getTextAndFormat = function getTextAndFormat() {
                                return this.rows;
                            };
                            return CaptionScreen;
                        }(); // var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];
                        var Cea608Channel = /*#__PURE__*/ function() {
                            function Cea608Channel(channelNumber, outputFilter) {
                                this.chNr = void 0;
                                this.outputFilter = void 0;
                                this.mode = void 0;
                                this.verbose = void 0;
                                this.displayedMemory = void 0;
                                this.nonDisplayedMemory = void 0;
                                this.lastOutputScreen = void 0;
                                this.currRollUpRow = void 0;
                                this.writeScreen = void 0;
                                this.cueStartTime = void 0;
                                this.lastCueEndTime = void 0;
                                this.chNr = channelNumber;
                                this.outputFilter = outputFilter;
                                this.mode = null;
                                this.verbose = 0;
                                this.displayedMemory = new CaptionScreen();
                                this.nonDisplayedMemory = new CaptionScreen();
                                this.lastOutputScreen = new CaptionScreen();
                                this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
                                this.writeScreen = this.displayedMemory;
                                this.mode = null;
                                this.cueStartTime = null; // Keeps track of where a cue started.
                            }
                            var _proto5 = Cea608Channel.prototype;
                            _proto5.reset = function reset() {
                                this.mode = null;
                                this.displayedMemory.reset();
                                this.nonDisplayedMemory.reset();
                                this.lastOutputScreen.reset();
                                this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
                                this.writeScreen = this.displayedMemory;
                                this.mode = null;
                                this.cueStartTime = null;
                            };
                            _proto5.getHandler = function getHandler() {
                                return this.outputFilter;
                            };
                            _proto5.setHandler = function setHandler(newHandler) {
                                this.outputFilter = newHandler;
                            };
                            _proto5.setPAC = function setPAC(pacData) {
                                this.writeScreen.setPAC(pacData);
                            };
                            _proto5.setBkgData = function setBkgData(bkgData) {
                                this.writeScreen.setBkgData(bkgData);
                            };
                            _proto5.setMode = function setMode(newMode) {
                                if (newMode === this.mode) return;
                                this.mode = newMode;
                                cea_608_parser_logger.log('INFO', 'MODE=' + newMode);
                                if (this.mode === 'MODE_POP-ON') this.writeScreen = this.nonDisplayedMemory;
                                else {
                                    this.writeScreen = this.displayedMemory;
                                    this.writeScreen.reset();
                                }
                                if (this.mode !== 'MODE_ROLL-UP') {
                                    this.displayedMemory.nrRollUpRows = null;
                                    this.nonDisplayedMemory.nrRollUpRows = null;
                                }
                                this.mode = newMode;
                            };
                            _proto5.insertChars = function insertChars(chars) {
                                for(var i = 0; i < chars.length; i++)this.writeScreen.insertChar(chars[i]);
                                var screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
                                cea_608_parser_logger.log('INFO', screen + ': ' + this.writeScreen.getDisplayText(true));
                                if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
                                    cea_608_parser_logger.log('TEXT', 'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
                                    this.outputDataUpdate();
                                }
                            };
                            _proto5.ccRCL = function ccRCL() {
                                // Resume Caption Loading (switch mode to Pop On)
                                cea_608_parser_logger.log('INFO', 'RCL - Resume Caption Loading');
                                this.setMode('MODE_POP-ON');
                            };
                            _proto5.ccBS = function ccBS() {
                                // BackSpace
                                cea_608_parser_logger.log('INFO', 'BS - BackSpace');
                                if (this.mode === 'MODE_TEXT') return;
                                this.writeScreen.backSpace();
                                if (this.writeScreen === this.displayedMemory) this.outputDataUpdate();
                            };
                            _proto5.ccAOF = function ccAOF() {};
                            _proto5.ccAON = function ccAON() {};
                            _proto5.ccDER = function ccDER() {
                                // Delete to End of Row
                                cea_608_parser_logger.log('INFO', 'DER- Delete to End of Row');
                                this.writeScreen.clearToEndOfRow();
                                this.outputDataUpdate();
                            };
                            _proto5.ccRU = function ccRU(nrRows) {
                                // Roll-Up Captions-2,3,or 4 Rows
                                cea_608_parser_logger.log('INFO', 'RU(' + nrRows + ') - Roll Up');
                                this.writeScreen = this.displayedMemory;
                                this.setMode('MODE_ROLL-UP');
                                this.writeScreen.setRollUpRows(nrRows);
                            };
                            _proto5.ccFON = function ccFON() {
                                // Flash On
                                cea_608_parser_logger.log('INFO', 'FON - Flash On');
                                this.writeScreen.setPen({
                                    flash: true
                                });
                            };
                            _proto5.ccRDC = function ccRDC() {
                                // Resume Direct Captioning (switch mode to PaintOn)
                                cea_608_parser_logger.log('INFO', 'RDC - Resume Direct Captioning');
                                this.setMode('MODE_PAINT-ON');
                            };
                            _proto5.ccTR = function ccTR() {
                                // Text Restart in text mode (not supported, however)
                                cea_608_parser_logger.log('INFO', 'TR');
                                this.setMode('MODE_TEXT');
                            };
                            _proto5.ccRTD = function ccRTD() {
                                // Resume Text Display in Text mode (not supported, however)
                                cea_608_parser_logger.log('INFO', 'RTD');
                                this.setMode('MODE_TEXT');
                            };
                            _proto5.ccEDM = function ccEDM() {
                                // Erase Displayed Memory
                                cea_608_parser_logger.log('INFO', 'EDM - Erase Displayed Memory');
                                this.displayedMemory.reset();
                                this.outputDataUpdate(true);
                            };
                            _proto5.ccCR = function ccCR() {
                                // Carriage Return
                                cea_608_parser_logger.log('INFO', 'CR - Carriage Return');
                                this.writeScreen.rollUp();
                                this.outputDataUpdate(true);
                            };
                            _proto5.ccENM = function ccENM() {
                                // Erase Non-Displayed Memory
                                cea_608_parser_logger.log('INFO', 'ENM - Erase Non-displayed Memory');
                                this.nonDisplayedMemory.reset();
                            };
                            _proto5.ccEOC = function ccEOC() {
                                // End of Caption (Flip Memories)
                                cea_608_parser_logger.log('INFO', 'EOC - End Of Caption');
                                if (this.mode === 'MODE_POP-ON') {
                                    var tmp = this.displayedMemory;
                                    this.displayedMemory = this.nonDisplayedMemory;
                                    this.nonDisplayedMemory = tmp;
                                    this.writeScreen = this.nonDisplayedMemory;
                                    cea_608_parser_logger.log('TEXT', 'DISP: ' + this.displayedMemory.getDisplayText());
                                }
                                this.outputDataUpdate(true);
                            };
                            _proto5.ccTO = function ccTO(nrCols) {
                                // Tab Offset 1,2, or 3 columns
                                cea_608_parser_logger.log('INFO', 'TO(' + nrCols + ') - Tab Offset');
                                this.writeScreen.moveCursor(nrCols);
                            };
                            _proto5.ccMIDROW = function ccMIDROW(secondByte) {
                                // Parse MIDROW command
                                var styles = {
                                    flash: false
                                };
                                styles.underline = secondByte % 2 === 1;
                                styles.italics = secondByte >= 0x2e;
                                if (!styles.italics) {
                                    var colorIndex = Math.floor(secondByte / 2) - 0x10;
                                    var colors = [
                                        'white',
                                        'green',
                                        'blue',
                                        'cyan',
                                        'red',
                                        'yellow',
                                        'magenta'
                                    ];
                                    styles.foreground = colors[colorIndex];
                                } else styles.foreground = 'white';
                                cea_608_parser_logger.log('INFO', 'MIDROW: ' + JSON.stringify(styles));
                                this.writeScreen.setPen(styles);
                            };
                            _proto5.outputDataUpdate = function outputDataUpdate(dispatch) {
                                if (dispatch === void 0) dispatch = false;
                                var t = cea_608_parser_logger.time;
                                if (t === null) return;
                                if (this.outputFilter) {
                                    if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) // Start of a new cue
                                    this.cueStartTime = t;
                                    else if (!this.displayedMemory.equals(this.lastOutputScreen)) {
                                        this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen);
                                        if (dispatch && this.outputFilter.dispatchCue) this.outputFilter.dispatchCue();
                                        this.cueStartTime = this.displayedMemory.isEmpty() ? null : t;
                                    }
                                    this.lastOutputScreen.copy(this.displayedMemory);
                                }
                            };
                            _proto5.cueSplitAtTime = function cueSplitAtTime(t) {
                                if (this.outputFilter) {
                                    if (!this.displayedMemory.isEmpty()) {
                                        if (this.outputFilter.newCue) this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
                                        this.cueStartTime = t;
                                    }
                                }
                            };
                            return Cea608Channel;
                        }();
                        var Cea608Parser = /*#__PURE__*/ function() {
                            function Cea608Parser(field, out1, out2) {
                                this.field = void 0;
                                this.outputs = void 0;
                                this.channels = void 0;
                                this.currChNr = void 0;
                                this.lastCmdA = void 0;
                                this.lastCmdB = void 0;
                                this.lastTime = void 0;
                                this.dataCounters = void 0;
                                this.field = field || 1;
                                this.outputs = [
                                    out1,
                                    out2
                                ];
                                this.channels = [
                                    new Cea608Channel(1, out1),
                                    new Cea608Channel(2, out2)
                                ];
                                this.currChNr = -1; // Will be 1 or 2
                                this.lastCmdA = null; // First byte of last command
                                this.lastCmdB = null; // Second byte of last command
                                this.lastTime = null;
                                this.dataCounters = {
                                    'padding': 0,
                                    'char': 0,
                                    'cmd': 0,
                                    'other': 0
                                };
                            }
                            var _proto6 = Cea608Parser.prototype;
                            _proto6.getHandler = function getHandler(index) {
                                return this.channels[index].getHandler();
                            };
                            _proto6.setHandler = function setHandler(index, newHandler) {
                                this.channels[index].setHandler(newHandler);
                            };
                            _proto6.addData = function addData(t, byteList) {
                                var cmdFound, a, b, charsFound = false;
                                this.lastTime = t;
                                cea_608_parser_logger.setTime(t);
                                for(var i = 0; i < byteList.length; i += 2){
                                    a = byteList[i] & 0x7f;
                                    b = byteList[i + 1] & 0x7f;
                                    if (a === 0 && b === 0) {
                                        this.dataCounters.padding += 2;
                                        continue;
                                    } else cea_608_parser_logger.log('DATA', '[' + numArrayToHexArray([
                                        byteList[i],
                                        byteList[i + 1]
                                    ]) + '] -> (' + numArrayToHexArray([
                                        a,
                                        b
                                    ]) + ')');
                                    cmdFound = this.parseCmd(a, b);
                                    if (!cmdFound) cmdFound = this.parseMidrow(a, b);
                                    if (!cmdFound) cmdFound = this.parsePAC(a, b);
                                    if (!cmdFound) cmdFound = this.parseBackgroundAttributes(a, b);
                                    if (!cmdFound) {
                                        charsFound = this.parseChars(a, b);
                                        if (charsFound) {
                                            if (this.currChNr && this.currChNr >= 0) {
                                                var channel = this.channels[this.currChNr - 1];
                                                channel.insertChars(charsFound);
                                            } else cea_608_parser_logger.log('WARNING', 'No channel found yet. TEXT-MODE?');
                                        }
                                    }
                                    if (cmdFound) this.dataCounters.cmd += 2;
                                    else if (charsFound) this.dataCounters.char += 2;
                                    else {
                                        this.dataCounters.other += 2;
                                        cea_608_parser_logger.log('WARNING', 'Couldn\'t parse cleaned data ' + numArrayToHexArray([
                                            a,
                                            b
                                        ]) + ' orig: ' + numArrayToHexArray([
                                            byteList[i],
                                            byteList[i + 1]
                                        ]));
                                    }
                                }
                            };
                            _proto6.parseCmd = function parseCmd(a, b) {
                                var chNr = null;
                                var cond1 = (a === 0x14 || a === 0x1C) && b >= 0x20 && b <= 0x2F;
                                var cond2 = (a === 0x17 || a === 0x1F) && b >= 0x21 && b <= 0x23;
                                if (!(cond1 || cond2)) return false;
                                if (a === this.lastCmdA && b === this.lastCmdB) {
                                    this.lastCmdA = null;
                                    this.lastCmdB = null; // Repeated commands are dropped (once)
                                    cea_608_parser_logger.log('DEBUG', 'Repeated command (' + numArrayToHexArray([
                                        a,
                                        b
                                    ]) + ') is dropped');
                                    return true;
                                }
                                if (a === 0x14 || a === 0x17) chNr = 1;
                                else chNr = 2;
                                 // (a === 0x1C || a=== 0x1f)
                                var channel = this.channels[chNr - 1];
                                if (a === 0x14 || a === 0x1C) {
                                    if (b === 0x20) channel.ccRCL();
                                    else if (b === 0x21) channel.ccBS();
                                    else if (b === 0x22) channel.ccAOF();
                                    else if (b === 0x23) channel.ccAON();
                                    else if (b === 0x24) channel.ccDER();
                                    else if (b === 0x25) channel.ccRU(2);
                                    else if (b === 0x26) channel.ccRU(3);
                                    else if (b === 0x27) channel.ccRU(4);
                                    else if (b === 0x28) channel.ccFON();
                                    else if (b === 0x29) channel.ccRDC();
                                    else if (b === 0x2A) channel.ccTR();
                                    else if (b === 0x2B) channel.ccRTD();
                                    else if (b === 0x2C) channel.ccEDM();
                                    else if (b === 0x2D) channel.ccCR();
                                    else if (b === 0x2E) channel.ccENM();
                                    else if (b === 0x2F) channel.ccEOC();
                                } else // a == 0x17 || a == 0x1F
                                channel.ccTO(b - 0x20);
                                this.lastCmdA = a;
                                this.lastCmdB = b;
                                this.currChNr = chNr;
                                return true;
                            };
                            _proto6.parseMidrow = function parseMidrow(a, b) {
                                var chNr = null;
                                if ((a === 0x11 || a === 0x19) && b >= 0x20 && b <= 0x2f) {
                                    if (a === 0x11) chNr = 1;
                                    else chNr = 2;
                                    if (chNr !== this.currChNr) {
                                        cea_608_parser_logger.log('ERROR', 'Mismatch channel in midrow parsing');
                                        return false;
                                    }
                                    var channel = this.channels[chNr - 1];
                                    channel.ccMIDROW(b);
                                    cea_608_parser_logger.log('DEBUG', 'MIDROW (' + numArrayToHexArray([
                                        a,
                                        b
                                    ]) + ')');
                                    return true;
                                }
                                return false;
                            };
                            _proto6.parsePAC = function parsePAC(a, b) {
                                var chNr = null;
                                var row = null;
                                var case1 = (a >= 0x11 && a <= 0x17 || a >= 0x19 && a <= 0x1F) && b >= 0x40 && b <= 0x7F;
                                var case2 = (a === 0x10 || a === 0x18) && b >= 0x40 && b <= 0x5F;
                                if (!(case1 || case2)) return false;
                                if (a === this.lastCmdA && b === this.lastCmdB) {
                                    this.lastCmdA = null;
                                    this.lastCmdB = null;
                                    return true; // Repeated commands are dropped (once)
                                }
                                chNr = a <= 0x17 ? 1 : 2;
                                if (b >= 0x40 && b <= 0x5F) row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
                                else // 0x60 <= b <= 0x7F
                                row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
                                var pacData = this.interpretPAC(row, b);
                                var channel = this.channels[chNr - 1];
                                channel.setPAC(pacData);
                                this.lastCmdA = a;
                                this.lastCmdB = b;
                                this.currChNr = chNr;
                                return true;
                            };
                            _proto6.interpretPAC = function interpretPAC(row, byte) {
                                var pacIndex = byte;
                                var pacData = {
                                    color: null,
                                    italics: false,
                                    indent: null,
                                    underline: false,
                                    row: row
                                };
                                if (byte > 0x5F) pacIndex = byte - 0x60;
                                else pacIndex = byte - 0x40;
                                pacData.underline = (pacIndex & 1) === 1;
                                if (pacIndex <= 0xd) pacData.color = [
                                    'white',
                                    'green',
                                    'blue',
                                    'cyan',
                                    'red',
                                    'yellow',
                                    'magenta',
                                    'white'
                                ][Math.floor(pacIndex / 2)];
                                else if (pacIndex <= 0xf) {
                                    pacData.italics = true;
                                    pacData.color = 'white';
                                } else pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
                                return pacData; // Note that row has zero offset. The spec uses 1.
                            };
                            _proto6.parseChars = function parseChars(a, b) {
                                var channelNr = null, charCodes = null, charCode1 = null;
                                if (a >= 0x19) {
                                    channelNr = 2;
                                    charCode1 = a - 8;
                                } else {
                                    channelNr = 1;
                                    charCode1 = a;
                                }
                                if (charCode1 >= 0x11 && charCode1 <= 0x13) {
                                    // Special character
                                    var oneCode = b;
                                    if (charCode1 === 0x11) oneCode = b + 0x50;
                                    else if (charCode1 === 0x12) oneCode = b + 0x70;
                                    else oneCode = b + 0x90;
                                    cea_608_parser_logger.log('INFO', 'Special char \'' + getCharForByte(oneCode) + '\' in channel ' + channelNr);
                                    charCodes = [
                                        oneCode
                                    ];
                                } else if (a >= 0x20 && a <= 0x7f) charCodes = b === 0 ? [
                                    a
                                ] : [
                                    a,
                                    b
                                ];
                                if (charCodes) {
                                    var hexCodes = numArrayToHexArray(charCodes);
                                    cea_608_parser_logger.log('DEBUG', 'Char codes =  ' + hexCodes.join(','));
                                    this.lastCmdA = null;
                                    this.lastCmdB = null;
                                }
                                return charCodes;
                            };
                            _proto6.parseBackgroundAttributes = function parseBackgroundAttributes(a, b) {
                                var bkgData, index, chNr, channel;
                                var case1 = (a === 0x10 || a === 0x18) && b >= 0x20 && b <= 0x2f;
                                var case2 = (a === 0x17 || a === 0x1f) && b >= 0x2d && b <= 0x2f;
                                if (!(case1 || case2)) return false;
                                bkgData = {};
                                if (a === 0x10 || a === 0x18) {
                                    index = Math.floor((b - 0x20) / 2);
                                    bkgData.background = backgroundColors[index];
                                    if (b % 2 === 1) bkgData.background = bkgData.background + '_semi';
                                } else if (b === 0x2d) bkgData.background = 'transparent';
                                else {
                                    bkgData.foreground = 'black';
                                    if (b === 0x2f) bkgData.underline = true;
                                }
                                chNr = a < 0x18 ? 1 : 2;
                                channel = this.channels[chNr - 1];
                                channel.setBkgData(bkgData);
                                this.lastCmdA = null;
                                this.lastCmdB = null;
                                return true;
                            };
                            _proto6.reset = function reset() {
                                for(var i = 0; i < this.channels.length; i++)if (this.channels[i]) this.channels[i].reset();
                                this.lastCmdA = null;
                                this.lastCmdB = null;
                            };
                            _proto6.cueSplitAtTime = function cueSplitAtTime(t) {
                                for(var i = 0; i < this.channels.length; i++)if (this.channels[i]) this.channels[i].cueSplitAtTime(t);
                            };
                            return Cea608Parser;
                        }();
                        /* harmony default export */ var cea_608_parser = Cea608Parser;
                        // CONCATENATED MODULE: ./src/utils/output-filter.ts
                        var OutputFilter = /*#__PURE__*/ function() {
                            // TODO(typescript-timelineController)
                            function OutputFilter(timelineController, trackName) {
                                this.timelineController = void 0;
                                this.trackName = void 0;
                                this.startTime = void 0;
                                this.endTime = void 0;
                                this.screen = void 0;
                                this.timelineController = timelineController;
                                this.trackName = trackName;
                                this.startTime = null;
                                this.endTime = null;
                                this.screen = null;
                            }
                            var _proto = OutputFilter.prototype;
                            _proto.dispatchCue = function dispatchCue() {
                                if (this.startTime === null) return;
                                this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen);
                                this.startTime = null;
                            };
                            _proto.newCue = function newCue(startTime, endTime, screen) {
                                if (this.startTime === null || this.startTime > startTime) this.startTime = startTime;
                                this.endTime = endTime;
                                this.screen = screen;
                                this.timelineController.createCaptionsTrack(this.trackName);
                            };
                            return OutputFilter;
                        }();
                        // CONCATENATED MODULE: ./src/utils/webvtt-parser.js
                        // String.prototype.startsWith is not supported in IE11
                        var startsWith = function startsWith(inputString, searchString, position) {
                            return inputString.substr(position || 0, searchString.length) === searchString;
                        };
                        var webvtt_parser_cueString2millis = function cueString2millis(timeString) {
                            var ts = parseInt(timeString.substr(-3));
                            var secs = parseInt(timeString.substr(-6, 2));
                            var mins = parseInt(timeString.substr(-9, 2));
                            var hours = timeString.length > 9 ? parseInt(timeString.substr(0, timeString.indexOf(':'))) : 0;
                            if (!Object(number_isFinite["isFiniteNumber"])(ts) || !Object(number_isFinite["isFiniteNumber"])(secs) || !Object(number_isFinite["isFiniteNumber"])(mins) || !Object(number_isFinite["isFiniteNumber"])(hours)) throw Error("Malformed X-TIMESTAMP-MAP: Local:" + timeString);
                            ts += 1000 * secs;
                            ts += 60000 * mins;
                            ts += 3600000 * hours;
                            return ts;
                        }; // From https://github.com/darkskyapp/string-hash
                        var hash = function hash(text) {
                            var hash = 5381;
                            var i = text.length;
                            while(i)hash = hash * 33 ^ text.charCodeAt(--i);
                            return (hash >>> 0).toString();
                        };
                        var calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
                            var currCC = vttCCs[cc];
                            var prevCC = vttCCs[currCC.prevCC]; // This is the first discontinuity or cues have been processed since the last discontinuity
                            // Offset = current discontinuity time
                            if (!prevCC || !prevCC.new && currCC.new) {
                                vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
                                currCC.new = false;
                                return;
                            } // There have been discontinuities since cues were last parsed.
                            // Offset = time elapsed
                            while(prevCC && prevCC.new){
                                vttCCs.ccOffset += currCC.start - prevCC.start;
                                currCC.new = false;
                                currCC = prevCC;
                                prevCC = vttCCs[currCC.prevCC];
                            }
                            vttCCs.presentationOffset = presentationTime;
                        };
                        var WebVTTParser = {
                            parse: function parse(vttByteArray, syncPTS, vttCCs, cc, callBack, errorCallBack) {
                                // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
                                var re = /\r\n|\n\r|\n|\r/g; // Uint8Array.prototype.reduce is not implemented in IE11
                                var vttLines = Object(id3["utf8ArrayToStr"])(new Uint8Array(vttByteArray)).trim().replace(re, '\n').split('\n');
                                var cueTime = '00:00.000';
                                var mpegTs = 0;
                                var localTime = 0;
                                var presentationTime = 0;
                                var cues = [];
                                var parsingError;
                                var inHeader = true;
                                var timestampMap = false; // let VTTCue = VTTCue || window.TextTrackCue;
                                // Create parser object using VTTCue with TextTrackCue fallback on certain browsers.
                                var parser = new vttparser();
                                parser.oncue = function(cue) {
                                    // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
                                    var currCC = vttCCs[cc];
                                    var cueOffset = vttCCs.ccOffset; // Update offsets for new discontinuities
                                    if (currCC && currCC.new) {
                                        if (localTime !== undefined) // When local time is provided, offset = discontinuity start time - local time
                                        cueOffset = vttCCs.ccOffset = currCC.start;
                                        else calculateOffset(vttCCs, cc, presentationTime);
                                    }
                                    if (presentationTime) // If we have MPEGTS, offset = presentation time + discontinuity offset
                                    cueOffset = presentationTime - vttCCs.presentationOffset;
                                    if (timestampMap) {
                                        cue.startTime += cueOffset - localTime;
                                        cue.endTime += cueOffset - localTime;
                                    } // Create a unique hash id for a cue based on start/end times and text.
                                    // This helps timeline-controller to avoid showing repeated captions.
                                    cue.id = hash(cue.startTime.toString()) + hash(cue.endTime.toString()) + hash(cue.text); // Fix encoding of special characters. TODO: Test with all sorts of weird characters.
                                    cue.text = decodeURIComponent(encodeURIComponent(cue.text));
                                    if (cue.endTime > 0) cues.push(cue);
                                };
                                parser.onparsingerror = function(e) {
                                    parsingError = e;
                                };
                                parser.onflush = function() {
                                    if (parsingError && errorCallBack) {
                                        errorCallBack(parsingError);
                                        return;
                                    }
                                    callBack(cues);
                                }; // Go through contents line by line.
                                vttLines.forEach(function(line) {
                                    if (inHeader) {
                                        // Look for X-TIMESTAMP-MAP in header.
                                        if (startsWith(line, 'X-TIMESTAMP-MAP=')) {
                                            // Once found, no more are allowed anyway, so stop searching.
                                            inHeader = false;
                                            timestampMap = true; // Extract LOCAL and MPEGTS.
                                            line.substr(16).split(',').forEach(function(timestamp) {
                                                if (startsWith(timestamp, 'LOCAL:')) cueTime = timestamp.substr(6);
                                                else if (startsWith(timestamp, 'MPEGTS:')) mpegTs = parseInt(timestamp.substr(7));
                                            });
                                            try {
                                                // Calculate subtitle offset in milliseconds.
                                                if (syncPTS + (vttCCs[cc].start * 90000 || 0) < 0) syncPTS += 8589934592;
                                                 // Adjust MPEGTS by sync PTS.
                                                mpegTs -= syncPTS; // Convert cue time to seconds
                                                localTime = webvtt_parser_cueString2millis(cueTime) / 1000; // Convert MPEGTS to seconds from 90kHz.
                                                presentationTime = mpegTs / 90000;
                                            } catch (e) {
                                                timestampMap = false;
                                                parsingError = e;
                                            } // Return without parsing X-TIMESTAMP-MAP line.
                                            return;
                                        } else if (line === '') inHeader = false;
                                    } // Parse line by default.
                                    parser.parse(line + '\n');
                                });
                                parser.flush();
                            }
                        };
                        /* harmony default export */ var webvtt_parser = WebVTTParser;
                        // CONCATENATED MODULE: ./src/controller/timeline-controller.ts
                        function timeline_controller_assertThisInitialized(self1) {
                            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return self1;
                        }
                        function timeline_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        // TS todo: Reduce usage of any
                        var timeline_controller_TimelineController = /*#__PURE__*/ function(_EventHandler) {
                            timeline_controller_inheritsLoose(TimelineController, _EventHandler);
                            function TimelineController(hls) {
                                var _this;
                                _this = _EventHandler.call(this, hls, events["default"].MEDIA_ATTACHING, events["default"].MEDIA_DETACHING, events["default"].FRAG_PARSING_USERDATA, events["default"].FRAG_DECRYPTED, events["default"].MANIFEST_LOADING, events["default"].MANIFEST_LOADED, events["default"].FRAG_LOADED, events["default"].INIT_PTS_FOUND) || this;
                                _this.media = null;
                                _this.config = void 0;
                                _this.enabled = true;
                                _this.Cues = void 0;
                                _this.textTracks = [];
                                _this.tracks = [];
                                _this.initPTS = [];
                                _this.unparsedVttFrags = [];
                                _this.cueRanges = [];
                                _this.captionsTracks = {};
                                _this.captionsProperties = void 0;
                                _this.cea608Parser = void 0;
                                _this.lastSn = -1;
                                _this.prevCC = -1;
                                _this.vttCCs = null;
                                _this.hls = hls;
                                _this.config = hls.config;
                                _this.Cues = hls.config.cueHandler;
                                _this.captionsProperties = {
                                    textTrack1: {
                                        label: _this.config.captionsTextTrack1Label,
                                        languageCode: _this.config.captionsTextTrack1LanguageCode
                                    },
                                    textTrack2: {
                                        label: _this.config.captionsTextTrack2Label,
                                        languageCode: _this.config.captionsTextTrack2LanguageCode
                                    }
                                };
                                if (_this.config.enableCEA708Captions) {
                                    var channel1 = new OutputFilter(timeline_controller_assertThisInitialized(_this), 'textTrack1');
                                    var channel2 = new OutputFilter(timeline_controller_assertThisInitialized(_this), 'textTrack2');
                                    _this.cea608Parser = new cea_608_parser(0, channel1, channel2);
                                }
                                return _this;
                            }
                            var _proto = TimelineController.prototype;
                            _proto.addCues = function addCues(trackName, startTime, endTime, screen) {
                                // skip cues which overlap more than 50% with previously parsed time ranges
                                var ranges = this.cueRanges;
                                var merged = false;
                                for(var i = ranges.length; i--;){
                                    var cueRange = ranges[i];
                                    var overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
                                    if (overlap >= 0) {
                                        cueRange[0] = Math.min(cueRange[0], startTime);
                                        cueRange[1] = Math.max(cueRange[1], endTime);
                                        merged = true;
                                        if (overlap / (endTime - startTime) > 0.5) return;
                                    }
                                }
                                if (!merged) ranges.push([
                                    startTime,
                                    endTime
                                ]);
                                this.Cues.newCue(this.captionsTracks[trackName], startTime, endTime, screen);
                            } // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
                            ;
                            _proto.onInitPtsFound = function onInitPtsFound(data) {
                                var _this2 = this;
                                var frag = data.frag, id = data.id, initPTS = data.initPTS;
                                var unparsedVttFrags = this.unparsedVttFrags;
                                if (id === 'main') this.initPTS[frag.cc] = initPTS;
                                 // Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
                                // Parse any unparsed fragments upon receiving the initial PTS.
                                if (unparsedVttFrags.length) {
                                    this.unparsedVttFrags = [];
                                    unparsedVttFrags.forEach(function(frag) {
                                        _this2.onFragLoaded(frag);
                                    });
                                }
                            };
                            _proto.getExistingTrack = function getExistingTrack(trackName) {
                                var media = this.media;
                                if (media) for(var i = 0; i < media.textTracks.length; i++){
                                    var textTrack = media.textTracks[i];
                                    if (textTrack[trackName]) return textTrack;
                                }
                                return null;
                            };
                            _proto.createCaptionsTrack = function createCaptionsTrack(trackName) {
                                var captionsProperties = this.captionsProperties, captionsTracks = this.captionsTracks, media = this.media;
                                var _captionsProperties$t = captionsProperties[trackName], label = _captionsProperties$t.label, languageCode = _captionsProperties$t.languageCode;
                                if (!captionsTracks[trackName]) {
                                    // Enable reuse of existing text track.
                                    var existingTrack = this.getExistingTrack(trackName);
                                    if (!existingTrack) {
                                        var textTrack = this.createTextTrack('captions', label, languageCode);
                                        if (textTrack) {
                                            // Set a special property on the track so we know it's managed by Hls.js
                                            textTrack[trackName] = true;
                                            captionsTracks[trackName] = textTrack;
                                        }
                                    } else {
                                        captionsTracks[trackName] = existingTrack;
                                        clearCurrentCues(captionsTracks[trackName]);
                                        sendAddTrackEvent(captionsTracks[trackName], media);
                                    }
                                }
                            };
                            _proto.createTextTrack = function createTextTrack(kind, label, lang) {
                                var media = this.media;
                                if (!media) return;
                                return media.addTextTrack(kind, label, lang);
                            };
                            _proto.destroy = function destroy() {
                                _EventHandler.prototype.destroy.call(this);
                            };
                            _proto.onMediaAttaching = function onMediaAttaching(data) {
                                this.media = data.media;
                                this._cleanTracks();
                            };
                            _proto.onMediaDetaching = function onMediaDetaching() {
                                var captionsTracks = this.captionsTracks;
                                Object.keys(captionsTracks).forEach(function(trackName) {
                                    clearCurrentCues(captionsTracks[trackName]);
                                    delete captionsTracks[trackName];
                                });
                            };
                            _proto.onManifestLoading = function onManifestLoading() {
                                this.lastSn = -1; // Detect discontiguity in fragment parsing
                                this.prevCC = -1;
                                this.vttCCs = {
                                    // Detect discontinuity in subtitle manifests
                                    ccOffset: 0,
                                    presentationOffset: 0,
                                    0: {
                                        start: 0,
                                        prevCC: -1,
                                        new: false
                                    }
                                };
                                this._cleanTracks();
                            };
                            _proto._cleanTracks = function _cleanTracks() {
                                // clear outdated subtitles
                                var media = this.media;
                                if (!media) return;
                                var textTracks = media.textTracks;
                                if (textTracks) for(var i = 0; i < textTracks.length; i++)clearCurrentCues(textTracks[i]);
                            };
                            _proto.onManifestLoaded = function onManifestLoaded(data) {
                                var _this3 = this;
                                this.textTracks = [];
                                this.unparsedVttFrags = this.unparsedVttFrags || [];
                                this.initPTS = [];
                                this.cueRanges = [];
                                if (this.config.enableWebVTT) {
                                    this.tracks = data.subtitles || [];
                                    var inUseTracks = this.media ? this.media.textTracks : [];
                                    this.tracks.forEach(function(track, index) {
                                        var textTrack;
                                        if (index < inUseTracks.length) {
                                            var inUseTrack = null;
                                            for(var i = 0; i < inUseTracks.length; i++)if (canReuseVttTextTrack(inUseTracks[i], track)) {
                                                inUseTrack = inUseTracks[i];
                                                break;
                                            }
                                             // Reuse tracks with the same label, but do not reuse 608/708 tracks
                                            if (inUseTrack) textTrack = inUseTrack;
                                        }
                                        if (!textTrack) textTrack = _this3.createTextTrack('subtitles', track.name, track.lang);
                                        if (track.default) textTrack.mode = _this3.hls.subtitleDisplay ? 'showing' : 'hidden';
                                        else textTrack.mode = 'disabled';
                                        _this3.textTracks.push(textTrack);
                                    });
                                }
                            };
                            _proto.onFragLoaded = function onFragLoaded(data) {
                                var frag = data.frag, payload = data.payload;
                                var cea608Parser = this.cea608Parser, initPTS = this.initPTS, lastSn = this.lastSn, unparsedVttFrags = this.unparsedVttFrags;
                                if (frag.type === 'main') {
                                    var sn = frag.sn; // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
                                    if (frag.sn !== lastSn + 1) {
                                        if (cea608Parser) cea608Parser.reset();
                                    }
                                    this.lastSn = sn;
                                } else if (frag.type === 'subtitle') {
                                    if (payload.byteLength) {
                                        // We need an initial synchronisation PTS. Store fragments as long as none has arrived.
                                        if (!Object(number_isFinite["isFiniteNumber"])(initPTS[frag.cc])) {
                                            unparsedVttFrags.push(data);
                                            if (initPTS.length) // finish unsuccessfully, otherwise the subtitle-stream-controller could be blocked from loading new frags.
                                            this.hls.trigger(events["default"].SUBTITLE_FRAG_PROCESSED, {
                                                success: false,
                                                frag: frag
                                            });
                                            return;
                                        }
                                        var decryptData = frag.decryptdata; // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
                                        if (decryptData == null || decryptData.key == null || decryptData.method !== 'AES-128') this._parseVTTs(frag, payload);
                                    } else // In case there is no payload, finish unsuccessfully.
                                    this.hls.trigger(events["default"].SUBTITLE_FRAG_PROCESSED, {
                                        success: false,
                                        frag: frag
                                    });
                                }
                            };
                            _proto._parseVTTs = function _parseVTTs(frag, payload) {
                                var hls = this.hls, prevCC = this.prevCC, textTracks = this.textTracks, vttCCs = this.vttCCs;
                                if (!vttCCs[frag.cc]) {
                                    vttCCs[frag.cc] = {
                                        start: frag.start,
                                        prevCC: prevCC,
                                        new: true
                                    };
                                    this.prevCC = frag.cc;
                                } // Parse the WebVTT file contents.
                                webvtt_parser.parse(payload, this.initPTS[frag.cc], vttCCs, frag.cc, function(cues) {
                                    var currentTrack = textTracks[frag.level]; // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
                                    // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
                                    // and trying to access getCueById method of cues will throw an exception
                                    if (currentTrack.mode === 'disabled') {
                                        hls.trigger(events["default"].SUBTITLE_FRAG_PROCESSED, {
                                            success: false,
                                            frag: frag
                                        });
                                        return;
                                    } // Add cues and trigger event with success true.
                                    cues.forEach(function(cue) {
                                        // Sometimes there are cue overlaps on segmented vtts so the same
                                        // cue can appear more than once in different vtt files.
                                        // This avoid showing duplicated cues with same timecode and text.
                                        if (!currentTrack.cues.getCueById(cue.id)) try {
                                            currentTrack.addCue(cue);
                                            if (!currentTrack.cues.getCueById(cue.id)) throw new Error("addCue is failed for: " + cue);
                                        } catch (err) {
                                            logger["logger"].debug("Failed occurred on adding cues: " + err);
                                            var textTrackCue = new window.TextTrackCue(cue.startTime, cue.endTime, cue.text);
                                            textTrackCue.id = cue.id;
                                            currentTrack.addCue(textTrackCue);
                                        }
                                    });
                                    hls.trigger(events["default"].SUBTITLE_FRAG_PROCESSED, {
                                        success: true,
                                        frag: frag
                                    });
                                }, function(e) {
                                    // Something went wrong while parsing. Trigger event with success false.
                                    logger["logger"].log("Failed to parse VTT cue: " + e);
                                    hls.trigger(events["default"].SUBTITLE_FRAG_PROCESSED, {
                                        success: false,
                                        frag: frag
                                    });
                                });
                            };
                            _proto.onFragDecrypted = function onFragDecrypted(data) {
                                var frag = data.frag, payload = data.payload;
                                if (frag.type === 'subtitle') {
                                    if (!Object(number_isFinite["isFiniteNumber"])(this.initPTS[frag.cc])) {
                                        this.unparsedVttFrags.push(data);
                                        return;
                                    }
                                    this._parseVTTs(frag, payload);
                                }
                            };
                            _proto.onFragParsingUserdata = function onFragParsingUserdata(data) {
                                if (!this.enabled || !this.cea608Parser) return;
                                 // If the event contains captions (found in the bytes property), push all bytes into the parser immediately
                                // It will create the proper timestamps based on the PTS value
                                for(var i = 0; i < data.samples.length; i++){
                                    var ccBytes = data.samples[i].bytes;
                                    if (ccBytes) {
                                        var ccdatas = this.extractCea608Data(ccBytes);
                                        this.cea608Parser.addData(data.samples[i].pts, ccdatas);
                                    }
                                }
                            };
                            _proto.extractCea608Data = function extractCea608Data(byteArray) {
                                var count = byteArray[0] & 31;
                                var position = 2;
                                var tmpByte, ccbyte1, ccbyte2, ccValid, ccType;
                                var actualCCBytes = [];
                                for(var j = 0; j < count; j++){
                                    tmpByte = byteArray[position++];
                                    ccbyte1 = 0x7F & byteArray[position++];
                                    ccbyte2 = 0x7F & byteArray[position++];
                                    ccValid = (4 & tmpByte) !== 0;
                                    ccType = 3 & tmpByte;
                                    if (ccbyte1 === 0 && ccbyte2 === 0) continue;
                                    if (ccValid) {
                                        if (ccType === 0) {
                                            // || ccType === 1
                                            actualCCBytes.push(ccbyte1);
                                            actualCCBytes.push(ccbyte2);
                                        }
                                    }
                                }
                                return actualCCBytes;
                            };
                            return TimelineController;
                        }(event_handler);
                        function canReuseVttTextTrack(inUseTrack, manifestTrack) {
                            return inUseTrack && inUseTrack.label === manifestTrack.name && !(inUseTrack.textTrack1 || inUseTrack.textTrack2);
                        }
                        function intersection(x1, x2, y1, y2) {
                            return Math.min(x2, y2) - Math.max(x1, y1);
                        }
                        /* harmony default export */ var timeline_controller = timeline_controller_TimelineController;
                        // CONCATENATED MODULE: ./src/controller/subtitle-track-controller.js
                        function subtitle_track_controller_defineProperties(target, props) {
                            for(var i = 0; i < props.length; i++){
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function subtitle_track_controller_createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) subtitle_track_controller_defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) subtitle_track_controller_defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        function subtitle_track_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        var subtitle_track_controller_SubtitleTrackController = /*#__PURE__*/ function(_EventHandler) {
                            subtitle_track_controller_inheritsLoose(SubtitleTrackController, _EventHandler);
                            function SubtitleTrackController(hls) {
                                var _this;
                                _this = _EventHandler.call(this, hls, events["default"].MEDIA_ATTACHED, events["default"].MEDIA_DETACHING, events["default"].MANIFEST_LOADED, events["default"].SUBTITLE_TRACK_LOADED) || this;
                                _this.tracks = [];
                                _this.trackId = -1;
                                _this.media = null;
                                _this.stopped = true;
                                /**
     * @member {boolean} subtitleDisplay Enable/disable subtitle display rendering
     */ _this.subtitleDisplay = true;
                                /**
     * Keeps reference to a default track id when media has not been attached yet
     * @member {number}
     */ _this.queuedDefaultTrack = null;
                                return _this;
                            }
                            var _proto = SubtitleTrackController.prototype;
                            _proto.destroy = function destroy() {
                                event_handler.prototype.destroy.call(this);
                            } // Listen for subtitle track change, then extract the current track ID.
                            ;
                            _proto.onMediaAttached = function onMediaAttached(data) {
                                var _this2 = this;
                                this.media = data.media;
                                if (!this.media) return;
                                if (Object(number_isFinite["isFiniteNumber"])(this.queuedDefaultTrack)) {
                                    this.subtitleTrack = this.queuedDefaultTrack;
                                    this.queuedDefaultTrack = null;
                                }
                                this.trackChangeListener = this._onTextTracksChanged.bind(this);
                                this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks);
                                if (this.useTextTrackPolling) this.subtitlePollingInterval = setInterval(function() {
                                    _this2.trackChangeListener();
                                }, 500);
                                else this.media.textTracks.addEventListener('change', this.trackChangeListener);
                            };
                            _proto.onMediaDetaching = function onMediaDetaching() {
                                if (!this.media) return;
                                if (this.useTextTrackPolling) clearInterval(this.subtitlePollingInterval);
                                else this.media.textTracks.removeEventListener('change', this.trackChangeListener);
                                if (Object(number_isFinite["isFiniteNumber"])(this.subtitleTrack)) this.queuedDefaultTrack = this.subtitleTrack;
                                var textTracks = filterSubtitleTracks(this.media.textTracks); // Clear loaded cues on media detachment from tracks
                                textTracks.forEach(function(track) {
                                    clearCurrentCues(track);
                                }); // Disable all subtitle tracks before detachment so when reattached only tracks in that content are enabled.
                                this.subtitleTrack = -1;
                                this.media = null;
                            } // Fired whenever a new manifest is loaded.
                            ;
                            _proto.onManifestLoaded = function onManifestLoaded(data) {
                                var _this3 = this;
                                var tracks = data.subtitles || [];
                                this.tracks = tracks;
                                this.hls.trigger(events["default"].SUBTITLE_TRACKS_UPDATED, {
                                    subtitleTracks: tracks
                                }); // loop through available subtitle tracks and autoselect default if needed
                                // TODO: improve selection logic to handle forced, etc
                                tracks.forEach(function(track) {
                                    if (track.default) {
                                        // setting this.subtitleTrack will trigger internal logic
                                        // if media has not been attached yet, it will fail
                                        // we keep a reference to the default track id
                                        // and we'll set subtitleTrack when onMediaAttached is triggered
                                        if (_this3.media) _this3.subtitleTrack = track.id;
                                        else _this3.queuedDefaultTrack = track.id;
                                    }
                                });
                            };
                            _proto.onSubtitleTrackLoaded = function onSubtitleTrackLoaded(data) {
                                var _this4 = this;
                                var id = data.id, details = data.details;
                                var trackId = this.trackId, tracks = this.tracks;
                                var currentTrack = tracks[trackId];
                                if (id >= tracks.length || id !== trackId || !currentTrack || this.stopped) {
                                    this._clearReloadTimer();
                                    return;
                                }
                                logger["logger"].log("subtitle track " + id + " loaded");
                                if (details.live) {
                                    var reloadInterval = computeReloadInterval(currentTrack.details, details, data.stats.trequest);
                                    logger["logger"].log("Reloading live subtitle playlist in " + reloadInterval + "ms");
                                    this.timer = setTimeout(function() {
                                        _this4._loadCurrentTrack();
                                    }, reloadInterval);
                                } else this._clearReloadTimer();
                            };
                            _proto.startLoad = function startLoad() {
                                this.stopped = false;
                                this._loadCurrentTrack();
                            };
                            _proto.stopLoad = function stopLoad() {
                                this.stopped = true;
                                this._clearReloadTimer();
                            };
                            _proto._clearReloadTimer = function _clearReloadTimer() {
                                if (this.timer) {
                                    clearTimeout(this.timer);
                                    this.timer = null;
                                }
                            };
                            _proto._loadCurrentTrack = function _loadCurrentTrack() {
                                var trackId = this.trackId, tracks = this.tracks, hls = this.hls;
                                var currentTrack = tracks[trackId];
                                if (trackId < 0 || !currentTrack || currentTrack.details && !currentTrack.details.live) return;
                                logger["logger"].log("Loading subtitle track " + trackId);
                                hls.trigger(events["default"].SUBTITLE_TRACK_LOADING, {
                                    url: currentTrack.url,
                                    id: trackId
                                });
                            };
                            _proto._toggleTrackModes = function _toggleTrackModes(newId) {
                                var media = this.media, subtitleDisplay = this.subtitleDisplay, trackId = this.trackId;
                                if (!media) return;
                                var textTracks = filterSubtitleTracks(media.textTracks);
                                if (newId === -1) [].slice.call(textTracks).forEach(function(track) {
                                    track.mode = 'disabled';
                                });
                                else {
                                    var oldTrack = textTracks[trackId];
                                    if (oldTrack) oldTrack.mode = 'disabled';
                                }
                                var nextTrack = textTracks[newId];
                                if (nextTrack) nextTrack.mode = subtitleDisplay ? 'showing' : 'hidden';
                            };
                            _proto._setSubtitleTrackInternal = function _setSubtitleTrackInternal(newId) {
                                var hls = this.hls, tracks = this.tracks;
                                if (!Object(number_isFinite["isFiniteNumber"])(newId) || newId < -1 || newId >= tracks.length) return;
                                this.trackId = newId;
                                logger["logger"].log("Switching to subtitle track " + newId);
                                hls.trigger(events["default"].SUBTITLE_TRACK_SWITCH, {
                                    id: newId
                                });
                                this._loadCurrentTrack();
                            };
                            _proto._onTextTracksChanged = function _onTextTracksChanged() {
                                // Media is undefined when switching streams via loadSource()
                                if (!this.media) return;
                                var trackId = -1;
                                var tracks = filterSubtitleTracks(this.media.textTracks);
                                for(var id = 0; id < tracks.length; id++){
                                    if (tracks[id].mode === 'hidden') // Do not break in case there is a following track with showing.
                                    trackId = id;
                                    else if (tracks[id].mode === 'showing') {
                                        trackId = id;
                                        break;
                                    }
                                } // Setting current subtitleTrack will invoke code.
                                this.subtitleTrack = trackId;
                            };
                            subtitle_track_controller_createClass(SubtitleTrackController, [
                                {
                                    key: "subtitleTracks",
                                    get: function get() {
                                        return this.tracks;
                                    }
                                },
                                {
                                    key: "subtitleTrack",
                                    get: function get() {
                                        return this.trackId;
                                    },
                                    set: function set(subtitleTrackId) {
                                        if (this.trackId !== subtitleTrackId) {
                                            this._toggleTrackModes(subtitleTrackId);
                                            this._setSubtitleTrackInternal(subtitleTrackId);
                                        }
                                    }
                                }
                            ]);
                            return SubtitleTrackController;
                        }(event_handler);
                        function filterSubtitleTracks(textTrackList) {
                            var tracks = [];
                            for(var i = 0; i < textTrackList.length; i++){
                                var track = textTrackList[i]; // Edge adds a track without a label; we don't want to use it
                                if (track.kind === 'subtitles' && track.label) tracks.push(textTrackList[i]);
                            }
                            return tracks;
                        }
                        /* harmony default export */ var subtitle_track_controller = subtitle_track_controller_SubtitleTrackController;
                        // EXTERNAL MODULE: ./src/crypt/decrypter.js + 3 modules
                        var decrypter = __webpack_require__("./src/crypt/decrypter.js");
                        // CONCATENATED MODULE: ./src/controller/subtitle-stream-controller.js
                        function subtitle_stream_controller_assertThisInitialized(self1) {
                            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return self1;
                        }
                        function subtitle_stream_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /**
 * @class SubtitleStreamController
 */ var subtitle_stream_controller_window = window, subtitle_stream_controller_performance = subtitle_stream_controller_window.performance;
                        var subtitle_stream_controller_TICK_INTERVAL = 500; // how often to tick in ms
                        var subtitle_stream_controller_SubtitleStreamController = /*#__PURE__*/ function(_BaseStreamController) {
                            subtitle_stream_controller_inheritsLoose(SubtitleStreamController, _BaseStreamController);
                            function SubtitleStreamController(hls, fragmentTracker) {
                                var _this;
                                _this = _BaseStreamController.call(this, hls, events["default"].MEDIA_ATTACHED, events["default"].MEDIA_DETACHING, events["default"].ERROR, events["default"].KEY_LOADED, events["default"].FRAG_LOADED, events["default"].SUBTITLE_TRACKS_UPDATED, events["default"].SUBTITLE_TRACK_SWITCH, events["default"].SUBTITLE_TRACK_LOADED, events["default"].SUBTITLE_FRAG_PROCESSED, events["default"].LEVEL_UPDATED) || this;
                                _this.fragmentTracker = fragmentTracker;
                                _this.config = hls.config;
                                _this.state = State.STOPPED;
                                _this.tracks = [];
                                _this.tracksBuffered = [];
                                _this.currentTrackId = -1;
                                _this.decrypter = new decrypter["default"](hls, hls.config); // lastAVStart stores the time in seconds for the start time of a level load
                                _this.lastAVStart = 0;
                                _this._onMediaSeeking = _this.onMediaSeeking.bind(subtitle_stream_controller_assertThisInitialized(_this));
                                return _this;
                            }
                            var _proto = SubtitleStreamController.prototype;
                            _proto.onSubtitleFragProcessed = function onSubtitleFragProcessed(data) {
                                var frag = data.frag, success = data.success;
                                this.fragPrevious = frag;
                                this.state = State.IDLE;
                                if (!success) return;
                                var buffered = this.tracksBuffered[this.currentTrackId];
                                if (!buffered) return;
                                 // Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
                                // so we can re-use the logic used to detect how much have been buffered
                                var timeRange;
                                var fragStart = frag.start;
                                for(var i = 0; i < buffered.length; i++)if (fragStart >= buffered[i].start && fragStart <= buffered[i].end) {
                                    timeRange = buffered[i];
                                    break;
                                }
                                var fragEnd = frag.start + frag.duration;
                                if (timeRange) timeRange.end = fragEnd;
                                else {
                                    timeRange = {
                                        start: fragStart,
                                        end: fragEnd
                                    };
                                    buffered.push(timeRange);
                                }
                            };
                            _proto.onMediaAttached = function onMediaAttached(_ref) {
                                var media = _ref.media;
                                this.media = media;
                                media.addEventListener('seeking', this._onMediaSeeking);
                                this.state = State.IDLE;
                            };
                            _proto.onMediaDetaching = function onMediaDetaching() {
                                var _this2 = this;
                                if (!this.media) return;
                                this.media.removeEventListener('seeking', this._onMediaSeeking);
                                this.fragmentTracker.removeAllFragments();
                                this.currentTrackId = -1;
                                this.tracks.forEach(function(track) {
                                    _this2.tracksBuffered[track.id] = [];
                                });
                                this.media = null;
                                this.state = State.STOPPED;
                            } // If something goes wrong, proceed to next frag, if we were processing one.
                            ;
                            _proto.onError = function onError(data) {
                                var frag = data.frag; // don't handle error not related to subtitle fragment
                                if (!frag || frag.type !== 'subtitle') return;
                                this.state = State.IDLE;
                            } // Got all new subtitle tracks.
                            ;
                            _proto.onSubtitleTracksUpdated = function onSubtitleTracksUpdated(data) {
                                var _this3 = this;
                                logger["logger"].log('subtitle tracks updated');
                                this.tracksBuffered = [];
                                this.tracks = data.subtitleTracks;
                                this.tracks.forEach(function(track) {
                                    _this3.tracksBuffered[track.id] = [];
                                });
                            };
                            _proto.onSubtitleTrackSwitch = function onSubtitleTrackSwitch(data) {
                                this.currentTrackId = data.id;
                                if (!this.tracks || !this.tracks.length || this.currentTrackId === -1) {
                                    this.clearInterval();
                                    return;
                                } // Check if track has the necessary details to load fragments
                                var currentTrack = this.tracks[this.currentTrackId];
                                if (currentTrack && currentTrack.details) this.setInterval(subtitle_stream_controller_TICK_INTERVAL);
                            } // Got a new set of subtitle fragments.
                            ;
                            _proto.onSubtitleTrackLoaded = function onSubtitleTrackLoaded(data) {
                                var id = data.id, details = data.details;
                                var currentTrackId = this.currentTrackId, tracks = this.tracks;
                                var currentTrack = tracks[currentTrackId];
                                if (id >= tracks.length || id !== currentTrackId || !currentTrack) return;
                                if (details.live) mergeSubtitlePlaylists(currentTrack.details, details, this.lastAVStart);
                                currentTrack.details = details;
                                this.setInterval(subtitle_stream_controller_TICK_INTERVAL);
                            };
                            _proto.onKeyLoaded = function onKeyLoaded() {
                                if (this.state === State.KEY_LOADING) this.state = State.IDLE;
                            };
                            _proto.onFragLoaded = function onFragLoaded(data) {
                                var fragCurrent = this.fragCurrent;
                                var decryptData = data.frag.decryptdata;
                                var fragLoaded = data.frag;
                                var hls = this.hls;
                                if (this.state === State.FRAG_LOADING && fragCurrent && data.frag.type === 'subtitle' && fragCurrent.sn === data.frag.sn) // check to see if the payload needs to be decrypted
                                {
                                    if (data.payload.byteLength > 0 && decryptData && decryptData.key && decryptData.method === 'AES-128') {
                                        var startTime = subtitle_stream_controller_performance.now(); // decrypt the subtitles
                                        this.decrypter.decrypt(data.payload, decryptData.key.buffer, decryptData.iv.buffer, function(decryptedData) {
                                            var endTime = subtitle_stream_controller_performance.now();
                                            hls.trigger(events["default"].FRAG_DECRYPTED, {
                                                frag: fragLoaded,
                                                payload: decryptedData,
                                                stats: {
                                                    tstart: startTime,
                                                    tdecrypt: endTime
                                                }
                                            });
                                        });
                                    }
                                }
                            };
                            _proto.onLevelUpdated = function onLevelUpdated(_ref2) {
                                var details = _ref2.details;
                                var frags = details.fragments;
                                this.lastAVStart = frags.length ? frags[0].start : 0;
                            };
                            _proto.doTick = function doTick() {
                                if (!this.media) {
                                    this.state = State.IDLE;
                                    return;
                                }
                                switch(this.state){
                                    case State.IDLE:
                                        var config = this.config, currentTrackId = this.currentTrackId, fragmentTracker = this.fragmentTracker, media = this.media, tracks = this.tracks;
                                        if (!tracks || !tracks[currentTrackId] || !tracks[currentTrackId].details) break;
                                        var maxBufferHole = config.maxBufferHole, maxFragLookUpTolerance = config.maxFragLookUpTolerance;
                                        var maxConfigBuffer = Math.min(config.maxBufferLength, config.maxMaxBufferLength);
                                        var bufferedInfo = BufferHelper.bufferedInfo(this._getBuffered(), media.currentTime, maxBufferHole);
                                        var bufferEnd = bufferedInfo.end, bufferLen = bufferedInfo.len;
                                        var trackDetails = tracks[currentTrackId].details;
                                        var fragments = trackDetails.fragments;
                                        var fragLen = fragments.length;
                                        var end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration;
                                        if (bufferLen > maxConfigBuffer) return;
                                        var foundFrag;
                                        var fragPrevious = this.fragPrevious;
                                        if (bufferEnd < end) {
                                            if (fragPrevious && trackDetails.hasProgramDateTime) foundFrag = findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, maxFragLookUpTolerance);
                                            if (!foundFrag) foundFrag = findFragmentByPTS(fragPrevious, fragments, bufferEnd, maxFragLookUpTolerance);
                                        } else foundFrag = fragments[fragLen - 1];
                                        if (foundFrag && foundFrag.encrypted) {
                                            logger["logger"].log("Loading key for " + foundFrag.sn);
                                            this.state = State.KEY_LOADING;
                                            this.hls.trigger(events["default"].KEY_LOADING, {
                                                frag: foundFrag
                                            });
                                        } else if (foundFrag && fragmentTracker.getState(foundFrag) === FragmentState.NOT_LOADED) {
                                            // only load if fragment is not loaded
                                            this.fragCurrent = foundFrag;
                                            this.state = State.FRAG_LOADING;
                                            this.hls.trigger(events["default"].FRAG_LOADING, {
                                                frag: foundFrag
                                            });
                                        }
                                }
                            };
                            _proto.stopLoad = function stopLoad() {
                                this.lastAVStart = 0;
                                _BaseStreamController.prototype.stopLoad.call(this);
                            };
                            _proto._getBuffered = function _getBuffered() {
                                return this.tracksBuffered[this.currentTrackId] || [];
                            };
                            _proto.onMediaSeeking = function onMediaSeeking() {
                                this.fragPrevious = null;
                            };
                            return SubtitleStreamController;
                        }(base_stream_controller_BaseStreamController);
                        // CONCATENATED MODULE: ./src/utils/mediakeys-helper.ts
                        /**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
 */ var KeySystems;
                        (function(KeySystems) {
                            KeySystems["WIDEVINE"] = "com.widevine.alpha";
                            KeySystems["PLAYREADY"] = "com.microsoft.playready";
                        })(KeySystems || (KeySystems = {}));
                        var requestMediaKeySystemAccess = function() {
                            if (typeof window !== 'undefined' && window.navigator && window.navigator.requestMediaKeySystemAccess) return window.navigator.requestMediaKeySystemAccess.bind(window.navigator);
                            else return null;
                        }();
                        // CONCATENATED MODULE: ./src/controller/eme-controller.ts
                        function eme_controller_defineProperties(target, props) {
                            for(var i = 0; i < props.length; i++){
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function eme_controller_createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) eme_controller_defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) eme_controller_defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        function eme_controller_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /**
 * @author Stephan Hesse <disparat@gmail.com> | <tchakabam@gmail.com>
 *
 * DRM support for Hls.js
 */ var MAX_LICENSE_REQUEST_FAILURES = 3;
                        /**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
 * @param {Array<string>} audioCodecs List of required audio codecs to support
 * @param {Array<string>} videoCodecs List of required video codecs to support
 * @param {object} drmSystemOptions Optional parameters/requirements for the key-system
 * @returns {Array<MediaSystemConfiguration>} An array of supported configurations
 */ var createWidevineMediaKeySystemConfigurations = function createWidevineMediaKeySystemConfigurations(audioCodecs, videoCodecs) {
                            /* jshint ignore:line */ var baseConfig = {
                                // initDataTypes: ['keyids', 'mp4'],
                                // label: "",
                                // persistentState: "not-allowed", // or "required" ?
                                // distinctiveIdentifier: "not-allowed", // or "required" ?
                                // sessionTypes: ['temporary'],
                                videoCapabilities: [] // { contentType: 'video/mp4; codecs="avc1.42E01E"' }
                            };
                            videoCodecs.forEach(function(codec) {
                                baseConfig.videoCapabilities.push({
                                    contentType: "video/mp4; codecs=\"" + codec + "\""
                                });
                            });
                            return [
                                baseConfig
                            ];
                        };
                        /**
 * The idea here is to handle key-system (and their respective platforms) specific configuration differences
 * in order to work with the local requestMediaKeySystemAccess method.
 *
 * We can also rule-out platform-related key-system support at this point by throwing an error.
 *
 * @param {string} keySystem Identifier for the key-system, see `KeySystems` enum
 * @param {Array<string>} audioCodecs List of required audio codecs to support
 * @param {Array<string>} videoCodecs List of required video codecs to support
 * @throws will throw an error if a unknown key system is passed
 * @returns {Array<MediaSystemConfiguration>} A non-empty Array of MediaKeySystemConfiguration objects
 */ var eme_controller_getSupportedMediaKeySystemConfigurations = function getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs) {
                            switch(keySystem){
                                case KeySystems.WIDEVINE:
                                    return createWidevineMediaKeySystemConfigurations(audioCodecs, videoCodecs);
                                default:
                                    throw new Error("Unknown key-system: " + keySystem);
                            }
                        };
                        /**
 * Controller to deal with encrypted media extensions (EME)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
 *
 * @class
 * @constructor
 */ var eme_controller_EMEController = /*#__PURE__*/ function(_EventHandler) {
                            eme_controller_inheritsLoose(EMEController, _EventHandler);
                            /**
     * @constructs
     * @param {Hls} hls Our Hls.js instance
     */ function EMEController(hls) {
                                var _this;
                                _this = _EventHandler.call(this, hls, events["default"].MEDIA_ATTACHED, events["default"].MEDIA_DETACHED, events["default"].MANIFEST_PARSED) || this;
                                _this._widevineLicenseUrl = void 0;
                                _this._licenseXhrSetup = void 0;
                                _this._emeEnabled = void 0;
                                _this._requestMediaKeySystemAccess = void 0;
                                _this._config = void 0;
                                _this._mediaKeysList = [];
                                _this._media = null;
                                _this._hasSetMediaKeys = false;
                                _this._requestLicenseFailureCount = 0;
                                _this._onMediaEncrypted = function(e) {
                                    logger["logger"].log("Media is encrypted using \"" + e.initDataType + "\" init data type");
                                    _this._attemptSetMediaKeys();
                                    _this._generateRequestWithPreferredKeySession(e.initDataType, e.initData);
                                };
                                _this._config = hls.config;
                                _this._widevineLicenseUrl = _this._config.widevineLicenseUrl;
                                _this._licenseXhrSetup = _this._config.licenseXhrSetup;
                                _this._emeEnabled = _this._config.emeEnabled;
                                _this._requestMediaKeySystemAccess = _this._config.requestMediaKeySystemAccessFunc;
                                return _this;
                            }
                            /**
   * @param {string} keySystem Identifier for the key-system, see `KeySystems` enum
   * @returns {string} License server URL for key-system (if any configured, otherwise causes error)
   * @throws if a unsupported keysystem is passed
   */ var _proto = EMEController.prototype;
                            _proto.getLicenseServerUrl = function getLicenseServerUrl(keySystem) {
                                switch(keySystem){
                                    case KeySystems.WIDEVINE:
                                        if (!this._widevineLicenseUrl) break;
                                        return this._widevineLicenseUrl;
                                }
                                throw new Error("no license server URL configured for key-system \"" + keySystem + "\"");
                            };
                            _proto._attemptKeySystemAccess = function _attemptKeySystemAccess(keySystem, audioCodecs, videoCodecs) {
                                var _this2 = this;
                                // TODO: add other DRM "options"
                                // This can throw, but is caught in event handler callpath
                                var mediaKeySystemConfigs = eme_controller_getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs);
                                logger["logger"].log('Requesting encrypted media key-system access'); // expecting interface like window.navigator.requestMediaKeySystemAccess
                                this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs).then(function(mediaKeySystemAccess) {
                                    _this2._onMediaKeySystemAccessObtained(keySystem, mediaKeySystemAccess);
                                }).catch(function(err) {
                                    logger["logger"].error("Failed to obtain key-system \"" + keySystem + "\" access:", err);
                                });
                            };
                            /**
     * Handles obtaining access to a key-system
     * @private
     * @param {string} keySystem
     * @param {MediaKeySystemAccess} mediaKeySystemAccess https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemAccess
     */ _proto._onMediaKeySystemAccessObtained = function _onMediaKeySystemAccessObtained(keySystem, mediaKeySystemAccess) {
                                var _this3 = this;
                                logger["logger"].log("Access for key-system \"" + keySystem + "\" obtained");
                                var mediaKeysListItem = {
                                    mediaKeysSessionInitialized: false,
                                    mediaKeySystemAccess: mediaKeySystemAccess,
                                    mediaKeySystemDomain: keySystem
                                };
                                this._mediaKeysList.push(mediaKeysListItem);
                                mediaKeySystemAccess.createMediaKeys().then(function(mediaKeys) {
                                    mediaKeysListItem.mediaKeys = mediaKeys;
                                    logger["logger"].log("Media-keys created for key-system \"" + keySystem + "\"");
                                    _this3._onMediaKeysCreated();
                                }).catch(function(err) {
                                    logger["logger"].error('Failed to create media-keys:', err);
                                });
                            };
                            _proto._onMediaKeysCreated = function _onMediaKeysCreated() {
                                var _this4 = this;
                                // check for all key-list items if a session exists, otherwise, create one
                                this._mediaKeysList.forEach(function(mediaKeysListItem) {
                                    if (!mediaKeysListItem.mediaKeysSession) {
                                        // mediaKeys is definitely initialized here
                                        mediaKeysListItem.mediaKeysSession = mediaKeysListItem.mediaKeys.createSession();
                                        _this4._onNewMediaKeySession(mediaKeysListItem.mediaKeysSession);
                                    }
                                });
                            };
                            _proto._onNewMediaKeySession = function _onNewMediaKeySession(keySession) {
                                var _this5 = this;
                                logger["logger"].log("New key-system session " + keySession.sessionId);
                                keySession.addEventListener('message', function(event) {
                                    _this5._onKeySessionMessage(keySession, event.message);
                                }, false);
                            };
                            _proto._onKeySessionMessage = function _onKeySessionMessage(keySession, message) {
                                logger["logger"].log('Got EME message event, creating license request');
                                this._requestLicense(message, function(data) {
                                    logger["logger"].log("Received license data (length: " + (data ? data.byteLength : data) + "), updating key-session");
                                    keySession.update(data);
                                });
                            };
                            /**
   * @private
   */ _proto._attemptSetMediaKeys = function _attemptSetMediaKeys() {
                                if (!this._media) throw new Error('Attempted to set mediaKeys without first attaching a media element');
                                if (!this._hasSetMediaKeys) {
                                    // FIXME: see if we can/want/need-to really to deal with several potential key-sessions?
                                    var keysListItem = this._mediaKeysList[0];
                                    if (!keysListItem || !keysListItem.mediaKeys) {
                                        logger["logger"].error('Fatal: Media is encrypted but no CDM access or no keys have been obtained yet');
                                        this.hls.trigger(events["default"].ERROR, {
                                            type: errors["ErrorTypes"].KEY_SYSTEM_ERROR,
                                            details: errors["ErrorDetails"].KEY_SYSTEM_NO_KEYS,
                                            fatal: true
                                        });
                                        return;
                                    }
                                    logger["logger"].log('Setting keys for encrypted media');
                                    this._media.setMediaKeys(keysListItem.mediaKeys);
                                    this._hasSetMediaKeys = true;
                                }
                            };
                            _proto._generateRequestWithPreferredKeySession = function _generateRequestWithPreferredKeySession(initDataType, initData) {
                                var _this6 = this;
                                // FIXME: see if we can/want/need-to really to deal with several potential key-sessions?
                                var keysListItem = this._mediaKeysList[0];
                                if (!keysListItem) {
                                    logger["logger"].error('Fatal: Media is encrypted but not any key-system access has been obtained yet');
                                    this.hls.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].KEY_SYSTEM_ERROR,
                                        details: errors["ErrorDetails"].KEY_SYSTEM_NO_ACCESS,
                                        fatal: true
                                    });
                                    return;
                                }
                                if (keysListItem.mediaKeysSessionInitialized) {
                                    logger["logger"].warn('Key-Session already initialized but requested again');
                                    return;
                                }
                                var keySession = keysListItem.mediaKeysSession;
                                if (!keySession) {
                                    logger["logger"].error('Fatal: Media is encrypted but no key-session existing');
                                    this.hls.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].KEY_SYSTEM_ERROR,
                                        details: errors["ErrorDetails"].KEY_SYSTEM_NO_SESSION,
                                        fatal: true
                                    });
                                    return;
                                } // initData is null if the media is not CORS-same-origin
                                if (!initData) {
                                    logger["logger"].warn('Fatal: initData required for generating a key session is null');
                                    this.hls.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].KEY_SYSTEM_ERROR,
                                        details: errors["ErrorDetails"].KEY_SYSTEM_NO_INIT_DATA,
                                        fatal: true
                                    });
                                    return;
                                }
                                logger["logger"].log("Generating key-session request for \"" + initDataType + "\" init data type");
                                keysListItem.mediaKeysSessionInitialized = true;
                                keySession.generateRequest(initDataType, initData).then(function() {
                                    logger["logger"].debug('Key-session generation succeeded');
                                }).catch(function(err) {
                                    logger["logger"].error('Error generating key-session request:', err);
                                    _this6.hls.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].KEY_SYSTEM_ERROR,
                                        details: errors["ErrorDetails"].KEY_SYSTEM_NO_SESSION,
                                        fatal: false
                                    });
                                });
                            };
                            _proto._createLicenseXhr = function _createLicenseXhr(url, keyMessage, callback) {
                                var xhr = new XMLHttpRequest();
                                var licenseXhrSetup = this._licenseXhrSetup;
                                try {
                                    if (licenseXhrSetup) try {
                                        licenseXhrSetup(xhr, url);
                                    } catch (e) {
                                        // let's try to open before running setup
                                        xhr.open('POST', url, true);
                                        licenseXhrSetup(xhr, url);
                                    }
                                     // if licenseXhrSetup did not yet call open, let's do it now
                                    if (!xhr.readyState) xhr.open('POST', url, true);
                                } catch (e) {
                                    // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
                                    throw new Error("issue setting up KeySystem license XHR " + e);
                                } // Because we set responseType to ArrayBuffer here, callback is typed as handling only array buffers
                                xhr.responseType = 'arraybuffer';
                                xhr.onreadystatechange = this._onLicenseRequestReadyStageChange.bind(this, xhr, url, keyMessage, callback);
                                return xhr;
                            };
                            _proto._onLicenseRequestReadyStageChange = function _onLicenseRequestReadyStageChange(xhr, url, keyMessage, callback) {
                                switch(xhr.readyState){
                                    case 4:
                                        if (xhr.status === 200) {
                                            this._requestLicenseFailureCount = 0;
                                            logger["logger"].log('License request succeeded');
                                            if (xhr.responseType !== 'arraybuffer') logger["logger"].warn('xhr response type was not set to the expected arraybuffer for license request');
                                            callback(xhr.response);
                                        } else {
                                            logger["logger"].error("License Request XHR failed (" + url + "). Status: " + xhr.status + " (" + xhr.statusText + ")");
                                            this._requestLicenseFailureCount++;
                                            if (this._requestLicenseFailureCount > MAX_LICENSE_REQUEST_FAILURES) {
                                                this.hls.trigger(events["default"].ERROR, {
                                                    type: errors["ErrorTypes"].KEY_SYSTEM_ERROR,
                                                    details: errors["ErrorDetails"].KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                                                    fatal: true
                                                });
                                                return;
                                            }
                                            var attemptsLeft = MAX_LICENSE_REQUEST_FAILURES - this._requestLicenseFailureCount + 1;
                                            logger["logger"].warn("Retrying license request, " + attemptsLeft + " attempts left");
                                            this._requestLicense(keyMessage, callback);
                                        }
                                        break;
                                }
                            };
                            _proto._generateLicenseRequestChallenge = function _generateLicenseRequestChallenge(keysListItem, keyMessage) {
                                switch(keysListItem.mediaKeySystemDomain){
                                    // case KeySystems.PLAYREADY:
                                    // from https://github.com/MicrosoftEdge/Demos/blob/master/eme/scripts/demo.js
                                    /*
        if (this.licenseType !== this.LICENSE_TYPE_WIDEVINE) {
          // For PlayReady CDMs, we need to dig the Challenge out of the XML.
          var keyMessageXml = new DOMParser().parseFromString(String.fromCharCode.apply(null, new Uint16Array(keyMessage)), 'application/xml');
          if (keyMessageXml.getElementsByTagName('Challenge')[0]) {
              challenge = atob(keyMessageXml.getElementsByTagName('Challenge')[0].childNodes[0].nodeValue);
          } else {
              throw 'Cannot find <Challenge> in key message';
          }
          var headerNames = keyMessageXml.getElementsByTagName('name');
          var headerValues = keyMessageXml.getElementsByTagName('value');
          if (headerNames.length !== headerValues.length) {
              throw 'Mismatched header <name>/<value> pair in key message';
          }
          for (var i = 0; i < headerNames.length; i++) {
              xhr.setRequestHeader(headerNames[i].childNodes[0].nodeValue, headerValues[i].childNodes[0].nodeValue);
          }
        }
        break;
      */ case KeySystems.WIDEVINE:
                                        // For Widevine CDMs, the challenge is the keyMessage.
                                        return keyMessage;
                                }
                                throw new Error("unsupported key-system: " + keysListItem.mediaKeySystemDomain);
                            };
                            _proto._requestLicense = function _requestLicense(keyMessage, callback) {
                                logger["logger"].log('Requesting content license for key-system');
                                var keysListItem = this._mediaKeysList[0];
                                if (!keysListItem) {
                                    logger["logger"].error('Fatal error: Media is encrypted but no key-system access has been obtained yet');
                                    this.hls.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].KEY_SYSTEM_ERROR,
                                        details: errors["ErrorDetails"].KEY_SYSTEM_NO_ACCESS,
                                        fatal: true
                                    });
                                    return;
                                }
                                try {
                                    var _url = this.getLicenseServerUrl(keysListItem.mediaKeySystemDomain);
                                    var _xhr = this._createLicenseXhr(_url, keyMessage, callback);
                                    logger["logger"].log("Sending license request to URL: " + _url);
                                    var challenge = this._generateLicenseRequestChallenge(keysListItem, keyMessage);
                                    _xhr.send(challenge);
                                } catch (e) {
                                    logger["logger"].error("Failure requesting DRM license: " + e);
                                    this.hls.trigger(events["default"].ERROR, {
                                        type: errors["ErrorTypes"].KEY_SYSTEM_ERROR,
                                        details: errors["ErrorDetails"].KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                                        fatal: true
                                    });
                                }
                            };
                            _proto.onMediaAttached = function onMediaAttached(data) {
                                if (!this._emeEnabled) return;
                                var media = data.media; // keep reference of media
                                this._media = media;
                                media.addEventListener('encrypted', this._onMediaEncrypted);
                            };
                            _proto.onMediaDetached = function onMediaDetached() {
                                if (this._media) {
                                    this._media.removeEventListener('encrypted', this._onMediaEncrypted);
                                    this._media = null; // release reference
                                }
                            } // TODO: Use manifest types here when they are defined
                            ;
                            _proto.onManifestParsed = function onManifestParsed(data) {
                                if (!this._emeEnabled) return;
                                var audioCodecs = data.levels.map(function(level) {
                                    return level.audioCodec;
                                });
                                var videoCodecs = data.levels.map(function(level) {
                                    return level.videoCodec;
                                });
                                this._attemptKeySystemAccess(KeySystems.WIDEVINE, audioCodecs, videoCodecs);
                            };
                            eme_controller_createClass(EMEController, [
                                {
                                    key: "requestMediaKeySystemAccess",
                                    get: function get() {
                                        if (!this._requestMediaKeySystemAccess) throw new Error('No requestMediaKeySystemAccess function configured');
                                        return this._requestMediaKeySystemAccess;
                                    }
                                }
                            ]);
                            return EMEController;
                        }(event_handler);
                        /* harmony default export */ var eme_controller = eme_controller_EMEController;
                        // CONCATENATED MODULE: ./src/config.ts
                        function _objectSpread(target) {
                            for(var i = 1; i < arguments.length; i++){
                                var source = arguments[i] != null ? arguments[i] : {};
                                var ownKeys = Object.keys(source);
                                if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                                }));
                                ownKeys.forEach(function(key) {
                                    _defineProperty(target, key, source[key]);
                                });
                            }
                            return target;
                        }
                        function _defineProperty(obj, key, value) {
                            if (key in obj) Object.defineProperty(obj, key, {
                                value: value,
                                enumerable: true,
                                configurable: true,
                                writable: true
                            });
                            else obj[key] = value;
                            return obj;
                        }
                        /**
 * HLS config
 */ // import FetchLoader from './utils/fetch-loader';
                        // If possible, keep hlsDefaultConfig shallow
                        // It is cloned whenever a new Hls instance is created, by keeping the config
                        var hlsDefaultConfig = _objectSpread({
                            autoStartLoad: true,
                            // used by stream-controller
                            startPosition: -1,
                            // used by stream-controller
                            defaultAudioCodec: void 0,
                            // used by stream-controller
                            debug: false,
                            // used by logger
                            capLevelOnFPSDrop: false,
                            // used by fps-controller
                            capLevelToPlayerSize: false,
                            // used by cap-level-controller
                            initialLiveManifestSize: 1,
                            // used by stream-controller
                            maxBufferLength: 30,
                            // used by stream-controller
                            maxBufferSize: 60000000,
                            // used by stream-controller
                            maxBufferHole: 0.5,
                            // used by stream-controller
                            lowBufferWatchdogPeriod: 0.5,
                            // used by stream-controller
                            highBufferWatchdogPeriod: 3,
                            // used by stream-controller
                            nudgeOffset: 0.1,
                            // used by stream-controller
                            nudgeMaxRetry: 3,
                            // used by stream-controller
                            maxFragLookUpTolerance: 0.25,
                            // used by stream-controller
                            liveSyncDurationCount: 3,
                            // used by stream-controller
                            liveMaxLatencyDurationCount: Infinity,
                            // used by stream-controller
                            liveSyncDuration: void 0,
                            // used by stream-controller
                            liveMaxLatencyDuration: void 0,
                            // used by stream-controller
                            liveDurationInfinity: false,
                            // used by buffer-controller
                            liveBackBufferLength: Infinity,
                            // used by buffer-controller
                            maxMaxBufferLength: 600,
                            // used by stream-controller
                            enableWorker: true,
                            // used by demuxer
                            enableSoftwareAES: true,
                            // used by decrypter
                            manifestLoadingTimeOut: 10000,
                            // used by playlist-loader
                            manifestLoadingMaxRetry: 1,
                            // used by playlist-loader
                            manifestLoadingRetryDelay: 1000,
                            // used by playlist-loader
                            manifestLoadingMaxRetryTimeout: 64000,
                            // used by playlist-loader
                            startLevel: void 0,
                            // used by level-controller
                            levelLoadingTimeOut: 10000,
                            // used by playlist-loader
                            levelLoadingMaxRetry: 4,
                            // used by playlist-loader
                            levelLoadingRetryDelay: 1000,
                            // used by playlist-loader
                            levelLoadingMaxRetryTimeout: 64000,
                            // used by playlist-loader
                            fragLoadingTimeOut: 20000,
                            // used by fragment-loader
                            fragLoadingMaxRetry: 6,
                            // used by fragment-loader
                            fragLoadingRetryDelay: 1000,
                            // used by fragment-loader
                            fragLoadingMaxRetryTimeout: 64000,
                            // used by fragment-loader
                            startFragPrefetch: false,
                            // used by stream-controller
                            fpsDroppedMonitoringPeriod: 5000,
                            // used by fps-controller
                            fpsDroppedMonitoringThreshold: 0.2,
                            // used by fps-controller
                            appendErrorMaxRetry: 3,
                            // used by buffer-controller
                            loader: xhr_loader,
                            // loader: FetchLoader,
                            fLoader: void 0,
                            // used by fragment-loader
                            pLoader: void 0,
                            // used by playlist-loader
                            xhrSetup: void 0,
                            // used by xhr-loader
                            licenseXhrSetup: void 0,
                            // used by eme-controller
                            // fetchSetup: void 0,
                            abrController: abr_controller,
                            bufferController: buffer_controller,
                            capLevelController: cap_level_controller,
                            fpsController: fps_controller,
                            stretchShortVideoTrack: false,
                            // used by mp4-remuxer
                            maxAudioFramesDrift: 1,
                            // used by mp4-remuxer
                            forceKeyFrameOnDiscontinuity: true,
                            // used by ts-demuxer
                            abrEwmaFastLive: 3,
                            // used by abr-controller
                            abrEwmaSlowLive: 9,
                            // used by abr-controller
                            abrEwmaFastVoD: 3,
                            // used by abr-controller
                            abrEwmaSlowVoD: 9,
                            // used by abr-controller
                            abrEwmaDefaultEstimate: 5e5,
                            // 500 kbps  // used by abr-controller
                            abrBandWidthFactor: 0.95,
                            // used by abr-controller
                            abrBandWidthUpFactor: 0.7,
                            // used by abr-controller
                            abrMaxWithRealBitrate: false,
                            // used by abr-controller
                            maxStarvationDelay: 4,
                            // used by abr-controller
                            maxLoadingDelay: 4,
                            // used by abr-controller
                            minAutoBitrate: 0,
                            // used by hls
                            emeEnabled: false,
                            // used by eme-controller
                            widevineLicenseUrl: void 0,
                            // used by eme-controller
                            requestMediaKeySystemAccessFunc: requestMediaKeySystemAccess
                        }, timelineConfig(), {
                            subtitleStreamController: subtitle_stream_controller_SubtitleStreamController,
                            subtitleTrackController: subtitle_track_controller,
                            timelineController: timeline_controller,
                            audioStreamController: audio_stream_controller,
                            audioTrackController: audio_track_controller,
                            emeController: eme_controller
                        });
                        function timelineConfig() {
                            return {
                                cueHandler: cues_namespaceObject,
                                // used by timeline-controller
                                enableCEA708Captions: true,
                                // used by timeline-controller
                                enableWebVTT: true,
                                // used by timeline-controller
                                captionsTextTrack1Label: 'English',
                                // used by timeline-controller
                                captionsTextTrack1LanguageCode: 'en',
                                // used by timeline-controller
                                captionsTextTrack2Label: 'Spanish',
                                // used by timeline-controller
                                captionsTextTrack2LanguageCode: 'es' // used by timeline-controller
                            };
                        }
                        // CONCATENATED MODULE: ./src/hls.ts
                        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() {
                            return hls_Hls;
                        });
                        function hls_objectSpread(target) {
                            for(var i = 1; i < arguments.length; i++){
                                var source = arguments[i] != null ? arguments[i] : {};
                                var ownKeys = Object.keys(source);
                                if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                                }));
                                ownKeys.forEach(function(key) {
                                    hls_defineProperty(target, key, source[key]);
                                });
                            }
                            return target;
                        }
                        function hls_defineProperty(obj, key, value) {
                            if (key in obj) Object.defineProperty(obj, key, {
                                value: value,
                                enumerable: true,
                                configurable: true,
                                writable: true
                            });
                            else obj[key] = value;
                            return obj;
                        }
                        function hls_assertThisInitialized(self1) {
                            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return self1;
                        }
                        function hls_defineProperties(target, props) {
                            for(var i = 0; i < props.length; i++){
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function hls_createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) hls_defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) hls_defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        function hls_inheritsLoose(subClass, superClass) {
                            subClass.prototype = Object.create(superClass.prototype);
                            subClass.prototype.constructor = subClass;
                            subClass.__proto__ = superClass;
                        }
                        /**
 * @module Hls
 * @class
 * @constructor
 */ var hls_Hls = /*#__PURE__*/ function(_Observer) {
                            hls_inheritsLoose(Hls, _Observer);
                            /**
   * @type {boolean}
   */ Hls.isSupported = function isSupported() {
                                return is_supported_isSupported();
                            };
                            hls_createClass(Hls, null, [
                                {
                                    key: "version",
                                    /**
     * @type {string}
     */ get: function get() {
                                        return "0.13.2";
                                    }
                                },
                                {
                                    key: "Events",
                                    get: function get() {
                                        return events["default"];
                                    }
                                },
                                {
                                    key: "ErrorTypes",
                                    get: function get() {
                                        return errors["ErrorTypes"];
                                    }
                                },
                                {
                                    key: "ErrorDetails",
                                    get: function get() {
                                        return errors["ErrorDetails"];
                                    }
                                },
                                {
                                    key: "DefaultConfig",
                                    get: function get() {
                                        if (!Hls.defaultConfig) return hlsDefaultConfig;
                                        return Hls.defaultConfig;
                                    },
                                    set: function set(defaultConfig) {
                                        Hls.defaultConfig = defaultConfig;
                                    }
                                }
                            ]);
                            function Hls(userConfig) {
                                var _this;
                                if (userConfig === void 0) userConfig = {};
                                _this = _Observer.call(this) || this;
                                _this.config = void 0;
                                _this._autoLevelCapping = void 0;
                                _this.abrController = void 0;
                                _this.capLevelController = void 0;
                                _this.levelController = void 0;
                                _this.streamController = void 0;
                                _this.networkControllers = void 0;
                                _this.audioTrackController = void 0;
                                _this.subtitleTrackController = void 0;
                                _this.emeController = void 0;
                                _this.coreComponents = void 0;
                                _this.media = null;
                                _this.url = null;
                                var defaultConfig = Hls.DefaultConfig;
                                if ((userConfig.liveSyncDurationCount || userConfig.liveMaxLatencyDurationCount) && (userConfig.liveSyncDuration || userConfig.liveMaxLatencyDuration)) throw new Error('Illegal hls.js config: don\'t mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration');
                                 // Shallow clone
                                _this.config = hls_objectSpread({}, defaultConfig, userConfig);
                                var _assertThisInitialize = hls_assertThisInitialized(_this), config = _assertThisInitialize.config;
                                if (config.liveMaxLatencyDurationCount !== void 0 && config.liveMaxLatencyDurationCount <= config.liveSyncDurationCount) throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');
                                if (config.liveMaxLatencyDuration !== void 0 && (config.liveSyncDuration === void 0 || config.liveMaxLatencyDuration <= config.liveSyncDuration)) throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');
                                Object(logger["enableLogs"])(config.debug);
                                _this._autoLevelCapping = -1; // core controllers and network loaders
                                /**
     * @member {AbrController} abrController
     */ var abrController = _this.abrController = new config.abrController(hls_assertThisInitialized(_this)); // eslint-disable-line new-cap
                                var bufferController = new config.bufferController(hls_assertThisInitialized(_this)); // eslint-disable-line new-cap
                                var capLevelController = _this.capLevelController = new config.capLevelController(hls_assertThisInitialized(_this)); // eslint-disable-line new-cap
                                var fpsController = new config.fpsController(hls_assertThisInitialized(_this)); // eslint-disable-line new-cap
                                var playListLoader = new playlist_loader(hls_assertThisInitialized(_this));
                                var fragmentLoader = new fragment_loader(hls_assertThisInitialized(_this));
                                var keyLoader = new key_loader(hls_assertThisInitialized(_this));
                                var id3TrackController = new id3_track_controller(hls_assertThisInitialized(_this)); // network controllers
                                /**
     * @member {LevelController} levelController
     */ var levelController = _this.levelController = new level_controller_LevelController(hls_assertThisInitialized(_this)); // FIXME: FragmentTracker must be defined before StreamController because the order of event handling is important
                                var fragmentTracker = new fragment_tracker_FragmentTracker(hls_assertThisInitialized(_this));
                                /**
     * @member {StreamController} streamController
     */ var streamController = _this.streamController = new stream_controller(hls_assertThisInitialized(_this), fragmentTracker);
                                var networkControllers = [
                                    levelController,
                                    streamController
                                ]; // optional audio stream controller
                                /**
     * @var {ICoreComponent | Controller}
     */ var Controller = config.audioStreamController;
                                if (Controller) networkControllers.push(new Controller(hls_assertThisInitialized(_this), fragmentTracker));
                                /**
     * @member {INetworkController[]} networkControllers
     */ _this.networkControllers = networkControllers;
                                /**
     * @var {ICoreComponent[]}
     */ var coreComponents = [
                                    playListLoader,
                                    fragmentLoader,
                                    keyLoader,
                                    abrController,
                                    bufferController,
                                    capLevelController,
                                    fpsController,
                                    id3TrackController,
                                    fragmentTracker
                                ]; // optional audio track and subtitle controller
                                Controller = config.audioTrackController;
                                if (Controller) {
                                    var audioTrackController = new Controller(hls_assertThisInitialized(_this));
                                    /**
       * @member {AudioTrackController} audioTrackController
       */ _this.audioTrackController = audioTrackController;
                                    coreComponents.push(audioTrackController);
                                }
                                Controller = config.subtitleTrackController;
                                if (Controller) {
                                    var subtitleTrackController = new Controller(hls_assertThisInitialized(_this));
                                    /**
       * @member {SubtitleTrackController} subtitleTrackController
       */ _this.subtitleTrackController = subtitleTrackController;
                                    networkControllers.push(subtitleTrackController);
                                }
                                Controller = config.emeController;
                                if (Controller) {
                                    var emeController = new Controller(hls_assertThisInitialized(_this));
                                    /**
       * @member {EMEController} emeController
       */ _this.emeController = emeController;
                                    coreComponents.push(emeController);
                                } // optional subtitle controllers
                                Controller = config.subtitleStreamController;
                                if (Controller) networkControllers.push(new Controller(hls_assertThisInitialized(_this), fragmentTracker));
                                Controller = config.timelineController;
                                if (Controller) coreComponents.push(new Controller(hls_assertThisInitialized(_this)));
                                /**
     * @member {ICoreComponent[]}
     */ _this.coreComponents = coreComponents;
                                return _this;
                            }
                            /**
   * Dispose of the instance
   */ var _proto = Hls.prototype;
                            _proto.destroy = function destroy() {
                                logger["logger"].log('destroy');
                                this.trigger(events["default"].DESTROYING);
                                this.detachMedia();
                                this.coreComponents.concat(this.networkControllers).forEach(function(component) {
                                    component.destroy();
                                });
                                this.url = null;
                                this.removeAllListeners();
                                this._autoLevelCapping = -1;
                            };
                            _proto.attachMedia = function attachMedia(media) {
                                logger["logger"].log('attachMedia');
                                this.media = media;
                                this.trigger(events["default"].MEDIA_ATTACHING, {
                                    media: media
                                });
                            };
                            _proto.detachMedia = function detachMedia() {
                                logger["logger"].log('detachMedia');
                                this.trigger(events["default"].MEDIA_DETACHING);
                                this.media = null;
                            };
                            _proto.loadSource = function loadSource(url) {
                                url = url_toolkit["buildAbsoluteURL"](window.location.href, url, {
                                    alwaysNormalize: true
                                });
                                logger["logger"].log("loadSource:" + url);
                                this.url = url; // when attaching to a source URL, trigger a playlist load
                                this.trigger(events["default"].MANIFEST_LOADING, {
                                    url: url
                                });
                            };
                            _proto.startLoad = function startLoad(startPosition) {
                                if (startPosition === void 0) startPosition = -1;
                                logger["logger"].log("startLoad(" + startPosition + ")");
                                this.networkControllers.forEach(function(controller) {
                                    controller.startLoad(startPosition);
                                });
                            };
                            _proto.stopLoad = function stopLoad() {
                                logger["logger"].log('stopLoad');
                                this.networkControllers.forEach(function(controller) {
                                    controller.stopLoad();
                                });
                            };
                            _proto.swapAudioCodec = function swapAudioCodec() {
                                logger["logger"].log('swapAudioCodec');
                                this.streamController.swapAudioCodec();
                            };
                            _proto.recoverMediaError = function recoverMediaError() {
                                logger["logger"].log('recoverMediaError');
                                var media = this.media;
                                this.detachMedia();
                                if (media) this.attachMedia(media);
                            };
                            hls_createClass(Hls, [
                                {
                                    key: "levels",
                                    get: function get() {
                                        return this.levelController.levels;
                                    }
                                },
                                {
                                    key: "currentLevel",
                                    get: function get() {
                                        return this.streamController.currentLevel;
                                    },
                                    set: function set(newLevel) {
                                        logger["logger"].log("set currentLevel:" + newLevel);
                                        this.loadLevel = newLevel;
                                        this.streamController.immediateLevelSwitch();
                                    }
                                },
                                {
                                    key: "nextLevel",
                                    get: function get() {
                                        return this.streamController.nextLevel;
                                    },
                                    set: function set(newLevel) {
                                        logger["logger"].log("set nextLevel:" + newLevel);
                                        this.levelController.manualLevel = newLevel;
                                        this.streamController.nextLevelSwitch();
                                    }
                                },
                                {
                                    key: "loadLevel",
                                    get: function get() {
                                        return this.levelController.level;
                                    },
                                    set: function set(newLevel) {
                                        logger["logger"].log("set loadLevel:" + newLevel);
                                        this.levelController.manualLevel = newLevel;
                                    }
                                },
                                {
                                    key: "nextLoadLevel",
                                    get: function get() {
                                        return this.levelController.nextLoadLevel;
                                    },
                                    set: function set(level) {
                                        this.levelController.nextLoadLevel = level;
                                    }
                                },
                                {
                                    key: "firstLevel",
                                    get: function get() {
                                        return Math.max(this.levelController.firstLevel, this.minAutoLevel);
                                    },
                                    set: function set(newLevel) {
                                        logger["logger"].log("set firstLevel:" + newLevel);
                                        this.levelController.firstLevel = newLevel;
                                    }
                                },
                                {
                                    key: "startLevel",
                                    get: function get() {
                                        return this.levelController.startLevel;
                                    },
                                    set: function set(newLevel) {
                                        logger["logger"].log("set startLevel:" + newLevel); // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
                                        if (newLevel !== -1) newLevel = Math.max(newLevel, this.minAutoLevel);
                                        this.levelController.startLevel = newLevel;
                                    }
                                },
                                {
                                    key: "capLevelToPlayerSize",
                                    set: function set(shouldStartCapping) {
                                        var newCapLevelToPlayerSize = !!shouldStartCapping;
                                        if (newCapLevelToPlayerSize !== this.config.capLevelToPlayerSize) {
                                            if (newCapLevelToPlayerSize) this.capLevelController.startCapping(); // If capping occurs, nextLevelSwitch will happen based on size.
                                            else {
                                                this.capLevelController.stopCapping();
                                                this.autoLevelCapping = -1;
                                                this.streamController.nextLevelSwitch(); // Now we're uncapped, get the next level asap.
                                            }
                                            this.config.capLevelToPlayerSize = newCapLevelToPlayerSize;
                                        }
                                    }
                                },
                                {
                                    key: "autoLevelCapping",
                                    get: function get() {
                                        return this._autoLevelCapping;
                                    },
                                    /**
     * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
     * @type {number}
     */ set: function set(newLevel) {
                                        logger["logger"].log("set autoLevelCapping:" + newLevel);
                                        this._autoLevelCapping = newLevel;
                                    }
                                },
                                {
                                    key: "bandwidthEstimate",
                                    get: function get() {
                                        var bwEstimator = this.abrController._bwEstimator;
                                        return bwEstimator ? bwEstimator.getEstimate() : NaN;
                                    }
                                },
                                {
                                    key: "autoLevelEnabled",
                                    get: function get() {
                                        return this.levelController.manualLevel === -1;
                                    }
                                },
                                {
                                    key: "manualLevel",
                                    get: function get() {
                                        return this.levelController.manualLevel;
                                    }
                                },
                                {
                                    key: "minAutoLevel",
                                    get: function get() {
                                        var levels = this.levels, minAutoBitrate = this.config.minAutoBitrate;
                                        var len = levels ? levels.length : 0;
                                        for(var i = 0; i < len; i++){
                                            var levelNextBitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate;
                                            if (levelNextBitrate > minAutoBitrate) return i;
                                        }
                                        return 0;
                                    }
                                },
                                {
                                    key: "maxAutoLevel",
                                    get: function get() {
                                        var levels = this.levels, autoLevelCapping = this.autoLevelCapping;
                                        var maxAutoLevel;
                                        if (autoLevelCapping === -1 && levels && levels.length) maxAutoLevel = levels.length - 1;
                                        else maxAutoLevel = autoLevelCapping;
                                        return maxAutoLevel;
                                    }
                                },
                                {
                                    key: "nextAutoLevel",
                                    get: function get() {
                                        // ensure next auto level is between  min and max auto level
                                        return Math.min(Math.max(this.abrController.nextAutoLevel, this.minAutoLevel), this.maxAutoLevel);
                                    },
                                    set: function set(nextLevel) {
                                        this.abrController.nextAutoLevel = Math.max(this.minAutoLevel, nextLevel);
                                    }
                                },
                                {
                                    key: "audioTracks",
                                    get: function get() {
                                        var audioTrackController = this.audioTrackController;
                                        return audioTrackController ? audioTrackController.audioTracks : [];
                                    }
                                },
                                {
                                    key: "audioTrack",
                                    get: function get() {
                                        var audioTrackController = this.audioTrackController;
                                        return audioTrackController ? audioTrackController.audioTrack : -1;
                                    },
                                    set: function set(audioTrackId) {
                                        var audioTrackController = this.audioTrackController;
                                        if (audioTrackController) audioTrackController.audioTrack = audioTrackId;
                                    }
                                },
                                {
                                    key: "liveSyncPosition",
                                    get: function get() {
                                        return this.streamController.liveSyncPosition;
                                    }
                                },
                                {
                                    key: "subtitleTracks",
                                    get: function get() {
                                        var subtitleTrackController = this.subtitleTrackController;
                                        return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
                                    }
                                },
                                {
                                    key: "subtitleTrack",
                                    get: function get() {
                                        var subtitleTrackController = this.subtitleTrackController;
                                        return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
                                    },
                                    set: function set(subtitleTrackId) {
                                        var subtitleTrackController = this.subtitleTrackController;
                                        if (subtitleTrackController) subtitleTrackController.subtitleTrack = subtitleTrackId;
                                    }
                                },
                                {
                                    key: "subtitleDisplay",
                                    get: function get() {
                                        var subtitleTrackController = this.subtitleTrackController;
                                        return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
                                    },
                                    set: function set(value) {
                                        var subtitleTrackController = this.subtitleTrackController;
                                        if (subtitleTrackController) subtitleTrackController.subtitleDisplay = value;
                                    }
                                }
                            ]);
                            return Hls;
                        }(Observer);
                        hls_Hls.defaultConfig = void 0;
                    /***/ },
                    /***/ "./src/polyfills/number-isFinite.js": /*!******************************************!*\
  !*** ./src/polyfills/number-isFinite.js ***!
  \******************************************/ /*! exports provided: isFiniteNumber */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                        "use strict";
                        __webpack_require__.r(__webpack_exports__);
                        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFiniteNumber", function() {
                            return isFiniteNumber;
                        });
                        var isFiniteNumber = Number.isFinite || function(value) {
                            return typeof value === 'number' && isFinite(value);
                        };
                    /***/ },
                    /***/ "./src/utils/get-self-scope.js": /*!*************************************!*\
  !*** ./src/utils/get-self-scope.js ***!
  \*************************************/ /*! exports provided: getSelfScope */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                        "use strict";
                        __webpack_require__.r(__webpack_exports__);
                        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelfScope", function() {
                            return getSelfScope;
                        });
                        function getSelfScope() {
                            // see https://stackoverflow.com/a/11237259/589493
                            if (typeof window === 'undefined') /* eslint-disable-next-line no-undef */ return self;
                            else return window;
                        }
                    /***/ },
                    /***/ "./src/utils/logger.js": /*!*****************************!*\
  !*** ./src/utils/logger.js ***!
  \*****************************/ /*! exports provided: enableLogs, logger */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                        "use strict";
                        __webpack_require__.r(__webpack_exports__);
                        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableLogs", function() {
                            return enableLogs;
                        });
                        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logger", function() {
                            return logger;
                        });
                        /* harmony import */ var _get_self_scope__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./get-self-scope */ "./src/utils/get-self-scope.js");
                        function noop() {}
                        var fakeLogger = {
                            trace: noop,
                            debug: noop,
                            log: noop,
                            warn: noop,
                            info: noop,
                            error: noop
                        };
                        var exportedLogger = fakeLogger; // let lastCallTime;
                        // function formatMsgWithTimeInfo(type, msg) {
                        //   const now = Date.now();
                        //   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
                        //   lastCallTime = now;
                        //   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
                        //   return msg;
                        // }
                        function formatMsg(type, msg) {
                            msg = '[' + type + '] > ' + msg;
                            return msg;
                        }
                        var global = Object(_get_self_scope__WEBPACK_IMPORTED_MODULE_0__["getSelfScope"])();
                        function consolePrintFn(type) {
                            var func = global.console[type];
                            if (func) return function() {
                                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                if (args[0]) args[0] = formatMsg(type, args[0]);
                                func.apply(global.console, args);
                            };
                            return noop;
                        }
                        function exportLoggerFunctions(debugConfig) {
                            for(var _len2 = arguments.length, functions = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)functions[_key2 - 1] = arguments[_key2];
                            functions.forEach(function(type) {
                                exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
                            });
                        }
                        var enableLogs = function enableLogs(debugConfig) {
                            // check that console is available
                            if (global.console && debugConfig === true || typeof debugConfig === 'object') {
                                exportLoggerFunctions(debugConfig, // 'trace',
                                'debug', 'log', 'info', 'warn', 'error'); // Some browsers don't allow to use bind on console object anyway
                                // fallback to default if needed
                                try {
                                    exportedLogger.log();
                                } catch (e) {
                                    exportedLogger = fakeLogger;
                                }
                            } else exportedLogger = fakeLogger;
                        };
                        var logger = exportedLogger;
                    /***/ }
                })["default"];
            });
        //# sourceMappingURL=hls.js.map
        /***/ },
        /***/ "./node_modules/node-libs-browser/node_modules/process/browser.js": /*!************************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/process/browser.js ***!
  \************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            // shim for using process in browser
            var process = module1.exports = {};
            // cached from whatever global is present so that test runners that stub it
            // don't break things.  But we need to wrap it in a try catch in case it is
            // wrapped in strict mode code which doesn't define any globals.  It's inside a
            // function because try/catches deoptimize in certain engines.
            var cachedSetTimeout;
            var cachedClearTimeout;
            function defaultSetTimout() {
                throw new Error('setTimeout has not been defined');
            }
            function defaultClearTimeout() {
                throw new Error('clearTimeout has not been defined');
            }
            (function() {
                try {
                    if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
                    else cachedSetTimeout = defaultSetTimout;
                } catch (e) {
                    cachedSetTimeout = defaultSetTimout;
                }
                try {
                    if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
                    else cachedClearTimeout = defaultClearTimeout;
                } catch (e) {
                    cachedClearTimeout = defaultClearTimeout;
                }
            })();
            function runTimeout(fun) {
                if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                return setTimeout(fun, 0);
                // if setTimeout wasn't available but was latter defined
                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                    cachedSetTimeout = setTimeout;
                    return setTimeout(fun, 0);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedSetTimeout(fun, 0);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                        return cachedSetTimeout.call(null, fun, 0);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                        return cachedSetTimeout.call(this, fun, 0);
                    }
                }
            }
            function runClearTimeout(marker) {
                if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                return clearTimeout(marker);
                // if clearTimeout wasn't available but was latter defined
                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                    cachedClearTimeout = clearTimeout;
                    return clearTimeout(marker);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedClearTimeout(marker);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                        return cachedClearTimeout.call(null, marker);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                        return cachedClearTimeout.call(this, marker);
                    }
                }
            }
            var queue = [];
            var draining = false;
            var currentQueue;
            var queueIndex = -1;
            function cleanUpNextTick() {
                if (!draining || !currentQueue) return;
                draining = false;
                if (currentQueue.length) queue = currentQueue.concat(queue);
                else queueIndex = -1;
                if (queue.length) drainQueue();
            }
            function drainQueue() {
                if (draining) return;
                var timeout = runTimeout(cleanUpNextTick);
                draining = true;
                var len = queue.length;
                while(len){
                    currentQueue = queue;
                    queue = [];
                    while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                    queueIndex = -1;
                    len = queue.length;
                }
                currentQueue = null;
                draining = false;
                runClearTimeout(timeout);
            }
            process.nextTick = function(fun) {
                var args = new Array(arguments.length - 1);
                if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                queue.push(new Item(fun, args));
                if (queue.length === 1 && !draining) runTimeout(drainQueue);
            };
            // v8 likes predictible objects
            function Item(fun, array) {
                this.fun = fun;
                this.array = array;
            }
            Item.prototype.run = function() {
                this.fun.apply(null, this.array);
            };
            process.title = 'browser';
            process.browser = true;
            process.env = {};
            process.argv = [];
            process.version = ''; // empty string to avoid regexp issues
            process.versions = {};
            function noop() {}
            process.on = noop;
            process.addListener = noop;
            process.once = noop;
            process.off = noop;
            process.removeListener = noop;
            process.removeAllListeners = noop;
            process.emit = noop;
            process.binding = function(name) {
                throw new Error('process.binding is not supported');
            };
            process.cwd = function() {
                return '/';
            };
            process.chdir = function(dir) {
                throw new Error('process.chdir is not supported');
            };
            process.umask = function() {
                return 0;
            };
        /***/ },
        /***/ "./node_modules/style-loader/lib/addStyles.js": /*!****************************************************!*\
  !*** ./node_modules/style-loader/lib/addStyles.js ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            /*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ var stylesInDom = {};
            var memoize = function(fn) {
                var memo;
                return function() {
                    if (typeof memo === "undefined") memo = fn.apply(this, arguments);
                    return memo;
                };
            };
            var isOldIE = memoize(function() {
                // Test for IE <= 9 as proposed by Browserhacks
                // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
                // Tests for existence of standard globals is to allow style-loader
                // to operate correctly into non-standard environments
                // @see https://github.com/webpack-contrib/style-loader/issues/177
                return window && document && document.all && !window.atob;
            });
            var getTarget = function(target) {
                return document.querySelector(target);
            };
            var getElement = function(fn) {
                var memo = {};
                return function(target) {
                    // If passing function in options, then use it for resolve "head" element.
                    // Useful for Shadow Root style i.e
                    // {
                    //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                    // }
                    if (typeof target === 'function') return target();
                    if (typeof memo[target] === "undefined") {
                        var styleTarget = getTarget.call(this, target);
                        // Special case to return head of iframe instead of iframe itself
                        if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) try {
                            // This will throw an exception if access to iframe is blocked
                            // due to cross-origin restrictions
                            styleTarget = styleTarget.contentDocument.head;
                        } catch (e) {
                            styleTarget = null;
                        }
                        memo[target] = styleTarget;
                    }
                    return memo[target];
                };
            }();
            var singleton = null;
            var singletonCounter = 0;
            var stylesInsertedAtTop = [];
            var fixUrls = __webpack_require__(/*! ./urls */ "./node_modules/style-loader/lib/urls.js");
            module1.exports = function(list, options) {
                if (typeof DEBUG !== "undefined" && DEBUG) {
                    if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
                }
                options = options || {};
                options.attrs = typeof options.attrs === "object" ? options.attrs : {};
                // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
                // tags it will allow on a page
                if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();
                // By default, add <style> tags to the <head> element
                if (!options.insertInto) options.insertInto = "head";
                // By default, add <style> tags to the bottom of the target
                if (!options.insertAt) options.insertAt = "bottom";
                var styles = listToStyles(list, options);
                addStylesToDom(styles, options);
                return function update(newList) {
                    var mayRemove = [];
                    for(var i = 0; i < styles.length; i++){
                        var item = styles[i];
                        var domStyle = stylesInDom[item.id];
                        domStyle.refs--;
                        mayRemove.push(domStyle);
                    }
                    if (newList) {
                        var newStyles = listToStyles(newList, options);
                        addStylesToDom(newStyles, options);
                    }
                    for(var i = 0; i < mayRemove.length; i++){
                        var domStyle = mayRemove[i];
                        if (domStyle.refs === 0) {
                            for(var j = 0; j < domStyle.parts.length; j++)domStyle.parts[j]();
                            delete stylesInDom[domStyle.id];
                        }
                    }
                };
            };
            function addStylesToDom(styles, options) {
                for(var i = 0; i < styles.length; i++){
                    var item = styles[i];
                    var domStyle = stylesInDom[item.id];
                    if (domStyle) {
                        domStyle.refs++;
                        for(var j = 0; j < domStyle.parts.length; j++)domStyle.parts[j](item.parts[j]);
                        for(; j < item.parts.length; j++)domStyle.parts.push(addStyle(item.parts[j], options));
                    } else {
                        var parts = [];
                        for(var j = 0; j < item.parts.length; j++)parts.push(addStyle(item.parts[j], options));
                        stylesInDom[item.id] = {
                            id: item.id,
                            refs: 1,
                            parts: parts
                        };
                    }
                }
            }
            function listToStyles(list, options) {
                var styles = [];
                var newStyles = {};
                for(var i = 0; i < list.length; i++){
                    var item = list[i];
                    var id = options.base ? item[0] + options.base : item[0];
                    var css = item[1];
                    var media = item[2];
                    var sourceMap = item[3];
                    var part = {
                        css: css,
                        media: media,
                        sourceMap: sourceMap
                    };
                    if (!newStyles[id]) styles.push(newStyles[id] = {
                        id: id,
                        parts: [
                            part
                        ]
                    });
                    else newStyles[id].parts.push(part);
                }
                return styles;
            }
            function insertStyleElement(options, style) {
                var target = getElement(options.insertInto);
                if (!target) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
                var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];
                if (options.insertAt === "top") {
                    if (!lastStyleElementInsertedAtTop) target.insertBefore(style, target.firstChild);
                    else if (lastStyleElementInsertedAtTop.nextSibling) target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
                    else target.appendChild(style);
                    stylesInsertedAtTop.push(style);
                } else if (options.insertAt === "bottom") target.appendChild(style);
                else if (typeof options.insertAt === "object" && options.insertAt.before) {
                    var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
                    target.insertBefore(style, nextSibling);
                } else throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
            }
            function removeStyleElement(style) {
                if (style.parentNode === null) return false;
                style.parentNode.removeChild(style);
                var idx = stylesInsertedAtTop.indexOf(style);
                if (idx >= 0) stylesInsertedAtTop.splice(idx, 1);
            }
            function createStyleElement(options) {
                var style = document.createElement("style");
                options.attrs.type = "text/css";
                addAttrs(style, options.attrs);
                insertStyleElement(options, style);
                return style;
            }
            function createLinkElement(options) {
                var link = document.createElement("link");
                options.attrs.type = "text/css";
                options.attrs.rel = "stylesheet";
                addAttrs(link, options.attrs);
                insertStyleElement(options, link);
                return link;
            }
            function addAttrs(el, attrs) {
                Object.keys(attrs).forEach(function(key) {
                    el.setAttribute(key, attrs[key]);
                });
            }
            function addStyle(obj, options) {
                var style, update, remove, result;
                // If a transform function was defined, run it on the css
                if (options.transform && obj.css) {
                    result = options.transform(obj.css);
                    if (result) // If transform returns a value, use that instead of the original css.
                    // This allows running runtime transformations on the css.
                    obj.css = result;
                    else // If the transform function returns a falsy value, don't add this css.
                    // This allows conditional loading of css
                    return function() {
                    // noop
                    };
                }
                if (options.singleton) {
                    var styleIndex = singletonCounter++;
                    style = singleton || (singleton = createStyleElement(options));
                    update = applyToSingletonTag.bind(null, style, styleIndex, false);
                    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
                } else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
                    style = createLinkElement(options);
                    update = updateLink.bind(null, style, options);
                    remove = function() {
                        removeStyleElement(style);
                        if (style.href) URL.revokeObjectURL(style.href);
                    };
                } else {
                    style = createStyleElement(options);
                    update = applyToTag.bind(null, style);
                    remove = function() {
                        removeStyleElement(style);
                    };
                }
                update(obj);
                return function updateStyle(newObj) {
                    if (newObj) {
                        if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                        update(obj = newObj);
                    } else remove();
                };
            }
            var replaceText = function() {
                var textStore = [];
                return function(index, replacement) {
                    textStore[index] = replacement;
                    return textStore.filter(Boolean).join('\n');
                };
            }();
            function applyToSingletonTag(style, index, remove, obj) {
                var css = remove ? "" : obj.css;
                if (style.styleSheet) style.styleSheet.cssText = replaceText(index, css);
                else {
                    var cssNode = document.createTextNode(css);
                    var childNodes = style.childNodes;
                    if (childNodes[index]) style.removeChild(childNodes[index]);
                    if (childNodes.length) style.insertBefore(cssNode, childNodes[index]);
                    else style.appendChild(cssNode);
                }
            }
            function applyToTag(style, obj) {
                var css = obj.css;
                var media = obj.media;
                if (media) style.setAttribute("media", media);
                if (style.styleSheet) style.styleSheet.cssText = css;
                else {
                    while(style.firstChild)style.removeChild(style.firstChild);
                    style.appendChild(document.createTextNode(css));
                }
            }
            function updateLink(link, options, obj) {
                var css = obj.css;
                var sourceMap = obj.sourceMap;
                /*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/ var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;
                if (options.convertToAbsoluteUrls || autoFixUrls) css = fixUrls(css);
                if (sourceMap) // http://stackoverflow.com/a/26603875
                css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
                var blob = new Blob([
                    css
                ], {
                    type: "text/css"
                });
                var oldSrc = link.href;
                link.href = URL.createObjectURL(blob);
                if (oldSrc) URL.revokeObjectURL(oldSrc);
            }
        /***/ },
        /***/ "./node_modules/style-loader/lib/urls.js": /*!***********************************************!*\
  !*** ./node_modules/style-loader/lib/urls.js ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            /**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */ module1.exports = function(css) {
                // get current location
                var location = typeof window !== "undefined" && window.location;
                if (!location) throw new Error("fixUrls requires window.location");
                // blank or null?
                if (!css || typeof css !== "string") return css;
                var baseUrl = location.protocol + "//" + location.host;
                var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");
                // convert each url(...)
                /*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */ var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
                    // strip quotes (if they exist)
                    var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function(o, $1) {
                        return $1;
                    }).replace(/^'(.*)'$/, function(o, $1) {
                        return $1;
                    });
                    // already a full url? no change
                    if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) return fullMatch;
                    // convert the url to a full url
                    var newUrl;
                    if (unquotedOrigUrl.indexOf("//") === 0) //TODO: should we add protocol?
                    newUrl = unquotedOrigUrl;
                    else if (unquotedOrigUrl.indexOf("/") === 0) // path should be relative to the base url
                    newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
                    else // path should be relative to current directory
                    newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
                    // send back the fixed url(...)
                    return "url(" + JSON.stringify(newUrl) + ")";
                });
                // send back the fixed css
                return fixedCss;
            };
        /***/ },
        /***/ "./src/base/base_object.js": /*!*********************************!*\
  !*** ./src/base/base_object.js ***!
  \*********************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _utils = __webpack_require__(/*! ./utils */ "./src/base/utils.js");
            var _events = __webpack_require__(/*! ./events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
 * @class BaseObject
 * @constructor
 * @extends Events
 * @module base
 */ // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var BaseObject = function(_Events) {
                (0, _inherits3.default)(BaseObject, _Events);
                (0, _createClass3.default)(BaseObject, [
                    {
                        key: 'options',
                        /**
     * returns the object options
     * @property options
     * @type Object
     */ get: function get() {
                            return this._options;
                        }
                    }
                ]);
                function BaseObject() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    (0, _classCallCheck3.default)(this, BaseObject);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _Events.call(this, options));
                    _this._options = options;
                    _this.uniqueId = (0, _utils.uniqueId)('o');
                    return _this;
                }
                /**
  * a unique id prefixed with `'o'`, `o1, o232`
  *
  * @property uniqueId
  * @type String
  */ return BaseObject;
            }(_events2.default);
            exports.default = BaseObject;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/base/container_plugin.js": /*!**************************************!*\
  !*** ./src/base/container_plugin.js ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
            var _assign2 = _interopRequireDefault(_assign);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _base_object = __webpack_require__(/*! ./base_object */ "./src/base/base_object.js");
            var _base_object2 = _interopRequireDefault(_base_object);
            var _utils = __webpack_require__(/*! ./utils */ "./src/base/utils.js");
            var _error_mixin = __webpack_require__(/*! ./error_mixin */ "./src/base/error_mixin.js");
            var _error_mixin2 = _interopRequireDefault(_error_mixin);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
 * The base class for a container plugin
 * @class ContainerPlugin
 * @constructor
 * @extends BaseObject
 * @module base
 */ var ContainerPlugin = function(_BaseObject) {
                (0, _inherits3.default)(ContainerPlugin, _BaseObject);
                (0, _createClass3.default)(ContainerPlugin, [
                    {
                        key: 'playerError',
                        get: function get() {
                            return this.container.playerError;
                        }
                    }
                ]);
                function ContainerPlugin(container) {
                    (0, _classCallCheck3.default)(this, ContainerPlugin);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _BaseObject.call(this, container.options));
                    _this.container = container;
                    _this.enabled = true;
                    _this.bindEvents();
                    return _this;
                }
                ContainerPlugin.prototype.enable = function enable() {
                    if (!this.enabled) {
                        this.bindEvents();
                        this.enabled = true;
                    }
                };
                ContainerPlugin.prototype.disable = function disable() {
                    if (this.enabled) {
                        this.stopListening();
                        this.enabled = false;
                    }
                };
                ContainerPlugin.prototype.bindEvents = function bindEvents() {};
                ContainerPlugin.prototype.destroy = function destroy() {
                    this.stopListening();
                };
                return ContainerPlugin;
            }(_base_object2.default);
            exports.default = ContainerPlugin;
            (0, _assign2.default)(ContainerPlugin.prototype, _error_mixin2.default);
            ContainerPlugin.extend = function(properties) {
                return (0, _utils.extend)(ContainerPlugin, properties);
            };
            ContainerPlugin.type = 'container';
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/base/core_plugin.js": /*!*********************************!*\
  !*** ./src/base/core_plugin.js ***!
  \*********************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
            var _assign2 = _interopRequireDefault(_assign);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _utils = __webpack_require__(/*! ./utils */ "./src/base/utils.js");
            var _base_object = __webpack_require__(/*! ./base_object */ "./src/base/base_object.js");
            var _base_object2 = _interopRequireDefault(_base_object);
            var _error_mixin = __webpack_require__(/*! ./error_mixin */ "./src/base/error_mixin.js");
            var _error_mixin2 = _interopRequireDefault(_error_mixin);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var CorePlugin = function(_BaseObject) {
                (0, _inherits3.default)(CorePlugin, _BaseObject);
                (0, _createClass3.default)(CorePlugin, [
                    {
                        key: 'playerError',
                        get: function get() {
                            return this.core.playerError;
                        }
                    }
                ]);
                function CorePlugin(core) {
                    (0, _classCallCheck3.default)(this, CorePlugin);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _BaseObject.call(this, core.options));
                    _this.core = core;
                    _this.enabled = true;
                    _this.bindEvents();
                    return _this;
                }
                CorePlugin.prototype.bindEvents = function bindEvents() {};
                CorePlugin.prototype.enable = function enable() {
                    if (!this.enabled) {
                        this.bindEvents();
                        this.enabled = true;
                    }
                };
                CorePlugin.prototype.disable = function disable() {
                    if (this.enabled) {
                        this.stopListening();
                        this.enabled = false;
                    }
                };
                CorePlugin.prototype.getExternalInterface = function getExternalInterface() {
                    return {};
                };
                CorePlugin.prototype.destroy = function destroy() {
                    this.stopListening();
                };
                return CorePlugin;
            }(_base_object2.default);
            exports.default = CorePlugin;
            (0, _assign2.default)(CorePlugin.prototype, _error_mixin2.default);
            CorePlugin.extend = function(properties) {
                return (0, _utils.extend)(CorePlugin, properties);
            };
            CorePlugin.type = 'core';
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/base/error_mixin.js": /*!*********************************!*\
  !*** ./src/base/error_mixin.js ***!
  \*********************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
            var _assign2 = _interopRequireDefault(_assign);
            var _log = __webpack_require__(/*! ../plugins/log */ "./src/plugins/log/index.js");
            var _log2 = _interopRequireDefault(_log);
            var _error = __webpack_require__(/*! ../components/error */ "./src/components/error/index.js");
            var _error2 = _interopRequireDefault(_error);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var ErrorMixin = {
                /**
   * creates an error.
   * @method createError
   * @param {Object} error should be an object with code, description, level and raw error.
   * @return {Object} Object with formatted error data including origin and scope
   */ createError: function createError(error) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        useCodePrefix: true
                    };
                    var scope = this.constructor && this.constructor.type || '';
                    var origin = this.name || scope;
                    var i18n = this.i18n || this.core && this.core.i18n || this.container && this.container.i18n;
                    var prefixedCode = origin + ':' + (error && error.code || 'unknown');
                    var defaultError = {
                        description: '',
                        level: _error2.default.Levels.FATAL,
                        origin: origin,
                        scope: scope,
                        raw: {}
                    };
                    var errorData = (0, _assign2.default)({}, defaultError, error, {
                        code: options.useCodePrefix ? prefixedCode : error.code
                    });
                    if (i18n && errorData.level == _error2.default.Levels.FATAL && !errorData.UI) {
                        var defaultUI = {
                            title: i18n.t('default_error_title'),
                            message: i18n.t('default_error_message')
                        };
                        errorData.UI = defaultUI;
                    }
                    if (this.playerError) this.playerError.createError(errorData);
                    else _log2.default.warn(origin, 'PlayerError is not defined. Error: ', errorData);
                    return errorData;
                }
            };
            exports.default = ErrorMixin;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/base/events.js": /*!****************************!*\
  !*** ./src/base/events.js ***!
  \****************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _keys = __webpack_require__(/*! babel-runtime/core-js/object/keys */ "./node_modules/babel-runtime/core-js/object/keys.js");
            var _keys2 = _interopRequireDefault(_keys);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ "./node_modules/babel-runtime/helpers/typeof.js");
            var _typeof3 = _interopRequireDefault(_typeof2);
            var _log = __webpack_require__(/*! ../plugins/log */ "./src/plugins/log/index.js");
            var _log2 = _interopRequireDefault(_log);
            var _utils = __webpack_require__(/*! ./utils */ "./src/base/utils.js");
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var slice = Array.prototype.slice;
            var eventSplitter = /\s+/;
            var eventsApi = function eventsApi(obj, action, name, rest) {
                if (!name) return true;
                // Handle event maps.
                if ((typeof name === 'undefined' ? 'undefined' : (0, _typeof3.default)(name)) === 'object') {
                    for(var key in name)obj[action].apply(obj, [
                        key,
                        name[key]
                    ].concat(rest));
                    return false;
                }
                // Handle space separated event names.
                if (eventSplitter.test(name)) {
                    var names = name.split(eventSplitter);
                    for(var i = 0, l = names.length; i < l; i++)obj[action].apply(obj, [
                        names[i]
                    ].concat(rest));
                    return false;
                }
                return true;
            };
            var triggerEvents = function triggerEvents(events, args, klass, name) {
                var ev = void 0, i = -1;
                var l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
                run();
                function run() {
                    try {
                        switch(args.length){
                            /* eslint-disable curly */ case 0:
                                while(++i < l)(ev = events[i]).callback.call(ev.ctx);
                                return;
                            case 1:
                                while(++i < l)(ev = events[i]).callback.call(ev.ctx, a1);
                                return;
                            case 2:
                                while(++i < l)(ev = events[i]).callback.call(ev.ctx, a1, a2);
                                return;
                            case 3:
                                while(++i < l)(ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
                                return;
                            default:
                                while(++i < l)(ev = events[i]).callback.apply(ev.ctx, args);
                                return;
                        }
                    } catch (exception) {
                        _log2.default.error.apply(_log2.default, [
                            klass,
                            'error on event',
                            name,
                            'trigger',
                            '-',
                            exception
                        ]);
                        run();
                    }
                }
            };
            /**
 * @class Events
 * @constructor
 * @module base
 */ var Events = function() {
                function Events() {
                    (0, _classCallCheck3.default)(this, Events);
                }
                /**
   * listen to an event indefinitely, if you want to stop you need to call `off`
   * @method on
   * @param {String} name
   * @param {Function} callback
   * @param {Object} context
   */ Events.prototype.on = function on(name, callback, context) {
                    if (!eventsApi(this, 'on', name, [
                        callback,
                        context
                    ]) || !callback) return this;
                    this._events || (this._events = {});
                    var events = this._events[name] || (this._events[name] = []);
                    events.push({
                        callback: callback,
                        context: context,
                        ctx: context || this
                    });
                    return this;
                };
                /**
   * listen to an event only once
   * @method once
   * @param {String} name
   * @param {Function} callback
   * @param {Object} context
   */ Events.prototype.once = function once(name, callback, context) {
                    var _this = this;
                    var _once = void 0;
                    if (!eventsApi(this, 'once', name, [
                        callback,
                        context
                    ]) || !callback) return this;
                    var off = function off() {
                        return _this.off(name, _once);
                    };
                    _once = function once() {
                        off(name, _once);
                        callback.apply(this, arguments);
                    };
                    return this.on(name, _once, context);
                };
                /**
   * stop listening to an event
   * @method off
   * @param {String} name
   * @param {Function} callback
   * @param {Object} context
   */ Events.prototype.off = function off(name, callback, context) {
                    var retain = void 0, ev = void 0, events = void 0, names = void 0, i = void 0, l = void 0, j = void 0, k = void 0;
                    if (!this._events || !eventsApi(this, 'off', name, [
                        callback,
                        context
                    ])) return this;
                    if (!name && !callback && !context) {
                        this._events = void 0;
                        return this;
                    }
                    names = name ? [
                        name
                    ] : (0, _keys2.default)(this._events);
                    // jshint maxdepth:5
                    for(i = 0, l = names.length; i < l; i++){
                        name = names[i];
                        events = this._events[name];
                        if (events) {
                            this._events[name] = retain = [];
                            if (callback || context) for(j = 0, k = events.length; j < k; j++){
                                ev = events[j];
                                if (callback && callback !== ev.callback && callback !== ev.callback._callback || context && context !== ev.context) retain.push(ev);
                            }
                            if (!retain.length) delete this._events[name];
                        }
                    }
                    return this;
                };
                /**
   * triggers an event given its `name`
   * @method trigger
   * @param {String} name
   */ Events.prototype.trigger = function trigger(name) {
                    var klass = this.name || this.constructor.name;
                    _log2.default.debug.apply(_log2.default, [
                        klass
                    ].concat(Array.prototype.slice.call(arguments)));
                    if (!this._events) return this;
                    var args = slice.call(arguments, 1);
                    if (!eventsApi(this, 'trigger', name, args)) return this;
                    var events = this._events[name];
                    var allEvents = this._events.all;
                    if (events) triggerEvents(events, args, klass, name);
                    if (allEvents) triggerEvents(allEvents, arguments, klass, name);
                    return this;
                };
                /**
   * stop listening an event for a given object
   * @method stopListening
   * @param {Object} obj
   * @param {String} name
   * @param {Function} callback
   */ Events.prototype.stopListening = function stopListening(obj, name, callback) {
                    var listeningTo = this._listeningTo;
                    if (!listeningTo) return this;
                    var remove = !name && !callback;
                    if (!callback && (typeof name === 'undefined' ? 'undefined' : (0, _typeof3.default)(name)) === 'object') callback = this;
                    if (obj) (listeningTo = {})[obj._listenId] = obj;
                    for(var id in listeningTo){
                        obj = listeningTo[id];
                        obj.off(name, callback, this);
                        if (remove || (0, _keys2.default)(obj._events).length === 0) delete this._listeningTo[id];
                    }
                    return this;
                };
                Events.register = function register(eventName) {
                    Events.Custom || (Events.Custom = {});
                    var property = typeof eventName === 'string' && eventName.toUpperCase().trim();
                    if (property && !Events.Custom[property]) Events.Custom[property] = property.toLowerCase().split('_').map(function(value, index) {
                        return index === 0 ? value : value = value[0].toUpperCase() + value.slice(1);
                    }).join('');
                    else _log2.default.error('Events', 'Error when register event: ' + eventName);
                };
                Events.listAvailableCustomEvents = function listAvailableCustomEvents() {
                    Events.Custom || (Events.Custom = {});
                    return (0, _keys2.default)(Events.Custom).filter(function(property) {
                        return typeof Events.Custom[property] === 'string';
                    });
                };
                return Events;
            }();
            /**
 * listen to an event indefinitely for a given `obj`
 * @method listenTo
 * @param {Object} obj
 * @param {String} name
 * @param {Function} callback
 * @param {Object} context
 * @example
 * ```javascript
 * this.listenTo(this.core.playback, Events.PLAYBACK_PAUSE, this.callback)
 * ```
 */ /**
 * listen to an event once for a given `obj`
 * @method listenToOnce
 * @param {Object} obj
 * @param {String} name
 * @param {Function} callback
 * @param {Object} context
 * @example
 * ```javascript
 * this.listenToOnce(this.core.playback, Events.PLAYBACK_PAUSE, this.callback)
 * ```
 */ exports.default = Events;
            var listenMethods = {
                listenTo: 'on',
                listenToOnce: 'once'
            };
            (0, _keys2.default)(listenMethods).forEach(function(method) {
                Events.prototype[method] = function(obj, name, callback) {
                    var listeningTo = this._listeningTo || (this._listeningTo = {});
                    var id = obj._listenId || (obj._listenId = (0, _utils.uniqueId)('l'));
                    listeningTo[id] = obj;
                    if (!callback && (typeof name === 'undefined' ? 'undefined' : (0, _typeof3.default)(name)) === 'object') callback = this;
                    obj[listenMethods[method]](name, callback, this);
                    return this;
                };
            });
            // PLAYER EVENTS
            /**
 * Fired when the player is ready on startup
 *
 * @event PLAYER_READY
 */ Events.PLAYER_READY = 'ready';
            /**
 * Fired when player resizes
 *
 * @event PLAYER_RESIZE
 * @param {Object} currentSize an object with the current size
 */ Events.PLAYER_RESIZE = 'resize';
            /**
 * Fired when player changes its fullscreen state
 *
 * @event PLAYER_FULLSCREEN
 * @param {Boolean} whether or not the player is on fullscreen mode
 */ Events.PLAYER_FULLSCREEN = 'fullscreen';
            /**
 * Fired when player starts to play
 *
 * @event PLAYER_PLAY
 */ Events.PLAYER_PLAY = 'play';
            /**
 * Fired when player pauses
 *
 * @event PLAYER_PAUSE
 */ Events.PLAYER_PAUSE = 'pause';
            /**
 * Fired when player stops
 *
 * @event PLAYER_STOP
 */ Events.PLAYER_STOP = 'stop';
            /**
 * Fired when player ends the video
 *
 * @event PLAYER_ENDED
 */ Events.PLAYER_ENDED = 'ended';
            /**
 * Fired when player seeks the video
 *
 * @event PLAYER_SEEK
 * @param {Number} time the current time in seconds
 */ Events.PLAYER_SEEK = 'seek';
            /**
 * Fired when player receives an error
 *
 * @event PLAYER_ERROR
 * @param {Object} error the error
 */ Events.PLAYER_ERROR = 'playererror';
            /**
 * Fired when there is an error
 *
 * @event ERROR
 * @param {Object} error
 * the error with the following format `{code, description, level, raw, origin, scope}`
 * @param {String} [options.code]
 * error's code: code to identify error in the following format: origin:code
 * @param {String} [options.description]
 * error's description: description of the error
 * @param {String} [options.level]
 * error's level: FATAL or WARN.
 * @param {String} [options.origin]
 * error's origin. Example: hls, html5, etc
 * @param {String} [options.scope]
 * error's scope. Example: playback, container, etc
 * @param {String} [options.raw]
 * raw error: the initial error received
 */ Events.ERROR = 'error';
            /**
 * Fired when the time is updated on player
 *
 * @event PLAYER_TIMEUPDATE
 * @param {Object} progress Data
 * progress object
 * @param {Number} [progress.current]
 * current time (in seconds)
 * @param {Number} [progress.total]
 * total time (in seconds)
 */ Events.PLAYER_TIMEUPDATE = 'timeupdate';
            /**
 * Fired when player updates its volume
 *
 * @event PLAYER_VOLUMEUPDATE
 * @param {Number} volume the current volume
 */ Events.PLAYER_VOLUMEUPDATE = 'volumeupdate';
            /**
 * Fired when subtitle is available
 *
 * @event PLAYER_SUBTITLE_AVAILABLE
 */ Events.PLAYER_SUBTITLE_AVAILABLE = 'subtitleavailable';
            // Playback Events
            /**
 * Fired when the playback is downloading the media
 *
 * @event PLAYBACK_PROGRESS
 * @param progress {Object}
 * Data progress object
 * @param [progress.start] {Number}
 * start position of buffered content at current position
 * @param [progress.current] {Number}
 * end position of buffered content at current position
 * @param [progress.total] {Number}
 * total content to be downloaded
 * @param buffered {Array}
 * array of buffered segments ({start, end}). [Only for supported playbacks]
 */ Events.PLAYBACK_PROGRESS = 'playback:progress';
            /**
 * Fired when the time is updated on playback
 *
 * @event PLAYBACK_TIMEUPDATE
 * @param {Object} progress Data
 * progress object
 * @param {Number} [progress.current]
 * current time (in seconds)
 * @param {Number} [progress.total]
 * total time (in seconds)
 */ Events.PLAYBACK_TIMEUPDATE = 'playback:timeupdate';
            /**
 * Fired when playback is ready
 *
 * @event PLAYBACK_READY
 */ Events.PLAYBACK_READY = 'playback:ready';
            /**
 * Fired when the playback starts having to buffer because
 * playback can currently not be smooth.
 *
 * This corresponds to the playback `buffering` property being
 * `true`.
 *
 * @event PLAYBACK_BUFFERING
 */ Events.PLAYBACK_BUFFERING = 'playback:buffering';
            /**
 * Fired when the playback has enough in the buffer to be
 * able to play smoothly, after previously being unable to
 * do this.
 *
 * This corresponds to the playback `buffering` property being
 * `false`.
 *
 * @event PLAYBACK_BUFFERFULL
 */ Events.PLAYBACK_BUFFERFULL = 'playback:bufferfull';
            /**
 * Fired when playback changes any settings (volume, seek and etc)
 *
 * @event PLAYBACK_SETTINGSUPDATE
 */ Events.PLAYBACK_SETTINGSUPDATE = 'playback:settingsupdate';
            /**
 * Fired when playback loaded its metadata
 *
 * @event PLAYBACK_LOADEDMETADATA
 * @param {Object} metadata Data
 * settings object
 * @param {Number} [metadata.duration]
 * the playback duration
 * @param {Object} [metadata.data]
 * extra meta data
 */ Events.PLAYBACK_LOADEDMETADATA = 'playback:loadedmetadata';
            /**
 * Fired when playback updates its video quality
 *
 * @event PLAYBACK_HIGHDEFINITIONUPDATE
 * @param {Boolean} isHD
 * true when is on HD, false otherwise
 */ Events.PLAYBACK_HIGHDEFINITIONUPDATE = 'playback:highdefinitionupdate';
            /**
 * Fired when playback updates its bitrate
 *
 * @event PLAYBACK_BITRATE
 * @param {Object} bitrate Data
 * bitrate object
 * @param {Number} [bitrate.bandwidth]
 * bitrate bandwidth when it's available
 * @param {Number} [bitrate.width]
 * playback width (ex: 720, 640, 1080)
 * @param {Number} [bitrate.height]
 * playback height (ex: 240, 480, 720)
 * @param {Number} [bitrate.level]
 * playback level when it's available, it could be just a map for width (0 => 240, 1 => 480, 2 => 720)
 */ Events.PLAYBACK_BITRATE = 'playback:bitrate';
            /**
 * Fired when the playback has its levels
 *
 * @event PLAYBACK_LEVELS_AVAILABLE
 * @param {Array} levels
 * the ordered levels, each one with the following format `{id: 1, label: '500kbps'}` ps: id should be a number >= 0
 * @param {Number} initial
 * the initial level otherwise -1 (AUTO)
 */ Events.PLAYBACK_LEVELS_AVAILABLE = 'playback:levels:available';
            /**
 * Fired when the playback starts to switch level
 *
 * @event PLAYBACK_LEVEL_SWITCH_START
 *
 */ Events.PLAYBACK_LEVEL_SWITCH_START = 'playback:levels:switch:start';
            /**
 * Fired when the playback ends the level switch
 *
 * @event PLAYBACK_LEVEL_SWITCH_END
 *
 */ Events.PLAYBACK_LEVEL_SWITCH_END = 'playback:levels:switch:end';
            /**
 * Fired when playback internal state changes
 *
 * @event PLAYBACK_PLAYBACKSTATE
 * @param {Object} state Data
 * state object
 * @param {String} [state.type]
 * the playback type
 */ Events.PLAYBACK_PLAYBACKSTATE = 'playback:playbackstate';
            /**
 * Fired when DVR becomes enabled/disabled.
 *
 * @event PLAYBACK_DVR
 * @param {boolean} state true if dvr enabled
 */ Events.PLAYBACK_DVR = 'playback:dvr';
            // TODO doc
            Events.PLAYBACK_MEDIACONTROL_DISABLE = 'playback:mediacontrol:disable';
            // TODO doc
            Events.PLAYBACK_MEDIACONTROL_ENABLE = 'playback:mediacontrol:enable';
            /**
 * Fired when the media for a playback ends.
 *
 * @event PLAYBACK_ENDED
 * @param {String} name the name of the playback
 */ Events.PLAYBACK_ENDED = 'playback:ended';
            /**
 * Fired when user requests `play()`
 *
 * @event PLAYBACK_PLAY_INTENT
 */ Events.PLAYBACK_PLAY_INTENT = 'playback:play:intent';
            /**
 * Fired when the media for a playback starts playing.
 * This is not necessarily when the user requests `play()`
 * The media may have to buffer first.
 * I.e. `isPlaying()` might return `true` before this event is fired,
 * because `isPlaying()` represents the intended state.
 *
 * @event PLAYBACK_PLAY
 */ Events.PLAYBACK_PLAY = 'playback:play';
            /**
 * Fired when the media for a playback pauses.
 *
 * @event PLAYBACK_PAUSE
 */ Events.PLAYBACK_PAUSE = 'playback:pause';
            /**
 * Fired when the media for a playback is seeking.
 *
 * @event PLAYBACK_SEEK
 */ Events.PLAYBACK_SEEK = 'playback:seek';
            /**
 * Fired when the media for a playback is seeked.
 *
 * @event PLAYBACK_SEEKED
 */ Events.PLAYBACK_SEEKED = 'playback:seeked';
            /**
 * Fired when the media for a playback is stopped.
 *
 * @event PLAYBACK_STOP
 */ Events.PLAYBACK_STOP = 'playback:stop';
            /**
 * Fired if an error occurs in the playback.
 *
 * @event PLAYBACK_ERROR
 * @param {Object} error An object containing the error details
 * @param {String} name Playback name
 */ Events.PLAYBACK_ERROR = 'playback:error';
            // TODO doc
            Events.PLAYBACK_STATS_ADD = 'playback:stats:add';
            // TODO doc
            Events.PLAYBACK_FRAGMENT_LOADED = 'playback:fragment:loaded';
            // TODO doc
            Events.PLAYBACK_LEVEL_SWITCH = 'playback:level:switch';
            /**
 * Fired when subtitle is available on playback for display
 *
 * @event PLAYBACK_SUBTITLE_AVAILABLE
 */ Events.PLAYBACK_SUBTITLE_AVAILABLE = 'playback:subtitle:available';
            /**
 * Fired when playback subtitle track has changed
 *
 * @event CONTAINER_SUBTITLE_CHANGED
 * @param {Object} track Data
 * track object
 * @param {Number} [track.id]
 * selected track id
 */ Events.PLAYBACK_SUBTITLE_CHANGED = 'playback:subtitle:changed';
            // Core Events
            /**
 * Fired when the containers are created
 *
 * @event CORE_CONTAINERS_CREATED
 */ Events.CORE_CONTAINERS_CREATED = 'core:containers:created';
            /**
 * Fired when the active container changed
 *
 * @event CORE_ACTIVE_CONTAINER_CHANGED
 */ Events.CORE_ACTIVE_CONTAINER_CHANGED = 'core:active:container:changed';
            /**
 * Fired when the options were changed for the core
 *
 * @event CORE_OPTIONS_CHANGE
 * @param {Object} new options provided to configure() method
 */ Events.CORE_OPTIONS_CHANGE = 'core:options:change';
            /**
 * Fired after creating containers, when the core is ready
 *
 * @event CORE_READY
 */ Events.CORE_READY = 'core:ready';
            /**
 * Fired when the fullscreen state change
 *
 * @event CORE_FULLSCREEN
 * @param {Boolean} whether or not the player is on fullscreen mode
 */ Events.CORE_FULLSCREEN = 'core:fullscreen';
            /**
 * Fired when core updates size
 *
 * @event CORE_RESIZE
 * @param {Object} currentSize an object with the current size
 */ Events.CORE_RESIZE = 'core:resize';
            /**
 * Fired when the screen orientation has changed.
 * This event is trigger only for mobile devices.
 *
 * @event CORE_SCREEN_ORIENTATION_CHANGED
 * @param {Object} screen An object with screen orientation
 * screen object
 * @param {Object} [screen.event]
 * window resize event object
 * @param {String} [screen.orientation]
 * screen orientation (ie: 'landscape' or 'portrait')
 */ Events.CORE_SCREEN_ORIENTATION_CHANGED = 'core:screen:orientation:changed';
            /**
 * Fired when occurs mouse move event on core element
 *
 * @event CORE_MOUSE_MOVE
 * @param {Object} event a DOM event
 */ Events.CORE_MOUSE_MOVE = 'core:mousemove';
            /**
 * Fired when occurs mouse leave event on core element
 *
 * @event CORE_MOUSE_LEAVE
 * @param {Object} event a DOM event
 */ Events.CORE_MOUSE_LEAVE = 'core:mouseleave';
            // Container Events
            /**
 * Fired when the container internal state changes
 *
 * @event CONTAINER_PLAYBACKSTATE
 * @param {Object} state Data
 * state object
 * @param {String} [state.type]
 * the playback type
 */ Events.CONTAINER_PLAYBACKSTATE = 'container:playbackstate';
            Events.CONTAINER_PLAYBACKDVRSTATECHANGED = 'container:dvr';
            /**
 * Fired when the container updates its bitrate
 *
 * @event CONTAINER_BITRATE
 * @param {Object} bitrate Data
 * bitrate object
 * @param {Number} [bitrate.bandwidth]
 * bitrate bandwidth when it's available
 * @param {Number} [bitrate.width]
 * playback width (ex: 720, 640, 1080)
 * @param {Number} [bitrate.height]
 * playback height (ex: 240, 480, 720)
 * @param {Number} [bitrate.level]
 * playback level when it's available, it could be just a map for width (0 => 240, 1 => 480, 2 => 720)
 */ Events.CONTAINER_BITRATE = 'container:bitrate';
            Events.CONTAINER_STATS_REPORT = 'container:stats:report';
            Events.CONTAINER_DESTROYED = 'container:destroyed';
            /**
 * Fired when the container is ready
 *
 * @event CONTAINER_READY
 */ Events.CONTAINER_READY = 'container:ready';
            Events.CONTAINER_ERROR = 'container:error';
            /**
 * Fired when the container loaded its metadata
 *
 * @event CONTAINER_LOADEDMETADATA
 * @param {Object} metadata Data
 * settings object
 * @param {Number} [metadata.duration]
 * the playback duration
 * @param {Object} [metadata.data]
 * extra meta data
 */ Events.CONTAINER_LOADEDMETADATA = 'container:loadedmetadata';
            /**
 * Fired when subtitle is available on container for display
 *
 * @event CONTAINER_SUBTITLE_AVAILABLE
 */ Events.CONTAINER_SUBTITLE_AVAILABLE = 'container:subtitle:available';
            /**
 * Fired when subtitle track has changed
 *
 * @event CONTAINER_SUBTITLE_CHANGED
 * @param {Object} track Data
 * track object
 * @param {Number} [track.id]
 * selected track id
 */ Events.CONTAINER_SUBTITLE_CHANGED = 'container:subtitle:changed';
            /**
 * Fired when the time is updated on container
 *
 * @event CONTAINER_TIMEUPDATE
 * @param {Object} progress Data
 * progress object
 * @param {Number} [progress.current]
 * current time (in seconds)
 * @param {Number} [progress.total]
 * total time (in seconds)
 */ Events.CONTAINER_TIMEUPDATE = 'container:timeupdate';
            /**
 * Fired when the container is downloading the media
 *
 * @event CONTAINER_PROGRESS
 * @param {Object} progress Data
 * progress object
 * @param {Number} [progress.start]
 * initial downloaded content
 * @param {Number} [progress.current]
 * current dowloaded content
 * @param {Number} [progress.total]
 * total content to be downloaded
 */ Events.CONTAINER_PROGRESS = 'container:progress';
            Events.CONTAINER_PLAY = 'container:play';
            Events.CONTAINER_STOP = 'container:stop';
            Events.CONTAINER_PAUSE = 'container:pause';
            Events.CONTAINER_ENDED = 'container:ended';
            Events.CONTAINER_CLICK = 'container:click';
            Events.CONTAINER_DBLCLICK = 'container:dblclick';
            Events.CONTAINER_CONTEXTMENU = 'container:contextmenu';
            Events.CONTAINER_MOUSE_ENTER = 'container:mouseenter';
            Events.CONTAINER_MOUSE_LEAVE = 'container:mouseleave';
            /**
 * Fired when the container seeks the video
 *
 * @event CONTAINER_SEEK
 * @param {Number} time the current time in seconds
 */ Events.CONTAINER_SEEK = 'container:seek';
            /**
 * Fired when the container was finished the seek video
 *
 * @event CONTAINER_SEEKED
 * @param {Number} time the current time in seconds
 */ Events.CONTAINER_SEEKED = 'container:seeked';
            Events.CONTAINER_VOLUME = 'container:volume';
            Events.CONTAINER_FULLSCREEN = 'container:fullscreen';
            /**
 * Fired when container is buffering
 *
 * @event CONTAINER_STATE_BUFFERING
 */ Events.CONTAINER_STATE_BUFFERING = 'container:state:buffering';
            /**
 * Fired when the container filled the buffer
 *
 * @event CONTAINER_STATE_BUFFERFULL
 */ Events.CONTAINER_STATE_BUFFERFULL = 'container:state:bufferfull';
            /**
 * Fired when the container changes any settings (volume, seek and etc)
 *
 * @event CONTAINER_SETTINGSUPDATE
 */ Events.CONTAINER_SETTINGSUPDATE = 'container:settingsupdate';
            /**
 * Fired when container updates its video quality
 *
 * @event CONTAINER_HIGHDEFINITIONUPDATE
 * @param {Boolean} isHD
 * true when is on HD, false otherwise
 */ Events.CONTAINER_HIGHDEFINITIONUPDATE = 'container:highdefinitionupdate';
            /**
 * Fired when the media control shows
 *
 * @event CONTAINER_MEDIACONTROL_SHOW
 */ Events.CONTAINER_MEDIACONTROL_SHOW = 'container:mediacontrol:show';
            /**
 * Fired when the media control hides
 *
 * @event CONTAINER_MEDIACONTROL_HIDE
 */ Events.CONTAINER_MEDIACONTROL_HIDE = 'container:mediacontrol:hide';
            Events.CONTAINER_MEDIACONTROL_DISABLE = 'container:mediacontrol:disable';
            Events.CONTAINER_MEDIACONTROL_ENABLE = 'container:mediacontrol:enable';
            Events.CONTAINER_STATS_ADD = 'container:stats:add';
            /**
 * Fired when the options were changed for the container
 *
 * @event CONTAINER_OPTIONS_CHANGE
 */ Events.CONTAINER_OPTIONS_CHANGE = 'container:options:change';
            // MediaControl Events
            Events.MEDIACONTROL_RENDERED = 'mediacontrol:rendered';
            /**
 * Fired when the player enters/exit on fullscreen
 *
 * @event MEDIACONTROL_FULLSCREEN
 */ Events.MEDIACONTROL_FULLSCREEN = 'mediacontrol:fullscreen';
            /**
 * Fired when the media control shows
 *
 * @event MEDIACONTROL_SHOW
 */ Events.MEDIACONTROL_SHOW = 'mediacontrol:show';
            /**
 * Fired when the media control hides
 *
 * @event MEDIACONTROL_HIDE
 */ Events.MEDIACONTROL_HIDE = 'mediacontrol:hide';
            /**
 * Fired when mouse enters on the seekbar
 *
 * @event MEDIACONTROL_MOUSEMOVE_SEEKBAR
 * @param {Object} event
 * the javascript event
 */ Events.MEDIACONTROL_MOUSEMOVE_SEEKBAR = 'mediacontrol:mousemove:seekbar';
            /**
 * Fired when mouse leaves the seekbar
 *
 * @event MEDIACONTROL_MOUSELEAVE_SEEKBAR
 * @param {Object} event
 * the javascript event
 */ Events.MEDIACONTROL_MOUSELEAVE_SEEKBAR = 'mediacontrol:mouseleave:seekbar';
            /**
 * Fired when the media is being played
 *
 * @event MEDIACONTROL_PLAYING
 */ Events.MEDIACONTROL_PLAYING = 'mediacontrol:playing';
            /**
 * Fired when the media is not being played
 *
 * @event MEDIACONTROL_NOTPLAYING
 */ Events.MEDIACONTROL_NOTPLAYING = 'mediacontrol:notplaying';
            /**
 * Fired when the container was changed
 *
 * @event MEDIACONTROL_CONTAINERCHANGED
 */ Events.MEDIACONTROL_CONTAINERCHANGED = 'mediacontrol:containerchanged';
            /**
 * Fired when the options were changed for the mediacontrol
 *
 * @event MEDIACONTROL_OPTIONS_CHANGE
 */ Events.MEDIACONTROL_OPTIONS_CHANGE = 'mediacontrol:options:change';
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/base/media.js": /*!***************************!*\
  !*** ./src/base/media.js ***!
  \***************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            // https://github.com/mathiasbynens/small
            var mp4 = exports.mp4 = 'data:video/mp4;base64,AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAAAhmcmVlAAAC721kYXQhEAUgpBv/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3pwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcCEQBSCkG//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADengAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcAAAAsJtb292AAAAbG12aGQAAAAAAAAAAAAAAAAAAAPoAAAALwABAAABAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAB7HRyYWsAAABcdGtoZAAAAAMAAAAAAAAAAAAAAAIAAAAAAAAALwAAAAAAAAAAAAAAAQEAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAACRlZHRzAAAAHGVsc3QAAAAAAAAAAQAAAC8AAAAAAAEAAAAAAWRtZGlhAAAAIG1kaGQAAAAAAAAAAAAAAAAAAKxEAAAIAFXEAAAAAAAtaGRscgAAAAAAAAAAc291bgAAAAAAAAAAAAAAAFNvdW5kSGFuZGxlcgAAAAEPbWluZgAAABBzbWhkAAAAAAAAAAAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAADTc3RibAAAAGdzdHNkAAAAAAAAAAEAAABXbXA0YQAAAAAAAAABAAAAAAAAAAAAAgAQAAAAAKxEAAAAAAAzZXNkcwAAAAADgICAIgACAASAgIAUQBUAAAAAAfQAAAHz+QWAgIACEhAGgICAAQIAAAAYc3R0cwAAAAAAAAABAAAAAgAABAAAAAAcc3RzYwAAAAAAAAABAAAAAQAAAAIAAAABAAAAHHN0c3oAAAAAAAAAAAAAAAIAAAFzAAABdAAAABRzdGNvAAAAAAAAAAEAAAAsAAAAYnVkdGEAAABabWV0YQAAAAAAAAAhaGRscgAAAAAAAAAAbWRpcmFwcGwAAAAAAAAAAAAAAAAtaWxzdAAAACWpdG9vAAAAHWRhdGEAAAABAAAAAExhdmY1Ni40MC4xMDE=';
            exports.default = {
                mp4: mp4
            };
        /***/ },
        /***/ "./src/base/playback.js": /*!******************************!*\
  !*** ./src/base/playback.js ***!
  \******************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
            var _assign2 = _interopRequireDefault(_assign);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _utils = __webpack_require__(/*! ./utils */ "./src/base/utils.js");
            var _ui_object = __webpack_require__(/*! ./ui_object */ "./src/base/ui_object.js");
            var _ui_object2 = _interopRequireDefault(_ui_object);
            var _error_mixin = __webpack_require__(/*! ./error_mixin */ "./src/base/error_mixin.js");
            var _error_mixin2 = _interopRequireDefault(_error_mixin);
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
 * An abstraction to represent a generic playback, it's like an interface to be implemented by subclasses.
 * @class Playback
 * @constructor
 * @extends UIObject
 * @module base
 */ var Playback = function(_UIObject) {
                (0, _inherits3.default)(Playback, _UIObject);
                (0, _createClass3.default)(Playback, [
                    {
                        key: 'isAudioOnly',
                        /**
    * Determine if the playback does not contain video/has video but video should be ignored.
    * @property isAudioOnly
    * @type Boolean
    */ get: function get() {
                            return false;
                        }
                    },
                    {
                        key: 'isAdaptive',
                        get: function get() {
                            return false;
                        }
                    },
                    {
                        key: 'ended',
                        get: function get() {
                            return false;
                        }
                    },
                    {
                        key: 'i18n',
                        get: function get() {
                            return this._i18n;
                        }
                    },
                    {
                        key: 'buffering',
                        get: function get() {
                            return false;
                        }
                    },
                    {
                        key: 'consented',
                        get: function get() {
                            return this._consented;
                        }
                    }
                ]);
                function Playback(options, i18n, playerError) {
                    (0, _classCallCheck3.default)(this, Playback);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _UIObject.call(this, options));
                    _this.settings = {};
                    _this._i18n = i18n;
                    _this.playerError = playerError;
                    _this._consented = false;
                    return _this;
                }
                /**
   * Gives user consent to playback (mobile devices).
   * @method consent
   */ Playback.prototype.consent = function consent() {
                    this._consented = true;
                };
                /**
   * plays the playback.
   * @method play
   */ Playback.prototype.play = function play() {};
                /**
   * pauses the playback.
   * @method pause
   */ Playback.prototype.pause = function pause() {};
                /**
   * stops the playback.
   * @method stop
   */ Playback.prototype.stop = function stop() {};
                /**
   * seeks the playback to a given `time` in seconds
   * @method seek
   * @param {Number} time should be a number between 0 and the video duration
   */ Playback.prototype.seek = function seek(time) {}; // eslint-disable-line no-unused-vars
                /**
   * seeks the playback to a given `percentage` in percentage
   * @method seekPercentage
   * @param {Number} time should be a number between 0 and 100
   */ Playback.prototype.seekPercentage = function seekPercentage(percentage) {}; // eslint-disable-line no-unused-vars
                /**
   * The time that "0" now represents relative to when playback started.
   * For a stream with a sliding window this will increase as content is
   * removed from the beginning.
   * @method getStartTimeOffset
   * @return {Number} time (in seconds) that time "0" represents.
   */ Playback.prototype.getStartTimeOffset = function getStartTimeOffset() {
                    return 0;
                };
                /**
   * gets the duration in seconds
   * @method getDuration
   * @return {Number} duration (in seconds) of the current source
   */ Playback.prototype.getDuration = function getDuration() {
                    return 0;
                };
                /**
   * checks if the playback is playing.
   * @method isPlaying
   * @return {Boolean} `true` if the current playback is playing, otherwise `false`
   */ Playback.prototype.isPlaying = function isPlaying() {
                    return false;
                };
                /**
   * checks if the playback is ready.
   * @property isReady
   * @type {Boolean} `true` if the current playback is ready, otherwise `false`
   */ // eslint-disable-line no-unused-vars
                /**
   * gets the playback type (`'vod', 'live', 'aod'`)
   * @method getPlaybackType
   * @return {String} you should write the playback type otherwise it'll assume `'no_op'`
   * @example
   * ```javascript
   * html5VideoPlayback.getPlaybackType() //vod
   * html5AudioPlayback.getPlaybackType() //aod
   * html5VideoPlayback.getPlaybackType() //live
   * flashHlsPlayback.getPlaybackType() //live
   * ```
   */ Playback.prototype.getPlaybackType = function getPlaybackType() {
                    return Playback.NO_OP;
                };
                /**
   * checks if the playback is in HD.
   * @method isHighDefinitionInUse
   * @return {Boolean} `true` if the playback is playing in HD, otherwise `false`
   */ Playback.prototype.isHighDefinitionInUse = function isHighDefinitionInUse() {
                    return false;
                };
                /**
   * sets the volume for the playback
   * @method volume
   * @param {Number} value a number between 0 (`muted`) to 100 (`max`)
   */ Playback.prototype.volume = function volume(value) {}; // eslint-disable-line no-unused-vars
                /**
   * enables to configure the playback after its creation
   * @method configure
   * @param {Object} options all the options to change in form of a javascript object
   */ Playback.prototype.configure = function configure(options) {
                    this._options = _clapprZepto2.default.extend(this._options, options);
                };
                /**
   * attempt to autoplays the playback.
   * @method attemptAutoPlay
   */ Playback.prototype.attemptAutoPlay = function attemptAutoPlay() {
                    var _this2 = this;
                    this.canAutoPlay(function(result, error) {
                        // eslint-disable-line no-unused-vars
                        result && _this2.play();
                    });
                };
                /**
   * checks if the playback can autoplay.
   * @method canAutoPlay
   * @param {Function} callback function where first param is Boolean and second param is playback Error or null
   */ Playback.prototype.canAutoPlay = function canAutoPlay(cb) {
                    cb(true, null); // Assume playback can autoplay by default
                };
                (0, _createClass3.default)(Playback, [
                    {
                        key: 'isReady',
                        get: function get() {
                            return false;
                        }
                    },
                    {
                        key: 'hasClosedCaptionsTracks',
                        get: function get() {
                            return this.closedCaptionsTracks.length > 0;
                        }
                    },
                    {
                        key: 'closedCaptionsTracks',
                        get: function get() {
                            return [];
                        }
                    },
                    {
                        key: 'closedCaptionsTrackId',
                        get: function get() {
                            return -1;
                        },
                        set: function set(trackId) {}
                    }
                ]);
                return Playback;
            }(_ui_object2.default);
            exports.default = Playback;
            (0, _assign2.default)(Playback.prototype, _error_mixin2.default);
            Playback.extend = function(properties) {
                return (0, _utils.extend)(Playback, properties);
            };
            /**
 * checks if the playback can play a given `source`
 * If a mimeType is provided then this will be used instead of inferring the mimetype
 * from the source extension.
 * @method canPlay
 * @static
 * @param {String} source the given source ex: `http://example.com/play.mp4`
 * @param {String} [mimeType] the given mime type, ex: `'application/vnd.apple.mpegurl'`
 * @return {Boolean} `true` if the playback is playable, otherwise `false`
 */ Playback.canPlay = function(source, mimeType) {
                // eslint-disable-line no-unused-vars
                return false;
            };
            /**
 * a playback type for video on demand
 *
 * @property VOD
 * @static
 * @type String
 */ Playback.VOD = 'vod';
            /**
 * a playback type for audio on demand
 *
 * @property AOD
 * @static
 * @type String
 */ Playback.AOD = 'aod';
            /**
 * a playback type for live video
 *
 * @property LIVE
 * @static
 * @type String
 */ Playback.LIVE = 'live';
            /**
 * a default playback type
 *
 * @property NO_OP
 * @static
 * @type String
 */ Playback.NO_OP = 'no_op';
            /**
 * the plugin type
 *
 * @property type
 * @static
 * @type String
 */ Playback.type = 'playback';
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/base/polyfills.js": /*!*******************************!*\
  !*** ./src/base/polyfills.js ***!
  \*******************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            /**
 * Array.prototype.find
 *
 * Original source : https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * See also : https://tc39.github.io/ecma262/#sec-array.prototype.find
 */ if (!Array.prototype.find) // eslint-disable-next-line
            Object.defineProperty(Array.prototype, 'find', {
                // Note: ES6 arrow function syntax is not used on purpose to avoid this to be undefined
                value: function value(predicate) {
                    // 1. Let O be ? ToObject(this value).
                    if (this == null) throw new TypeError('"this" is null or not defined');
                    var o = Object(this);
                    // 2. Let len be ? ToLength(? Get(O, "length")).
                    var len = o.length >>> 0;
                    // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                    if (typeof predicate !== 'function') throw new TypeError('predicate must be a function');
                    // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                    var thisArg = arguments[1];
                    // 5. Let k be 0.
                    var k = 0;
                    // 6. Repeat, while k < len
                    while(k < len){
                        // a. Let Pk be ! ToString(k).
                        // b. Let kValue be ? Get(O, Pk).
                        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                        // d. If testResult is true, return kValue.
                        var kValue = o[k];
                        if (predicate.call(thisArg, kValue, k, o)) return kValue;
                        // e. Increase k by 1.
                        k++;
                    }
                    // 7. Return undefined.
                    return undefined;
                }
            });
        /***/ },
        /***/ "./src/base/styler.js": /*!****************************!*\
  !*** ./src/base/styler.js ***!
  \****************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            var _template = __webpack_require__(/*! ./template */ "./src/base/template.js");
            var _template2 = _interopRequireDefault(_template);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var Styler = {
                getStyleFor: function getStyleFor(style) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        baseUrl: ''
                    };
                    return (0, _clapprZepto2.default)('<style class="clappr-style"></style>').html((0, _template2.default)(style.toString())(options));
                }
            };
            exports.default = Styler;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/base/svg_icons.js": /*!*******************************!*\
  !*** ./src/base/svg_icons.js ***!
  \*******************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.volumeMute = exports.volume = exports.stop = exports.reload = exports.play = exports.pause = exports.hd = exports.fullscreen = exports.exitFullscreen = exports.cc = undefined;
            var _play = __webpack_require__(/*! ../icons/01-play.svg */ "./src/icons/01-play.svg");
            var _play2 = _interopRequireDefault(_play);
            var _pause = __webpack_require__(/*! ../icons/02-pause.svg */ "./src/icons/02-pause.svg");
            var _pause2 = _interopRequireDefault(_pause);
            var _stop = __webpack_require__(/*! ../icons/03-stop.svg */ "./src/icons/03-stop.svg");
            var _stop2 = _interopRequireDefault(_stop);
            var _volume = __webpack_require__(/*! ../icons/04-volume.svg */ "./src/icons/04-volume.svg");
            var _volume2 = _interopRequireDefault(_volume);
            var _mute = __webpack_require__(/*! ../icons/05-mute.svg */ "./src/icons/05-mute.svg");
            var _mute2 = _interopRequireDefault(_mute);
            var _expand = __webpack_require__(/*! ../icons/06-expand.svg */ "./src/icons/06-expand.svg");
            var _expand2 = _interopRequireDefault(_expand);
            var _shrink = __webpack_require__(/*! ../icons/07-shrink.svg */ "./src/icons/07-shrink.svg");
            var _shrink2 = _interopRequireDefault(_shrink);
            var _hd = __webpack_require__(/*! ../icons/08-hd.svg */ "./src/icons/08-hd.svg");
            var _hd2 = _interopRequireDefault(_hd);
            var _cc = __webpack_require__(/*! ../icons/09-cc.svg */ "./src/icons/09-cc.svg");
            var _cc2 = _interopRequireDefault(_cc);
            var _reload = __webpack_require__(/*! ../icons/10-reload.svg */ "./src/icons/10-reload.svg");
            var _reload2 = _interopRequireDefault(_reload);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var cc = exports.cc = _cc2.default;
            var exitFullscreen = exports.exitFullscreen = _shrink2.default;
            var fullscreen = exports.fullscreen = _expand2.default;
            var hd = exports.hd = _hd2.default;
            var pause = exports.pause = _pause2.default;
            var play = exports.play = _play2.default;
            var reload = exports.reload = _reload2.default;
            var stop = exports.stop = _stop2.default;
            var volume = exports.volume = _volume2.default;
            var volumeMute = exports.volumeMute = _mute2.default;
            exports.default = {
                cc: _cc2.default,
                exitFullscreen: _shrink2.default,
                fullscreen: _expand2.default,
                hd: _hd2.default,
                pause: _pause2.default,
                play: _play2.default,
                reload: _reload2.default,
                stop: _stop2.default,
                volume: _volume2.default,
                volumeMute: _mute2.default
            };
        /***/ },
        /***/ "./src/base/template.js": /*!******************************!*\
  !*** ./src/base/template.js ***!
  \******************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /* eslint-disable no-var */ // Simple JavaScript Templating
            // Paul Miller (http://paulmillr.com)
            // http://underscorejs.org
            // (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
            // By default, Underscore uses ERB-style template delimiters, change the
            // following template settings to use alternative delimiters.
            var settings = {
                evaluate: /<%([\s\S]+?)%>/g,
                interpolate: /<%=([\s\S]+?)%>/g,
                escape: /<%-([\s\S]+?)%>/g
            };
            var noMatch = /(.)^/;
            // Certain characters need to be escaped so that they can be put into a
            // string literal.
            var escapes = {
                '\'': '\'',
                '\\': '\\',
                '\r': 'r',
                '\n': 'n',
                '\t': 't',
                '\u2028': 'u2028',
                '\u2029': 'u2029'
            };
            var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;
            // List of HTML entities for escaping.
            var htmlEntities = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                '\'': '&#x27;'
            };
            var entityRe = new RegExp('[&<>"\']', 'g');
            var escapeExpr = function escapeExpr(string) {
                if (string === null) return '';
                return ('' + string).replace(entityRe, function(match) {
                    return htmlEntities[match];
                });
            };
            var counter = 0;
            // JavaScript micro-templating, similar to John Resig's implementation.
            // Underscore templating handles arbitrary delimiters, preserves whitespace,
            // and correctly escapes quotes within interpolated code.
            var tmpl = function tmpl(text, data) {
                var render;
                // Combine delimiters into one regular expression via alternation.
                var matcher = new RegExp([
                    (settings.escape || noMatch).source,
                    (settings.interpolate || noMatch).source,
                    (settings.evaluate || noMatch).source
                ].join('|') + '|$', 'g');
                // Compile the template source, escaping string literals appropriately.
                var index = 0;
                var source = '__p+=\'';
                text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
                    source += text.slice(index, offset).replace(escaper, function(match) {
                        return '\\' + escapes[match];
                    });
                    if (escape) source += '\'+\n((__t=(' + escape + '))==null?\'\':escapeExpr(__t))+\n\'';
                    if (interpolate) source += '\'+\n((__t=(' + interpolate + '))==null?\'\':__t)+\n\'';
                    if (evaluate) source += '\';\n' + evaluate + '\n__p+=\'';
                    index = offset + match.length;
                    return match;
                });
                source += '\';\n';
                // If a variable is not specified, place data values in local scope.
                if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
                source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n//# sourceURL=/microtemplates/source[' + counter++ + ']';
                try {
                    /*jshint -W054 */ // TODO: find a way to avoid eval
                    render = new Function(settings.variable || 'obj', 'escapeExpr', source);
                } catch (e) {
                    e.source = source;
                    throw e;
                }
                if (data) return render(data, escapeExpr);
                var template = function template(data) {
                    return render.call(this, data, escapeExpr);
                };
                // Provide the compiled function source as a convenience for precompilation.
                template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';
                return template;
            };
            tmpl.settings = settings;
            exports.default = tmpl;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/base/ui_container_plugin.js": /*!*****************************************!*\
  !*** ./src/base/ui_container_plugin.js ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
            var _assign2 = _interopRequireDefault(_assign);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _utils = __webpack_require__(/*! ./utils */ "./src/base/utils.js");
            var _ui_object = __webpack_require__(/*! ./ui_object */ "./src/base/ui_object.js");
            var _ui_object2 = _interopRequireDefault(_ui_object);
            var _error_mixin = __webpack_require__(/*! ./error_mixin */ "./src/base/error_mixin.js");
            var _error_mixin2 = _interopRequireDefault(_error_mixin);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
 * The base class for an ui container plugin
 * @class UIContainerPlugin
 * @constructor
 * @extends UIObject
 * @module base
 */ var UIContainerPlugin = function(_UIObject) {
                (0, _inherits3.default)(UIContainerPlugin, _UIObject);
                (0, _createClass3.default)(UIContainerPlugin, [
                    {
                        key: 'playerError',
                        get: function get() {
                            return this.container.playerError;
                        }
                    }
                ]);
                function UIContainerPlugin(container) {
                    (0, _classCallCheck3.default)(this, UIContainerPlugin);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _UIObject.call(this, container.options));
                    _this.container = container;
                    _this.enabled = true;
                    _this.bindEvents();
                    return _this;
                }
                UIContainerPlugin.prototype.enable = function enable() {
                    if (!this.enabled) {
                        this.bindEvents();
                        this.$el.show();
                        this.enabled = true;
                    }
                };
                UIContainerPlugin.prototype.disable = function disable() {
                    this.stopListening();
                    this.$el.hide();
                    this.enabled = false;
                };
                UIContainerPlugin.prototype.bindEvents = function bindEvents() {};
                return UIContainerPlugin;
            }(_ui_object2.default); // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            exports.default = UIContainerPlugin;
            (0, _assign2.default)(UIContainerPlugin.prototype, _error_mixin2.default);
            UIContainerPlugin.extend = function(properties) {
                return (0, _utils.extend)(UIContainerPlugin, properties);
            };
            UIContainerPlugin.type = 'container';
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/base/ui_core_plugin.js": /*!************************************!*\
  !*** ./src/base/ui_core_plugin.js ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
            var _assign2 = _interopRequireDefault(_assign);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _utils = __webpack_require__(/*! ./utils */ "./src/base/utils.js");
            var _ui_object = __webpack_require__(/*! ./ui_object */ "./src/base/ui_object.js");
            var _ui_object2 = _interopRequireDefault(_ui_object);
            var _error_mixin = __webpack_require__(/*! ./error_mixin */ "./src/base/error_mixin.js");
            var _error_mixin2 = _interopRequireDefault(_error_mixin);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var UICorePlugin = function(_UIObject) {
                (0, _inherits3.default)(UICorePlugin, _UIObject);
                (0, _createClass3.default)(UICorePlugin, [
                    {
                        key: 'playerError',
                        get: function get() {
                            return this.core.playerError;
                        }
                    }
                ]);
                function UICorePlugin(core) {
                    (0, _classCallCheck3.default)(this, UICorePlugin);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _UIObject.call(this, core.options));
                    _this.core = core;
                    _this.enabled = true;
                    _this.bindEvents();
                    _this.render();
                    return _this;
                }
                UICorePlugin.prototype.bindEvents = function bindEvents() {};
                UICorePlugin.prototype.getExternalInterface = function getExternalInterface() {
                    return {};
                };
                UICorePlugin.prototype.enable = function enable() {
                    if (!this.enabled) {
                        this.bindEvents();
                        this.$el.show();
                        this.enabled = true;
                    }
                };
                UICorePlugin.prototype.disable = function disable() {
                    this.stopListening();
                    this.$el.hide();
                    this.enabled = false;
                };
                UICorePlugin.prototype.render = function render() {
                    return this;
                };
                return UICorePlugin;
            }(_ui_object2.default);
            exports.default = UICorePlugin;
            (0, _assign2.default)(UICorePlugin.prototype, _error_mixin2.default);
            UICorePlugin.extend = function(properties) {
                return (0, _utils.extend)(UICorePlugin, properties);
            };
            UICorePlugin.type = 'core';
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/base/ui_object.js": /*!*******************************!*\
  !*** ./src/base/ui_object.js ***!
  \*******************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            var _utils = __webpack_require__(/*! ./utils */ "./src/base/utils.js");
            var _base_object = __webpack_require__(/*! ./base_object */ "./src/base/base_object.js");
            var _base_object2 = _interopRequireDefault(_base_object);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var delegateEventSplitter = /^(\S+)\s*(.*)$/;
            /**
 * A base class to create ui object.
 * @class UIObject
 * @constructor
 * @extends BaseObject
 * @module base
 */ // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var UIObject = function(_BaseObject) {
                (0, _inherits3.default)(UIObject, _BaseObject);
                (0, _createClass3.default)(UIObject, [
                    {
                        key: 'tagName',
                        /**
     * a unique id prefixed with `'c'`, `c1, c232`
     *
     * @property cid
     * @type String
     */ /**
     * the dom element itself
     *
     * @property el
     * @type HTMLElement
     */ /**
     * the dom element wrapped by `$`
     *
     * @property $el
     * @type HTMLElement
     */ /**
     * gets the tag name for the ui component
     * @method tagName
     * @default div
     * @return {String} tag's name
     */ get: function get() {
                            return 'div';
                        }
                    },
                    {
                        key: 'events',
                        get: function get() {
                            return {};
                        }
                    },
                    {
                        key: 'attributes',
                        get: function get() {
                            return {};
                        }
                    }
                ]);
                function UIObject(options) {
                    (0, _classCallCheck3.default)(this, UIObject);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _BaseObject.call(this, options));
                    _this.cid = (0, _utils.uniqueId)('c');
                    _this._ensureElement();
                    _this.delegateEvents();
                    return _this;
                }
                /**
   * selects within the component.
   * @method $
   * @param {String} selector a selector to find within the component.
   * @return {HTMLElement} an element, if it exists.
   * @example
   * ```javascript
   * fullScreenBarUIComponent.$('.button-full') //will return only `.button-full` within the component
   * ```
   */ UIObject.prototype.$ = function $(selector) {
                    return this.$el.find(selector);
                };
                /**
   * render the component, usually attach it to a real existent `element`
   * @method render
   * @return {UIObject} itself
   */ UIObject.prototype.render = function render() {
                    return this;
                };
                /**
   * removes the ui component from DOM
   * @method destroy
   * @return {UIObject} itself
   */ UIObject.prototype.destroy = function destroy() {
                    this.$el.remove();
                    this.stopListening();
                    this.undelegateEvents();
                    return this;
                };
                /**
   * set element to `el` and `$el`
   * @method setElement
   * @param {HTMLElement} element
   * @param {Boolean} delegate whether is delegate or not
   * @return {UIObject} itself
   */ UIObject.prototype.setElement = function setElement(element, delegate) {
                    if (this.$el) this.undelegateEvents();
                    this.$el = _clapprZepto2.default.zepto.isZ(element) ? element : (0, _clapprZepto2.default)(element);
                    this.el = this.$el[0];
                    if (delegate !== false) this.delegateEvents();
                    return this;
                };
                /**
   * delegates all the original `events` on `element` to its callbacks
   * @method delegateEvents
   * @param {Object} events
   * @return {UIObject} itself
   */ UIObject.prototype.delegateEvents = function delegateEvents(events) {
                    if (!(events || (events = this.events))) return this;
                    this.undelegateEvents();
                    for(var key in events){
                        var method = events[key];
                        if (method && method.constructor !== Function) method = this[events[key]];
                        if (!method) continue;
                        var match = key.match(delegateEventSplitter);
                        var eventName = match[1], selector = match[2];
                        eventName += '.delegateEvents' + this.cid;
                        if (selector === '') this.$el.on(eventName, method.bind(this));
                        else this.$el.on(eventName, selector, method.bind(this));
                    }
                    return this;
                };
                /**
   * undelegats all the `events`
   * @method undelegateEvents
   * @return {UIObject} itself
   */ UIObject.prototype.undelegateEvents = function undelegateEvents() {
                    this.$el.off('.delegateEvents' + this.cid);
                    return this;
                };
                /**
   * ensures the creation of this ui component
   * @method _ensureElement
   * @private
   */ UIObject.prototype._ensureElement = function _ensureElement() {
                    if (!this.el) {
                        var attrs = _clapprZepto2.default.extend({}, this.attributes);
                        if (this.id) attrs.id = this.id;
                        if (this.className) attrs['class'] = this.className;
                        var $el = _utils.DomRecycler.create(this.tagName).attr(attrs);
                        this.setElement($el, false);
                    } else this.setElement(this.el, false);
                };
                return UIObject;
            }(_base_object2.default);
            exports.default = UIObject;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/base/utils.js": /*!***************************!*\
  !*** ./src/base/utils.js ***!
  \***************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SvgIcons = exports.DoubleEventHandler = exports.DomRecycler = exports.cancelAnimationFrame = exports.requestAnimationFrame = exports.QueryString = exports.Config = exports.Fullscreen = undefined;
            var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
            var _assign2 = _interopRequireDefault(_assign);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _defineProperty = __webpack_require__(/*! babel-runtime/core-js/object/define-property */ "./node_modules/babel-runtime/core-js/object/define-property.js");
            var _defineProperty2 = _interopRequireDefault(_defineProperty);
            var _getOwnPropertyDescriptor = __webpack_require__(/*! babel-runtime/core-js/object/get-own-property-descriptor */ "./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");
            var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
            exports.assign = assign;
            exports.extend = extend;
            exports.formatTime = formatTime;
            exports.seekStringToSeconds = seekStringToSeconds;
            exports.uniqueId = uniqueId;
            exports.isNumber = isNumber;
            exports.currentScriptUrl = currentScriptUrl;
            exports.getBrowserLanguage = getBrowserLanguage;
            exports.now = now;
            exports.removeArrayItem = removeArrayItem;
            exports.listContainsIgnoreCase = listContainsIgnoreCase;
            exports.canAutoPlayMedia = canAutoPlayMedia;
            __webpack_require__(/*! ./polyfills */ "./src/base/polyfills.js");
            var _browser = __webpack_require__(/*! ../components/browser */ "./src/components/browser/index.js");
            var _browser2 = _interopRequireDefault(_browser);
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            var _media = __webpack_require__(/*! ./media */ "./src/base/media.js");
            var _media2 = _interopRequireDefault(_media);
            var _svg_icons = __webpack_require__(/*! ./svg_icons */ "./src/base/svg_icons.js");
            var _svg_icons2 = _interopRequireDefault(_svg_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function assign(obj, source) {
                if (source) for(var prop in source){
                    var propDescriptor = (0, _getOwnPropertyDescriptor2.default)(source, prop);
                    propDescriptor ? (0, _defineProperty2.default)(obj, prop, propDescriptor) : obj[prop] = source[prop];
                }
                return obj;
            } // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            /*jshint -W079 */ function extend(parent, properties) {
                var Surrogate = function(_parent) {
                    (0, _inherits3.default)(Surrogate, _parent);
                    function Surrogate() {
                        (0, _classCallCheck3.default)(this, Surrogate);
                        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        var _this = (0, _possibleConstructorReturn3.default)(this, _parent.call.apply(_parent, [
                            this
                        ].concat(args)));
                        if (properties.initialize) properties.initialize.apply(_this, args);
                        return _this;
                    }
                    return Surrogate;
                }(parent);
                assign(Surrogate.prototype, properties);
                return Surrogate;
            }
            function formatTime(time, paddedHours) {
                if (!isFinite(time)) return '--:--';
                time = time * 1000;
                time = parseInt(time / 1000);
                var seconds = time % 60;
                time = parseInt(time / 60);
                var minutes = time % 60;
                time = parseInt(time / 60);
                var hours = time % 24;
                var days = parseInt(time / 24);
                var out = '';
                if (days && days > 0) {
                    out += days + ':';
                    if (hours < 1) out += '00:';
                }
                if (hours && hours > 0 || paddedHours) out += ('0' + hours).slice(-2) + ':';
                out += ('0' + minutes).slice(-2) + ':';
                out += ('0' + seconds).slice(-2);
                return out.trim();
            }
            var Fullscreen = exports.Fullscreen = {
                fullscreenElement: function fullscreenElement() {
                    return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
                },
                requestFullscreen: function requestFullscreen(el) {
                    if (el.requestFullscreen) el.requestFullscreen();
                    else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
                    else if (el.mozRequestFullScreen) el.mozRequestFullScreen();
                    else if (el.msRequestFullscreen) el.msRequestFullscreen();
                    else if (el.querySelector && el.querySelector('video') && el.querySelector('video').webkitEnterFullScreen) el.querySelector('video').webkitEnterFullScreen();
                    else if (el.webkitEnterFullScreen) el.webkitEnterFullScreen();
                },
                cancelFullscreen: function cancelFullscreen() {
                    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
                    if (el.exitFullscreen) el.exitFullscreen();
                    else if (el.webkitCancelFullScreen) el.webkitCancelFullScreen();
                    else if (el.webkitExitFullscreen) el.webkitExitFullscreen();
                    else if (el.mozCancelFullScreen) el.mozCancelFullScreen();
                    else if (el.msExitFullscreen) el.msExitFullscreen();
                },
                fullscreenEnabled: function fullscreenEnabled() {
                    return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
                }
            };
            var Config = exports.Config = function() {
                function Config() {
                    (0, _classCallCheck3.default)(this, Config);
                }
                Config._defaultConfig = function _defaultConfig() {
                    return {
                        volume: {
                            value: 100,
                            parse: parseInt
                        }
                    };
                };
                Config._defaultValueFor = function _defaultValueFor(key) {
                    try {
                        return this._defaultConfig()[key].parse(this._defaultConfig()[key].value);
                    } catch (e) {
                        return undefined;
                    }
                };
                Config._createKeyspace = function _createKeyspace(key) {
                    return 'clappr.' + document.domain + '.' + key;
                };
                Config.restore = function restore(key) {
                    if (_browser2.default.hasLocalstorage && localStorage[this._createKeyspace(key)]) return this._defaultConfig()[key].parse(localStorage[this._createKeyspace(key)]);
                    return this._defaultValueFor(key);
                };
                Config.persist = function persist(key, value) {
                    if (_browser2.default.hasLocalstorage) try {
                        localStorage[this._createKeyspace(key)] = value;
                        return true;
                    } catch (e) {
                        return false;
                    }
                };
                return Config;
            }();
            var QueryString = exports.QueryString = function() {
                function QueryString() {
                    (0, _classCallCheck3.default)(this, QueryString);
                }
                QueryString.parse = function parse(paramsString) {
                    var match = void 0;
                    var pl = /\+/g, // Regex for replacing addition symbol with a space
                    search = /([^&=]+)=?([^&]*)/g, decode = function decode(s) {
                        return decodeURIComponent(s.replace(pl, ' '));
                    }, params = {};
                    while(match = search.exec(paramsString))// eslint-disable-line no-cond-assign
                    params[decode(match[1]).toLowerCase()] = decode(match[2]);
                    return params;
                };
                (0, _createClass3.default)(QueryString, null, [
                    {
                        key: 'params',
                        get: function get() {
                            var query = window.location.search.substring(1);
                            if (query !== this.query) {
                                this._urlParams = this.parse(query);
                                this.query = query;
                            }
                            return this._urlParams;
                        }
                    },
                    {
                        key: 'hashParams',
                        get: function get() {
                            var hash = window.location.hash.substring(1);
                            if (hash !== this.hash) {
                                this._hashParams = this.parse(hash);
                                this.hash = hash;
                            }
                            return this._hashParams;
                        }
                    }
                ]);
                return QueryString;
            }();
            function seekStringToSeconds() {
                var paramName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 't';
                var seconds = 0;
                var seekString = QueryString.params[paramName] || QueryString.hashParams[paramName] || '';
                var parts = seekString.match(/[0-9]+[hms]+/g) || [];
                if (parts.length > 0) {
                    var factor = {
                        'h': 3600,
                        'm': 60,
                        's': 1
                    };
                    parts.forEach(function(el) {
                        if (el) {
                            var suffix = el[el.length - 1];
                            var time = parseInt(el.slice(0, el.length - 1), 10);
                            seconds += time * factor[suffix];
                        }
                    });
                } else if (seekString) seconds = parseInt(seekString, 10);
                return seconds;
            }
            var idsCounter = {};
            function uniqueId(prefix) {
                idsCounter[prefix] || (idsCounter[prefix] = 0);
                var id = ++idsCounter[prefix];
                return prefix + id;
            }
            function isNumber(value) {
                return value - parseFloat(value) + 1 >= 0;
            }
            function currentScriptUrl() {
                var scripts = document.getElementsByTagName('script');
                return scripts.length ? scripts[scripts.length - 1].src : '';
            }
            var requestAnimationFrame = exports.requestAnimationFrame = (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) {
                window.setTimeout(fn, 1000 / 60);
            }).bind(window);
            var cancelAnimationFrame = exports.cancelAnimationFrame = (window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout).bind(window);
            function getBrowserLanguage() {
                return window.navigator && window.navigator.language;
            }
            function now() {
                if (window.performance && window.performance.now) return performance.now();
                return Date.now();
            }
            // remove the item from the array if it exists in the array
            function removeArrayItem(arr, item) {
                var i = arr.indexOf(item);
                if (i >= 0) arr.splice(i, 1);
            }
            // find an item regardless of its letter case
            function listContainsIgnoreCase(item, items) {
                if (item === undefined || items === undefined) return false;
                return items.find(function(itemEach) {
                    return item.toLowerCase() === itemEach.toLowerCase();
                }) !== undefined;
            }
            // https://github.com/video-dev/can-autoplay
            function canAutoPlayMedia(cb, options) {
                options = (0, _assign2.default)({
                    inline: false,
                    muted: false,
                    timeout: 250,
                    type: 'video',
                    source: _media2.default.mp4,
                    element: null
                }, options);
                var element = options.element ? options.element : document.createElement(options.type);
                element.muted = options.muted;
                if (options.muted === true) element.setAttribute('muted', 'muted');
                if (options.inline === true) element.setAttribute('playsinline', 'playsinline');
                element.src = options.source;
                var promise = element.play();
                var timeoutId = setTimeout(function() {
                    setResult(false, new Error('Timeout ' + options.timeout + ' ms has been reached'));
                }, options.timeout);
                var setResult = function setResult(result) {
                    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                    clearTimeout(timeoutId);
                    cb(result, error);
                };
                if (promise !== undefined) promise.then(function() {
                    return setResult(true);
                }).catch(function(err) {
                    return setResult(false, err);
                });
                else setResult(true);
            }
            // Simple Zepto element factory with video recycle feature.
            var videoStack = [];
            var DomRecycler = exports.DomRecycler = function() {
                function DomRecycler() {
                    (0, _classCallCheck3.default)(this, DomRecycler);
                }
                DomRecycler.configure = function configure(options) {
                    this.options = _clapprZepto2.default.extend(this.options, options);
                };
                DomRecycler.create = function create(name) {
                    if (this.options.recycleVideo && name === 'video' && videoStack.length > 0) return videoStack.shift();
                    return (0, _clapprZepto2.default)('<' + name + '>');
                };
                DomRecycler.garbage = function garbage($el) {
                    // Expect Zepto collection with single element (does not iterate!)
                    if (!this.options.recycleVideo || $el[0].tagName.toUpperCase() !== 'VIDEO') return;
                    $el.children().remove();
                    videoStack.push($el);
                };
                return DomRecycler;
            }();
            DomRecycler.options = {
                recycleVideo: false
            };
            var DoubleEventHandler = exports.DoubleEventHandler = function() {
                function DoubleEventHandler() {
                    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
                    (0, _classCallCheck3.default)(this, DoubleEventHandler);
                    this.delay = delay;
                    this.lastTime = 0;
                }
                DoubleEventHandler.prototype.handle = function handle(event, cb) {
                    var prevented = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                    // Based on http://jsfiddle.net/brettwp/J4djY/
                    var currentTime = new Date().getTime();
                    var diffTime = currentTime - this.lastTime;
                    if (diffTime < this.delay && diffTime > 0) {
                        cb();
                        prevented && event.preventDefault();
                    }
                    this.lastTime = currentTime;
                };
                return DoubleEventHandler;
            }();
            var SvgIcons = exports.SvgIcons = _svg_icons2.default;
            exports.default = {
                Config: Config,
                Fullscreen: Fullscreen,
                QueryString: QueryString,
                DomRecycler: DomRecycler,
                extend: extend,
                formatTime: formatTime,
                seekStringToSeconds: seekStringToSeconds,
                uniqueId: uniqueId,
                currentScriptUrl: currentScriptUrl,
                isNumber: isNumber,
                requestAnimationFrame: requestAnimationFrame,
                cancelAnimationFrame: cancelAnimationFrame,
                getBrowserLanguage: getBrowserLanguage,
                now: now,
                removeArrayItem: removeArrayItem,
                canAutoPlayMedia: canAutoPlayMedia,
                Media: _media2.default,
                DoubleEventHandler: DoubleEventHandler,
                SvgIcons: _svg_icons2.default
            };
        /***/ },
        /***/ "./src/components/browser/browser.js": /*!*******************************************!*\
  !*** ./src/components/browser/browser.js ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.getDevice = exports.getViewportSize = exports.getOsData = exports.getBrowserData = exports.getBrowserInfo = undefined;
            var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ "./node_modules/babel-runtime/core-js/get-iterator.js");
            var _getIterator3 = _interopRequireDefault(_getIterator2);
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            var _browser_data = __webpack_require__(/*! ./browser_data */ "./src/components/browser/browser_data.js");
            var _browser_data2 = _interopRequireDefault(_browser_data);
            var _os_data = __webpack_require__(/*! ./os_data */ "./src/components/browser/os_data.js");
            var _os_data2 = _interopRequireDefault(_os_data);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var Browser = {};
            var hasLocalstorage = function hasLocalstorage() {
                try {
                    localStorage.setItem('clappr', 'clappr');
                    localStorage.removeItem('clappr');
                    return true;
                } catch (e) {
                    return false;
                }
            };
            var hasFlash = function hasFlash() {
                try {
                    var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
                    return !!fo;
                } catch (e) {
                    return !!(navigator.mimeTypes && navigator.mimeTypes['application/x-shockwave-flash'] !== undefined && navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin);
                }
            };
            var getBrowserInfo = exports.getBrowserInfo = function getBrowserInfo(ua) {
                var parts = ua.match(/\b(playstation 4|nx|opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [], extra = void 0;
                if (/trident/i.test(parts[1])) {
                    extra = /\brv[ :]+(\d+)/g.exec(ua) || [];
                    return {
                        name: 'IE',
                        version: parseInt(extra[1] || '')
                    };
                } else if (parts[1] === 'Chrome') {
                    extra = ua.match(/\bOPR\/(\d+)/);
                    if (extra != null) return {
                        name: 'Opera',
                        version: parseInt(extra[1])
                    };
                    extra = ua.match(/\bEdge\/(\d+)/);
                    if (extra != null) return {
                        name: 'Edge',
                        version: parseInt(extra[1])
                    };
                } else if (/android/i.test(ua) && (extra = ua.match(/version\/(\d+)/i))) {
                    parts.splice(1, 1, 'Android WebView');
                    parts.splice(2, 1, extra[1]);
                }
                parts = parts[2] ? [
                    parts[1],
                    parts[2]
                ] : [
                    navigator.appName,
                    navigator.appVersion,
                    '-?'
                ];
                return {
                    name: parts[0],
                    version: parseInt(parts[1])
                };
            };
            //  Get browser data
            var getBrowserData = exports.getBrowserData = function getBrowserData() {
                var browserObject = {};
                var userAgent = Browser.userAgent.toLowerCase();
                // Check browser type
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                    for(var _iterator = (0, _getIterator3.default)(_browser_data2.default), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var browser = _step.value;
                        var browserRegExp = new RegExp(browser.identifier.toLowerCase());
                        var browserRegExpResult = browserRegExp.exec(userAgent);
                        if (browserRegExpResult != null && browserRegExpResult[1]) {
                            browserObject.name = browser.name;
                            browserObject.group = browser.group;
                            // Check version
                            if (browser.versionIdentifier) {
                                var versionRegExp = new RegExp(browser.versionIdentifier.toLowerCase());
                                var versionRegExpResult = versionRegExp.exec(userAgent);
                                if (versionRegExpResult != null && versionRegExpResult[1]) setBrowserVersion(versionRegExpResult[1], browserObject);
                            } else setBrowserVersion(browserRegExpResult[1], browserObject);
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                    } finally{
                        if (_didIteratorError) throw _iteratorError;
                    }
                }
                return browserObject;
            };
            // Set browser version
            var setBrowserVersion = function setBrowserVersion(version, browserObject) {
                var splitVersion = version.split('.', 2);
                browserObject.fullVersion = version;
                // Major version
                if (splitVersion[0]) browserObject.majorVersion = parseInt(splitVersion[0]);
                // Minor version
                if (splitVersion[1]) browserObject.minorVersion = parseInt(splitVersion[1]);
            };
            //  Get OS data
            var getOsData = exports.getOsData = function getOsData() {
                var osObject = {};
                var userAgent = Browser.userAgent.toLowerCase();
                // Check browser type
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = (0, _getIterator3.default)(_os_data2.default), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var os = _step2.value;
                        var osRegExp = new RegExp(os.identifier.toLowerCase());
                        var osRegExpResult = osRegExp.exec(userAgent);
                        if (osRegExpResult != null) {
                            osObject.name = os.name;
                            osObject.group = os.group;
                            // Version defined
                            if (os.version) setOsVersion(os.version, os.versionSeparator ? os.versionSeparator : '.', osObject);
                            else if (osRegExpResult[1]) setOsVersion(osRegExpResult[1], os.versionSeparator ? os.versionSeparator : '.', osObject);
                            else if (os.versionIdentifier) {
                                var versionRegExp = new RegExp(os.versionIdentifier.toLowerCase());
                                var versionRegExpResult = versionRegExp.exec(userAgent);
                                if (versionRegExpResult != null && versionRegExpResult[1]) setOsVersion(versionRegExpResult[1], os.versionSeparator ? os.versionSeparator : '.', osObject);
                            }
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                    } finally{
                        if (_didIteratorError2) throw _iteratorError2;
                    }
                }
                return osObject;
            };
            // Set OS version
            var setOsVersion = function setOsVersion(version, separator, osObject) {
                var finalSeparator = separator.substr(0, 1) == '[' ? new RegExp(separator, 'g') : separator;
                var splitVersion = version.split(finalSeparator, 2);
                if (separator != '.') version = version.replace(new RegExp(separator, 'g'), '.');
                osObject.fullVersion = version;
                // Major version
                if (splitVersion && splitVersion[0]) osObject.majorVersion = parseInt(splitVersion[0]);
                // Minor version
                if (splitVersion && splitVersion[1]) osObject.minorVersion = parseInt(splitVersion[1]);
            };
            // Set viewport size
            var getViewportSize = exports.getViewportSize = function getViewportSize() {
                var viewportObject = {};
                viewportObject.width = (0, _clapprZepto2.default)(window).width();
                viewportObject.height = (0, _clapprZepto2.default)(window).height();
                return viewportObject;
            };
            // Set viewport orientation
            var setViewportOrientation = function setViewportOrientation() {
                switch(window.orientation){
                    case -90:
                    case 90:
                        Browser.viewport.orientation = 'landscape';
                        break;
                    default:
                        Browser.viewport.orientation = 'portrait';
                        break;
                }
            };
            var getDevice = exports.getDevice = function getDevice(ua) {
                var platformRegExp = /\((iP(?:hone|ad|od))?(?:[^;]*; ){0,2}([^)]+(?=\)))/;
                var matches = platformRegExp.exec(ua);
                var device = matches && (matches[1] || matches[2]) || '';
                return device;
            };
            var browserInfo = getBrowserInfo(navigator.userAgent);
            Browser.isEdge = /edge/i.test(navigator.userAgent);
            Browser.isChrome = /chrome|CriOS/i.test(navigator.userAgent) && !Browser.isEdge;
            Browser.isSafari = /safari/i.test(navigator.userAgent) && !Browser.isChrome && !Browser.isEdge;
            Browser.isFirefox = /firefox/i.test(navigator.userAgent);
            Browser.isLegacyIE = !!window.ActiveXObject;
            Browser.isIE = Browser.isLegacyIE || /trident.*rv:1\d/i.test(navigator.userAgent);
            Browser.isIE11 = /trident.*rv:11/i.test(navigator.userAgent);
            Browser.isChromecast = Browser.isChrome && /CrKey/i.test(navigator.userAgent);
            Browser.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|IEMobile|Mobile Safari|Opera Mini/i.test(navigator.userAgent);
            Browser.isiOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
            Browser.isAndroid = /Android/i.test(navigator.userAgent);
            Browser.isWindowsPhone = /Windows Phone/i.test(navigator.userAgent);
            Browser.isWin8App = /MSAppHost/i.test(navigator.userAgent);
            Browser.isWiiU = /WiiU/i.test(navigator.userAgent);
            Browser.isPS4 = /PlayStation 4/i.test(navigator.userAgent);
            Browser.hasLocalstorage = hasLocalstorage();
            Browser.hasFlash = hasFlash();
            /**
* @deprecated
* This parameter currently exists for retrocompatibility reasons.
* Use Browser.data.name instead.
*/ Browser.name = browserInfo.name;
            /**
* @deprecated
* This parameter currently exists for retrocompatibility reasons.
* Use Browser.data.fullVersion instead.
*/ Browser.version = browserInfo.version;
            Browser.userAgent = navigator.userAgent;
            Browser.data = getBrowserData();
            Browser.os = getOsData();
            Browser.viewport = getViewportSize();
            Browser.device = getDevice(Browser.userAgent);
            typeof window.orientation !== 'undefined' && setViewportOrientation();
            exports.default = Browser;
        /***/ },
        /***/ "./src/components/browser/browser_data.js": /*!************************************************!*\
  !*** ./src/components/browser/browser_data.js ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /* eslint-disable no-useless-escape */ // The order of the following arrays is important, be careful if you change it.
            var BROWSER_DATA = [
                {
                    name: 'Chromium',
                    group: 'Chrome',
                    identifier: 'Chromium/([0-9\.]*)'
                },
                {
                    name: 'Chrome Mobile',
                    group: 'Chrome',
                    identifier: 'Chrome/([0-9\.]*) Mobile',
                    versionIdentifier: 'Chrome/([0-9\.]*)'
                },
                {
                    name: 'Chrome',
                    group: 'Chrome',
                    identifier: 'Chrome/([0-9\.]*)'
                },
                {
                    name: 'Chrome for iOS',
                    group: 'Chrome',
                    identifier: 'CriOS/([0-9\.]*)'
                },
                {
                    name: 'Android Browser',
                    group: 'Chrome',
                    identifier: 'CrMo/([0-9\.]*)'
                },
                {
                    name: 'Firefox',
                    group: 'Firefox',
                    identifier: 'Firefox/([0-9\.]*)'
                },
                {
                    name: 'Opera Mini',
                    group: 'Opera',
                    identifier: 'Opera Mini/([0-9\.]*)'
                },
                {
                    name: 'Opera',
                    group: 'Opera',
                    identifier: 'Opera ([0-9\.]*)'
                },
                {
                    name: 'Opera',
                    group: 'Opera',
                    identifier: 'Opera/([0-9\.]*)',
                    versionIdentifier: 'Version/([0-9\.]*)'
                },
                {
                    name: 'IEMobile',
                    group: 'Explorer',
                    identifier: 'IEMobile/([0-9\.]*)'
                },
                {
                    name: 'Internet Explorer',
                    group: 'Explorer',
                    identifier: 'MSIE ([a-zA-Z0-9\.]*)'
                },
                {
                    name: 'Internet Explorer',
                    group: 'Explorer',
                    identifier: 'Trident/([0-9\.]*)',
                    versionIdentifier: 'rv:([0-9\.]*)'
                },
                {
                    name: 'Spartan',
                    group: 'Spartan',
                    identifier: 'Edge/([0-9\.]*)',
                    versionIdentifier: 'Edge/([0-9\.]*)'
                },
                {
                    name: 'Safari',
                    group: 'Safari',
                    identifier: 'Safari/([0-9\.]*)',
                    versionIdentifier: 'Version/([0-9\.]*)'
                }
            ];
            exports.default = BROWSER_DATA;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/browser/index.js": /*!*****************************************!*\
  !*** ./src/components/browser/index.js ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _browser = __webpack_require__(/*! ./browser */ "./src/components/browser/browser.js");
            var _browser2 = _interopRequireDefault(_browser);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _browser2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/browser/os_data.js": /*!*******************************************!*\
  !*** ./src/components/browser/os_data.js ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /* eslint-disable no-useless-escape */ // The order of the following arrays is important, be careful if you change it.
            var OS_DATA = [
                {
                    name: 'Windows 2000',
                    group: 'Windows',
                    identifier: 'Windows NT 5.0',
                    version: '5.0'
                },
                {
                    name: 'Windows XP',
                    group: 'Windows',
                    identifier: 'Windows NT 5.1',
                    version: '5.1'
                },
                {
                    name: 'Windows Vista',
                    group: 'Windows',
                    identifier: 'Windows NT 6.0',
                    version: '6.0'
                },
                {
                    name: 'Windows 7',
                    group: 'Windows',
                    identifier: 'Windows NT 6.1',
                    version: '7.0'
                },
                {
                    name: 'Windows 8',
                    group: 'Windows',
                    identifier: 'Windows NT 6.2',
                    version: '8.0'
                },
                {
                    name: 'Windows 8.1',
                    group: 'Windows',
                    identifier: 'Windows NT 6.3',
                    version: '8.1'
                },
                {
                    name: 'Windows 10',
                    group: 'Windows',
                    identifier: 'Windows NT 10.0',
                    version: '10.0'
                },
                {
                    name: 'Windows Phone',
                    group: 'Windows Phone',
                    identifier: 'Windows Phone ([0-9\.]*)'
                },
                {
                    name: 'Windows Phone',
                    group: 'Windows Phone',
                    identifier: 'Windows Phone OS ([0-9\.]*)'
                },
                {
                    name: 'Windows',
                    group: 'Windows',
                    identifier: 'Windows'
                },
                {
                    name: 'Chrome OS',
                    group: 'Chrome OS',
                    identifier: 'CrOS'
                },
                {
                    name: 'Android',
                    group: 'Android',
                    identifier: 'Android',
                    versionIdentifier: 'Android ([a-zA-Z0-9\.-]*)'
                },
                {
                    name: 'iPad',
                    group: 'iOS',
                    identifier: 'iPad',
                    versionIdentifier: 'OS ([0-9_]*)',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'iPod',
                    group: 'iOS',
                    identifier: 'iPod',
                    versionIdentifier: 'OS ([0-9_]*)',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'iPhone',
                    group: 'iOS',
                    identifier: 'iPhone OS',
                    versionIdentifier: 'OS ([0-9_]*)',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X High Sierra',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])13([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X Sierra',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])12([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X El Capitan',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])11([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X Yosemite',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])10([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X Mavericks',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])9([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X Mountain Lion',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])8([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X Lion',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])7([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X Snow Leopard',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])6([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X Leopard',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])5([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X Tiger',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])4([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X Panther',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])3([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X Jaguar',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])2([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X Puma',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])1([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS X Cheetah',
                    group: 'Mac OS',
                    identifier: 'Mac OS X (10([_|\.])0([0-9_\.]*))',
                    versionSeparator: '[_|\.]'
                },
                {
                    name: 'Mac OS',
                    group: 'Mac OS',
                    identifier: 'Mac OS'
                },
                {
                    name: 'Ubuntu',
                    group: 'Linux',
                    identifier: 'Ubuntu',
                    versionIdentifier: 'Ubuntu/([0-9\.]*)'
                },
                {
                    name: 'Debian',
                    group: 'Linux',
                    identifier: 'Debian'
                },
                {
                    name: 'Gentoo',
                    group: 'Linux',
                    identifier: 'Gentoo'
                },
                {
                    name: 'Linux',
                    group: 'Linux',
                    identifier: 'Linux'
                },
                {
                    name: 'BlackBerry',
                    group: 'BlackBerry',
                    identifier: 'BlackBerry'
                }
            ];
            exports.default = OS_DATA;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/container/container.js": /*!***********************************************!*\
  !*** ./src/components/container/container.js ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
            var _assign2 = _interopRequireDefault(_assign);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _ui_object = __webpack_require__(/*! ../../base/ui_object */ "./src/base/ui_object.js");
            var _ui_object2 = _interopRequireDefault(_ui_object);
            var _error_mixin = __webpack_require__(/*! ../../base/error_mixin */ "./src/base/error_mixin.js");
            var _error_mixin2 = _interopRequireDefault(_error_mixin);
            var _utils = __webpack_require__(/*! ../../base/utils */ "./src/base/utils.js");
            __webpack_require__(/*! ./public/style.scss */ "./src/components/container/public/style.scss");
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
 * An abstraction to represent a container for a given playback
 * TODO: describe its responsabilities
 * @class Container
 * @constructor
 * @extends UIObject
 * @module base
 */ // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            /**
 * Container is responsible for the video rendering and state
 */ var Container = function(_UIObject) {
                (0, _inherits3.default)(Container, _UIObject);
                (0, _createClass3.default)(Container, [
                    {
                        key: 'name',
                        /**
     * container's name
     * @method name
     * @default Container
     * @return {String} container's name
     */ get: function get() {
                            return 'Container';
                        }
                    },
                    {
                        key: 'attributes',
                        get: function get() {
                            return {
                                class: 'container',
                                'data-container': ''
                            };
                        }
                    },
                    {
                        key: 'events',
                        get: function get() {
                            return {
                                'click': 'clicked',
                                'dblclick': 'dblClicked',
                                'touchend': 'dblTap',
                                'contextmenu': 'onContextMenu',
                                'mouseenter': 'mouseEnter',
                                'mouseleave': 'mouseLeave'
                            };
                        }
                    },
                    {
                        key: 'ended',
                        get: function get() {
                            return this.playback.ended;
                        }
                    },
                    {
                        key: 'buffering',
                        get: function get() {
                            return this.playback.buffering;
                        }
                    },
                    {
                        key: 'i18n',
                        get: function get() {
                            return this._i18n;
                        }
                    },
                    {
                        key: 'hasClosedCaptionsTracks',
                        get: function get() {
                            return this.playback.hasClosedCaptionsTracks;
                        }
                    },
                    {
                        key: 'closedCaptionsTracks',
                        get: function get() {
                            return this.playback.closedCaptionsTracks;
                        }
                    },
                    {
                        key: 'closedCaptionsTrackId',
                        get: function get() {
                            return this.playback.closedCaptionsTrackId;
                        },
                        set: function set(trackId) {
                            this.playback.closedCaptionsTrackId = trackId;
                        }
                    }
                ]);
                function Container(options, i18n, playerError) {
                    (0, _classCallCheck3.default)(this, Container);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _UIObject.call(this, options));
                    _this._i18n = i18n;
                    _this.currentTime = 0;
                    _this.volume = 100;
                    _this.playback = options.playback;
                    _this.playerError = playerError;
                    _this.settings = _clapprZepto2.default.extend({}, _this.playback.settings);
                    _this.isReady = false;
                    _this.mediaControlDisabled = false;
                    _this.plugins = [
                        _this.playback
                    ];
                    _this.dblTapHandler = new _utils.DoubleEventHandler(500);
                    _this.clickTimer = null;
                    _this.clickDelay = 200; // FIXME: could be a player option
                    _this.bindEvents();
                    return _this;
                }
                /**
   * binds playback events to the methods of the container.
   * it listens to playback's events and triggers them as container events.
   *
   * | Playback |
   * |----------|
   * | progress |
   * | timeupdate |
   * | ready |
   * | buffering |
   * | bufferfull |
   * | settingsupdate |
   * | loadedmetadata |
   * | highdefinitionupdate |
   * | bitrate |
   * | playbackstate |
   * | dvr |
   * | mediacontrol_disable |
   * | mediacontrol_enable |
   * | ended |
   * | play |
   * | pause |
   * | error |
   *
   * ps: the events usually translate from PLABACK_x to CONTAINER_x, you can check all the events at `Event` class.
   *
   * @method bindEvents
   */ Container.prototype.bindEvents = function bindEvents() {
                    this.listenTo(this.playback, _events2.default.PLAYBACK_PROGRESS, this.onProgress);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_TIMEUPDATE, this.timeUpdated);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_READY, this.ready);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_BUFFERING, this.onBuffering);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_BUFFERFULL, this.bufferfull);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_SETTINGSUPDATE, this.settingsUpdate);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_LOADEDMETADATA, this.loadedMetadata);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_HIGHDEFINITIONUPDATE, this.highDefinitionUpdate);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_BITRATE, this.updateBitrate);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_PLAYBACKSTATE, this.playbackStateChanged);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_DVR, this.playbackDvrStateChanged);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_MEDIACONTROL_DISABLE, this.disableMediaControl);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_MEDIACONTROL_ENABLE, this.enableMediaControl);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_SEEKED, this.onSeeked);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_ENDED, this.onEnded);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_PLAY, this.playing);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_PAUSE, this.paused);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_STOP, this.stopped);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_ERROR, this.error);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_SUBTITLE_AVAILABLE, this.subtitleAvailable);
                    this.listenTo(this.playback, _events2.default.PLAYBACK_SUBTITLE_CHANGED, this.subtitleChanged);
                };
                Container.prototype.subtitleAvailable = function subtitleAvailable() {
                    this.trigger(_events2.default.CONTAINER_SUBTITLE_AVAILABLE);
                };
                Container.prototype.subtitleChanged = function subtitleChanged(track) {
                    this.trigger(_events2.default.CONTAINER_SUBTITLE_CHANGED, track);
                };
                Container.prototype.playbackStateChanged = function playbackStateChanged(state) {
                    this.trigger(_events2.default.CONTAINER_PLAYBACKSTATE, state);
                };
                Container.prototype.playbackDvrStateChanged = function playbackDvrStateChanged(dvrInUse) {
                    this.settings = this.playback.settings;
                    this.dvrInUse = dvrInUse;
                    this.trigger(_events2.default.CONTAINER_PLAYBACKDVRSTATECHANGED, dvrInUse);
                };
                Container.prototype.updateBitrate = function updateBitrate(newBitrate) {
                    this.trigger(_events2.default.CONTAINER_BITRATE, newBitrate);
                };
                Container.prototype.statsReport = function statsReport(metrics) {
                    this.trigger(_events2.default.CONTAINER_STATS_REPORT, metrics);
                };
                Container.prototype.getPlaybackType = function getPlaybackType() {
                    return this.playback.getPlaybackType();
                };
                /**
   * returns `true` if DVR is enable otherwise `false`.
   * @method isDvrEnabled
   * @return {Boolean}
   */ Container.prototype.isDvrEnabled = function isDvrEnabled() {
                    return !!this.playback.dvrEnabled;
                };
                /**
   * returns `true` if DVR is in use otherwise `false`.
   * @method isDvrInUse
   * @return {Boolean}
   */ Container.prototype.isDvrInUse = function isDvrInUse() {
                    return !!this.dvrInUse;
                };
                /**
   * destroys the container
   * @method destroy
   */ Container.prototype.destroy = function destroy() {
                    this.trigger(_events2.default.CONTAINER_DESTROYED, this, this.name);
                    this.stopListening();
                    this.plugins.forEach(function(plugin) {
                        return plugin.destroy();
                    });
                    this.$el.remove();
                };
                Container.prototype.setStyle = function setStyle(style) {
                    this.$el.css(style);
                };
                Container.prototype.animate = function animate(style, duration) {
                    return this.$el.animate(style, duration).promise();
                };
                Container.prototype.ready = function ready() {
                    this.isReady = true;
                    this.trigger(_events2.default.CONTAINER_READY, this.name);
                };
                Container.prototype.isPlaying = function isPlaying() {
                    return this.playback.isPlaying();
                };
                Container.prototype.getStartTimeOffset = function getStartTimeOffset() {
                    return this.playback.getStartTimeOffset();
                };
                Container.prototype.getCurrentTime = function getCurrentTime() {
                    return this.currentTime;
                };
                Container.prototype.getDuration = function getDuration() {
                    return this.playback.getDuration();
                };
                Container.prototype.error = function error(_error) {
                    if (!this.isReady) this.ready();
                    this.trigger(_events2.default.CONTAINER_ERROR, _error, this.name);
                };
                Container.prototype.loadedMetadata = function loadedMetadata(metadata) {
                    this.trigger(_events2.default.CONTAINER_LOADEDMETADATA, metadata);
                };
                Container.prototype.timeUpdated = function timeUpdated(timeProgress) {
                    this.currentTime = timeProgress.current;
                    this.trigger(_events2.default.CONTAINER_TIMEUPDATE, timeProgress, this.name);
                };
                Container.prototype.onProgress = function onProgress() {
                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    this.trigger.apply(this, [
                        _events2.default.CONTAINER_PROGRESS
                    ].concat(args, [
                        this.name
                    ]));
                };
                Container.prototype.playing = function playing() {
                    this.trigger(_events2.default.CONTAINER_PLAY, this.name);
                };
                Container.prototype.paused = function paused() {
                    this.trigger(_events2.default.CONTAINER_PAUSE, this.name);
                };
                /**
   * plays the playback
   * @method play
   */ Container.prototype.play = function play() {
                    this.playback.play();
                };
                /**
   * stops the playback
   * @method stop
   */ Container.prototype.stop = function stop() {
                    this.playback.stop();
                    this.currentTime = 0;
                };
                /**
   * pauses the playback
   * @method pause
   */ Container.prototype.pause = function pause() {
                    this.playback.pause();
                };
                Container.prototype.onEnded = function onEnded() {
                    this.trigger(_events2.default.CONTAINER_ENDED, this, this.name);
                    this.currentTime = 0;
                };
                Container.prototype.stopped = function stopped() {
                    this.trigger(_events2.default.CONTAINER_STOP);
                };
                Container.prototype.clicked = function clicked() {
                    var _this2 = this;
                    if (!this.options.chromeless || this.options.allowUserInteraction) // The event is delayed because it can be canceled by a double-click event
                    // An example of use is to prevent playback from pausing when switching to full screen
                    this.clickTimer = setTimeout(function() {
                        _this2.clickTimer && _this2.trigger(_events2.default.CONTAINER_CLICK, _this2, _this2.name);
                    }, this.clickDelay);
                };
                Container.prototype.cancelClicked = function cancelClicked() {
                    clearTimeout(this.clickTimer);
                    this.clickTimer = null;
                };
                Container.prototype.dblClicked = function dblClicked() {
                    if (!this.options.chromeless || this.options.allowUserInteraction) {
                        this.cancelClicked();
                        this.trigger(_events2.default.CONTAINER_DBLCLICK, this, this.name);
                    }
                };
                Container.prototype.dblTap = function dblTap(evt) {
                    var _this3 = this;
                    if (!this.options.chromeless || this.options.allowUserInteraction) this.dblTapHandler.handle(evt, function() {
                        _this3.cancelClicked();
                        _this3.trigger(_events2.default.CONTAINER_DBLCLICK, _this3, _this3.name);
                    });
                };
                Container.prototype.onContextMenu = function onContextMenu(event) {
                    if (!this.options.chromeless || this.options.allowUserInteraction) this.trigger(_events2.default.CONTAINER_CONTEXTMENU, event, this.name);
                };
                Container.prototype.seek = function seek(time) {
                    this.trigger(_events2.default.CONTAINER_SEEK, time, this.name);
                    this.playback.seek(time);
                };
                Container.prototype.onSeeked = function onSeeked() {
                    this.trigger(_events2.default.CONTAINER_SEEKED, this.name);
                };
                Container.prototype.seekPercentage = function seekPercentage(percentage) {
                    var duration = this.getDuration();
                    if (percentage >= 0 && percentage <= 100) {
                        var time = duration * (percentage / 100);
                        this.seek(time);
                    }
                };
                Container.prototype.setVolume = function setVolume(value) {
                    this.volume = parseFloat(value);
                    this.trigger(_events2.default.CONTAINER_VOLUME, this.volume, this.name);
                    this.playback.volume(this.volume);
                };
                Container.prototype.fullscreen = function fullscreen() {
                    this.trigger(_events2.default.CONTAINER_FULLSCREEN, this.name);
                };
                Container.prototype.onBuffering = function onBuffering() {
                    this.trigger(_events2.default.CONTAINER_STATE_BUFFERING, this.name);
                };
                Container.prototype.bufferfull = function bufferfull() {
                    this.trigger(_events2.default.CONTAINER_STATE_BUFFERFULL, this.name);
                };
                /**
   * adds plugin to the container
   * @method addPlugin
   * @param {Object} plugin
   */ Container.prototype.addPlugin = function addPlugin(plugin) {
                    this.plugins.push(plugin);
                };
                /**
   * checks if a plugin, given its name, exist
   * @method hasPlugin
   * @param {String} name
   * @return {Boolean}
   */ Container.prototype.hasPlugin = function hasPlugin(name) {
                    return !!this.getPlugin(name);
                };
                /**
   * get the plugin given its name
   * @method getPlugin
   * @param {String} name
   */ Container.prototype.getPlugin = function getPlugin(name) {
                    return this.plugins.filter(function(plugin) {
                        return plugin.name === name;
                    })[0];
                };
                Container.prototype.mouseEnter = function mouseEnter() {
                    if (!this.options.chromeless || this.options.allowUserInteraction) this.trigger(_events2.default.CONTAINER_MOUSE_ENTER);
                };
                Container.prototype.mouseLeave = function mouseLeave() {
                    if (!this.options.chromeless || this.options.allowUserInteraction) this.trigger(_events2.default.CONTAINER_MOUSE_LEAVE);
                };
                Container.prototype.settingsUpdate = function settingsUpdate() {
                    this.settings = this.playback.settings;
                    this.trigger(_events2.default.CONTAINER_SETTINGSUPDATE);
                };
                Container.prototype.highDefinitionUpdate = function highDefinitionUpdate(isHD) {
                    this.trigger(_events2.default.CONTAINER_HIGHDEFINITIONUPDATE, isHD);
                };
                Container.prototype.isHighDefinitionInUse = function isHighDefinitionInUse() {
                    return this.playback.isHighDefinitionInUse();
                };
                Container.prototype.disableMediaControl = function disableMediaControl() {
                    if (!this.mediaControlDisabled) {
                        this.mediaControlDisabled = true;
                        this.trigger(_events2.default.CONTAINER_MEDIACONTROL_DISABLE);
                    }
                };
                Container.prototype.enableMediaControl = function enableMediaControl() {
                    if (this.mediaControlDisabled) {
                        this.mediaControlDisabled = false;
                        this.trigger(_events2.default.CONTAINER_MEDIACONTROL_ENABLE);
                    }
                };
                Container.prototype.updateStyle = function updateStyle() {
                    if (!this.options.chromeless || this.options.allowUserInteraction) this.$el.removeClass('chromeless');
                    else this.$el.addClass('chromeless');
                };
                /**
   * enables to configure the container after its creation
   * @method configure
   * @param {Object} options all the options to change in form of a javascript object
   */ Container.prototype.configure = function configure(options) {
                    this._options = _clapprZepto2.default.extend(this._options, options);
                    this.updateStyle();
                    this.playback.configure(this.options);
                    this.trigger(_events2.default.CONTAINER_OPTIONS_CHANGE);
                };
                Container.prototype.render = function render() {
                    this.$el.append(this.playback.render().el);
                    this.updateStyle();
                    return this;
                };
                return Container;
            }(_ui_object2.default);
            exports.default = Container;
            (0, _assign2.default)(Container.prototype, _error_mixin2.default);
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/container/index.js": /*!*******************************************!*\
  !*** ./src/components/container/index.js ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _container = __webpack_require__(/*! ./container */ "./src/components/container/container.js");
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _container2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/container/public/style.scss": /*!****************************************************!*\
  !*** ./src/components/container/public/style.scss ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./style.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/components/container/public/style.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/components/container_factory/container_factory.js": /*!***************************************************************!*\
  !*** ./src/components/container_factory/container_factory.js ***!
  \***************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ "./node_modules/babel-runtime/helpers/typeof.js");
            var _typeof3 = _interopRequireDefault(_typeof2);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _base_object = __webpack_require__(/*! ../../base/base_object */ "./src/base/base_object.js");
            var _base_object2 = _interopRequireDefault(_base_object);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _container = __webpack_require__(/*! ../../components/container */ "./src/components/container/index.js");
            var _container2 = _interopRequireDefault(_container);
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            /**
 * The ContainerFactory is responsible for manage playback bootstrap and create containers.
 */ var ContainerFactory = function(_BaseObject) {
                (0, _inherits3.default)(ContainerFactory, _BaseObject);
                (0, _createClass3.default)(ContainerFactory, [
                    {
                        key: 'options',
                        get: function get() {
                            return this._options;
                        },
                        set: function set(options) {
                            this._options = options;
                        }
                    }
                ]);
                function ContainerFactory(options, loader, i18n, playerError) {
                    (0, _classCallCheck3.default)(this, ContainerFactory);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _BaseObject.call(this, options));
                    _this._i18n = i18n;
                    _this.loader = loader;
                    _this.playerError = playerError;
                    return _this;
                }
                ContainerFactory.prototype.createContainers = function createContainers() {
                    var _this2 = this;
                    return _clapprZepto2.default.Deferred(function(promise) {
                        promise.resolve(_this2.options.sources.map(function(source) {
                            return _this2.createContainer(source);
                        }));
                    });
                };
                ContainerFactory.prototype.findPlaybackPlugin = function findPlaybackPlugin(source, mimeType) {
                    return this.loader.playbackPlugins.filter(function(p) {
                        return p.canPlay(source, mimeType);
                    })[0];
                };
                ContainerFactory.prototype.createContainer = function createContainer(source) {
                    var resolvedSource = null, mimeType = this.options.mimeType;
                    if ((typeof source === 'undefined' ? 'undefined' : (0, _typeof3.default)(source)) === 'object') {
                        resolvedSource = source.source.toString();
                        if (source.mimeType) mimeType = source.mimeType;
                    } else resolvedSource = source.toString();
                    if (resolvedSource.match(/^\/\//)) resolvedSource = window.location.protocol + resolvedSource;
                    var options = _clapprZepto2.default.extend({}, this.options, {
                        src: resolvedSource,
                        mimeType: mimeType
                    });
                    var playbackPlugin = this.findPlaybackPlugin(resolvedSource, mimeType);
                    var playback = new playbackPlugin(options, this._i18n, this.playerError);
                    options = _clapprZepto2.default.extend({}, options, {
                        playback: playback
                    });
                    var container = new _container2.default(options, this._i18n, this.playerError);
                    var defer = _clapprZepto2.default.Deferred();
                    defer.promise(container);
                    this.addContainerPlugins(container);
                    this.listenToOnce(container, _events2.default.CONTAINER_READY, function() {
                        return defer.resolve(container);
                    });
                    return container;
                };
                ContainerFactory.prototype.addContainerPlugins = function addContainerPlugins(container) {
                    this.loader.containerPlugins.forEach(function(Plugin) {
                        container.addPlugin(new Plugin(container));
                    });
                };
                return ContainerFactory;
            }(_base_object2.default);
            exports.default = ContainerFactory;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/container_factory/index.js": /*!***************************************************!*\
  !*** ./src/components/container_factory/index.js ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _container_factory = __webpack_require__(/*! ./container_factory */ "./src/components/container_factory/container_factory.js");
            var _container_factory2 = _interopRequireDefault(_container_factory);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _container_factory2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/core/core.js": /*!*************************************!*\
  !*** ./src/components/core/core.js ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
            var _assign2 = _interopRequireDefault(_assign);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _utils = __webpack_require__(/*! ../../base/utils */ "./src/base/utils.js");
            var _styler = __webpack_require__(/*! ../../base/styler */ "./src/base/styler.js");
            var _styler2 = _interopRequireDefault(_styler);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _ui_object = __webpack_require__(/*! ../../base/ui_object */ "./src/base/ui_object.js");
            var _ui_object2 = _interopRequireDefault(_ui_object);
            var _ui_core_plugin = __webpack_require__(/*! ../../base/ui_core_plugin */ "./src/base/ui_core_plugin.js");
            var _ui_core_plugin2 = _interopRequireDefault(_ui_core_plugin);
            var _browser = __webpack_require__(/*! ../../components/browser */ "./src/components/browser/index.js");
            var _browser2 = _interopRequireDefault(_browser);
            var _container_factory = __webpack_require__(/*! ../../components/container_factory */ "./src/components/container_factory/index.js");
            var _container_factory2 = _interopRequireDefault(_container_factory);
            var _mediator = __webpack_require__(/*! ../../components/mediator */ "./src/components/mediator.js");
            var _mediator2 = _interopRequireDefault(_mediator);
            var _player_info = __webpack_require__(/*! ../../components/player_info */ "./src/components/player_info.js");
            var _player_info2 = _interopRequireDefault(_player_info);
            var _error = __webpack_require__(/*! ../../components/error */ "./src/components/error/index.js");
            var _error2 = _interopRequireDefault(_error);
            var _error_mixin = __webpack_require__(/*! ../../base/error_mixin */ "./src/base/error_mixin.js");
            var _error_mixin2 = _interopRequireDefault(_error_mixin);
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            __webpack_require__(/*! ./public/style.scss */ "./src/components/core/public/style.scss");
            var _fonts = __webpack_require__(/*! ./public/fonts.css */ "./src/components/core/public/fonts.css");
            var _fonts2 = _interopRequireDefault(_fonts);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var style = void 0;
            /**
 * The Core is responsible to manage Containers, the mediator, MediaControl
 * and the player state.
 * @class Core
 * @constructor
 * @extends UIObject
 * @module components
 */ var Core = function(_UIObject) {
                (0, _inherits3.default)(Core, _UIObject);
                (0, _createClass3.default)(Core, [
                    {
                        key: 'events',
                        get: function get() {
                            return {
                                'webkitfullscreenchange': 'handleFullscreenChange',
                                'mousemove': 'onMouseMove',
                                'mouseleave': 'onMouseLeave'
                            };
                        }
                    },
                    {
                        key: 'attributes',
                        get: function get() {
                            return {
                                'data-player': '',
                                tabindex: 9999
                            };
                        }
                    },
                    {
                        key: 'isReady',
                        get: function get() {
                            return !!this.ready;
                        }
                    },
                    {
                        key: 'i18n',
                        get: function get() {
                            return this.getPlugin('strings') || {
                                t: function t(key) {
                                    return key;
                                }
                            };
                        }
                    },
                    {
                        key: 'mediaControl',
                        get: function get() {
                            return this.getPlugin('media_control') || this.dummyMediaControl;
                        }
                    },
                    {
                        key: 'dummyMediaControl',
                        get: function get() {
                            if (this._dummyMediaControl) return this._dummyMediaControl;
                            this._dummyMediaControl = new _ui_core_plugin2.default(this);
                            return this._dummyMediaControl;
                        }
                    },
                    {
                        key: 'activeContainer',
                        get: function get() {
                            return this._activeContainer;
                        },
                        set: function set(container) {
                            this._activeContainer = container;
                            this.trigger(_events2.default.CORE_ACTIVE_CONTAINER_CHANGED, this._activeContainer);
                        }
                    },
                    {
                        key: 'activePlayback',
                        get: function get() {
                            return this.activeContainer && this.activeContainer.playback;
                        }
                    }
                ]);
                function Core(options) {
                    (0, _classCallCheck3.default)(this, Core);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _UIObject.call(this, options));
                    _this.playerError = new _error2.default(options, _this);
                    _this.configureDomRecycler();
                    _this.playerInfo = _player_info2.default.getInstance(options.playerId);
                    _this.firstResize = true;
                    _this.plugins = [];
                    _this.containers = [];
                    //FIXME fullscreen api sucks
                    _this._boundFullscreenHandler = function() {
                        return _this.handleFullscreenChange();
                    };
                    (0, _clapprZepto2.default)(document).bind('fullscreenchange', _this._boundFullscreenHandler);
                    (0, _clapprZepto2.default)(document).bind('MSFullscreenChange', _this._boundFullscreenHandler);
                    (0, _clapprZepto2.default)(document).bind('mozfullscreenchange', _this._boundFullscreenHandler);
                    _browser2.default.isMobile && (0, _clapprZepto2.default)(window).bind('resize', function(o) {
                        _this.handleWindowResize(o);
                    });
                    return _this;
                }
                Core.prototype.configureDomRecycler = function configureDomRecycler() {
                    var recycleVideo = this.options && this.options.playback && this.options.playback.recycleVideo;
                    _utils.DomRecycler.configure({
                        recycleVideo: recycleVideo
                    });
                };
                Core.prototype.createContainers = function createContainers(options) {
                    this.defer = _clapprZepto2.default.Deferred();
                    this.defer.promise(this);
                    this.containerFactory = new _container_factory2.default(options, options.loader, this.i18n, this.playerError);
                    this.prepareContainers();
                };
                Core.prototype.prepareContainers = function prepareContainers() {
                    var _this2 = this;
                    this.containerFactory.createContainers().then(function(containers) {
                        return _this2.setupContainers(containers);
                    }).then(function(containers) {
                        return _this2.resolveOnContainersReady(containers);
                    });
                };
                Core.prototype.updateSize = function updateSize() {
                    this.isFullscreen() ? this.setFullscreen() : this.setPlayerSize();
                };
                Core.prototype.setFullscreen = function setFullscreen() {
                    if (!_browser2.default.isiOS) {
                        this.$el.addClass('fullscreen');
                        this.$el.removeAttr('style');
                        this.playerInfo.previousSize = {
                            width: this.options.width,
                            height: this.options.height
                        };
                        this.playerInfo.currentSize = {
                            width: (0, _clapprZepto2.default)(window).width(),
                            height: (0, _clapprZepto2.default)(window).height()
                        };
                    }
                };
                Core.prototype.setPlayerSize = function setPlayerSize() {
                    this.$el.removeClass('fullscreen');
                    this.playerInfo.currentSize = this.playerInfo.previousSize;
                    this.playerInfo.previousSize = {
                        width: (0, _clapprZepto2.default)(window).width(),
                        height: (0, _clapprZepto2.default)(window).height()
                    };
                    this.resize(this.playerInfo.currentSize);
                };
                Core.prototype.resize = function resize(options) {
                    if (!(0, _utils.isNumber)(options.height) && !(0, _utils.isNumber)(options.width)) {
                        this.el.style.height = '' + options.height;
                        this.el.style.width = '' + options.width;
                    } else {
                        this.el.style.height = options.height + 'px';
                        this.el.style.width = options.width + 'px';
                    }
                    this.playerInfo.previousSize = {
                        width: this.options.width,
                        height: this.options.height
                    };
                    this.options.width = options.width;
                    this.options.height = options.height;
                    this.playerInfo.currentSize = options;
                    this.triggerResize(this.playerInfo.currentSize);
                };
                Core.prototype.enableResizeObserver = function enableResizeObserver() {
                    var _this3 = this;
                    var checkSizeCallback = function checkSizeCallback() {
                        _this3.triggerResize({
                            width: _this3.el.clientWidth,
                            height: _this3.el.clientHeight
                        });
                    };
                    this.resizeObserverInterval = setInterval(checkSizeCallback, 500);
                };
                Core.prototype.triggerResize = function triggerResize(newSize) {
                    var thereWasChange = this.firstResize || this.oldHeight !== newSize.height || this.oldWidth !== newSize.width;
                    if (thereWasChange) {
                        this.oldHeight = newSize.height;
                        this.oldWidth = newSize.width;
                        this.playerInfo.computedSize = newSize;
                        this.firstResize = false;
                        _mediator2.default.trigger(this.options.playerId + ':' + _events2.default.PLAYER_RESIZE, newSize);
                        this.trigger(_events2.default.CORE_RESIZE, newSize);
                    }
                };
                Core.prototype.disableResizeObserver = function disableResizeObserver() {
                    this.resizeObserverInterval && clearInterval(this.resizeObserverInterval);
                };
                Core.prototype.resolveOnContainersReady = function resolveOnContainersReady(containers) {
                    var _this4 = this;
                    _clapprZepto2.default.when.apply(_clapprZepto2.default, containers).done(function() {
                        _this4.defer.resolve(_this4);
                        _this4.ready = true;
                        _this4.trigger(_events2.default.CORE_READY);
                    });
                };
                Core.prototype.addPlugin = function addPlugin(plugin) {
                    this.plugins.push(plugin);
                };
                Core.prototype.hasPlugin = function hasPlugin(name) {
                    return !!this.getPlugin(name);
                };
                Core.prototype.getPlugin = function getPlugin(name) {
                    return this.plugins.filter(function(plugin) {
                        return plugin.name === name;
                    })[0];
                };
                Core.prototype.load = function load(sources, mimeType) {
                    this.options.mimeType = mimeType;
                    sources = sources && sources.constructor === Array ? sources : [
                        sources
                    ];
                    this.options.sources = sources;
                    this.containers.forEach(function(container) {
                        return container.destroy();
                    });
                    this.containerFactory.options = _clapprZepto2.default.extend(this.options, {
                        sources: sources
                    });
                    this.prepareContainers();
                };
                Core.prototype.destroy = function destroy() {
                    this.disableResizeObserver();
                    this.containers.forEach(function(container) {
                        return container.destroy();
                    });
                    this.plugins.forEach(function(plugin) {
                        return plugin.destroy();
                    });
                    this.$el.remove();
                    (0, _clapprZepto2.default)(document).unbind('fullscreenchange', this._boundFullscreenHandler);
                    (0, _clapprZepto2.default)(document).unbind('MSFullscreenChange', this._boundFullscreenHandler);
                    (0, _clapprZepto2.default)(document).unbind('mozfullscreenchange', this._boundFullscreenHandler);
                    this.stopListening();
                };
                Core.prototype.handleFullscreenChange = function handleFullscreenChange() {
                    this.trigger(_events2.default.CORE_FULLSCREEN, this.isFullscreen());
                    this.updateSize();
                };
                Core.prototype.handleWindowResize = function handleWindowResize(event) {
                    var orientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
                    if (this._screenOrientation === orientation) return;
                    this._screenOrientation = orientation;
                    this.triggerResize({
                        width: this.el.clientWidth,
                        height: this.el.clientHeight
                    });
                    this.trigger(_events2.default.CORE_SCREEN_ORIENTATION_CHANGED, {
                        event: event,
                        orientation: this._screenOrientation
                    });
                };
                Core.prototype.removeContainer = function removeContainer(container) {
                    this.stopListening(container);
                    this.containers = this.containers.filter(function(c) {
                        return c !== container;
                    });
                };
                Core.prototype.setupContainer = function setupContainer(container) {
                    this.listenTo(container, _events2.default.CONTAINER_DESTROYED, this.removeContainer);
                    this.containers.push(container);
                };
                Core.prototype.setupContainers = function setupContainers(containers) {
                    containers.forEach(this.setupContainer.bind(this));
                    this.trigger(_events2.default.CORE_CONTAINERS_CREATED);
                    this.renderContainers();
                    this.activeContainer = containers[0];
                    this.render();
                    this.appendToParent();
                    return this.containers;
                };
                Core.prototype.renderContainers = function renderContainers() {
                    var _this5 = this;
                    this.containers.forEach(function(container) {
                        return _this5.el.appendChild(container.render().el);
                    });
                };
                Core.prototype.createContainer = function createContainer(source, options) {
                    var container = this.containerFactory.createContainer(source, options);
                    this.setupContainer(container);
                    this.el.appendChild(container.render().el);
                    return container;
                };
                /**
   * @deprecated
   * This method currently exists for retrocompatibility reasons.
   * If you want the current container reference, use the activeContainer getter.
   */ Core.prototype.getCurrentContainer = function getCurrentContainer() {
                    return this.activeContainer;
                };
                /**
   * @deprecated
   * This method currently exists for retrocompatibility reasons.
   * If you want the current playback reference, use the activePlayback getter.
   */ Core.prototype.getCurrentPlayback = function getCurrentPlayback() {
                    return this.activePlayback;
                };
                Core.prototype.getPlaybackType = function getPlaybackType() {
                    return this.activeContainer && this.activeContainer.getPlaybackType();
                };
                Core.prototype.isFullscreen = function isFullscreen() {
                    // Ensure current instance is in fullscreen mode by checking fullscreen element
                    var el = _browser2.default.isiOS ? this.activeContainer && this.activeContainer.el || this.el : this.el;
                    return _utils.Fullscreen.fullscreenElement() === el;
                };
                Core.prototype.toggleFullscreen = function toggleFullscreen() {
                    if (this.isFullscreen()) {
                        _utils.Fullscreen.cancelFullscreen();
                        !_browser2.default.isiOS && this.$el.removeClass('fullscreen nocursor');
                    } else {
                        _utils.Fullscreen.requestFullscreen(_browser2.default.isiOS ? this.activeContainer.el : this.el);
                        !_browser2.default.isiOS && this.$el.addClass('fullscreen');
                    }
                };
                Core.prototype.onMouseMove = function onMouseMove(event) {
                    this.trigger(_events2.default.CORE_MOUSE_MOVE, event);
                };
                Core.prototype.onMouseLeave = function onMouseLeave(event) {
                    this.trigger(_events2.default.CORE_MOUSE_LEAVE, event);
                };
                /**
   * enables to configure the container after its creation
   * @method configure
   * @param {Object} options all the options to change in form of a javascript object
   */ Core.prototype.configure = function configure(options) {
                    var _this6 = this;
                    this._options = _clapprZepto2.default.extend(this._options, options);
                    this.configureDomRecycler();
                    var sources = options.source || options.sources;
                    sources && this.load(sources, options.mimeType || this.options.mimeType);
                    this.trigger(_events2.default.CORE_OPTIONS_CHANGE, options); // Trigger with newly provided options
                    this.containers.forEach(function(container) {
                        return container.configure(_this6.options);
                    });
                };
                Core.prototype.appendToParent = function appendToParent() {
                    var hasCoreParent = this.$el.parent() && this.$el.parent().length;
                    !hasCoreParent && this.$el.appendTo(this.options.parentElement);
                };
                Core.prototype.render = function render() {
                    if (!style) style = _styler2.default.getStyleFor(_fonts2.default, {
                        baseUrl: this.options.baseUrl
                    });
                    (0, _clapprZepto2.default)('head').append(style);
                    this.options.width = this.options.width || this.$el.width();
                    this.options.height = this.options.height || this.$el.height();
                    var size = {
                        width: this.options.width,
                        height: this.options.height
                    };
                    this.playerInfo.previousSize = this.playerInfo.currentSize = this.playerInfo.computedSize = size;
                    this.updateSize();
                    this.previousSize = {
                        width: this.$el.width(),
                        height: this.$el.height()
                    };
                    this.enableResizeObserver();
                    return this;
                };
                return Core;
            }(_ui_object2.default);
            exports.default = Core;
            (0, _assign2.default)(Core.prototype, _error_mixin2.default);
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/core/index.js": /*!**************************************!*\
  !*** ./src/components/core/index.js ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _core = __webpack_require__(/*! ./core */ "./src/components/core/core.js");
            var _core2 = _interopRequireDefault(_core);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _core2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/core/public/Roboto.ttf": /*!***********************************************!*\
  !*** ./src/components/core/public/Roboto.ttf ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<%=baseUrl%>/38861cba61c66739c1452c3a71e39852.ttf";
        /***/ },
        /***/ "./src/components/core/public/fonts.css": /*!**********************************************!*\
  !*** ./src/components/core/public/fonts.css ***!
  \**********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var escape = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/url/escape.js */ "./node_modules/css-loader/lib/url/escape.js");
            exports = module1.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
            // imports
            // module
            exports.push([
                module1.i,
                "@font-face {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  src: local(\"Roboto\"), local(\"Roboto-Regular\"), url(" + escape(__webpack_require__(/*! ./Roboto.ttf */ "./src/components/core/public/Roboto.ttf")) + ") format(\"truetype\");\n}\n",
                ""
            ]);
        // exports
        /***/ },
        /***/ "./src/components/core/public/style.scss": /*!***********************************************!*\
  !*** ./src/components/core/public/style.scss ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./style.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/components/core/public/style.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/components/core_factory/core_factory.js": /*!*****************************************************!*\
  !*** ./src/components/core_factory/core_factory.js ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _base_object = __webpack_require__(/*! ../../base/base_object */ "./src/base/base_object.js");
            var _base_object2 = _interopRequireDefault(_base_object);
            var _core = __webpack_require__(/*! ../core */ "./src/components/core/index.js");
            var _core2 = _interopRequireDefault(_core);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
 * The Core Factory is responsible for instantiate the core and it's plugins.
 * @class CoreFactory
 * @constructor
 * @extends BaseObject
 * @module components
 */ // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var CoreFactory = function(_BaseObject) {
                (0, _inherits3.default)(CoreFactory, _BaseObject);
                (0, _createClass3.default)(CoreFactory, [
                    {
                        key: 'loader',
                        get: function get() {
                            return this.player.loader;
                        }
                    }
                ]);
                function CoreFactory(player) {
                    (0, _classCallCheck3.default)(this, CoreFactory);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _BaseObject.call(this));
                    _this.player = player;
                    _this._options = player.options;
                    return _this;
                }
                /**
   * creates a core and its plugins
   * @method create
   * @return {Core} created core
   */ CoreFactory.prototype.create = function create() {
                    this.options.loader = this.loader;
                    this.core = new _core2.default(this.options);
                    this.addCorePlugins();
                    this.core.createContainers(this.options);
                    return this.core;
                };
                /**
   * given the core plugins (`loader.corePlugins`) it builds each one
   * @method addCorePlugins
   * @return {Core} the core with all plugins
   */ CoreFactory.prototype.addCorePlugins = function addCorePlugins() {
                    var _this2 = this;
                    this.loader.corePlugins.forEach(function(Plugin) {
                        var plugin = new Plugin(_this2.core);
                        _this2.core.addPlugin(plugin);
                        _this2.setupExternalInterface(plugin);
                    });
                    return this.core;
                };
                CoreFactory.prototype.setupExternalInterface = function setupExternalInterface(plugin) {
                    var externalFunctions = plugin.getExternalInterface();
                    for(var key in externalFunctions){
                        this.player[key] = externalFunctions[key].bind(plugin);
                        this.core[key] = externalFunctions[key].bind(plugin);
                    }
                };
                return CoreFactory;
            }(_base_object2.default);
            exports.default = CoreFactory;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/core_factory/index.js": /*!**********************************************!*\
  !*** ./src/components/core_factory/index.js ***!
  \**********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _core_factory = __webpack_require__(/*! ./core_factory */ "./src/components/core_factory/core_factory.js");
            var _core_factory2 = _interopRequireDefault(_core_factory);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _core_factory2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/error/error.js": /*!***************************************!*\
  !*** ./src/components/error/error.js ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _base_object = __webpack_require__(/*! ../../base/base_object */ "./src/base/base_object.js");
            var _base_object2 = _interopRequireDefault(_base_object);
            var _log = __webpack_require__(/*! ../../plugins/log */ "./src/plugins/log/index.js");
            var _log2 = _interopRequireDefault(_log);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
 * The PlayerError is responsible to receive and propagate errors.
 * @class PlayerError
 * @constructor
 * @extends BaseObject
 * @module components
 */ var PlayerError = function(_BaseObject) {
                (0, _inherits3.default)(PlayerError, _BaseObject);
                (0, _createClass3.default)(PlayerError, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'error';
                        }
                    }
                ], [
                    {
                        key: 'Levels',
                        get: function get() {
                            return {
                                FATAL: 'FATAL',
                                WARN: 'WARN',
                                INFO: 'INFO'
                            };
                        }
                    }
                ]);
                function PlayerError() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var core = arguments[1];
                    (0, _classCallCheck3.default)(this, PlayerError);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _BaseObject.call(this, options));
                    _this.core = core;
                    return _this;
                }
                /**
   * creates and trigger an error.
   * @method createError
   * @param {Object} err should be an object with code, description, level, origin, scope and raw error.
   */ PlayerError.prototype.createError = function createError(err) {
                    if (!this.core) {
                        _log2.default.warn(this.name, 'Core is not set. Error: ', err);
                        return;
                    }
                    this.core.trigger(_events2.default.ERROR, err);
                };
                return PlayerError;
            }(_base_object2.default);
            exports.default = PlayerError;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/error/index.js": /*!***************************************!*\
  !*** ./src/components/error/index.js ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _error = __webpack_require__(/*! ./error */ "./src/components/error/error.js");
            var _error2 = _interopRequireDefault(_error);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _error2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/loader/index.js": /*!****************************************!*\
  !*** ./src/components/loader/index.js ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _loader = __webpack_require__(/*! ./loader */ "./src/components/loader/loader.js");
            var _loader2 = _interopRequireDefault(_loader);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _loader2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/loader/loader.js": /*!*****************************************!*\
  !*** ./src/components/loader/loader.js ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _create = __webpack_require__(/*! babel-runtime/core-js/object/create */ "./node_modules/babel-runtime/core-js/object/create.js");
            var _create2 = _interopRequireDefault(_create);
            var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ "./node_modules/babel-runtime/helpers/toConsumableArray.js");
            var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _base_object = __webpack_require__(/*! ../../base/base_object */ "./src/base/base_object.js");
            var _base_object2 = _interopRequireDefault(_base_object);
            var _player_info = __webpack_require__(/*! ../player_info */ "./src/components/player_info.js");
            var _player_info2 = _interopRequireDefault(_player_info);
            var _html5_video = __webpack_require__(/*! ../../playbacks/html5_video */ "./src/playbacks/html5_video/index.js");
            var _html5_video2 = _interopRequireDefault(_html5_video);
            var _flash = __webpack_require__(/*! ../../playbacks/flash */ "./src/playbacks/flash/index.js");
            var _flash2 = _interopRequireDefault(_flash);
            var _html5_audio = __webpack_require__(/*! ../../playbacks/html5_audio */ "./src/playbacks/html5_audio/index.js");
            var _html5_audio2 = _interopRequireDefault(_html5_audio);
            var _flashls = __webpack_require__(/*! ../../playbacks/flashls */ "./src/playbacks/flashls/index.js");
            var _flashls2 = _interopRequireDefault(_flashls);
            var _hls = __webpack_require__(/*! ../../playbacks/hls */ "./src/playbacks/hls/index.js");
            var _hls2 = _interopRequireDefault(_hls);
            var _html_img = __webpack_require__(/*! ../../playbacks/html_img */ "./src/playbacks/html_img/index.js");
            var _html_img2 = _interopRequireDefault(_html_img);
            var _no_op = __webpack_require__(/*! ../../playbacks/no_op */ "./src/playbacks/no_op/index.js");
            var _no_op2 = _interopRequireDefault(_no_op);
            var _spinner_three_bounce = __webpack_require__(/*! ../../plugins/spinner_three_bounce */ "./src/plugins/spinner_three_bounce/index.js");
            var _spinner_three_bounce2 = _interopRequireDefault(_spinner_three_bounce);
            var _stats = __webpack_require__(/*! ../../plugins/stats */ "./src/plugins/stats/index.js");
            var _stats2 = _interopRequireDefault(_stats);
            var _watermark = __webpack_require__(/*! ../../plugins/watermark */ "./src/plugins/watermark/index.js");
            var _watermark2 = _interopRequireDefault(_watermark);
            var _poster = __webpack_require__(/*! ../../plugins/poster */ "./src/plugins/poster/index.js");
            var _poster2 = _interopRequireDefault(_poster);
            var _google_analytics = __webpack_require__(/*! ../../plugins/google_analytics */ "./src/plugins/google_analytics/index.js");
            var _google_analytics2 = _interopRequireDefault(_google_analytics);
            var _click_to_pause = __webpack_require__(/*! ../../plugins/click_to_pause */ "./src/plugins/click_to_pause/index.js");
            var _click_to_pause2 = _interopRequireDefault(_click_to_pause);
            var _media_control = __webpack_require__(/*! ../../plugins/media_control */ "./src/plugins/media_control/index.js");
            var _media_control2 = _interopRequireDefault(_media_control);
            var _dvr_controls = __webpack_require__(/*! ../../plugins/dvr_controls */ "./src/plugins/dvr_controls/index.js");
            var _dvr_controls2 = _interopRequireDefault(_dvr_controls);
            var _closed_captions = __webpack_require__(/*! ../../plugins/closed_captions */ "./src/plugins/closed_captions/index.js");
            var _closed_captions2 = _interopRequireDefault(_closed_captions);
            var _favicon = __webpack_require__(/*! ../../plugins/favicon */ "./src/plugins/favicon/index.js");
            var _favicon2 = _interopRequireDefault(_favicon);
            var _seek_time = __webpack_require__(/*! ../../plugins/seek_time */ "./src/plugins/seek_time/index.js");
            var _seek_time2 = _interopRequireDefault(_seek_time);
            var _sources = __webpack_require__(/*! ../../plugins/sources */ "./src/plugins/sources.js");
            var _sources2 = _interopRequireDefault(_sources);
            var _end_video = __webpack_require__(/*! ../../plugins/end_video */ "./src/plugins/end_video.js");
            var _end_video2 = _interopRequireDefault(_end_video);
            var _strings = __webpack_require__(/*! ../../plugins/strings */ "./src/plugins/strings.js");
            var _strings2 = _interopRequireDefault(_strings);
            var _error_screen = __webpack_require__(/*! ../../plugins/error_screen */ "./src/plugins/error_screen/index.js");
            var _error_screen2 = _interopRequireDefault(_error_screen);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
 * It keeps a list of the default plugins (playback, container, core) and it merges external plugins with its internals.
 * @class Loader
 * @constructor
 * @extends BaseObject
 * @module components
 */ /* Playback Plugins */ // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var Loader = function(_BaseObject) {
                (0, _inherits3.default)(Loader, _BaseObject);
                /**
   * builds the loader
   * @method constructor
   * @param {Object} externalPlugins the external plugins
   * @param {Number} playerId you can embed multiple instances of clappr, therefore this is the unique id of each one.
   */ function Loader() {
                    var externalPlugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                    var playerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                    var useOnlyPlainHtml5Plugins = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                    (0, _classCallCheck3.default)(this, Loader);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _BaseObject.call(this));
                    _this.playerId = playerId;
                    _this.playbackPlugins = [];
                    if (!useOnlyPlainHtml5Plugins) _this.playbackPlugins = [].concat((0, _toConsumableArray3.default)(_this.playbackPlugins), [
                        _hls2.default
                    ]);
                    _this.playbackPlugins = [].concat((0, _toConsumableArray3.default)(_this.playbackPlugins), [
                        _html5_video2.default,
                        _html5_audio2.default
                    ]);
                    if (!useOnlyPlainHtml5Plugins) _this.playbackPlugins = [].concat((0, _toConsumableArray3.default)(_this.playbackPlugins), [
                        _flash2.default,
                        _flashls2.default
                    ]);
                    _this.playbackPlugins = [].concat((0, _toConsumableArray3.default)(_this.playbackPlugins), [
                        _html_img2.default,
                        _no_op2.default
                    ]);
                    _this.containerPlugins = [
                        _spinner_three_bounce2.default,
                        _watermark2.default,
                        _poster2.default,
                        _stats2.default,
                        _google_analytics2.default,
                        _click_to_pause2.default
                    ];
                    _this.corePlugins = [
                        _media_control2.default,
                        _dvr_controls2.default,
                        _closed_captions2.default,
                        _favicon2.default,
                        _seek_time2.default,
                        _sources2.default,
                        _end_video2.default,
                        _error_screen2.default,
                        _strings2.default
                    ];
                    if (!Array.isArray(externalPlugins)) _this.validateExternalPluginsType(externalPlugins);
                    _this.addExternalPlugins(externalPlugins);
                    return _this;
                }
                /**
   * groups by type the external plugins that were passed through `options.plugins` it they're on a flat array
   * @method addExternalPlugins
   * @private
   * @param {Object} an config object or an array of plugins
   * @return {Object} plugins the config object with the plugins separated by type
   */ Loader.prototype.groupPluginsByType = function groupPluginsByType(plugins) {
                    if (Array.isArray(plugins)) plugins = plugins.reduce(function(memo, plugin) {
                        memo[plugin.type] || (memo[plugin.type] = []);
                        memo[plugin.type].push(plugin);
                        return memo;
                    }, {});
                    return plugins;
                };
                Loader.prototype.removeDups = function removeDups(list) {
                    var groupUp = function groupUp(plugins, plugin) {
                        plugins[plugin.prototype.name] && delete plugins[plugin.prototype.name];
                        plugins[plugin.prototype.name] = plugin;
                        return plugins;
                    };
                    var pluginsMap = list.reduceRight(groupUp, (0, _create2.default)(null));
                    var plugins = [];
                    for(var key in pluginsMap)plugins.unshift(pluginsMap[key]);
                    return plugins;
                };
                /**
   * adds all the external plugins that were passed through `options.plugins`
   * @method addExternalPlugins
   * @private
   * @param {Object} plugins the config object with all plugins
   */ Loader.prototype.addExternalPlugins = function addExternalPlugins(plugins) {
                    plugins = this.groupPluginsByType(plugins);
                    if (plugins.playback) this.playbackPlugins = this.removeDups(plugins.playback.concat(this.playbackPlugins));
                    if (plugins.container) this.containerPlugins = this.removeDups(plugins.container.concat(this.containerPlugins));
                    if (plugins.core) this.corePlugins = this.removeDups(plugins.core.concat(this.corePlugins));
                    _player_info2.default.getInstance(this.playerId).playbackPlugins = this.playbackPlugins;
                };
                /**
   * validate if the external plugins that were passed through `options.plugins` are associated to the correct type
   * @method validateExternalPluginsType
   * @private
   * @param {Object} plugins the config object with all plugins
   */ Loader.prototype.validateExternalPluginsType = function validateExternalPluginsType(plugins) {
                    var plugintypes = [
                        'playback',
                        'container',
                        'core'
                    ];
                    plugintypes.forEach(function(type) {
                        (plugins[type] || []).forEach(function(el) {
                            var errorMessage = 'external ' + el.type + ' plugin on ' + type + ' array';
                            if (el.type !== type) throw new ReferenceError(errorMessage);
                        });
                    });
                };
                return Loader;
            }(_base_object2.default);
            /* Core Plugins */ /* Container Plugins */ exports.default = Loader;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/mediator.js": /*!************************************!*\
  !*** ./src/components/mediator.js ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _events = __webpack_require__(/*! ../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var events = new _events2.default(); // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            /**
 * The mediator is a singleton for handling global events.
 */ var Mediator = function Mediator() {
                (0, _classCallCheck3.default)(this, Mediator);
            };
            exports.default = Mediator;
            Mediator.on = function(name, callback, context) {
                events.on(name, callback, context);
                return;
            };
            Mediator.once = function(name, callback, context) {
                events.once(name, callback, context);
                return;
            };
            Mediator.off = function(name, callback, context) {
                events.off(name, callback, context);
                return;
            };
            Mediator.trigger = function(name) {
                for(var _len = arguments.length, opts = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)opts[_key - 1] = arguments[_key];
                events.trigger.apply(events, [
                    name
                ].concat(opts));
                return;
            };
            Mediator.stopListening = function(obj, name, callback) {
                events.stopListening(obj, name, callback);
                return;
            };
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/player.js": /*!**********************************!*\
  !*** ./src/components/player.js ***!
  \**********************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
            var _assign2 = _interopRequireDefault(_assign);
            var _keys = __webpack_require__(/*! babel-runtime/core-js/object/keys */ "./node_modules/babel-runtime/core-js/object/keys.js");
            var _keys2 = _interopRequireDefault(_keys);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _utils = __webpack_require__(/*! ../base/utils */ "./src/base/utils.js");
            var _base_object = __webpack_require__(/*! ../base/base_object */ "./src/base/base_object.js");
            var _base_object2 = _interopRequireDefault(_base_object);
            var _events = __webpack_require__(/*! ../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _browser = __webpack_require__(/*! ./browser */ "./src/components/browser/index.js");
            var _browser2 = _interopRequireDefault(_browser);
            var _core_factory = __webpack_require__(/*! ./core_factory */ "./src/components/core_factory/index.js");
            var _core_factory2 = _interopRequireDefault(_core_factory);
            var _loader = __webpack_require__(/*! ./loader */ "./src/components/loader/index.js");
            var _loader2 = _interopRequireDefault(_loader);
            var _player_info = __webpack_require__(/*! ./player_info */ "./src/components/player_info.js");
            var _player_info2 = _interopRequireDefault(_player_info);
            var _error_mixin = __webpack_require__(/*! ../base/error_mixin */ "./src/base/error_mixin.js");
            var _error_mixin2 = _interopRequireDefault(_error_mixin);
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var baseUrl = (0, _utils.currentScriptUrl)().replace(/\/[^/]+$/, '');
            /**
 * @class Player
 * @constructor
 * @extends BaseObject
 * @module components
 * @example
 * ### Using the Player
 *
 * Add the following script on your HTML:
 * ```html
 * <head>
 *   <script type="text/javascript" src="http://cdn.clappr.io/latest/clappr.min.js"></script>
 * </head>
 * ```
 * Now, create the player:
 * ```html
 * <body>
 *   <div id="player"></div>
 *   <script>
 *     var player = new Clappr.Player({source: "http://your.video/here.mp4", parentId: "#player"});
 *   </script>
 * </body>
 * ```
 */ // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var Player = function(_BaseObject) {
                (0, _inherits3.default)(Player, _BaseObject);
                (0, _createClass3.default)(Player, [
                    {
                        key: 'loader',
                        set: function set(loader) {
                            this._loader = loader;
                        },
                        get: function get() {
                            if (!this._loader) this._loader = new _loader2.default(this.options.plugins || {}, this.options.playerId);
                            return this._loader;
                        }
                    },
                    {
                        key: 'ended',
                        get: function get() {
                            return this.core.activeContainer.ended;
                        }
                    },
                    {
                        key: 'buffering',
                        get: function get() {
                            return this.core.activeContainer.buffering;
                        }
                    },
                    {
                        key: 'isReady',
                        get: function get() {
                            return !!this._ready;
                        }
                    },
                    {
                        key: 'eventsMapping',
                        get: function get() {
                            return {
                                onReady: _events2.default.PLAYER_READY,
                                onResize: _events2.default.PLAYER_RESIZE,
                                onPlay: _events2.default.PLAYER_PLAY,
                                onPause: _events2.default.PLAYER_PAUSE,
                                onStop: _events2.default.PLAYER_STOP,
                                onEnded: _events2.default.PLAYER_ENDED,
                                onSeek: _events2.default.PLAYER_SEEK,
                                onError: _events2.default.PLAYER_ERROR,
                                onTimeUpdate: _events2.default.PLAYER_TIMEUPDATE,
                                onVolumeUpdate: _events2.default.PLAYER_VOLUMEUPDATE,
                                onSubtitleAvailable: _events2.default.PLAYER_SUBTITLE_AVAILABLE
                            };
                        }
                    }
                ]);
                function Player(options) {
                    (0, _classCallCheck3.default)(this, Player);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _BaseObject.call(this, options));
                    var playbackDefaultOptions = {
                        recycleVideo: true
                    };
                    var defaultOptions = {
                        playerId: (0, _utils.uniqueId)(''),
                        persistConfig: true,
                        width: 640,
                        height: 360,
                        baseUrl: baseUrl,
                        allowUserInteraction: _browser2.default.isMobile,
                        playback: playbackDefaultOptions
                    };
                    _this._options = _clapprZepto2.default.extend(defaultOptions, options);
                    _this.options.sources = _this._normalizeSources(options);
                    if (!_this.options.chromeless) // "allowUserInteraction" cannot be false if not in chromeless mode.
                    _this.options.allowUserInteraction = true;
                    if (!_this.options.allowUserInteraction) // if user iteraction is not allowed ensure keyboard shortcuts are disabled
                    _this.options.disableKeyboardShortcuts = true;
                    _this._registerOptionEventListeners(_this.options.events);
                    _this._coreFactory = new _core_factory2.default(_this);
                    _this.playerInfo = _player_info2.default.getInstance(_this.options.playerId);
                    _this.playerInfo.currentSize = {
                        width: options.width,
                        height: options.height
                    };
                    _this.playerInfo.options = _this.options;
                    if (_this.options.parentId) _this.setParentId(_this.options.parentId);
                    else if (_this.options.parent) _this.attachTo(_this.options.parent);
                    return _this;
                }
                /**
   * Specify a `parentId` to the player.
   * @method setParentId
   * @param {String} parentId the element parent id.
   * @return {Player} itself
   */ Player.prototype.setParentId = function setParentId(parentId) {
                    var el = document.querySelector(parentId);
                    if (el) this.attachTo(el);
                    return this;
                };
                /**
   * You can use this method to attach the player to a given element. You don't need to do this when you specify it during the player instantiation passing the `parentId` param.
   * @method attachTo
   * @param {Object} element a given element.
   * @return {Player} itself
   */ Player.prototype.attachTo = function attachTo(element) {
                    this.options.parentElement = element;
                    this.core = this._coreFactory.create();
                    this._addEventListeners();
                    return this;
                };
                Player.prototype._addEventListeners = function _addEventListeners() {
                    if (!this.core.isReady) this.listenToOnce(this.core, _events2.default.CORE_READY, this._onReady);
                    else this._onReady();
                    this.listenTo(this.core, _events2.default.CORE_ACTIVE_CONTAINER_CHANGED, this._containerChanged);
                    this.listenTo(this.core, _events2.default.CORE_FULLSCREEN, this._onFullscreenChange);
                    this.listenTo(this.core, _events2.default.CORE_RESIZE, this._onResize);
                    return this;
                };
                Player.prototype._addContainerEventListeners = function _addContainerEventListeners() {
                    var container = this.core.activeContainer;
                    if (container) {
                        this.listenTo(container, _events2.default.CONTAINER_PLAY, this._onPlay);
                        this.listenTo(container, _events2.default.CONTAINER_PAUSE, this._onPause);
                        this.listenTo(container, _events2.default.CONTAINER_STOP, this._onStop);
                        this.listenTo(container, _events2.default.CONTAINER_ENDED, this._onEnded);
                        this.listenTo(container, _events2.default.CONTAINER_SEEK, this._onSeek);
                        this.listenTo(container, _events2.default.CONTAINER_ERROR, this._onError);
                        this.listenTo(container, _events2.default.CONTAINER_TIMEUPDATE, this._onTimeUpdate);
                        this.listenTo(container, _events2.default.CONTAINER_VOLUME, this._onVolumeUpdate);
                        this.listenTo(container, _events2.default.CONTAINER_SUBTITLE_AVAILABLE, this._onSubtitleAvailable);
                    }
                    return this;
                };
                Player.prototype._registerOptionEventListeners = function _registerOptionEventListeners() {
                    var _this2 = this;
                    var newEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var hasNewEvents = (0, _keys2.default)(newEvents).length > 0;
                    hasNewEvents && (0, _keys2.default)(events).forEach(function(userEvent) {
                        var eventType = _this2.eventsMapping[userEvent];
                        eventType && _this2.off(eventType, events[userEvent]);
                    });
                    (0, _keys2.default)(newEvents).forEach(function(userEvent) {
                        var eventType = _this2.eventsMapping[userEvent];
                        if (eventType) {
                            var eventFunction = newEvents[userEvent];
                            eventFunction = typeof eventFunction === 'function' && eventFunction;
                            eventFunction && _this2.on(eventType, eventFunction);
                        }
                    });
                    return this;
                };
                Player.prototype._containerChanged = function _containerChanged() {
                    this.stopListening();
                    this._addEventListeners();
                };
                Player.prototype._onReady = function _onReady() {
                    this._ready = true;
                    this._addContainerEventListeners();
                    this.trigger(_events2.default.PLAYER_READY);
                };
                Player.prototype._onFullscreenChange = function _onFullscreenChange(fullscreen) {
                    this.trigger(_events2.default.PLAYER_FULLSCREEN, fullscreen);
                };
                Player.prototype._onVolumeUpdate = function _onVolumeUpdate(volume) {
                    this.trigger(_events2.default.PLAYER_VOLUMEUPDATE, volume);
                };
                Player.prototype._onSubtitleAvailable = function _onSubtitleAvailable() {
                    this.trigger(_events2.default.PLAYER_SUBTITLE_AVAILABLE);
                };
                Player.prototype._onResize = function _onResize(size) {
                    this.trigger(_events2.default.PLAYER_RESIZE, size);
                };
                Player.prototype._onPlay = function _onPlay() {
                    this.trigger(_events2.default.PLAYER_PLAY);
                };
                Player.prototype._onPause = function _onPause() {
                    this.trigger(_events2.default.PLAYER_PAUSE);
                };
                Player.prototype._onStop = function _onStop() {
                    this.trigger(_events2.default.PLAYER_STOP, this.getCurrentTime());
                };
                Player.prototype._onEnded = function _onEnded() {
                    this.trigger(_events2.default.PLAYER_ENDED);
                };
                Player.prototype._onSeek = function _onSeek(time) {
                    this.trigger(_events2.default.PLAYER_SEEK, time);
                };
                Player.prototype._onTimeUpdate = function _onTimeUpdate(timeProgress) {
                    this.trigger(_events2.default.PLAYER_TIMEUPDATE, timeProgress);
                };
                Player.prototype._onError = function _onError(error) {
                    this.trigger(_events2.default.PLAYER_ERROR, error);
                };
                Player.prototype._normalizeSources = function _normalizeSources(options) {
                    var sources = options.sources || (options.source !== undefined ? [
                        options.source
                    ] : []);
                    return sources.length === 0 ? [
                        {
                            source: '',
                            mimeType: ''
                        }
                    ] : sources;
                };
                /**
   * resizes the current player canvas.
   * @method resize
   * @param {Object} size should be a literal object with `height` and `width`.
   * @return {Player} itself
   * @example
   * ```javascript
   * player.resize({height: 360, width: 640})
   * ```
   */ Player.prototype.resize = function resize(size) {
                    this.core.resize(size);
                    return this;
                };
                /**
   * loads a new source.
   * @method load
   * @param {Array|String} sources source or sources of video.
   * An array item can be a string or {source: <<source URL>>, mimeType: <<source mime type>>}
   * @param {String} mimeType a mime type, example: `'application/vnd.apple.mpegurl'`
   * @param {Boolean} [autoPlay=false] whether playing should be started immediately
   * @return {Player} itself
   */ Player.prototype.load = function load(sources, mimeType, autoPlay) {
                    if (autoPlay !== undefined) this.configure({
                        autoPlay: !!autoPlay
                    });
                    this.core.load(sources, mimeType);
                    return this;
                };
                /**
   * destroys the current player and removes it from the DOM.
   * @method destroy
   * @return {Player} itself
   */ Player.prototype.destroy = function destroy() {
                    this.stopListening();
                    this.core.destroy();
                    return this;
                };
                /**
   * Gives user consent to playback. Required by mobile device after a click event before Player.load().
   * @method consent
   * @return {Player} itself
   */ Player.prototype.consent = function consent() {
                    this.core.getCurrentPlayback().consent();
                    return this;
                };
                /**
   * plays the current video (`source`).
   * @method play
   * @return {Player} itself
   */ Player.prototype.play = function play() {
                    this.core.activeContainer.play();
                    return this;
                };
                /**
   * pauses the current video (`source`).
   * @method pause
   * @return {Player} itself
   */ Player.prototype.pause = function pause() {
                    this.core.activeContainer.pause();
                    return this;
                };
                /**
   * stops the current video (`source`).
   * @method stop
   * @return {Player} itself
   */ Player.prototype.stop = function stop() {
                    this.core.activeContainer.stop();
                    return this;
                };
                /**
   * seeks the current video (`source`). For example, `player.seek(120)` will seek to second 120 (2minutes) of the current video.
   * @method seek
   * @param {Number} time should be a number between 0 and the video duration.
   * @return {Player} itself
   */ Player.prototype.seek = function seek(time) {
                    this.core.activeContainer.seek(time);
                    return this;
                };
                /**
   * seeks the current video (`source`). For example, `player.seek(50)` will seek to the middle of the current video.
   * @method seekPercentage
   * @param {Number} time should be a number between 0 and 100.
   * @return {Player} itself
   */ Player.prototype.seekPercentage = function seekPercentage(percentage) {
                    this.core.activeContainer.seekPercentage(percentage);
                    return this;
                };
                /**
   * mutes the current video (`source`).
   * @method mute
   * @return {Player} itself
   */ Player.prototype.mute = function mute() {
                    this._mutedVolume = this.getVolume();
                    this.setVolume(0);
                    return this;
                };
                /**
   * unmutes the current video (`source`).
   * @method unmute
   * @return {Player} itself
   */ Player.prototype.unmute = function unmute() {
                    this.setVolume(typeof this._mutedVolume === 'number' ? this._mutedVolume : 100);
                    this._mutedVolume = null;
                    return this;
                };
                /**
   * checks if the player is playing.
   * @method isPlaying
   * @return {Boolean} `true` if the current source is playing, otherwise `false`
   */ Player.prototype.isPlaying = function isPlaying() {
                    return this.core.activeContainer.isPlaying();
                };
                /**
   * returns `true` if DVR is enable otherwise `false`.
   * @method isDvrEnabled
   * @return {Boolean}
   */ Player.prototype.isDvrEnabled = function isDvrEnabled() {
                    return this.core.activeContainer.isDvrEnabled();
                };
                /**
   * returns `true` if DVR is in use otherwise `false`.
   * @method isDvrInUse
   * @return {Boolean}
   */ Player.prototype.isDvrInUse = function isDvrInUse() {
                    return this.core.activeContainer.isDvrInUse();
                };
                /**
   * enables to configure a player after its creation
   * @method configure
   * @param {Object} options all the options to change in form of a javascript object
   * @return {Player} itself
   */ Player.prototype.configure = function configure() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    this._registerOptionEventListeners(options.events, this.options.events);
                    this.core.configure(options);
                    return this;
                };
                /**
   * get a plugin by its name.
   * @method getPlugin
   * @param {String} name of the plugin.
   * @return {Object} the plugin instance
   * @example
   * ```javascript
   * var poster = player.getPlugin('poster');
   * poster.hidePlayButton();
   * ```
   */ Player.prototype.getPlugin = function getPlugin(name) {
                    var plugins = this.core.plugins.concat(this.core.activeContainer.plugins);
                    return plugins.filter(function(plugin) {
                        return plugin.name === name;
                    })[0];
                };
                /**
   * the current time in seconds.
   * @method getCurrentTime
   * @return {Number} current time (in seconds) of the current source
   */ Player.prototype.getCurrentTime = function getCurrentTime() {
                    return this.core.activeContainer.getCurrentTime();
                };
                /**
   * The time that "0" now represents relative to when playback started.
   * For a stream with a sliding window this will increase as content is
   * removed from the beginning.
   * @method getStartTimeOffset
   * @return {Number} time (in seconds) that time "0" represents.
   */ Player.prototype.getStartTimeOffset = function getStartTimeOffset() {
                    return this.core.activeContainer.getStartTimeOffset();
                };
                /**
   * the duration time in seconds.
   * @method getDuration
   * @return {Number} duration time (in seconds) of the current source
   */ Player.prototype.getDuration = function getDuration() {
                    return this.core.activeContainer.getDuration();
                };
                return Player;
            }(_base_object2.default);
            exports.default = Player;
            (0, _assign2.default)(Player.prototype, _error_mixin2.default);
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/components/player_info.js": /*!***************************************!*\
  !*** ./src/components/player_info.js ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var PlayerInfo = function PlayerInfo() {
                (0, _classCallCheck3.default)(this, PlayerInfo);
                this.options = {};
                this.playbackPlugins = [];
                this.currentSize = {
                    width: 0,
                    height: 0
                };
            };
            PlayerInfo._players = {};
            PlayerInfo.getInstance = function(playerId) {
                return PlayerInfo._players[playerId] || (PlayerInfo._players[playerId] = new PlayerInfo());
            };
            exports.default = PlayerInfo;
            module1.exports = exports["default"];
        /***/ },
        /***/ "./src/icons/01-play.svg": /*!*******************************!*\
  !*** ./src/icons/01-play.svg ***!
  \*******************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill=\"#010101\" d=\"M1.425.35L14.575 8l-13.15 7.65V.35z\"></path></svg>";
        /***/ },
        /***/ "./src/icons/02-pause.svg": /*!********************************!*\
  !*** ./src/icons/02-pause.svg ***!
  \********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M1.712 14.76H6.43V1.24H1.71v13.52zm7.86-13.52v13.52h4.716V1.24H9.573z\"></path></svg>";
        /***/ },
        /***/ "./src/icons/03-stop.svg": /*!*******************************!*\
  !*** ./src/icons/03-stop.svg ***!
  \*******************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M1.712 1.24h12.6v13.52h-12.6z\"></path></svg>";
        /***/ },
        /***/ "./src/icons/04-volume.svg": /*!*********************************!*\
  !*** ./src/icons/04-volume.svg ***!
  \*********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M11.5 11h-.002v1.502L7.798 10H4.5V6h3.297l3.7-2.502V4.5h.003V11zM11 4.49L7.953 6.5H5v3h2.953L11 11.51V4.49z\"></path></svg>";
        /***/ },
        /***/ "./src/icons/05-mute.svg": /*!*******************************!*\
  !*** ./src/icons/05-mute.svg ***!
  \*******************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M9.75 11.51L6.7 9.5H3.75v-3H6.7L9.75 4.49v.664l.497.498V3.498L6.547 6H3.248v4h3.296l3.7 2.502v-2.154l-.497.5v.662zm3-5.165L12.404 6l-1.655 1.653L9.093 6l-.346.345L10.402 8 8.747 9.654l.346.347 1.655-1.653L12.403 10l.348-.346L11.097 8l1.655-1.655z\"></path></svg>";
        /***/ },
        /***/ "./src/icons/06-expand.svg": /*!*********************************!*\
  !*** ./src/icons/06-expand.svg ***!
  \*********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill=\"#010101\" d=\"M7.156 8L4 11.156V8.5H3V13h4.5v-1H4.844L8 8.844 7.156 8zM8.5 3v1h2.657L8 7.157 8.846 8 12 4.844V7.5h1V3H8.5z\"></path></svg>";
        /***/ },
        /***/ "./src/icons/07-shrink.svg": /*!*********************************!*\
  !*** ./src/icons/07-shrink.svg ***!
  \*********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill=\"#010101\" d=\"M13.5 3.344l-.844-.844L9.5 5.656V3h-1v4.5H13v-1h-2.656L13.5 3.344zM3 9.5h2.656L2.5 12.656l.844.844L6.5 10.344V13h1V8.5H3v1z\"></path></svg>";
        /***/ },
        /***/ "./src/icons/08-hd.svg": /*!*****************************!*\
  !*** ./src/icons/08-hd.svg ***!
  \*****************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill=\"#010101\" d=\"M5.375 7.062H2.637V4.26H.502v7.488h2.135V8.9h2.738v2.848h2.133V4.26H5.375v2.802zm5.97-2.81h-2.84v7.496h2.798c2.65 0 4.195-1.607 4.195-3.77v-.022c0-2.162-1.523-3.704-4.154-3.704zm2.06 3.758c0 1.21-.81 1.896-2.03 1.896h-.83V6.093h.83c1.22 0 2.03.696 2.03 1.896v.02z\"></path></svg>";
        /***/ },
        /***/ "./src/icons/09-cc.svg": /*!*****************************!*\
  !*** ./src/icons/09-cc.svg ***!
  \*****************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 49 41.8\" style=\"enable-background:new 0 0 49 41.8;\" xml:space=\"preserve\"><path d=\"M47.1,0H3.2C1.6,0,0,1.2,0,2.8v31.5C0,35.9,1.6,37,3.2,37h11.9l3.2,1.9l4.7,2.7c0.9,0.5,2-0.1,2-1.1V37h22.1 c1.6,0,1.9-1.1,1.9-2.7V2.8C49,1.2,48.7,0,47.1,0z M7.2,18.6c0-4.8,3.5-9.3,9.9-9.3c4.8,0,7.1,2.7,7.1,2.7l-2.5,4 c0,0-1.7-1.7-4.2-1.7c-2.8,0-4.3,2.1-4.3,4.3c0,2.1,1.5,4.4,4.5,4.4c2.5,0,4.9-2.1,4.9-2.1l2.2,4.2c0,0-2.7,2.9-7.6,2.9 C10.8,27.9,7.2,23.5,7.2,18.6z M36.9,27.9c-6.4,0-9.9-4.4-9.9-9.3c0-4.8,3.5-9.3,9.9-9.3C41.7,9.3,44,12,44,12l-2.5,4 c0,0-1.7-1.7-4.2-1.7c-2.8,0-4.3,2.1-4.3,4.3c0,2.1,1.5,4.4,4.5,4.4c2.5,0,4.9-2.1,4.9-2.1l2.2,4.2C44.5,25,41.9,27.9,36.9,27.9z\"></path></svg>";
        /***/ },
        /***/ "./src/icons/10-reload.svg": /*!*********************************!*\
  !*** ./src/icons/10-reload.svg ***!
  \*********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<svg fill=\"#FFFFFF\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z\"></path><path d=\"M0 0h24v24H0z\" fill=\"none\"></path></svg>";
        /***/ },
        /***/ "./src/main.js": /*!*********************!*\
  !*** ./src/main.js ***!
  \*********************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _player = __webpack_require__(/*! ./components/player */ "./src/components/player.js");
            var _player2 = _interopRequireDefault(_player);
            var _utils = __webpack_require__(/*! ./base/utils */ "./src/base/utils.js");
            var _utils2 = _interopRequireDefault(_utils);
            var _events = __webpack_require__(/*! ./base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _playback = __webpack_require__(/*! ./base/playback */ "./src/base/playback.js");
            var _playback2 = _interopRequireDefault(_playback);
            var _container_plugin = __webpack_require__(/*! ./base/container_plugin */ "./src/base/container_plugin.js");
            var _container_plugin2 = _interopRequireDefault(_container_plugin);
            var _core_plugin = __webpack_require__(/*! ./base/core_plugin */ "./src/base/core_plugin.js");
            var _core_plugin2 = _interopRequireDefault(_core_plugin);
            var _ui_core_plugin = __webpack_require__(/*! ./base/ui_core_plugin */ "./src/base/ui_core_plugin.js");
            var _ui_core_plugin2 = _interopRequireDefault(_ui_core_plugin);
            var _ui_container_plugin = __webpack_require__(/*! ./base/ui_container_plugin */ "./src/base/ui_container_plugin.js");
            var _ui_container_plugin2 = _interopRequireDefault(_ui_container_plugin);
            var _base_object = __webpack_require__(/*! ./base/base_object */ "./src/base/base_object.js");
            var _base_object2 = _interopRequireDefault(_base_object);
            var _ui_object = __webpack_require__(/*! ./base/ui_object */ "./src/base/ui_object.js");
            var _ui_object2 = _interopRequireDefault(_ui_object);
            var _browser = __webpack_require__(/*! ./components/browser */ "./src/components/browser/index.js");
            var _browser2 = _interopRequireDefault(_browser);
            var _container = __webpack_require__(/*! ./components/container */ "./src/components/container/index.js");
            var _container2 = _interopRequireDefault(_container);
            var _core = __webpack_require__(/*! ./components/core */ "./src/components/core/index.js");
            var _core2 = _interopRequireDefault(_core);
            var _error = __webpack_require__(/*! ./components/error */ "./src/components/error/index.js");
            var _error2 = _interopRequireDefault(_error);
            var _loader = __webpack_require__(/*! ./components/loader */ "./src/components/loader/index.js");
            var _loader2 = _interopRequireDefault(_loader);
            var _mediator = __webpack_require__(/*! ./components/mediator */ "./src/components/mediator.js");
            var _mediator2 = _interopRequireDefault(_mediator);
            var _player_info = __webpack_require__(/*! ./components/player_info */ "./src/components/player_info.js");
            var _player_info2 = _interopRequireDefault(_player_info);
            var _base_flash_playback = __webpack_require__(/*! ./playbacks/base_flash_playback */ "./src/playbacks/base_flash_playback/index.js");
            var _base_flash_playback2 = _interopRequireDefault(_base_flash_playback);
            var _flash = __webpack_require__(/*! ./playbacks/flash */ "./src/playbacks/flash/index.js");
            var _flash2 = _interopRequireDefault(_flash);
            var _flashls = __webpack_require__(/*! ./playbacks/flashls */ "./src/playbacks/flashls/index.js");
            var _flashls2 = _interopRequireDefault(_flashls);
            var _hls = __webpack_require__(/*! ./playbacks/hls */ "./src/playbacks/hls/index.js");
            var _hls2 = _interopRequireDefault(_hls);
            var _html5_audio = __webpack_require__(/*! ./playbacks/html5_audio */ "./src/playbacks/html5_audio/index.js");
            var _html5_audio2 = _interopRequireDefault(_html5_audio);
            var _html5_video = __webpack_require__(/*! ./playbacks/html5_video */ "./src/playbacks/html5_video/index.js");
            var _html5_video2 = _interopRequireDefault(_html5_video);
            var _html_img = __webpack_require__(/*! ./playbacks/html_img */ "./src/playbacks/html_img/index.js");
            var _html_img2 = _interopRequireDefault(_html_img);
            var _no_op = __webpack_require__(/*! ./playbacks/no_op */ "./src/playbacks/no_op/index.js");
            var _no_op2 = _interopRequireDefault(_no_op);
            var _media_control = __webpack_require__(/*! ./plugins/media_control */ "./src/plugins/media_control/index.js");
            var _media_control2 = _interopRequireDefault(_media_control);
            var _click_to_pause = __webpack_require__(/*! ./plugins/click_to_pause */ "./src/plugins/click_to_pause/index.js");
            var _click_to_pause2 = _interopRequireDefault(_click_to_pause);
            var _dvr_controls = __webpack_require__(/*! ./plugins/dvr_controls */ "./src/plugins/dvr_controls/index.js");
            var _dvr_controls2 = _interopRequireDefault(_dvr_controls);
            var _favicon = __webpack_require__(/*! ./plugins/favicon */ "./src/plugins/favicon/index.js");
            var _favicon2 = _interopRequireDefault(_favicon);
            var _log = __webpack_require__(/*! ./plugins/log */ "./src/plugins/log/index.js");
            var _log2 = _interopRequireDefault(_log);
            var _poster = __webpack_require__(/*! ./plugins/poster */ "./src/plugins/poster/index.js");
            var _poster2 = _interopRequireDefault(_poster);
            var _spinner_three_bounce = __webpack_require__(/*! ./plugins/spinner_three_bounce */ "./src/plugins/spinner_three_bounce/index.js");
            var _spinner_three_bounce2 = _interopRequireDefault(_spinner_three_bounce);
            var _watermark = __webpack_require__(/*! ./plugins/watermark */ "./src/plugins/watermark/index.js");
            var _watermark2 = _interopRequireDefault(_watermark);
            var _styler = __webpack_require__(/*! ./base/styler */ "./src/base/styler.js");
            var _styler2 = _interopRequireDefault(_styler);
            var _vendor = __webpack_require__(/*! ./vendor */ "./src/vendor/index.js");
            var _vendor2 = _interopRequireDefault(_vendor);
            var _template = __webpack_require__(/*! ./base/template */ "./src/base/template.js");
            var _template2 = _interopRequireDefault(_template);
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var version = "0.3.13"; // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            exports.default = {
                Player: _player2.default,
                Mediator: _mediator2.default,
                Events: _events2.default,
                Browser: _browser2.default,
                PlayerInfo: _player_info2.default,
                MediaControl: _media_control2.default,
                ContainerPlugin: _container_plugin2.default,
                UIContainerPlugin: _ui_container_plugin2.default,
                CorePlugin: _core_plugin2.default,
                UICorePlugin: _ui_core_plugin2.default,
                Playback: _playback2.default,
                Container: _container2.default,
                Core: _core2.default,
                PlayerError: _error2.default,
                Loader: _loader2.default,
                BaseObject: _base_object2.default,
                UIObject: _ui_object2.default,
                Utils: _utils2.default,
                BaseFlashPlayback: _base_flash_playback2.default,
                Flash: _flash2.default,
                FlasHLS: _flashls2.default,
                HLS: _hls2.default,
                HTML5Audio: _html5_audio2.default,
                HTML5Video: _html5_video2.default,
                HTMLImg: _html_img2.default,
                NoOp: _no_op2.default,
                ClickToPausePlugin: _click_to_pause2.default,
                DVRControls: _dvr_controls2.default,
                Favicon: _favicon2.default,
                Log: _log2.default,
                Poster: _poster2.default,
                SpinnerThreeBouncePlugin: _spinner_three_bounce2.default,
                WaterMarkPlugin: _watermark2.default,
                Styler: _styler2.default,
                Vendor: _vendor2.default,
                version: version,
                template: _template2.default,
                $: _clapprZepto2.default
            };
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/base_flash_playback/base_flash_playback.js": /*!******************************************************************!*\
  !*** ./src/playbacks/base_flash_playback/base_flash_playback.js ***!
  \******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
            var _playback2 = _interopRequireDefault(_playback);
            var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
            var _template2 = _interopRequireDefault(_template);
            var _browser = __webpack_require__(/*! ../../components/browser */ "./src/components/browser/index.js");
            var _browser2 = _interopRequireDefault(_browser);
            var _flash = __webpack_require__(/*! ./public/flash.html */ "./src/playbacks/base_flash_playback/public/flash.html");
            var _flash2 = _interopRequireDefault(_flash);
            __webpack_require__(/*! ./public/flash.scss */ "./src/playbacks/base_flash_playback/public/flash.scss");
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var IE_CLASSID = 'clsid:d27cdb6e-ae6d-11cf-96b8-444553540000'; // Copyright 2015 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var BaseFlashPlayback = function(_Playback) {
                (0, _inherits3.default)(BaseFlashPlayback, _Playback);
                function BaseFlashPlayback() {
                    (0, _classCallCheck3.default)(this, BaseFlashPlayback);
                    return (0, _possibleConstructorReturn3.default)(this, _Playback.apply(this, arguments));
                }
                BaseFlashPlayback.prototype.setElement = function setElement(element) {
                    this.$el = element;
                    this.el = element[0];
                };
                BaseFlashPlayback.prototype.render = function render() {
                    this.$el.attr('data', this.swfPath);
                    this.$el.html(this.template({
                        cid: this.cid,
                        swfPath: this.swfPath,
                        baseUrl: this.baseUrl,
                        playbackId: this.uniqueId,
                        wmode: this.wmode,
                        callbackName: 'window.Clappr.flashlsCallbacks.' + this.cid
                    }));
                    if (_browser2.default.isIE) {
                        this.$('embed').remove();
                        if (_browser2.default.isLegacyIE) this.$el.attr('classid', IE_CLASSID);
                    }
                    this.el.id = this.cid;
                    return this;
                };
                (0, _createClass3.default)(BaseFlashPlayback, [
                    {
                        key: 'tagName',
                        get: function get() {
                            return 'object';
                        }
                    },
                    {
                        key: 'swfPath',
                        get: function get() {
                            return '';
                        }
                    },
                    {
                        key: 'wmode',
                        get: function get() {
                            return 'transparent';
                        }
                    },
                    {
                        key: 'template',
                        get: function get() {
                            return (0, _template2.default)(_flash2.default);
                        }
                    },
                    {
                        key: 'attributes',
                        get: function get() {
                            var type = 'application/x-shockwave-flash';
                            if (_browser2.default.isLegacyIE) type = '';
                            return {
                                class: 'clappr-flash-playback',
                                type: type,
                                width: '100%',
                                height: '100%',
                                data: this.swfPath,
                                'data-flash-playback': this.name
                            };
                        }
                    }
                ]);
                return BaseFlashPlayback;
            }(_playback2.default);
            exports.default = BaseFlashPlayback;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/base_flash_playback/index.js": /*!****************************************************!*\
  !*** ./src/playbacks/base_flash_playback/index.js ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = __webpack_require__(/*! ./base_flash_playback */ "./src/playbacks/base_flash_playback/base_flash_playback.js");
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/base_flash_playback/public/flash.html": /*!*************************************************************!*\
  !*** ./src/playbacks/base_flash_playback/public/flash.html ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<param name=\"movie\" value=\"<%= swfPath %>\">\n<param name=\"quality\" value=\"autohigh\">\n<param name=\"swliveconnect\" value=\"true\">\n<param name=\"allowScriptAccess\" value=\"always\">\n<param name=\"bgcolor\" value=\"#000000\">\n<param name=\"allowFullScreen\" value=\"false\">\n<param name=\"wmode\" value=\"<%= wmode %>\">\n<param name=\"tabindex\" value=\"1\">\n<param name=\"FlashVars\" value=\"playbackId=<%= playbackId %>&callback=<%= callbackName %>\">\n<embed\n  name=\"<%= cid %>\"\n  type=\"application/x-shockwave-flash\"\n  disabled=\"disabled\"\n  tabindex=\"-1\"\n  enablecontextmenu=\"false\"\n  allowScriptAccess=\"always\"\n  quality=\"autohigh\"\n  pluginspage=\"http://www.macromedia.com/go/getflashplayer\"\n  wmode=\"<%= wmode %>\"\n  swliveconnect=\"true\"\n  allowfullscreen=\"false\"\n  bgcolor=\"#000000\"\n  FlashVars=\"playbackId=<%= playbackId %>&callback=<%= callbackName %>\"\n  data=\"<%= swfPath %>\"\n  src=\"<%= swfPath %>\"\n  width=\"100%\"\n  height=\"100%\">\n</embed>\n";
        /***/ },
        /***/ "./src/playbacks/base_flash_playback/public/flash.scss": /*!*************************************************************!*\
  !*** ./src/playbacks/base_flash_playback/public/flash.scss ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./flash.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/playbacks/base_flash_playback/public/flash.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/playbacks/flash/flash.js": /*!**************************************!*\
  !*** ./src/playbacks/flash/flash.js ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _utils = __webpack_require__(/*! ../../base/utils */ "./src/base/utils.js");
            var _base_flash_playback = __webpack_require__(/*! ../../playbacks/base_flash_playback */ "./src/playbacks/base_flash_playback/index.js");
            var _base_flash_playback2 = _interopRequireDefault(_base_flash_playback);
            var _browser = __webpack_require__(/*! ../../components/browser */ "./src/components/browser/index.js");
            var _browser2 = _interopRequireDefault(_browser);
            var _mediator = __webpack_require__(/*! ../../components/mediator */ "./src/components/mediator.js");
            var _mediator2 = _interopRequireDefault(_mediator);
            var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
            var _template2 = _interopRequireDefault(_template);
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
            var _playback2 = _interopRequireDefault(_playback);
            var _Player = __webpack_require__(/*! ./public/Player.swf */ "./src/playbacks/flash/public/Player.swf");
            var _Player2 = _interopRequireDefault(_Player);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var MAX_ATTEMPTS = 60; // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var Flash = function(_BaseFlashPlayback) {
                (0, _inherits3.default)(Flash, _BaseFlashPlayback);
                (0, _createClass3.default)(Flash, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'flash';
                        }
                    },
                    {
                        key: 'swfPath',
                        get: function get() {
                            return (0, _template2.default)(_Player2.default)({
                                baseUrl: this._baseUrl
                            });
                        }
                    },
                    {
                        key: 'ended',
                        get: function get() {
                            return this._currentState === 'ENDED';
                        }
                    },
                    {
                        key: 'buffering',
                        get: function get() {
                            return !!this._bufferingState && this._currentState !== 'ENDED';
                        }
                    }
                ]);
                function Flash() {
                    (0, _classCallCheck3.default)(this, Flash);
                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _this = (0, _possibleConstructorReturn3.default)(this, _BaseFlashPlayback.call.apply(_BaseFlashPlayback, [
                        this
                    ].concat(args)));
                    _this._src = _this.options.src;
                    _this._baseUrl = _this.options.baseUrl;
                    _this._autoPlay = _this.options.autoPlay;
                    _this.settings = {
                        default: [
                            'seekbar'
                        ]
                    };
                    _this.settings.left = [
                        'playpause',
                        'position',
                        'duration'
                    ];
                    _this.settings.right = [
                        'fullscreen',
                        'volume'
                    ];
                    _this.settings.seekEnabled = true;
                    _this._isReadyState = false;
                    _this._addListeners();
                    return _this;
                }
                Flash.prototype._bootstrap = function _bootstrap() {
                    var _this2 = this;
                    if (this.el.playerPlay) {
                        this.el.width = '100%';
                        this.el.height = '100%';
                        if (this._currentState === 'PLAYING') this._firstPlay();
                        else {
                            this._currentState = 'IDLE';
                            this._autoPlay && this.play();
                        }
                        (0, _clapprZepto2.default)('<div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%" />').insertAfter(this.$el);
                        if (this.getDuration() > 0) this._metadataLoaded();
                        else _mediator2.default.once(this.uniqueId + ':timeupdate', this._metadataLoaded, this);
                    } else {
                        this._attempts = this._attempts || 0;
                        if (++this._attempts <= MAX_ATTEMPTS) setTimeout(function() {
                            return _this2._bootstrap();
                        }, 50);
                        else this.trigger(_events2.default.PLAYBACK_ERROR, {
                            message: 'Max number of attempts reached'
                        }, this.name);
                    }
                };
                Flash.prototype._metadataLoaded = function _metadataLoaded() {
                    this._isReadyState = true;
                    this.trigger(_events2.default.PLAYBACK_READY, this.name);
                    this.trigger(_events2.default.PLAYBACK_SETTINGSUPDATE, this.name);
                };
                Flash.prototype.getPlaybackType = function getPlaybackType() {
                    return _playback2.default.VOD;
                };
                Flash.prototype.isHighDefinitionInUse = function isHighDefinitionInUse() {
                    return false;
                };
                Flash.prototype._updateTime = function _updateTime() {
                    this.trigger(_events2.default.PLAYBACK_TIMEUPDATE, {
                        current: this.el.getPosition(),
                        total: this.el.getDuration()
                    }, this.name);
                };
                Flash.prototype._addListeners = function _addListeners() {
                    _mediator2.default.on(this.uniqueId + ':progress', this._progress, this);
                    _mediator2.default.on(this.uniqueId + ':timeupdate', this._updateTime, this);
                    _mediator2.default.on(this.uniqueId + ':statechanged', this._checkState, this);
                    _mediator2.default.on(this.uniqueId + ':flashready', this._bootstrap, this);
                };
                Flash.prototype.stopListening = function stopListening() {
                    _BaseFlashPlayback.prototype.stopListening.call(this);
                    _mediator2.default.off(this.uniqueId + ':progress');
                    _mediator2.default.off(this.uniqueId + ':timeupdate');
                    _mediator2.default.off(this.uniqueId + ':statechanged');
                    _mediator2.default.off(this.uniqueId + ':flashready');
                };
                Flash.prototype._checkState = function _checkState() {
                    if (this._isIdle || this._currentState === 'PAUSED') return;
                    else if (this._currentState !== 'PLAYING_BUFFERING' && this.el.getState() === 'PLAYING_BUFFERING') {
                        this._bufferingState = true;
                        this.trigger(_events2.default.PLAYBACK_BUFFERING, this.name);
                        this._currentState = 'PLAYING_BUFFERING';
                    } else if (this.el.getState() === 'PLAYING') {
                        this._bufferingState = false;
                        this.trigger(_events2.default.PLAYBACK_BUFFERFULL, this.name);
                        this._currentState = 'PLAYING';
                    } else if (this.el.getState() === 'IDLE') this._currentState = 'IDLE';
                    else if (this.el.getState() === 'ENDED') {
                        this.trigger(_events2.default.PLAYBACK_ENDED, this.name);
                        this.trigger(_events2.default.PLAYBACK_TIMEUPDATE, {
                            current: 0,
                            total: this.el.getDuration()
                        }, this.name);
                        this._currentState = 'ENDED';
                        this._isIdle = true;
                    }
                };
                Flash.prototype._progress = function _progress() {
                    if (this._currentState !== 'IDLE' && this._currentState !== 'ENDED') this.trigger(_events2.default.PLAYBACK_PROGRESS, {
                        start: 0,
                        current: this.el.getBytesLoaded(),
                        total: this.el.getBytesTotal()
                    });
                };
                Flash.prototype._firstPlay = function _firstPlay() {
                    var _this3 = this;
                    if (this.el.playerPlay) {
                        this._isIdle = false;
                        this.el.playerPlay(this._src);
                        this.listenToOnce(this, _events2.default.PLAYBACK_BUFFERFULL, function() {
                            return _this3._checkInitialSeek();
                        });
                        this._currentState = 'PLAYING';
                    } else this.listenToOnce(this, _events2.default.PLAYBACK_READY, this._firstPlay);
                };
                Flash.prototype._checkInitialSeek = function _checkInitialSeek() {
                    var seekTime = (0, _utils.seekStringToSeconds)(window.location.href);
                    if (seekTime !== 0) this.seekSeconds(seekTime);
                };
                Flash.prototype.play = function play() {
                    this.trigger(_events2.default.PLAYBACK_PLAY_INTENT);
                    if (this._currentState === 'PAUSED' || this._currentState === 'PLAYING_BUFFERING') {
                        this._currentState = 'PLAYING';
                        this.el.playerResume();
                        this.trigger(_events2.default.PLAYBACK_PLAY, this.name);
                    } else if (this._currentState !== 'PLAYING') {
                        this._firstPlay();
                        this.trigger(_events2.default.PLAYBACK_PLAY, this.name);
                    }
                };
                Flash.prototype.volume = function volume(value) {
                    var _this4 = this;
                    if (this.isReady) this.el.playerVolume(value);
                    else this.listenToOnce(this, _events2.default.PLAYBACK_BUFFERFULL, function() {
                        return _this4.volume(value);
                    });
                };
                Flash.prototype.pause = function pause() {
                    this._currentState = 'PAUSED';
                    this.el.playerPause();
                    this.trigger(_events2.default.PLAYBACK_PAUSE, this.name);
                };
                Flash.prototype.stop = function stop() {
                    this.el.playerStop();
                    this.trigger(_events2.default.PLAYBACK_STOP);
                    this.trigger(_events2.default.PLAYBACK_TIMEUPDATE, {
                        current: 0,
                        total: 0
                    }, this.name);
                };
                Flash.prototype.isPlaying = function isPlaying() {
                    return !!(this.isReady && this._currentState.indexOf('PLAYING') > -1);
                };
                Flash.prototype.getDuration = function getDuration() {
                    return this.el.getDuration();
                };
                Flash.prototype.seekPercentage = function seekPercentage(percentage) {
                    var _this5 = this;
                    if (this.el.getDuration() > 0) {
                        var seekSeconds = this.el.getDuration() * (percentage / 100);
                        this.seek(seekSeconds);
                    } else this.listenToOnce(this, _events2.default.PLAYBACK_BUFFERFULL, function() {
                        return _this5.seekPercentage(percentage);
                    });
                };
                Flash.prototype.seek = function seek(time) {
                    var _this6 = this;
                    if (this.isReady && this.el.playerSeek) {
                        this.el.playerSeek(time);
                        this.trigger(_events2.default.PLAYBACK_TIMEUPDATE, {
                            current: time,
                            total: this.el.getDuration()
                        }, this.name);
                        if (this._currentState === 'PAUSED') this.el.playerPause();
                    } else this.listenToOnce(this, _events2.default.PLAYBACK_BUFFERFULL, function() {
                        return _this6.seek(time);
                    });
                };
                Flash.prototype.destroy = function destroy() {
                    clearInterval(this.bootstrapId);
                    _BaseFlashPlayback.prototype.stopListening.call(this);
                    this.$el.remove();
                };
                (0, _createClass3.default)(Flash, [
                    {
                        key: 'isReady',
                        get: function get() {
                            return this._isReadyState;
                        }
                    }
                ]);
                return Flash;
            }(_base_flash_playback2.default);
            exports.default = Flash;
            Flash.canPlay = function(resource) {
                if (!_browser2.default.hasFlash || !resource || resource.constructor !== String) return false;
                else {
                    var resourceParts = resource.split('?')[0].match(/.*\.(.*)$/) || [];
                    return resourceParts.length > 1 && !_browser2.default.isMobile && resourceParts[1].toLowerCase().match(/^(mp4|mov|f4v|3gpp|3gp)$/);
                }
            };
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/flash/index.js": /*!**************************************!*\
  !*** ./src/playbacks/flash/index.js ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _flash = __webpack_require__(/*! ./flash */ "./src/playbacks/flash/flash.js");
            var _flash2 = _interopRequireDefault(_flash);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _flash2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/flash/public/Player.swf": /*!***********************************************!*\
  !*** ./src/playbacks/flash/public/Player.swf ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<%=baseUrl%>/4b76590b32dab62bc95c1b7951efae78.swf";
        /***/ },
        /***/ "./src/playbacks/flashls/flashls.js": /*!******************************************!*\
  !*** ./src/playbacks/flashls/flashls.js ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _base_flash_playback = __webpack_require__(/*! ../../playbacks/base_flash_playback */ "./src/playbacks/base_flash_playback/index.js");
            var _base_flash_playback2 = _interopRequireDefault(_base_flash_playback);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
            var _template2 = _interopRequireDefault(_template);
            var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
            var _playback2 = _interopRequireDefault(_playback);
            var _mediator = __webpack_require__(/*! ../../components/mediator */ "./src/components/mediator.js");
            var _mediator2 = _interopRequireDefault(_mediator);
            var _browser = __webpack_require__(/*! ../../components/browser */ "./src/components/browser/index.js");
            var _browser2 = _interopRequireDefault(_browser);
            var _error = __webpack_require__(/*! ../../components/error */ "./src/components/error/index.js");
            var _error2 = _interopRequireDefault(_error);
            var _flashls_events = __webpack_require__(/*! ./flashls_events */ "./src/playbacks/flashls/flashls_events.js");
            var _flashls_events2 = _interopRequireDefault(_flashls_events);
            var _HLSPlayer = __webpack_require__(/*! ./public/HLSPlayer.swf */ "./src/playbacks/flashls/public/HLSPlayer.swf");
            var _HLSPlayer2 = _interopRequireDefault(_HLSPlayer);
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var MAX_ATTEMPTS = 60;
            var AUTO = -1;
            var FlasHLS = function(_BaseFlashPlayback) {
                (0, _inherits3.default)(FlasHLS, _BaseFlashPlayback);
                (0, _createClass3.default)(FlasHLS, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'flashls';
                        }
                    },
                    {
                        key: 'swfPath',
                        get: function get() {
                            return (0, _template2.default)(_HLSPlayer2.default)({
                                baseUrl: this._baseUrl
                            });
                        }
                    },
                    {
                        key: 'levels',
                        get: function get() {
                            return this._levels || [];
                        }
                    },
                    {
                        key: 'currentLevel',
                        get: function get() {
                            if (this._currentLevel === null || this._currentLevel === undefined) return AUTO;
                            else return this._currentLevel; //0 is a valid level ID
                        },
                        set: function set(id) {
                            this._currentLevel = id;
                            this.trigger(_events2.default.PLAYBACK_LEVEL_SWITCH_START);
                            this.el.playerSetCurrentLevel(id);
                        }
                    },
                    {
                        key: 'ended',
                        get: function get() {
                            return this._hasEnded;
                        }
                    },
                    {
                        key: 'buffering',
                        get: function get() {
                            return !!this._bufferingState && !this._hasEnded;
                        }
                    }
                ]);
                function FlasHLS() {
                    (0, _classCallCheck3.default)(this, FlasHLS);
                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _this = (0, _possibleConstructorReturn3.default)(this, _BaseFlashPlayback.call.apply(_BaseFlashPlayback, [
                        this
                    ].concat(args)));
                    _this._src = _this.options.src;
                    _this._baseUrl = _this.options.baseUrl;
                    _this._initHlsParameters(_this.options);
                    // TODO can this be private?
                    _this.highDefinition = false;
                    _this._autoPlay = _this.options.autoPlay;
                    _this._loop = _this.options.loop;
                    _this._defaultSettings = {
                        left: [
                            'playstop'
                        ],
                        default: [
                            'seekbar'
                        ],
                        right: [
                            'fullscreen',
                            'volume',
                            'hd-indicator'
                        ],
                        seekEnabled: false
                    };
                    _this.settings = _clapprZepto2.default.extend({}, _this._defaultSettings);
                    _this._playbackType = _playback2.default.LIVE;
                    _this._hasEnded = false;
                    _this._addListeners();
                    return _this;
                }
                FlasHLS.prototype._initHlsParameters = function _initHlsParameters(options) {
                    this._autoStartLoad = options.autoStartLoad === undefined ? true : options.autoStartLoad;
                    this._capLevelToStage = options.capLevelToStage === undefined ? false : options.capLevelToStage;
                    this._maxLevelCappingMode = options.maxLevelCappingMode === undefined ? 'downscale' : options.maxLevelCappingMode;
                    this._minBufferLength = options.minBufferLength === undefined ? -1 : options.minBufferLength;
                    this._minBufferLengthCapping = options.minBufferLengthCapping === undefined ? -1 : options.minBufferLengthCapping;
                    this._maxBufferLength = options.maxBufferLength === undefined ? 120 : options.maxBufferLength;
                    this._maxBackBufferLength = options.maxBackBufferLength === undefined ? 30 : options.maxBackBufferLength;
                    this._lowBufferLength = options.lowBufferLength === undefined ? 3 : options.lowBufferLength;
                    this._mediaTimePeriod = options.mediaTimePeriod === undefined ? 100 : options.mediaTimePeriod;
                    this._fpsDroppedMonitoringPeriod = options.fpsDroppedMonitoringPeriod === undefined ? 5000 : options.fpsDroppedMonitoringPeriod;
                    this._fpsDroppedMonitoringThreshold = options.fpsDroppedMonitoringThreshold === undefined ? 0.2 : options.fpsDroppedMonitoringThreshold;
                    this._capLevelonFPSDrop = options.capLevelonFPSDrop === undefined ? false : options.capLevelonFPSDrop;
                    this._smoothAutoSwitchonFPSDrop = options.smoothAutoSwitchonFPSDrop === undefined ? this.capLevelonFPSDrop : options.smoothAutoSwitchonFPSDrop;
                    this._switchDownOnLevelError = options.switchDownOnLevelError === undefined ? true : options.switchDownOnLevelError;
                    this._seekMode = options.seekMode === undefined ? 'ACCURATE' : options.seekMode;
                    this._keyLoadMaxRetry = options.keyLoadMaxRetry === undefined ? 3 : options.keyLoadMaxRetry;
                    this._keyLoadMaxRetryTimeout = options.keyLoadMaxRetryTimeout === undefined ? 64000 : options.keyLoadMaxRetryTimeout;
                    this._fragmentLoadMaxRetry = options.fragmentLoadMaxRetry === undefined ? 3 : options.fragmentLoadMaxRetry;
                    this._fragmentLoadMaxRetryTimeout = options.fragmentLoadMaxRetryTimeout === undefined ? 4000 : options.fragmentLoadMaxRetryTimeout;
                    this._fragmentLoadSkipAfterMaxRetry = options.fragmentLoadSkipAfterMaxRetry === undefined ? true : options.fragmentLoadSkipAfterMaxRetry;
                    this._maxSkippedFragments = options.maxSkippedFragments === undefined ? 5 : options.maxSkippedFragments;
                    this._flushLiveURLCache = options.flushLiveURLCache === undefined ? false : options.flushLiveURLCache;
                    this._initialLiveManifestSize = options.initialLiveManifestSize === undefined ? 1 : options.initialLiveManifestSize;
                    this._manifestLoadMaxRetry = options.manifestLoadMaxRetry === undefined ? 3 : options.manifestLoadMaxRetry;
                    this._manifestLoadMaxRetryTimeout = options.manifestLoadMaxRetryTimeout === undefined ? 64000 : options.manifestLoadMaxRetryTimeout;
                    this._manifestRedundantLoadmaxRetry = options.manifestRedundantLoadmaxRetry === undefined ? 3 : options.manifestRedundantLoadmaxRetry;
                    this._startFromBitrate = options.startFromBitrate === undefined ? -1 : options.startFromBitrate;
                    this._startFromLevel = options.startFromLevel === undefined ? -1 : options.startFromLevel;
                    this._autoStartMaxDuration = options.autoStartMaxDuration === undefined ? -1 : options.autoStartMaxDuration;
                    this._seekFromLevel = options.seekFromLevel === undefined ? -1 : options.seekFromLevel;
                    this._useHardwareVideoDecoder = options.useHardwareVideoDecoder === undefined ? false : options.useHardwareVideoDecoder;
                    this._hlsLogEnabled = options.hlsLogEnabled === undefined ? true : options.hlsLogEnabled;
                    this._logDebug = options.logDebug === undefined ? false : options.logDebug;
                    this._logDebug2 = options.logDebug2 === undefined ? false : options.logDebug2;
                    this._logWarn = options.logWarn === undefined ? true : options.logWarn;
                    this._logError = options.logError === undefined ? true : options.logError;
                    this._hlsMinimumDvrSize = options.hlsMinimumDvrSize === undefined ? 60 : options.hlsMinimumDvrSize;
                };
                FlasHLS.prototype._addListeners = function _addListeners() {
                    var _this2 = this;
                    _mediator2.default.on(this.cid + ':flashready', function() {
                        return _this2._bootstrap();
                    });
                    _mediator2.default.on(this.cid + ':timeupdate', function(timeMetrics) {
                        return _this2._updateTime(timeMetrics);
                    });
                    _mediator2.default.on(this.cid + ':playbackstate', function(state) {
                        return _this2._setPlaybackState(state);
                    });
                    _mediator2.default.on(this.cid + ':levelchanged', function(level) {
                        return _this2._levelChanged(level);
                    });
                    _mediator2.default.on(this.cid + ':error', function(code, url, message) {
                        return _this2._flashPlaybackError(code, url, message);
                    });
                    _mediator2.default.on(this.cid + ':fragmentloaded', function(loadmetrics) {
                        return _this2._onFragmentLoaded(loadmetrics);
                    });
                    _mediator2.default.on(this.cid + ':levelendlist', function(level) {
                        return _this2._onLevelEndlist(level);
                    });
                };
                FlasHLS.prototype.stopListening = function stopListening() {
                    _BaseFlashPlayback.prototype.stopListening.call(this);
                    _mediator2.default.off(this.cid + ':flashready');
                    _mediator2.default.off(this.cid + ':timeupdate');
                    _mediator2.default.off(this.cid + ':playbackstate');
                    _mediator2.default.off(this.cid + ':levelchanged');
                    _mediator2.default.off(this.cid + ':playbackerror');
                    _mediator2.default.off(this.cid + ':fragmentloaded');
                    _mediator2.default.off(this.cid + ':manifestloaded');
                    _mediator2.default.off(this.cid + ':levelendlist');
                };
                FlasHLS.prototype._bootstrap = function _bootstrap() {
                    var _this3 = this;
                    if (this.el.playerLoad) {
                        this.el.width = '100%';
                        this.el.height = '100%';
                        this._isReadyState = true;
                        this._srcLoaded = false;
                        this._currentState = 'IDLE';
                        this._setFlashSettings();
                        this._updatePlaybackType();
                        if (this._autoPlay || this._shouldPlayOnManifestLoaded) this.play();
                        this.trigger(_events2.default.PLAYBACK_READY, this.name);
                    } else {
                        this._bootstrapAttempts = this._bootstrapAttempts || 0;
                        if (++this._bootstrapAttempts <= MAX_ATTEMPTS) setTimeout(function() {
                            return _this3._bootstrap();
                        }, 50);
                        else {
                            var formattedError = this.createError({
                                code: 'playerLoadFail_maxNumberAttemptsReached',
                                description: this.name + ' error: Max number of attempts reached',
                                level: _error2.default.Levels.FATAL,
                                raw: {}
                            });
                            this.trigger(_events2.default.PLAYBACK_ERROR, formattedError);
                        }
                    }
                };
                FlasHLS.prototype._setFlashSettings = function _setFlashSettings() {
                    this.el.playerSetAutoStartLoad(this._autoStartLoad);
                    this.el.playerSetCapLevelToStage(this._capLevelToStage);
                    this.el.playerSetMaxLevelCappingMode(this._maxLevelCappingMode);
                    this.el.playerSetMinBufferLength(this._minBufferLength);
                    this.el.playerSetMinBufferLengthCapping(this._minBufferLengthCapping);
                    this.el.playerSetMaxBufferLength(this._maxBufferLength);
                    this.el.playerSetMaxBackBufferLength(this._maxBackBufferLength);
                    this.el.playerSetLowBufferLength(this._lowBufferLength);
                    this.el.playerSetMediaTimePeriod(this._mediaTimePeriod);
                    this.el.playerSetFpsDroppedMonitoringPeriod(this._fpsDroppedMonitoringPeriod);
                    this.el.playerSetFpsDroppedMonitoringThreshold(this._fpsDroppedMonitoringThreshold);
                    this.el.playerSetCapLevelonFPSDrop(this._capLevelonFPSDrop);
                    this.el.playerSetSmoothAutoSwitchonFPSDrop(this._smoothAutoSwitchonFPSDrop);
                    this.el.playerSetSwitchDownOnLevelError(this._switchDownOnLevelError);
                    this.el.playerSetSeekMode(this._seekMode);
                    this.el.playerSetKeyLoadMaxRetry(this._keyLoadMaxRetry);
                    this.el.playerSetKeyLoadMaxRetryTimeout(this._keyLoadMaxRetryTimeout);
                    this.el.playerSetFragmentLoadMaxRetry(this._fragmentLoadMaxRetry);
                    this.el.playerSetFragmentLoadMaxRetryTimeout(this._fragmentLoadMaxRetryTimeout);
                    this.el.playerSetFragmentLoadSkipAfterMaxRetry(this._fragmentLoadSkipAfterMaxRetry);
                    this.el.playerSetMaxSkippedFragments(this._maxSkippedFragments);
                    this.el.playerSetFlushLiveURLCache(this._flushLiveURLCache);
                    this.el.playerSetInitialLiveManifestSize(this._initialLiveManifestSize);
                    this.el.playerSetManifestLoadMaxRetry(this._manifestLoadMaxRetry);
                    this.el.playerSetManifestLoadMaxRetryTimeout(this._manifestLoadMaxRetryTimeout);
                    this.el.playerSetManifestRedundantLoadmaxRetry(this._manifestRedundantLoadmaxRetry);
                    this.el.playerSetStartFromBitrate(this._startFromBitrate);
                    this.el.playerSetStartFromLevel(this._startFromLevel);
                    this.el.playerSetAutoStartMaxDuration(this._autoStartMaxDuration);
                    this.el.playerSetSeekFromLevel(this._seekFromLevel);
                    this.el.playerSetUseHardwareVideoDecoder(this._useHardwareVideoDecoder);
                    this.el.playerSetLogInfo(this._hlsLogEnabled);
                    this.el.playerSetLogDebug(this._logDebug);
                    this.el.playerSetLogDebug2(this._logDebug2);
                    this.el.playerSetLogWarn(this._logWarn);
                    this.el.playerSetLogError(this._logError);
                };
                FlasHLS.prototype.setAutoStartLoad = function setAutoStartLoad(autoStartLoad) {
                    this._autoStartLoad = autoStartLoad;
                    this.el.playerSetAutoStartLoad(this._autoStartLoad);
                };
                FlasHLS.prototype.setCapLevelToStage = function setCapLevelToStage(capLevelToStage) {
                    this._capLevelToStage = capLevelToStage;
                    this.el.playerSetCapLevelToStage(this._capLevelToStage);
                };
                FlasHLS.prototype.setMaxLevelCappingMode = function setMaxLevelCappingMode(maxLevelCappingMode) {
                    this._maxLevelCappingMode = maxLevelCappingMode;
                    this.el.playerSetMaxLevelCappingMode(this._maxLevelCappingMode);
                };
                FlasHLS.prototype.setSetMinBufferLength = function setSetMinBufferLength(minBufferLength) {
                    this._minBufferLength = minBufferLength;
                    this.el.playerSetMinBufferLength(this._minBufferLength);
                };
                FlasHLS.prototype.setMinBufferLengthCapping = function setMinBufferLengthCapping(minBufferLengthCapping) {
                    this._minBufferLengthCapping = minBufferLengthCapping;
                    this.el.playerSetMinBufferLengthCapping(this._minBufferLengthCapping);
                };
                FlasHLS.prototype.setMaxBufferLength = function setMaxBufferLength(maxBufferLength) {
                    this._maxBufferLength = maxBufferLength;
                    this.el.playerSetMaxBufferLength(this._maxBufferLength);
                };
                FlasHLS.prototype.setMaxBackBufferLength = function setMaxBackBufferLength(maxBackBufferLength) {
                    this._maxBackBufferLength = maxBackBufferLength;
                    this.el.playerSetMaxBackBufferLength(this._maxBackBufferLength);
                };
                FlasHLS.prototype.setLowBufferLength = function setLowBufferLength(lowBufferLength) {
                    this._lowBufferLength = lowBufferLength;
                    this.el.playerSetLowBufferLength(this._lowBufferLength);
                };
                FlasHLS.prototype.setMediaTimePeriod = function setMediaTimePeriod(mediaTimePeriod) {
                    this._mediaTimePeriod = mediaTimePeriod;
                    this.el.playerSetMediaTimePeriod(this._mediaTimePeriod);
                };
                FlasHLS.prototype.setFpsDroppedMonitoringPeriod = function setFpsDroppedMonitoringPeriod(fpsDroppedMonitoringPeriod) {
                    this._fpsDroppedMonitoringPeriod = fpsDroppedMonitoringPeriod;
                    this.el.playerSetFpsDroppedMonitoringPeriod(this._fpsDroppedMonitoringPeriod);
                };
                FlasHLS.prototype.setFpsDroppedMonitoringThreshold = function setFpsDroppedMonitoringThreshold(fpsDroppedMonitoringThreshold) {
                    this._fpsDroppedMonitoringThreshold = fpsDroppedMonitoringThreshold;
                    this.el.playerSetFpsDroppedMonitoringThreshold(this._fpsDroppedMonitoringThreshold);
                };
                FlasHLS.prototype.setCapLevelonFPSDrop = function setCapLevelonFPSDrop(capLevelonFPSDrop) {
                    this._capLevelonFPSDrop = capLevelonFPSDrop;
                    this.el.playerSetCapLevelonFPSDrop(this._capLevelonFPSDrop);
                };
                FlasHLS.prototype.setSmoothAutoSwitchonFPSDrop = function setSmoothAutoSwitchonFPSDrop(smoothAutoSwitchonFPSDrop) {
                    this._smoothAutoSwitchonFPSDrop = smoothAutoSwitchonFPSDrop;
                    this.el.playerSetSmoothAutoSwitchonFPSDrop(this._smoothAutoSwitchonFPSDrop);
                };
                FlasHLS.prototype.setSwitchDownOnLevelError = function setSwitchDownOnLevelError(switchDownOnLevelError) {
                    this._switchDownOnLevelError = switchDownOnLevelError;
                    this.el.playerSetSwitchDownOnLevelError(this._switchDownOnLevelError);
                };
                FlasHLS.prototype.setSeekMode = function setSeekMode(seekMode) {
                    this._seekMode = seekMode;
                    this.el.playerSetSeekMode(this._seekMode);
                };
                FlasHLS.prototype.setKeyLoadMaxRetry = function setKeyLoadMaxRetry(keyLoadMaxRetry) {
                    this._keyLoadMaxRetry = keyLoadMaxRetry;
                    this.el.playerSetKeyLoadMaxRetry(this._keyLoadMaxRetry);
                };
                FlasHLS.prototype.setKeyLoadMaxRetryTimeout = function setKeyLoadMaxRetryTimeout(keyLoadMaxRetryTimeout) {
                    this._keyLoadMaxRetryTimeout = keyLoadMaxRetryTimeout;
                    this.el.playerSetKeyLoadMaxRetryTimeout(this._keyLoadMaxRetryTimeout);
                };
                FlasHLS.prototype.setFragmentLoadMaxRetry = function setFragmentLoadMaxRetry(fragmentLoadMaxRetry) {
                    this._fragmentLoadMaxRetry = fragmentLoadMaxRetry;
                    this.el.playerSetFragmentLoadMaxRetry(this._fragmentLoadMaxRetry);
                };
                FlasHLS.prototype.setFragmentLoadMaxRetryTimeout = function setFragmentLoadMaxRetryTimeout(fragmentLoadMaxRetryTimeout) {
                    this._fragmentLoadMaxRetryTimeout = fragmentLoadMaxRetryTimeout;
                    this.el.playerSetFragmentLoadMaxRetryTimeout(this._fragmentLoadMaxRetryTimeout);
                };
                FlasHLS.prototype.setFragmentLoadSkipAfterMaxRetry = function setFragmentLoadSkipAfterMaxRetry(fragmentLoadSkipAfterMaxRetry) {
                    this._fragmentLoadSkipAfterMaxRetry = fragmentLoadSkipAfterMaxRetry;
                    this.el.playerSetFragmentLoadSkipAfterMaxRetry(this._fragmentLoadSkipAfterMaxRetry);
                };
                FlasHLS.prototype.setMaxSkippedFragments = function setMaxSkippedFragments(maxSkippedFragments) {
                    this._maxSkippedFragments = maxSkippedFragments;
                    this.el.playerSetMaxSkippedFragments(this._maxSkippedFragments);
                };
                FlasHLS.prototype.setFlushLiveURLCache = function setFlushLiveURLCache(flushLiveURLCache) {
                    this._flushLiveURLCache = flushLiveURLCache;
                    this.el.playerSetFlushLiveURLCache(this._flushLiveURLCache);
                };
                FlasHLS.prototype.setInitialLiveManifestSize = function setInitialLiveManifestSize(initialLiveManifestSize) {
                    this._initialLiveManifestSize = initialLiveManifestSize;
                    this.el.playerSetInitialLiveManifestSize(this._initialLiveManifestSize);
                };
                FlasHLS.prototype.setManifestLoadMaxRetry = function setManifestLoadMaxRetry(manifestLoadMaxRetry) {
                    this._manifestLoadMaxRetry = manifestLoadMaxRetry;
                    this.el.playerSetManifestLoadMaxRetry(this._manifestLoadMaxRetry);
                };
                FlasHLS.prototype.setManifestLoadMaxRetryTimeout = function setManifestLoadMaxRetryTimeout(manifestLoadMaxRetryTimeout) {
                    this._manifestLoadMaxRetryTimeout = manifestLoadMaxRetryTimeout;
                    this.el.playerSetManifestLoadMaxRetryTimeout(this._manifestLoadMaxRetryTimeout);
                };
                FlasHLS.prototype.setManifestRedundantLoadmaxRetry = function setManifestRedundantLoadmaxRetry(manifestRedundantLoadmaxRetry) {
                    this._manifestRedundantLoadmaxRetry = manifestRedundantLoadmaxRetry;
                    this.el.playerSetManifestRedundantLoadmaxRetry(this._manifestRedundantLoadmaxRetry);
                };
                FlasHLS.prototype.setStartFromBitrate = function setStartFromBitrate(startFromBitrate) {
                    this._startFromBitrate = startFromBitrate;
                    this.el.playerSetStartFromBitrate(this._startFromBitrate);
                };
                FlasHLS.prototype.setStartFromLevel = function setStartFromLevel(startFromLevel) {
                    this._startFromLevel = startFromLevel;
                    this.el.playerSetStartFromLevel(this._startFromLevel);
                };
                FlasHLS.prototype.setAutoStartMaxDuration = function setAutoStartMaxDuration(autoStartMaxDuration) {
                    this._autoStartMaxDuration = autoStartMaxDuration;
                    this.el.playerSetAutoStartMaxDuration(this._autoStartMaxDuration);
                };
                FlasHLS.prototype.setSeekFromLevel = function setSeekFromLevel(seekFromLevel) {
                    this._seekFromLevel = seekFromLevel;
                    this.el.playerSetSeekFromLevel(this._seekFromLevel);
                };
                FlasHLS.prototype.setUseHardwareVideoDecoder = function setUseHardwareVideoDecoder(useHardwareVideoDecoder) {
                    this._useHardwareVideoDecoder = useHardwareVideoDecoder;
                    this.el.playerSetUseHardwareVideoDecoder(this._useHardwareVideoDecoder);
                };
                FlasHLS.prototype.setSetLogInfo = function setSetLogInfo(hlsLogEnabled) {
                    this._hlsLogEnabled = hlsLogEnabled;
                    this.el.playerSetLogInfo(this._hlsLogEnabled);
                };
                FlasHLS.prototype.setLogDebug = function setLogDebug(logDebug) {
                    this._logDebug = logDebug;
                    this.el.playerSetLogDebug(this._logDebug);
                };
                FlasHLS.prototype.setLogDebug2 = function setLogDebug2(logDebug2) {
                    this._logDebug2 = logDebug2;
                    this.el.playerSetLogDebug2(this._logDebug2);
                };
                FlasHLS.prototype.setLogWarn = function setLogWarn(logWarn) {
                    this._logWarn = logWarn;
                    this.el.playerSetLogWarn(this._logWarn);
                };
                FlasHLS.prototype.setLogError = function setLogError(logError) {
                    this._logError = logError;
                    this.el.playerSetLogError(this._logError);
                };
                FlasHLS.prototype._levelChanged = function _levelChanged(level) {
                    var currentLevel = this.el.getLevels()[level];
                    if (currentLevel) {
                        this.highDefinition = currentLevel.height >= 720 || currentLevel.bitrate / 1000 >= 2000;
                        this.trigger(_events2.default.PLAYBACK_HIGHDEFINITIONUPDATE, this.highDefinition);
                        if (!this._levels || this._levels.length === 0) this._fillLevels();
                        this.trigger(_events2.default.PLAYBACK_BITRATE, {
                            height: currentLevel.height,
                            width: currentLevel.width,
                            bandwidth: currentLevel.bitrate,
                            bitrate: currentLevel.bitrate,
                            level: level
                        });
                        this.trigger(_events2.default.PLAYBACK_LEVEL_SWITCH_END);
                    }
                };
                FlasHLS.prototype._updateTime = function _updateTime(timeMetrics) {
                    if (this._currentState === 'IDLE') return;
                    var duration = this._normalizeDuration(timeMetrics.duration);
                    var position = Math.min(Math.max(timeMetrics.position, 0), duration);
                    var previousDVRStatus = this._dvrEnabled;
                    var livePlayback = this._playbackType === _playback2.default.LIVE;
                    this._dvrEnabled = livePlayback && duration > this._hlsMinimumDvrSize;
                    if (duration === 100 || livePlayback === undefined) return;
                    if (this._dvrEnabled !== previousDVRStatus) {
                        this._updateSettings();
                        this.trigger(_events2.default.PLAYBACK_SETTINGSUPDATE, this.name);
                    }
                    if (livePlayback && !this._dvrEnabled) position = duration;
                    this.trigger(_events2.default.PLAYBACK_TIMEUPDATE, {
                        current: position,
                        total: duration
                    }, this.name);
                };
                FlasHLS.prototype.play = function play() {
                    this.trigger(_events2.default.PLAYBACK_PLAY_INTENT);
                    if (this._currentState === 'PAUSED') this.el.playerResume();
                    else if (!this._srcLoaded && this._currentState !== 'PLAYING') this._firstPlay();
                    else this.el.playerPlay();
                };
                FlasHLS.prototype.getPlaybackType = function getPlaybackType() {
                    return this._playbackType ? this._playbackType : null;
                };
                FlasHLS.prototype.getCurrentTime = function getCurrentTime() {
                    return this.el.getPosition();
                };
                FlasHLS.prototype.getCurrentLevelIndex = function getCurrentLevelIndex() {
                    return this._currentLevel;
                };
                FlasHLS.prototype.getCurrentLevel = function getCurrentLevel() {
                    return this.levels[this.currentLevel];
                };
                FlasHLS.prototype.getCurrentBitrate = function getCurrentBitrate() {
                    return this.levels[this.currentLevel].bitrate;
                };
                FlasHLS.prototype.setCurrentLevel = function setCurrentLevel(level) {
                    this.currentLevel = level;
                };
                FlasHLS.prototype.isHighDefinitionInUse = function isHighDefinitionInUse() {
                    return this.highDefinition;
                };
                FlasHLS.prototype.getLevels = function getLevels() {
                    return this.levels;
                };
                FlasHLS.prototype._setPlaybackState = function _setPlaybackState(state) {
                    if ([
                        'PLAYING_BUFFERING',
                        'PAUSED_BUFFERING'
                    ].indexOf(state) >= 0) {
                        this._bufferingState = true;
                        this.trigger(_events2.default.PLAYBACK_BUFFERING, this.name);
                        this._updateCurrentState(state);
                    } else if ([
                        'PLAYING',
                        'PAUSED'
                    ].indexOf(state) >= 0) {
                        if ([
                            'PLAYING_BUFFERING',
                            'PAUSED_BUFFERING',
                            'IDLE'
                        ].indexOf(this._currentState) >= 0) {
                            this._bufferingState = false;
                            this.trigger(_events2.default.PLAYBACK_BUFFERFULL, this.name);
                        }
                        this._updateCurrentState(state);
                    } else if (state === 'IDLE') {
                        this._srcLoaded = false;
                        if (this._loop && [
                            'PLAYING_BUFFERING',
                            'PLAYING'
                        ].indexOf(this._currentState) >= 0) {
                            this.play();
                            this.seek(0);
                        } else {
                            this._updateCurrentState(state);
                            this._hasEnded = true;
                            this.trigger(_events2.default.PLAYBACK_TIMEUPDATE, {
                                current: 0,
                                total: this.getDuration()
                            }, this.name);
                            this.trigger(_events2.default.PLAYBACK_ENDED, this.name);
                        }
                    }
                };
                FlasHLS.prototype._updateCurrentState = function _updateCurrentState(state) {
                    this._currentState = state;
                    if (state !== 'IDLE') this._hasEnded = false;
                    this._updatePlaybackType();
                    if (state === 'PLAYING') this.trigger(_events2.default.PLAYBACK_PLAY, this.name);
                    else if (state === 'PAUSED') this.trigger(_events2.default.PLAYBACK_PAUSE, this.name);
                };
                FlasHLS.prototype._updatePlaybackType = function _updatePlaybackType() {
                    this._playbackType = this.el.getType();
                    if (this._playbackType) {
                        this._playbackType = this._playbackType.toLowerCase();
                        if (this._playbackType === _playback2.default.VOD) this._startReportingProgress();
                        else this._stopReportingProgress();
                    }
                    this.trigger(_events2.default.PLAYBACK_PLAYBACKSTATE, {
                        type: this._playbackType
                    });
                };
                FlasHLS.prototype._startReportingProgress = function _startReportingProgress() {
                    if (!this._reportingProgress) this._reportingProgress = true;
                };
                FlasHLS.prototype._stopReportingProgress = function _stopReportingProgress() {
                    this._reportingProgress = false;
                };
                FlasHLS.prototype._onFragmentLoaded = function _onFragmentLoaded(loadmetrics) {
                    this.trigger(_events2.default.PLAYBACK_FRAGMENT_LOADED, loadmetrics);
                    if (this._reportingProgress && this.getCurrentTime()) {
                        var buffered = this.getCurrentTime() + this.el.getbufferLength();
                        this.trigger(_events2.default.PLAYBACK_PROGRESS, {
                            start: this.getCurrentTime(),
                            current: buffered,
                            total: this.el.getDuration()
                        });
                    }
                };
                FlasHLS.prototype._onLevelEndlist = function _onLevelEndlist() {
                    this._updatePlaybackType();
                };
                FlasHLS.prototype._firstPlay = function _firstPlay() {
                    var _this4 = this;
                    this._shouldPlayOnManifestLoaded = true;
                    if (this.el.playerLoad) {
                        _mediator2.default.once(this.cid + ':manifestloaded', function(duration, loadmetrics) {
                            return _this4._manifestLoaded(duration, loadmetrics);
                        });
                        this._setFlashSettings(); //ensure flushLiveURLCache will work (#327)
                        this.el.playerLoad(this._src);
                        this._srcLoaded = true;
                    }
                };
                FlasHLS.prototype.volume = function volume(value) {
                    var _this5 = this;
                    if (this.isReady) this.el.playerVolume(value);
                    else this.listenToOnce(this, _events2.default.PLAYBACK_BUFFERFULL, function() {
                        return _this5.volume(value);
                    });
                };
                FlasHLS.prototype.pause = function pause() {
                    if (this._playbackType !== _playback2.default.LIVE || this._dvrEnabled) {
                        this.el.playerPause();
                        if (this._playbackType === _playback2.default.LIVE && this._dvrEnabled) this._updateDvr(true);
                    }
                };
                FlasHLS.prototype.stop = function stop() {
                    this._srcLoaded = false;
                    this.el.playerStop();
                    this.trigger(_events2.default.PLAYBACK_STOP);
                    this.trigger(_events2.default.PLAYBACK_TIMEUPDATE, {
                        current: 0,
                        total: 0
                    }, this.name);
                };
                FlasHLS.prototype.isPlaying = function isPlaying() {
                    if (this._currentState) return !!this._currentState.match(/playing/i);
                    return false;
                };
                FlasHLS.prototype.getDuration = function getDuration() {
                    return this._normalizeDuration(this.el.getDuration());
                };
                FlasHLS.prototype._normalizeDuration = function _normalizeDuration(duration) {
                    if (this._playbackType === _playback2.default.LIVE) // estimate 10 seconds of buffer time for live streams for seek positions
                    duration = Math.max(0, duration - 10);
                    return duration;
                };
                FlasHLS.prototype.seekPercentage = function seekPercentage(percentage) {
                    var duration = this.el.getDuration();
                    var time = 0;
                    if (percentage > 0) time = duration * percentage / 100;
                    this.seek(time);
                };
                FlasHLS.prototype.seek = function seek(time) {
                    var duration = this.getDuration();
                    if (this._playbackType === _playback2.default.LIVE) {
                        // seek operations to a time within 3 seconds from live stream will position playhead back to live
                        var dvrInUse = duration - time > 3;
                        this._updateDvr(dvrInUse);
                    }
                    this.el.playerSeek(time);
                    this.trigger(_events2.default.PLAYBACK_TIMEUPDATE, {
                        current: time,
                        total: duration
                    }, this.name);
                };
                FlasHLS.prototype._updateDvr = function _updateDvr(dvrInUse) {
                    var previousDvrInUse = !!this._dvrInUse;
                    this._dvrInUse = dvrInUse;
                    if (this._dvrInUse !== previousDvrInUse) {
                        this._updateSettings();
                        this.trigger(_events2.default.PLAYBACK_DVR, this._dvrInUse);
                        this.trigger(_events2.default.PLAYBACK_STATS_ADD, {
                            'dvr': this._dvrInUse
                        });
                    }
                };
                FlasHLS.prototype._flashPlaybackError = function _flashPlaybackError(code, url, message) {
                    var error = {
                        code: code,
                        description: message,
                        level: _error2.default.Levels.FATAL,
                        raw: {
                            code: code,
                            url: url,
                            message: message
                        }
                    };
                    var formattedError = this.createError(error);
                    this.trigger(_events2.default.PLAYBACK_ERROR, formattedError);
                    this.trigger(_events2.default.PLAYBACK_STOP);
                };
                FlasHLS.prototype._manifestLoaded = function _manifestLoaded(duration, loadmetrics) {
                    if (this._shouldPlayOnManifestLoaded) {
                        this._shouldPlayOnManifestLoaded = false;
                        // this method initialises the player (and starts playback)
                        // this needs to happen before PLAYBACK_LOADEDMETADATA is fired
                        // as the user may call seek() in a LOADEDMETADATA listener.
                        /// when playerPlay() is called the player seeks to 0
                        this.el.playerPlay();
                    }
                    this._fillLevels();
                    this.trigger(_events2.default.PLAYBACK_LOADEDMETADATA, {
                        duration: duration,
                        data: loadmetrics
                    });
                };
                FlasHLS.prototype._fillLevels = function _fillLevels() {
                    var levels = this.el.getLevels();
                    var levelsLength = levels.length;
                    this._levels = [];
                    for(var index = 0; index < levelsLength; index++)this._levels.push({
                        id: index,
                        label: levels[index].height + 'p',
                        level: levels[index]
                    });
                    this.trigger(_events2.default.PLAYBACK_LEVELS_AVAILABLE, this._levels);
                };
                FlasHLS.prototype.destroy = function destroy() {
                    this.stopListening();
                    this.$el.remove();
                };
                FlasHLS.prototype._updateSettings = function _updateSettings() {
                    this.settings = _clapprZepto2.default.extend({}, this._defaultSettings);
                    if (this._playbackType === _playback2.default.VOD || this._dvrInUse) {
                        this.settings.left = [
                            'playpause',
                            'position',
                            'duration'
                        ];
                        this.settings.seekEnabled = true;
                    } else if (this._dvrEnabled) {
                        this.settings.left = [
                            'playpause'
                        ];
                        this.settings.seekEnabled = true;
                    } else this.settings.seekEnabled = false;
                };
                FlasHLS.prototype._createCallbacks = function _createCallbacks() {
                    var _this6 = this;
                    if (!window.Clappr) window.Clappr = {};
                    if (!window.Clappr.flashlsCallbacks) window.Clappr.flashlsCallbacks = {};
                    this.flashlsEvents = new _flashls_events2.default(this.cid);
                    window.Clappr.flashlsCallbacks[this.cid] = function(eventName, args) {
                        _this6.flashlsEvents[eventName].apply(_this6.flashlsEvents, args);
                    };
                };
                FlasHLS.prototype.render = function render() {
                    _BaseFlashPlayback.prototype.render.call(this);
                    this._createCallbacks();
                    return this;
                };
                (0, _createClass3.default)(FlasHLS, [
                    {
                        key: 'isReady',
                        get: function get() {
                            return this._isReadyState;
                        }
                    },
                    {
                        key: 'dvrEnabled',
                        get: function get() {
                            return !!this._dvrEnabled;
                        }
                    }
                ]);
                return FlasHLS;
            }(_base_flash_playback2.default);
            exports.default = FlasHLS;
            FlasHLS.canPlay = function(resource, mimeType) {
                var resourceParts = resource.split('?')[0].match(/.*\.(.*)$/) || [];
                return _browser2.default.hasFlash && (resourceParts.length > 1 && resourceParts[1].toLowerCase() === 'm3u8' || mimeType === 'application/x-mpegURL' || mimeType === 'application/vnd.apple.mpegurl');
            };
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/flashls/flashls_events.js": /*!*************************************************!*\
  !*** ./src/playbacks/flashls/flashls_events.js ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _mediator = __webpack_require__(/*! ../../components/mediator */ "./src/components/mediator.js");
            var _mediator2 = _interopRequireDefault(_mediator);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var HLSEvents = function() {
                function HLSEvents(instanceId) {
                    (0, _classCallCheck3.default)(this, HLSEvents);
                    this.instanceId = instanceId;
                }
                HLSEvents.prototype.ready = function ready() {
                    _mediator2.default.trigger(this.instanceId + ':flashready');
                };
                HLSEvents.prototype.videoSize = function videoSize(width, height) {
                    _mediator2.default.trigger(this.instanceId + ':videosizechanged', width, height);
                };
                HLSEvents.prototype.complete = function complete() {
                    _mediator2.default.trigger(this.instanceId + ':complete');
                };
                HLSEvents.prototype.error = function error(code, url, message) {
                    _mediator2.default.trigger(this.instanceId + ':error', code, url, message);
                };
                HLSEvents.prototype.manifest = function manifest(duration, loadmetrics) {
                    _mediator2.default.trigger(this.instanceId + ':manifestloaded', duration, loadmetrics);
                };
                HLSEvents.prototype.audioLevelLoaded = function audioLevelLoaded(loadmetrics) {
                    _mediator2.default.trigger(this.instanceId + ':audiolevelloaded', loadmetrics);
                };
                HLSEvents.prototype.levelLoaded = function levelLoaded(loadmetrics) {
                    _mediator2.default.trigger(this.instanceId + ':levelloaded', loadmetrics);
                };
                HLSEvents.prototype.levelEndlist = function levelEndlist(level) {
                    _mediator2.default.trigger(this.instanceId + ':levelendlist', level);
                };
                HLSEvents.prototype.fragmentLoaded = function fragmentLoaded(loadmetrics) {
                    _mediator2.default.trigger(this.instanceId + ':fragmentloaded', loadmetrics);
                };
                HLSEvents.prototype.fragmentPlaying = function fragmentPlaying(playmetrics) {
                    _mediator2.default.trigger(this.instanceId + ':fragmentplaying', playmetrics);
                };
                HLSEvents.prototype.position = function position(timemetrics) {
                    _mediator2.default.trigger(this.instanceId + ':timeupdate', timemetrics);
                };
                HLSEvents.prototype.state = function state(newState) {
                    _mediator2.default.trigger(this.instanceId + ':playbackstate', newState);
                };
                HLSEvents.prototype.seekState = function seekState(newState) {
                    _mediator2.default.trigger(this.instanceId + ':seekstate', newState);
                };
                HLSEvents.prototype.switch = function _switch(newLevel) {
                    _mediator2.default.trigger(this.instanceId + ':levelchanged', newLevel);
                };
                HLSEvents.prototype.audioTracksListChange = function audioTracksListChange(trackList) {
                    _mediator2.default.trigger(this.instanceId + ':audiotracklistchanged', trackList);
                };
                HLSEvents.prototype.audioTrackChange = function audioTrackChange(trackId) {
                    _mediator2.default.trigger(this.instanceId + ':audiotrackchanged', trackId);
                };
                return HLSEvents;
            }();
            exports.default = HLSEvents;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/flashls/index.js": /*!****************************************!*\
  !*** ./src/playbacks/flashls/index.js ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _flashls = __webpack_require__(/*! ./flashls */ "./src/playbacks/flashls/flashls.js");
            var _flashls2 = _interopRequireDefault(_flashls);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _flashls2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/flashls/public/HLSPlayer.swf": /*!****************************************************!*\
  !*** ./src/playbacks/flashls/public/HLSPlayer.swf ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<%=baseUrl%>/8fa12a459188502b9f0d39b8a67d9e6c.swf";
        /***/ },
        /***/ "./src/playbacks/hls/hls.js": /*!**********************************!*\
  !*** ./src/playbacks/hls/hls.js ***!
  \**********************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ "./node_modules/babel-runtime/helpers/toConsumableArray.js");
            var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
            var _stringify = __webpack_require__(/*! babel-runtime/core-js/json/stringify */ "./node_modules/babel-runtime/core-js/json/stringify.js");
            var _stringify2 = _interopRequireDefault(_stringify);
            var _extends2 = __webpack_require__(/*! babel-runtime/helpers/extends */ "./node_modules/babel-runtime/helpers/extends.js");
            var _extends3 = _interopRequireDefault(_extends2);
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _html5_video = __webpack_require__(/*! ../../playbacks/html5_video */ "./src/playbacks/html5_video/index.js");
            var _html5_video2 = _interopRequireDefault(_html5_video);
            var _hls = __webpack_require__(/*! hls.js */ "./node_modules/hls.js/dist/hls.js");
            var _hls2 = _interopRequireDefault(_hls);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
            var _playback2 = _interopRequireDefault(_playback);
            var _utils = __webpack_require__(/*! ../../base/utils */ "./src/base/utils.js");
            var _log = __webpack_require__(/*! ../../plugins/log */ "./src/plugins/log/index.js");
            var _log2 = _interopRequireDefault(_log);
            var _error = __webpack_require__(/*! ../../components/error */ "./src/components/error/index.js");
            var _error2 = _interopRequireDefault(_error);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var AUTO = -1; // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var HLS = function(_HTML5VideoPlayback) {
                (0, _inherits3.default)(HLS, _HTML5VideoPlayback);
                (0, _createClass3.default)(HLS, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'hls';
                        }
                    },
                    {
                        key: 'levels',
                        get: function get() {
                            return this._levels || [];
                        }
                    },
                    {
                        key: 'currentLevel',
                        get: function get() {
                            if (this._currentLevel === null || this._currentLevel === undefined) return AUTO;
                            else return this._currentLevel; //0 is a valid level ID
                        },
                        set: function set(id) {
                            this._currentLevel = id;
                            this.trigger(_events2.default.PLAYBACK_LEVEL_SWITCH_START);
                            if (this.options.playback.hlsUseNextLevel) this._hls.nextLevel = this._currentLevel;
                            else this._hls.currentLevel = this._currentLevel;
                        }
                    },
                    {
                        key: 'isReady',
                        get: function get() {
                            return this._isReadyState;
                        }
                    },
                    {
                        key: '_startTime',
                        get: function get() {
                            if (this._playbackType === _playback2.default.LIVE && this._playlistType !== 'EVENT') return this._extrapolatedStartTime;
                            return this._playableRegionStartTime;
                        }
                    },
                    {
                        key: '_now',
                        get: function get() {
                            return (0, _utils.now)();
                        }
                    },
                    {
                        key: '_extrapolatedStartTime',
                        get: function get() {
                            if (!this._localStartTimeCorrelation) return this._playableRegionStartTime;
                            var corr = this._localStartTimeCorrelation;
                            var timePassed = this._now - corr.local;
                            var extrapolatedWindowStartTime = (corr.remote + timePassed) / 1000;
                            // cap at the end of the extrapolated window duration
                            return Math.min(extrapolatedWindowStartTime, this._playableRegionStartTime + this._extrapolatedWindowDuration);
                        }
                    },
                    {
                        key: '_extrapolatedEndTime',
                        get: function get() {
                            var actualEndTime = this._playableRegionStartTime + this._playableRegionDuration;
                            if (!this._localEndTimeCorrelation) return actualEndTime;
                            var corr = this._localEndTimeCorrelation;
                            var timePassed = this._now - corr.local;
                            var extrapolatedEndTime = (corr.remote + timePassed) / 1000;
                            return Math.max(actualEndTime - this._extrapolatedWindowDuration, Math.min(extrapolatedEndTime, actualEndTime));
                        }
                    },
                    {
                        key: '_duration',
                        get: function get() {
                            return this._extrapolatedEndTime - this._startTime;
                        }
                    },
                    {
                        key: '_extrapolatedWindowDuration',
                        get: function get() {
                            if (this._segmentTargetDuration === null) return 0;
                            return this._extrapolatedWindowNumSegments * this._segmentTargetDuration;
                        }
                    }
                ], [
                    {
                        key: 'HLSJS',
                        get: function get() {
                            return _hls2.default;
                        }
                    }
                ]);
                function HLS() {
                    (0, _classCallCheck3.default)(this, HLS);
                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    // backwards compatibility (TODO: remove on 0.3.0)
                    var _this = (0, _possibleConstructorReturn3.default)(this, _HTML5VideoPlayback.call.apply(_HTML5VideoPlayback, [
                        this
                    ].concat(args)));
                    _this.options.playback = (0, _extends3.default)({}, _this.options, _this.options.playback);
                    _this._minDvrSize = typeof _this.options.hlsMinimumDvrSize === 'undefined' ? 60 : _this.options.hlsMinimumDvrSize;
                    // The size of the start time extrapolation window measured as a multiple of segments.
                    // Should be 2 or higher, or 0 to disable. Should only need to be increased above 2 if more than one segment is
                    // removed from the start of the playlist at a time. E.g if the playlist is cached for 10 seconds and new chunks are
                    // added/removed every 5.
                    _this._extrapolatedWindowNumSegments = !_this.options.playback || typeof _this.options.playback.extrapolatedWindowNumSegments === 'undefined' ? 2 : _this.options.playback.extrapolatedWindowNumSegments;
                    _this._playbackType = _playback2.default.VOD;
                    _this._lastTimeUpdate = {
                        current: 0,
                        total: 0
                    };
                    _this._lastDuration = null;
                    // for hls streams which have dvr with a sliding window,
                    // the content at the start of the playlist is removed as new
                    // content is appended at the end.
                    // this means the actual playable start time will increase as the
                    // start content is deleted
                    // For streams with dvr where the entire recording is kept from the
                    // beginning this should stay as 0
                    _this._playableRegionStartTime = 0;
                    // {local, remote} remote is the time in the video element that should represent 0
                    //                 local is the system time when the 'remote' measurment took place
                    _this._localStartTimeCorrelation = null;
                    // {local, remote} remote is the time in the video element that should represents the end
                    //                 local is the system time when the 'remote' measurment took place
                    _this._localEndTimeCorrelation = null;
                    // if content is removed from the beginning then this empty area should
                    // be ignored. "playableRegionDuration" excludes the empty area
                    _this._playableRegionDuration = 0;
                    // #EXT-X-PROGRAM-DATE-TIME
                    _this._programDateTime = 0;
                    // true when the actual duration is longer than hlsjs's live sync point
                    // when this is false playableRegionDuration will be the actual duration
                    // when this is true playableRegionDuration will exclude the time after the sync point
                    _this._durationExcludesAfterLiveSyncPoint = false;
                    // #EXT-X-TARGETDURATION
                    _this._segmentTargetDuration = null;
                    // #EXT-X-PLAYLIST-TYPE
                    _this._playlistType = null;
                    _this._recoverAttemptsRemaining = _this.options.hlsRecoverAttempts || 16;
                    return _this;
                }
                HLS.prototype._setup = function _setup() {
                    var _this2 = this;
                    this._ccIsSetup = false;
                    this._ccTracksUpdated = false;
                    this._hls = new _hls2.default((0, _utils.assign)({}, this.options.playback.hlsjsConfig));
                    this._hls.on(_hls2.default.Events.MEDIA_ATTACHED, function() {
                        return _this2._hls.loadSource(_this2.options.src);
                    });
                    this._hls.on(_hls2.default.Events.LEVEL_LOADED, function(evt, data) {
                        return _this2._updatePlaybackType(evt, data);
                    });
                    this._hls.on(_hls2.default.Events.LEVEL_UPDATED, function(evt, data) {
                        return _this2._onLevelUpdated(evt, data);
                    });
                    this._hls.on(_hls2.default.Events.LEVEL_SWITCHING, function(evt, data) {
                        return _this2._onLevelSwitch(evt, data);
                    });
                    this._hls.on(_hls2.default.Events.FRAG_LOADED, function(evt, data) {
                        return _this2._onFragmentLoaded(evt, data);
                    });
                    this._hls.on(_hls2.default.Events.ERROR, function(evt, data) {
                        return _this2._onHLSJSError(evt, data);
                    });
                    this._hls.on(_hls2.default.Events.SUBTITLE_TRACK_LOADED, function(evt, data) {
                        return _this2._onSubtitleLoaded(evt, data);
                    });
                    this._hls.on(_hls2.default.Events.SUBTITLE_TRACKS_UPDATED, function() {
                        return _this2._ccTracksUpdated = true;
                    });
                    this._hls.attachMedia(this.el);
                };
                HLS.prototype.render = function render() {
                    this._ready();
                    return _HTML5VideoPlayback.prototype.render.call(this);
                };
                HLS.prototype._ready = function _ready() {
                    this._isReadyState = true;
                    this.trigger(_events2.default.PLAYBACK_READY, this.name);
                };
                HLS.prototype._recover = function _recover(evt, data, error) {
                    if (!this._recoveredDecodingError) {
                        this._recoveredDecodingError = true;
                        this._hls.recoverMediaError();
                    } else if (!this._recoveredAudioCodecError) {
                        this._recoveredAudioCodecError = true;
                        this._hls.swapAudioCodec();
                        this._hls.recoverMediaError();
                    } else {
                        _log2.default.error('hlsjs: failed to recover', {
                            evt: evt,
                            data: data
                        });
                        error.level = _error2.default.Levels.FATAL;
                        var formattedError = this.createError(error);
                        this.trigger(_events2.default.PLAYBACK_ERROR, formattedError);
                        this.stop();
                    }
                };
                // override
                HLS.prototype._setupSrc = function _setupSrc(srcUrl) {
                // this playback manages the src on the video element itself
                };
                HLS.prototype._startTimeUpdateTimer = function _startTimeUpdateTimer() {
                    var _this3 = this;
                    if (this._timeUpdateTimer) return;
                    this._timeUpdateTimer = setInterval(function() {
                        _this3._onDurationChange();
                        _this3._onTimeUpdate();
                    }, 100);
                };
                HLS.prototype._stopTimeUpdateTimer = function _stopTimeUpdateTimer() {
                    if (!this._timeUpdateTimer) return;
                    clearInterval(this._timeUpdateTimer);
                    this._timeUpdateTimer = null;
                };
                HLS.prototype.getProgramDateTime = function getProgramDateTime() {
                    return this._programDateTime;
                };
                // the duration on the video element itself should not be used
                // as this does not necesarily represent the duration of the stream
                // https://github.com/clappr/clappr/issues/668#issuecomment-157036678
                HLS.prototype.getDuration = function getDuration() {
                    return this._duration;
                };
                HLS.prototype.getCurrentTime = function getCurrentTime() {
                    // e.g. can be < 0 if user pauses near the start
                    // eventually they will then be kicked to the end by hlsjs if they run out of buffer
                    // before the official start time
                    return Math.max(0, this.el.currentTime - this._startTime);
                };
                // the time that "0" now represents relative to when playback started
                // for a stream with a sliding window this will increase as content is
                // removed from the beginning
                HLS.prototype.getStartTimeOffset = function getStartTimeOffset() {
                    return this._startTime;
                };
                HLS.prototype.seekPercentage = function seekPercentage(percentage) {
                    var seekTo = this._duration;
                    if (percentage > 0) seekTo = this._duration * (percentage / 100);
                    this.seek(seekTo);
                };
                HLS.prototype.seek = function seek(time) {
                    if (time < 0) {
                        _log2.default.warn('Attempt to seek to a negative time. Resetting to live point. Use seekToLivePoint() to seek to the live point.');
                        time = this.getDuration();
                    }
                    // assume live if time within 3 seconds of end of stream
                    this.dvrEnabled && this._updateDvr(time < this.getDuration() - 3);
                    time += this._startTime;
                    _HTML5VideoPlayback.prototype.seek.call(this, time);
                };
                HLS.prototype.seekToLivePoint = function seekToLivePoint() {
                    this.seek(this.getDuration());
                };
                HLS.prototype._updateDvr = function _updateDvr(status) {
                    this.trigger(_events2.default.PLAYBACK_DVR, status);
                    this.trigger(_events2.default.PLAYBACK_STATS_ADD, {
                        'dvr': status
                    });
                };
                HLS.prototype._updateSettings = function _updateSettings() {
                    if (this._playbackType === _playback2.default.VOD) this.settings.left = [
                        'playpause',
                        'position',
                        'duration'
                    ];
                    else if (this.dvrEnabled) this.settings.left = [
                        'playpause'
                    ];
                    else this.settings.left = [
                        'playstop'
                    ];
                    this.settings.seekEnabled = this.isSeekEnabled();
                    this.trigger(_events2.default.PLAYBACK_SETTINGSUPDATE);
                };
                HLS.prototype._onHLSJSError = function _onHLSJSError(evt, data) {
                    var error = {
                        code: data.type + '_' + data.details,
                        description: this.name + ' error: type: ' + data.type + ', details: ' + data.details,
                        raw: data
                    };
                    var formattedError = void 0;
                    if (data.response) error.description += ', response: ' + (0, _stringify2.default)(data.response);
                    // only report/handle errors if they are fatal
                    // hlsjs should automatically handle non fatal errors
                    if (data.fatal) {
                        if (this._recoverAttemptsRemaining > 0) {
                            this._recoverAttemptsRemaining -= 1;
                            switch(data.type){
                                case _hls2.default.ErrorTypes.NETWORK_ERROR:
                                    switch(data.details){
                                        // The following network errors cannot be recovered with HLS.startLoad()
                                        // For more details, see https://github.com/video-dev/hls.js/blob/master/doc/design.md#error-detection-and-handling
                                        // For "level load" fatal errors, see https://github.com/video-dev/hls.js/issues/1138
                                        case _hls2.default.ErrorDetails.MANIFEST_LOAD_ERROR:
                                        case _hls2.default.ErrorDetails.MANIFEST_LOAD_TIMEOUT:
                                        case _hls2.default.ErrorDetails.MANIFEST_PARSING_ERROR:
                                        case _hls2.default.ErrorDetails.LEVEL_LOAD_ERROR:
                                        case _hls2.default.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                                            _log2.default.error('hlsjs: unrecoverable network fatal error.', {
                                                evt: evt,
                                                data: data
                                            });
                                            formattedError = this.createError(error);
                                            this.trigger(_events2.default.PLAYBACK_ERROR, formattedError);
                                            this.stop();
                                            break;
                                        default:
                                            _log2.default.warn('hlsjs: trying to recover from network error.', {
                                                evt: evt,
                                                data: data
                                            });
                                            error.level = _error2.default.Levels.WARN;
                                            this.createError(error);
                                            this._hls.startLoad();
                                            break;
                                    }
                                    break;
                                case _hls2.default.ErrorTypes.MEDIA_ERROR:
                                    _log2.default.warn('hlsjs: trying to recover from media error.', {
                                        evt: evt,
                                        data: data
                                    });
                                    error.level = _error2.default.Levels.WARN;
                                    this.createError(error);
                                    this._recover(evt, data, error);
                                    break;
                                default:
                                    _log2.default.error('hlsjs: could not recover from error.', {
                                        evt: evt,
                                        data: data
                                    });
                                    formattedError = this.createError(error);
                                    this.trigger(_events2.default.PLAYBACK_ERROR, formattedError);
                                    this.stop();
                                    break;
                            }
                        } else {
                            _log2.default.error('hlsjs: could not recover from error after maximum number of attempts.', {
                                evt: evt,
                                data: data
                            });
                            formattedError = this.createError(error);
                            this.trigger(_events2.default.PLAYBACK_ERROR, formattedError);
                            this.stop();
                        }
                    } else {
                        // Transforms HLSJS.ErrorDetails.KEY_LOAD_ERROR non-fatal error to
                        // playback fatal error if triggerFatalErrorOnResourceDenied playback
                        // option is set. HLSJS.ErrorTypes.KEY_SYSTEM_ERROR are fatal errors
                        // and therefore already handled.
                        if (this.options.playback.triggerFatalErrorOnResourceDenied && this._keyIsDenied(data)) {
                            _log2.default.error('hlsjs: could not load decrypt key.', {
                                evt: evt,
                                data: data
                            });
                            formattedError = this.createError(error);
                            this.trigger(_events2.default.PLAYBACK_ERROR, formattedError);
                            this.stop();
                            return;
                        }
                        error.level = _error2.default.Levels.WARN;
                        this.createError(error);
                        _log2.default.warn('hlsjs: non-fatal error occurred', {
                            evt: evt,
                            data: data
                        });
                    }
                };
                HLS.prototype._keyIsDenied = function _keyIsDenied(data) {
                    return data.type === _hls2.default.ErrorTypes.NETWORK_ERROR && data.details === _hls2.default.ErrorDetails.KEY_LOAD_ERROR && data.response && data.response.code >= 400;
                };
                HLS.prototype._onTimeUpdate = function _onTimeUpdate() {
                    var update = {
                        current: this.getCurrentTime(),
                        total: this.getDuration(),
                        firstFragDateTime: this.getProgramDateTime()
                    };
                    var isSame = this._lastTimeUpdate && update.current === this._lastTimeUpdate.current && update.total === this._lastTimeUpdate.total;
                    if (isSame) return;
                    this._lastTimeUpdate = update;
                    this.trigger(_events2.default.PLAYBACK_TIMEUPDATE, update, this.name);
                };
                HLS.prototype._onDurationChange = function _onDurationChange() {
                    var duration = this.getDuration();
                    if (this._lastDuration === duration) return;
                    this._lastDuration = duration;
                    _HTML5VideoPlayback.prototype._onDurationChange.call(this);
                };
                HLS.prototype._onProgress = function _onProgress() {
                    if (!this.el.buffered.length) return;
                    var buffered = [];
                    var bufferedPos = 0;
                    for(var i = 0; i < this.el.buffered.length; i++){
                        buffered = [].concat((0, _toConsumableArray3.default)(buffered), [
                            {
                                // for a stream with sliding window dvr something that is buffered my slide off the start of the timeline
                                start: Math.max(0, this.el.buffered.start(i) - this._playableRegionStartTime),
                                end: Math.max(0, this.el.buffered.end(i) - this._playableRegionStartTime)
                            }
                        ]);
                        if (this.el.currentTime >= buffered[i].start && this.el.currentTime <= buffered[i].end) bufferedPos = i;
                    }
                    var progress = {
                        start: buffered[bufferedPos].start,
                        current: buffered[bufferedPos].end,
                        total: this.getDuration()
                    };
                    this.trigger(_events2.default.PLAYBACK_PROGRESS, progress, buffered);
                };
                HLS.prototype.play = function play() {
                    if (!this._hls) this._setup();
                    _HTML5VideoPlayback.prototype.play.call(this);
                    this._startTimeUpdateTimer();
                };
                HLS.prototype.pause = function pause() {
                    if (!this._hls) return;
                    _HTML5VideoPlayback.prototype.pause.call(this);
                    if (this.dvrEnabled) this._updateDvr(true);
                };
                HLS.prototype.stop = function stop() {
                    this._stopTimeUpdateTimer();
                    if (this._hls) {
                        _HTML5VideoPlayback.prototype.stop.call(this);
                        this._hls.destroy();
                        delete this._hls;
                    }
                };
                HLS.prototype.destroy = function destroy() {
                    this._stopTimeUpdateTimer();
                    if (this._hls) {
                        this._hls.destroy();
                        delete this._hls;
                    }
                    _HTML5VideoPlayback.prototype.destroy.call(this);
                };
                HLS.prototype._updatePlaybackType = function _updatePlaybackType(evt, data) {
                    this._playbackType = data.details.live ? _playback2.default.LIVE : _playback2.default.VOD;
                    this._onLevelUpdated(evt, data);
                    // Live stream subtitle tracks detection hack (may not immediately available)
                    if (this._ccTracksUpdated && this._playbackType === _playback2.default.LIVE && this.hasClosedCaptionsTracks) this._onSubtitleLoaded();
                };
                HLS.prototype._fillLevels = function _fillLevels() {
                    this._levels = this._hls.levels.map(function(level, index) {
                        return {
                            id: index,
                            level: level,
                            label: level.bitrate / 1000 + 'Kbps'
                        };
                    });
                    this.trigger(_events2.default.PLAYBACK_LEVELS_AVAILABLE, this._levels);
                };
                HLS.prototype._onLevelUpdated = function _onLevelUpdated(evt, data) {
                    this._segmentTargetDuration = data.details.targetduration;
                    this._playlistType = data.details.type || null;
                    var startTimeChanged = false;
                    var durationChanged = false;
                    var fragments = data.details.fragments;
                    var previousPlayableRegionStartTime = this._playableRegionStartTime;
                    var previousPlayableRegionDuration = this._playableRegionDuration;
                    if (fragments.length === 0) return;
                    // #EXT-X-PROGRAM-DATE-TIME
                    if (fragments[0].rawProgramDateTime) this._programDateTime = fragments[0].rawProgramDateTime;
                    if (this._playableRegionStartTime !== fragments[0].start) {
                        startTimeChanged = true;
                        this._playableRegionStartTime = fragments[0].start;
                    }
                    if (startTimeChanged) {
                        if (!this._localStartTimeCorrelation) // set the correlation to map to middle of the extrapolation window
                        this._localStartTimeCorrelation = {
                            local: this._now,
                            remote: (fragments[0].start + this._extrapolatedWindowDuration / 2) * 1000
                        };
                        else {
                            // check if the correlation still works
                            var corr = this._localStartTimeCorrelation;
                            var timePassed = this._now - corr.local;
                            // this should point to a time within the extrapolation window
                            var startTime = (corr.remote + timePassed) / 1000;
                            if (startTime < fragments[0].start) // our start time is now earlier than the first chunk
                            // (maybe the chunk was removed early)
                            // reset correlation so that it sits at the beginning of the first available chunk
                            this._localStartTimeCorrelation = {
                                local: this._now,
                                remote: fragments[0].start * 1000
                            };
                            else if (startTime > previousPlayableRegionStartTime + this._extrapolatedWindowDuration) // start time was past the end of the old extrapolation window (so would have been capped)
                            // see if now that time would be inside the window, and if it would be set the correlation
                            // so that it resumes from the time it was at at the end of the old window
                            // update the correlation so that the time starts counting again from the value it's on now
                            this._localStartTimeCorrelation = {
                                local: this._now,
                                remote: Math.max(fragments[0].start, previousPlayableRegionStartTime + this._extrapolatedWindowDuration) * 1000
                            };
                        }
                    }
                    var newDuration = data.details.totalduration;
                    // if it's a live stream then shorten the duration to remove access
                    // to the area after hlsjs's live sync point
                    // seeks to areas after this point sometimes have issues
                    if (this._playbackType === _playback2.default.LIVE) {
                        var fragmentTargetDuration = data.details.targetduration;
                        var hlsjsConfig = this.options.playback.hlsjsConfig || {};
                        var liveSyncDurationCount = hlsjsConfig.liveSyncDurationCount || _hls2.default.DefaultConfig.liveSyncDurationCount;
                        var hiddenAreaDuration = fragmentTargetDuration * liveSyncDurationCount;
                        if (hiddenAreaDuration <= newDuration) {
                            newDuration -= hiddenAreaDuration;
                            this._durationExcludesAfterLiveSyncPoint = true;
                        } else this._durationExcludesAfterLiveSyncPoint = false;
                    }
                    if (newDuration !== this._playableRegionDuration) {
                        durationChanged = true;
                        this._playableRegionDuration = newDuration;
                    }
                    // Note the end time is not the playableRegionDuration
                    // The end time will always increase even if content is removed from the beginning
                    var endTime = fragments[0].start + newDuration;
                    var previousEndTime = previousPlayableRegionStartTime + previousPlayableRegionDuration;
                    var endTimeChanged = endTime !== previousEndTime;
                    if (endTimeChanged) {
                        if (!this._localEndTimeCorrelation) // set the correlation to map to the end
                        this._localEndTimeCorrelation = {
                            local: this._now,
                            remote: endTime * 1000
                        };
                        else {
                            // check if the correlation still works
                            var _corr = this._localEndTimeCorrelation;
                            var _timePassed = this._now - _corr.local;
                            // this should point to a time within the extrapolation window from the end
                            var extrapolatedEndTime = (_corr.remote + _timePassed) / 1000;
                            if (extrapolatedEndTime > endTime) this._localEndTimeCorrelation = {
                                local: this._now,
                                remote: endTime * 1000
                            };
                            else if (extrapolatedEndTime < endTime - this._extrapolatedWindowDuration) // our extrapolated end time is now earlier than the extrapolation window from the actual end time
                            // (maybe a chunk became available early)
                            // reset correlation so that it sits at the beginning of the extrapolation window from the end time
                            this._localEndTimeCorrelation = {
                                local: this._now,
                                remote: (endTime - this._extrapolatedWindowDuration) * 1000
                            };
                            else if (extrapolatedEndTime > previousEndTime) // end time was past the old end time (so would have been capped)
                            // set the correlation so that it resumes from the time it was at at the end of the old window
                            this._localEndTimeCorrelation = {
                                local: this._now,
                                remote: previousEndTime * 1000
                            };
                        }
                    }
                    // now that the values have been updated call any methods that use on them so they get the updated values
                    // immediately
                    durationChanged && this._onDurationChange();
                    startTimeChanged && this._onProgress();
                };
                HLS.prototype._onFragmentLoaded = function _onFragmentLoaded(evt, data) {
                    this.trigger(_events2.default.PLAYBACK_FRAGMENT_LOADED, data);
                };
                HLS.prototype._onSubtitleLoaded = function _onSubtitleLoaded() {
                    // This event may be triggered multiple times
                    // Setup CC only once (disable CC by default)
                    if (!this._ccIsSetup) {
                        this.trigger(_events2.default.PLAYBACK_SUBTITLE_AVAILABLE);
                        var trackId = this._playbackType === _playback2.default.LIVE ? -1 : this.closedCaptionsTrackId;
                        this.closedCaptionsTrackId = trackId;
                        this._ccIsSetup = true;
                    }
                };
                HLS.prototype._onLevelSwitch = function _onLevelSwitch(evt, data) {
                    if (!this.levels.length) this._fillLevels();
                    this.trigger(_events2.default.PLAYBACK_LEVEL_SWITCH_END);
                    this.trigger(_events2.default.PLAYBACK_LEVEL_SWITCH, data);
                    var currentLevel = this._hls.levels[data.level];
                    if (currentLevel) {
                        // TODO should highDefinition be private and maybe have a read only accessor if it's used somewhere
                        this.highDefinition = currentLevel.height >= 720 || currentLevel.bitrate / 1000 >= 2000;
                        this.trigger(_events2.default.PLAYBACK_HIGHDEFINITIONUPDATE, this.highDefinition);
                        this.trigger(_events2.default.PLAYBACK_BITRATE, {
                            height: currentLevel.height,
                            width: currentLevel.width,
                            bandwidth: currentLevel.bitrate,
                            bitrate: currentLevel.bitrate,
                            level: data.level
                        });
                    }
                };
                HLS.prototype.getPlaybackType = function getPlaybackType() {
                    return this._playbackType;
                };
                HLS.prototype.isSeekEnabled = function isSeekEnabled() {
                    return this._playbackType === _playback2.default.VOD || this.dvrEnabled;
                };
                (0, _createClass3.default)(HLS, [
                    {
                        key: 'dvrEnabled',
                        get: function get() {
                            // enabled when:
                            // - the duration does not include content after hlsjs's live sync point
                            // - the playable region duration is longer than the configured duration to enable dvr after
                            // - the playback type is LIVE.
                            return this._durationExcludesAfterLiveSyncPoint && this._duration >= this._minDvrSize && this.getPlaybackType() === _playback2.default.LIVE;
                        }
                    }
                ]);
                return HLS;
            }(_html5_video2.default);
            exports.default = HLS;
            HLS.canPlay = function(resource, mimeType) {
                var resourceParts = resource.split('?')[0].match(/.*\.(.*)$/) || [];
                var isHls = resourceParts.length > 1 && resourceParts[1].toLowerCase() === 'm3u8' || (0, _utils.listContainsIgnoreCase)(mimeType, [
                    'application/vnd.apple.mpegurl',
                    'application/x-mpegURL'
                ]);
                return !!(_hls2.default.isSupported() && isHls);
            };
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/hls/index.js": /*!************************************!*\
  !*** ./src/playbacks/hls/index.js ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _hls = __webpack_require__(/*! ./hls */ "./src/playbacks/hls/hls.js");
            var _hls2 = _interopRequireDefault(_hls);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _hls2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/html5_audio/html5_audio.js": /*!**************************************************!*\
  !*** ./src/playbacks/html5_audio/html5_audio.js ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
            var _playback2 = _interopRequireDefault(_playback);
            var _html5_video = __webpack_require__(/*! ../../playbacks/html5_video */ "./src/playbacks/html5_video/index.js");
            var _html5_video2 = _interopRequireDefault(_html5_video);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            // TODO: remove this playback and change HTML5Video to HTML5Playback (breaking change, only after 0.3.0)
            var HTML5Audio = function(_HTML5Video) {
                (0, _inherits3.default)(HTML5Audio, _HTML5Video);
                function HTML5Audio() {
                    (0, _classCallCheck3.default)(this, HTML5Audio);
                    return (0, _possibleConstructorReturn3.default)(this, _HTML5Video.apply(this, arguments));
                }
                HTML5Audio.prototype.updateSettings = function updateSettings() {
                    this.settings.left = [
                        'playpause',
                        'position',
                        'duration'
                    ];
                    this.settings.seekEnabled = this.isSeekEnabled();
                    this.trigger(_events2.default.PLAYBACK_SETTINGSUPDATE);
                };
                HTML5Audio.prototype.getPlaybackType = function getPlaybackType() {
                    return _playback2.default.AOD;
                };
                (0, _createClass3.default)(HTML5Audio, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'html5_audio';
                        }
                    },
                    {
                        key: 'tagName',
                        get: function get() {
                            return 'audio';
                        }
                    },
                    {
                        key: 'isAudioOnly',
                        get: function get() {
                            return true;
                        }
                    }
                ]);
                return HTML5Audio;
            }(_html5_video2.default); // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            exports.default = HTML5Audio;
            HTML5Audio.canPlay = function(resourceUrl, mimeType) {
                var mimetypes = {
                    'wav': [
                        'audio/wav'
                    ],
                    'mp3': [
                        'audio/mp3',
                        'audio/mpeg;codecs="mp3"'
                    ],
                    'aac': [
                        'audio/mp4;codecs="mp4a.40.5"'
                    ],
                    'oga': [
                        'audio/ogg'
                    ]
                };
                return _html5_video2.default._canPlay('audio', mimetypes, resourceUrl, mimeType);
            };
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/html5_audio/index.js": /*!********************************************!*\
  !*** ./src/playbacks/html5_audio/index.js ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _html5_audio = __webpack_require__(/*! ./html5_audio */ "./src/playbacks/html5_audio/html5_audio.js");
            var _html5_audio2 = _interopRequireDefault(_html5_audio);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _html5_audio2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/html5_video/html5_video.js": /*!**************************************************!*\
  !*** ./src/playbacks/html5_video/html5_video.js ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(process) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _from = __webpack_require__(/*! babel-runtime/core-js/array/from */ "./node_modules/babel-runtime/core-js/array/from.js");
                var _from2 = _interopRequireDefault(_from);
                var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
                var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
                var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
                var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
                var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
                var _createClass3 = _interopRequireDefault(_createClass2);
                var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
                var _inherits3 = _interopRequireDefault(_inherits2);
                var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ "./node_modules/babel-runtime/helpers/toConsumableArray.js");
                var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
                var _keys = __webpack_require__(/*! babel-runtime/core-js/object/keys */ "./node_modules/babel-runtime/core-js/object/keys.js");
                var _keys2 = _interopRequireDefault(_keys);
                var _utils = __webpack_require__(/*! ../../base/utils */ "./src/base/utils.js");
                var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
                var _playback2 = _interopRequireDefault(_playback);
                var _browser = __webpack_require__(/*! ../../components/browser */ "./src/components/browser/index.js");
                var _browser2 = _interopRequireDefault(_browser);
                var _error = __webpack_require__(/*! ../../components/error */ "./src/components/error/index.js");
                var _error2 = _interopRequireDefault(_error);
                var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
                var _events2 = _interopRequireDefault(_events);
                var _log = __webpack_require__(/*! ../../plugins/log */ "./src/plugins/log/index.js");
                var _log2 = _interopRequireDefault(_log);
                var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
                var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
                var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
                var _template2 = _interopRequireDefault(_template);
                var _tracks = __webpack_require__(/*! ./public/tracks.html */ "./src/playbacks/html5_video/public/tracks.html");
                var _tracks2 = _interopRequireDefault(_tracks);
                __webpack_require__(/*! ./public/style.scss */ "./src/playbacks/html5_video/public/style.scss");
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                // Copyright 2014 Globo.com Player authors. All rights reserved.
                // Use of this source code is governed by a BSD-style
                // license that can be found in the LICENSE file.
                var MIMETYPES = {
                    'mp4': [
                        'avc1.42E01E',
                        'avc1.58A01E',
                        'avc1.4D401E',
                        'avc1.64001E',
                        'mp4v.20.8',
                        'mp4v.20.240',
                        'mp4a.40.2'
                    ].map(function(codec) {
                        return 'video/mp4; codecs="' + codec + ', mp4a.40.2"';
                    }),
                    'ogg': [
                        'video/ogg; codecs="theora, vorbis"',
                        'video/ogg; codecs="dirac"',
                        'video/ogg; codecs="theora, speex"'
                    ],
                    '3gpp': [
                        'video/3gpp; codecs="mp4v.20.8, samr"'
                    ],
                    'webm': [
                        'video/webm; codecs="vp8, vorbis"'
                    ],
                    'mkv': [
                        'video/x-matroska; codecs="theora, vorbis"'
                    ],
                    'm3u8': [
                        'application/x-mpegurl'
                    ]
                };
                MIMETYPES['ogv'] = MIMETYPES['ogg'];
                MIMETYPES['3gp'] = MIMETYPES['3gpp'];
                var AUDIO_MIMETYPES = {
                    'wav': [
                        'audio/wav'
                    ],
                    'mp3': [
                        'audio/mp3',
                        'audio/mpeg;codecs="mp3"'
                    ],
                    'aac': [
                        'audio/mp4;codecs="mp4a.40.5"'
                    ],
                    'oga': [
                        'audio/ogg'
                    ]
                };
                var KNOWN_AUDIO_MIMETYPES = (0, _keys2.default)(AUDIO_MIMETYPES).reduce(function(acc, k) {
                    return [].concat((0, _toConsumableArray3.default)(acc), (0, _toConsumableArray3.default)(AUDIO_MIMETYPES[k]));
                }, []);
                var UNKNOWN_ERROR = {
                    code: 'unknown',
                    message: 'unknown'
                };
                var HTML5Video = function(_Playback) {
                    (0, _inherits3.default)(HTML5Video, _Playback);
                    (0, _createClass3.default)(HTML5Video, [
                        {
                            key: 'name',
                            get: function get() {
                                return 'html5_video';
                            }
                        },
                        {
                            key: 'tagName',
                            get: function get() {
                                return this.isAudioOnly ? 'audio' : 'video';
                            }
                        },
                        {
                            key: 'isAudioOnly',
                            get: function get() {
                                var resourceUrl = this.options.src;
                                var mimeTypes = HTML5Video._mimeTypesForUrl(resourceUrl, AUDIO_MIMETYPES, this.options.mimeType);
                                return this.options.playback && this.options.playback.audioOnly || this.options.audioOnly || KNOWN_AUDIO_MIMETYPES.indexOf(mimeTypes[0]) >= 0;
                            }
                        },
                        {
                            key: 'attributes',
                            get: function get() {
                                return {
                                    'data-html5-video': ''
                                };
                            }
                        },
                        {
                            key: 'events',
                            get: function get() {
                                return {
                                    'canplay': '_onCanPlay',
                                    'canplaythrough': '_handleBufferingEvents',
                                    'durationchange': '_onDurationChange',
                                    'ended': '_onEnded',
                                    'error': '_onError',
                                    'loadeddata': '_onLoadedData',
                                    'loadedmetadata': '_onLoadedMetadata',
                                    'pause': '_onPause',
                                    'playing': '_onPlaying',
                                    'progress': '_onProgress',
                                    'seeking': '_onSeeking',
                                    'seeked': '_onSeeked',
                                    'stalled': '_handleBufferingEvents',
                                    'timeupdate': '_onTimeUpdate',
                                    'waiting': '_onWaiting'
                                };
                            }
                        },
                        {
                            key: 'ended',
                            get: function get() {
                                return this.el.ended;
                            }
                        },
                        {
                            key: 'buffering',
                            get: function get() {
                                return this._isBuffering;
                            }
                        }
                    ]);
                    function HTML5Video() {
                        (0, _classCallCheck3.default)(this, HTML5Video);
                        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        var _this = (0, _possibleConstructorReturn3.default)(this, _Playback.call.apply(_Playback, [
                            this
                        ].concat(args)));
                        _this._destroyed = false;
                        _this._loadStarted = false;
                        _this._isBuffering = false;
                        _this._playheadMoving = false;
                        _this._playheadMovingTimer = null;
                        _this._stopped = false;
                        _this._ccTrackId = -1;
                        _this._setupSrc(_this.options.src);
                        // backwards compatibility (TODO: remove on 0.3.0)
                        _this.options.playback || (_this.options.playback = _this.options || {});
                        _this.options.playback.disableContextMenu = _this.options.playback.disableContextMenu || _this.options.disableVideoTagContextMenu;
                        var playbackConfig = _this.options.playback;
                        var preload = playbackConfig.preload || (_browser2.default.isSafari ? 'auto' : _this.options.preload);
                        var posterUrl = void 0; // FIXME: poster plugin should always convert poster to object with expected properties ?
                        if (_this.options.poster) {
                            if (typeof _this.options.poster === 'string') posterUrl = _this.options.poster;
                            else if (typeof _this.options.poster.url === 'string') posterUrl = _this.options.poster.url;
                        }
                        _clapprZepto2.default.extend(_this.el, {
                            muted: _this.options.mute,
                            defaultMuted: _this.options.mute,
                            loop: _this.options.loop,
                            poster: posterUrl,
                            preload: preload || 'metadata',
                            controls: (playbackConfig.controls || _this.options.useVideoTagDefaultControls) && 'controls',
                            crossOrigin: playbackConfig.crossOrigin,
                            'x-webkit-playsinline': playbackConfig.playInline
                        });
                        playbackConfig.playInline && _this.$el.attr({
                            playsinline: 'playsinline'
                        });
                        playbackConfig.crossOrigin && _this.$el.attr({
                            crossorigin: playbackConfig.crossOrigin
                        });
                        // TODO should settings be private?
                        _this.settings = {
                            default: [
                                'seekbar'
                            ]
                        };
                        _this.settings.left = [
                            'playpause',
                            'position',
                            'duration'
                        ];
                        _this.settings.right = [
                            'fullscreen',
                            'volume',
                            'hd-indicator'
                        ];
                        playbackConfig.externalTracks && _this._setupExternalTracks(playbackConfig.externalTracks);
                        _this.options.autoPlay && _this.attemptAutoPlay();
                        return _this;
                    }
                    HTML5Video.prototype.configure = function configure(options) {
                        _Playback.prototype.configure.call(this, options);
                        this.el.loop = !!options.loop;
                    };
                    // See Playback.attemptAutoPlay()
                    HTML5Video.prototype.attemptAutoPlay = function attemptAutoPlay() {
                        var _this2 = this;
                        this.canAutoPlay(function(result, error) {
                            error && _log2.default.warn(_this2.name, 'autoplay error.', {
                                result: result,
                                error: error
                            });
                            // https://github.com/clappr/clappr/issues/1076
                            result && process.nextTick(function() {
                                return !_this2._destroyed && _this2.play();
                            });
                        });
                    };
                    // See Playback.canAutoPlay()
                    HTML5Video.prototype.canAutoPlay = function canAutoPlay(cb) {
                        if (this.options.disableCanAutoPlay) cb(true, null);
                        var opts = {
                            timeout: this.options.autoPlayTimeout || 500,
                            inline: this.options.playback.playInline || false,
                            muted: this.options.mute || false // Known issue: mediacontrols may asynchronously mute video
                        };
                        if (_browser2.default.isMobile && _utils.DomRecycler.options.recycleVideo) opts.element = this.el;
                        // Desktop browser autoplay policy may require user action
                        // Mobile browser autoplay require user consent and video recycling feature enabled
                        // It may returns a false positive with source-less player consent
                        (0, _utils.canAutoPlayMedia)(cb, opts);
                    };
                    HTML5Video.prototype._setupExternalTracks = function _setupExternalTracks(tracks) {
                        this._externalTracks = tracks.map(function(track) {
                            return {
                                kind: track.kind || 'subtitles',
                                label: track.label,
                                lang: track.lang,
                                src: track.src
                            };
                        });
                    };
                    /**
   * Sets the source url on the <video> element, and also the 'src' property.
   * @method setupSrc
   * @private
   * @param {String} srcUrl The source URL.
   */ HTML5Video.prototype._setupSrc = function _setupSrc(srcUrl) {
                        if (this.el.src === srcUrl) return;
                        this._ccIsSetup = false;
                        this.el.src = srcUrl;
                        this._src = this.el.src;
                    };
                    HTML5Video.prototype._onLoadedMetadata = function _onLoadedMetadata(e) {
                        this._handleBufferingEvents();
                        this.trigger(_events2.default.PLAYBACK_LOADEDMETADATA, {
                            duration: e.target.duration,
                            data: e
                        });
                        this._updateSettings();
                        var autoSeekFromUrl = typeof this._options.autoSeekFromUrl === 'undefined' || this._options.autoSeekFromUrl;
                        if (this.getPlaybackType() !== _playback2.default.LIVE && autoSeekFromUrl) this._checkInitialSeek();
                    };
                    HTML5Video.prototype._onDurationChange = function _onDurationChange() {
                        this._updateSettings();
                        this._onTimeUpdate();
                        // onProgress uses the duration
                        this._onProgress();
                    };
                    HTML5Video.prototype._updateSettings = function _updateSettings() {
                        // we can't figure out if hls resource is VoD or not until it is being loaded or duration has changed.
                        // that's why we check it again and update media control accordingly.
                        if (this.getPlaybackType() === _playback2.default.VOD || this.getPlaybackType() === _playback2.default.AOD) this.settings.left = [
                            'playpause',
                            'position',
                            'duration'
                        ];
                        else this.settings.left = [
                            'playstop'
                        ];
                        this.settings.seekEnabled = this.isSeekEnabled();
                        this.trigger(_events2.default.PLAYBACK_SETTINGSUPDATE);
                    };
                    HTML5Video.prototype.isSeekEnabled = function isSeekEnabled() {
                        return isFinite(this.getDuration());
                    };
                    HTML5Video.prototype.getPlaybackType = function getPlaybackType() {
                        var onDemandType = this.tagName === 'audio' ? _playback2.default.AOD : _playback2.default.VOD;
                        return [
                            0,
                            undefined,
                            Infinity
                        ].indexOf(this.el.duration) >= 0 ? _playback2.default.LIVE : onDemandType;
                    };
                    HTML5Video.prototype.isHighDefinitionInUse = function isHighDefinitionInUse() {
                        return false;
                    };
                    // On mobile device, HTML5 video element "retains" user action consent if
                    // load() method is called. See Player.consent().
                    HTML5Video.prototype.consent = function consent() {
                        if (!this.isPlaying()) {
                            _Playback.prototype.consent.call(this);
                            this.el.load();
                        }
                    };
                    HTML5Video.prototype.play = function play() {
                        this.trigger(_events2.default.PLAYBACK_PLAY_INTENT);
                        this._stopped = false;
                        this._setupSrc(this._src);
                        this._handleBufferingEvents();
                        var promise = this.el.play();
                        // For more details, see https://developers.google.com/web/updates/2016/03/play-returns-promise
                        if (promise && promise.catch) promise.catch(function() {});
                    };
                    HTML5Video.prototype.pause = function pause() {
                        this.el.pause();
                    };
                    HTML5Video.prototype.stop = function stop() {
                        this.pause();
                        this._stopped = true;
                        // src will be added again in play()
                        this.el.removeAttribute('src');
                        this.el.load(); // load with no src to stop loading of the previous source and avoid leaks
                        this._stopPlayheadMovingChecks();
                        this._handleBufferingEvents();
                        this.trigger(_events2.default.PLAYBACK_STOP);
                    };
                    HTML5Video.prototype.volume = function volume(value) {
                        if (value === 0) {
                            this.$el.attr({
                                muted: 'true'
                            });
                            this.el.muted = true;
                        } else {
                            this.$el.attr({
                                muted: null
                            });
                            this.el.muted = false;
                            this.el.volume = value / 100;
                        }
                    };
                    /**
   * @deprecated
   * @private
   */ HTML5Video.prototype.mute = function mute() {
                        this.el.muted = true;
                    };
                    /**
   * @deprecated
   * @private
   */ HTML5Video.prototype.unmute = function unmute() {
                        this.el.muted = false;
                    };
                    HTML5Video.prototype.isMuted = function isMuted() {
                        return this.el.muted === true || this.el.volume === 0;
                    };
                    HTML5Video.prototype.isPlaying = function isPlaying() {
                        return !this.el.paused && !this.el.ended;
                    };
                    HTML5Video.prototype._startPlayheadMovingChecks = function _startPlayheadMovingChecks() {
                        if (this._playheadMovingTimer !== null) return;
                        this._playheadMovingTimeOnCheck = null;
                        this._determineIfPlayheadMoving();
                        this._playheadMovingTimer = setInterval(this._determineIfPlayheadMoving.bind(this), 500);
                    };
                    HTML5Video.prototype._stopPlayheadMovingChecks = function _stopPlayheadMovingChecks() {
                        if (this._playheadMovingTimer === null) return;
                        clearInterval(this._playheadMovingTimer);
                        this._playheadMovingTimer = null;
                        this._playheadMoving = false;
                    };
                    HTML5Video.prototype._determineIfPlayheadMoving = function _determineIfPlayheadMoving() {
                        var before = this._playheadMovingTimeOnCheck;
                        var now = this.el.currentTime;
                        this._playheadMoving = before !== now;
                        this._playheadMovingTimeOnCheck = now;
                        this._handleBufferingEvents();
                    };
                    // this seems to happen when the user is having to wait
                    // for something to happen AFTER A USER INTERACTION
                    // e.g the player might be buffering, but when `play()` is called
                    // only at this point will this be called.
                    // Or the user may seek somewhere but the new area requires buffering,
                    // so it will fire then as well.
                    // On devices where playing is blocked until requested with a user action,
                    // buffering may start, but never finish until the user initiates a play,
                    // but this only happens when play is actually requested
                    HTML5Video.prototype._onWaiting = function _onWaiting() {
                        this._loadStarted = true;
                        this._handleBufferingEvents();
                    };
                    // called after the first frame has loaded
                    // note this doesn't fire on ios before the user has requested play
                    // ideally the "loadstart" event would be used instead, but this fires
                    // before a user has requested play on iOS, and also this is always fired
                    // even if the preload setting is "none". In both these cases this causes
                    // infinite buffering until the user does something which isn't great.
                    HTML5Video.prototype._onLoadedData = function _onLoadedData() {
                        this._loadStarted = true;
                        this._handleBufferingEvents();
                    };
                    // note this doesn't fire on ios before user has requested play
                    HTML5Video.prototype._onCanPlay = function _onCanPlay() {
                        this._handleBufferingEvents();
                    };
                    HTML5Video.prototype._onPlaying = function _onPlaying() {
                        this._checkForClosedCaptions();
                        this._startPlayheadMovingChecks();
                        this._handleBufferingEvents();
                        this.trigger(_events2.default.PLAYBACK_PLAY);
                    };
                    HTML5Video.prototype._onPause = function _onPause() {
                        this._stopPlayheadMovingChecks();
                        this._handleBufferingEvents();
                        this.trigger(_events2.default.PLAYBACK_PAUSE);
                    };
                    HTML5Video.prototype._onSeeking = function _onSeeking() {
                        this._handleBufferingEvents();
                        this.trigger(_events2.default.PLAYBACK_SEEK);
                    };
                    HTML5Video.prototype._onSeeked = function _onSeeked() {
                        this._handleBufferingEvents();
                        this.trigger(_events2.default.PLAYBACK_SEEKED);
                    };
                    HTML5Video.prototype._onEnded = function _onEnded() {
                        this._handleBufferingEvents();
                        this.trigger(_events2.default.PLAYBACK_ENDED, this.name);
                    };
                    // The playback should be classed as buffering if the following are true:
                    // - the ready state is less then HAVE_FUTURE_DATA or the playhead isn't moving and it should be
                    // - the media hasn't "ended",
                    // - the media hasn't been stopped
                    // - loading has started
                    HTML5Video.prototype._handleBufferingEvents = function _handleBufferingEvents() {
                        var playheadShouldBeMoving = !this.el.ended && !this.el.paused;
                        var buffering = this._loadStarted && !this.el.ended && !this._stopped && (playheadShouldBeMoving && !this._playheadMoving || this.el.readyState < this.el.HAVE_FUTURE_DATA);
                        if (this._isBuffering !== buffering) {
                            this._isBuffering = buffering;
                            if (buffering) this.trigger(_events2.default.PLAYBACK_BUFFERING, this.name);
                            else this.trigger(_events2.default.PLAYBACK_BUFFERFULL, this.name);
                        }
                    };
                    HTML5Video.prototype._onError = function _onError() {
                        var _ref = this.el.error || UNKNOWN_ERROR, code = _ref.code, message = _ref.message;
                        var isUnknownError = code === UNKNOWN_ERROR.code;
                        var formattedError = this.createError({
                            code: code,
                            description: message,
                            raw: this.el.error,
                            level: isUnknownError ? _error2.default.Levels.WARN : _error2.default.Levels.FATAL
                        });
                        if (isUnknownError) _log2.default.warn(this.name, 'HTML5 unknown error: ', formattedError);
                        else this.trigger(_events2.default.PLAYBACK_ERROR, formattedError);
                    };
                    HTML5Video.prototype.destroy = function destroy() {
                        this._destroyed = true;
                        this.handleTextTrackChange && this.el.textTracks.removeEventListener('change', this.handleTextTrackChange);
                        _Playback.prototype.destroy.call(this);
                        this.el.removeAttribute('src');
                        this.el.load(); // load with no src to stop loading of the previous source and avoid leaks
                        this._src = null;
                        _utils.DomRecycler.garbage(this.$el);
                    };
                    HTML5Video.prototype.seek = function seek(time) {
                        this.el.currentTime = time;
                    };
                    HTML5Video.prototype.seekPercentage = function seekPercentage(percentage) {
                        var time = this.el.duration * (percentage / 100);
                        this.seek(time);
                    };
                    HTML5Video.prototype._checkInitialSeek = function _checkInitialSeek() {
                        var seekTime = (0, _utils.seekStringToSeconds)();
                        if (seekTime !== 0) this.seek(seekTime);
                    };
                    HTML5Video.prototype.getCurrentTime = function getCurrentTime() {
                        return this.el.currentTime;
                    };
                    HTML5Video.prototype.getDuration = function getDuration() {
                        return this.el.duration;
                    };
                    HTML5Video.prototype._onTimeUpdate = function _onTimeUpdate() {
                        if (this.getPlaybackType() === _playback2.default.LIVE) this.trigger(_events2.default.PLAYBACK_TIMEUPDATE, {
                            current: 1,
                            total: 1
                        }, this.name);
                        else this.trigger(_events2.default.PLAYBACK_TIMEUPDATE, {
                            current: this.el.currentTime,
                            total: this.el.duration
                        }, this.name);
                    };
                    HTML5Video.prototype._onProgress = function _onProgress() {
                        if (!this.el.buffered.length) return;
                        var buffered = [];
                        var bufferedPos = 0;
                        for(var i = 0; i < this.el.buffered.length; i++){
                            buffered = [].concat((0, _toConsumableArray3.default)(buffered), [
                                {
                                    start: this.el.buffered.start(i),
                                    end: this.el.buffered.end(i)
                                }
                            ]);
                            if (this.el.currentTime >= buffered[i].start && this.el.currentTime <= buffered[i].end) bufferedPos = i;
                        }
                        var progress = {
                            start: buffered[bufferedPos].start,
                            current: buffered[bufferedPos].end,
                            total: this.el.duration
                        };
                        this.trigger(_events2.default.PLAYBACK_PROGRESS, progress, buffered);
                    };
                    HTML5Video.prototype._typeFor = function _typeFor(src) {
                        var mimeTypes = HTML5Video._mimeTypesForUrl(src, MIMETYPES, this.options.mimeType);
                        if (mimeTypes.length === 0) mimeTypes = HTML5Video._mimeTypesForUrl(src, AUDIO_MIMETYPES, this.options.mimeType);
                        var mimeType = mimeTypes[0] || '';
                        return mimeType.split(';')[0];
                    };
                    HTML5Video.prototype._ready = function _ready() {
                        if (this._isReadyState) return;
                        this._isReadyState = true;
                        this.trigger(_events2.default.PLAYBACK_READY, this.name);
                    };
                    HTML5Video.prototype._checkForClosedCaptions = function _checkForClosedCaptions() {
                        // Check if CC available only if current playback is HTML5Video
                        if (this.isHTML5Video && !this._ccIsSetup) {
                            if (this.hasClosedCaptionsTracks) {
                                this.trigger(_events2.default.PLAYBACK_SUBTITLE_AVAILABLE);
                                var trackId = this.closedCaptionsTrackId;
                                this.closedCaptionsTrackId = trackId;
                                this.handleTextTrackChange = this._handleTextTrackChange.bind(this);
                                this.el.textTracks.addEventListener('change', this.handleTextTrackChange);
                            }
                            this._ccIsSetup = true;
                        }
                    };
                    HTML5Video.prototype._handleTextTrackChange = function _handleTextTrackChange() {
                        var tracks = this.closedCaptionsTracks;
                        var track = tracks.find(function(track) {
                            return track.track.mode === 'showing';
                        }) || {
                            id: -1
                        };
                        if (this._ccTrackId !== track.id) {
                            this._ccTrackId = track.id;
                            this.trigger(_events2.default.PLAYBACK_SUBTITLE_CHANGED, {
                                id: track.id
                            });
                        }
                    };
                    HTML5Video.prototype.render = function render() {
                        if (this.options.playback.disableContextMenu) this.$el.on('contextmenu', function() {
                            return false;
                        });
                        if (this._externalTracks && this._externalTracks.length > 0) this.$el.html(this.template({
                            tracks: this._externalTracks
                        }));
                        this._ready();
                        return this;
                    };
                    (0, _createClass3.default)(HTML5Video, [
                        {
                            key: 'isReady',
                            get: function get() {
                                return this._isReadyState;
                            }
                        },
                        {
                            key: 'isHTML5Video',
                            get: function get() {
                                return this.name === HTML5Video.prototype.name;
                            }
                        },
                        {
                            key: 'closedCaptionsTracks',
                            get: function get() {
                                var id = 0;
                                var trackId = function trackId() {
                                    return id++;
                                };
                                var textTracks = this.el.textTracks ? (0, _from2.default)(this.el.textTracks) : [];
                                return textTracks.filter(function(track) {
                                    return track.kind === 'subtitles' || track.kind === 'captions';
                                }).map(function(track) {
                                    return {
                                        id: trackId(),
                                        name: track.label,
                                        track: track
                                    };
                                });
                            }
                        },
                        {
                            key: 'closedCaptionsTrackId',
                            get: function get() {
                                return this._ccTrackId;
                            },
                            set: function set(trackId) {
                                if (!(0, _utils.isNumber)(trackId)) return;
                                var tracks = this.closedCaptionsTracks;
                                var showingTrack = void 0;
                                // Note: -1 is for hide all tracks
                                if (trackId !== -1) {
                                    showingTrack = tracks.find(function(track) {
                                        return track.id === trackId;
                                    });
                                    if (!showingTrack) return; // Track id not found
                                    if (showingTrack.track.mode === 'showing') return; // Track already showing
                                }
                                // Since it is possible to display multiple tracks,
                                // ensure that all tracks are hidden.
                                tracks.filter(function(track) {
                                    return track.track.mode !== 'hidden';
                                }).forEach(function(track) {
                                    return track.track.mode = 'hidden';
                                });
                                showingTrack && (showingTrack.track.mode = 'showing');
                                this._ccTrackId = trackId;
                                this.trigger(_events2.default.PLAYBACK_SUBTITLE_CHANGED, {
                                    id: trackId
                                });
                            }
                        },
                        {
                            key: 'template',
                            get: function get() {
                                return (0, _template2.default)(_tracks2.default);
                            }
                        }
                    ]);
                    return HTML5Video;
                }(_playback2.default);
                exports.default = HTML5Video;
                HTML5Video._mimeTypesForUrl = function(resourceUrl, mimeTypesByExtension, mimeType) {
                    var extension = (resourceUrl.split('?')[0].match(/.*\.(.*)$/) || [])[1];
                    var mimeTypes = mimeType || extension && mimeTypesByExtension[extension.toLowerCase()] || [];
                    return mimeTypes.constructor === Array ? mimeTypes : [
                        mimeTypes
                    ];
                };
                HTML5Video._canPlay = function(type, mimeTypesByExtension, resourceUrl, mimeType) {
                    var mimeTypes = HTML5Video._mimeTypesForUrl(resourceUrl, mimeTypesByExtension, mimeType);
                    var media = document.createElement(type);
                    return !!mimeTypes.filter(function(mediaType) {
                        return !!media.canPlayType(mediaType).replace(/no/, '');
                    })[0];
                };
                HTML5Video.canPlay = function(resourceUrl, mimeType) {
                    return HTML5Video._canPlay('audio', AUDIO_MIMETYPES, resourceUrl, mimeType) || HTML5Video._canPlay('video', MIMETYPES, resourceUrl, mimeType);
                };
                module1.exports = exports['default'];
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(/*! ./../../../node_modules/node-libs-browser/node_modules/process/browser.js */ "./node_modules/node-libs-browser/node_modules/process/browser.js"));
        /***/ },
        /***/ "./src/playbacks/html5_video/index.js": /*!********************************************!*\
  !*** ./src/playbacks/html5_video/index.js ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _html5_video = __webpack_require__(/*! ./html5_video */ "./src/playbacks/html5_video/html5_video.js");
            var _html5_video2 = _interopRequireDefault(_html5_video);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _html5_video2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/html5_video/public/style.scss": /*!*****************************************************!*\
  !*** ./src/playbacks/html5_video/public/style.scss ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./style.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/playbacks/html5_video/public/style.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/playbacks/html5_video/public/tracks.html": /*!******************************************************!*\
  !*** ./src/playbacks/html5_video/public/tracks.html ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<% for (var i = 0; i < tracks.length; i++) { %>\n  <track data-html5-video-track=\"<%= i %>\" kind=\"<%= tracks[i].kind %>\" label=\"<%= tracks[i].label %>\" srclang=\"<%= tracks[i].lang %>\" src=\"<%= tracks[i].src %>\" />\n<% }; %>\n";
        /***/ },
        /***/ "./src/playbacks/html_img/html_img.js": /*!********************************************!*\
  !*** ./src/playbacks/html_img/html_img.js ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
            var _playback2 = _interopRequireDefault(_playback);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            __webpack_require__(/*! ./public/style.scss */ "./src/playbacks/html_img/public/style.scss");
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var HTMLImg = function(_Playback) {
                (0, _inherits3.default)(HTMLImg, _Playback);
                HTMLImg.prototype.getPlaybackType = function getPlaybackType() {
                    return _playback2.default.NO_OP;
                };
                (0, _createClass3.default)(HTMLImg, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'html_img';
                        }
                    },
                    {
                        key: 'tagName',
                        get: function get() {
                            return 'img';
                        }
                    },
                    {
                        key: 'attributes',
                        get: function get() {
                            return {
                                'data-html-img': ''
                            };
                        }
                    },
                    {
                        key: 'events',
                        get: function get() {
                            return {
                                'load': '_onLoad',
                                'abort': '_onError',
                                'error': '_onError'
                            };
                        }
                    }
                ]);
                function HTMLImg(params) {
                    (0, _classCallCheck3.default)(this, HTMLImg);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _Playback.call(this, params));
                    _this.el.src = params.src;
                    return _this;
                }
                HTMLImg.prototype.render = function render() {
                    this.trigger(_events2.default.PLAYBACK_READY, this.name);
                    return this;
                };
                HTMLImg.prototype._onLoad = function _onLoad() {
                    this.trigger(_events2.default.PLAYBACK_ENDED, this.name);
                };
                HTMLImg.prototype._onError = function _onError(evt) {
                    var m = evt.type === 'error' ? 'load error' : 'loading aborted';
                    this.trigger(_events2.default.PLAYBACK_ERROR, {
                        message: m
                    }, this.name);
                };
                return HTMLImg;
            }(_playback2.default); // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            exports.default = HTMLImg;
            HTMLImg.canPlay = function(resource) {
                return /\.(png|jpg|jpeg|gif|bmp|tiff|pgm|pnm|webp)(|\?.*)$/i.test(resource);
            };
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/html_img/index.js": /*!*****************************************!*\
  !*** ./src/playbacks/html_img/index.js ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _html_img = __webpack_require__(/*! ./html_img */ "./src/playbacks/html_img/html_img.js");
            var _html_img2 = _interopRequireDefault(_html_img);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _html_img2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/html_img/public/style.scss": /*!**************************************************!*\
  !*** ./src/playbacks/html_img/public/style.scss ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./style.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/playbacks/html_img/public/style.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/playbacks/no_op/index.js": /*!**************************************!*\
  !*** ./src/playbacks/no_op/index.js ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _no_op = __webpack_require__(/*! ./no_op */ "./src/playbacks/no_op/no_op.js");
            var _no_op2 = _interopRequireDefault(_no_op);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _no_op2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/no_op/no_op.js": /*!**************************************!*\
  !*** ./src/playbacks/no_op/no_op.js ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _utils = __webpack_require__(/*! ../../base/utils */ "./src/base/utils.js");
            var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
            var _playback2 = _interopRequireDefault(_playback);
            var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
            var _template2 = _interopRequireDefault(_template);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _error = __webpack_require__(/*! ./public/error.html */ "./src/playbacks/no_op/public/error.html");
            var _error2 = _interopRequireDefault(_error);
            __webpack_require__(/*! ./public/style.scss */ "./src/playbacks/no_op/public/style.scss");
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var NoOp = function(_Playback) {
                (0, _inherits3.default)(NoOp, _Playback);
                (0, _createClass3.default)(NoOp, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'no_op';
                        }
                    },
                    {
                        key: 'template',
                        get: function get() {
                            return (0, _template2.default)(_error2.default);
                        }
                    },
                    {
                        key: 'attributes',
                        get: function get() {
                            return {
                                'data-no-op': ''
                            };
                        }
                    }
                ]);
                function NoOp() {
                    (0, _classCallCheck3.default)(this, NoOp);
                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _this = (0, _possibleConstructorReturn3.default)(this, _Playback.call.apply(_Playback, [
                        this
                    ].concat(args)));
                    _this._noiseFrameNum = -1;
                    return _this;
                }
                NoOp.prototype.render = function render() {
                    var playbackNotSupported = this.options.playbackNotSupportedMessage || this.i18n.t('playback_not_supported');
                    this.$el.html(this.template({
                        message: playbackNotSupported
                    }));
                    this.trigger(_events2.default.PLAYBACK_READY, this.name);
                    var showForNoOp = !!(this.options.poster && this.options.poster.showForNoOp);
                    if (this.options.autoPlay || !showForNoOp) this._animate();
                    return this;
                };
                NoOp.prototype._noise = function _noise() {
                    this._noiseFrameNum = (this._noiseFrameNum + 1) % 5;
                    if (this._noiseFrameNum) // only update noise every 5 frames to save cpu
                    return;
                    var idata = this.context.createImageData(this.context.canvas.width, this.context.canvas.height);
                    var buffer32 = void 0;
                    try {
                        buffer32 = new Uint32Array(idata.data.buffer);
                    } catch (err) {
                        buffer32 = new Uint32Array(this.context.canvas.width * this.context.canvas.height * 4);
                        var data = idata.data;
                        for(var i = 0; i < data.length; i++)buffer32[i] = data[i];
                    }
                    var len = buffer32.length, m = Math.random() * 6 + 4;
                    var run = 0, color = 0;
                    for(var _i = 0; _i < len;){
                        if (run < 0) {
                            run = m * Math.random();
                            var p = Math.pow(Math.random(), 0.4);
                            color = 255 * p << 24;
                        }
                        run -= 1;
                        buffer32[_i++] = color;
                    }
                    this.context.putImageData(idata, 0, 0);
                };
                NoOp.prototype._loop = function _loop() {
                    var _this2 = this;
                    if (this._stop) return;
                    this._noise();
                    this._animationHandle = (0, _utils.requestAnimationFrame)(function() {
                        return _this2._loop();
                    });
                };
                NoOp.prototype.destroy = function destroy() {
                    if (this._animationHandle) {
                        (0, _utils.cancelAnimationFrame)(this._animationHandle);
                        this._stop = true;
                    }
                };
                NoOp.prototype._animate = function _animate() {
                    this.canvas = this.$el.find('canvas[data-no-op-canvas]')[0];
                    this.context = this.canvas.getContext('2d');
                    this._loop();
                };
                return NoOp;
            }(_playback2.default);
            exports.default = NoOp;
            NoOp.canPlay = function(source) {
                // eslint-disable-line no-unused-vars
                return true;
            };
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/playbacks/no_op/public/error.html": /*!***********************************************!*\
  !*** ./src/playbacks/no_op/public/error.html ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<canvas data-no-op-canvas></canvas>\n<p data-no-op-msg><%=message%><p>\n";
        /***/ },
        /***/ "./src/playbacks/no_op/public/style.scss": /*!***********************************************!*\
  !*** ./src/playbacks/no_op/public/style.scss ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./style.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/playbacks/no_op/public/style.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/plugins/click_to_pause/click_to_pause.js": /*!******************************************************!*\
  !*** ./src/plugins/click_to_pause/click_to_pause.js ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _container_plugin = __webpack_require__(/*! ../../base/container_plugin */ "./src/base/container_plugin.js");
            var _container_plugin2 = _interopRequireDefault(_container_plugin);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
            var _playback2 = _interopRequireDefault(_playback);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var ClickToPausePlugin = function(_ContainerPlugin) {
                (0, _inherits3.default)(ClickToPausePlugin, _ContainerPlugin);
                (0, _createClass3.default)(ClickToPausePlugin, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'click_to_pause';
                        }
                    }
                ]);
                function ClickToPausePlugin(container) {
                    (0, _classCallCheck3.default)(this, ClickToPausePlugin);
                    return (0, _possibleConstructorReturn3.default)(this, _ContainerPlugin.call(this, container));
                }
                ClickToPausePlugin.prototype.bindEvents = function bindEvents() {
                    this.listenTo(this.container, _events2.default.CONTAINER_CLICK, this.click);
                    this.listenTo(this.container, _events2.default.CONTAINER_SETTINGSUPDATE, this.settingsUpdate);
                };
                ClickToPausePlugin.prototype.click = function click() {
                    if (this.container.getPlaybackType() !== _playback2.default.LIVE || this.container.isDvrEnabled()) {
                        if (this.container.isPlaying()) this.container.pause();
                        else this.container.play();
                    }
                };
                ClickToPausePlugin.prototype.settingsUpdate = function settingsUpdate() {
                    var pointerEnabled = this.container.getPlaybackType() !== _playback2.default.LIVE || this.container.isDvrEnabled();
                    if (pointerEnabled === this.pointerEnabled) return;
                    var method = pointerEnabled ? 'addClass' : 'removeClass';
                    this.container.$el[method]('pointer-enabled');
                    this.pointerEnabled = pointerEnabled;
                };
                return ClickToPausePlugin;
            }(_container_plugin2.default); //Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            exports.default = ClickToPausePlugin;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/click_to_pause/index.js": /*!*********************************************!*\
  !*** ./src/plugins/click_to_pause/index.js ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _click_to_pause = __webpack_require__(/*! ./click_to_pause */ "./src/plugins/click_to_pause/click_to_pause.js");
            var _click_to_pause2 = _interopRequireDefault(_click_to_pause);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _click_to_pause2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/closed_captions/closed_captions.js": /*!********************************************************!*\
  !*** ./src/plugins/closed_captions/closed_captions.js ***!
  \********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _ui_core_plugin = __webpack_require__(/*! ../../base/ui_core_plugin */ "./src/base/ui_core_plugin.js");
            var _ui_core_plugin2 = _interopRequireDefault(_ui_core_plugin);
            var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
            var _template2 = _interopRequireDefault(_template);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _utils = __webpack_require__(/*! ../../base/utils */ "./src/base/utils.js");
            var _closed_captions = __webpack_require__(/*! ./public/closed_captions.html */ "./src/plugins/closed_captions/public/closed_captions.html");
            var _closed_captions2 = _interopRequireDefault(_closed_captions);
            __webpack_require__(/*! ./public/closed_captions.scss */ "./src/plugins/closed_captions/public/closed_captions.scss");
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var ClosedCaptions = function(_UICorePlugin) {
                (0, _inherits3.default)(ClosedCaptions, _UICorePlugin);
                (0, _createClass3.default)(ClosedCaptions, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'closed_captions';
                        }
                    },
                    {
                        key: 'template',
                        get: function get() {
                            return (0, _template2.default)(_closed_captions2.default);
                        }
                    },
                    {
                        key: 'events',
                        get: function get() {
                            return {
                                'click [data-cc-button]': 'toggleContextMenu',
                                'click [data-cc-select]': 'onTrackSelect'
                            };
                        }
                    },
                    {
                        key: 'attributes',
                        get: function get() {
                            return {
                                'class': 'cc-controls',
                                'data-cc-controls': ''
                            };
                        }
                    }
                ]);
                function ClosedCaptions(core) {
                    (0, _classCallCheck3.default)(this, ClosedCaptions);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _UICorePlugin.call(this, core));
                    var config = core.options.closedCaptionsConfig;
                    _this._title = config && config.title ? config.title : null;
                    _this._ariaLabel = config && config.ariaLabel ? config.ariaLabel : 'cc-button';
                    _this._labelCb = config && config.labelCallback && typeof config.labelCallback === 'function' ? config.labelCallback : function(track) {
                        return track.name;
                    };
                    return _this;
                }
                ClosedCaptions.prototype.bindEvents = function bindEvents() {
                    this.listenTo(this.core, _events2.default.CORE_ACTIVE_CONTAINER_CHANGED, this.containerChanged);
                    this.listenTo(this.core.mediaControl, _events2.default.MEDIACONTROL_RENDERED, this.render);
                    this.listenTo(this.core.mediaControl, _events2.default.MEDIACONTROL_HIDE, this.hideContextMenu);
                    this.container = this.core.getCurrentContainer();
                    if (this.container) {
                        this.listenTo(this.container, _events2.default.CONTAINER_SUBTITLE_AVAILABLE, this.onSubtitleAvailable);
                        this.listenTo(this.container, _events2.default.CONTAINER_SUBTITLE_CHANGED, this.onSubtitleChanged);
                        this.listenTo(this.container, _events2.default.CONTAINER_STOP, this.onContainerStop);
                    }
                };
                ClosedCaptions.prototype.onContainerStop = function onContainerStop() {
                    this.ccAvailable(false);
                };
                ClosedCaptions.prototype.containerChanged = function containerChanged() {
                    this.ccAvailable(false);
                    this.stopListening();
                    this.bindEvents();
                };
                ClosedCaptions.prototype.onSubtitleAvailable = function onSubtitleAvailable() {
                    this.renderCcButton();
                    this.ccAvailable(true);
                };
                ClosedCaptions.prototype.onSubtitleChanged = function onSubtitleChanged(track) {
                    this.setCurrentContextMenuElement(track.id);
                };
                ClosedCaptions.prototype.onTrackSelect = function onTrackSelect(event) {
                    var trackId = parseInt(event.target.dataset.ccSelect, 10);
                    this.container.closedCaptionsTrackId = trackId;
                    this.hideContextMenu();
                    event.stopPropagation();
                    return false;
                };
                ClosedCaptions.prototype.ccAvailable = function ccAvailable(hasCC) {
                    var method = hasCC ? 'addClass' : 'removeClass';
                    this.$el[method]('available');
                };
                ClosedCaptions.prototype.toggleContextMenu = function toggleContextMenu() {
                    this.$el.find('ul').toggle();
                };
                ClosedCaptions.prototype.hideContextMenu = function hideContextMenu() {
                    this.$el.find('ul').hide();
                };
                ClosedCaptions.prototype.contextMenuElement = function contextMenuElement(id) {
                    return this.$el.find('ul a' + (!isNaN(id) ? '[data-cc-select="' + id + '"]' : '')).parent();
                };
                ClosedCaptions.prototype.setCurrentContextMenuElement = function setCurrentContextMenuElement(trackId) {
                    if (this._trackId !== trackId) {
                        this.contextMenuElement().removeClass('current');
                        this.contextMenuElement(trackId).addClass('current');
                        var method = trackId > -1 ? 'addClass' : 'removeClass';
                        this.$ccButton[method]('enabled');
                        this._trackId = trackId;
                    }
                };
                ClosedCaptions.prototype.renderCcButton = function renderCcButton() {
                    var tracks = this.container ? this.container.closedCaptionsTracks : [];
                    for(var i = 0; i < tracks.length; i++)tracks[i].label = this._labelCb(tracks[i]);
                    this.$el.html(this.template({
                        ariaLabel: this._ariaLabel,
                        disabledLabel: this.core.i18n.t('disabled'),
                        title: this._title,
                        tracks: tracks
                    }));
                    this.$ccButton = this.$el.find('button.cc-button[data-cc-button]');
                    this.$ccButton.append(_utils.SvgIcons.cc);
                    this.$el.append(this.style);
                };
                ClosedCaptions.prototype.render = function render() {
                    this.renderCcButton();
                    var $fullscreen = this.core.mediaControl.$el.find('button[data-fullscreen]');
                    if ($fullscreen[0]) this.$el.insertAfter($fullscreen);
                    else this.core.mediaControl.$el.find('.media-control-right-panel[data-media-control]').prepend(this.$el);
                    return this;
                };
                return ClosedCaptions;
            }(_ui_core_plugin2.default);
            exports.default = ClosedCaptions;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/closed_captions/index.js": /*!**********************************************!*\
  !*** ./src/plugins/closed_captions/index.js ***!
  \**********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _closed_captions = __webpack_require__(/*! ./closed_captions */ "./src/plugins/closed_captions/closed_captions.js");
            var _closed_captions2 = _interopRequireDefault(_closed_captions);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _closed_captions2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/closed_captions/public/closed_captions.html": /*!*****************************************************************!*\
  !*** ./src/plugins/closed_captions/public/closed_captions.html ***!
  \*****************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<button type=\"button\" class=\"cc-button media-control-button media-control-icon\" data-cc-button aria-label=\"<%= ariaLabel %>\"></button>\n<ul>\n  <% if (title) { %>\n  <li data-title><%= title %></li>\n  <% }; %>\n  <li><a href=\"#\" data-cc-select=\"-1\"><%= disabledLabel %></a></li>\n  <% for (var i = 0; i < tracks.length; i++) { %>\n    <li><a href=\"#\" data-cc-select=\"<%= tracks[i].id %>\"><%= tracks[i].label %></a></li>\n  <% }; %>\n</ul>\n";
        /***/ },
        /***/ "./src/plugins/closed_captions/public/closed_captions.scss": /*!*****************************************************************!*\
  !*** ./src/plugins/closed_captions/public/closed_captions.scss ***!
  \*****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./closed_captions.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/closed_captions/public/closed_captions.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/plugins/dvr_controls/dvr_controls.js": /*!**************************************************!*\
  !*** ./src/plugins/dvr_controls/dvr_controls.js ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _ui_core_plugin = __webpack_require__(/*! ../../base/ui_core_plugin */ "./src/base/ui_core_plugin.js");
            var _ui_core_plugin2 = _interopRequireDefault(_ui_core_plugin);
            var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
            var _template2 = _interopRequireDefault(_template);
            var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
            var _playback2 = _interopRequireDefault(_playback);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _index = __webpack_require__(/*! ./public/index.html */ "./src/plugins/dvr_controls/public/index.html");
            var _index2 = _interopRequireDefault(_index);
            __webpack_require__(/*! ./public/dvr_controls.scss */ "./src/plugins/dvr_controls/public/dvr_controls.scss");
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var DVRControls = function(_UICorePlugin) {
                (0, _inherits3.default)(DVRControls, _UICorePlugin);
                (0, _createClass3.default)(DVRControls, [
                    {
                        key: 'template',
                        get: function get() {
                            return (0, _template2.default)(_index2.default);
                        }
                    },
                    {
                        key: 'name',
                        get: function get() {
                            return 'dvr_controls';
                        }
                    },
                    {
                        key: 'events',
                        get: function get() {
                            return {
                                'click .live-button': 'click'
                            };
                        }
                    },
                    {
                        key: 'attributes',
                        get: function get() {
                            return {
                                'class': 'dvr-controls',
                                'data-dvr-controls': ''
                            };
                        }
                    }
                ]);
                function DVRControls(core) {
                    (0, _classCallCheck3.default)(this, DVRControls);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _UICorePlugin.call(this, core));
                    _this.settingsUpdate();
                    return _this;
                }
                DVRControls.prototype.bindEvents = function bindEvents() {
                    this.listenTo(this.core.mediaControl, _events2.default.MEDIACONTROL_CONTAINERCHANGED, this.containerChanged);
                    this.listenTo(this.core.mediaControl, _events2.default.MEDIACONTROL_RENDERED, this.settingsUpdate);
                    this.listenTo(this.core, _events2.default.CORE_OPTIONS_CHANGE, this.render);
                    if (this.core.getCurrentContainer()) {
                        this.listenToOnce(this.core.getCurrentContainer(), _events2.default.CONTAINER_TIMEUPDATE, this.render);
                        this.listenTo(this.core.getCurrentContainer(), _events2.default.CONTAINER_PLAYBACKDVRSTATECHANGED, this.dvrChanged);
                    }
                };
                DVRControls.prototype.containerChanged = function containerChanged() {
                    this.stopListening();
                    this.bindEvents();
                };
                DVRControls.prototype.dvrChanged = function dvrChanged(dvrEnabled) {
                    if (this.core.getPlaybackType() !== _playback2.default.LIVE) return;
                    this.settingsUpdate();
                    this.core.mediaControl.$el.addClass('live');
                    if (dvrEnabled) {
                        this.core.mediaControl.$el.addClass('dvr');
                        this.core.mediaControl.$el.find('.media-control-indicator[data-position], .media-control-indicator[data-duration]').hide();
                    } else this.core.mediaControl.$el.removeClass('dvr');
                };
                DVRControls.prototype.click = function click() {
                    var mediaControl = this.core.mediaControl;
                    var container = mediaControl.container;
                    if (!container.isPlaying()) container.play();
                    if (mediaControl.$el.hasClass('dvr')) container.seek(container.getDuration());
                };
                DVRControls.prototype.settingsUpdate = function settingsUpdate() {
                    var _this2 = this;
                    this.stopListening();
                    this.core.mediaControl.$el.removeClass('live');
                    if (this.shouldRender()) {
                        this.render();
                        this.$el.click(function() {
                            return _this2.click();
                        });
                    }
                    this.bindEvents();
                };
                DVRControls.prototype.shouldRender = function shouldRender() {
                    var useDvrControls = this.core.options.useDvrControls === undefined || !!this.core.options.useDvrControls;
                    return useDvrControls && this.core.getPlaybackType() === _playback2.default.LIVE;
                };
                DVRControls.prototype.render = function render() {
                    this.$el.html(this.template({
                        live: this.core.i18n.t('live'),
                        backToLive: this.core.i18n.t('back_to_live')
                    }));
                    if (this.shouldRender()) {
                        this.core.mediaControl.$el.addClass('live');
                        this.core.mediaControl.$('.media-control-left-panel[data-media-control]').append(this.$el);
                    }
                    return this;
                };
                return DVRControls;
            }(_ui_core_plugin2.default);
            exports.default = DVRControls;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/dvr_controls/index.js": /*!*******************************************!*\
  !*** ./src/plugins/dvr_controls/index.js ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _dvr_controls = __webpack_require__(/*! ./dvr_controls */ "./src/plugins/dvr_controls/dvr_controls.js");
            var _dvr_controls2 = _interopRequireDefault(_dvr_controls);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _dvr_controls2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/dvr_controls/public/dvr_controls.scss": /*!***********************************************************!*\
  !*** ./src/plugins/dvr_controls/public/dvr_controls.scss ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./dvr_controls.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/dvr_controls/public/dvr_controls.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/plugins/dvr_controls/public/index.html": /*!****************************************************!*\
  !*** ./src/plugins/dvr_controls/public/index.html ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<div class=\"live-info\"><%= live %></div>\n<button type=\"button\" class=\"live-button\" aria-label=\"<%= backToLive %>\"><%= backToLive %></button>\n";
        /***/ },
        /***/ "./src/plugins/end_video.js": /*!**********************************!*\
  !*** ./src/plugins/end_video.js ***!
  \**********************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _events = __webpack_require__(/*! ../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _core_plugin = __webpack_require__(/*! ../base/core_plugin */ "./src/base/core_plugin.js");
            var _core_plugin2 = _interopRequireDefault(_core_plugin);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var EndVideo = function(_CorePlugin) {
                (0, _inherits3.default)(EndVideo, _CorePlugin);
                function EndVideo() {
                    (0, _classCallCheck3.default)(this, EndVideo);
                    return (0, _possibleConstructorReturn3.default)(this, _CorePlugin.apply(this, arguments));
                }
                EndVideo.prototype.bindEvents = function bindEvents() {
                    this.listenTo(this.core, _events2.default.CORE_ACTIVE_CONTAINER_CHANGED, this.containerChanged);
                    var container = this.core.activeContainer;
                    if (container) {
                        this.listenTo(container, _events2.default.CONTAINER_ENDED, this.ended);
                        this.listenTo(container, _events2.default.CONTAINER_STOP, this.ended);
                    }
                };
                EndVideo.prototype.containerChanged = function containerChanged() {
                    this.stopListening();
                    this.bindEvents();
                };
                EndVideo.prototype.ended = function ended() {
                    var exitOnEnd = typeof this.core.options.exitFullscreenOnEnd === 'undefined' || this.core.options.exitFullscreenOnEnd;
                    if (exitOnEnd && this.core.isFullscreen()) this.core.toggleFullscreen();
                };
                (0, _createClass3.default)(EndVideo, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'end_video';
                        }
                    }
                ]);
                return EndVideo;
            }(_core_plugin2.default);
            exports.default = EndVideo;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/error_screen/error_screen.js": /*!**************************************************!*\
  !*** ./src/plugins/error_screen/error_screen.js ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _ui_core_plugin = __webpack_require__(/*! ../../base/ui_core_plugin */ "./src/base/ui_core_plugin.js");
            var _ui_core_plugin2 = _interopRequireDefault(_ui_core_plugin);
            var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
            var _template2 = _interopRequireDefault(_template);
            var _error = __webpack_require__(/*! ../../components/error/ */ "./src/components/error/index.js");
            var _error2 = _interopRequireDefault(_error);
            var _utils = __webpack_require__(/*! ../../base/utils */ "./src/base/utils.js");
            var _error_screen = __webpack_require__(/*! ./public/error_screen.html */ "./src/plugins/error_screen/public/error_screen.html");
            var _error_screen2 = _interopRequireDefault(_error_screen);
            __webpack_require__(/*! ./public/error_screen.scss */ "./src/plugins/error_screen/public/error_screen.scss");
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var ErrorScreen = function(_UICorePlugin) {
                (0, _inherits3.default)(ErrorScreen, _UICorePlugin);
                (0, _createClass3.default)(ErrorScreen, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'error_screen';
                        }
                    },
                    {
                        key: 'template',
                        get: function get() {
                            return (0, _template2.default)(_error_screen2.default);
                        }
                    },
                    {
                        key: 'container',
                        get: function get() {
                            return this.core.getCurrentContainer();
                        }
                    },
                    {
                        key: 'attributes',
                        get: function get() {
                            return {
                                'class': 'player-error-screen',
                                'data-error-screen': ''
                            };
                        }
                    }
                ]);
                function ErrorScreen(core) {
                    var _ret;
                    (0, _classCallCheck3.default)(this, ErrorScreen);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _UICorePlugin.call(this, core));
                    if (_this.options.disableErrorScreen) return _ret = _this.disable(), (0, _possibleConstructorReturn3.default)(_this, _ret);
                    return _this;
                }
                ErrorScreen.prototype.bindEvents = function bindEvents() {
                    this.listenTo(this.core, _events2.default.ERROR, this.onError);
                    this.listenTo(this.core, _events2.default.CORE_ACTIVE_CONTAINER_CHANGED, this.onContainerChanged);
                };
                ErrorScreen.prototype.bindReload = function bindReload() {
                    this.reloadButton = this.$el.find('.player-error-screen__reload');
                    this.reloadButton && this.reloadButton.on('click', this.reload.bind(this));
                };
                ErrorScreen.prototype.reload = function reload() {
                    var _this2 = this;
                    this.listenToOnce(this.core, _events2.default.CORE_READY, function() {
                        return _this2.container.play();
                    });
                    this.core.load(this.options.sources, this.options.mimeType);
                    this.unbindReload();
                };
                ErrorScreen.prototype.unbindReload = function unbindReload() {
                    this.reloadButton && this.reloadButton.off('click');
                };
                ErrorScreen.prototype.onContainerChanged = function onContainerChanged() {
                    this.err = null;
                    this.unbindReload();
                    this.hide();
                };
                ErrorScreen.prototype.onError = function onError() {
                    var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    if (err.level === _error2.default.Levels.FATAL) {
                        this.err = err;
                        this.container.disableMediaControl();
                        this.container.stop();
                        this.show();
                    }
                };
                ErrorScreen.prototype.show = function show() {
                    this.render();
                    this.$el.show();
                };
                ErrorScreen.prototype.hide = function hide() {
                    this.$el.hide();
                };
                ErrorScreen.prototype.render = function render() {
                    if (!this.err) return;
                    this.$el.html(this.template({
                        title: this.err.UI.title,
                        message: this.err.UI.message,
                        code: this.err.code,
                        icon: this.err.UI.icon || '',
                        reloadIcon: _utils.SvgIcons.reload
                    }));
                    this.core.$el.append(this.el);
                    this.bindReload();
                    return this;
                };
                return ErrorScreen;
            }(_ui_core_plugin2.default);
            exports.default = ErrorScreen;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/error_screen/index.js": /*!*******************************************!*\
  !*** ./src/plugins/error_screen/index.js ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _error_screen = __webpack_require__(/*! ./error_screen */ "./src/plugins/error_screen/error_screen.js");
            var _error_screen2 = _interopRequireDefault(_error_screen);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _error_screen2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/error_screen/public/error_screen.html": /*!***********************************************************!*\
  !*** ./src/plugins/error_screen/public/error_screen.html ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<div class=\"player-error-screen__content\" data-error-screen>\n  <% if (icon) { %>\n  <div class=\"player-error-screen__icon\" data-error-screen><%= icon %></div>\n  <% } %>\n  <div class=\"player-error-screen__title\" data-error-screen><%= title %></div>\n  <div class=\"player-error-screen__message\" data-error-screen><%= message %></div>\n  <div class=\"player-error-screen__code\" data-error-screen>Error code: <%= code %></div>\n  <div class=\"player-error-screen__reload\" data-error-screen><%= reloadIcon %></div>\n</div>\n";
        /***/ },
        /***/ "./src/plugins/error_screen/public/error_screen.scss": /*!***********************************************************!*\
  !*** ./src/plugins/error_screen/public/error_screen.scss ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./error_screen.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/error_screen/public/error_screen.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/plugins/favicon/favicon.js": /*!****************************************!*\
  !*** ./src/plugins/favicon/favicon.js ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _core_plugin = __webpack_require__(/*! ../../base/core_plugin */ "./src/base/core_plugin.js");
            var _core_plugin2 = _interopRequireDefault(_core_plugin);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            var _utils = __webpack_require__(/*! ../../base/utils */ "./src/base/utils.js");
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var oldIcon = (0, _clapprZepto2.default)('link[rel="shortcut icon"]');
            var Favicon = function(_CorePlugin) {
                (0, _inherits3.default)(Favicon, _CorePlugin);
                (0, _createClass3.default)(Favicon, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'favicon';
                        }
                    },
                    {
                        key: 'oldIcon',
                        get: function get() {
                            return oldIcon;
                        }
                    }
                ]);
                function Favicon(core) {
                    (0, _classCallCheck3.default)(this, Favicon);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _CorePlugin.call(this, core));
                    _this._container = null;
                    _this.configure();
                    return _this;
                }
                Favicon.prototype.configure = function configure() {
                    if (this.core.options.changeFavicon) {
                        if (!this.enabled) {
                            this.stopListening(this.core, _events2.default.CORE_OPTIONS_CHANGE);
                            this.enable();
                        }
                    } else if (this.enabled) {
                        this.disable();
                        this.listenTo(this.core, _events2.default.CORE_OPTIONS_CHANGE, this.configure);
                    }
                };
                Favicon.prototype.bindEvents = function bindEvents() {
                    this.listenTo(this.core, _events2.default.CORE_OPTIONS_CHANGE, this.configure);
                    this.listenTo(this.core, _events2.default.CORE_ACTIVE_CONTAINER_CHANGED, this.containerChanged);
                    this.core.activeContainer && this.containerChanged();
                };
                Favicon.prototype.containerChanged = function containerChanged() {
                    this._container && this.stopListening(this._container);
                    this._container = this.core.activeContainer;
                    this.listenTo(this._container, _events2.default.CONTAINER_PLAY, this.setPlayIcon);
                    this.listenTo(this._container, _events2.default.CONTAINER_PAUSE, this.setPauseIcon);
                    this.listenTo(this._container, _events2.default.CONTAINER_STOP, this.resetIcon);
                    this.listenTo(this._container, _events2.default.CONTAINER_ENDED, this.resetIcon);
                    this.listenTo(this._container, _events2.default.CONTAINER_ERROR, this.resetIcon);
                    this.resetIcon();
                };
                Favicon.prototype.disable = function disable() {
                    _CorePlugin.prototype.disable.call(this);
                    this.resetIcon();
                };
                Favicon.prototype.destroy = function destroy() {
                    _CorePlugin.prototype.destroy.call(this);
                    this.resetIcon();
                };
                Favicon.prototype.createIcon = function createIcon(svg) {
                    var canvas = (0, _clapprZepto2.default)('<canvas/>');
                    canvas[0].width = 16;
                    canvas[0].height = 16;
                    var ctx = canvas[0].getContext('2d');
                    ctx.fillStyle = '#000';
                    var d = (0, _clapprZepto2.default)(svg).find('path').attr('d');
                    var path = new Path2D(d);
                    ctx.fill(path);
                    var icon = (0, _clapprZepto2.default)('<link rel="shortcut icon" type="image/png"/>');
                    icon.attr('href', canvas[0].toDataURL('image/png'));
                    return icon;
                };
                Favicon.prototype.setPlayIcon = function setPlayIcon() {
                    if (!this.playIcon) this.playIcon = this.createIcon(_utils.SvgIcons.play);
                    this.changeIcon(this.playIcon);
                };
                Favicon.prototype.setPauseIcon = function setPauseIcon() {
                    if (!this.pauseIcon) this.pauseIcon = this.createIcon(_utils.SvgIcons.pause);
                    this.changeIcon(this.pauseIcon);
                };
                Favicon.prototype.resetIcon = function resetIcon() {
                    (0, _clapprZepto2.default)('link[rel="shortcut icon"]').remove();
                    (0, _clapprZepto2.default)('head').append(this.oldIcon);
                };
                Favicon.prototype.changeIcon = function changeIcon(icon) {
                    if (icon) {
                        (0, _clapprZepto2.default)('link[rel="shortcut icon"]').remove();
                        (0, _clapprZepto2.default)('head').append(icon);
                    }
                };
                return Favicon;
            }(_core_plugin2.default);
            exports.default = Favicon;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/favicon/index.js": /*!**************************************!*\
  !*** ./src/plugins/favicon/index.js ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _favicon = __webpack_require__(/*! ./favicon.js */ "./src/plugins/favicon/favicon.js");
            var _favicon2 = _interopRequireDefault(_favicon);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _favicon2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/google_analytics/google_analytics.js": /*!**********************************************************!*\
  !*** ./src/plugins/google_analytics/google_analytics.js ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _container_plugin = __webpack_require__(/*! ../../base/container_plugin */ "./src/base/container_plugin.js");
            var _container_plugin2 = _interopRequireDefault(_container_plugin);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var GoogleAnalytics = function(_ContainerPlugin) {
                (0, _inherits3.default)(GoogleAnalytics, _ContainerPlugin);
                (0, _createClass3.default)(GoogleAnalytics, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'google_analytics';
                        }
                    }
                ]);
                function GoogleAnalytics(container) {
                    (0, _classCallCheck3.default)(this, GoogleAnalytics);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _ContainerPlugin.call(this, container));
                    if (_this.container.options.gaAccount) {
                        _this.account = _this.container.options.gaAccount;
                        _this.trackerName = _this.container.options.gaTrackerName ? _this.container.options.gaTrackerName + '.' : 'Clappr.';
                        _this.domainName = _this.container.options.gaDomainName;
                        _this.currentHDState = undefined;
                        _this.embedScript();
                    }
                    return _this;
                }
                GoogleAnalytics.prototype.embedScript = function embedScript() {
                    var _this2 = this;
                    if (!window._gat) {
                        var script = document.createElement('script');
                        script.setAttribute('type', 'text/javascript');
                        script.setAttribute('async', 'async');
                        script.setAttribute('src', '//www.google-analytics.com/ga.js');
                        script.onload = function() {
                            return _this2.addEventListeners();
                        };
                        document.body.appendChild(script);
                    } else this.addEventListeners();
                };
                GoogleAnalytics.prototype.addEventListeners = function addEventListeners() {
                    var _this3 = this;
                    if (this.container) {
                        this.listenTo(this.container, _events2.default.CONTAINER_READY, this.onReady);
                        this.listenTo(this.container, _events2.default.CONTAINER_PLAY, this.onPlay);
                        this.listenTo(this.container, _events2.default.CONTAINER_STOP, this.onStop);
                        this.listenTo(this.container, _events2.default.CONTAINER_PAUSE, this.onPause);
                        this.listenTo(this.container, _events2.default.CONTAINER_ENDED, this.onEnded);
                        this.listenTo(this.container, _events2.default.CONTAINER_STATE_BUFFERING, this.onBuffering);
                        this.listenTo(this.container, _events2.default.CONTAINER_STATE_BUFFERFULL, this.onBufferFull);
                        this.listenTo(this.container, _events2.default.CONTAINER_ERROR, this.onError);
                        this.listenTo(this.container, _events2.default.CONTAINER_PLAYBACKSTATE, this.onPlaybackChanged);
                        this.listenTo(this.container, _events2.default.CONTAINER_VOLUME, function(event) {
                            return _this3.onVolumeChanged(event);
                        });
                        this.listenTo(this.container, _events2.default.CONTAINER_SEEK, function(event) {
                            return _this3.onSeek(event);
                        });
                        this.listenTo(this.container, _events2.default.CONTAINER_FULL_SCREEN, this.onFullscreen);
                        this.listenTo(this.container, _events2.default.CONTAINER_HIGHDEFINITIONUPDATE, this.onHD);
                        this.listenTo(this.container, _events2.default.CONTAINER_PLAYBACKDVRSTATECHANGED, this.onDVR);
                    }
                    _gaq.push([
                        this.trackerName + '_setAccount',
                        this.account
                    ]);
                    if (this.domainName) _gaq.push([
                        this.trackerName + '_setDomainName',
                        this.domainName
                    ]);
                };
                GoogleAnalytics.prototype.onReady = function onReady() {
                    this.push([
                        'Video',
                        'Playback',
                        this.container.playback.name
                    ]);
                };
                GoogleAnalytics.prototype.onPlay = function onPlay() {
                    this.push([
                        'Video',
                        'Play',
                        this.container.playback.src
                    ]);
                };
                GoogleAnalytics.prototype.onStop = function onStop() {
                    this.push([
                        'Video',
                        'Stop',
                        this.container.playback.src
                    ]);
                };
                GoogleAnalytics.prototype.onEnded = function onEnded() {
                    this.push([
                        'Video',
                        'Ended',
                        this.container.playback.src
                    ]);
                };
                GoogleAnalytics.prototype.onBuffering = function onBuffering() {
                    this.push([
                        'Video',
                        'Buffering',
                        this.container.playback.src
                    ]);
                };
                GoogleAnalytics.prototype.onBufferFull = function onBufferFull() {
                    this.push([
                        'Video',
                        'Bufferfull',
                        this.container.playback.src
                    ]);
                };
                GoogleAnalytics.prototype.onError = function onError() {
                    this.push([
                        'Video',
                        'Error',
                        this.container.playback.src
                    ]);
                };
                GoogleAnalytics.prototype.onHD = function onHD(isHD) {
                    var status = isHD ? 'ON' : 'OFF';
                    if (status !== this.currentHDState) {
                        this.currentHDState = status;
                        this.push([
                            'Video',
                            'HD - ' + status,
                            this.container.playback.src
                        ]);
                    }
                };
                GoogleAnalytics.prototype.onPlaybackChanged = function onPlaybackChanged(playbackState) {
                    if (playbackState.type !== null) this.push([
                        'Video',
                        'Playback Type - ' + playbackState.type,
                        this.container.playback.src
                    ]);
                };
                GoogleAnalytics.prototype.onDVR = function onDVR(dvrInUse) {
                    var status = dvrInUse ? 'ON' : 'OFF';
                    this.push([
                        'Interaction',
                        'DVR - ' + status,
                        this.container.playback.src
                    ]);
                };
                GoogleAnalytics.prototype.onPause = function onPause() {
                    this.push([
                        'Video',
                        'Pause',
                        this.container.playback.src
                    ]);
                };
                GoogleAnalytics.prototype.onSeek = function onSeek() {
                    this.push([
                        'Video',
                        'Seek',
                        this.container.playback.src
                    ]);
                };
                GoogleAnalytics.prototype.onVolumeChanged = function onVolumeChanged() {
                    this.push([
                        'Interaction',
                        'Volume',
                        this.container.playback.src
                    ]);
                };
                GoogleAnalytics.prototype.onFullscreen = function onFullscreen() {
                    this.push([
                        'Interaction',
                        'Fullscreen',
                        this.container.playback.src
                    ]);
                };
                GoogleAnalytics.prototype.push = function push(array) {
                    var res = [
                        this.trackerName + '_trackEvent'
                    ].concat(array);
                    _gaq.push(res);
                };
                return GoogleAnalytics;
            }(_container_plugin2.default);
            exports.default = GoogleAnalytics;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/google_analytics/index.js": /*!***********************************************!*\
  !*** ./src/plugins/google_analytics/index.js ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _google_analytics = __webpack_require__(/*! ./google_analytics */ "./src/plugins/google_analytics/google_analytics.js");
            var _google_analytics2 = _interopRequireDefault(_google_analytics);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _google_analytics2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/log/index.js": /*!**********************************!*\
  !*** ./src/plugins/log/index.js ***!
  \**********************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _log = __webpack_require__(/*! ./log */ "./src/plugins/log/log.js");
            var _log2 = _interopRequireDefault(_log);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _log2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/log/log.js": /*!********************************!*\
  !*** ./src/plugins/log/log.js ***!
  \********************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _vendor = __webpack_require__(/*! ../../vendor */ "./src/vendor/index.js");
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var BOLD = 'font-weight: bold; font-size: 13px;';
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            var INFO = 'color: #006600;' + BOLD;
            var DEBUG1 = 'color: #0000ff;' + BOLD;
            var WARN = 'color: #ff8000;' + BOLD;
            var ERROR = 'color: #ff0000;' + BOLD;
            var LEVEL_DEBUG = 0;
            var LEVEL_INFO = 1;
            var LEVEL_WARN = 2;
            var LEVEL_ERROR = 3;
            var LEVEL_DISABLED = LEVEL_ERROR;
            var COLORS = [
                DEBUG1,
                INFO,
                WARN,
                ERROR,
                ERROR
            ];
            var DESCRIPTIONS = [
                'debug',
                'info',
                'warn',
                'error',
                'disabled'
            ];
            var Log = function() {
                function Log() {
                    var _this = this;
                    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LEVEL_INFO;
                    var offLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LEVEL_DISABLED;
                    (0, _classCallCheck3.default)(this, Log);
                    this.kibo = new _vendor.Kibo();
                    this.kibo.down([
                        'ctrl shift d'
                    ], function() {
                        return _this.onOff();
                    });
                    this.BLACKLIST = [
                        'timeupdate',
                        'playback:timeupdate',
                        'playback:progress',
                        'container:hover',
                        'container:timeupdate',
                        'container:progress'
                    ];
                    this.level = level;
                    this.offLevel = offLevel;
                }
                Log.prototype.debug = function debug(klass) {
                    this.log(klass, LEVEL_DEBUG, Array.prototype.slice.call(arguments, 1));
                };
                Log.prototype.info = function info(klass) {
                    this.log(klass, LEVEL_INFO, Array.prototype.slice.call(arguments, 1));
                };
                Log.prototype.warn = function warn(klass) {
                    this.log(klass, LEVEL_WARN, Array.prototype.slice.call(arguments, 1));
                };
                Log.prototype.error = function error(klass) {
                    this.log(klass, LEVEL_ERROR, Array.prototype.slice.call(arguments, 1));
                };
                Log.prototype.onOff = function onOff() {
                    if (this.level === this.offLevel) this.level = this.previousLevel;
                    else {
                        this.previousLevel = this.level;
                        this.level = this.offLevel;
                    }
                    // handle instances where console.log is unavailable
                    if (window.console && window.console.log) window.console.log('%c[Clappr.Log] set log level to ' + DESCRIPTIONS[this.level], WARN);
                };
                Log.prototype.level = function level(newLevel) {
                    this.level = newLevel;
                };
                Log.prototype.log = function log(klass, level, message) {
                    if (this.BLACKLIST.indexOf(message[0]) >= 0) return;
                    if (level < this.level) return;
                    if (!message) {
                        message = klass;
                        klass = null;
                    }
                    var color = COLORS[level];
                    var klassDescription = '';
                    if (klass) klassDescription = '[' + klass + ']';
                    if (window.console && window.console.log) window.console.log.apply(console, [
                        '%c[' + DESCRIPTIONS[level] + ']' + klassDescription,
                        color
                    ].concat(message));
                };
                return Log;
            }();
            exports.default = Log;
            Log.LEVEL_DEBUG = LEVEL_DEBUG;
            Log.LEVEL_INFO = LEVEL_INFO;
            Log.LEVEL_WARN = LEVEL_WARN;
            Log.LEVEL_ERROR = LEVEL_ERROR;
            Log.getInstance = function() {
                if (this._instance === undefined) {
                    this._instance = new this();
                    this._instance.previousLevel = this._instance.level;
                    this._instance.level = this._instance.offLevel;
                }
                return this._instance;
            };
            Log.setLevel = function(level) {
                this.getInstance().level = level;
            };
            Log.debug = function() {
                this.getInstance().debug.apply(this.getInstance(), arguments);
            };
            Log.info = function() {
                this.getInstance().info.apply(this.getInstance(), arguments);
            };
            Log.warn = function() {
                this.getInstance().warn.apply(this.getInstance(), arguments);
            };
            Log.error = function() {
                this.getInstance().error.apply(this.getInstance(), arguments);
            };
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/media_control/index.js": /*!********************************************!*\
  !*** ./src/plugins/media_control/index.js ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _media_control = __webpack_require__(/*! ./media_control */ "./src/plugins/media_control/media_control.js");
            var _media_control2 = _interopRequireDefault(_media_control);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _media_control2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/media_control/media_control.js": /*!****************************************************!*\
  !*** ./src/plugins/media_control/media_control.js ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(process) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _stringify = __webpack_require__(/*! babel-runtime/core-js/json/stringify */ "./node_modules/babel-runtime/core-js/json/stringify.js");
                var _stringify2 = _interopRequireDefault(_stringify);
                var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
                var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
                var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
                var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
                var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
                var _createClass3 = _interopRequireDefault(_createClass2);
                var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
                var _inherits3 = _interopRequireDefault(_inherits2);
                var _utils = __webpack_require__(/*! ../../base/utils */ "./src/base/utils.js");
                var _vendor = __webpack_require__(/*! ../../vendor */ "./src/vendor/index.js");
                var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
                var _events2 = _interopRequireDefault(_events);
                var _ui_core_plugin = __webpack_require__(/*! ../../base/ui_core_plugin */ "./src/base/ui_core_plugin.js");
                var _ui_core_plugin2 = _interopRequireDefault(_ui_core_plugin);
                var _browser = __webpack_require__(/*! ../../components/browser */ "./src/components/browser/index.js");
                var _browser2 = _interopRequireDefault(_browser);
                var _mediator = __webpack_require__(/*! ../../components/mediator */ "./src/components/mediator.js");
                var _mediator2 = _interopRequireDefault(_mediator);
                var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
                var _template2 = _interopRequireDefault(_template);
                var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
                var _playback2 = _interopRequireDefault(_playback);
                var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
                var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
                __webpack_require__(/*! ./public/media-control.scss */ "./src/plugins/media_control/public/media-control.scss");
                var _mediaControl = __webpack_require__(/*! ./public/media-control.html */ "./src/plugins/media_control/public/media-control.html");
                var _mediaControl2 = _interopRequireDefault(_mediaControl);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                // Copyright 2014 Globo.com Player authors. All rights reserved.
                // Use of this source code is governed by a BSD-style
                // license that can be found in the LICENSE file.
                /**
 * The MediaControl is responsible for displaying the Player controls.
 */ var MediaControl = function(_UICorePlugin) {
                    (0, _inherits3.default)(MediaControl, _UICorePlugin);
                    (0, _createClass3.default)(MediaControl, [
                        {
                            key: 'name',
                            get: function get() {
                                return 'media_control';
                            }
                        },
                        {
                            key: 'disabled',
                            get: function get() {
                                var playbackIsNOOP = this.container && this.container.getPlaybackType() === _playback2.default.NO_OP;
                                return this.userDisabled || playbackIsNOOP;
                            }
                        },
                        {
                            key: 'container',
                            get: function get() {
                                return this.core && this.core.activeContainer;
                            }
                        },
                        {
                            key: 'playback',
                            get: function get() {
                                return this.core && this.core.activePlayback;
                            }
                        },
                        {
                            key: 'attributes',
                            get: function get() {
                                return {
                                    'class': 'media-control',
                                    'data-media-control': ''
                                };
                            }
                        },
                        {
                            key: 'events',
                            get: function get() {
                                return {
                                    'click [data-play]': 'play',
                                    'click [data-pause]': 'pause',
                                    'click [data-playpause]': 'togglePlayPause',
                                    'click [data-stop]': 'stop',
                                    'click [data-playstop]': 'togglePlayStop',
                                    'click [data-fullscreen]': 'toggleFullscreen',
                                    'click .bar-container[data-seekbar]': 'seek',
                                    'click .bar-container[data-volume]': 'onVolumeClick',
                                    'click .drawer-icon[data-volume]': 'toggleMute',
                                    'mouseenter .drawer-container[data-volume]': 'showVolumeBar',
                                    'mouseleave .drawer-container[data-volume]': 'hideVolumeBar',
                                    'mousedown .bar-container[data-volume]': 'startVolumeDrag',
                                    'mousemove .bar-container[data-volume]': 'mousemoveOnVolumeBar',
                                    'mousedown .bar-scrubber[data-seekbar]': 'startSeekDrag',
                                    'mousemove .bar-container[data-seekbar]': 'mousemoveOnSeekBar',
                                    'mouseleave .bar-container[data-seekbar]': 'mouseleaveOnSeekBar',
                                    'mouseenter .media-control-layer[data-controls]': 'setUserKeepVisible',
                                    'mouseleave .media-control-layer[data-controls]': 'resetUserKeepVisible'
                                };
                            }
                        },
                        {
                            key: 'template',
                            get: function get() {
                                return (0, _template2.default)(_mediaControl2.default);
                            }
                        },
                        {
                            key: 'volume',
                            get: function get() {
                                return this.container && this.container.isReady ? this.container.volume : this.intendedVolume;
                            }
                        },
                        {
                            key: 'muted',
                            get: function get() {
                                return this.volume === 0;
                            }
                        }
                    ]);
                    function MediaControl(core) {
                        (0, _classCallCheck3.default)(this, MediaControl);
                        var _this = (0, _possibleConstructorReturn3.default)(this, _UICorePlugin.call(this, core));
                        _this.persistConfig = _this.options.persistConfig;
                        _this.currentPositionValue = null;
                        _this.currentDurationValue = null;
                        _this.keepVisible = false;
                        _this.fullScreenOnVideoTagSupported = null; // unknown
                        _this.setInitialVolume();
                        _this.settings = {
                            left: [
                                'play',
                                'stop',
                                'pause'
                            ],
                            right: [
                                'volume'
                            ],
                            default: [
                                'position',
                                'seekbar',
                                'duration'
                            ]
                        };
                        _this.kibo = new _vendor.Kibo(_this.options.focusElement);
                        _this.bindKeyEvents();
                        if (_this.container) {
                            if (!_clapprZepto2.default.isEmptyObject(_this.container.settings)) _this.settings = _clapprZepto2.default.extend({}, _this.container.settings);
                        } else _this.settings = {};
                        _this.userDisabled = false;
                        if (_this.container && _this.container.mediaControlDisabled || _this.options.chromeless) _this.disable();
                        _this.stopDragHandler = function(event) {
                            return _this.stopDrag(event);
                        };
                        _this.updateDragHandler = function(event) {
                            return _this.updateDrag(event);
                        };
                        (0, _clapprZepto2.default)(document).bind('mouseup', _this.stopDragHandler);
                        (0, _clapprZepto2.default)(document).bind('mousemove', _this.updateDragHandler);
                        return _this;
                    }
                    MediaControl.prototype.getExternalInterface = function getExternalInterface() {
                        var _this2 = this;
                        return {
                            setVolume: this.setVolume,
                            getVolume: function getVolume() {
                                return _this2.volume;
                            }
                        };
                    };
                    MediaControl.prototype.bindEvents = function bindEvents() {
                        var _this3 = this;
                        this.stopListening();
                        this.listenTo(this.core, _events2.default.CORE_ACTIVE_CONTAINER_CHANGED, this.onActiveContainerChanged);
                        this.listenTo(this.core, _events2.default.CORE_MOUSE_MOVE, this.show);
                        this.listenTo(this.core, _events2.default.CORE_MOUSE_LEAVE, function() {
                            return _this3.hide(_this3.options.hideMediaControlDelay);
                        });
                        this.listenTo(this.core, _events2.default.CORE_FULLSCREEN, this.show);
                        this.listenTo(this.core, _events2.default.CORE_OPTIONS_CHANGE, this.configure);
                        _mediator2.default.on(this.options.playerId + ':' + _events2.default.PLAYER_RESIZE, this.playerResize, this);
                        this.bindContainerEvents();
                    };
                    MediaControl.prototype.bindContainerEvents = function bindContainerEvents() {
                        if (!this.container) return;
                        this.listenTo(this.container, _events2.default.CONTAINER_PLAY, this.changeTogglePlay);
                        this.listenTo(this.container, _events2.default.CONTAINER_PAUSE, this.changeTogglePlay);
                        this.listenTo(this.container, _events2.default.CONTAINER_STOP, this.changeTogglePlay);
                        this.listenTo(this.container, _events2.default.CONTAINER_DBLCLICK, this.toggleFullscreen);
                        this.listenTo(this.container, _events2.default.CONTAINER_TIMEUPDATE, this.onTimeUpdate);
                        this.listenTo(this.container, _events2.default.CONTAINER_PROGRESS, this.updateProgressBar);
                        this.listenTo(this.container, _events2.default.CONTAINER_SETTINGSUPDATE, this.settingsUpdate);
                        this.listenTo(this.container, _events2.default.CONTAINER_PLAYBACKDVRSTATECHANGED, this.settingsUpdate);
                        this.listenTo(this.container, _events2.default.CONTAINER_HIGHDEFINITIONUPDATE, this.highDefinitionUpdate);
                        this.listenTo(this.container, _events2.default.CONTAINER_MEDIACONTROL_DISABLE, this.disable);
                        this.listenTo(this.container, _events2.default.CONTAINER_MEDIACONTROL_ENABLE, this.enable);
                        this.listenTo(this.container, _events2.default.CONTAINER_ENDED, this.ended);
                        this.listenTo(this.container, _events2.default.CONTAINER_VOLUME, this.onVolumeChanged);
                        this.listenTo(this.container, _events2.default.CONTAINER_OPTIONS_CHANGE, this.setInitialVolume);
                        if (this.container.playback.el.nodeName.toLowerCase() === 'video') // wait until the metadata has loaded and then check if fullscreen on video tag is supported
                        this.listenToOnce(this.container, _events2.default.CONTAINER_LOADEDMETADATA, this.onLoadedMetadataOnVideoTag);
                    };
                    MediaControl.prototype.disable = function disable() {
                        this.userDisabled = true;
                        this.hide();
                        this.unbindKeyEvents();
                        this.$el.hide();
                    };
                    MediaControl.prototype.enable = function enable() {
                        if (this.options.chromeless) return;
                        this.userDisabled = false;
                        this.bindKeyEvents();
                        this.show();
                    };
                    MediaControl.prototype.play = function play() {
                        this.container && this.container.play();
                    };
                    MediaControl.prototype.pause = function pause() {
                        this.container && this.container.pause();
                    };
                    MediaControl.prototype.stop = function stop() {
                        this.container && this.container.stop();
                    };
                    MediaControl.prototype.setInitialVolume = function setInitialVolume() {
                        var initialVolume = this.persistConfig ? _utils.Config.restore('volume') : 100;
                        var options = this.container && this.container.options || this.options;
                        this.setVolume(options.mute ? 0 : initialVolume, true);
                    };
                    MediaControl.prototype.onVolumeChanged = function onVolumeChanged() {
                        this.updateVolumeUI();
                    };
                    MediaControl.prototype.onLoadedMetadataOnVideoTag = function onLoadedMetadataOnVideoTag() {
                        var video = this.playback && this.playback.el;
                        // video.webkitSupportsFullscreen is deprecated but iOS appears to only use this
                        // see https://github.com/clappr/clappr/issues/1127
                        if (!_utils.Fullscreen.fullscreenEnabled() && video.webkitSupportsFullscreen) {
                            this.fullScreenOnVideoTagSupported = true;
                            this.settingsUpdate();
                        }
                    };
                    MediaControl.prototype.updateVolumeUI = function updateVolumeUI() {
                        // this will be called after a render
                        if (!this.rendered) return;
                        // update volume bar scrubber/fill on bar mode
                        this.$volumeBarContainer.find('.bar-fill-2').css({});
                        var containerWidth = this.$volumeBarContainer.width();
                        var barWidth = this.$volumeBarBackground.width();
                        var offset = (containerWidth - barWidth) / 2.0;
                        var pos = barWidth * this.volume / 100.0 + offset;
                        this.$volumeBarFill.css({
                            width: this.volume + '%'
                        });
                        this.$volumeBarScrubber.css({
                            left: pos
                        });
                        // update volume bar segments on segmented bar mode
                        this.$volumeBarContainer.find('.segmented-bar-element').removeClass('fill');
                        var item = Math.ceil(this.volume / 10.0);
                        this.$volumeBarContainer.find('.segmented-bar-element').slice(0, item).addClass('fill');
                        this.$volumeIcon.html('');
                        this.$volumeIcon.removeClass('muted');
                        if (!this.muted) this.$volumeIcon.append(_utils.SvgIcons.volume);
                        else {
                            this.$volumeIcon.append(_utils.SvgIcons.volumeMute);
                            this.$volumeIcon.addClass('muted');
                        }
                        this.applyButtonStyle(this.$volumeIcon);
                    };
                    MediaControl.prototype.changeTogglePlay = function changeTogglePlay() {
                        this.$playPauseToggle.html('');
                        this.$playStopToggle.html('');
                        if (this.container && this.container.isPlaying()) {
                            this.$playPauseToggle.append(_utils.SvgIcons.pause);
                            this.$playStopToggle.append(_utils.SvgIcons.stop);
                            this.trigger(_events2.default.MEDIACONTROL_PLAYING);
                        } else {
                            this.$playPauseToggle.append(_utils.SvgIcons.play);
                            this.$playStopToggle.append(_utils.SvgIcons.play);
                            this.trigger(_events2.default.MEDIACONTROL_NOTPLAYING);
                            _browser2.default.isMobile && this.show();
                        }
                        this.applyButtonStyle(this.$playPauseToggle);
                        this.applyButtonStyle(this.$playStopToggle);
                    };
                    MediaControl.prototype.mousemoveOnSeekBar = function mousemoveOnSeekBar(event) {
                        if (this.settings.seekEnabled) {
                            var offsetX = event.pageX - this.$seekBarContainer.offset().left - this.$seekBarHover.width() / 2;
                            this.$seekBarHover.css({
                                left: offsetX
                            });
                        }
                        this.trigger(_events2.default.MEDIACONTROL_MOUSEMOVE_SEEKBAR, event);
                    };
                    MediaControl.prototype.mouseleaveOnSeekBar = function mouseleaveOnSeekBar(event) {
                        this.trigger(_events2.default.MEDIACONTROL_MOUSELEAVE_SEEKBAR, event);
                    };
                    MediaControl.prototype.onVolumeClick = function onVolumeClick(event) {
                        this.setVolume(this.getVolumeFromUIEvent(event));
                    };
                    MediaControl.prototype.mousemoveOnVolumeBar = function mousemoveOnVolumeBar(event) {
                        this.draggingVolumeBar && this.setVolume(this.getVolumeFromUIEvent(event));
                    };
                    MediaControl.prototype.playerResize = function playerResize(size) {
                        this.$fullscreenToggle.html('');
                        var icon = this.core.isFullscreen() ? _utils.SvgIcons.exitFullscreen : _utils.SvgIcons.fullscreen;
                        this.$fullscreenToggle.append(icon);
                        this.applyButtonStyle(this.$fullscreenToggle);
                        this.$el.find('.media-control').length !== 0 && this.$el.removeClass('w320');
                        if (size.width <= 320 || this.options.hideVolumeBar) this.$el.addClass('w320');
                    };
                    MediaControl.prototype.togglePlayPause = function togglePlayPause() {
                        this.container.isPlaying() ? this.container.pause() : this.container.play();
                        return false;
                    };
                    MediaControl.prototype.togglePlayStop = function togglePlayStop() {
                        this.container.isPlaying() ? this.container.stop() : this.container.play();
                    };
                    MediaControl.prototype.startSeekDrag = function startSeekDrag(event) {
                        if (!this.settings.seekEnabled) return;
                        this.draggingSeekBar = true;
                        this.$el.addClass('dragging');
                        this.$seekBarLoaded.addClass('media-control-notransition');
                        this.$seekBarPosition.addClass('media-control-notransition');
                        this.$seekBarScrubber.addClass('media-control-notransition');
                        event && event.preventDefault();
                    };
                    MediaControl.prototype.startVolumeDrag = function startVolumeDrag(event) {
                        this.draggingVolumeBar = true;
                        this.$el.addClass('dragging');
                        event && event.preventDefault();
                    };
                    MediaControl.prototype.stopDrag = function stopDrag(event) {
                        this.draggingSeekBar && this.seek(event);
                        this.$el.removeClass('dragging');
                        this.$seekBarLoaded.removeClass('media-control-notransition');
                        this.$seekBarPosition.removeClass('media-control-notransition');
                        this.$seekBarScrubber.removeClass('media-control-notransition dragging');
                        this.draggingSeekBar = false;
                        this.draggingVolumeBar = false;
                    };
                    MediaControl.prototype.updateDrag = function updateDrag(event) {
                        if (this.draggingSeekBar) {
                            event.preventDefault();
                            var offsetX = event.pageX - this.$seekBarContainer.offset().left;
                            var pos = offsetX / this.$seekBarContainer.width() * 100;
                            pos = Math.min(100, Math.max(pos, 0));
                            this.setSeekPercentage(pos);
                        } else if (this.draggingVolumeBar) {
                            event.preventDefault();
                            this.setVolume(this.getVolumeFromUIEvent(event));
                        }
                    };
                    MediaControl.prototype.getVolumeFromUIEvent = function getVolumeFromUIEvent(event) {
                        var offsetY = event.pageX - this.$volumeBarContainer.offset().left;
                        var volumeFromUI = offsetY / this.$volumeBarContainer.width() * 100;
                        return volumeFromUI;
                    };
                    MediaControl.prototype.toggleMute = function toggleMute() {
                        if (this.muted) {
                            this.setVolume(this._mutedVolume || 100);
                            this._mutedVolume = null;
                            return;
                        }
                        this._mutedVolume = this.volume;
                        this.setVolume(0);
                    };
                    MediaControl.prototype.setVolume = function setVolume(value) {
                        var _this4 = this;
                        var isInitialVolume = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        value = Math.min(100, Math.max(value, 0));
                        // this will hold the intended volume
                        // it may not actually get set to this straight away
                        // if the container is not ready etc
                        this.intendedVolume = value;
                        this.persistConfig && !isInitialVolume && _utils.Config.persist('volume', value);
                        var setWhenContainerReady = function setWhenContainerReady() {
                            if (_this4.container && _this4.container.isReady) _this4.container.setVolume(value);
                            else _this4.listenToOnce(_this4.container, _events2.default.CONTAINER_READY, function() {
                                _this4.container.setVolume(value);
                            });
                        };
                        if (!this.container) this.listenToOnce(this, _events2.default.MEDIACONTROL_CONTAINERCHANGED, function() {
                            return setWhenContainerReady();
                        });
                        else setWhenContainerReady();
                    };
                    MediaControl.prototype.toggleFullscreen = function toggleFullscreen() {
                        this.trigger(_events2.default.MEDIACONTROL_FULLSCREEN, this.name);
                        this.container.fullscreen();
                        this.core.toggleFullscreen();
                        this.resetUserKeepVisible();
                    };
                    MediaControl.prototype.onActiveContainerChanged = function onActiveContainerChanged() {
                        this.fullScreenOnVideoTagSupported = null;
                        _mediator2.default.off(this.options.playerId + ':' + _events2.default.PLAYER_RESIZE, this.playerResize, this);
                        this.bindEvents();
                        // set the new container to match the volume of the last one
                        this.setInitialVolume();
                        this.changeTogglePlay();
                        this.bindContainerEvents();
                        this.settingsUpdate();
                        this.container && this.container.trigger(_events2.default.CONTAINER_PLAYBACKDVRSTATECHANGED, this.container.isDvrInUse());
                        this.container && this.container.mediaControlDisabled && this.disable();
                        this.trigger(_events2.default.MEDIACONTROL_CONTAINERCHANGED);
                    };
                    MediaControl.prototype.showVolumeBar = function showVolumeBar() {
                        this.hideVolumeId && clearTimeout(this.hideVolumeId);
                        this.$volumeBarContainer.removeClass('volume-bar-hide');
                    };
                    MediaControl.prototype.hideVolumeBar = function hideVolumeBar() {
                        var _this5 = this;
                        var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 400;
                        if (!this.$volumeBarContainer) return;
                        if (this.draggingVolumeBar) this.hideVolumeId = setTimeout(function() {
                            return _this5.hideVolumeBar();
                        }, timeout);
                        else {
                            this.hideVolumeId && clearTimeout(this.hideVolumeId);
                            this.hideVolumeId = setTimeout(function() {
                                return _this5.$volumeBarContainer.addClass('volume-bar-hide');
                            }, timeout);
                        }
                    };
                    MediaControl.prototype.ended = function ended() {
                        this.changeTogglePlay();
                    };
                    MediaControl.prototype.updateProgressBar = function updateProgressBar(progress) {
                        var loadedStart = progress.start / progress.total * 100;
                        var loadedEnd = progress.current / progress.total * 100;
                        this.$seekBarLoaded.css({
                            left: loadedStart + '%',
                            width: loadedEnd - loadedStart + '%'
                        });
                    };
                    MediaControl.prototype.onTimeUpdate = function onTimeUpdate(timeProgress) {
                        if (this.draggingSeekBar) return;
                        // TODO why should current time ever be negative?
                        var position = timeProgress.current < 0 ? timeProgress.total : timeProgress.current;
                        this.currentPositionValue = position;
                        this.currentDurationValue = timeProgress.total;
                        this.renderSeekBar();
                    };
                    MediaControl.prototype.renderSeekBar = function renderSeekBar() {
                        // this will be triggered as soon as these become available
                        if (this.currentPositionValue === null || this.currentDurationValue === null) return;
                        // default to 100%
                        this.currentSeekBarPercentage = 100;
                        if (this.container && (this.container.getPlaybackType() !== _playback2.default.LIVE || this.container.isDvrInUse())) this.currentSeekBarPercentage = this.currentPositionValue / this.currentDurationValue * 100;
                        this.setSeekPercentage(this.currentSeekBarPercentage);
                        var newPosition = (0, _utils.formatTime)(this.currentPositionValue);
                        var newDuration = (0, _utils.formatTime)(this.currentDurationValue);
                        if (newPosition !== this.displayedPosition) {
                            this.$position.text(newPosition);
                            this.displayedPosition = newPosition;
                        }
                        if (newDuration !== this.displayedDuration) {
                            this.$duration.text(newDuration);
                            this.displayedDuration = newDuration;
                        }
                    };
                    MediaControl.prototype.seek = function seek(event) {
                        if (!this.settings.seekEnabled) return;
                        var offsetX = event.pageX - this.$seekBarContainer.offset().left;
                        var pos = offsetX / this.$seekBarContainer.width() * 100;
                        pos = Math.min(100, Math.max(pos, 0));
                        this.container && this.container.seekPercentage(pos);
                        this.setSeekPercentage(pos);
                        return false;
                    };
                    MediaControl.prototype.setKeepVisible = function setKeepVisible() {
                        this.keepVisible = true;
                    };
                    MediaControl.prototype.resetKeepVisible = function resetKeepVisible() {
                        this.keepVisible = false;
                    };
                    MediaControl.prototype.setUserKeepVisible = function setUserKeepVisible() {
                        this.userKeepVisible = true;
                    };
                    MediaControl.prototype.resetUserKeepVisible = function resetUserKeepVisible() {
                        this.userKeepVisible = false;
                    };
                    MediaControl.prototype.isVisible = function isVisible() {
                        return !this.$el.hasClass('media-control-hide');
                    };
                    MediaControl.prototype.show = function show(event) {
                        var _this6 = this;
                        if (this.disabled) return;
                        var timeout = 2000;
                        var mousePointerMoved = event && event.clientX !== this.lastMouseX && event.clientY !== this.lastMouseY;
                        if (!event || mousePointerMoved || navigator.userAgent.match(/firefox/i)) {
                            clearTimeout(this.hideId);
                            this.$el.show();
                            this.trigger(_events2.default.MEDIACONTROL_SHOW, this.name);
                            this.container && this.container.trigger(_events2.default.CONTAINER_MEDIACONTROL_SHOW, this.name);
                            this.$el.removeClass('media-control-hide');
                            this.hideId = setTimeout(function() {
                                return _this6.hide();
                            }, timeout);
                            if (event) {
                                this.lastMouseX = event.clientX;
                                this.lastMouseY = event.clientY;
                            }
                        }
                        var showing = true;
                        this.updateCursorStyle(showing);
                    };
                    MediaControl.prototype.hide = function hide() {
                        var _this7 = this;
                        var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                        if (!this.isVisible()) return;
                        var timeout = delay || 2000;
                        clearTimeout(this.hideId);
                        if (!this.disabled && this.options.hideMediaControl === false) return;
                        var hasKeepVisibleRequested = this.userKeepVisible || this.keepVisible;
                        var hasDraggingAction = this.draggingSeekBar || this.draggingVolumeBar;
                        if (!this.disabled && (delay || hasKeepVisibleRequested || hasDraggingAction)) this.hideId = setTimeout(function() {
                            return _this7.hide();
                        }, timeout);
                        else {
                            this.trigger(_events2.default.MEDIACONTROL_HIDE, this.name);
                            this.container && this.container.trigger(_events2.default.CONTAINER_MEDIACONTROL_HIDE, this.name);
                            this.$el.addClass('media-control-hide');
                            this.hideVolumeBar(0);
                            var showing = false;
                            this.updateCursorStyle(showing);
                        }
                    };
                    MediaControl.prototype.updateCursorStyle = function updateCursorStyle(showing) {
                        if (showing) this.core.$el.removeClass('nocursor');
                        else if (this.core.isFullscreen()) this.core.$el.addClass('nocursor');
                    };
                    MediaControl.prototype.settingsUpdate = function settingsUpdate() {
                        var newSettings = this.getSettings();
                        if (newSettings && !this.fullScreenOnVideoTagSupported && !_utils.Fullscreen.fullscreenEnabled()) {
                            // remove fullscreen from settings if it is present
                            newSettings.default && (0, _utils.removeArrayItem)(newSettings.default, 'fullscreen');
                            newSettings.left && (0, _utils.removeArrayItem)(newSettings.left, 'fullscreen');
                            newSettings.right && (0, _utils.removeArrayItem)(newSettings.right, 'fullscreen');
                        }
                        var settingsChanged = (0, _stringify2.default)(this.settings) !== (0, _stringify2.default)(newSettings);
                        if (settingsChanged) {
                            this.settings = newSettings;
                            this.render();
                        }
                    };
                    MediaControl.prototype.getSettings = function getSettings() {
                        return _clapprZepto2.default.extend(true, {}, this.container && this.container.settings);
                    };
                    MediaControl.prototype.highDefinitionUpdate = function highDefinitionUpdate(isHD) {
                        this.isHD = isHD;
                        var method = isHD ? 'addClass' : 'removeClass';
                        this.$hdIndicator[method]('enabled');
                    };
                    MediaControl.prototype.createCachedElements = function createCachedElements() {
                        var $layer = this.$el.find('.media-control-layer');
                        this.$duration = $layer.find('.media-control-indicator[data-duration]');
                        this.$fullscreenToggle = $layer.find('button.media-control-button[data-fullscreen]');
                        this.$playPauseToggle = $layer.find('button.media-control-button[data-playpause]');
                        this.$playStopToggle = $layer.find('button.media-control-button[data-playstop]');
                        this.$position = $layer.find('.media-control-indicator[data-position]');
                        this.$seekBarContainer = $layer.find('.bar-container[data-seekbar]');
                        this.$seekBarHover = $layer.find('.bar-hover[data-seekbar]');
                        this.$seekBarLoaded = $layer.find('.bar-fill-1[data-seekbar]');
                        this.$seekBarPosition = $layer.find('.bar-fill-2[data-seekbar]');
                        this.$seekBarScrubber = $layer.find('.bar-scrubber[data-seekbar]');
                        this.$volumeBarContainer = $layer.find('.bar-container[data-volume]');
                        this.$volumeContainer = $layer.find('.drawer-container[data-volume]');
                        this.$volumeIcon = $layer.find('.drawer-icon[data-volume]');
                        this.$volumeBarBackground = this.$el.find('.bar-background[data-volume]');
                        this.$volumeBarFill = this.$el.find('.bar-fill-1[data-volume]');
                        this.$volumeBarScrubber = this.$el.find('.bar-scrubber[data-volume]');
                        this.$hdIndicator = this.$el.find('button.media-control-button[data-hd-indicator]');
                        this.resetIndicators();
                        this.initializeIcons();
                    };
                    MediaControl.prototype.resetIndicators = function resetIndicators() {
                        this.displayedPosition = this.$position.text();
                        this.displayedDuration = this.$duration.text();
                    };
                    MediaControl.prototype.initializeIcons = function initializeIcons() {
                        var $layer = this.$el.find('.media-control-layer');
                        $layer.find('button.media-control-button[data-play]').append(_utils.SvgIcons.play);
                        $layer.find('button.media-control-button[data-pause]').append(_utils.SvgIcons.pause);
                        $layer.find('button.media-control-button[data-stop]').append(_utils.SvgIcons.stop);
                        this.$playPauseToggle.append(_utils.SvgIcons.play);
                        this.$playStopToggle.append(_utils.SvgIcons.play);
                        this.$volumeIcon.append(_utils.SvgIcons.volume);
                        this.$fullscreenToggle.append(_utils.SvgIcons.fullscreen);
                        this.$hdIndicator.append(_utils.SvgIcons.hd);
                    };
                    MediaControl.prototype.setSeekPercentage = function setSeekPercentage(value) {
                        value = Math.max(Math.min(value, 100.0), 0);
                        // not changed since last update
                        if (this.displayedSeekBarPercentage === value) return;
                        this.displayedSeekBarPercentage = value;
                        this.$seekBarPosition.removeClass('media-control-notransition');
                        this.$seekBarScrubber.removeClass('media-control-notransition');
                        this.$seekBarPosition.css({
                            width: value + '%'
                        });
                        this.$seekBarScrubber.css({
                            left: value + '%'
                        });
                    };
                    MediaControl.prototype.seekRelative = function seekRelative(delta) {
                        if (!this.settings.seekEnabled) return;
                        var currentTime = this.container.getCurrentTime();
                        var duration = this.container.getDuration();
                        var position = Math.min(Math.max(currentTime + delta, 0), duration);
                        position = Math.min(position * 100 / duration, 100);
                        this.container.seekPercentage(position);
                    };
                    MediaControl.prototype.bindKeyAndShow = function bindKeyAndShow(key, callback) {
                        var _this8 = this;
                        this.kibo.down(key, function() {
                            _this8.show();
                            return callback();
                        });
                    };
                    MediaControl.prototype.bindKeyEvents = function bindKeyEvents() {
                        var _this9 = this;
                        if (_browser2.default.isMobile || this.options.disableKeyboardShortcuts) return;
                        this.unbindKeyEvents();
                        this.kibo = new _vendor.Kibo(this.options.focusElement || this.options.parentElement);
                        this.bindKeyAndShow('space', function() {
                            return _this9.togglePlayPause();
                        });
                        this.bindKeyAndShow('left', function() {
                            return _this9.seekRelative(-5);
                        });
                        this.bindKeyAndShow('right', function() {
                            return _this9.seekRelative(5);
                        });
                        this.bindKeyAndShow('shift left', function() {
                            return _this9.seekRelative(-10);
                        });
                        this.bindKeyAndShow('shift right', function() {
                            return _this9.seekRelative(10);
                        });
                        this.bindKeyAndShow('shift ctrl left', function() {
                            return _this9.seekRelative(-15);
                        });
                        this.bindKeyAndShow('shift ctrl right', function() {
                            return _this9.seekRelative(15);
                        });
                        var keys = [
                            '1',
                            '2',
                            '3',
                            '4',
                            '5',
                            '6',
                            '7',
                            '8',
                            '9',
                            '0'
                        ];
                        keys.forEach(function(i) {
                            _this9.bindKeyAndShow(i, function() {
                                _this9.settings.seekEnabled && _this9.container && _this9.container.seekPercentage(i * 10);
                            });
                        });
                    };
                    MediaControl.prototype.unbindKeyEvents = function unbindKeyEvents() {
                        if (this.kibo) {
                            this.kibo.off('space');
                            this.kibo.off('left');
                            this.kibo.off('right');
                            this.kibo.off('shift left');
                            this.kibo.off('shift right');
                            this.kibo.off('shift ctrl left');
                            this.kibo.off('shift ctrl right');
                            this.kibo.off([
                                '1',
                                '2',
                                '3',
                                '4',
                                '5',
                                '6',
                                '7',
                                '8',
                                '9',
                                '0'
                            ]);
                        }
                    };
                    MediaControl.prototype.parseColors = function parseColors() {
                        if (this.options.mediacontrol) {
                            this.buttonsColor = this.options.mediacontrol.buttons;
                            var seekbarColor = this.options.mediacontrol.seekbar;
                            this.$el.find('.bar-fill-2[data-seekbar]').css('background-color', seekbarColor);
                            this.$el.find('.media-control-icon svg path').css('fill', this.buttonsColor);
                            this.$el.find('.segmented-bar-element[data-volume]').css('boxShadow', 'inset 2px 0 0 ' + this.buttonsColor);
                        }
                    };
                    MediaControl.prototype.applyButtonStyle = function applyButtonStyle(element) {
                        this.buttonsColor && element && (0, _clapprZepto2.default)(element).find('svg path').css('fill', this.buttonsColor);
                    };
                    MediaControl.prototype.destroy = function destroy() {
                        (0, _clapprZepto2.default)(document).unbind('mouseup', this.stopDragHandler);
                        (0, _clapprZepto2.default)(document).unbind('mousemove', this.updateDragHandler);
                        this.unbindKeyEvents();
                        this.stopListening();
                        _UICorePlugin.prototype.destroy.call(this);
                    };
                    /**
   * enables to configure the media control after its creation
   * @method configure
   * @param {Object} options all the options to change in form of a javascript object
   */ MediaControl.prototype.configure = function configure(options) {
                        // Check if chromeless mode or if configure is called with new source(s)
                        if (this.options.chromeless || options.source || options.sources) this.disable();
                        else this.enable();
                        this.trigger(_events2.default.MEDIACONTROL_OPTIONS_CHANGE);
                    };
                    MediaControl.prototype.render = function render() {
                        var _this10 = this;
                        var timeout = this.options.hideMediaControlDelay || 2000;
                        this.settings && this.$el.html(this.template({
                            settings: this.settings
                        }));
                        this.createCachedElements();
                        this.$playPauseToggle.addClass('paused');
                        this.$playStopToggle.addClass('stopped');
                        this.changeTogglePlay();
                        if (this.container) {
                            this.hideId = setTimeout(function() {
                                return _this10.hide();
                            }, timeout);
                            this.disabled && this.hide();
                        }
                        // Video volume cannot be changed with Safari on mobile devices
                        // Display mute/unmute icon only if Safari version >= 10
                        if (_browser2.default.isSafari && _browser2.default.isMobile) {
                            if (_browser2.default.version < 10) this.$volumeContainer.css('display', 'none');
                            else this.$volumeBarContainer.css('display', 'none');
                        }
                        this.$seekBarPosition.addClass('media-control-notransition');
                        this.$seekBarScrubber.addClass('media-control-notransition');
                        var previousSeekPercentage = 0;
                        if (this.displayedSeekBarPercentage) previousSeekPercentage = this.displayedSeekBarPercentage;
                        this.displayedSeekBarPercentage = null;
                        this.setSeekPercentage(previousSeekPercentage);
                        process.nextTick(function() {
                            !_this10.settings.seekEnabled && _this10.$seekBarContainer.addClass('seek-disabled');
                            !_browser2.default.isMobile && !_this10.options.disableKeyboardShortcuts && _this10.bindKeyEvents();
                            _this10.playerResize({
                                width: _this10.options.width,
                                height: _this10.options.height
                            });
                            _this10.hideVolumeBar(0);
                        });
                        this.parseColors();
                        this.highDefinitionUpdate(this.isHD);
                        this.core.$el.append(this.el);
                        this.rendered = true;
                        this.updateVolumeUI();
                        this.trigger(_events2.default.MEDIACONTROL_RENDERED);
                        return this;
                    };
                    return MediaControl;
                }(_ui_core_plugin2.default);
                exports.default = MediaControl;
                MediaControl.extend = function(properties) {
                    return (0, _utils.extend)(MediaControl, properties);
                };
                module1.exports = exports['default'];
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(/*! ./../../../node_modules/node-libs-browser/node_modules/process/browser.js */ "./node_modules/node-libs-browser/node_modules/process/browser.js"));
        /***/ },
        /***/ "./src/plugins/media_control/public/closed-hand.cur": /*!**********************************************************!*\
  !*** ./src/plugins/media_control/public/closed-hand.cur ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<%=baseUrl%>/a8c874b93b3d848f39a71260c57e3863.cur";
        /***/ },
        /***/ "./src/plugins/media_control/public/media-control.html": /*!*************************************************************!*\
  !*** ./src/plugins/media_control/public/media-control.html ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<div class=\"media-control-background\" data-background></div>\n<div class=\"media-control-layer\" data-controls>\n  <%  var renderBar = function(name) { %>\n      <div class=\"bar-container\" data-<%= name %>>\n        <div class=\"bar-background\" data-<%= name %>>\n          <div class=\"bar-fill-1\" data-<%= name %>></div>\n          <div class=\"bar-fill-2\" data-<%= name %>></div>\n          <div class=\"bar-hover\" data-<%= name %>></div>\n        </div>\n        <div class=\"bar-scrubber\" data-<%= name %>>\n          <div class=\"bar-scrubber-icon\" data-<%= name %>></div>\n        </div>\n      </div>\n  <%  }; %>\n  <%  var renderSegmentedBar = function(name, segments) {\n      segments = segments || 10; %>\n    <div class=\"bar-container\" data-<%= name %>>\n    <% for (var i = 0; i < segments; i++) { %>\n      <div class=\"segmented-bar-element\" data-<%= name %>></div>\n    <% } %>\n    </div>\n  <% }; %>\n  <% var renderDrawer = function(name, renderContent) { %>\n      <div class=\"drawer-container\" data-<%= name %>>\n        <div class=\"drawer-icon-container\" data-<%= name %>>\n          <div class=\"drawer-icon media-control-icon\" data-<%= name %>></div>\n          <span class=\"drawer-text\" data-<%= name %>></span>\n        </div>\n        <% renderContent(name); %>\n      </div>\n  <% }; %>\n  <% var renderIndicator = function(name) { %>\n      <div class=\"media-control-indicator\" data-<%= name %>></div>\n  <% }; %>\n  <% var renderButton = function(name) { %>\n    <button type=\"button\" class=\"media-control-button media-control-icon\" data-<%= name %> aria-label=\"<%= name %>\"></button>\n  <% }; %>\n  <%  var templates = {\n        bar: renderBar,\n        segmentedBar: renderSegmentedBar,\n      };\n      var render = function(settingsList) {\n        settingsList.forEach(function(setting) {\n          if(setting === \"seekbar\") {\n            renderBar(setting);\n          } else if (setting === \"volume\") {\n            renderDrawer(setting, settings.volumeBarTemplate ? templates[settings.volumeBarTemplate] : function(name) { return renderSegmentedBar(name); });\n          } else if (setting === \"duration\" || setting === \"position\") {\n            renderIndicator(setting);\n          } else {\n            renderButton(setting);\n          }\n        });\n      }; %>\n  <% if (settings.default && settings.default.length) { %>\n  <div class=\"media-control-center-panel\" data-media-control>\n    <% render(settings.default); %>\n  </div>\n  <% } %>\n  <% if (settings.left && settings.left.length) { %>\n  <div class=\"media-control-left-panel\" data-media-control>\n    <% render(settings.left); %>\n  </div>\n  <% } %>\n  <% if (settings.right && settings.right.length) { %>\n  <div class=\"media-control-right-panel\" data-media-control>\n    <% render(settings.right); %>\n  </div>\n  <% } %>\n</div>\n";
        /***/ },
        /***/ "./src/plugins/media_control/public/media-control.scss": /*!*************************************************************!*\
  !*** ./src/plugins/media_control/public/media-control.scss ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./media-control.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/media_control/public/media-control.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/plugins/poster/index.js": /*!*************************************!*\
  !*** ./src/plugins/poster/index.js ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _poster = __webpack_require__(/*! ./poster */ "./src/plugins/poster/poster.js");
            var _poster2 = _interopRequireDefault(_poster);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _poster2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/poster/poster.js": /*!**************************************!*\
  !*** ./src/plugins/poster/poster.js ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(process) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
                var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
                var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
                var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
                var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
                var _createClass3 = _interopRequireDefault(_createClass2);
                var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
                var _inherits3 = _interopRequireDefault(_inherits2);
                var _ui_container_plugin = __webpack_require__(/*! ../../base/ui_container_plugin */ "./src/base/ui_container_plugin.js");
                var _ui_container_plugin2 = _interopRequireDefault(_ui_container_plugin);
                var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
                var _events2 = _interopRequireDefault(_events);
                var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
                var _template2 = _interopRequireDefault(_template);
                var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
                var _playback2 = _interopRequireDefault(_playback);
                var _error = __webpack_require__(/*! ../../components/error/error */ "./src/components/error/error.js");
                var _error2 = _interopRequireDefault(_error);
                var _poster = __webpack_require__(/*! ./public/poster.html */ "./src/plugins/poster/public/poster.html");
                var _poster2 = _interopRequireDefault(_poster);
                var _utils = __webpack_require__(/*! ../../base/utils */ "./src/base/utils.js");
                __webpack_require__(/*! ./public/poster.scss */ "./src/plugins/poster/public/poster.scss");
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                //Copyright 2014 Globo.com Player authors. All rights reserved.
                // Use of this source code is governed by a BSD-style
                // license that can be found in the LICENSE file.
                var PosterPlugin = function(_UIContainerPlugin) {
                    (0, _inherits3.default)(PosterPlugin, _UIContainerPlugin);
                    (0, _createClass3.default)(PosterPlugin, [
                        {
                            key: 'name',
                            get: function get() {
                                return 'poster';
                            }
                        },
                        {
                            key: 'template',
                            get: function get() {
                                return (0, _template2.default)(_poster2.default);
                            }
                        },
                        {
                            key: 'shouldRender',
                            get: function get() {
                                var showForNoOp = !!(this.options.poster && this.options.poster.showForNoOp);
                                return this.container.playback.name !== 'html_img' && (this.container.playback.getPlaybackType() !== _playback2.default.NO_OP || showForNoOp);
                            }
                        },
                        {
                            key: 'attributes',
                            get: function get() {
                                return {
                                    'class': 'player-poster',
                                    'data-poster': ''
                                };
                            }
                        },
                        {
                            key: 'events',
                            get: function get() {
                                return {
                                    'click': 'clicked'
                                };
                            }
                        },
                        {
                            key: 'showOnVideoEnd',
                            get: function get() {
                                return !this.options.poster || this.options.poster.showOnVideoEnd || this.options.poster.showOnVideoEnd === undefined;
                            }
                        }
                    ]);
                    function PosterPlugin(container) {
                        (0, _classCallCheck3.default)(this, PosterPlugin);
                        var _this = (0, _possibleConstructorReturn3.default)(this, _UIContainerPlugin.call(this, container));
                        _this.hasStartedPlaying = false;
                        _this.playRequested = false;
                        _this.render();
                        process.nextTick(function() {
                            return _this.update();
                        });
                        return _this;
                    }
                    PosterPlugin.prototype.bindEvents = function bindEvents() {
                        this.listenTo(this.container, _events2.default.CONTAINER_STOP, this.onStop);
                        this.listenTo(this.container, _events2.default.CONTAINER_PLAY, this.onPlay);
                        this.listenTo(this.container, _events2.default.CONTAINER_STATE_BUFFERING, this.update);
                        this.listenTo(this.container, _events2.default.CONTAINER_STATE_BUFFERFULL, this.update);
                        this.listenTo(this.container, _events2.default.CONTAINER_OPTIONS_CHANGE, this.render);
                        this.listenTo(this.container, _events2.default.CONTAINER_ERROR, this.onError);
                        this.showOnVideoEnd && this.listenTo(this.container, _events2.default.CONTAINER_ENDED, this.onStop);
                    };
                    PosterPlugin.prototype.onError = function onError(error) {
                        this.hasFatalError = error.level === _error2.default.Levels.FATAL;
                        if (this.hasFatalError) {
                            this.hasStartedPlaying = false;
                            this.playRequested = false;
                            this.showPlayButton();
                        }
                    };
                    PosterPlugin.prototype.onPlay = function onPlay() {
                        this.hasStartedPlaying = true;
                        this.update();
                    };
                    PosterPlugin.prototype.onStop = function onStop() {
                        this.hasStartedPlaying = false;
                        this.playRequested = false;
                        this.update();
                    };
                    PosterPlugin.prototype.updatePlayButton = function updatePlayButton(show) {
                        if (show && (!this.options.chromeless || this.options.allowUserInteraction)) this.showPlayButton();
                        else this.hidePlayButton();
                    };
                    PosterPlugin.prototype.showPlayButton = function showPlayButton() {
                        if (this.hasFatalError && !this.options.disableErrorScreen) return;
                        this.$playButton.show();
                        this.$el.addClass('clickable');
                    };
                    PosterPlugin.prototype.hidePlayButton = function hidePlayButton() {
                        this.$playButton.hide();
                        this.$el.removeClass('clickable');
                    };
                    PosterPlugin.prototype.clicked = function clicked() {
                        // Let "click_to_pause" plugin handle click event if media has started playing
                        if (!this.hasStartedPlaying) {
                            if (!this.options.chromeless || this.options.allowUserInteraction) {
                                this.playRequested = true;
                                this.update();
                                this.container.play();
                            }
                            return false;
                        }
                    };
                    PosterPlugin.prototype.shouldHideOnPlay = function shouldHideOnPlay() {
                        // Audio broadcasts should keep the poster up; video should hide poster while playing.
                        return !this.container.playback.isAudioOnly;
                    };
                    PosterPlugin.prototype.update = function update() {
                        if (!this.shouldRender) return;
                        var showPlayButton = !this.playRequested && !this.hasStartedPlaying && !this.container.buffering;
                        this.updatePlayButton(showPlayButton);
                        this.updatePoster();
                    };
                    PosterPlugin.prototype.updatePoster = function updatePoster() {
                        if (!this.hasStartedPlaying) this.showPoster();
                        else this.hidePoster();
                    };
                    PosterPlugin.prototype.showPoster = function showPoster() {
                        this.container.disableMediaControl();
                        this.$el.show();
                    };
                    PosterPlugin.prototype.hidePoster = function hidePoster() {
                        this.container.enableMediaControl();
                        if (this.shouldHideOnPlay()) this.$el.hide();
                    };
                    PosterPlugin.prototype.render = function render() {
                        if (!this.shouldRender) return;
                        this.$el.html(this.template());
                        var isRegularPoster = this.options.poster && this.options.poster.custom === undefined;
                        if (isRegularPoster) {
                            var posterUrl = this.options.poster.url || this.options.poster;
                            this.$el.css({
                                'background-image': 'url(' + posterUrl + ')'
                            });
                        } else if (this.options.poster) this.$el.css({
                            'background': this.options.poster.custom
                        });
                        this.container.$el.append(this.el);
                        this.$playWrapper = this.$el.find('.play-wrapper');
                        this.$playWrapper.append(_utils.SvgIcons.play);
                        this.$playButton = this.$playWrapper.find('svg');
                        this.$playButton.addClass('poster-icon');
                        this.$playButton.attr('data-poster', '');
                        var buttonsColor = this.options.mediacontrol && this.options.mediacontrol.buttons;
                        if (buttonsColor) this.$el.find('svg path').css('fill', buttonsColor);
                        if (this.options.mediacontrol && this.options.mediacontrol.buttons) {
                            buttonsColor = this.options.mediacontrol.buttons;
                            this.$playButton.css('color', buttonsColor);
                        }
                        this.update();
                        return this;
                    };
                    return PosterPlugin;
                }(_ui_container_plugin2.default);
                exports.default = PosterPlugin;
                module1.exports = exports['default'];
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(/*! ./../../../node_modules/node-libs-browser/node_modules/process/browser.js */ "./node_modules/node-libs-browser/node_modules/process/browser.js"));
        /***/ },
        /***/ "./src/plugins/poster/public/poster.html": /*!***********************************************!*\
  !*** ./src/plugins/poster/public/poster.html ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<div class=\"play-wrapper\" data-poster></div>\n";
        /***/ },
        /***/ "./src/plugins/poster/public/poster.scss": /*!***********************************************!*\
  !*** ./src/plugins/poster/public/poster.scss ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./poster.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/poster/public/poster.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/plugins/seek_time/index.js": /*!****************************************!*\
  !*** ./src/plugins/seek_time/index.js ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _seek_time = __webpack_require__(/*! ./seek_time */ "./src/plugins/seek_time/seek_time.js");
            var _seek_time2 = _interopRequireDefault(_seek_time);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _seek_time2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/seek_time/public/seek_time.html": /*!*****************************************************!*\
  !*** ./src/plugins/seek_time/public/seek_time.html ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<span data-seek-time></span>\n<span data-duration></span>\n";
        /***/ },
        /***/ "./src/plugins/seek_time/public/seek_time.scss": /*!*****************************************************!*\
  !*** ./src/plugins/seek_time/public/seek_time.scss ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./seek_time.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/seek_time/public/seek_time.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/plugins/seek_time/seek_time.js": /*!********************************************!*\
  !*** ./src/plugins/seek_time/seek_time.js ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _utils = __webpack_require__(/*! ../../base/utils */ "./src/base/utils.js");
            var _ui_core_plugin = __webpack_require__(/*! ../../base/ui_core_plugin */ "./src/base/ui_core_plugin.js");
            var _ui_core_plugin2 = _interopRequireDefault(_ui_core_plugin);
            var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
            var _template2 = _interopRequireDefault(_template);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _playback = __webpack_require__(/*! ../../base/playback */ "./src/base/playback.js");
            var _playback2 = _interopRequireDefault(_playback);
            var _seek_time = __webpack_require__(/*! ./public/seek_time.html */ "./src/plugins/seek_time/public/seek_time.html");
            var _seek_time2 = _interopRequireDefault(_seek_time);
            __webpack_require__(/*! ./public/seek_time.scss */ "./src/plugins/seek_time/public/seek_time.scss");
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var SeekTime = function(_UICorePlugin) {
                (0, _inherits3.default)(SeekTime, _UICorePlugin);
                (0, _createClass3.default)(SeekTime, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'seek_time';
                        }
                    },
                    {
                        key: 'template',
                        get: function get() {
                            return (0, _template2.default)(_seek_time2.default);
                        }
                    },
                    {
                        key: 'attributes',
                        get: function get() {
                            return {
                                'class': 'seek-time',
                                'data-seek-time': ''
                            };
                        }
                    },
                    {
                        key: 'mediaControl',
                        get: function get() {
                            return this.core.mediaControl;
                        }
                    },
                    {
                        key: 'mediaControlContainer',
                        get: function get() {
                            return this.mediaControl.container;
                        }
                    },
                    {
                        key: 'isLiveStreamWithDvr',
                        get: function get() {
                            return this.mediaControlContainer && this.mediaControlContainer.getPlaybackType() === _playback2.default.LIVE && this.mediaControlContainer.isDvrEnabled();
                        }
                    },
                    {
                        key: 'durationShown',
                        get: function get() {
                            return this.isLiveStreamWithDvr && !this.actualLiveTime;
                        }
                    },
                    {
                        key: 'useActualLiveTime',
                        get: function get() {
                            return this.actualLiveTime && this.isLiveStreamWithDvr;
                        }
                    }
                ]);
                function SeekTime(core) {
                    (0, _classCallCheck3.default)(this, SeekTime);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _UICorePlugin.call(this, core));
                    _this.hoveringOverSeekBar = false;
                    _this.hoverPosition = null;
                    _this.duration = null;
                    _this.firstFragDateTime = null;
                    _this.actualLiveTime = !!_this.mediaControl.options.actualLiveTime;
                    if (_this.actualLiveTime) {
                        if (_this.mediaControl.options.actualLiveServerTime) _this.actualLiveServerTimeDiff = new Date().getTime() - new Date(_this.mediaControl.options.actualLiveServerTime).getTime();
                        else _this.actualLiveServerTimeDiff = 0;
                    }
                    return _this;
                }
                SeekTime.prototype.bindEvents = function bindEvents() {
                    this.listenTo(this.mediaControl, _events2.default.MEDIACONTROL_RENDERED, this.render);
                    this.listenTo(this.mediaControl, _events2.default.MEDIACONTROL_MOUSEMOVE_SEEKBAR, this.showTime);
                    this.listenTo(this.mediaControl, _events2.default.MEDIACONTROL_MOUSELEAVE_SEEKBAR, this.hideTime);
                    this.listenTo(this.mediaControl, _events2.default.MEDIACONTROL_CONTAINERCHANGED, this.onContainerChanged);
                    if (this.mediaControlContainer) {
                        this.listenTo(this.mediaControlContainer, _events2.default.CONTAINER_PLAYBACKDVRSTATECHANGED, this.update);
                        this.listenTo(this.mediaControlContainer, _events2.default.CONTAINER_TIMEUPDATE, this.updateDuration);
                    }
                };
                SeekTime.prototype.onContainerChanged = function onContainerChanged() {
                    this.stopListening();
                    this.bindEvents();
                };
                SeekTime.prototype.updateDuration = function updateDuration(timeProgress) {
                    this.duration = timeProgress.total;
                    this.firstFragDateTime = timeProgress.firstFragDateTime;
                    this.update();
                };
                SeekTime.prototype.showTime = function showTime(event) {
                    this.hoveringOverSeekBar = true;
                    this.calculateHoverPosition(event);
                    this.update();
                };
                SeekTime.prototype.hideTime = function hideTime() {
                    this.hoveringOverSeekBar = false;
                    this.update();
                };
                SeekTime.prototype.calculateHoverPosition = function calculateHoverPosition(event) {
                    var offset = event.pageX - this.mediaControl.$seekBarContainer.offset().left;
                    // proportion into the seek bar that the mouse is hovered over 0-1
                    this.hoverPosition = Math.min(1, Math.max(offset / this.mediaControl.$seekBarContainer.width(), 0));
                };
                SeekTime.prototype.getSeekTime = function getSeekTime() {
                    var seekTime = void 0, secondsSinceMidnight = void 0, d = void 0, e = void 0;
                    if (this.useActualLiveTime) {
                        if (this.firstFragDateTime) {
                            e = new Date(this.firstFragDateTime);
                            d = new Date(this.firstFragDateTime);
                            d.setHours(0, 0, 0, 0);
                            secondsSinceMidnight = (e.getTime() - d.getTime()) / 1000 + this.duration;
                        } else {
                            d = new Date(new Date().getTime() - this.actualLiveServerTimeDiff);
                            e = new Date(d);
                            secondsSinceMidnight = (e - d.setHours(0, 0, 0, 0)) / 1000;
                        }
                        seekTime = secondsSinceMidnight - this.duration + this.hoverPosition * this.duration;
                        if (seekTime < 0) seekTime += 86400;
                    } else seekTime = this.hoverPosition * this.duration;
                    return {
                        seekTime: seekTime,
                        secondsSinceMidnight: secondsSinceMidnight
                    };
                };
                SeekTime.prototype.update = function update() {
                    if (!this.rendered) // update() is always called after a render
                    return;
                    if (!this.shouldBeVisible()) {
                        this.$el.hide();
                        this.$el.css('left', '-100%');
                    } else {
                        var seekTime = this.getSeekTime();
                        var currentSeekTime = (0, _utils.formatTime)(seekTime.seekTime, this.useActualLiveTime);
                        // only update dom if necessary, ie time actually changed
                        if (currentSeekTime !== this.displayedSeekTime) {
                            this.$seekTimeEl.text(currentSeekTime);
                            this.displayedSeekTime = currentSeekTime;
                        }
                        if (this.durationShown) {
                            this.$durationEl.show();
                            var currentDuration = (0, _utils.formatTime)(this.actualLiveTime ? seekTime.secondsSinceMidnight : this.duration, this.actualLiveTime);
                            if (currentDuration !== this.displayedDuration) {
                                this.$durationEl.text(currentDuration);
                                this.displayedDuration = currentDuration;
                            }
                        } else this.$durationEl.hide();
                        // the element must be unhidden before its width is requested, otherwise it's width will be reported as 0
                        this.$el.show();
                        var containerWidth = this.mediaControl.$seekBarContainer.width();
                        var elWidth = this.$el.width();
                        var elLeftPos = this.hoverPosition * containerWidth;
                        elLeftPos -= elWidth / 2;
                        elLeftPos = Math.max(0, Math.min(elLeftPos, containerWidth - elWidth));
                        this.$el.css('left', elLeftPos);
                    }
                };
                SeekTime.prototype.shouldBeVisible = function shouldBeVisible() {
                    return this.mediaControlContainer && this.mediaControlContainer.settings.seekEnabled && this.hoveringOverSeekBar && this.hoverPosition !== null && this.duration !== null;
                };
                SeekTime.prototype.render = function render() {
                    this.rendered = true;
                    this.displayedDuration = null;
                    this.displayedSeekTime = null;
                    this.$el.html(this.template());
                    this.$el.hide();
                    this.mediaControl.$el.append(this.el);
                    this.$seekTimeEl = this.$el.find('[data-seek-time]');
                    this.$durationEl = this.$el.find('[data-duration]');
                    this.$durationEl.hide();
                    this.update();
                };
                return SeekTime;
            }(_ui_core_plugin2.default); // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            exports.default = SeekTime;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/sources.js": /*!********************************!*\
  !*** ./src/plugins/sources.js ***!
  \********************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _core_plugin = __webpack_require__(/*! ../base/core_plugin */ "./src/base/core_plugin.js");
            var _core_plugin2 = _interopRequireDefault(_core_plugin);
            var _events = __webpack_require__(/*! ../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var SourcesPlugin = function(_CorePlugin) {
                (0, _inherits3.default)(SourcesPlugin, _CorePlugin);
                function SourcesPlugin() {
                    (0, _classCallCheck3.default)(this, SourcesPlugin);
                    return (0, _possibleConstructorReturn3.default)(this, _CorePlugin.apply(this, arguments));
                }
                SourcesPlugin.prototype.bindEvents = function bindEvents() {
                    this.listenTo(this.core, _events2.default.CORE_CONTAINERS_CREATED, this.onContainersCreated);
                };
                SourcesPlugin.prototype.onContainersCreated = function onContainersCreated() {
                    var firstValidSource = this.core.containers.filter(function(container) {
                        return container.playback.name !== 'no_op';
                    })[0] || this.core.containers[0];
                    if (firstValidSource) this.core.containers.forEach(function(container) {
                        if (container !== firstValidSource) container.destroy();
                    });
                };
                (0, _createClass3.default)(SourcesPlugin, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'sources';
                        }
                    }
                ]);
                return SourcesPlugin;
            }(_core_plugin2.default);
            exports.default = SourcesPlugin;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/spinner_three_bounce/index.js": /*!***************************************************!*\
  !*** ./src/plugins/spinner_three_bounce/index.js ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _spinner_three_bounce = __webpack_require__(/*! ./spinner_three_bounce */ "./src/plugins/spinner_three_bounce/spinner_three_bounce.js");
            var _spinner_three_bounce2 = _interopRequireDefault(_spinner_three_bounce);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _spinner_three_bounce2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/spinner_three_bounce/public/spinner.html": /*!**************************************************************!*\
  !*** ./src/plugins/spinner_three_bounce/public/spinner.html ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<div data-bounce1></div><div data-bounce2></div><div data-bounce3></div>\n";
        /***/ },
        /***/ "./src/plugins/spinner_three_bounce/public/spinner.scss": /*!**************************************************************!*\
  !*** ./src/plugins/spinner_three_bounce/public/spinner.scss ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./spinner.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/spinner_three_bounce/public/spinner.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/plugins/spinner_three_bounce/spinner_three_bounce.js": /*!******************************************************************!*\
  !*** ./src/plugins/spinner_three_bounce/spinner_three_bounce.js ***!
  \******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _ui_container_plugin = __webpack_require__(/*! ../../base/ui_container_plugin */ "./src/base/ui_container_plugin.js");
            var _ui_container_plugin2 = _interopRequireDefault(_ui_container_plugin);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
            var _template2 = _interopRequireDefault(_template);
            var _spinner = __webpack_require__(/*! ./public/spinner.html */ "./src/plugins/spinner_three_bounce/public/spinner.html");
            var _spinner2 = _interopRequireDefault(_spinner);
            __webpack_require__(/*! ./public/spinner.scss */ "./src/plugins/spinner_three_bounce/public/spinner.scss");
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var SpinnerThreeBouncePlugin = function(_UIContainerPlugin) {
                (0, _inherits3.default)(SpinnerThreeBouncePlugin, _UIContainerPlugin);
                (0, _createClass3.default)(SpinnerThreeBouncePlugin, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'spinner';
                        }
                    },
                    {
                        key: 'attributes',
                        get: function get() {
                            return {
                                'data-spinner': '',
                                'class': 'spinner-three-bounce'
                            };
                        }
                    }
                ]);
                function SpinnerThreeBouncePlugin(container) {
                    (0, _classCallCheck3.default)(this, SpinnerThreeBouncePlugin);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _UIContainerPlugin.call(this, container));
                    _this.template = (0, _template2.default)(_spinner2.default);
                    _this.showTimeout = null;
                    _this.listenTo(_this.container, _events2.default.CONTAINER_STATE_BUFFERING, _this.onBuffering);
                    _this.listenTo(_this.container, _events2.default.CONTAINER_STATE_BUFFERFULL, _this.onBufferFull);
                    _this.listenTo(_this.container, _events2.default.CONTAINER_STOP, _this.onStop);
                    _this.listenTo(_this.container, _events2.default.CONTAINER_ENDED, _this.onStop);
                    _this.listenTo(_this.container, _events2.default.CONTAINER_ERROR, _this.onStop);
                    _this.render();
                    return _this;
                }
                SpinnerThreeBouncePlugin.prototype.onBuffering = function onBuffering() {
                    this.show();
                };
                SpinnerThreeBouncePlugin.prototype.onBufferFull = function onBufferFull() {
                    this.hide();
                };
                SpinnerThreeBouncePlugin.prototype.onStop = function onStop() {
                    this.hide();
                };
                SpinnerThreeBouncePlugin.prototype.show = function show() {
                    var _this2 = this;
                    if (this.showTimeout === null) this.showTimeout = setTimeout(function() {
                        return _this2.$el.show();
                    }, 300);
                };
                SpinnerThreeBouncePlugin.prototype.hide = function hide() {
                    if (this.showTimeout !== null) {
                        clearTimeout(this.showTimeout);
                        this.showTimeout = null;
                    }
                    this.$el.hide();
                };
                SpinnerThreeBouncePlugin.prototype.render = function render() {
                    this.$el.html(this.template());
                    this.container.$el.append(this.$el);
                    this.$el.hide();
                    if (this.container.buffering) this.onBuffering();
                    return this;
                };
                return SpinnerThreeBouncePlugin;
            }(_ui_container_plugin2.default); // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            exports.default = SpinnerThreeBouncePlugin;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/stats/index.js": /*!************************************!*\
  !*** ./src/plugins/stats/index.js ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _stats = __webpack_require__(/*! ./stats */ "./src/plugins/stats/stats.js");
            var _stats2 = _interopRequireDefault(_stats);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _stats2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/stats/stats.js": /*!************************************!*\
  !*** ./src/plugins/stats/stats.js ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _container_plugin = __webpack_require__(/*! ../../base/container_plugin */ "./src/base/container_plugin.js");
            var _container_plugin2 = _interopRequireDefault(_container_plugin);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var StatsPlugin = function(_ContainerPlugin) {
                (0, _inherits3.default)(StatsPlugin, _ContainerPlugin);
                (0, _createClass3.default)(StatsPlugin, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'stats';
                        }
                    }
                ]);
                function StatsPlugin(container) {
                    (0, _classCallCheck3.default)(this, StatsPlugin);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _ContainerPlugin.call(this, container));
                    _this.setInitialAttrs();
                    _this.reportInterval = _this.options.reportInterval || 5000;
                    _this.state = 'IDLE';
                    return _this;
                }
                StatsPlugin.prototype.bindEvents = function bindEvents() {
                    this.listenTo(this.container.playback, _events2.default.PLAYBACK_PLAY, this.onPlay);
                    this.listenTo(this.container, _events2.default.CONTAINER_STOP, this.onStop);
                    this.listenTo(this.container, _events2.default.CONTAINER_ENDED, this.onStop);
                    this.listenTo(this.container, _events2.default.CONTAINER_DESTROYED, this.onStop);
                    this.listenTo(this.container, _events2.default.CONTAINER_STATE_BUFFERING, this.onBuffering);
                    this.listenTo(this.container, _events2.default.CONTAINER_STATE_BUFFERFULL, this.onBufferFull);
                    this.listenTo(this.container, _events2.default.CONTAINER_STATS_ADD, this.onStatsAdd);
                    this.listenTo(this.container, _events2.default.CONTAINER_BITRATE, this.onStatsAdd);
                    this.listenTo(this.container.playback, _events2.default.PLAYBACK_STATS_ADD, this.onStatsAdd);
                };
                StatsPlugin.prototype.setInitialAttrs = function setInitialAttrs() {
                    this.firstPlay = true;
                    this.startupTime = 0;
                    this.rebufferingTime = 0;
                    this.watchingTime = 0;
                    this.rebuffers = 0;
                    this.externalMetrics = {};
                };
                StatsPlugin.prototype.onPlay = function onPlay() {
                    this.state = 'PLAYING';
                    this.watchingTimeInit = Date.now();
                    if (!this.intervalId) this.intervalId = setInterval(this.report.bind(this), this.reportInterval);
                };
                StatsPlugin.prototype.onStop = function onStop() {
                    clearInterval(this.intervalId);
                    this.report();
                    this.intervalId = undefined;
                    this.state = 'STOPPED';
                };
                StatsPlugin.prototype.onBuffering = function onBuffering() {
                    if (this.firstPlay) this.startupTimeInit = Date.now();
                    else this.rebufferingTimeInit = Date.now();
                    this.state = 'BUFFERING';
                    this.rebuffers++;
                };
                StatsPlugin.prototype.onBufferFull = function onBufferFull() {
                    if (this.firstPlay && this.startupTimeInit) {
                        this.firstPlay = false;
                        this.startupTime = Date.now() - this.startupTimeInit;
                        this.watchingTimeInit = Date.now();
                    } else if (this.rebufferingTimeInit) this.rebufferingTime += this.getRebufferingTime();
                    this.rebufferingTimeInit = undefined;
                    this.state = 'PLAYING';
                };
                StatsPlugin.prototype.getRebufferingTime = function getRebufferingTime() {
                    return Date.now() - this.rebufferingTimeInit;
                };
                StatsPlugin.prototype.getWatchingTime = function getWatchingTime() {
                    var totalTime = Date.now() - this.watchingTimeInit;
                    return totalTime - this.rebufferingTime;
                };
                StatsPlugin.prototype.isRebuffering = function isRebuffering() {
                    return !!this.rebufferingTimeInit;
                };
                StatsPlugin.prototype.onStatsAdd = function onStatsAdd(metric) {
                    _clapprZepto2.default.extend(this.externalMetrics, metric);
                };
                StatsPlugin.prototype.getStats = function getStats() {
                    var metrics = {
                        startupTime: this.startupTime,
                        rebuffers: this.rebuffers,
                        rebufferingTime: this.isRebuffering() ? this.rebufferingTime + this.getRebufferingTime() : this.rebufferingTime,
                        watchingTime: this.isRebuffering() ? this.getWatchingTime() - this.getRebufferingTime() : this.getWatchingTime()
                    };
                    _clapprZepto2.default.extend(metrics, this.externalMetrics);
                    return metrics;
                };
                StatsPlugin.prototype.report = function report() {
                    this.container.statsReport(this.getStats());
                };
                return StatsPlugin;
            }(_container_plugin2.default); // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            exports.default = StatsPlugin;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/strings.js": /*!********************************!*\
  !*** ./src/plugins/strings.js ***!
  \********************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _utils = __webpack_require__(/*! ../base/utils */ "./src/base/utils.js");
            var _clapprZepto = __webpack_require__(/*! clappr-zepto */ "./node_modules/clappr-zepto/zepto.js");
            var _clapprZepto2 = _interopRequireDefault(_clapprZepto);
            var _core_plugin = __webpack_require__(/*! ../base/core_plugin */ "./src/base/core_plugin.js");
            var _core_plugin2 = _interopRequireDefault(_core_plugin);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
 * The internationalization (i18n) plugin
 * @class Strings
 * @constructor
 * @extends CorePlugin
 * @module plugins
 */ var Strings = function(_CorePlugin) {
                (0, _inherits3.default)(Strings, _CorePlugin);
                (0, _createClass3.default)(Strings, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'strings';
                        }
                    }
                ]);
                function Strings(core) {
                    (0, _classCallCheck3.default)(this, Strings);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _CorePlugin.call(this, core));
                    _this._initializeMessages();
                    return _this;
                }
                /**
   * Gets a translated string for the given key.
   * @method t
   * @param {String} key the key to all messages
   * @return {String} translated label
   */ Strings.prototype.t = function t(key) {
                    var lang = this._language();
                    var fallbackLang = this._messages['en'];
                    var i18n = lang && this._messages[lang] || fallbackLang;
                    return i18n[key] || fallbackLang[key] || key;
                };
                Strings.prototype._language = function _language() {
                    return this.core.options.language || (0, _utils.getBrowserLanguage)();
                };
                Strings.prototype._initializeMessages = function _initializeMessages() {
                    var defaultMessages = {
                        'en': {
                            'live': 'live',
                            'back_to_live': 'back to live',
                            'disabled': 'Disabled',
                            'playback_not_supported': 'Your browser does not support the playback of this video. Please try using a different browser.',
                            'default_error_title': 'Could not play video.',
                            'default_error_message': 'There was a problem trying to load the video.'
                        },
                        'pt': {
                            'live': 'ao vivo',
                            'back_to_live': 'voltar para o ao vivo',
                            'disabled': 'Desativado',
                            'playback_not_supported': "Seu navegador n\xe3o supporta a reprodu\xe7\xe3o deste video. Por favor, tente usar um navegador diferente.",
                            'default_error_title': "N\xe3o foi poss\xedvel reproduzir o v\xeddeo.",
                            'default_error_message': "Ocorreu um problema ao tentar carregar o v\xeddeo."
                        },
                        'es': {
                            'live': 'vivo',
                            'back_to_live': 'volver en vivo',
                            'disabled': 'Discapacitado',
                            'playback_not_supported': "Su navegador no soporta la reproducci\xf3n de un video. Por favor, trate de usar un navegador diferente."
                        },
                        'ru': {
                            'live': "\u043F\u0440\u044F\u043C\u043E\u0439 \u044D\u0444\u0438\u0440",
                            'back_to_live': "\u043A \u043F\u0440\u044F\u043C\u043E\u043C\u0443 \u044D\u0444\u0438\u0440\u0443",
                            'disabled': "\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
                            'playback_not_supported': "\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0438\u0434\u0435\u043E. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0439 \u0431\u0440\u0430\u0443\u0437\u0435\u0440."
                        },
                        'fr': {
                            'live': 'en direct',
                            'back_to_live': 'retour au direct',
                            'disabled': "D\xe9sactiv\xe9",
                            'playback_not_supported': "Votre navigateur ne supporte pas la lecture de cette vid\xe9o. Merci de tenter sur un autre navigateur.",
                            'default_error_title': "Impossible de lire la vid\xe9o.",
                            'default_error_message': "Un probl\xe8me est survenu lors du chargement de la vid\xe9o."
                        },
                        'tr': {
                            'live': "canl\u0131",
                            'back_to_live': "canl\u0131 yay\u0131na d\xf6n",
                            'disabled': 'Engelli',
                            'playback_not_supported': "Taray\u0131c\u0131n\u0131z bu videoyu oynatma deste\u011Fine sahip de\u011Fil. L\xfctfen farkl\u0131 bir taray\u0131c\u0131 ile deneyin."
                        },
                        'et': {
                            'live': "Otse\xfclekanne",
                            'back_to_live': "Tagasi otse\xfclekande juurde",
                            'disabled': 'Keelatud',
                            'playback_not_supported': 'Teie brauser ei toeta selle video taasesitust. Proovige kasutada muud brauserit.'
                        },
                        'ar': {
                            'live': "\u0645\u0628\u0627\u0634\u0631",
                            'back_to_live': "\u0627\u0644\u0631\u062C\u0648\u0639 \u0625\u0644\u0649 \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
                            'disabled': "\u0645\u0639\u0637\u0651\u0644",
                            'playback_not_supported': "\u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u0630\u064A \u062A\u0633\u062A\u062E\u062F\u0645\u0647 \u0644\u0627 \u064A\u062F\u0639\u0645 \u062A\u0634\u063A\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u0641\u064A\u062F\u064A\u0648. \u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u062A\u0635\u0641\u062D \u0622\u062E\u0631.",
                            'default_error_title': "\u063A\u064A\u0631 \u0642\u0627\u062F\u0631 \u0627\u0644\u0649 \u0627\u0644\u062A\u0634\u063A\u064A\u0644.",
                            'default_error_message': "\u062D\u062F\u062B\u062A \u0645\u0634\u0643\u0644\u0629 \u0623\u062B\u0646\u0627\u0621 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0641\u064A\u062F\u064A\u0648."
                        }
                    };
                    this._messages = _clapprZepto2.default.extend(true, defaultMessages, this.core.options.strings || {});
                    this._messages['pt-BR'] = this._messages['pt'];
                    this._messages['en-US'] = this._messages['en'];
                    this._messages['es-419'] = this._messages['es'];
                    this._messages['fr-FR'] = this._messages['fr'];
                    this._messages['tr-TR'] = this._messages['tr'];
                    this._messages['et-EE'] = this._messages['et'];
                    this._messages['ar-IQ'] = this._messages['ar'];
                };
                return Strings;
            }(_core_plugin2.default);
            exports.default = Strings;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/watermark/index.js": /*!****************************************!*\
  !*** ./src/plugins/watermark/index.js ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _watermark = __webpack_require__(/*! ./watermark */ "./src/plugins/watermark/watermark.js");
            var _watermark2 = _interopRequireDefault(_watermark);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _watermark2.default;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/plugins/watermark/public/watermark.html": /*!*****************************************************!*\
  !*** ./src/plugins/watermark/public/watermark.html ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = "<div class=\"clappr-watermark\" data-watermark data-watermark-<%=position %>>\n<% if(typeof imageLink !== 'undefined') { %>\n<a target=_blank href=\"<%= imageLink %>\">\n<% } %>\n<img src=\"<%= imageUrl %>\">\n<% if(typeof imageLink !== 'undefined') { %>\n</a>\n<% } %>\n</div>\n";
        /***/ },
        /***/ "./src/plugins/watermark/public/watermark.scss": /*!*****************************************************!*\
  !*** ./src/plugins/watermark/public/watermark.scss ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/postcss-loader/lib!../../../../node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./watermark.scss */ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/lib/index.js!./node_modules/sass-loader/lib/loader.js?includePaths[]=/Users/joaopaulo/Workstation/JS/clappr/src/base/scss!./src/plugins/watermark/public/watermark.scss");
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "singleton": true,
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /***/ "./src/plugins/watermark/watermark.js": /*!********************************************!*\
  !*** ./src/plugins/watermark/watermark.js ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
            var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
            var _possibleConstructorReturn2 = __webpack_require__(/*! babel-runtime/helpers/possibleConstructorReturn */ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
            var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
            var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
            var _createClass3 = _interopRequireDefault(_createClass2);
            var _inherits2 = __webpack_require__(/*! babel-runtime/helpers/inherits */ "./node_modules/babel-runtime/helpers/inherits.js");
            var _inherits3 = _interopRequireDefault(_inherits2);
            var _ui_container_plugin = __webpack_require__(/*! ../../base/ui_container_plugin */ "./src/base/ui_container_plugin.js");
            var _ui_container_plugin2 = _interopRequireDefault(_ui_container_plugin);
            var _events = __webpack_require__(/*! ../../base/events */ "./src/base/events.js");
            var _events2 = _interopRequireDefault(_events);
            var _template = __webpack_require__(/*! ../../base/template */ "./src/base/template.js");
            var _template2 = _interopRequireDefault(_template);
            var _watermark = __webpack_require__(/*! ./public/watermark.html */ "./src/plugins/watermark/public/watermark.html");
            var _watermark2 = _interopRequireDefault(_watermark);
            __webpack_require__(/*! ./public/watermark.scss */ "./src/plugins/watermark/public/watermark.scss");
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var WaterMarkPlugin = function(_UIContainerPlugin) {
                (0, _inherits3.default)(WaterMarkPlugin, _UIContainerPlugin);
                (0, _createClass3.default)(WaterMarkPlugin, [
                    {
                        key: 'name',
                        get: function get() {
                            return 'watermark';
                        }
                    },
                    {
                        key: 'template',
                        get: function get() {
                            return (0, _template2.default)(_watermark2.default);
                        }
                    }
                ]);
                function WaterMarkPlugin(container) {
                    (0, _classCallCheck3.default)(this, WaterMarkPlugin);
                    var _this = (0, _possibleConstructorReturn3.default)(this, _UIContainerPlugin.call(this, container));
                    _this.configure();
                    return _this;
                }
                WaterMarkPlugin.prototype.bindEvents = function bindEvents() {
                    this.listenTo(this.container, _events2.default.CONTAINER_PLAY, this.onPlay);
                    this.listenTo(this.container, _events2.default.CONTAINER_STOP, this.onStop);
                    this.listenTo(this.container, _events2.default.CONTAINER_OPTIONS_CHANGE, this.configure);
                };
                WaterMarkPlugin.prototype.configure = function configure() {
                    this.position = this.options.position || 'bottom-right';
                    if (this.options.watermark) {
                        this.imageUrl = this.options.watermark;
                        this.imageLink = this.options.watermarkLink;
                        this.render();
                    } else this.$el.remove();
                };
                WaterMarkPlugin.prototype.onPlay = function onPlay() {
                    if (!this.hidden) this.$el.show();
                };
                WaterMarkPlugin.prototype.onStop = function onStop() {
                    this.$el.hide();
                };
                WaterMarkPlugin.prototype.render = function render() {
                    this.$el.hide();
                    var templateOptions = {
                        position: this.position,
                        imageUrl: this.imageUrl,
                        imageLink: this.imageLink
                    };
                    this.$el.html(this.template(templateOptions));
                    this.container.$el.append(this.$el);
                    return this;
                };
                return WaterMarkPlugin;
            }(_ui_container_plugin2.default); // Copyright 2014 Globo.com Player authors. All rights reserved.
            // Use of this source code is governed by a BSD-style
            // license that can be found in the LICENSE file.
            exports.default = WaterMarkPlugin;
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/vendor/index.js": /*!*****************************!*\
  !*** ./src/vendor/index.js ***!
  \*****************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _kibo = __webpack_require__(/*! ./kibo */ "./src/vendor/kibo.js");
            var _kibo2 = _interopRequireDefault(_kibo);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = {
                Kibo: _kibo2.default
            };
            module1.exports = exports['default'];
        /***/ },
        /***/ "./src/vendor/kibo.js": /*!****************************!*\
  !*** ./src/vendor/kibo.js ***!
  \****************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /* eslint-disable */ // Kibo is released under the MIT License. Copyright (c) 2013 marquete.
            // see https://github.com/marquete/kibo
            var Kibo = function Kibo(element) {
                this.element = element || window.document;
                this.initialize();
            };
            Kibo.KEY_NAMES_BY_CODE = {
                8: 'backspace',
                9: 'tab',
                13: 'enter',
                16: 'shift',
                17: 'ctrl',
                18: 'alt',
                20: 'caps_lock',
                27: 'esc',
                32: 'space',
                37: 'left',
                38: 'up',
                39: 'right',
                40: 'down',
                48: '0',
                49: '1',
                50: '2',
                51: '3',
                52: '4',
                53: '5',
                54: '6',
                55: '7',
                56: '8',
                57: '9',
                65: 'a',
                66: 'b',
                67: 'c',
                68: 'd',
                69: 'e',
                70: 'f',
                71: 'g',
                72: 'h',
                73: 'i',
                74: 'j',
                75: 'k',
                76: 'l',
                77: 'm',
                78: 'n',
                79: 'o',
                80: 'p',
                81: 'q',
                82: 'r',
                83: 's',
                84: 't',
                85: 'u',
                86: 'v',
                87: 'w',
                88: 'x',
                89: 'y',
                90: 'z',
                112: 'f1',
                113: 'f2',
                114: 'f3',
                115: 'f4',
                116: 'f5',
                117: 'f6',
                118: 'f7',
                119: 'f8',
                120: 'f9',
                121: 'f10',
                122: 'f11',
                123: 'f12'
            };
            Kibo.KEY_CODES_BY_NAME = {};
            (function() {
                for(var key in Kibo.KEY_NAMES_BY_CODE)if (Object.prototype.hasOwnProperty.call(Kibo.KEY_NAMES_BY_CODE, key)) Kibo.KEY_CODES_BY_NAME[Kibo.KEY_NAMES_BY_CODE[key]] = +key;
            })();
            Kibo.MODIFIERS = [
                'shift',
                'ctrl',
                'alt'
            ];
            Kibo.registerEvent = function() {
                if (document.addEventListener) return function(element, eventName, func) {
                    element.addEventListener(eventName, func, false);
                };
                else if (document.attachEvent) return function(element, eventName, func) {
                    element.attachEvent('on' + eventName, func);
                };
            }();
            Kibo.unregisterEvent = function() {
                if (document.removeEventListener) return function(element, eventName, func) {
                    element.removeEventListener(eventName, func, false);
                };
                else if (document.detachEvent) return function(element, eventName, func) {
                    element.detachEvent('on' + eventName, func);
                };
            }();
            Kibo.stringContains = function(string, substring) {
                return string.indexOf(substring) !== -1;
            };
            Kibo.neatString = function(string) {
                return string.replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
            };
            Kibo.capitalize = function(string) {
                return string.toLowerCase().replace(/^./, function(match) {
                    return match.toUpperCase();
                });
            };
            Kibo.isString = function(what) {
                return Kibo.stringContains(Object.prototype.toString.call(what), 'String');
            };
            Kibo.arrayIncludes = function() {
                if (Array.prototype.indexOf) return function(haystack, needle) {
                    return haystack.indexOf(needle) !== -1;
                };
                else return function(haystack, needle) {
                    for(var i = 0; i < haystack.length; i++){
                        if (haystack[i] === needle) return true;
                    }
                    return false;
                };
            }();
            Kibo.extractModifiers = function(keyCombination) {
                var modifiers, i;
                modifiers = [];
                for(i = 0; i < Kibo.MODIFIERS.length; i++)if (Kibo.stringContains(keyCombination, Kibo.MODIFIERS[i])) modifiers.push(Kibo.MODIFIERS[i]);
                return modifiers;
            };
            Kibo.extractKey = function(keyCombination) {
                var keys, i;
                keys = Kibo.neatString(keyCombination).split(' ');
                for(i = 0; i < keys.length; i++){
                    if (!Kibo.arrayIncludes(Kibo.MODIFIERS, keys[i])) return keys[i];
                }
            };
            Kibo.modifiersAndKey = function(keyCombination) {
                var result, key;
                if (Kibo.stringContains(keyCombination, 'any')) return Kibo.neatString(keyCombination).split(' ').slice(0, 2).join(' ');
                result = Kibo.extractModifiers(keyCombination);
                key = Kibo.extractKey(keyCombination);
                if (key && !Kibo.arrayIncludes(Kibo.MODIFIERS, key)) result.push(key);
                return result.join(' ');
            };
            Kibo.keyName = function(keyCode) {
                return Kibo.KEY_NAMES_BY_CODE[keyCode + ''];
            };
            Kibo.keyCode = function(keyName) {
                return +Kibo.KEY_CODES_BY_NAME[keyName];
            };
            Kibo.prototype.initialize = function() {
                var i, that = this;
                this.lastKeyCode = -1;
                this.lastModifiers = {};
                for(i = 0; i < Kibo.MODIFIERS.length; i++)this.lastModifiers[Kibo.MODIFIERS[i]] = false;
                this.keysDown = {
                    any: []
                };
                this.keysUp = {
                    any: []
                };
                this.downHandler = this.handler('down');
                this.upHandler = this.handler('up');
                Kibo.registerEvent(this.element, 'keydown', this.downHandler);
                Kibo.registerEvent(this.element, 'keyup', this.upHandler);
                Kibo.registerEvent(window, 'unload', function unloader() {
                    Kibo.unregisterEvent(that.element, 'keydown', that.downHandler);
                    Kibo.unregisterEvent(that.element, 'keyup', that.upHandler);
                    Kibo.unregisterEvent(window, 'unload', unloader);
                });
            };
            Kibo.prototype.handler = function(upOrDown) {
                var that = this;
                return function(e) {
                    var i, registeredKeys, lastModifiersAndKey;
                    e = e || window.event;
                    that.lastKeyCode = e.keyCode;
                    for(i = 0; i < Kibo.MODIFIERS.length; i++)that.lastModifiers[Kibo.MODIFIERS[i]] = e[Kibo.MODIFIERS[i] + 'Key'];
                    if (Kibo.arrayIncludes(Kibo.MODIFIERS, Kibo.keyName(that.lastKeyCode))) that.lastModifiers[Kibo.keyName(that.lastKeyCode)] = true;
                    registeredKeys = that['keys' + Kibo.capitalize(upOrDown)];
                    for(i = 0; i < registeredKeys.any.length; i++)if (registeredKeys.any[i](e) === false && e.preventDefault) e.preventDefault();
                    lastModifiersAndKey = that.lastModifiersAndKey();
                    if (registeredKeys[lastModifiersAndKey]) {
                        for(i = 0; i < registeredKeys[lastModifiersAndKey].length; i++)if (registeredKeys[lastModifiersAndKey][i](e) === false && e.preventDefault) e.preventDefault();
                    }
                };
            };
            Kibo.prototype.registerKeys = function(upOrDown, newKeys, func) {
                var i, keys, registeredKeys = this['keys' + Kibo.capitalize(upOrDown)];
                if (Kibo.isString(newKeys)) newKeys = [
                    newKeys
                ];
                for(i = 0; i < newKeys.length; i++){
                    keys = newKeys[i];
                    keys = Kibo.modifiersAndKey(keys + '');
                    if (registeredKeys[keys]) registeredKeys[keys].push(func);
                    else registeredKeys[keys] = [
                        func
                    ];
                }
                return this;
            };
            // jshint maxdepth:5
            Kibo.prototype.unregisterKeys = function(upOrDown, newKeys, func) {
                var i, j, keys, registeredKeys = this['keys' + Kibo.capitalize(upOrDown)];
                if (Kibo.isString(newKeys)) newKeys = [
                    newKeys
                ];
                for(i = 0; i < newKeys.length; i++){
                    keys = newKeys[i];
                    keys = Kibo.modifiersAndKey(keys + '');
                    if (func === null) delete registeredKeys[keys];
                    else if (registeredKeys[keys]) {
                        for(j = 0; j < registeredKeys[keys].length; j++)if (String(registeredKeys[keys][j]) === String(func)) {
                            registeredKeys[keys].splice(j, 1);
                            break;
                        }
                    }
                }
                return this;
            };
            Kibo.prototype.off = function(keys) {
                return this.unregisterKeys('down', keys, null);
            };
            Kibo.prototype.delegate = function(upOrDown, keys, func) {
                return func !== null || func !== undefined ? this.registerKeys(upOrDown, keys, func) : this.unregisterKeys(upOrDown, keys, func);
            };
            Kibo.prototype.down = function(keys, func) {
                return this.delegate('down', keys, func);
            };
            Kibo.prototype.up = function(keys, func) {
                return this.delegate('up', keys, func);
            };
            Kibo.prototype.lastKey = function(modifier) {
                if (!modifier) return Kibo.keyName(this.lastKeyCode);
                return this.lastModifiers[modifier];
            };
            Kibo.prototype.lastModifiersAndKey = function() {
                var result, i;
                result = [];
                for(i = 0; i < Kibo.MODIFIERS.length; i++)if (this.lastKey(Kibo.MODIFIERS[i])) result.push(Kibo.MODIFIERS[i]);
                if (!Kibo.arrayIncludes(result, this.lastKey())) result.push(this.lastKey());
                return result.join(' ');
            };
            exports.default = Kibo;
            module1.exports = exports['default'];
        /***/ }
    });
});



const $d997c435b848789d$export$928e4fc72ae64313 = 'buffering';
const $d997c435b848789d$export$3ad39751a33c16b8 = 'paused';


const $9c562394e0e8f664$var$devMode = false;
class $9c562394e0e8f664$var$EmbeddedVideo extends (0, $bh6RR.Component) {
    static propTypes = {
        onPlay: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        onPause: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        onReady: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        onEnd: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        hasPlayerError: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool
    };
    constructor(props){
        super(props);
        this.playerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createRef();
        this.state = {
            playerTime: 0,
            logoAnimPercentage: 0
        };
    }
    componentDidMount() {
        this._setupPlayer();
    }
    shouldComponentUpdate() {
        return $9c562394e0e8f664$var$devMode;
    }
    componentWillUnmount() {
        this.destroyPlayer();
    }
    _playCallback = ()=>{
        this.props.onPlay();
        this._removeMediaControls();
        if (window.introStartCallback) window.introStartCallback();
    };
    _endCallback = ()=>{
        this.props.onEnd();
        if (window.introEndedCallback) window.introEndedCallback();
    };
    _removeMediaControls = ()=>{
        // this.player.core.$el.find('.media-control').remove();
        if (!$9c562394e0e8f664$var$devMode) this.player.core.activeContainer.disableMediaControl();
    };
    _setupPlayer() {
        const { onStateChange: onStateChange, onPause: onPause } = this.props;
        if (this.player) this.destroyPlayer();
        const devModeOptions = {};
        if ($9c562394e0e8f664$var$devMode) devModeOptions.events = {
            onTimeUpdate: (time)=>{
                if ($9c562394e0e8f664$var$devMode) {
                    const { current: current } = time;
                    this.setState({
                        playerTime: current,
                        logoAnimPercentage: (current - 86.75) / 7 * 100
                    });
                }
            }
        };
        this.player = new (0, (/*@__PURE__*/$parcel$interopDefault($c60576c11a83bb1a$exports))).Player({
            parent: this.playerRef.current,
            source: (0, $d39cc430308b5205$export$ca6f3c3553bace4c),
            exitFullscreenOnEnd: true,
            width: '100%',
            height: '100%',
            // mute: true,
            hlsjsConfig: {
                enableWorker: true
            },
            playback: {
                playInline: true
            },
            autoPlay: this.props.hasPlayerError,
            ...devModeOptions
        });
        if ($9c562394e0e8f664$var$devMode) window.player = this.player;
        if (!(0, $d39cc430308b5205$export$7392ea15d6a929a4)) {
            window.playApp = ()=>{
                this.player.play();
            };
            console.warn('Use window.playApp() to run the video.');
        }
        this.player.once((0, (/*@__PURE__*/$parcel$interopDefault($c60576c11a83bb1a$exports))).Events.PLAYER_ENDED, this._endCallback);
        this.player.listenTo(this.player.core.activeContainer, (0, (/*@__PURE__*/$parcel$interopDefault($c60576c11a83bb1a$exports))).Events.CONTAINER_STATE_BUFFERING, ()=>{
            onStateChange((0, $d997c435b848789d$export$928e4fc72ae64313));
        });
        this.player.core.activePlayback.on((0, (/*@__PURE__*/$parcel$interopDefault($c60576c11a83bb1a$exports))).Events.PLAYBACK_PAUSE, ()=>{
            onStateChange((0, $d997c435b848789d$export$3ad39751a33c16b8));
            onPause();
        });
        this.player.core.activePlayback.on((0, (/*@__PURE__*/$parcel$interopDefault($c60576c11a83bb1a$exports))).Events.PLAYBACK_PLAY, this._playCallback);
        // set Time factor
        this.player.core.$el.find('video,audio').get(0).playbackRate = 1 / (0, $d39cc430308b5205$export$888108240e4c7c6d);
        if (0, $d39cc430308b5205$export$87d6643ee8fe08fb) this.player.seek((0, $d39cc430308b5205$export$87d6643ee8fe08fb));
        this.props.onReady();
        onStateChange(null);
        this._removeMediaControls();
    }
    play() {
        this.props.onStateChange(null);
        this.player.play();
    }
    destroyPlayer() {
        if (this.player) this.player.destroy();
        this.player = null;
    }
    render() {
        if (!$9c562394e0e8f664$var$devMode) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "embedded-video",
            ref: this.playerRef
        });
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "embedded-video",
                    ref: this.playerRef
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        color: 'white',
                        position: 'absolute',
                        top: '20px',
                        left: '20px',
                        fontSize: '25px'
                    },
                    children: `${this.state.playerTime.toFixed(2)} s / ${this.state.logoAnimPercentage.toFixed(2)}%`
                })
            ]
        });
    }
}
var $9c562394e0e8f664$export$2e2bcd8739ae039 = $9c562394e0e8f664$var$EmbeddedVideo;




var $bh6RR = parcelRequire("bh6RR");

var $0a2fd319aeb28ddf$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0a2fd319aeb28ddf$var$ReactIs, $0a2fd319aeb28ddf$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$0a2fd319aeb28ddf$exports = (parcelRequire("fHlIx"))();



var $bh6RR = parcelRequire("bh6RR");
var $da9c10bf0d633d8b$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
$da9c10bf0d633d8b$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


var $b302f860f45377ca$exports = {};
'use strict';
Object.defineProperty($b302f860f45377ca$exports, "__esModule", {
    value: true
});
var $b302f860f45377ca$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $476c2f487fbb1145$exports = {};
'use strict';
var $476c2f487fbb1145$var$Sister;
/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/ $476c2f487fbb1145$var$Sister = function() {
    var sister = {}, events = {};
    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */ /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */ sister.on = function(name, handler) {
        var listener = {
            name: name,
            handler: handler
        };
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };
    /**
     * @param {listener}
     */ sister.off = function(listener) {
        var index = events[listener.name].indexOf(listener);
        if (index !== -1) events[listener.name].splice(index, 1);
    };
    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */ sister.trigger = function(name, data) {
        var listeners = events[name], i;
        if (listeners) {
            i = listeners.length;
            while(i--)listeners[i].handler(data);
        }
    };
    return sister;
};
$476c2f487fbb1145$exports = $476c2f487fbb1145$var$Sister;


var $b302f860f45377ca$var$_sister2 = $b302f860f45377ca$var$_interopRequireDefault($476c2f487fbb1145$exports);
var $2b5be65de324474b$exports = {};
'use strict';
Object.defineProperty($2b5be65de324474b$exports, "__esModule", {
    value: true
});
var $2299d10db7db9462$exports = {};
$2299d10db7db9462$exports = function load(src, opts, cb) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    if (typeof opts === 'function') {
        cb = opts;
        opts = {};
    }
    opts = opts || {};
    cb = cb || function() {};
    script.type = opts.type || 'text/javascript';
    script.charset = opts.charset || 'utf8';
    script.async = 'async' in opts ? !!opts.async : true;
    script.src = src;
    if (opts.attrs) $2299d10db7db9462$var$setAttributes(script, opts.attrs);
    if (opts.text) script.text = '' + opts.text;
    var onend = 'onload' in script ? $2299d10db7db9462$var$stdOnEnd : $2299d10db7db9462$var$ieOnEnd;
    onend(script, cb);
    // some good legacy browsers (firefox) fail the 'in' detection above
    // so as a fallback we always set onload
    // old IE will ignore this and new IE will set onload
    if (!script.onload) $2299d10db7db9462$var$stdOnEnd(script, cb);
    head.appendChild(script);
};
function $2299d10db7db9462$var$setAttributes(script, attrs) {
    for(var attr in attrs)script.setAttribute(attr, attrs[attr]);
}
function $2299d10db7db9462$var$stdOnEnd(script, cb) {
    script.onload = function() {
        this.onerror = this.onload = null;
        cb(null, script);
    };
    script.onerror = function() {
        // this.onload = null here is necessary
        // because even IE9 works not like others
        this.onerror = this.onload = null;
        cb(new Error('Failed to load ' + this.src), script);
    };
}
function $2299d10db7db9462$var$ieOnEnd(script, cb) {
    script.onreadystatechange = function() {
        if (this.readyState != 'complete' && this.readyState != 'loaded') return;
        this.onreadystatechange = null;
        cb(null, script) // there is no way to catch loading errors in IE8
        ;
    };
}


var $2b5be65de324474b$var$_loadScript2 = $2b5be65de324474b$var$_interopRequireDefault($2299d10db7db9462$exports);
function $2b5be65de324474b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$2b5be65de324474b$exports.default = function(emitter) {
    /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */ var iframeAPIReady = new Promise(function(resolve) {
        if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
            resolve(window.YT);
            return;
        } else {
            var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
            (0, $2b5be65de324474b$var$_loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function(error) {
                if (error) emitter.trigger('error', error);
            });
        }
        var previous = window.onYouTubeIframeAPIReady;
        // The API will call this function when page has finished downloading
        // the JavaScript for the player API.
        window.onYouTubeIframeAPIReady = function() {
            if (previous) previous();
            resolve(window.YT);
        };
    });
    return iframeAPIReady;
};
$2b5be65de324474b$exports = $2b5be65de324474b$exports['default'];


var $b302f860f45377ca$var$_loadYouTubeIframeApi2 = $b302f860f45377ca$var$_interopRequireDefault($2b5be65de324474b$exports);
var $54cb67a45636ed46$exports = {};
'use strict';
Object.defineProperty($54cb67a45636ed46$exports, "__esModule", {
    value: true
});

var $aJtYT = parcelRequire("aJtYT");
var $54cb67a45636ed46$var$_debug2 = $54cb67a45636ed46$var$_interopRequireDefault($aJtYT);
var $7ba2c3b7d91e4fab$exports = {};
'use strict';
Object.defineProperty($7ba2c3b7d91e4fab$exports, "__esModule", {
    value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */ $7ba2c3b7d91e4fab$exports.default = [
    'cueVideoById',
    'loadVideoById',
    'cueVideoByUrl',
    'loadVideoByUrl',
    'playVideo',
    'pauseVideo',
    'stopVideo',
    'getVideoLoadedFraction',
    'cuePlaylist',
    'loadPlaylist',
    'nextVideo',
    'previousVideo',
    'playVideoAt',
    'setShuffle',
    'setLoop',
    'getPlaylist',
    'getPlaylistIndex',
    'setOption',
    'mute',
    'unMute',
    'isMuted',
    'setVolume',
    'getVolume',
    'seekTo',
    'getPlayerState',
    'getPlaybackRate',
    'setPlaybackRate',
    'getAvailablePlaybackRates',
    'getPlaybackQuality',
    'setPlaybackQuality',
    'getAvailableQualityLevels',
    'getCurrentTime',
    'getDuration',
    'removeEventListener',
    'getVideoUrl',
    'getVideoEmbedCode',
    'getOptions',
    'getOption',
    'addEventListener',
    'destroy',
    'setSize',
    'getIframe'
];
$7ba2c3b7d91e4fab$exports = $7ba2c3b7d91e4fab$exports['default'];


var $54cb67a45636ed46$var$_functionNames2 = $54cb67a45636ed46$var$_interopRequireDefault($7ba2c3b7d91e4fab$exports);
var $fac2398ebc34bc63$exports = {};
'use strict';
Object.defineProperty($fac2398ebc34bc63$exports, "__esModule", {
    value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */ $fac2398ebc34bc63$exports.default = [
    'ready',
    'stateChange',
    'playbackQualityChange',
    'playbackRateChange',
    'error',
    'apiChange',
    'volumeChange'
];
$fac2398ebc34bc63$exports = $fac2398ebc34bc63$exports['default'];


var $54cb67a45636ed46$var$_eventNames2 = $54cb67a45636ed46$var$_interopRequireDefault($fac2398ebc34bc63$exports);
var $127324ab45dba9de$exports = {};
'use strict';
Object.defineProperty($127324ab45dba9de$exports, "__esModule", {
    value: true
});
var $88d4712cf3f9f8d6$exports = {};
"use strict";
Object.defineProperty($88d4712cf3f9f8d6$exports, "__esModule", {
    value: true
});
$88d4712cf3f9f8d6$exports.default = {
    BUFFERING: 3,
    ENDED: 0,
    PAUSED: 2,
    PLAYING: 1,
    UNSTARTED: -1,
    VIDEO_CUED: 5
};
$88d4712cf3f9f8d6$exports = $88d4712cf3f9f8d6$exports["default"];


var $127324ab45dba9de$var$_PlayerStates2 = $127324ab45dba9de$var$_interopRequireDefault($88d4712cf3f9f8d6$exports);
function $127324ab45dba9de$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$127324ab45dba9de$exports.default = {
    pauseVideo: {
        acceptableStates: [
            $127324ab45dba9de$var$_PlayerStates2.default.ENDED,
            $127324ab45dba9de$var$_PlayerStates2.default.PAUSED
        ],
        stateChangeRequired: false
    },
    playVideo: {
        acceptableStates: [
            $127324ab45dba9de$var$_PlayerStates2.default.ENDED,
            $127324ab45dba9de$var$_PlayerStates2.default.PLAYING
        ],
        stateChangeRequired: false
    },
    seekTo: {
        acceptableStates: [
            $127324ab45dba9de$var$_PlayerStates2.default.ENDED,
            $127324ab45dba9de$var$_PlayerStates2.default.PLAYING,
            $127324ab45dba9de$var$_PlayerStates2.default.PAUSED
        ],
        stateChangeRequired: true,
        // TRICKY: `seekTo` may not cause a state change if no buffering is
        // required.
        timeout: 3000
    }
};
$127324ab45dba9de$exports = $127324ab45dba9de$exports['default'];


var $54cb67a45636ed46$var$_FunctionStateMap2 = $54cb67a45636ed46$var$_interopRequireDefault($127324ab45dba9de$exports);
function $54cb67a45636ed46$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable promise/prefer-await-to-then */ var $54cb67a45636ed46$var$debug = (0, $54cb67a45636ed46$var$_debug2.default)('youtube-player');
var $54cb67a45636ed46$var$YouTubePlayer = {};
/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */ $54cb67a45636ed46$var$YouTubePlayer.proxyEvents = function(emitter) {
    var events = {};
    var _loop = function _loop(eventName) {
        var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);
        events[onEventName] = function(event) {
            $54cb67a45636ed46$var$debug('event "%s"', onEventName, event);
            emitter.trigger(eventName, event);
        };
    };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $54cb67a45636ed46$var$_eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var eventName = _step.value;
            _loop(eventName);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
    return events;
};
/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */ $54cb67a45636ed46$var$YouTubePlayer.promisifyPlayer = function(playerAPIReady) {
    var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var functions = {};
    var _loop2 = function _loop2(functionName) {
        if (strictState && $54cb67a45636ed46$var$_FunctionStateMap2.default[functionName]) functions[functionName] = function() {
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return playerAPIReady.then(function(player) {
                var stateInfo = $54cb67a45636ed46$var$_FunctionStateMap2.default[functionName];
                var playerState = player.getPlayerState();
                // eslint-disable-next-line no-warning-comments
                // TODO: Just spread the args into the function once Babel is fixed:
                // https://github.com/babel/babel/issues/4270
                //
                // eslint-disable-next-line prefer-spread
                var value = player[functionName].apply(player, args);
                // TRICKY: For functions like `seekTo`, a change in state must be
                // triggered given that the resulting state could match the initial
                // state.
                if (stateInfo.stateChangeRequired || // eslint-disable-next-line no-extra-parens
                Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) return new Promise(function(resolve) {
                    var onPlayerStateChange = function onPlayerStateChange() {
                        var playerStateAfterChange = player.getPlayerState();
                        var timeout = void 0;
                        if (typeof stateInfo.timeout === 'number') timeout = setTimeout(function() {
                            player.removeEventListener('onStateChange', onPlayerStateChange);
                            resolve();
                        }, stateInfo.timeout);
                        if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                            player.removeEventListener('onStateChange', onPlayerStateChange);
                            clearTimeout(timeout);
                            resolve();
                        }
                    };
                    player.addEventListener('onStateChange', onPlayerStateChange);
                }).then(function() {
                    return value;
                });
                return value;
            });
        };
        else functions[functionName] = function() {
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return playerAPIReady.then(function(player) {
                // eslint-disable-next-line no-warning-comments
                // TODO: Just spread the args into the function once Babel is fixed:
                // https://github.com/babel/babel/issues/4270
                //
                // eslint-disable-next-line prefer-spread
                return player[functionName].apply(player, args);
            });
        };
    };
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $54cb67a45636ed46$var$_functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var functionName = _step2.value;
            _loop2(functionName);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
    return functions;
};
$54cb67a45636ed46$exports.default = $54cb67a45636ed46$var$YouTubePlayer;
$54cb67a45636ed46$exports = $54cb67a45636ed46$exports['default'];


var $b302f860f45377ca$var$_YouTubePlayer2 = $b302f860f45377ca$var$_interopRequireDefault($54cb67a45636ed46$exports);
function $b302f860f45377ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */ /**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */ var $b302f860f45377ca$var$youtubeIframeAPI = void 0;
/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */ $b302f860f45377ca$exports.default = function(maybeElementId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var emitter = (0, $b302f860f45377ca$var$_sister2.default)();
    if (!$b302f860f45377ca$var$youtubeIframeAPI) $b302f860f45377ca$var$youtubeIframeAPI = (0, $b302f860f45377ca$var$_loadYouTubeIframeApi2.default)(emitter);
    if (options.events) throw new Error('Event handlers cannot be overwritten.');
    if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) throw new Error('Element "' + maybeElementId + '" does not exist.');
    options.events = $b302f860f45377ca$var$_YouTubePlayer2.default.proxyEvents(emitter);
    var playerAPIReady = new Promise(function(resolve) {
        if ((typeof maybeElementId === 'undefined' ? 'undefined' : $b302f860f45377ca$var$_typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
            var player = maybeElementId;
            resolve(player);
        } else // asume maybeElementId can be rendered inside
        // eslint-disable-next-line promise/catch-or-return
        $b302f860f45377ca$var$youtubeIframeAPI.then(function(YT) {
            // eslint-disable-line promise/prefer-await-to-then
            var player = new YT.Player(maybeElementId, options);
            emitter.on('ready', function() {
                resolve(player);
            });
            return null;
        });
    });
    var playerApi = $b302f860f45377ca$var$_YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);
    playerApi.on = emitter.on;
    playerApi.off = emitter.off;
    return playerApi;
};
$b302f860f45377ca$exports = $b302f860f45377ca$exports['default'];


function $cad165d75e1b82e6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cad165d75e1b82e6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cad165d75e1b82e6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cad165d75e1b82e6$var$_typeof(obj);
}
function $cad165d75e1b82e6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cad165d75e1b82e6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cad165d75e1b82e6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cad165d75e1b82e6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cad165d75e1b82e6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $cad165d75e1b82e6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $cad165d75e1b82e6$var$_setPrototypeOf(subClass, superClass);
}
function $cad165d75e1b82e6$var$_setPrototypeOf(o, p) {
    $cad165d75e1b82e6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cad165d75e1b82e6$var$_setPrototypeOf(o, p);
}
function $cad165d75e1b82e6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cad165d75e1b82e6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $cad165d75e1b82e6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $cad165d75e1b82e6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cad165d75e1b82e6$var$_possibleConstructorReturn(this, result);
    };
}
function $cad165d75e1b82e6$var$_possibleConstructorReturn(self, call) {
    if (call && ($cad165d75e1b82e6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $cad165d75e1b82e6$var$_assertThisInitialized(self);
}
function $cad165d75e1b82e6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cad165d75e1b82e6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cad165d75e1b82e6$var$_getPrototypeOf(o) {
    $cad165d75e1b82e6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cad165d75e1b82e6$var$_getPrototypeOf(o);
}
function $cad165d75e1b82e6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cad165d75e1b82e6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $cad165d75e1b82e6$var$ownKeys(Object(source), true).forEach(function(key) {
            $cad165d75e1b82e6$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $cad165d75e1b82e6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cad165d75e1b82e6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Check whether a `props` change should result in the video being updated.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */ function $cad165d75e1b82e6$var$shouldUpdateVideo(prevProps, props) {
    // A changing video should always trigger an update
    if (prevProps.videoId !== props.videoId) return true;
     // Otherwise, a change in the start/end time playerVars also requires a player
    // update.
    var prevVars = prevProps.opts.playerVars || {};
    var vars = props.opts.playerVars || {};
    return prevVars.start !== vars.start || prevVars.end !== vars.end;
}
/**
 * Neutralize API options that only require a video update, leaving only options
 * that require a player reset. The results can then be compared to see if a
 * player reset is necessary.
 *
 * @param {Object} opts
 */ function $cad165d75e1b82e6$var$filterResetOptions(opts) {
    return $cad165d75e1b82e6$var$_objectSpread($cad165d75e1b82e6$var$_objectSpread({}, opts), {}, {
        height: 0,
        width: 0,
        playerVars: $cad165d75e1b82e6$var$_objectSpread($cad165d75e1b82e6$var$_objectSpread({}, opts.playerVars), {}, {
            autoplay: 0,
            start: 0,
            end: 0
        })
    });
}
/**
 * Check whether a `props` change should result in the player being reset.
 * The player is reset when the `props.opts` change, except if the only change
 * is in the `start` and `end` playerVars, because a video update can deal with
 * those.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */ function $cad165d75e1b82e6$var$shouldResetPlayer(prevProps, props) {
    return prevProps.videoId !== props.videoId || !(0, (/*@__PURE__*/$parcel$interopDefault($da9c10bf0d633d8b$exports)))($cad165d75e1b82e6$var$filterResetOptions(prevProps.opts), $cad165d75e1b82e6$var$filterResetOptions(props.opts));
}
/**
 * Check whether a props change should result in an id or className update.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */ function $cad165d75e1b82e6$var$shouldUpdatePlayer(prevProps, props) {
    return prevProps.id !== props.id || prevProps.className !== props.className || prevProps.opts.width !== props.opts.width || prevProps.opts.height !== props.opts.height || prevProps.title !== props.title;
}
var $cad165d75e1b82e6$var$YouTube = /*#__PURE__*/ function(_React$Component) {
    $cad165d75e1b82e6$var$_inherits(YouTube, _React$Component);
    var _super = $cad165d75e1b82e6$var$_createSuper(YouTube);
    /**
   * Expose PlayerState constants for convenience. These constants can also be
   * accessed through the global YT object after the YouTube IFrame API is instantiated.
   * https://developers.google.com/youtube/iframe_api_reference#onStateChange
   */ function YouTube(props) {
        var _this;
        $cad165d75e1b82e6$var$_classCallCheck(this, YouTube);
        _this = _super.call(this, props);
        $cad165d75e1b82e6$var$_defineProperty($cad165d75e1b82e6$var$_assertThisInitialized(_this), "onPlayerReady", function(event) {
            return _this.props.onReady(event);
        });
        $cad165d75e1b82e6$var$_defineProperty($cad165d75e1b82e6$var$_assertThisInitialized(_this), "onPlayerError", function(event) {
            return _this.props.onError(event);
        });
        $cad165d75e1b82e6$var$_defineProperty($cad165d75e1b82e6$var$_assertThisInitialized(_this), "onPlayerStateChange", function(event) {
            _this.props.onStateChange(event);
            switch(event.data){
                case YouTube.PlayerState.ENDED:
                    _this.props.onEnd(event);
                    break;
                case YouTube.PlayerState.PLAYING:
                    _this.props.onPlay(event);
                    break;
                case YouTube.PlayerState.PAUSED:
                    _this.props.onPause(event);
                    break;
                default:
            }
        });
        $cad165d75e1b82e6$var$_defineProperty($cad165d75e1b82e6$var$_assertThisInitialized(_this), "onPlayerPlaybackRateChange", function(event) {
            return _this.props.onPlaybackRateChange(event);
        });
        $cad165d75e1b82e6$var$_defineProperty($cad165d75e1b82e6$var$_assertThisInitialized(_this), "onPlayerPlaybackQualityChange", function(event) {
            return _this.props.onPlaybackQualityChange(event);
        });
        $cad165d75e1b82e6$var$_defineProperty($cad165d75e1b82e6$var$_assertThisInitialized(_this), "createPlayer", function() {
            // do not attempt to create a player server-side, it won't work
            if (typeof document === 'undefined') return; // create player
            var playerOpts = $cad165d75e1b82e6$var$_objectSpread($cad165d75e1b82e6$var$_objectSpread({}, _this.props.opts), {}, {
                // preload the `videoId` video if one is already given
                videoId: _this.props.videoId
            });
            _this.internalPlayer = (0, (/*@__PURE__*/$parcel$interopDefault($b302f860f45377ca$exports)))(_this.container, playerOpts); // attach event handlers
            _this.internalPlayer.on('ready', _this.onPlayerReady);
            _this.internalPlayer.on('error', _this.onPlayerError);
            _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
            _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
            _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
        });
        $cad165d75e1b82e6$var$_defineProperty($cad165d75e1b82e6$var$_assertThisInitialized(_this), "resetPlayer", function() {
            return _this.internalPlayer.destroy().then(_this.createPlayer);
        });
        $cad165d75e1b82e6$var$_defineProperty($cad165d75e1b82e6$var$_assertThisInitialized(_this), "updatePlayer", function() {
            _this.internalPlayer.getIframe().then(function(iframe) {
                if (_this.props.id) iframe.setAttribute('id', _this.props.id);
                else iframe.removeAttribute('id');
                if (_this.props.className) iframe.setAttribute('class', _this.props.className);
                else iframe.removeAttribute('class');
                if (_this.props.opts && _this.props.opts.width) iframe.setAttribute('width', _this.props.opts.width);
                else iframe.removeAttribute('width');
                if (_this.props.opts && _this.props.opts.height) iframe.setAttribute('height', _this.props.opts.height);
                else iframe.removeAttribute('height');
                if (typeof _this.props.title === 'string') iframe.setAttribute('title', _this.props.title);
                else iframe.setAttribute('title', 'YouTube video player');
            });
        });
        $cad165d75e1b82e6$var$_defineProperty($cad165d75e1b82e6$var$_assertThisInitialized(_this), "getInternalPlayer", function() {
            return _this.internalPlayer;
        });
        $cad165d75e1b82e6$var$_defineProperty($cad165d75e1b82e6$var$_assertThisInitialized(_this), "updateVideo", function() {
            if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
                _this.internalPlayer.stopVideo();
                return;
            } // set queueing options
            var autoplay = false;
            var opts = {
                videoId: _this.props.videoId
            };
            if ('playerVars' in _this.props.opts) {
                autoplay = _this.props.opts.playerVars.autoplay === 1;
                if ('start' in _this.props.opts.playerVars) opts.startSeconds = _this.props.opts.playerVars.start;
                if ('end' in _this.props.opts.playerVars) opts.endSeconds = _this.props.opts.playerVars.end;
            } // if autoplay is enabled loadVideoById
            if (autoplay) {
                _this.internalPlayer.loadVideoById(opts);
                return;
            } // default behaviour just cues the video
            _this.internalPlayer.cueVideoById(opts);
        });
        $cad165d75e1b82e6$var$_defineProperty($cad165d75e1b82e6$var$_assertThisInitialized(_this), "refContainer", function(container) {
            _this.container = container;
        });
        _this.container = null;
        _this.internalPlayer = null;
        return _this;
    }
    $cad165d75e1b82e6$var$_createClass(YouTube, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.createPlayer();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if ($cad165d75e1b82e6$var$shouldUpdatePlayer(prevProps, this.props)) this.updatePlayer();
                if ($cad165d75e1b82e6$var$shouldResetPlayer(prevProps, this.props)) this.resetPlayer();
                if ($cad165d75e1b82e6$var$shouldUpdateVideo(prevProps, this.props)) this.updateVideo();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                /**
       * Note: The `youtube-player` package that is used promisifies all YouTube
       * Player API calls, which introduces a delay of a tick before it actually
       * gets destroyed. Since React attempts to remove the element instantly
       * this method isn't quick enough to reset the container element.
       */ this.internalPlayer.destroy();
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    className: this.props.containerClassName
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    id: this.props.id,
                    className: this.props.className,
                    ref: this.refContainer,
                    loading: this.props.loading
                }));
            }
        }
    ]);
    return YouTube;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$cad165d75e1b82e6$var$_defineProperty($cad165d75e1b82e6$var$YouTube, "PlayerState", {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    CUED: 5
});
$cad165d75e1b82e6$var$YouTube.propTypes = {
    videoId: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).string,
    // custom ID for player element
    id: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).string,
    // custom class name for player element
    className: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).string,
    // custom class name for player container element
    containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).string,
    // custom title for the iFrame, see https://www.w3.org/TR/WCAG20-TECHS/H64.html
    title: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).string,
    // custom loading for player element
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).oneOf([
        'lazy',
        'eager',
        'auto'
    ]),
    // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
    opts: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).any),
    // event subscriptions
    onReady: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).func,
    onError: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).func,
    onPlay: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).func,
    onPause: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).func,
    onEnd: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).func,
    onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).func,
    onPlaybackRateChange: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).func,
    onPlaybackQualityChange: (0, (/*@__PURE__*/$parcel$interopDefault($0a2fd319aeb28ddf$exports))).func
};
$cad165d75e1b82e6$var$YouTube.defaultProps = {
    videoId: null,
    id: null,
    className: null,
    loading: null,
    opts: {},
    containerClassName: '',
    onReady: function onReady() {},
    onError: function onError() {},
    onPlay: function onPlay() {},
    onPause: function onPause() {},
    onEnd: function onEnd() {},
    onStateChange: function onStateChange() {},
    onPlaybackRateChange: function onPlaybackRateChange() {},
    onPlaybackQualityChange: function onPlaybackQualityChange() {},
    title: null
};
var $cad165d75e1b82e6$export$2e2bcd8739ae039 = $cad165d75e1b82e6$var$YouTube;




class $1b4840eb415c7315$var$YoutubePlayer extends (0, $bh6RR.Component) {
    propTypes = {
        onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func
    };
    constructor(){
        super();
        this.youtubePlayer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createRef();
    }
    play = ()=>{
        this.youtubePlayer.current.internalPlayer.playVideo();
        this.youtubePlayer.current.internalPlayer.setPlaybackRate(1 / (0, $d39cc430308b5205$export$888108240e4c7c6d));
    };
    _checkState = (state)=>{
        const isBuffering = (0, $cad165d75e1b82e6$export$2e2bcd8739ae039).PlayerState.BUFFERING === state;
        if (isBuffering) return 0, $d997c435b848789d$export$928e4fc72ae64313;
        const isPaused = (0, $cad165d75e1b82e6$export$2e2bcd8739ae039).PlayerState.PAUSED === state;
        if (isPaused) return 0, $d997c435b848789d$export$3ad39751a33c16b8;
        return state;
    };
    _onStateChange = (event)=>{
        const state = event.data;
        const parsedState = this._checkState(state);
        this.props.onStateChange(parsedState);
    };
    render() {
        const opts = {
            width: '100%',
            height: '100%',
            playerVars: {
                autoplay: 0,
                controls: 0,
                disablekb: 1,
                enablejsapi: 1,
                fs: 1,
                modestbranding: 1,
                rel: 0,
                showinfo: 0,
                playsinline: 1,
                start: (0, $d39cc430308b5205$export$87d6643ee8fe08fb)
            }
        };
        const { onStateChange: onStateChange, ...props } = this.props;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cad165d75e1b82e6$export$2e2bcd8739ae039), {
            containerClassName: "youtube-player-container",
            className: "youtube-player",
            videoId: (0, $d39cc430308b5205$export$f16af92caec6693c),
            opts: opts,
            onStateChange: this._onStateChange,
            ...props,
            ref: this.youtubePlayer
        });
    }
}
var $1b4840eb415c7315$export$2e2bcd8739ae039 = $1b4840eb415c7315$var$YoutubePlayer;


const $d0e232dbfb9a7548$var$BackgroundVideo = ({ hasPlayerError: hasPlayerError, videoPlayerRef: videoPlayerRef, ...props })=>{
    if (0, $d39cc430308b5205$export$5c1c1b03b1861229) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e232dbecdbe60ad5$export$2e2bcd8739ae039), {
        ...props,
        ref: videoPlayerRef
    });
    if ((0, $d39cc430308b5205$export$e4cd0dd02a748dad) || hasPlayerError) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9c562394e0e8f664$export$2e2bcd8739ae039), {
        ...props,
        ref: videoPlayerRef,
        hasPlayerError: !!hasPlayerError
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1b4840eb415c7315$export$2e2bcd8739ae039), {
        ...props,
        ref: videoPlayerRef
    });
};
$d0e232dbfb9a7548$var$BackgroundVideo.propTypes = {
    videoPlayerRef: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
    hasPlayerError: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).any
};
var $d0e232dbfb9a7548$export$2e2bcd8739ae039 = $d0e232dbfb9a7548$var$BackgroundVideo;




class $142542c37b1c9617$var$VideoContainer extends (0, $bh6RR.Component) {
    static propTypes = {
        fullscreen: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
        onChangeFullscreen: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        configurations: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        opening: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        onVideoEnd: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        playAgain: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool
    };
    static defaultProps = {
        fullscreen: false,
        configurations: {
            texts: []
        }
    };
    constructor(){
        super();
        this.state = {
            videoReady: false,
            openingLoaded: false,
            videoPlaying: false,
            videoStarted: false,
            videoEnded: false,
            videoError: null,
            showPlayButton: false
        };
        this.videoPlayer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createRef();
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { openingLoaded: openingLoaded } = prevState;
        const { opening: opening, playAgain: playAgain } = nextProps;
        if (!openingLoaded && opening) {
            const nextState = {
                openingLoaded: true
            };
            return nextState;
        }
        if (playAgain) {
            const nextState = {
                videoEnded: false
            };
            return nextState;
        }
        return null;
    }
    componentDidMount() {
        if (!this.props.configurations.overlay) (0, $c1063bcab77d5448$export$2e2bcd8739ae039)();
    }
    componentDidUpdate(prevProps, prevState) {
        const { videoStarted: videoStarted, videoReady: videoReady, openingLoaded: openingLoaded } = this.state;
        const wasVideoReady = prevState.videoReady && prevState.openingLoaded;
        const isVideoReady = videoReady && openingLoaded;
        const isNowVideoReady = !wasVideoReady && isVideoReady;
        const { playAgain: playAgain } = this.props;
        // Start video if wasn't ready before and is ready to play now
        // or if the user hit play again.
        if (!videoStarted && (isNowVideoReady || playAgain)) this.videoPlayer.current.play();
    }
    onVideoStartPlay = ()=>{
        Raven.captureBreadcrumb({
            message: 'Video start play',
            category: 'videoPlayer'
        });
        setTimeout(()=>{
            this.setState({
                videoPlaying: true,
                videoStarted: true,
                showPlayButton: false
            });
        }, (0, $d39cc430308b5205$export$bc5effe1949c621f));
    };
    onVideoStateChange = (event)=>{
        Raven.captureBreadcrumb({
            message: 'Video state change',
            category: 'videoPlayer',
            data: {
                event: event
            }
        });
        const { videoReady: videoReady, videoStarted: videoStarted, openingLoaded: openingLoaded } = this.state;
        const { playAgain: playAgain } = this.props;
        const isBuffering = (0, $d997c435b848789d$export$928e4fc72ae64313) === event;
        const isPaused = (0, $d997c435b848789d$export$3ad39751a33c16b8) === event;
        const isVideoReadyToPlay = videoReady && openingLoaded;
        if (isBuffering || isPaused) this.setState({
            videoPlaying: false
        });
        // If autoplay fail should show the play button
        // for the user interact with the page and play the video
        if (isVideoReadyToPlay && !videoStarted && !isBuffering && !playAgain) this.setState({
            showPlayButton: true
        });
        // prevent Play button to show when still buffering the video.
        if (isBuffering) this.setState({
            showPlayButton: false
        });
    };
    onVideoReady = ()=>{
        Raven.captureBreadcrumb({
            message: 'Video ready',
            category: 'videoPlayer'
        });
        this.setState({
            videoReady: true
        });
    };
    onVideoEnd = ()=>{
        Raven.captureBreadcrumb({
            message: 'Video ended',
            category: 'videoPlayer'
        });
        this.props.onVideoEnd();
        this.setState({
            videoPlaying: false,
            videoStarted: false,
            videoEnded: true
        });
    };
    onVideoPause = ()=>{
        Raven.captureBreadcrumb({
            message: 'Video paused',
            category: 'videoPlayer'
        });
    };
    onVideoError = (event)=>{
        Raven.captureBreadcrumb({
            message: 'Video error',
            category: 'videoPlayer',
            level: 'error',
            data: {
                data: event.data
            }
        });
        this.setState({
            videoError: event.data,
            videoReady: false
        });
    };
    onVideoPlaybackRateChange = (event)=>{
        Raven.captureBreadcrumb({
            message: 'Video playback rate change',
            category: 'videoPlayer',
            data: {
                data: event.data
            }
        });
    };
    onVideoPlaybackQualityChange = (event)=>{
        Raven.captureBreadcrumb({
            message: 'Video playback quality change',
            category: 'videoPlayer',
            data: {
                data: event.data
            }
        });
    };
    _handleClickPlay = ()=>{
        this.videoPlayer.current.play();
    };
    render() {
        const { configurations: configurations, opening: opening } = this.props;
        const { videoPlaying: videoPlaying, videoReady: videoReady, videoStarted: videoStarted, openingLoaded: openingLoaded, videoEnded: videoEnded, videoError: videoError, showPlayButton: showPlayButton } = this.state;
        const isLoading = (0, $d39cc430308b5205$export$7392ea15d6a929a4) && !videoEnded && (!openingLoaded || !videoReady || !videoStarted);
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "video-container",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($9ee85db91d407c9f$exports))), {
                        enabled: (0, $70d54b79d383c562$export$2e2bcd8739ae039).fullscreenEnabled && this.props.fullscreen,
                        onChange: this.props.onChangeFullscreen,
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d0e232dbfb9a7548$export$2e2bcd8739ae039), {
                                onPlay: this.onVideoStartPlay,
                                onReady: this.onVideoReady,
                                onEnd: this.onVideoEnd,
                                onStateChange: this.onVideoStateChange,
                                onPause: this.onVideoPause,
                                onError: this.onVideoError,
                                onPlaybackRateChange: this.onVideoPlaybackRateChange,
                                onPlaybackQualityChange: this.onVideoPlaybackQualityChange,
                                videoPlayerRef: this.videoPlayer,
                                hasPlayerError: videoError
                            }),
                            !!opening && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e85104d277b77d32$export$2e2bcd8739ae039), {
                                configurations: configurations,
                                playing: videoPlaying,
                                playStart: videoStarted
                            })
                        ]
                    })
                }),
                showPlayButton && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b020b184d701f9e3$export$2e2bcd8739ae039), {
                    onClick: this._handleClickPlay
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $717f6f9cd6378efa$export$2e2bcd8739ae039), {
                    isLoading: !showPlayButton && isLoading
                })
            ]
        });
    }
}
const $142542c37b1c9617$var$mapConfigurationsToProps = (context)=>({
        configurations: context
    });
const $142542c37b1c9617$var$mapOpeningProviderToProps = (context)=>({
        opening: context.opening
    });
const $142542c37b1c9617$var$connectConfigurations = (0, (/*@__PURE__*/$parcel$interopDefault($17bc0d4f42435b88$exports)))((0, $2ef9ff2da13ee5ca$export$2e2bcd8739ae039), $142542c37b1c9617$var$mapConfigurationsToProps);
const $142542c37b1c9617$var$connectOpeningProvider = (0, (/*@__PURE__*/$parcel$interopDefault($17bc0d4f42435b88$exports)))((0, $87127865826734e4$export$2e2bcd8739ae039), $142542c37b1c9617$var$mapOpeningProviderToProps);
var $142542c37b1c9617$export$2e2bcd8739ae039 = $142542c37b1c9617$var$connectConfigurations($142542c37b1c9617$var$connectOpeningProvider($142542c37b1c9617$var$VideoContainer));



parcelRequire("bh6RR");



parcelRequire("bh6RR");
const $5a22ae36f81196ea$var$ContactButton = ({ customText: customText = 'If you have any questions, please check our FAQ or contact us through the link:' })=>{
    const link = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
        href: "https://kassellabs.io/help/game-of-thrones-intro-creator",
        rel: "noopener noreferrer",
        target: "_blank",
        className: "link",
        children: "FAQ and Contact"
    });
    if (customText) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
        children: [
            customText,
            ' ',
            link
        ]
    });
    return link;
};
var $5a22ae36f81196ea$export$2e2bcd8739ae039 = $5a22ae36f81196ea$var$ContactButton;



parcelRequire("bh6RR");
const $c794d0292d6e750b$var$TermsOfServiceAcceptance = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
        children: [
            "By using this website you are agreeing to our",
            ' ',
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                className: "link",
                href: "https://kassellabs.io/terms",
                target: "_blank",
                rel: "noopener noreferrer",
                children: "Terms of Service"
            }),
            "."
        ]
    });
var $c794d0292d6e750b$export$2e2bcd8739ae039 = $c794d0292d6e750b$var$TermsOfServiceAcceptance;



parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");



var $2e5310b7e303c483$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $2e5310b7e303c483$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $2e5310b7e303c483$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2e5310b7e303c483$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $2e5310b7e303c483$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $2e5310b7e303c483$var$isModifiedEvent = function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
/**
 * The public API for rendering a history-aware <a>.
 */ var $2e5310b7e303c483$var$Link = function(_React$Component) {
    $2e5310b7e303c483$var$_inherits(Link, _React$Component);
    function Link() {
        var _temp, _this, _ret;
        $2e5310b7e303c483$var$_classCallCheck(this, Link);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $2e5310b7e303c483$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore everything but left clicks
            !_this.props.target && // let browser handle "target=_blank" etc.
            !$2e5310b7e303c483$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                var history = _this.context.router.history;
                var _this$props = _this.props, replace = _this$props.replace, to = _this$props.to;
                if (replace) history.replace(to);
                else history.push(to);
            }
        }, _temp), $2e5310b7e303c483$var$_possibleConstructorReturn(_this, _ret);
    }
    Link.prototype.render = function render() {
        var _props = this.props, replace = _props.replace, to = _props.to, innerRef = _props.innerRef, props = $2e5310b7e303c483$var$_objectWithoutProperties(_props, [
            "replace",
            "to",
            "innerRef"
        ]); // eslint-disable-line no-unused-vars
        (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(this.context.router, "You should not use <Link> outside a <Router>");
        (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(to !== undefined, 'You must specify the "to" property');
        var history = this.context.router.history;
        var location = typeof to === "string" ? (0, $32e4998d9dcb6f96$export$90c043f1c57770b8)(to, null, null, history.location) : to;
        var href = history.createHref(location);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("a", $2e5310b7e303c483$var$_extends({}, props, {
            onClick: this.handleClick,
            href: href,
            ref: innerRef
        }));
    };
    return Link;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$2e5310b7e303c483$var$Link.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
    ]).isRequired,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func
    ])
};
$2e5310b7e303c483$var$Link.defaultProps = {
    replace: false
};
$2e5310b7e303c483$var$Link.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func.isRequired,
            createHref: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func.isRequired
        }).isRequired
    }).isRequired
};
var $2e5310b7e303c483$export$2e2bcd8739ae039 = $2e5310b7e303c483$var$Link;


const $1e45e86148133c84$var$ButtonLink = ({ children: children, className: className, to: to, style: style })=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2e5310b7e303c483$export$2e2bcd8739ae039), {
        to: to,
        style: {
            display: 'inline-block'
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
            className: className,
            style: style,
            children: children
        })
    });
$1e45e86148133c84$var$ButtonLink.propTypes = {
    to: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).any,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
var $1e45e86148133c84$export$2e2bcd8739ae039 = $1e45e86148133c84$var$ButtonLink;



const $fe445d5ab41c5a85$var$AfterVideoCard = ({ match: match })=>{
    const { openingKey: openingKey } = match.params;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "after-video-card",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "box",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        children: [
                            "Great! You made your own custom ",
                            (0, $d39cc430308b5205$export$cb3d07a9e503e9e2),
                            " opening!"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        children: [
                            "If the video did not play smoothly and paused for loading, it may have caused desynchronization with the text.",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            "Try to play it again. As the video already been loaded the next reproduction should be better."
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                        children: "You can now request to download your creation as a video."
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "buttons",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e45e86148133c84$export$2e2bcd8739ae039), {
                                to: `/${openingKey}/download`,
                                className: "button big",
                                children: "Download"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e45e86148133c84$export$2e2bcd8739ae039), {
                                to: `/${openingKey}/edit`,
                                className: "button medium",
                                children: "Back to Edit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                        children: "You can also share your creation by copying the URL link in your browser and send to your friends."
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a22ae36f81196ea$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c794d0292d6e750b$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
$fe445d5ab41c5a85$var$AfterVideoCard.propTypes = {
    match: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
var $fe445d5ab41c5a85$export$2e2bcd8739ae039 = (0, $df938650094f2b43$export$2e2bcd8739ae039)($fe445d5ab41c5a85$var$AfterVideoCard);




class $20d1603623f12c2f$var$VideoPage extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    static propTypes = {
        match: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        loadOpening: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func
    };
    state = {
        isFullscreenEnabled: false,
        isLoading: true,
        videoEnded: false,
        playAgain: false
    };
    static getDerivedStateFromProps(nextProps, prevState) {
        const { match: match } = nextProps;
        const { openingKey: openingKey } = match.params;
        const openingKeyLoaded = nextProps.openingKey;
        if (openingKey === openingKeyLoaded) return {
            ...prevState,
            isLoading: false
        };
        return prevState;
    }
    componentDidMount() {
        const { match: match, loadOpening: loadOpening } = this.props;
        const { openingKey: openingKey } = match.params;
        loadOpening(openingKey);
    }
    _setFullscreen = ()=>{
        this.setState({
            isFullscreenEnabled: true
        });
    };
    handleChangeFullscreen = (isFullscreenEnabled)=>{
        this.setState({
            isFullscreenEnabled: isFullscreenEnabled
        });
    };
    handleVideoEnd = ()=>{
        this.setState({
            isFullscreenEnabled: false,
            videoEnded: true,
            playAgain: false
        });
    };
    _playAgain = ()=>{
        this.setState({
            playAgain: true,
            videoEnded: false
        });
    };
    render() {
        const { match: match } = this.props;
        const { openingKey: openingKey } = match.params;
        const { videoEnded: videoEnded } = this.state;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            id: "videoPage",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                    className: "sr-only",
                    children: "Game of Thrones Intro Creator"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $142542c37b1c9617$export$2e2bcd8739ae039), {
                    fullscreen: this.state.isFullscreenEnabled,
                    onChangeFullscreen: this.handleChangeFullscreen,
                    onVideoEnd: this.handleVideoEnd,
                    playAgain: this.state.playAgain
                }),
                (0, $d39cc430308b5205$export$7392ea15d6a929a4) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
                    children: [
                        videoEnded && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fe445d5ab41c5a85$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "buttons-container",
                            children: [
                                (0, $70d54b79d383c562$export$2e2bcd8739ae039).fullscreenEnabled && !videoEnded && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e45e86148133c84$export$2e2bcd8739ae039), {
                                            to: `/${openingKey}/download`,
                                            className: "button",
                                            children: "Download"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e45e86148133c84$export$2e2bcd8739ae039), {
                                            to: `/${openingKey}/edit`,
                                            className: "button",
                                            children: "Back to Edit"
                                        })
                                    ]
                                }),
                                videoEnded && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    onClick: this._playAgain,
                                    className: "button",
                                    children: "Play Again"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
const $20d1603623f12c2f$var$mapOpeningProviderToProps = (context)=>({
        loadOpening: context.loadOpening
    });
const $20d1603623f12c2f$var$connectOpeningProvider = (0, (/*@__PURE__*/$parcel$interopDefault($17bc0d4f42435b88$exports)))((0, $87127865826734e4$export$2e2bcd8739ae039), $20d1603623f12c2f$var$mapOpeningProviderToProps);
var $20d1603623f12c2f$export$2e2bcd8739ae039 = (0, $df938650094f2b43$export$2e2bcd8739ae039)($20d1603623f12c2f$var$connectOpeningProvider($20d1603623f12c2f$var$VideoPage));




var $bh6RR = parcelRequire("bh6RR");



parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
var $a1828ac4fc2b6921$exports = {};
$a1828ac4fc2b6921$exports = $parcel$resolve("bRYlD");


class $9c2a358adba055d3$var$NavBar extends (0, $bh6RR.Component) {
    state = {
        showMenu: false
    };
    _toggleMenu = ()=>{
        this.setState({
            showMenu: !this.state.showMenu
        });
    };
    render() {
        const { showMenu: showMenu } = this.state;
        const menu = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
            className: "menu",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: "/#/",
                        children: "HOME"
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: "https://kassellabs.io/contact",
                        children: "CONTACT"
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            children: "HELP"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                            className: "dropdown",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                        href: "https://kassellabs.io/help/game-of-thrones-intro-creator",
                                        children: "FAQ"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                        href: "https://kassellabs.io/terms",
                                        children: "TERMS OF SERVICE"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                        href: "https://kassellabs.io/privacy",
                                        children: "PRIVACY POLICY"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                        href: "https://kassellabs.io/about",
                                        children: "ABOUT US"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: "https://kassellabs.io",
                        children: "MORE APPS"
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("nav", {
            className: "navBar",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "kasselLogo",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                href: "https://kassellabs.io",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a1828ac4fc2b6921$exports))),
                                    alt: "Kassel Labs",
                                    width: "160",
                                    height: "20"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                            htmlFor: "show-menu",
                            className: "show-menu",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                    onChange: this._toggleMenu,
                                    type: "checkbox",
                                    id: "show-menu",
                                    role: "button"
                                })
                            ]
                        }),
                        menu
                    ]
                }),
                showMenu && menu
            ]
        });
    }
}
var $9c2a358adba055d3$export$2e2bcd8739ae039 = $9c2a358adba055d3$var$NavBar;


const $26778b50e82826b4$var$PageContainer = ({ children: children })=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "page-container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "background-image"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9c2a358adba055d3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "center-content",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                        className: "app-title",
                        children: "GAME OF THRONES INTRO CREATOR"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "footer",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "social-pages",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                href: "https://www.facebook.com/KasselLabs",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
                                    role: "img",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("title", {
                                            children: "Facebook icon"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                            d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                href: "https://instagram.com/KasselLabs",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
                                    role: "img",
                                    viewBox: "0 0 24 24",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("title", {
                                            children: "Instagram icon"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                            d: "M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                href: "https://twitter.com/KasselLabs",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
                                    role: "img",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("title", {
                                            children: "Twitter icon"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                            d: "M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "fb-share-button",
                        "data-href": "https://gameofthronesintrocreator.kassellabs.io/",
                        "data-layout": "button_count",
                        "data-size": "small",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fgameofthronesintrocreator.kassellabs.io%2F&src=sdkpreparse",
                            className: "fb-xfbml-parse-ignore",
                            children: "Share"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: "https://twitter.com/share",
                        className: "twitter-share-button",
                        "data-text": "Check out the Game Intro Creator from @KasselLabs!",
                        "data-url": "https://gameofthronesintrocreator.kassellabs.io/",
                        "data-hashtags": "GameOfThrones,KasselLabs",
                        children: "Tweet"
                    })
                ]
            })
        ]
    });
$26778b50e82826b4$var$PageContainer.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).node
};
var $26778b50e82826b4$export$2e2bcd8739ae039 = $26778b50e82826b4$var$PageContainer;





var $bh6RR = parcelRequire("bh6RR");



var $1DYgm = parcelRequire("1DYgm");




/* eslint-disable jsx-a11y/interactive-supports-focus */ 

var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
function $aafa81330f82e15b$var$___$insertStyle(css) {
    if (!css) return;
    if (typeof window === 'undefined') return;
    var style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}
function $aafa81330f82e15b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aafa81330f82e15b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $aafa81330f82e15b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $aafa81330f82e15b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $aafa81330f82e15b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $aafa81330f82e15b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aafa81330f82e15b$var$_extends() {
    $aafa81330f82e15b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aafa81330f82e15b$var$_extends.apply(this, arguments);
}
function $aafa81330f82e15b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aafa81330f82e15b$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aafa81330f82e15b$var$ownKeys(Object(source), true).forEach(function(key) {
            $aafa81330f82e15b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aafa81330f82e15b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aafa81330f82e15b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $aafa81330f82e15b$var$_setPrototypeOf(subClass, superClass);
}
function $aafa81330f82e15b$var$_getPrototypeOf(o) {
    $aafa81330f82e15b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $aafa81330f82e15b$var$_getPrototypeOf(o);
}
function $aafa81330f82e15b$var$_setPrototypeOf(o, p) {
    $aafa81330f82e15b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $aafa81330f82e15b$var$_setPrototypeOf(o, p);
}
function $aafa81330f82e15b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $aafa81330f82e15b$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $aafa81330f82e15b$var$_assertThisInitialized(self);
}
function $aafa81330f82e15b$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $aafa81330f82e15b$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $aafa81330f82e15b$var$emptyFunction = function emptyFunction() {};
$aafa81330f82e15b$var$emptyFunction.thatReturns = $aafa81330f82e15b$var$makeEmptyFunction;
$aafa81330f82e15b$var$emptyFunction.thatReturnsFalse = $aafa81330f82e15b$var$makeEmptyFunction(false);
$aafa81330f82e15b$var$emptyFunction.thatReturnsTrue = $aafa81330f82e15b$var$makeEmptyFunction(true);
$aafa81330f82e15b$var$emptyFunction.thatReturnsNull = $aafa81330f82e15b$var$makeEmptyFunction(null);
$aafa81330f82e15b$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$aafa81330f82e15b$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
var $aafa81330f82e15b$var$emptyFunction_1 = $aafa81330f82e15b$var$emptyFunction;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $aafa81330f82e15b$var$validateFormat = function validateFormat(format) {};
function $aafa81330f82e15b$var$invariant(condition, format, a, b, c, d, e, f) {
    $aafa81330f82e15b$var$validateFormat(format);
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}
var $aafa81330f82e15b$var$invariant_1 = $aafa81330f82e15b$var$invariant;
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $aafa81330f82e15b$var$warning = $aafa81330f82e15b$var$emptyFunction_1;
var $aafa81330f82e15b$var$printWarning;
var $aafa81330f82e15b$var$warning_1 = $aafa81330f82e15b$var$warning;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var $aafa81330f82e15b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $aafa81330f82e15b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $aafa81330f82e15b$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $aafa81330f82e15b$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $aafa81330f82e15b$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
var $aafa81330f82e15b$var$objectAssign = $aafa81330f82e15b$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $aafa81330f82e15b$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($aafa81330f82e15b$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($aafa81330f82e15b$var$getOwnPropertySymbols) {
            symbols = $aafa81330f82e15b$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($aafa81330f82e15b$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aafa81330f82e15b$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var $aafa81330f82e15b$var$ReactPropTypesSecret_1 = $aafa81330f82e15b$var$ReactPropTypesSecret;
var $aafa81330f82e15b$var$invariant$1, $aafa81330f82e15b$var$warning$1, $aafa81330f82e15b$var$ReactPropTypesSecret$1, $aafa81330f82e15b$var$loggedTypeFailures;
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $aafa81330f82e15b$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    var typeSpecName, error, ex, stack;
}
var $aafa81330f82e15b$var$checkPropTypes_1 = $aafa81330f82e15b$var$checkPropTypes;
var $aafa81330f82e15b$var$factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message) {
        this.message = message;
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache, manualPropTypeWarningCount;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $aafa81330f82e15b$var$ReactPropTypesSecret_1) {
                if (throwOnDirectAccess) // New behavior only for users of `prop-types` package
                $aafa81330f82e15b$var$invariant_1(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                else var cacheKey;
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($aafa81330f82e15b$var$emptyFunction_1.thatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $aafa81330f82e15b$var$ReactPropTypesSecret_1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) return $aafa81330f82e15b$var$emptyFunction_1.thatReturnsNull;
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if (propValue.hasOwnProperty(key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $aafa81330f82e15b$var$ReactPropTypesSecret_1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) return $aafa81330f82e15b$var$emptyFunction_1.thatReturnsNull;
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $aafa81330f82e15b$var$warning_1(false, "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.", getPostfixForTypeWarning(checker), i);
                return $aafa81330f82e15b$var$emptyFunction_1.thatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                if (checker(props, propName, componentName, location, propFullName, $aafa81330f82e15b$var$ReactPropTypesSecret_1) == null) return null;
            }
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (!checker) continue;
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $aafa81330f82e15b$var$ReactPropTypesSecret_1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from
            // props.
            var allKeys = $aafa81330f82e15b$var$objectAssign({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $aafa81330f82e15b$var$ReactPropTypesSecret_1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $aafa81330f82e15b$var$checkPropTypes_1;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
var $aafa81330f82e15b$var$factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aafa81330f82e15b$var$ReactPropTypesSecret_1) // It is still safe when called from React.
        return;
        $aafa81330f82e15b$var$invariant_1(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    } // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim
    };
    ReactPropTypes.checkPropTypes = $aafa81330f82e15b$var$emptyFunction_1;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
var $aafa81330f82e15b$var$propTypes = $aafa81330f82e15b$var$createCommonjsModule(function(module) {
    var REACT_ELEMENT_TYPE, isValidElement, throwOnDirectAccess;
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = $aafa81330f82e15b$var$factoryWithThrowingShims();
});
var $aafa81330f82e15b$var$CONSTANT = {
    GLOBAL: {
        HIDE: "__react_tooltip_hide_event",
        REBUILD: "__react_tooltip_rebuild_event",
        SHOW: "__react_tooltip_show_event"
    }
};
/**
 * Static methods for react-tooltip
 */ var $aafa81330f82e15b$var$dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    var event;
    if (typeof window.CustomEvent === "function") event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent("Event");
        event.initEvent(eventName, false, true);
        event.detail = opts;
    }
    window.dispatchEvent(event);
};
function $aafa81330f82e15b$var$staticMethods(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        $aafa81330f82e15b$var$dispatchGlobalEvent($aafa81330f82e15b$var$CONSTANT.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        $aafa81330f82e15b$var$dispatchGlobalEvent($aafa81330f82e15b$var$CONSTANT.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        $aafa81330f82e15b$var$dispatchGlobalEvent($aafa81330f82e15b$var$CONSTANT.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            var e = {
                currentTarget: event.detail.target
            };
            this.showTooltip(e, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
}
/**
 * Events that should be bound to the window
 */ function $aafa81330f82e15b$var$windowListener(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener($aafa81330f82e15b$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener($aafa81330f82e15b$var$CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild
        window.removeEventListener($aafa81330f82e15b$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener($aafa81330f82e15b$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show
        window.removeEventListener($aafa81330f82e15b$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener($aafa81330f82e15b$var$CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize
        if (resizeHide) {
            window.removeEventListener("resize", this.onWindowResize);
            window.addEventListener("resize", this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener($aafa81330f82e15b$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener($aafa81330f82e15b$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener($aafa81330f82e15b$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener("resize", this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var $aafa81330f82e15b$var$checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute("currentItem");
    if (!isCapture) e.stopPropagation();
    if (show && currentItem === "true") {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute("currentItem", "true");
        $aafa81330f82e15b$var$setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var $aafa81330f82e15b$var$setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute("currentItem", "false");
    else targetArray[i].setAttribute("currentItem", "true");
};
var $aafa81330f82e15b$var$customListeners = {
    id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: $aafa81330f82e15b$var$_defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};
function $aafa81330f82e15b$var$customEvent(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute("data-event");
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute("data-event") || event;
        var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
        dataEvent.split(" ").forEach(function(event) {
            ele.removeEventListener(event, $aafa81330f82e15b$var$customListeners.get(ele, event));
            var customListener = $aafa81330f82e15b$var$checkStatus.bind(_this, dataEventOff);
            $aafa81330f82e15b$var$customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(" ").forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute("data-event");
        var dataEventOff = eventOff || ele.getAttribute("data-event-off");
        ele.removeEventListener(dataEvent, $aafa81330f82e15b$var$customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
/**
 * Util method to judge if it should follow capture model
 */ function $aafa81330f82e15b$var$isCapture(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
    };
}
/**
 * Util method to get effect
 */ function $aafa81330f82e15b$var$getEffect(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute("data-effect");
        return dataEffect || this.props.effect || "float";
    };
}
/**
 * Util method to get effect
 */ var $aafa81330f82e15b$var$makeProxy = function makeProxy(e) {
    var proxy = {};
    for(var key in e)if (typeof e[key] === "function") proxy[key] = e[key].bind(e);
    else proxy[key] = e[key];
    return proxy;
};
var $aafa81330f82e15b$var$bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = e.target.getAttribute("data-tip") || null;
    var forId = e.target.getAttribute("data-for") || null;
    var target = e.target;
    if (this.isCustomEvent(target) && !customEvent) return;
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
        var proxy = $aafa81330f82e15b$var$makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var $aafa81330f82e15b$var$findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function(target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(" ").forEach(function(event) {
            return events[event] = true;
        });
    });
    return events;
};
var $aafa81330f82e15b$var$getBody = function getBody() {
    return document.getElementsByTagName("body")[0];
};
function $aafa81330f82e15b$var$bodyMode(target) {
    target.prototype.isBodyMode = function() {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function(targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = $aafa81330f82e15b$var$getBody();
        var customEvents = $aafa81330f82e15b$var$findCustomEvents(targetArray, "data-event");
        var customEventsOff = $aafa81330f82e15b$var$findCustomEvents(targetArray, "data-event-off");
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(" ").forEach(function(event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(" ").forEach(function(event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = $aafa81330f82e15b$var$bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = $aafa81330f82e15b$var$bodyListener.bind(this, this.updateTooltip, {
                respectEffect: true
            });
            listeners.mouseout = $aafa81330f82e15b$var$bodyListener.bind(this, this.hideTooltip, {});
        }
        for(var _event in customEvents)listeners[_event] = $aafa81330f82e15b$var$bodyListener.bind(this, function(e) {
            var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
            $aafa81330f82e15b$var$checkStatus.call(_this, targetEventOff, e);
        }, {
            customEvent: true
        });
        for(var _event2 in customEventsOff)listeners[_event2] = $aafa81330f82e15b$var$bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
        });
        for(var _event3 in listeners)body.addEventListener(_event3, listeners[_event3]);
    };
    target.prototype.unbindBodyListener = function(body) {
        body = body || $aafa81330f82e15b$var$getBody();
        var listeners = this.bodyModeListeners;
        for(var event in listeners)body.removeEventListener(event, listeners[event]);
    };
}
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var $aafa81330f82e15b$var$getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function $aafa81330f82e15b$var$trackRemoval(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = $aafa81330f82e15b$var$getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ function $aafa81330f82e15b$var$getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = $aafa81330f82e15b$var$getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = $aafa81330f82e15b$var$getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = $aafa81330f82e15b$var$getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = $aafa81330f82e15b$var$getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = $aafa81330f82e15b$var$calculateOffset(offset), extraOffset_X = _calculateOffset.extraOffset_X, extraOffset_Y = _calculateOffset.extraOffset_Y;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = $aafa81330f82e15b$var$getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offset_X = defaultOffset[place].l;
        return mouseX + offset_X + extraOffset_X;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offset_X = defaultOffset[place].r;
        return mouseX + offset_X + extraOffset_X;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offset_Y = defaultOffset[place].t;
        return mouseY + offset_Y + extraOffset_Y;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offset_Y = defaultOffset[place].b;
        return mouseY + offset_Y + extraOffset_Y;
    }; //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    }; // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placesList = [
        "top",
        "bottom",
        "left",
        "right"
    ];
    var insideList = [];
    for(var i = 0; i < 4; i++){
        var p = placesList[i];
        if (inside(p)) insideList.push(p);
    }
    var isNewState = false;
    var newPlace;
    var shouldUpdatePlace = desiredPlace !== place;
    if (inside(desiredPlace) && shouldUpdatePlace) {
        isNewState = true;
        newPlace = desiredPlace;
    } else if (insideList.length > 0 && shouldUpdatePlace && outside(desiredPlace) && outside(place)) {
        isNewState = true;
        newPlace = insideList[0];
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var $aafa81330f82e15b$var$getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
}; // Get current mouse offset
var $aafa81330f82e15b$var$getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = $aafa81330f82e15b$var$getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === "float") return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
}; // List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var $aafa81330f82e15b$var$getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === "float") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === "solid") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
}; // Consider additional offset into position calculation
var $aafa81330f82e15b$var$calculateOffset = function calculateOffset(offset) {
    var extraOffset_X = 0;
    var extraOffset_Y = 0;
    if (Object.prototype.toString.apply(offset) === "[object String]") offset = JSON.parse(offset.toString().replace(/\'/g, '"'));
    for(var key in offset){
        if (key === "top") extraOffset_Y -= parseInt(offset[key], 10);
        else if (key === "bottom") extraOffset_Y += parseInt(offset[key], 10);
        else if (key === "left") extraOffset_X -= parseInt(offset[key], 10);
        else if (key === "right") extraOffset_X += parseInt(offset[key], 10);
    }
    return {
        extraOffset_X: extraOffset_X,
        extraOffset_Y: extraOffset_Y
    };
}; // Get the offset of the parent elements
var $aafa81330f82e15b$var$getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        if (window.getComputedStyle(currentParent).getPropertyValue("transform") !== "none") break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */ function $aafa81330f82e15b$var$getTipContent(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === "false" || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
     // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
}
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function $aafa81330f82e15b$var$parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */ function $aafa81330f82e15b$var$nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
}
$aafa81330f82e15b$var$___$insertStyle(".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip:before, .__react_component_tooltip:after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0px;\n  margin-left: 0px;\n  visibility: visible;\n}\n.__react_component_tooltip.type-dark {\n  color: #fff;\n  background-color: #222;\n}\n.__react_component_tooltip.type-dark.place-top:after {\n  border-top-color: #222;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-bottom:after {\n  border-bottom-color: #222;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-left:after {\n  border-left-color: #222;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-right:after {\n  border-right-color: #222;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-dark.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-success {\n  color: #fff;\n  background-color: #8DC572;\n}\n.__react_component_tooltip.type-success.place-top:after {\n  border-top-color: #8DC572;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-success.place-bottom:after {\n  border-bottom-color: #8DC572;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-success.place-left:after {\n  border-left-color: #8DC572;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-success.place-right:after {\n  border-right-color: #8DC572;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-success.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning {\n  color: #fff;\n  background-color: #F0AD4E;\n}\n.__react_component_tooltip.type-warning.place-top:after {\n  border-top-color: #F0AD4E;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-bottom:after {\n  border-bottom-color: #F0AD4E;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-left:after {\n  border-left-color: #F0AD4E;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-right:after {\n  border-right-color: #F0AD4E;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-warning.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-error {\n  color: #fff;\n  background-color: #BE6464;\n}\n.__react_component_tooltip.type-error.place-top:after {\n  border-top-color: #BE6464;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-error.place-bottom:after {\n  border-bottom-color: #BE6464;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-error.place-left:after {\n  border-left-color: #BE6464;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-error.place-right:after {\n  border-right-color: #BE6464;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-error.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-info {\n  color: #fff;\n  background-color: #337AB7;\n}\n.__react_component_tooltip.type-info.place-top:after {\n  border-top-color: #337AB7;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-info.place-bottom:after {\n  border-bottom-color: #337AB7;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-info.place-left:after {\n  border-left-color: #337AB7;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-info.place-right:after {\n  border-right-color: #337AB7;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-info.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-light {\n  color: #222;\n  background-color: #fff;\n}\n.__react_component_tooltip.type-light.place-top:after {\n  border-top-color: #fff;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-light.place-bottom:after {\n  border-bottom-color: #fff;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-light.place-left:after {\n  border-left-color: #fff;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-light.place-right:after {\n  border-right-color: #fff;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-light.border {\n  border: 1px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-top:before {\n  border-top: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-bottom:before {\n  border-bottom: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-left:before {\n  border-left: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-right:before {\n  border-right: 8px solid #222;\n}\n.__react_component_tooltip.place-top {\n  margin-top: -10px;\n}\n.__react_component_tooltip.place-top:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-top:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  bottom: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-bottom {\n  margin-top: 10px;\n}\n.__react_component_tooltip.place-bottom:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  top: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-left {\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-left:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  right: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip.place-right {\n  margin-left: 10px;\n}\n.__react_component_tooltip.place-right:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  left: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0px;\n  text-align: center;\n}");
var $aafa81330f82e15b$var$_class, $aafa81330f82e15b$var$_class2, $aafa81330f82e15b$var$_temp;
var $aafa81330f82e15b$var$ReactTooltip = $aafa81330f82e15b$var$staticMethods($aafa81330f82e15b$var$_class = $aafa81330f82e15b$var$windowListener($aafa81330f82e15b$var$_class = $aafa81330f82e15b$var$customEvent($aafa81330f82e15b$var$_class = $aafa81330f82e15b$var$isCapture($aafa81330f82e15b$var$_class = $aafa81330f82e15b$var$getEffect($aafa81330f82e15b$var$_class = $aafa81330f82e15b$var$bodyMode($aafa81330f82e15b$var$_class = $aafa81330f82e15b$var$trackRemoval($aafa81330f82e15b$var$_class = ($aafa81330f82e15b$var$_temp = $aafa81330f82e15b$var$_class2 = /*#__PURE__*/ function(_React$Component) {
    $aafa81330f82e15b$var$_inherits(ReactTooltip, _React$Component);
    function ReactTooltip(props) {
        var _this;
        $aafa81330f82e15b$var$_classCallCheck(this, ReactTooltip);
        _this = $aafa81330f82e15b$var$_possibleConstructorReturn(this, $aafa81330f82e15b$var$_getPrototypeOf(ReactTooltip).call(this, props));
        _this.state = {
            place: props.place || "top",
            // Direction of tooltip
            desiredPlace: props.place || "top",
            type: "dark",
            // Color theme of tooltip
            effect: "float",
            // float or fixed
            show: false,
            border: false,
            offset: {},
            extraClass: "",
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            // Current mouse event
            currentTarget: null,
            // Current target of mouse event
            ariaProps: $aafa81330f82e15b$var$parseAria(props),
            // aria- and role attributes
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || "",
            possibleCustomEventsOff: props.possibleCustomEventsOff || "",
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            "showTooltip",
            "updateTooltip",
            "hideTooltip",
            "hideTooltipOnScroll",
            "getTooltipContent",
            "globalRebuild",
            "globalShow",
            "globalHide",
            "onWindowResize",
            "mouseOnToolTip"
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ $aafa81330f82e15b$var$_createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props, insecure = _this$props.insecure, resizeHide = _this$props.resizeHide;
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener();
                this.unbindWindowEvents();
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(":hover");
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray;
                if (!id) targetArray = document.querySelectorAll("[data-tip]:not([data-for])");
                else {
                    var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                    targetArray = document.querySelectorAll("[data-tip][data-for=\"".concat(escaped, "\"]"));
                } // targetArray is a NodeList, convert it to a real array
                return $aafa81330f82e15b$var$nodeListToArray(targetArray);
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    if (target.getAttribute("currentItem") === null) target.setAttribute("currentItem", "false");
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) _this3.customUnbindListener(target);
                });
                if (this.isBodyMode()) this.bindBodyListener(targetArray);
                else targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
                    if (effect === "float") target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
                    target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
                });
                 // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                } // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) this.unbindBodyListener();
                else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function(target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
                target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
                target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children; // Generate tooltip content
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return $aafa81330f82e15b$var$getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === "string" && placeholder === "" || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                } // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute("data-tip");
                var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute("data-scroll-hide")) scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                 // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
                var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
                var result = $aafa81330f82e15b$var$getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
                var self = this;
                var updateState = function updateState() {
                    self.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute("data-type") || self.props.type || "dark",
                        effect: effect,
                        offset: offset,
                        html: target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self.props.html || false,
                        delayShow: target.getAttribute("data-delay-show") || self.props.delayShow || 0,
                        delayHide: target.getAttribute("data-delay-hide") || self.props.delayHide || 0,
                        delayUpdate: target.getAttribute("data-delay-update") || self.props.delayUpdate || 0,
                        border: target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self.props.border || false,
                        extraClass: target.getAttribute("data-class") || self.props["class"] || self.props.className || "",
                        disable: target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self.props.disable || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) self.addScrollListener(self.state.currentTarget);
                        self.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) self.intervalUpdateContent = setInterval(function() {
                            if (self.mount) {
                                var _getContent = self.props.getContent;
                                var placeholder = $aafa81330f82e15b$var$getTipContent(originTooltip, "", _getContent[0](), isMultiline);
                                var isEmptyTip = self.isEmptyTip(placeholder);
                                self.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                self.updatePosition();
                            }
                        }, getContent[1]);
                    });
                }; // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var afterShow = this.props.afterShow;
                var placeholder = this.getTooltipContent();
                var delayTime = parseInt(delayShow, 10);
                var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition();
                            if (isInvisible && afterShow) afterShow(e);
                        });
                    }
                };
                clearTimeout(this.delayShowLoop);
                if (delayShow) this.delayShowLoop = setTimeout(updateState, delayTime);
                else updateState();
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var afterHide = this.props.afterHide;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                }
                var resetState = function resetState() {
                    var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener();
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener() {
                window.removeEventListener("scroll", this.hideTooltipOnScroll);
            } // Calculation the position
        },
        {
            key: "updatePosition",
            value: function updatePosition() {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = $aafa81330f82e15b$var$getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition();
                });
                 // Set tooltip position
                node.style.left = result.position.left + "px";
                node.style.top = result.position.top + "px";
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                clearTimeout(this.delayShowLoop);
                clearTimeout(this.delayHideLoop);
                clearTimeout(this.delayReshow);
                clearInterval(this.intervalUpdateContent);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this8 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable;
                var placeholder = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(placeholder);
                var tooltipClass = "__react_component_tooltip" + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " border" : "") + " place-".concat(this.state.place) + // top, bottom, left, right
                " type-".concat(this.state.type) + (this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(" ");
                if (html) return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Wrapper, $aafa81330f82e15b$var$_extends({
                    className: wrapperClassName,
                    id: this.props.id,
                    ref: function ref(_ref) {
                        return _this8.tooltipRef = _ref;
                    }
                }, ariaProps, {
                    "data-id": "tooltip",
                    dangerouslySetInnerHTML: {
                        __html: placeholder
                    }
                }));
                else return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Wrapper, $aafa81330f82e15b$var$_extends({
                    className: wrapperClassName,
                    id: this.props.id
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this8.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), placeholder);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = $aafa81330f82e15b$var$parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return $aafa81330f82e15b$var$_objectSpread2({}, prevState, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component), $aafa81330f82e15b$var$_defineProperty($aafa81330f82e15b$var$_class2, "propTypes", {
    children: $aafa81330f82e15b$var$propTypes.any,
    place: $aafa81330f82e15b$var$propTypes.string,
    type: $aafa81330f82e15b$var$propTypes.string,
    effect: $aafa81330f82e15b$var$propTypes.string,
    offset: $aafa81330f82e15b$var$propTypes.object,
    multiline: $aafa81330f82e15b$var$propTypes.bool,
    border: $aafa81330f82e15b$var$propTypes.bool,
    insecure: $aafa81330f82e15b$var$propTypes.bool,
    "class": $aafa81330f82e15b$var$propTypes.string,
    className: $aafa81330f82e15b$var$propTypes.string,
    id: $aafa81330f82e15b$var$propTypes.string,
    html: $aafa81330f82e15b$var$propTypes.bool,
    delayHide: $aafa81330f82e15b$var$propTypes.number,
    delayUpdate: $aafa81330f82e15b$var$propTypes.number,
    delayShow: $aafa81330f82e15b$var$propTypes.number,
    event: $aafa81330f82e15b$var$propTypes.string,
    eventOff: $aafa81330f82e15b$var$propTypes.string,
    watchWindow: $aafa81330f82e15b$var$propTypes.bool,
    isCapture: $aafa81330f82e15b$var$propTypes.bool,
    globalEventOff: $aafa81330f82e15b$var$propTypes.string,
    getContent: $aafa81330f82e15b$var$propTypes.any,
    afterShow: $aafa81330f82e15b$var$propTypes.func,
    afterHide: $aafa81330f82e15b$var$propTypes.func,
    overridePosition: $aafa81330f82e15b$var$propTypes.func,
    disable: $aafa81330f82e15b$var$propTypes.bool,
    scrollHide: $aafa81330f82e15b$var$propTypes.bool,
    resizeHide: $aafa81330f82e15b$var$propTypes.bool,
    wrapper: $aafa81330f82e15b$var$propTypes.string,
    bodyMode: $aafa81330f82e15b$var$propTypes.bool,
    possibleCustomEvents: $aafa81330f82e15b$var$propTypes.string,
    possibleCustomEventsOff: $aafa81330f82e15b$var$propTypes.string,
    clickable: $aafa81330f82e15b$var$propTypes.bool
}), $aafa81330f82e15b$var$_defineProperty($aafa81330f82e15b$var$_class2, "defaultProps", {
    insecure: true,
    resizeHide: true,
    wrapper: "div",
    clickable: false
}), $aafa81330f82e15b$var$_defineProperty($aafa81330f82e15b$var$_class2, "supportedWrappers", [
    "div",
    "span"
]), $aafa81330f82e15b$var$_defineProperty($aafa81330f82e15b$var$_class2, "displayName", "ReactTooltip"), $aafa81330f82e15b$var$_temp)) || $aafa81330f82e15b$var$_class) || $aafa81330f82e15b$var$_class) || $aafa81330f82e15b$var$_class) || $aafa81330f82e15b$var$_class) || $aafa81330f82e15b$var$_class) || $aafa81330f82e15b$var$_class) || $aafa81330f82e15b$var$_class;
var $aafa81330f82e15b$export$2e2bcd8739ae039 = $aafa81330f82e15b$var$ReactTooltip;








const $1e24013d9d4f1dd7$var$getStateFromProps = (nextProps, prevState)=>{
    const { opening: opening } = nextProps;
    const { loadedText: loadedText } = prevState;
    const receiveText = opening && opening.texts.text26 || (0, $b62a9abcf18d7d2c$exports.DefaultOpening)[26];
    if (receiveText !== loadedText) return {
        logoText: receiveText,
        loadedText: receiveText
    };
    return null;
};
class $1e24013d9d4f1dd7$var$LogoInputComponent extends (0, $bh6RR.Component) {
    static propTypes = {
        opening: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
    };
    constructor(props){
        super(props);
        const { inputRef: inputRef, opening: opening } = props;
        this.inputRef = inputRef;
        this.ref = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createRef();
        const loadedText = opening ? opening.texts.text26 : (0, $b62a9abcf18d7d2c$exports.DefaultOpening)[26];
        this.state = {
            hoverOn: false,
            focusOn: false,
            loadedText: loadedText,
            logoText: loadedText
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        return $1e24013d9d4f1dd7$var$getStateFromProps(nextProps, prevState);
    }
    _onLogoTextChange = (event)=>{
        const { value: value } = event.target;
        this.setState({
            logoText: value
        });
    };
    _onFocusInput = ()=>{
        this.setState({
            focusOn: true
        });
    };
    _onBlurInput = ()=>{
        this.setState({
            focusOn: false
        });
    };
    _onMouseEnterInput = ()=>{
        this.setState({
            hoverOn: true
        });
    };
    _onMouseLeaveInput = ()=>{
        this.setState({
            hoverOn: false
        });
    };
    _onClickPreview = ()=>{
        this.inputRef.current.focus();
    };
    render() {
        const maxPreviewWidth = 500;
        const windowWidth = window.innerWidth - 20;
        const maxWidth = windowWidth > maxPreviewWidth ? maxPreviewWidth : windowWidth;
        const baseConfig = {
            width: 1448,
            fontSize: 37
        };
        const ratio = maxWidth / baseConfig.width;
        const logoStyleConfiguration = {
            minWidth: baseConfig.width * ratio,
            fontSize: baseConfig.fontSize * ratio
        };
        const { inputRef: inputRef } = this.props;
        const { logoText: logoText, hoverOn: hoverOn, focusOn: focusOn } = this.state;
        const id = `input-text${(0, $d39cc430308b5205$export$fbb44a8f9a47c90f)}`;
        const classNames = `${hoverOn ? 'hover' : ''} ${focusOn ? 'focus' : ''}`;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "form-inputs logo-form",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("textarea", {
                        ref: inputRef,
                        name: id,
                        id: id,
                        rows: 2,
                        spellCheck: false,
                        maxLength: (0, $d39cc430308b5205$export$30f705544d29b60e),
                        defaultValue: logoText,
                        onChange: this._onLogoTextChange,
                        onFocus: this._onFocusInput,
                        onBlur: this._onBlurInput,
                        onMouseEnter: this._onMouseEnterInput,
                        onMouseLeave: this._onMouseLeaveInput,
                        className: classNames,
                        "data-tip": "Try also uppercase letters, it will show bigger in the logo.",
                        "data-for": "input-logo",
                        "data-event": "focus",
                        "data-event-off": "blur"
                    }, id)
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "right-arrow",
                    children: "\u2192"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    role: "textbox",
                    style: logoStyleConfiguration,
                    className: `logo-preview-text ${classNames}`,
                    onFocus: this._onFocusInput,
                    onBlur: this._onBlurInput,
                    onMouseEnter: this._onMouseEnterInput,
                    onMouseLeave: this._onMouseLeaveInput,
                    onClick: this._onClickPreview,
                    onKeyPress: this._onClickPreview,
                    "data-tip": "This is a preview of how the logo will be placed in the video",
                    "data-for": "preview-logo",
                    children: (0, $f9ab4a733f3d6263$export$d13a1218bd1d6c6f)(this.state.logoText)
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $aafa81330f82e15b$export$2e2bcd8739ae039), {
                    id: "input-logo",
                    effect: "solid",
                    delayHide: 250,
                    className: "logo-preview-tooltip"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $aafa81330f82e15b$export$2e2bcd8739ae039), {
                    id: "preview-logo",
                    effect: "solid",
                    delayHide: 250,
                    className: "logo-preview-tooltip"
                })
            ]
        });
    }
}
const $1e24013d9d4f1dd7$var$mapContextToProps = (context)=>({
        opening: context.opening
    });
var $1e24013d9d4f1dd7$export$2e2bcd8739ae039 = (0, $df938650094f2b43$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($17bc0d4f42435b88$exports)))((0, $87127865826734e4$export$2e2bcd8739ae039), $1e24013d9d4f1dd7$var$mapContextToProps)($1e24013d9d4f1dd7$var$LogoInputComponent));



const $43232b96e1795519$var$FIRST_PART = 0;
const $43232b96e1795519$var$SECOND_PART = 1;
const $43232b96e1795519$var$getStateFromProps = (props)=>{
    const { opening: opening } = props;
    if (opening) return {
        opening: opening
    };
    const defaultOpening = {
        texts: (0, $b62a9abcf18d7d2c$exports.DefaultOpening)
    };
    const defaultOpeningEncoded = (0, $999f1b9a09e79f0c$export$2e2bcd8739ae039)(defaultOpening);
    return {
        opening: defaultOpeningEncoded
    };
};
class $43232b96e1795519$var$OpeningForm extends (0, $bh6RR.Component) {
    static propTypes = {
        opening: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        openingKey: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        playNewOpening: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        history: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        showDownloadButton: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool
    };
    constructor(props){
        super(props);
        this.inputsRefs = {};
        this.logoInputRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createRef();
        this.inputsRefs[0, $d39cc430308b5205$export$fbb44a8f9a47c90f] = this.logoInputRef;
        this.state = $43232b96e1795519$var$getStateFromProps(props);
    }
    static getDerivedStateFromProps(nextProps) {
        return $43232b96e1795519$var$getStateFromProps(nextProps);
    }
    componentDidUpdate(prevProps) {
        const openingKeyChanged = prevProps.openingKey !== this.props.openingKey;
        const { opening: opening } = this.state;
        if (openingKeyChanged) {
            const keys = Object.keys(this.inputsRefs);
            keys.forEach((key)=>{
                this.inputsRefs[key].current.value = opening.texts[`text${key}`];
            });
        }
    }
    _goToDownloadPage = ()=>{
        const { openingKey: openingKey, history: history } = this.props;
        history.push(`/${openingKey}/download`);
    };
    _download = async ()=>{
        const { openingKey: openingKey, playNewOpening: playNewOpening, history: history } = this.props;
        const { opening: openingBefore } = this.state;
        const formValues = this._getFormValues();
        const openingFromForm = {
            texts: formValues
        };
        const openingNow = (0, $999f1b9a09e79f0c$export$2e2bcd8739ae039)(openingFromForm);
        const isOpeningEqual = (0, (/*@__PURE__*/$parcel$interopDefault($1DYgm)))(openingBefore, openingNow);
        if (isOpeningEqual) {
            this._goToDownloadPage();
            return;
        }
        const alertResult = await (0, $b4af53e1575c5f4a$export$2e2bcd8739ae039)({
            titleText: 'TEXT WAS MODIFIED',
            showCancelButton: true,
            cancelButtonText: 'PLAY IT',
            cancelButtonAriaLabel: 'PLAY IT',
            confirmButtonText: 'RESTORE MY INTRO',
            confirmButtonAriaLabel: 'RESTORE MY INTRO',
            allowOutsideClick: false,
            text: 'You have changed some of the text fields. You need to play the new intro to save and request a download. Do you want to restore your intro text or play the new one?'
        });
        if (alertResult.value) {
            // refresh page form
            history.push('/');
            history.push(`/${openingKey}/edit`);
            return;
        }
        if (this._isValidOpening(openingFromForm)) playNewOpening(openingNow, history);
    };
    _isValidOpening = (opening)=>{
        const { texts: texts } = opening;
        const isAllTextsValid = texts.every((text, index)=>{
            const maxLength = (0, $d39cc430308b5205$export$fbb44a8f9a47c90f) === index ? (0, $d39cc430308b5205$export$30f705544d29b60e) : (0, $d39cc430308b5205$export$dc31da6a5e0e9565);
            return text.length <= maxLength;
        });
        if (!isAllTextsValid) {
            (0, $b4af53e1575c5f4a$export$2e2bcd8739ae039)('OOPS...', `All text fields should be less than ${(0, $d39cc430308b5205$export$dc31da6a5e0e9565)} characters and the logo should be less than ${(0, $d39cc430308b5205$export$30f705544d29b60e)}. ;)`, 'warning');
            return false;
        }
        const logoIsEmpty = 0 === texts[0, $d39cc430308b5205$export$fbb44a8f9a47c90f].trim().length;
        if (logoIsEmpty) {
            (0, $b4af53e1575c5f4a$export$2e2bcd8739ae039)('OOPS...', 'The logo text can\'t be empty.', 'warning');
            return false;
        }
        return true;
    };
    _textAreaInput = (id, value, ref, first)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("textarea", {
            ref: ref,
            name: id,
            id: id,
            rows: 2,
            spellCheck: false,
            maxLength: (0, $d39cc430308b5205$export$dc31da6a5e0e9565),
            defaultValue: value,
            autoFocus: first
        }, id);
    _renderInputs(part) {
        const inputsCount = (0, $b62a9abcf18d7d2c$exports.DefaultOpening).length;
        const inputs = [];
        const { texts: texts } = this.state.opening;
        const isSecondPart = part === $43232b96e1795519$var$SECOND_PART;
        const count = isSecondPart ? inputsCount : (0, $d39cc430308b5205$export$fbb44a8f9a47c90f);
        const start = isSecondPart ? (0, $d39cc430308b5205$export$fbb44a8f9a47c90f) + 1 : 0;
        for(let i = start; i < count; i += 1){
            const ref = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createRef();
            const id = `input-text${i}`;
            const first = 0 === i;
            const input = this._textAreaInput(id, texts[`text${i}`], ref, first);
            this.inputsRefs[i] = ref;
            inputs.push(input);
        }
        return inputs;
    }
    _getFormValues() {
        const keys = Object.keys(this.inputsRefs);
        const values = keys.map((key)=>this.inputsRefs[key].current.value);
        return values;
    }
    _handleSubmit = (e)=>{
        e.preventDefault();
        const values = this._getFormValues();
        const { playNewOpening: playNewOpening, history: history } = this.props;
        const opening = {
            texts: values
        };
        if (this._isValidOpening(opening)) {
            const encodedOpening = (0, $999f1b9a09e79f0c$export$2e2bcd8739ae039)(opening);
            playNewOpening(encodedOpening, history);
        }
    };
    render() {
        const { showDownloadButton: showDownloadButton } = this.props;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            id: "opening-form",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "info-box",
                    children: "Fill the inputs below, the order is left to right, top to bottom"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
                    onSubmit: this._handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "form-inputs",
                            children: this._renderInputs($43232b96e1795519$var$FIRST_PART)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e24013d9d4f1dd7$export$2e2bcd8739ae039), {
                            inputRef: this.logoInputRef
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "form-inputs",
                            children: this._renderInputs($43232b96e1795519$var$SECOND_PART)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "buttons",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    type: "submit",
                                    className: "button big",
                                    children: "Play"
                                }),
                                showDownloadButton && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    type: "button",
                                    onClick: this._download,
                                    className: "button big",
                                    children: "Download"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
const $43232b96e1795519$var$mapContextToProps = (context)=>({
        opening: context.opening,
        openingKey: context.key,
        playNewOpening: context.playNewOpening
    });
var $43232b96e1795519$export$2e2bcd8739ae039 = (0, $df938650094f2b43$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($17bc0d4f42435b88$exports)))((0, $87127865826734e4$export$2e2bcd8739ae039), $43232b96e1795519$var$mapContextToProps)($43232b96e1795519$var$OpeningForm));



class $5d616493c369fdfb$var$CreatePage extends (0, $bh6RR.Component) {
    static propTypes = {
        clearOpening: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func
    };
    componentWillMount() {
        this.props.clearOpening();
    }
    render() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $26778b50e82826b4$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $43232b96e1795519$export$2e2bcd8739ae039), {})
        });
    }
}
const $5d616493c369fdfb$var$mapOpeningProviderToProps = (context)=>({
        clearOpening: context.clearOpening
    });
const $5d616493c369fdfb$var$connectOpeningProvider = (0, (/*@__PURE__*/$parcel$interopDefault($17bc0d4f42435b88$exports)))((0, $87127865826734e4$export$2e2bcd8739ae039), $5d616493c369fdfb$var$mapOpeningProviderToProps);
var $5d616493c369fdfb$export$2e2bcd8739ae039 = $5d616493c369fdfb$var$connectOpeningProvider($5d616493c369fdfb$var$CreatePage);




var $bh6RR = parcelRequire("bh6RR");







class $4637d107a48f1ec8$var$EditPage extends (0, $bh6RR.Component) {
    static propTypes = {
        match: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        loadOpening: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        opening: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        openingKey: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        history: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
    };
    state = {
        isLoading: true
    };
    static getDerivedStateFromProps(nextProps, prevState) {
        const hasOpeningKeyChanged = nextProps.match.params.openingKey !== nextProps.openingKey;
        if (hasOpeningKeyChanged) return {
            isLoading: true
        };
        if (!hasOpeningKeyChanged && prevState.isLoading) return {
            isLoading: false
        };
        return null;
    }
    componentDidMount = async ()=>{
        const { match: match, history: history, loadOpening: loadOpening, opening: opening, openingKey: openingKey } = this.props;
        const hasOpeningKeyChanged = match.params.openingKey !== openingKey;
        if (!opening || hasOpeningKeyChanged) await loadOpening(match.params.openingKey, history);
    };
    componentDidUpdate = async (prevProps)=>{
        const { loadOpening: loadOpening, history: history } = this.props;
        const { openingKey: openingKey } = this.props.match.params;
        const prevOpeningKey = prevProps.match.params.openingKey;
        const openingKeyChanged = prevOpeningKey !== openingKey;
        if (openingKeyChanged) await loadOpening(openingKey, history);
    };
    render() {
        const { opening: opening } = this.props;
        const { isLoading: isLoading } = this.state;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $26778b50e82826b4$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $717f6f9cd6378efa$export$2e2bcd8739ae039), {
                    isLoading: isLoading
                }),
                opening && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $43232b96e1795519$export$2e2bcd8739ae039), {
                    showDownloadButton: true
                })
            ]
        });
    }
}
const $4637d107a48f1ec8$var$mapOpeningProviderToProps = (context)=>({
        loadOpening: context.loadOpening,
        opening: context.opening,
        openingKey: context.key
    });
const $4637d107a48f1ec8$var$connectOpeningProvider = (0, (/*@__PURE__*/$parcel$interopDefault($17bc0d4f42435b88$exports)))((0, $87127865826734e4$export$2e2bcd8739ae039), $4637d107a48f1ec8$var$mapOpeningProviderToProps);
var $4637d107a48f1ec8$export$2e2bcd8739ae039 = (0, $df938650094f2b43$export$2e2bcd8739ae039)($4637d107a48f1ec8$var$connectOpeningProvider($4637d107a48f1ec8$var$EditPage));




var $bh6RR = parcelRequire("bh6RR");



parcelRequire("bh6RR");
const $6970ed5340caef3d$var$Loader = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "loader"
    });
var $6970ed5340caef3d$export$2e2bcd8739ae039 = $6970ed5340caef3d$var$Loader;




const $f056960f2e07845b$var$app = 'game-of-thrones';
const $f056960f2e07845b$var$http = (0, $fe3196be52085d52$export$2e2bcd8739ae039)(`${(0, $d39cc430308b5205$export$b6aaa66cc55c3181)}/api`);
const $f056960f2e07845b$var$State = {
    status: null,
    email: null
};
const $f056960f2e07845b$var$_saveStatusFromResponse = (response)=>{
    const status = response.data;
    $f056960f2e07845b$var$State.status = status;
    return status;
};
const $f056960f2e07845b$var$_getRequestStatus = (code)=>$f056960f2e07845b$var$http.get(`/status/${$f056960f2e07845b$var$app}/${code}`);
const $f056960f2e07845b$var$_postDownloadRequest = (code, emails)=>$f056960f2e07845b$var$http.post('/request', {
        code: code,
        emails: emails,
        app: $f056960f2e07845b$var$app
    });
const $f056960f2e07845b$export$ffae4f72cb988e44 = async (code)=>$f056960f2e07845b$var$_saveStatusFromResponse(await $f056960f2e07845b$var$_getRequestStatus(code));
const $f056960f2e07845b$export$c2863f81b29a10db = async (code, email)=>{
    $f056960f2e07845b$var$State.email = email;
    return $f056960f2e07845b$var$_saveStatusFromResponse(await $f056960f2e07845b$var$_postDownloadRequest(code, email));
};
const $f056960f2e07845b$export$cb008828d1e2d0ca = (code)=>{
    if ($f056960f2e07845b$var$State.status) return $f056960f2e07845b$var$State.status;
    return $f056960f2e07845b$export$ffae4f72cb988e44(code);
};
const $f056960f2e07845b$export$546c1da6d53fd8de = ()=>$f056960f2e07845b$var$State.email;




var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");



const $8c601f58b7d640bb$var$DonateOrNotDonate = ({ match: match, hideNoDonateOption: hideNoDonateOption = false })=>{
    const { params: params } = match;
    const { openingKey: openingKey } = params;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "bold",
                    children: "Do you want to receive your video faster by paying or wait in the queue?"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "buttons",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $1e45e86148133c84$export$2e2bcd8739ae039), {
                        to: `/${openingKey}/download/pay`,
                        className: "button medium",
                        children: [
                            "Yes, I",
                            '\'',
                            "ll skip the queue!"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    !hideNoDonateOption && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $1e45e86148133c84$export$2e2bcd8739ae039), {
                        to: `/${openingKey}/download/request`,
                        className: "button small increase-padding",
                        children: [
                            "No, I",
                            '\'',
                            "ll get in the queue!"
                        ]
                    })
                ]
            })
        ]
    });
};
$8c601f58b7d640bb$var$DonateOrNotDonate.propTypes = {
    match: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
    hideNoDonateOption: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool
};
var $8c601f58b7d640bb$export$2e2bcd8739ae039 = (0, $df938650094f2b43$export$2e2bcd8739ae039)($8c601f58b7d640bb$var$DonateOrNotDonate);


var $49dedb61fc713737$exports = {};
// HumanizeDuration.js - https://git.io/j0HgmQ
/**
 * @typedef {string | ((unitCount: number) => string)} Unit
 */ /**
 * @typedef {"y" | "mo" | "w" | "d" | "h" | "m" | "s" | "ms"} UnitName
 */ /**
 * @typedef {Object} UnitMeasures
 * @prop {number} y
 * @prop {number} mo
 * @prop {number} w
 * @prop {number} d
 * @prop {number} h
 * @prop {number} m
 * @prop {number} s
 * @prop {number} ms
 */ /**
 * @internal
 * @typedef {[string, string, string, string, string, string, string, string, string, string]} DigitReplacements
 */ /**
 * @typedef {Object} Language
 * @prop {Unit} y
 * @prop {Unit} mo
 * @prop {Unit} w
 * @prop {Unit} d
 * @prop {Unit} h
 * @prop {Unit} m
 * @prop {Unit} s
 * @prop {Unit} ms
 * @prop {string} [decimal]
 * @prop {string} [delimiter]
 * @prop {DigitReplacements} [_digitReplacements]
 * @prop {boolean} [_numberFirst]
 * @prop {boolean} [_hideCountIf2]
 */ /**
 * @typedef {Object} Options
 * @prop {string} [language]
 * @prop {Record<string, Language>} [languages]
 * @prop {string[]} [fallbacks]
 * @prop {string} [delimiter]
 * @prop {string} [spacer]
 * @prop {boolean} [round]
 * @prop {number} [largest]
 * @prop {UnitName[]} [units]
 * @prop {string} [decimal]
 * @prop {string} [conjunction]
 * @prop {number} [maxDecimalPoints]
 * @prop {UnitMeasures} [unitMeasures]
 * @prop {boolean} [serialComma]
 * @prop {DigitReplacements} [digitReplacements]
 */ /**
 * @internal
 * @typedef {Required<Options>} NormalizedOptions
 */ (function() {
    // Fallback for `Object.assign` if relevant.
    var assign = Object.assign || /** @param {...any} destination */ function(destination) {
        var source;
        for(var i = 1; i < arguments.length; i++){
            source = arguments[i];
            for(var prop in source)if (has(source, prop)) destination[prop] = source[prop];
        }
        return destination;
    };
    // Fallback for `Array.isArray` if relevant.
    var isArray = Array.isArray || function(arg) {
        return Object.prototype.toString.call(arg) === "[object Array]";
    };
    // This has to be defined separately because of a bug: we want to alias
    // `gr` and `el` for backwards-compatiblity. In a breaking change, we can
    // remove `gr` entirely.
    // See https://github.com/EvanHahn/HumanizeDuration.js/issues/143 for more.
    var GREEK = onesLanguage([
        "\u03C7\u03C1\u03CC\u03BD\u03BF\u03C2",
        "\u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    ], [
        "\u03BC\u03AE\u03BD\u03B1\u03C2",
        "\u03BC\u03AE\u03BD\u03B5\u03C2"
    ], [
        "\u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        "\u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    ], [
        "\u03BC\u03AD\u03C1\u03B1",
        "\u03BC\u03AD\u03C1\u03B5\u03C2"
    ], [
        "\u03CE\u03C1\u03B1",
        "\u03CE\u03C1\u03B5\u03C2"
    ], [
        "\u03BB\u03B5\u03C0\u03C4\u03CC",
        "\u03BB\u03B5\u03C0\u03C4\u03AC"
    ], [
        "\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        "\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    ], [
        "\u03C7\u03B9\u03BB\u03B9\u03BF\u03C3\u03C4\u03CC \u03C4\u03BF\u03C5 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03BF\u03BB\u03AD\u03C0\u03C4\u03BF\u03C5",
        "\u03C7\u03B9\u03BB\u03B9\u03BF\u03C3\u03C4\u03AC \u03C4\u03BF\u03C5 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03BF\u03BB\u03AD\u03C0\u03C4\u03BF\u03C5"
    ], ",");
    /**
   * @internal
   * @type {Record<string, Language>}
   */ var LANGUAGES = {
        af: onesLanguage([
            "jaar",
            "jaar"
        ], [
            "maand",
            "maande"
        ], [
            "week",
            "weke"
        ], [
            "dag",
            "dae"
        ], [
            "uur",
            "ure"
        ], [
            "minuut",
            "minute"
        ], [
            "sekonde",
            "sekondes"
        ], [
            "millisekonde",
            "millisekondes"
        ], ","),
        am: language("\u12D3\u1218\u1275", "\u12C8\u122D", "\u1233\u121D\u1295\u1275", "\u1240\u1295", "\u1230\u12D3\u1275", "\u12F0\u1242\u1243", "\u1230\u12A8\u1295\u12F5", "\u121A\u120A\u1230\u12A8\u1295\u12F5"),
        ar: assign(language(function(c) {
            return [
                "\u0633\u0646\u0629",
                "\u0633\u0646\u062A\u0627\u0646",
                "\u0633\u0646\u0648\u0627\u062A"
            ][getArabicForm(c)];
        }, function(c) {
            return [
                "\u0634\u0647\u0631",
                "\u0634\u0647\u0631\u0627\u0646",
                "\u0623\u0634\u0647\u0631"
            ][getArabicForm(c)];
        }, function(c) {
            return [
                "\u0623\u0633\u0628\u0648\u0639",
                "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
                "\u0623\u0633\u0627\u0628\u064A\u0639"
            ][getArabicForm(c)];
        }, function(c) {
            return [
                "\u064A\u0648\u0645",
                "\u064A\u0648\u0645\u064A\u0646",
                "\u0623\u064A\u0627\u0645"
            ][getArabicForm(c)];
        }, function(c) {
            return [
                "\u0633\u0627\u0639\u0629",
                "\u0633\u0627\u0639\u062A\u064A\u0646",
                "\u0633\u0627\u0639\u0627\u062A"
            ][getArabicForm(c)];
        }, function(c) {
            return [
                "\u062F\u0642\u064A\u0642\u0629",
                "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
                "\u062F\u0642\u0627\u0626\u0642"
            ][getArabicForm(c)];
        }, function(c) {
            return [
                "\u062B\u0627\u0646\u064A\u0629",
                "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
                "\u062B\u0648\u0627\u0646\u064A"
            ][getArabicForm(c)];
        }, function(c) {
            return [
                "\u062C\u0632\u0621 \u0645\u0646 \u0627\u0644\u062B\u0627\u0646\u064A\u0629",
                "\u062C\u0632\u0622\u0646 \u0645\u0646 \u0627\u0644\u062B\u0627\u0646\u064A\u0629",
                "\u0623\u062C\u0632\u0627\u0621 \u0645\u0646 \u0627\u0644\u062B\u0627\u0646\u064A\u0629"
            ][getArabicForm(c)];
        }, ","), {
            delimiter: " \uFEED ",
            _hideCountIf2: true,
            _digitReplacements: [
                "\u06F0",
                "\u0661",
                "\u0662",
                "\u0663",
                "\u0664",
                "\u0665",
                "\u0666",
                "\u0667",
                "\u0668",
                "\u0669"
            ]
        }),
        bg: slavicLanguage([
            "\u0433\u043E\u0434\u0438\u043D\u0438",
            "\u0433\u043E\u0434\u0438\u043D\u0430",
            "\u0433\u043E\u0434\u0438\u043D\u0438"
        ], [
            "\u043C\u0435\u0441\u0435\u0446\u0430",
            "\u043C\u0435\u0441\u0435\u0446",
            "\u043C\u0435\u0441\u0435\u0446\u0430"
        ], [
            "\u0441\u0435\u0434\u043C\u0438\u0446\u0438",
            "\u0441\u0435\u0434\u043C\u0438\u0446\u0430",
            "\u0441\u0435\u0434\u043C\u0438\u0446\u0438"
        ], [
            "\u0434\u043D\u0438",
            "\u0434\u0435\u043D",
            "\u0434\u043D\u0438"
        ], [
            "\u0447\u0430\u0441\u0430",
            "\u0447\u0430\u0441",
            "\u0447\u0430\u0441\u0430"
        ], [
            "\u043C\u0438\u043D\u0443\u0442\u0438",
            "\u043C\u0438\u043D\u0443\u0442\u0430",
            "\u043C\u0438\u043D\u0443\u0442\u0438"
        ], [
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        ], [
            "\u043C\u0438\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            "\u043C\u0438\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u043C\u0438\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        ]),
        bn: language("\u09AC\u099B\u09B0", "\u09AE\u09BE\u09B8", "\u09B8\u09AA\u09CD\u09A4\u09BE\u09B9", "\u09A6\u09BF\u09A8", "\u0998\u09A8\u09CD\u099F\u09BE", "\u09AE\u09BF\u09A8\u09BF\u099F", "\u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1", "\u09AE\u09BF\u09B2\u09BF\u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"),
        ca: onesLanguage([
            "any",
            "anys"
        ], [
            "mes",
            "mesos"
        ], [
            "setmana",
            "setmanes"
        ], [
            "dia",
            "dies"
        ], [
            "hora",
            "hores"
        ], [
            "minut",
            "minuts"
        ], [
            "segon",
            "segons"
        ], [
            "milisegon",
            "milisegons"
        ], ","),
        ckb: language("\u0633\u0627\u06B5", "\u0645\u0627\u0646\u06AF", "\u0647\u06D5\u0641\u062A\u06D5", "\u0695\u06C6\u0698", "\u06A9\u0627\u0698\u06CE\u0631", "\u062E\u0648\u0644\u06D5\u06A9", "\u0686\u0631\u06A9\u06D5", "\u0645\u06CC\u0644\u06CC \u0686\u0631\u06A9\u06D5", "."),
        cs: language(function(c) {
            return [
                "rok",
                "roku",
                "roky",
                "let"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "m\u011Bs\xedc",
                "m\u011Bs\xedce",
                "m\u011Bs\xedce",
                "m\u011Bs\xedc\u016F"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "t\xfdden",
                "t\xfddne",
                "t\xfddny",
                "t\xfddn\u016F"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "den",
                "dne",
                "dny",
                "dn\xed"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "hodina",
                "hodiny",
                "hodiny",
                "hodin"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "minuta",
                "minuty",
                "minuty",
                "minut"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "sekunda",
                "sekundy",
                "sekundy",
                "sekund"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "milisekunda",
                "milisekundy",
                "milisekundy",
                "milisekund"
            ][getCzechOrSlovakForm(c)];
        }, ","),
        cy: language("flwyddyn", "mis", "wythnos", "diwrnod", "awr", "munud", "eiliad", "milieiliad"),
        da: onesLanguage([
            "\xe5r",
            "\xe5r"
        ], [
            "m\xe5ned",
            "m\xe5neder"
        ], [
            "uge",
            "uger"
        ], [
            "dag",
            "dage"
        ], [
            "time",
            "timer"
        ], [
            "minut",
            "minutter"
        ], [
            "sekund",
            "sekunder"
        ], [
            "millisekund",
            "millisekunder"
        ], ","),
        de: onesLanguage([
            "Jahr",
            "Jahre"
        ], [
            "Monat",
            "Monate"
        ], [
            "Woche",
            "Wochen"
        ], [
            "Tag",
            "Tage"
        ], [
            "Stunde",
            "Stunden"
        ], [
            "Minute",
            "Minuten"
        ], [
            "Sekunde",
            "Sekunden"
        ], [
            "Millisekunde",
            "Millisekunden"
        ], ","),
        el: GREEK,
        en: onesLanguage([
            "year",
            "years"
        ], [
            "month",
            "months"
        ], [
            "week",
            "weeks"
        ], [
            "day",
            "days"
        ], [
            "hour",
            "hours"
        ], [
            "minute",
            "minutes"
        ], [
            "second",
            "seconds"
        ], [
            "millisecond",
            "milliseconds"
        ]),
        eo: onesLanguage([
            "jaro",
            "jaroj"
        ], [
            "monato",
            "monatoj"
        ], [
            "semajno",
            "semajnoj"
        ], [
            "tago",
            "tagoj"
        ], [
            "horo",
            "horoj"
        ], [
            "minuto",
            "minutoj"
        ], [
            "sekundo",
            "sekundoj"
        ], [
            "milisekundo",
            "milisekundoj"
        ], ","),
        es: onesLanguage([
            "a\xf1o",
            "a\xf1os"
        ], [
            "mes",
            "meses"
        ], [
            "semana",
            "semanas"
        ], [
            "d\xeda",
            "d\xedas"
        ], [
            "hora",
            "horas"
        ], [
            "minuto",
            "minutos"
        ], [
            "segundo",
            "segundos"
        ], [
            "milisegundo",
            "milisegundos"
        ], ","),
        et: onesLanguage([
            "aasta",
            "aastat"
        ], [
            "kuu",
            "kuud"
        ], [
            "n\xe4dal",
            "n\xe4dalat"
        ], [
            "p\xe4ev",
            "p\xe4eva"
        ], [
            "tund",
            "tundi"
        ], [
            "minut",
            "minutit"
        ], [
            "sekund",
            "sekundit"
        ], [
            "millisekund",
            "millisekundit"
        ], ","),
        eu: language("urte", "hilabete", "aste", "egun", "ordu", "minutu", "segundo", "milisegundo", ","),
        fa: language("\u0633\u0627\u0644", "\u0645\u0627\u0647", "\u0647\u0641\u062A\u0647", "\u0631\u0648\u0632", "\u0633\u0627\u0639\u062A", "\u062F\u0642\u06CC\u0642\u0647", "\u062B\u0627\u0646\u06CC\u0647", "\u0645\u06CC\u0644\u06CC \u062B\u0627\u0646\u06CC\u0647"),
        fi: onesLanguage([
            "vuosi",
            "vuotta"
        ], [
            "kuukausi",
            "kuukautta"
        ], [
            "viikko",
            "viikkoa"
        ], [
            "p\xe4iv\xe4",
            "p\xe4iv\xe4\xe4"
        ], [
            "tunti",
            "tuntia"
        ], [
            "minuutti",
            "minuuttia"
        ], [
            "sekunti",
            "sekuntia"
        ], [
            "millisekunti",
            "millisekuntia"
        ], ","),
        fo: onesLanguage([
            "\xe1r",
            "\xe1r"
        ], [
            "m\xe1na\xf0ur",
            "m\xe1na\xf0ir"
        ], [
            "vika",
            "vikur"
        ], [
            "dagur",
            "dagar"
        ], [
            "t\xedmi",
            "t\xedmar"
        ], [
            "minuttur",
            "minuttir"
        ], [
            "sekund",
            "sekund"
        ], [
            "millisekund",
            "millisekund"
        ], ","),
        fr: language(function(c) {
            return "an" + (c >= 2 ? "s" : "");
        }, "mois", function(c) {
            return "semaine" + (c >= 2 ? "s" : "");
        }, function(c) {
            return "jour" + (c >= 2 ? "s" : "");
        }, function(c) {
            return "heure" + (c >= 2 ? "s" : "");
        }, function(c) {
            return "minute" + (c >= 2 ? "s" : "");
        }, function(c) {
            return "seconde" + (c >= 2 ? "s" : "");
        }, function(c) {
            return "milliseconde" + (c >= 2 ? "s" : "");
        }, ","),
        gr: GREEK,
        he: onesLanguage([
            "\u05E9\u05E0\u05D4",
            "\u05E9\u05E0\u05D9\u05DD"
        ], [
            "\u05D7\u05D5\u05D3\u05E9",
            "\u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
        ], [
            "\u05E9\u05D1\u05D5\u05E2",
            "\u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
        ], [
            "\u05D9\u05D5\u05DD",
            "\u05D9\u05DE\u05D9\u05DD"
        ], [
            "\u05E9\u05E2\u05D4",
            "\u05E9\u05E2\u05D5\u05EA"
        ], [
            "\u05D3\u05E7\u05D4",
            "\u05D3\u05E7\u05D5\u05EA"
        ], [
            "\u05E9\u05E0\u05D9\u05D4",
            "\u05E9\u05E0\u05D9\u05D5\u05EA"
        ], [
            "\u05DE\u05D9\u05DC\u05D9\u05E9\u05E0\u05D9\u05D9\u05D4",
            "\u05DE\u05D9\u05DC\u05D9\u05E9\u05E0\u05D9\u05D5\u05EA"
        ]),
        hr: language(function(c) {
            if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) return "godine";
            return "godina";
        }, function(c) {
            if (c === 1) return "mjesec";
            else if (c === 2 || c === 3 || c === 4) return "mjeseca";
            return "mjeseci";
        }, function(c) {
            if (c % 10 === 1 && c !== 11) return "tjedan";
            return "tjedna";
        }, onesUnit([
            "dan",
            "dana"
        ]), function(c) {
            if (c === 1) return "sat";
            else if (c === 2 || c === 3 || c === 4) return "sata";
            return "sati";
        }, function(c) {
            var mod10 = c % 10;
            if ((mod10 === 2 || mod10 === 3 || mod10 === 4) && (c < 10 || c > 14)) return "minute";
            return "minuta";
        }, function(c) {
            var mod10 = c % 10;
            if (mod10 === 5 || Math.floor(c) === c && c >= 10 && c <= 19) return "sekundi";
            else if (mod10 === 1) return "sekunda";
            else if (mod10 === 2 || mod10 === 3 || mod10 === 4) return "sekunde";
            return "sekundi";
        }, function(c) {
            if (c === 1) return "milisekunda";
            else if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) return "milisekunde";
            return "milisekundi";
        }, ","),
        hi: language("\u0938\u093E\u0932", onesUnit([
            "\u092E\u0939\u0940\u0928\u093E",
            "\u092E\u0939\u0940\u0928\u0947"
        ]), onesUnit([
            "\u0939\u095E\u094D\u0924\u093E",
            "\u0939\u092B\u094D\u0924\u0947"
        ]), "\u0926\u093F\u0928", onesUnit([
            "\u0918\u0902\u091F\u093E",
            "\u0918\u0902\u091F\u0947"
        ]), "\u092E\u093F\u0928\u091F", "\u0938\u0947\u0915\u0902\u0921", "\u092E\u093F\u0932\u0940\u0938\u0947\u0915\u0902\u0921"),
        hu: language("\xe9v", "h\xf3nap", "h\xe9t", "nap", "\xf3ra", "perc", "m\xe1sodperc", "ezredm\xe1sodperc", ","),
        id: language("tahun", "bulan", "minggu", "hari", "jam", "menit", "detik", "milidetik"),
        is: onesLanguage([
            "\xe1r",
            "\xe1r"
        ], [
            "m\xe1nu\xf0ur",
            "m\xe1nu\xf0ir"
        ], [
            "vika",
            "vikur"
        ], [
            "dagur",
            "dagar"
        ], [
            "klukkut\xedmi",
            "klukkut\xedmar"
        ], [
            "m\xedn\xfata",
            "m\xedn\xfatur"
        ], [
            "sek\xfanda",
            "sek\xfandur"
        ], [
            "millisek\xfanda",
            "millisek\xfandur"
        ]),
        it: onesLanguage([
            "anno",
            "anni"
        ], [
            "mese",
            "mesi"
        ], [
            "settimana",
            "settimane"
        ], [
            "giorno",
            "giorni"
        ], [
            "ora",
            "ore"
        ], [
            "minuto",
            "minuti"
        ], [
            "secondo",
            "secondi"
        ], [
            "millisecondo",
            "millisecondi"
        ], ","),
        ja: language("\u5E74", "\u30F6\u6708", "\u9031\u9593", "\u65E5", "\u6642\u9593", "\u5206", "\u79D2", "\u30DF\u30EA\u79D2"),
        km: language("\u1786\u17D2\u1793\u17B6\u17C6", "\u1781\u17C2", "\u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD", "\u1790\u17D2\u1784\u17C3", "\u1798\u17C9\u17C4\u1784", "\u1793\u17B6\u1791\u17B8", "\u179C\u17B7\u1793\u17B6\u1791\u17B8", "\u1798\u17B7\u179B\u17D2\u179B\u17B8\u179C\u17B7\u1793\u17B6\u1791\u17B8"),
        kn: onesLanguage([
            "\u0CB5\u0CB0\u0CCD\u0CB7",
            "\u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1"
        ], [
            "\u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            "\u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CC1"
        ], [
            "\u0CB5\u0CBE\u0CB0",
            "\u0CB5\u0CBE\u0CB0\u0C97\u0CB3\u0CC1"
        ], [
            "\u0CA6\u0CBF\u0CA8",
            "\u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1"
        ], [
            "\u0C97\u0C82\u0C9F\u0CC6",
            "\u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1"
        ], [
            "\u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            "\u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1"
        ], [
            "\u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            "\u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1"
        ], [
            "\u0CAE\u0CBF\u0CB2\u0CBF\u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            "\u0CAE\u0CBF\u0CB2\u0CBF\u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1"
        ]),
        ko: language("\uB144", "\uAC1C\uC6D4", "\uC8FC\uC77C", "\uC77C", "\uC2DC\uAC04", "\uBD84", "\uCD08", "\uBC00\uB9AC \uCD08"),
        ku: language("sal", "meh", "hefte", "roj", "seet", "deqe", "saniye", "m\xeel\xee\xe7irk", ","),
        lo: language("\u0E9B\u0EB5", "\u0EC0\u0E94\u0EB7\u0EAD\u0E99", "\u0EAD\u0EB2\u0E97\u0EB4\u0E94", "\u0EA1\u0EB7\u0EC9", "\u0E8A\u0EBB\u0EC8\u0EA7\u0EC2\u0EA1\u0E87", "\u0E99\u0EB2\u0E97\u0EB5", "\u0EA7\u0EB4\u0E99\u0EB2\u0E97\u0EB5", "\u0EA1\u0EB4\u0E99\u0EA5\u0EB4\u0EA7\u0EB4\u0E99\u0EB2\u0E97\u0EB5", ","),
        lt: language(function(c) {
            return c % 10 === 0 || c % 100 >= 10 && c % 100 <= 20 ? "met\u0173" : "metai";
        }, function(c) {
            return [
                "m\u0117nuo",
                "m\u0117nesiai",
                "m\u0117nesi\u0173"
            ][getLithuanianForm(c)];
        }, function(c) {
            return [
                "savait\u0117",
                "savait\u0117s",
                "savai\u010Di\u0173"
            ][getLithuanianForm(c)];
        }, function(c) {
            return [
                "diena",
                "dienos",
                "dien\u0173"
            ][getLithuanianForm(c)];
        }, function(c) {
            return [
                "valanda",
                "valandos",
                "valand\u0173"
            ][getLithuanianForm(c)];
        }, function(c) {
            return [
                "minut\u0117",
                "minut\u0117s",
                "minu\u010Di\u0173"
            ][getLithuanianForm(c)];
        }, function(c) {
            return [
                "sekund\u0117",
                "sekund\u0117s",
                "sekund\u017Ei\u0173"
            ][getLithuanianForm(c)];
        }, function(c) {
            return [
                "milisekund\u0117",
                "milisekund\u0117s",
                "milisekund\u017Ei\u0173"
            ][getLithuanianForm(c)];
        }, ","),
        lv: language(function(c) {
            return getLatvianForm(c) ? "gads" : "gadi";
        }, function(c) {
            return getLatvianForm(c) ? "m\u0113nesis" : "m\u0113ne\u0161i";
        }, function(c) {
            return getLatvianForm(c) ? "ned\u0113\u013Ca" : "ned\u0113\u013Cas";
        }, function(c) {
            return getLatvianForm(c) ? "diena" : "dienas";
        }, function(c) {
            return getLatvianForm(c) ? "stunda" : "stundas";
        }, function(c) {
            return getLatvianForm(c) ? "min\u016Bte" : "min\u016Btes";
        }, function(c) {
            return getLatvianForm(c) ? "sekunde" : "sekundes";
        }, function(c) {
            return getLatvianForm(c) ? "milisekunde" : "milisekundes";
        }, ","),
        mk: onesLanguage([
            "\u0433\u043E\u0434\u0438\u043D\u0430",
            "\u0433\u043E\u0434\u0438\u043D\u0438"
        ], [
            "\u043C\u0435\u0441\u0435\u0446",
            "\u043C\u0435\u0441\u0435\u0446\u0438"
        ], [
            "\u043D\u0435\u0434\u0435\u043B\u0430",
            "\u043D\u0435\u0434\u0435\u043B\u0438"
        ], [
            "\u0434\u0435\u043D",
            "\u0434\u0435\u043D\u0430"
        ], [
            "\u0447\u0430\u0441",
            "\u0447\u0430\u0441\u0430"
        ], [
            "\u043C\u0438\u043D\u0443\u0442\u0430",
            "\u043C\u0438\u043D\u0443\u0442\u0438"
        ], [
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        ], [
            "\u043C\u0438\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u043C\u0438\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        ], ","),
        mn: language("\u0436\u0438\u043B", "\u0441\u0430\u0440", "\u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433", "\u04E9\u0434\u04E9\u0440", "\u0446\u0430\u0433", "\u043C\u0438\u043D\u0443\u0442", "\u0441\u0435\u043A\u0443\u043D\u0434", "\u043C\u0438\u043B\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434"),
        mr: language(onesUnit([
            "\u0935\u0930\u094D\u0937",
            "\u0935\u0930\u094D\u0937\u0947"
        ]), onesUnit([
            "\u092E\u0939\u093F\u0928\u093E",
            "\u092E\u0939\u093F\u0928\u0947"
        ]), onesUnit([
            "\u0906\u0920\u0935\u0921\u093E",
            "\u0906\u0920\u0935\u0921\u0947"
        ]), "\u0926\u093F\u0935\u0938", "\u0924\u093E\u0938", onesUnit([
            "\u092E\u093F\u0928\u093F\u091F",
            "\u092E\u093F\u0928\u093F\u091F\u0947"
        ]), "\u0938\u0947\u0915\u0902\u0926", "\u092E\u093F\u0932\u093F\u0938\u0947\u0915\u0902\u0926"),
        ms: language("tahun", "bulan", "minggu", "hari", "jam", "minit", "saat", "milisaat"),
        nl: onesLanguage([
            "jaar",
            "jaar"
        ], [
            "maand",
            "maanden"
        ], [
            "week",
            "weken"
        ], [
            "dag",
            "dagen"
        ], [
            "uur",
            "uur"
        ], [
            "minuut",
            "minuten"
        ], [
            "seconde",
            "seconden"
        ], [
            "milliseconde",
            "milliseconden"
        ], ","),
        no: onesLanguage([
            "\xe5r",
            "\xe5r"
        ], [
            "m\xe5ned",
            "m\xe5neder"
        ], [
            "uke",
            "uker"
        ], [
            "dag",
            "dager"
        ], [
            "time",
            "timer"
        ], [
            "minutt",
            "minutter"
        ], [
            "sekund",
            "sekunder"
        ], [
            "millisekund",
            "millisekunder"
        ], ","),
        pl: language(function(c) {
            return [
                "rok",
                "roku",
                "lata",
                "lat"
            ][getPolishForm(c)];
        }, function(c) {
            return [
                "miesi\u0105c",
                "miesi\u0105ca",
                "miesi\u0105ce",
                "miesi\u0119cy"
            ][getPolishForm(c)];
        }, function(c) {
            return [
                "tydzie\u0144",
                "tygodnia",
                "tygodnie",
                "tygodni"
            ][getPolishForm(c)];
        }, function(c) {
            return [
                "dzie\u0144",
                "dnia",
                "dni",
                "dni"
            ][getPolishForm(c)];
        }, function(c) {
            return [
                "godzina",
                "godziny",
                "godziny",
                "godzin"
            ][getPolishForm(c)];
        }, function(c) {
            return [
                "minuta",
                "minuty",
                "minuty",
                "minut"
            ][getPolishForm(c)];
        }, function(c) {
            return [
                "sekunda",
                "sekundy",
                "sekundy",
                "sekund"
            ][getPolishForm(c)];
        }, function(c) {
            return [
                "milisekunda",
                "milisekundy",
                "milisekundy",
                "milisekund"
            ][getPolishForm(c)];
        }, ","),
        pt: onesLanguage([
            "ano",
            "anos"
        ], [
            "m\xeas",
            "meses"
        ], [
            "semana",
            "semanas"
        ], [
            "dia",
            "dias"
        ], [
            "hora",
            "horas"
        ], [
            "minuto",
            "minutos"
        ], [
            "segundo",
            "segundos"
        ], [
            "milissegundo",
            "milissegundos"
        ], ","),
        ro: language(romanianUnit("an", "ani", "de ani"), romanianUnit("lun\u0103", "luni", "de luni"), romanianUnit("s\u0103pt\u0103m\xe2n\u0103", "s\u0103pt\u0103m\xe2ni", "de s\u0103pt\u0103m\xe2ni"), romanianUnit("zi", "zile", "de zile"), romanianUnit("or\u0103", "ore", "de ore"), romanianUnit("minut", "minute", "de minute"), romanianUnit("secund\u0103", "secunde", "de secunde"), romanianUnit("milisecund\u0103", "milisecunde", "de milisecunde"), ","),
        ru: slavicLanguage([
            "\u043B\u0435\u0442",
            "\u0433\u043E\u0434",
            "\u0433\u043E\u0434\u0430"
        ], [
            "\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            "\u043C\u0435\u0441\u044F\u0446",
            "\u043C\u0435\u0441\u044F\u0446\u0430"
        ], [
            "\u043D\u0435\u0434\u0435\u043B\u044C",
            "\u043D\u0435\u0434\u0435\u043B\u044F",
            "\u043D\u0435\u0434\u0435\u043B\u0438"
        ], [
            "\u0434\u043D\u0435\u0439",
            "\u0434\u0435\u043D\u044C",
            "\u0434\u043D\u044F"
        ], [
            "\u0447\u0430\u0441\u043E\u0432",
            "\u0447\u0430\u0441",
            "\u0447\u0430\u0441\u0430"
        ], [
            "\u043C\u0438\u043D\u0443\u0442",
            "\u043C\u0438\u043D\u0443\u0442\u0430",
            "\u043C\u0438\u043D\u0443\u0442\u044B"
        ], [
            "\u0441\u0435\u043A\u0443\u043D\u0434",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u044B"
        ], [
            "\u043C\u0438\u043B\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434",
            "\u043C\u0438\u043B\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u043C\u0438\u043B\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u044B"
        ]),
        sq: language(onesUnit([
            "vit",
            "vjet"
        ]), "muaj", "jav\xeb", "dit\xeb", "or\xeb", function(c) {
            return "minut" + (c === 1 ? "\xeb" : "a");
        }, function(c) {
            return "sekond" + (c === 1 ? "\xeb" : "a");
        }, function(c) {
            return "milisekond" + (c === 1 ? "\xeb" : "a");
        }, ","),
        sr: slavicLanguage([
            "\u0433\u043E\u0434\u0438\u043D\u0438",
            "\u0433\u043E\u0434\u0438\u043D\u0430",
            "\u0433\u043E\u0434\u0438\u043D\u0435"
        ], [
            "\u043C\u0435\u0441\u0435\u0446\u0438",
            "\u043C\u0435\u0441\u0435\u0446",
            "\u043C\u0435\u0441\u0435\u0446\u0430"
        ], [
            "\u043D\u0435\u0434\u0435\u0459\u0438",
            "\u043D\u0435\u0434\u0435\u0459\u0430",
            "\u043D\u0435\u0434\u0435\u0459\u0435"
        ], [
            "\u0434\u0430\u043D\u0438",
            "\u0434\u0430\u043D",
            "\u0434\u0430\u043D\u0430"
        ], [
            "\u0441\u0430\u0442\u0438",
            "\u0441\u0430\u0442",
            "\u0441\u0430\u0442\u0430"
        ], [
            "\u043C\u0438\u043D\u0443\u0442\u0430",
            "\u043C\u0438\u043D\u0443\u0442",
            "\u043C\u0438\u043D\u0443\u0442\u0430"
        ], [
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0435"
        ], [
            "\u043C\u0438\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            "\u043C\u0438\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u043C\u0438\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u0435"
        ]),
        sr_Latn: slavicLanguage([
            "godini",
            "godina",
            "godine"
        ], [
            "meseci",
            "mesec",
            "meseca"
        ], [
            "nedelji",
            "nedelja",
            "nedelje"
        ], [
            "dani",
            "dan",
            "dana"
        ], [
            "sati",
            "sat",
            "sata"
        ], [
            "minuta",
            "minut",
            "minuta"
        ], [
            "sekundi",
            "sekunda",
            "sekunde"
        ], [
            "milisekundi",
            "milisekunda",
            "milisekunde"
        ]),
        ta: onesLanguage([
            "\u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            "\u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD"
        ], [
            "\u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            "\u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD"
        ], [
            "\u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            "\u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD"
        ], [
            "\u0BA8\u0BBE\u0BB3\u0BCD",
            "\u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD"
        ], [
            "\u0BAE\u0BA3\u0BBF",
            "\u0BAE\u0BA3\u0BBF\u0BA8\u0BC7\u0BB0\u0BAE\u0BCD"
        ], [
            "\u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            "\u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD"
        ], [
            "\u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            "\u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD"
        ], [
            "\u0BAE\u0BBF\u0BB2\u0BCD\u0BB2\u0BBF \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF",
            "\u0BAE\u0BBF\u0BB2\u0BCD\u0BB2\u0BBF \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD"
        ]),
        te: onesLanguage([
            "\u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            "\u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        ], [
            "\u0C28\u0C46\u0C32",
            "\u0C28\u0C46\u0C32\u0C32"
        ], [
            "\u0C35\u0C3E\u0C30\u0C02",
            "\u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        ], [
            "\u0C30\u0C4B\u0C1C\u0C41",
            "\u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        ], [
            "\u0C17\u0C02\u0C1F",
            "\u0C17\u0C02\u0C1F\u0C32\u0C41"
        ], [
            "\u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            "\u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        ], [
            "\u0C38\u0C46\u0C15\u0C28\u0C41",
            "\u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32\u0C41"
        ], [
            "\u0C2E\u0C3F\u0C32\u0C4D\u0C32\u0C40\u0C38\u0C46\u0C15\u0C28\u0C4D",
            "\u0C2E\u0C3F\u0C32\u0C4D\u0C32\u0C40\u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32\u0C41"
        ]),
        uk: slavicLanguage([
            "\u0440\u043E\u043A\u0456\u0432",
            "\u0440\u0456\u043A",
            "\u0440\u043E\u043A\u0438"
        ], [
            "\u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            "\u043C\u0456\u0441\u044F\u0446\u044C",
            "\u043C\u0456\u0441\u044F\u0446\u0456"
        ], [
            "\u0442\u0438\u0436\u043D\u0456\u0432",
            "\u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            "\u0442\u0438\u0436\u043D\u0456"
        ], [
            "\u0434\u043D\u0456\u0432",
            "\u0434\u0435\u043D\u044C",
            "\u0434\u043D\u0456"
        ], [
            "\u0433\u043E\u0434\u0438\u043D",
            "\u0433\u043E\u0434\u0438\u043D\u0430",
            "\u0433\u043E\u0434\u0438\u043D\u0438"
        ], [
            "\u0445\u0432\u0438\u043B\u0438\u043D",
            "\u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            "\u0445\u0432\u0438\u043B\u0438\u043D\u0438"
        ], [
            "\u0441\u0435\u043A\u0443\u043D\u0434",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        ], [
            "\u043C\u0456\u043B\u0456\u0441\u0435\u043A\u0443\u043D\u0434",
            "\u043C\u0456\u043B\u0456\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u043C\u0456\u043B\u0456\u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        ]),
        ur: language("\u0633\u0627\u0644", onesUnit([
            "\u0645\u06C1\u06CC\u0646\u06C1",
            "\u0645\u06C1\u06CC\u0646\u06D2"
        ]), onesUnit([
            "\u06C1\u0641\u062A\u06C1",
            "\u06C1\u0641\u062A\u06D2"
        ]), "\u062F\u0646", onesUnit([
            "\u06AF\u06BE\u0646\u0679\u06C1",
            "\u06AF\u06BE\u0646\u0679\u06D2"
        ]), "\u0645\u0646\u0679", "\u0633\u06CC\u06A9\u0646\u0688", "\u0645\u0644\u06CC \u0633\u06CC\u06A9\u0646\u0688"),
        sk: language(function(c) {
            return [
                "rok",
                "roky",
                "roky",
                "rokov"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "mesiac",
                "mesiace",
                "mesiace",
                "mesiacov"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "t\xfd\u017Ede\u0148",
                "t\xfd\u017Edne",
                "t\xfd\u017Edne",
                "t\xfd\u017Ed\u0148ov"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "de\u0148",
                "dni",
                "dni",
                "dn\xed"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "hodina",
                "hodiny",
                "hodiny",
                "hod\xedn"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "min\xfata",
                "min\xfaty",
                "min\xfaty",
                "min\xfat"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "sekunda",
                "sekundy",
                "sekundy",
                "sek\xfand"
            ][getCzechOrSlovakForm(c)];
        }, function(c) {
            return [
                "milisekunda",
                "milisekundy",
                "milisekundy",
                "milisek\xfand"
            ][getCzechOrSlovakForm(c)];
        }, ","),
        sl: language(function(c) {
            if (c % 10 === 1) return "leto";
            else if (c % 100 === 2) return "leti";
            else if (c % 100 === 3 || c % 100 === 4 || Math.floor(c) !== c && c % 100 <= 5) return "leta";
            else return "let";
        }, function(c) {
            if (c % 10 === 1) return "mesec";
            else if (c % 100 === 2 || Math.floor(c) !== c && c % 100 <= 5) return "meseca";
            else if (c % 10 === 3 || c % 10 === 4) return "mesece";
            else return "mesecev";
        }, function(c) {
            if (c % 10 === 1) return "teden";
            else if (c % 10 === 2 || Math.floor(c) !== c && c % 100 <= 4) return "tedna";
            else if (c % 10 === 3 || c % 10 === 4) return "tedne";
            else return "tednov";
        }, function(c) {
            return c % 100 === 1 ? "dan" : "dni";
        }, function(c) {
            if (c % 10 === 1) return "ura";
            else if (c % 100 === 2) return "uri";
            else if (c % 10 === 3 || c % 10 === 4 || Math.floor(c) !== c) return "ure";
            else return "ur";
        }, function(c) {
            if (c % 10 === 1) return "minuta";
            else if (c % 10 === 2) return "minuti";
            else if (c % 10 === 3 || c % 10 === 4 || Math.floor(c) !== c && c % 100 <= 4) return "minute";
            else return "minut";
        }, function(c) {
            if (c % 10 === 1) return "sekunda";
            else if (c % 100 === 2) return "sekundi";
            else if (c % 100 === 3 || c % 100 === 4 || Math.floor(c) !== c) return "sekunde";
            else return "sekund";
        }, function(c) {
            if (c % 10 === 1) return "milisekunda";
            else if (c % 100 === 2) return "milisekundi";
            else if (c % 100 === 3 || c % 100 === 4 || Math.floor(c) !== c) return "milisekunde";
            else return "milisekund";
        }, ","),
        sv: onesLanguage([
            "\xe5r",
            "\xe5r"
        ], [
            "m\xe5nad",
            "m\xe5nader"
        ], [
            "vecka",
            "veckor"
        ], [
            "dag",
            "dagar"
        ], [
            "timme",
            "timmar"
        ], [
            "minut",
            "minuter"
        ], [
            "sekund",
            "sekunder"
        ], [
            "millisekund",
            "millisekunder"
        ], ","),
        sw: assign(onesLanguage([
            "mwaka",
            "miaka"
        ], [
            "mwezi",
            "miezi"
        ], [
            "wiki",
            "wiki"
        ], [
            "siku",
            "masiku"
        ], [
            "saa",
            "masaa"
        ], [
            "dakika",
            "dakika"
        ], [
            "sekunde",
            "sekunde"
        ], [
            "milisekunde",
            "milisekunde"
        ]), {
            _numberFirst: true
        }),
        tr: language("y\u0131l", "ay", "hafta", "g\xfcn", "saat", "dakika", "saniye", "milisaniye", ","),
        th: language("\u0E1B\u0E35", "\u0E40\u0E14\u0E37\u0E2D\u0E19", "\u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C", "\u0E27\u0E31\u0E19", "\u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07", "\u0E19\u0E32\u0E17\u0E35", "\u0E27\u0E34\u0E19\u0E32\u0E17\u0E35", "\u0E21\u0E34\u0E25\u0E25\u0E34\u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"),
        uz: language("yil", "oy", "hafta", "kun", "soat", "minut", "sekund", "millisekund"),
        uz_CYR: language("\u0439\u0438\u043B", "\u043E\u0439", "\u04B3\u0430\u0444\u0442\u0430", "\u043A\u0443\u043D", "\u0441\u043E\u0430\u0442", "\u043C\u0438\u043D\u0443\u0442", "\u0441\u0435\u043A\u0443\u043D\u0434", "\u043C\u0438\u043B\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434"),
        vi: language("n\u0103m", "th\xe1ng", "tu\u1EA7n", "ng\xe0y", "gi\u1EDD", "ph\xfat", "gi\xe2y", "mili gi\xe2y", ","),
        zh_CN: language("\u5E74", "\u4E2A\u6708", "\u5468", "\u5929", "\u5C0F\u65F6", "\u5206\u949F", "\u79D2", "\u6BEB\u79D2"),
        zh_TW: language("\u5E74", "\u500B\u6708", "\u5468", "\u5929", "\u5C0F\u6642", "\u5206\u9418", "\u79D2", "\u6BEB\u79D2")
    };
    /**
   * Helper function for creating language definitions.
   *
   * @internal
   * @param {Unit} y
   * @param {Unit} mo
   * @param {Unit} w
   * @param {Unit} d
   * @param {Unit} h
   * @param {Unit} m
   * @param {Unit} s
   * @param {Unit} ms
   * @param {string} [decimal]
   * @returns {Language}
   */ function language(y, mo, w, d, h, m, s, ms, decimal) {
        /** @type {Language} */ var result = {
            y: y,
            mo: mo,
            w: w,
            d: d,
            h: h,
            m: m,
            s: s,
            ms: ms
        };
        if (decimal) result.decimal = decimal;
        return result;
    }
    /**
   * @internal
   * @param {[string, string]} unit
   * @returns {(c: number) => string}
   */ function onesUnit(unit) {
        return function(c) {
            return c === 1 ? unit[0] : unit[1];
        };
    }
    /**
   * Helper for generating languages where the word varies if the count is 1.
   *
   * @internal
   * @param {[string, string]} y
   * @param {[string, string]} mo
   * @param {[string, string]} w
   * @param {[string, string]} d
   * @param {[string, string]} h
   * @param {[string, string]} m
   * @param {[string, string]} s
   * @param {[string, string]} ms
   * @param {string} [decimal]
   * @returns {Language}
   */ function onesLanguage(y, mo, w, d, h, m, s, ms, decimal) {
        return language(onesUnit(y), onesUnit(mo), onesUnit(w), onesUnit(d), onesUnit(h), onesUnit(m), onesUnit(s), onesUnit(ms), decimal);
    }
    /**
   * Romanian uses "de" before the noun for numbers >= 20 (when not ending in 01-19).
   * See: https://en.wikipedia.org/wiki/Romanian_numbers#Preposition_de
   *
   * @internal
   * @param {string} single
   * @param {string} plural
   * @param {string} pluralWithDe
   * @returns {(c: number) => string}
   */ function romanianUnit(single, plural, pluralWithDe) {
        return function(c) {
            if (c === 1) return single;
            if (Math.floor(c) !== c || c === 0) return plural;
            var remainder = c % 100;
            if (remainder >= 1 && remainder <= 19) return plural;
            return pluralWithDe;
        };
    }
    /**
   * @internal
   * @param {[string, string, string]} unit
   * @returns {(c: number) => string}
   */ function slavicUnit(unit) {
        return function(c) {
            if (Math.floor(c) !== c) return unit[2];
            if (c % 100 >= 5 && c % 100 <= 20 || c % 10 >= 5 && c % 10 <= 9 || c % 10 === 0) return unit[0];
            if (c % 10 === 1) return unit[1];
            if (c > 1) return unit[2];
            return unit[1];
        };
    }
    /**
   * Helper for generating Slavic languages.
   *
   * @internal
   * @param {[string, string, string]} y
   * @param {[string, string, string]} mo
   * @param {[string, string, string]} w
   * @param {[string, string, string]} d
   * @param {[string, string, string]} h
   * @param {[string, string, string]} m
   * @param {[string, string, string]} s
   * @param {[string, string, string]} ms
   * @returns {Language}
   */ function slavicLanguage(y, mo, w, d, h, m, s, ms) {
        return language(slavicUnit(y), slavicUnit(mo), slavicUnit(w), slavicUnit(d), slavicUnit(h), slavicUnit(m), slavicUnit(s), slavicUnit(ms), ",");
    }
    /**
   * Helper function for Arabic.
   *
   * @internal
   * @param {number} c
   * @returns {0 | 1 | 2}
   */ function getArabicForm(c) {
        if (c === 2) return 1;
        if (c > 2 && c < 11) return 2;
        return 0;
    }
    /**
   * Helper function for Polish.
   *
   * @internal
   * @param {number} c
   * @returns {0 | 1 | 2 | 3}
   */ function getPolishForm(c) {
        if (c === 1) return 0;
        if (Math.floor(c) !== c) return 1;
        if (c % 10 >= 2 && c % 10 <= 4 && !(c % 100 > 10 && c % 100 < 20)) return 2;
        return 3;
    }
    /**
   * Helper function for Czech or Slovak.
   *
   * @internal
   * @param {number} c
   * @returns {0 | 1 | 2 | 3}
   */ function getCzechOrSlovakForm(c) {
        if (c === 1) return 0;
        if (Math.floor(c) !== c) return 1;
        if (c % 10 >= 2 && c % 10 <= 4 && c % 100 < 10) return 2;
        return 3;
    }
    /**
   * Helper function for Lithuanian.
   *
   * @internal
   * @param {number} c
   * @returns {0 | 1 | 2}
   */ function getLithuanianForm(c) {
        if (c === 1 || c % 10 === 1 && c % 100 > 20) return 0;
        if (Math.floor(c) !== c || c % 10 >= 2 && c % 100 > 20 || c % 10 >= 2 && c % 100 < 10) return 1;
        return 2;
    }
    /**
   * Helper function for Latvian.
   *
   * @internal
   * @param {number} c
   * @returns {boolean}
   */ function getLatvianForm(c) {
        return c % 10 === 1 && c % 100 !== 11;
    }
    /**
   * @internal
   * @template T
   * @param {T} obj
   * @param {keyof T} key
   * @returns {boolean}
   */ function has(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
    }
    /**
   * @internal
   * @param {Pick<Required<Options>, "language" | "fallbacks" | "languages">} options
   * @throws {Error} Throws an error if language is not found.
   * @returns {Language}
   */ function getLanguage(options) {
        var possibleLanguages = [
            options.language
        ];
        if (has(options, "fallbacks")) {
            if (isArray(options.fallbacks) && options.fallbacks.length) possibleLanguages = possibleLanguages.concat(options.fallbacks);
            else throw new Error("fallbacks must be an array with at least one element");
        }
        for(var i = 0; i < possibleLanguages.length; i++){
            var languageToTry = possibleLanguages[i];
            if (has(options.languages, languageToTry)) return options.languages[languageToTry];
            if (has(LANGUAGES, languageToTry)) return LANGUAGES[languageToTry];
        }
        throw new Error("No language found.");
    }
    /**
   * @internal
   * @param {Piece} piece
   * @param {Language} language
   * @param {Pick<Required<Options>, "decimal" | "spacer" | "maxDecimalPoints" | "digitReplacements">} options
   */ function renderPiece(piece, language, options) {
        var unitName = piece.unitName;
        var unitCount = piece.unitCount;
        var spacer = options.spacer;
        var maxDecimalPoints = options.maxDecimalPoints;
        /** @type {string} */ var decimal;
        if (has(options, "decimal")) decimal = options.decimal;
        else if (has(language, "decimal")) decimal = language.decimal;
        else decimal = ".";
        /** @type {undefined | DigitReplacements} */ var digitReplacements;
        if ("digitReplacements" in options) digitReplacements = options.digitReplacements;
        else if ("_digitReplacements" in language) digitReplacements = language._digitReplacements;
        /** @type {string} */ var formattedCount;
        var normalizedUnitCount = maxDecimalPoints === void 0 ? unitCount : Math.floor(unitCount * Math.pow(10, maxDecimalPoints)) / Math.pow(10, maxDecimalPoints);
        var countStr = normalizedUnitCount.toString();
        if (language._hideCountIf2 && unitCount === 2) {
            formattedCount = "";
            spacer = "";
        } else if (digitReplacements) {
            formattedCount = "";
            for(var i = 0; i < countStr.length; i++){
                var character = countStr[i];
                if (character === ".") formattedCount += decimal;
                else formattedCount += digitReplacements[/** @type {"0" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9"} */ character];
            }
        } else formattedCount = countStr.replace(".", decimal);
        var languageWord = language[unitName];
        var word;
        if (typeof languageWord === "function") word = languageWord(unitCount);
        else word = languageWord;
        if (language._numberFirst) return word + spacer + formattedCount;
        return formattedCount + spacer + word;
    }
    /**
   * @internal
   * @typedef {Object} Piece
   * @prop {UnitName} unitName
   * @prop {number} unitCount
   */ /**
   * @internal
   * @param {number} ms
   * @param {Pick<Required<Options>, "units" | "unitMeasures" | "largest" | "round">} options
   * @returns {Piece[]}
   */ function getPieces(ms, options) {
        /** @type {UnitName} */ var unitName;
        /** @type {number} */ var i;
        /** @type {number} */ var unitCount;
        /** @type {number} */ var msRemaining;
        var units = options.units;
        var unitMeasures = options.unitMeasures;
        var largest = "largest" in options ? options.largest : Infinity;
        if (!units.length) return [];
        // Get the counts for each unit. Doesn't round or truncate anything.
        // For example, might create an object like `{ y: 7, m: 6, w: 0, d: 5, h: 23.99 }`.
        /** @type {Partial<Record<UnitName, number>>} */ var unitCounts = {};
        msRemaining = ms;
        for(i = 0; i < units.length; i++){
            unitName = units[i];
            var unitMs = unitMeasures[unitName];
            var isLast = i === units.length - 1;
            unitCount = isLast ? msRemaining / unitMs : Math.floor(msRemaining / unitMs);
            unitCounts[unitName] = unitCount;
            msRemaining -= unitCount * unitMs;
        }
        if (options.round) {
            // Update counts based on the `largest` option.
            // For example, if `largest === 2` and `unitCount` is `{ y: 7, m: 6, w: 0, d: 5, h: 23.99 }`,
            // updates to something like `{ y: 7, m: 6.2 }`.
            var unitsRemainingBeforeRound = largest;
            for(i = 0; i < units.length; i++){
                unitName = units[i];
                unitCount = unitCounts[unitName];
                if (unitCount === 0) continue;
                unitsRemainingBeforeRound--;
                // "Take" the rest of the units into this one.
                if (unitsRemainingBeforeRound === 0) {
                    for(var j = i + 1; j < units.length; j++){
                        var smallerUnitName = units[j];
                        var smallerUnitCount = unitCounts[smallerUnitName];
                        unitCounts[unitName] += smallerUnitCount * unitMeasures[smallerUnitName] / unitMeasures[unitName];
                        unitCounts[smallerUnitName] = 0;
                    }
                    break;
                }
            }
            // Round the last piece (which should be the only non-integer).
            //
            // This can be a little tricky if the last piece "bubbles up" to a larger
            // unit. For example, "3 days, 23.99 hours" should be rounded to "4 days".
            // It can also require multiple passes. For example, "6 days, 23.99 hours"
            // should become "1 week".
            for(i = units.length - 1; i >= 0; i--){
                unitName = units[i];
                unitCount = unitCounts[unitName];
                if (unitCount === 0) continue;
                var rounded = Math.round(unitCount);
                unitCounts[unitName] = rounded;
                if (i === 0) break;
                var previousUnitName = units[i - 1];
                var previousUnitMs = unitMeasures[previousUnitName];
                var amountOfPreviousUnit = Math.floor(rounded * unitMeasures[unitName] / previousUnitMs);
                if (amountOfPreviousUnit) {
                    unitCounts[previousUnitName] += amountOfPreviousUnit;
                    unitCounts[unitName] = 0;
                } else break;
            }
        }
        /** @type {Piece[]} */ var result = [];
        for(i = 0; i < units.length && result.length < largest; i++){
            unitName = units[i];
            unitCount = unitCounts[unitName];
            if (unitCount) result.push({
                unitName: unitName,
                unitCount: unitCount
            });
        }
        return result;
    }
    /**
   * @internal
   * @param {Piece[]} pieces
   * @param {Pick<Required<Options>, "units" | "language" | "languages" | "fallbacks" | "delimiter" | "spacer" | "decimal" | "conjunction" | "maxDecimalPoints" | "serialComma" | "digitReplacements">} options
   * @returns {string}
   */ function formatPieces(pieces, options) {
        var language = getLanguage(options);
        if (!pieces.length) {
            var units = options.units;
            var smallestUnitName = units[units.length - 1];
            return renderPiece({
                unitName: smallestUnitName,
                unitCount: 0
            }, language, options);
        }
        var conjunction = options.conjunction;
        var serialComma = options.serialComma;
        var delimiter;
        if (has(options, "delimiter")) delimiter = options.delimiter;
        else if (has(language, "delimiter")) delimiter = language.delimiter;
        else delimiter = ", ";
        /** @type {string[]} */ var renderedPieces = [];
        for(var i = 0; i < pieces.length; i++)renderedPieces.push(renderPiece(pieces[i], language, options));
        if (!conjunction || pieces.length === 1) return renderedPieces.join(delimiter);
        if (pieces.length === 2) return renderedPieces.join(conjunction);
        return renderedPieces.slice(0, -1).join(delimiter) + (serialComma ? "," : "") + conjunction + renderedPieces.slice(-1);
    }
    /**
   * Create a humanizer, which lets you change the default options.
   *
   * @param {Options} [passedOptions] Options to customize the humanizer
   * @returns {(ms: number, humanizerOptions: Options) => string} A function that humanizes durations
   */ function humanizer(passedOptions) {
        /**
     * @param {number} ms
     * @param {Options} [humanizerOptions]
     * @returns {string}
     */ var result = function humanizer(ms, humanizerOptions) {
            // Make sure we have a positive number.
            //
            // Has the nice side-effect of converting things to numbers. For example,
            // converts `"123"` and `Number(123)` to `123`.
            ms = Math.abs(ms);
            var options = assign({}, result, humanizerOptions || {});
            var pieces = getPieces(ms, options);
            return formatPieces(pieces, options);
        };
        return assign(result, {
            language: "en",
            spacer: " ",
            conjunction: "",
            serialComma: true,
            units: [
                "y",
                "mo",
                "w",
                "d",
                "h",
                "m",
                "s"
            ],
            languages: {},
            round: false,
            unitMeasures: {
                y: 31557600000,
                mo: 2629800000,
                w: 604800000,
                d: 86400000,
                h: 3600000,
                m: 60000,
                s: 1000,
                ms: 1
            }
        }, passedOptions);
    }
    /**
   * Humanize a duration.
   *
   * This is a wrapper around the default humanizer.
   */ var humanizeDuration = assign(humanizer({}), {
        /**
     * Get a list of supported languages.
     *
     * @returns {string[]} An array of language codes
     */ getSupportedLanguages: function getSupportedLanguages() {
            var result = [];
            for(var language in LANGUAGES)if (has(LANGUAGES, language) && language !== "gr") result.push(language);
            return result;
        },
        humanizer: humanizer
    });
    // @ts-ignore
    if (typeof define === "function" && define.amd) // @ts-ignore
    define(function() {
        return humanizeDuration;
    });
    else if ($49dedb61fc713737$exports) $49dedb61fc713737$exports = humanizeDuration;
    else this.humanizeDuration = humanizeDuration;
})();


const $2c1695720c48a031$var$ESTIMATED_HOURS_TO_RENDER = 2;
const $2c1695720c48a031$var$calculateEta = (queuePosition)=>{
    const eta = queuePosition * $2c1695720c48a031$var$ESTIMATED_HOURS_TO_RENDER * 3600000;
    const etaText = (0, (/*@__PURE__*/$parcel$interopDefault($49dedb61fc713737$exports)))(eta, {
        largest: 1,
        units: [
            'd',
            'h'
        ]
    });
    return etaText;
};
var $2c1695720c48a031$export$2e2bcd8739ae039 = $2c1695720c48a031$var$calculateEta;


const $21eefb29f10b1b9e$var$PendingStatus = ({ match: match, status: { status: status, queueSize: queueSize, position: position } })=>{
    const { openingKey: openingKey } = match.params;
    const isNotQueued = 'not_queued' === status;
    const queuePosition = isNotQueued ? queueSize + 1 : position;
    const numberOfRequestsBefore = isNotQueued ? queueSize : position;
    const etaText = (0, $2c1695720c48a031$export$2e2bcd8739ae039)(queuePosition);
    const statusDescription = isNotQueued ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
        children: [
            "You can now request a download of your creation as a video, which you can play anywhere, put it in a slideshow or edit it in a movie editor, for instance. The video will be rendered on our servers and when it",
            '\'',
            "s ready, it will be sent to your email. We want to provide the video for free, but we have costs with the servers."
        ]
    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
        children: "This video is already in the queue to be rendered. This page will be updated when the video is ready. You can add more emails to receive the video, just follow the next page and add submit the request again with the new email."
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
        children: [
            statusDescription,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    "There are ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        className: "bold",
                        children: [
                            numberOfRequestsBefore,
                            " videos"
                        ]
                    }),
                    " in front of you to be rendered and may take up to ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "bold",
                        children: etaText
                    }),
                    " to send your video."
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    "Can",
                    '\'',
                    "t wait for it? Pay at least ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "bold",
                        children: "$15 US Dollars"
                    }),
                    " to support our service and your video will be ready in few hours (2 hours usually). The video is rendered in Full HD quality."
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    "You can pay via Credit Card or PayPal. If you don",
                    '\'',
                    "t receive the video please contact us via email so we can check it out."
                ]
            }),
            isNotQueued && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "bold",
                        children: "Attention!"
                    }),
                    ' ',
                    "Before sending the download request make sure there are no typos in your text to grant that your video will be with the correct text.",
                    ' ',
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2e5310b7e303c483$export$2e2bcd8739ae039), {
                        to: `/${openingKey}/edit`,
                        className: "link",
                        children: "Click here to go back and check your text."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a22ae36f81196ea$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c794d0292d6e750b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8c601f58b7d640bb$export$2e2bcd8739ae039), {})
        ]
    });
};
$21eefb29f10b1b9e$var$PendingStatus.propTypes = {
    match: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
    status: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).shape({
        queueSize: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    })
};
var $21eefb29f10b1b9e$export$2e2bcd8739ae039 = (0, $df938650094f2b43$export$2e2bcd8739ae039)($21eefb29f10b1b9e$var$PendingStatus);




var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");




class $5713618e2c793770$var$EmailRequestField extends (0, $bh6RR.Component) {
    static propTypes = {
        buttonLabel: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        match: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        history: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        donate: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool
    };
    constructor(){
        super();
        this.emailField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createRef();
    }
    state = {
        isLoading: false,
        hasError: false
    };
    goToNextPage = ()=>{
        const { match: match, history: history, donate: donate } = this.props;
        const { openingKey: openingKey } = match.params;
        if (donate) {
            history.push(`/${openingKey}/download/paid`);
            return;
        }
        history.push(`/${openingKey}/download/requested`);
    };
    handleSubmit = async (e)=>{
        e.preventDefault();
        const { match: match } = this.props;
        const { openingKey: openingKey } = match.params;
        const email = this.emailField.current.value;
        this.setState({
            isLoading: true,
            hasError: false
        });
        try {
            await (0, $f056960f2e07845b$export$c2863f81b29a10db)(openingKey, email);
            this.goToNextPage();
        } catch (error) {
            this.setState({
                isLoading: false,
                hasError: true
            });
        }
    };
    render() {
        const { buttonLabel: buttonLabel = 'SUBMIT REQUEST' } = this.props;
        const { isLoading: isLoading, hasError: hasError } = this.state;
        const classnames = `button medium has-loader ${isLoading ? 'loading' : ''}`;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
            onSubmit: this.handleSubmit,
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    className: "email",
                    type: "email",
                    name: "email",
                    id: "email",
                    placeholder: "Insert your email here...",
                    ref: this.emailField,
                    required: true
                }),
                hasError && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    style: {
                        marginBottom: 0
                    },
                    children: "Error has occured, please try again!"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                    className: classnames,
                    style: {
                        marginTop: '20px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6970ed5340caef3d$export$2e2bcd8739ae039), {}),
                        buttonLabel
                    ]
                })
            ]
        });
    }
}
var $5713618e2c793770$export$2e2bcd8739ae039 = (0, $df938650094f2b43$export$2e2bcd8739ae039)($5713618e2c793770$var$EmailRequestField);


const $0de827ae83e30dba$var$RenderingOrBumpedStatus = ({ status: { status: status } })=>{
    const isBumped = 'bumped' === status;
    const initialText = isBumped ? 'Your donation has been verified, your video will be rendered soon. You will receive your video by email in a few hours. ' : 'Your video is being rendered right now! You will receive your video by email in less than two hours. ';
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    initialText,
                    "This page will be updated when the video is ready."
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a22ae36f81196ea$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: "If you want, you can add more emails to receive the video in the form below."
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5713618e2c793770$export$2e2bcd8739ae039), {
                buttonLabel: "Add Email"
            })
        ]
    });
};
$0de827ae83e30dba$var$RenderingOrBumpedStatus.propTypes = {
    status: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
var $0de827ae83e30dba$export$2e2bcd8739ae039 = $0de827ae83e30dba$var$RenderingOrBumpedStatus;




var $bh6RR = parcelRequire("bh6RR");


const $7b628dc7c4560c5c$var$RenderedStatus = ({ status: { downloadUrl: downloadUrl } })=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: "Your video is ready to download! Click on the button below to download it!"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "center-content",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                    href: downloadUrl,
                    style: {
                        display: 'inline-block'
                    },
                    download: true,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        className: "button medium",
                        children: "Download"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a22ae36f81196ea$export$2e2bcd8739ae039), {
                customText: "If you have any problem while trying to download the video, please contact us:"
            })
        ]
    });
$7b628dc7c4560c5c$var$RenderedStatus.propTypes = {
    status: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
var $7b628dc7c4560c5c$export$2e2bcd8739ae039 = $7b628dc7c4560c5c$var$RenderedStatus;




var $bh6RR = parcelRequire("bh6RR");



class $02a62dbb9dd574c8$var$DownloadPageContainer extends (0, $bh6RR.Component) {
    static propTypes = {
        history: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        match: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).node,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string
    };
    _backToEdit = ()=>{
        const { history: history, match: match } = this.props;
        const { openingKey: openingKey } = match.params;
        history.push(`/${openingKey}/edit`);
    };
    render() {
        const { title: title = 'DOWNLOAD' } = this.props;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $26778b50e82826b4$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "download-page box-page",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "box",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            id: "closeButton",
                            className: "button",
                            onClick: this._backToEdit,
                            children: "x"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            children: this.props.children
                        })
                    ]
                })
            })
        });
    }
}
var $02a62dbb9dd574c8$export$2e2bcd8739ae039 = (0, $df938650094f2b43$export$2e2bcd8739ae039)($02a62dbb9dd574c8$var$DownloadPageContainer);



class $691ea1ad541192ac$var$DownloadPage extends (0, $bh6RR.Component) {
    static propTypes = {
        match: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
        clearOpening: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func
    };
    constructor(){
        super();
        this.state = {
            isLoading: true,
            error: null
        };
    }
    componentDidMount = async ()=>{
        await this._loadDownloadStatus();
    };
    componentDidUpdate = async (prevProps)=>{
        const { openingKey: openingKey } = this.props.match.params;
        const prevOpeningKey = prevProps.match.params.openingKey;
        const openingKeyChanged = prevOpeningKey !== openingKey;
        if (openingKeyChanged) {
            this.setState({
                isLoading: true
            });
            await this._loadDownloadStatus();
            this.props.clearOpening();
        }
    };
    _loadDownloadStatus = async ()=>{
        const { match: { params: params } } = this.props;
        const { openingKey: openingKey } = params;
        try {
            const status = await (0, $f056960f2e07845b$export$ffae4f72cb988e44)(openingKey);
            this.setState({
                isLoading: false,
                status: status
            });
        } catch (error) {
            this.setState({
                error: error
            });
        }
    };
    render() {
        const { isLoading: isLoading, status: status = {}, error: error } = this.state;
        const isNotQueued = 'not_queued' === status.status;
        const isQueued = 'queued' === status.status;
        const isPending = isQueued || isNotQueued;
        const isBumped = 'bumped' === status.status;
        const isRendering = 'rendering' === status.status;
        const isRenderingOrBumped = isRendering || isBumped;
        const isRendered = 'rendered' === status.status;
        if (error) throw error;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $02a62dbb9dd574c8$export$2e2bcd8739ae039), {
            children: [
                isLoading && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "center-content",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6970ed5340caef3d$export$2e2bcd8739ae039), {})
                }),
                isPending && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $21eefb29f10b1b9e$export$2e2bcd8739ae039), {
                    status: status
                }),
                isRenderingOrBumped && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0de827ae83e30dba$export$2e2bcd8739ae039), {
                    status: status
                }),
                isRendered && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7b628dc7c4560c5c$export$2e2bcd8739ae039), {
                    status: status
                })
            ]
        });
    }
}
const $691ea1ad541192ac$var$mapOpeningProviderToProps = (context)=>({
        clearOpening: context.clearOpening
    });
const $691ea1ad541192ac$var$connectOpeningProvider = (0, (/*@__PURE__*/$parcel$interopDefault($17bc0d4f42435b88$exports)))((0, $87127865826734e4$export$2e2bcd8739ae039), $691ea1ad541192ac$var$mapOpeningProviderToProps);
var $691ea1ad541192ac$export$2e2bcd8739ae039 = $691ea1ad541192ac$var$connectOpeningProvider($691ea1ad541192ac$var$DownloadPage);




var $bh6RR = parcelRequire("bh6RR");









var $bh6RR = parcelRequire("bh6RR");

var $44a44312232fffaa$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($44a44312232fffaa$exports) {
        classNames.default = classNames;
        $44a44312232fffaa$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


const $f0d97a1134d49036$var$DONATION_AMOUNTS = {
    watermark: 15,
    'no-watermark': 25
};
function $f0d97a1134d49036$export$2e2bcd8739ae039({ updatePaymentAmount: updatePaymentAmount }) {
    const [selectedOption, setSelectedOption] = (0, $bh6RR.useState)('no-watermark');
    const selectOption = (0, $bh6RR.useCallback)((option)=>{
        setSelectedOption(option);
        updatePaymentAmount($f0d97a1134d49036$var$DONATION_AMOUNTS[option]);
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "donation-options",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                type: "button",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))('option', {
                    '-selected': 'watermark' === selectedOption
                }),
                onClick: ()=>selectOption('watermark'),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "title",
                        children: "Standard"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "description",
                        children: "Full HD Quality"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "description",
                        children: "MP4 Video"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "description",
                        children: "Video will be like in the preview"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        className: "description",
                        children: [
                            "Pay at least",
                            ' ',
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("b", {
                                children: "$15"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                type: "button",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))('option', {
                    '-selected': 'no-watermark' === selectedOption
                }),
                onClick: ()=>selectOption('no-watermark'),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "title",
                        children: "No Watermark"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "description",
                        children: "Full HD Quality"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "description",
                        children: "MP4 Video"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "description",
                        children: "Video will be like in the preview"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "description",
                        children: "but without the watermark"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        className: "description",
                        children: [
                            "Pay at least",
                            ' ',
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("b", {
                                children: "$25"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$f0d97a1134d49036$export$2e2bcd8739ae039.propTypes = {
    updatePaymentAmount: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func.isRequired
};


const $42841dbc7c4805fb$var$DonateDownloadPage = ({ match: match })=>{
    const { params: params } = match;
    const { openingKey: openingKey } = params;
    const iframeRef = (0, $bh6RR.useRef)(null);
    const updatePaymentAmount = (0, $bh6RR.useCallback)((amount)=>{
        if (!iframeRef.current) return;
        iframeRef.current.contentWindow.postMessage({
            action: 'setAmount',
            payload: amount
        }, '*');
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        const handleTrackPaymentsEventCallback = (event)=>{
            if (!event.origin.match(/https:\/\/payment\.kassellabs\.io$/)) return;
            const { data: data } = event;
            const isPaymentSuccess = data && 'success' === data.action && 'payment' === data.type;
            if (isPaymentSuccess && window.dataLayer) window.dataLayer.push({
                event: 'purchase',
                value: data.payload.finalAmount,
                currency: data.payload.currency
            });
        };
        window.addEventListener('message', handleTrackPaymentsEventCallback);
        return ()=>{
            window.removeEventListener('message', handleTrackPaymentsEventCallback);
        };
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $02a62dbb9dd574c8$export$2e2bcd8739ae039), {
        title: "PAYMENT AND DOWNLOAD",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: "Great choice! You can pay the amount for the following options:"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0d97a1134d49036$export$2e2bcd8739ae039), {
                updatePaymentAmount: updatePaymentAmount
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "compose-iframe",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "center center-content",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6970ed5340caef3d$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("iframe", {
                        ref: iframeRef,
                        className: "stripe",
                        id: "stripeDonateIframe",
                        title: "Stripe Payment Form",
                        src: `${(0, $d39cc430308b5205$export$7467e90a3cb2bd05)}?embed=true&app=game-of-thrones&code=${openingKey}&amount=2500`,
                        allowpaymentrequest: "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: "You will receive the confirmation and the video on the email you put in the form above. Please, confirm your email below."
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a22ae36f81196ea$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c794d0292d6e750b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5713618e2c793770$export$2e2bcd8739ae039), {
                donate: true
            })
        ]
    });
};
$42841dbc7c4805fb$var$DonateDownloadPage.propTypes = {
    match: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
var $42841dbc7c4805fb$export$2e2bcd8739ae039 = $42841dbc7c4805fb$var$DonateDownloadPage;




var $bh6RR = parcelRequire("bh6RR");









class $220ed3ee88dec351$var$RequestDownloadPage extends (0, $bh6RR.Component) {
    static propTypes = {
        match: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
    };
    state = {
        isLoading: true,
        status: null
    };
    componentDidMount = async ()=>{
        const { match: { params: params } } = this.props;
        const { openingKey: openingKey } = params;
        const status = await (0, $f056960f2e07845b$export$cb008828d1e2d0ca)(openingKey);
        this.setState({
            status: status,
            isLoading: false
        });
    };
    getQueuedText = ()=>{
        const { status: { status: status, position: position, queueSize: queueSize } } = this.state;
        const queuePosition = position || queueSize + 1;
        const etaText = (0, $2c1695720c48a031$export$2e2bcd8739ae039)(queuePosition);
        const notQueuedText = 'will be';
        const qeuedText = 'is';
        const isQueued = status !== 'not_queued';
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
            children: [
                "Your video request ",
                isQueued ? qeuedText : notQueuedText,
                ' ',
                "queued at position ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "bold",
                    children: queuePosition
                }),
                ". It may take up to ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "bold",
                    children: etaText
                }),
                " to have your video rendered. You can still pay to get it earlier if you want."
            ]
        });
    };
    renderContent = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
            children: [
                this.getQueuedText(),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8c601f58b7d640bb$export$2e2bcd8739ae039), {
                    hideNoDonateOption: true
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    children: "Fill your email below and when your video is ready you will receive a message with the link to download it. We promise not to send spam!"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c794d0292d6e750b$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a22ae36f81196ea$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5713618e2c793770$export$2e2bcd8739ae039), {})
            ]
        });
    render() {
        const { isLoading: isLoading } = this.state;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $02a62dbb9dd574c8$export$2e2bcd8739ae039), {
            title: "REQUEST DOWNLOAD",
            children: [
                isLoading && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6970ed5340caef3d$export$2e2bcd8739ae039), {}),
                !isLoading && this.renderContent()
            ]
        });
    }
}
var $220ed3ee88dec351$export$2e2bcd8739ae039 = $220ed3ee88dec351$var$RequestDownloadPage;



parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");

const $77b9da9220c43e88$var$ShowRequestedEmail = ()=>{
    const email = (0, $f056960f2e07845b$export$546c1da6d53fd8de)();
    if (!email) return null;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: "The link to download the video will be sent to the email:"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "bold",
                style: {
                    textAlign: 'center'
                },
                children: email
            })
        ]
    });
};
var $77b9da9220c43e88$export$2e2bcd8739ae039 = $77b9da9220c43e88$var$ShowRequestedEmail;



const $c157d2538b7d9858$var$RequestedPagesFooter = ({ openingKey: openingKey })=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $77b9da9220c43e88$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    "You can add more emails to receive the video if you want. The link to download will also be available on this page when it",
                    '\'',
                    "s ready."
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c794d0292d6e750b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "center-content horizontal",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e45e86148133c84$export$2e2bcd8739ae039), {
                        to: `/${openingKey}/edit`,
                        className: "button small-medium",
                        children: "Ok"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e45e86148133c84$export$2e2bcd8739ae039), {
                        to: `/${openingKey}/download/add_email`,
                        className: "button small-medium",
                        style: {
                            marginLeft: '20px'
                        },
                        children: "Add another email"
                    })
                ]
            })
        ]
    });
$c157d2538b7d9858$var$RequestedPagesFooter.propTypes = {
    openingKey: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string
};
var $c157d2538b7d9858$export$2e2bcd8739ae039 = $c157d2538b7d9858$var$RequestedPagesFooter;





var $bh6RR = parcelRequire("bh6RR");


const $a03dcc533d4ba28b$var$PENDING = 0;
const $a03dcc533d4ba28b$var$CONFIRMED = 1;
const $a03dcc533d4ba28b$var$NOT_FOUND = 2;
class $a03dcc533d4ba28b$var$CheckForDonation extends (0, $bh6RR.Component) {
    constructor(){
        super();
        this.state = {
            status: $a03dcc533d4ba28b$var$PENDING,
            startTime: Date.now()
        };
    }
    componentDidMount() {
        this._fetchDownloadStatus();
    }
    _fetchDownloadStatus = async ()=>{
        const { openingKey: openingKey } = this.props;
        let catchError = null;
        try {
            const response = await (0, $f056960f2e07845b$export$ffae4f72cb988e44)(openingKey);
            const isBumped = 'bumped' === response.status;
            const isRenderingViaBump = 'rendering' === response.status && response.bumpedOn;
            if (isBumped || isRenderingViaBump) {
                this.setState({
                    status: $a03dcc533d4ba28b$var$CONFIRMED
                });
                return;
            }
        } catch (error) {
            catchError = error;
        }
        const now = Date.now();
        const elapsed = now - this.state.startTime;
        const oneMinute = 60000;
        if (elapsed > oneMinute) {
            if (catchError) {
                this.setState({
                    error: catchError
                });
                return;
            }
            this.setState({
                status: $a03dcc533d4ba28b$var$NOT_FOUND
            });
            return;
        }
        setTimeout(this._fetchDownloadStatus, 3000);
    };
    render() {
        const { status: status, error: error } = this.state;
        if (error) throw error;
        const donationPending = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "check-for-donation__card",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6970ed5340caef3d$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "bold",
                    children: "Checking for payment..."
                })
            ]
        });
        const donationConfirmed = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "check-for-donation__card check-for-donation__card--verified",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "check-for-donation__icon check",
                    children: "\u2713"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "bold",
                    children: "Payment confimed!"
                })
            ]
        });
        const donationNotFound = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "check-for-donation__card check-for-donation__card--not-found",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "check-for-donation__icon",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        children: "X"
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    className: "bold",
                    children: [
                        "Payment not found! ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        "Please, check if your payment was made successfully or try to pay again."
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "check-for-donation",
            children: [
                status === $a03dcc533d4ba28b$var$PENDING && donationPending,
                status === $a03dcc533d4ba28b$var$CONFIRMED && donationConfirmed,
                status === $a03dcc533d4ba28b$var$NOT_FOUND && donationNotFound
            ]
        });
    }
}
var $a03dcc533d4ba28b$export$2e2bcd8739ae039 = $a03dcc533d4ba28b$var$CheckForDonation;


const $9426e1b932313a27$var$DonatedPage = ({ match: match })=>{
    const { params: params } = match;
    const { openingKey: openingKey } = params;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $02a62dbb9dd574c8$export$2e2bcd8739ae039), {
        title: "PAYMENT AND DOWNLOAD",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a03dcc533d4ba28b$export$2e2bcd8739ae039), {
                openingKey: openingKey
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: "Thank you so much for supporting us! Your video should be rendered soon when your payment is confirmed!"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    "When your payment is confirmed you should receive the confirmation message from us within a few minutes in your email. Don",
                    '\'',
                    "t forget to check your spam box. If you don",
                    '\'',
                    "t receive it, please check if the payment went successfully or contact us:",
                    ' ',
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a22ae36f81196ea$export$2e2bcd8739ae039), {
                        customText: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                children: [
                    "If you didn",
                    '\'',
                    "t pay yet, click on the button below to make your payment:"
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "center-content",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1e45e86148133c84$export$2e2bcd8739ae039), {
                    to: `/${openingKey}/download/pay`,
                    className: "button small-medium",
                    children: "Make Payment"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c157d2538b7d9858$export$2e2bcd8739ae039), {
                openingKey: openingKey
            })
        ]
    });
};
$9426e1b932313a27$var$DonatedPage.propTypes = {
    match: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
var $9426e1b932313a27$export$2e2bcd8739ae039 = $9426e1b932313a27$var$DonatedPage;




var $bh6RR = parcelRequire("bh6RR");






class $aef55ea7a76ebd23$var$RequestedPage extends (0, $bh6RR.Component) {
    static propTypes = {
        match: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
    };
    state = {
        isLoading: true,
        status: null
    };
    componentDidMount = async ()=>{
        const { match: { params: params } } = this.props;
        const { openingKey: openingKey } = params;
        try {
            const status = await (0, $f056960f2e07845b$export$cb008828d1e2d0ca)(openingKey);
            this.setState({
                status: status,
                isLoading: false
            });
        } catch (error) {
            this.setState({
                error: error
            });
        }
    };
    renderContent = ()=>{
        const { match: { params: { openingKey: openingKey } } } = this.props;
        const { status: { position: position } } = this.state;
        const etaText = (0, $2c1695720c48a031$export$2e2bcd8739ae039)(position);
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                    children: [
                        "Your video request has been queued! Your current position on the queue is ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            className: "bold",
                            children: position
                        }),
                        ", and may take up to ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            className: "bold",
                            children: etaText
                        }),
                        " to send your video."
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c157d2538b7d9858$export$2e2bcd8739ae039), {
                    openingKey: openingKey
                })
            ]
        });
    };
    render() {
        const { isLoading: isLoading, error: error } = this.state;
        if (error) throw error;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $02a62dbb9dd574c8$export$2e2bcd8739ae039), {
            title: "REQUEST AND DOWNLOAD",
            children: [
                isLoading && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6970ed5340caef3d$export$2e2bcd8739ae039), {}),
                !isLoading && this.renderContent()
            ]
        });
    }
}
var $aef55ea7a76ebd23$export$2e2bcd8739ae039 = $aef55ea7a76ebd23$var$RequestedPage;



parcelRequire("bh6RR");


const $0463949a84caae4a$var$AddDownloadEmailPage = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $02a62dbb9dd574c8$export$2e2bcd8739ae039), {
        title: "REQUEST DOWNLOAD",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                children: "You can add more emails to receive the video in the form below."
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5713618e2c793770$export$2e2bcd8739ae039), {
                buttonLabel: "Add Email"
            })
        ]
    });
var $0463949a84caae4a$export$2e2bcd8739ae039 = $0463949a84caae4a$var$AddDownloadEmailPage;


const $426afd8802bb3805$var$Routes = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $691e9536716fb7ca$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $97c042ebbd22f932$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $43cd07aecf347b85$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fcf57e8865974c97$export$2e2bcd8739ae039), {
                        exact: true,
                        path: "/",
                        component: (0, $5d616493c369fdfb$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fcf57e8865974c97$export$2e2bcd8739ae039), {
                        exact: true,
                        path: "/:openingKey",
                        component: (0, $20d1603623f12c2f$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fcf57e8865974c97$export$2e2bcd8739ae039), {
                        path: "/:openingKey/edit",
                        component: (0, $4637d107a48f1ec8$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fcf57e8865974c97$export$2e2bcd8739ae039), {
                        path: "/:openingKey/download/pay",
                        component: (0, $42841dbc7c4805fb$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fcf57e8865974c97$export$2e2bcd8739ae039), {
                        path: "/:openingKey/download/paid",
                        component: (0, $9426e1b932313a27$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fcf57e8865974c97$export$2e2bcd8739ae039), {
                        path: "/:openingKey/download/request",
                        component: (0, $220ed3ee88dec351$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fcf57e8865974c97$export$2e2bcd8739ae039), {
                        path: "/:openingKey/download/requested",
                        component: (0, $aef55ea7a76ebd23$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fcf57e8865974c97$export$2e2bcd8739ae039), {
                        path: "/:openingKey/download/add_email",
                        component: (0, $0463949a84caae4a$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fcf57e8865974c97$export$2e2bcd8739ae039), {
                        path: "/:openingKey/download/",
                        component: (0, $691ea1ad541192ac$export$2e2bcd8739ae039)
                    })
                ]
            })
        })
    });
var $426afd8802bb3805$export$2e2bcd8739ae039 = $426afd8802bb3805$var$Routes;






var $bh6RR = parcelRequire("bh6RR");



class $626c4207bc64f422$var$ErrorBoundary extends (0, $bh6RR.Component) {
    static propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).any
    };
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error
        });
        Raven.captureException(error, {
            extra: errorInfo
        });
    }
    render() {
        if (this.state.error) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $26778b50e82826b4$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "box-page error-boundary",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "box",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                            className: "title",
                            children: "ERROR"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                            src: (0, $d39cc430308b5205$export$5b6610bdbcc26c4f),
                            alt: (0, $d39cc430308b5205$export$180f22624eb9e7e6),
                            loading: "lazy"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            children: "We're sorry \u2014 something's gone wrong."
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            children: "Please try to reload the page or return to the home page."
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "center-content horizontal",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    className: "button small-medium",
                                    onClick: ()=>{
                                        window.location.href = '/';
                                    },
                                    children: "Home Page"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    className: "button small-medium",
                                    style: {
                                        marginLeft: '20px'
                                    },
                                    onClick: ()=>window.location.reload(),
                                    children: "Reload page"
                                })
                            ]
                        })
                    ]
                })
            })
        });
        return this.props.children;
    }
}
var $626c4207bc64f422$export$2e2bcd8739ae039 = $626c4207bc64f422$var$ErrorBoundary;



const $c1063bcab77d5448$var$renderWithAnimationConfig = (animationConfig)=>{
    const AnimationConfigProvider = (0, $2ef9ff2da13ee5ca$export$2e2bcd8739ae039).Provider;
    const mountNode = document.getElementById('app');
    (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $626c4207bc64f422$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(AnimationConfigProvider, {
            value: animationConfig,
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87127865826734e4$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $426afd8802bb3805$export$2e2bcd8739ae039), {})
            })
        })
    }), mountNode);
    if (!(0, $d39cc430308b5205$export$7392ea15d6a929a4)) document.querySelector('body').classList.remove('default-background');
};
const $c1063bcab77d5448$var$renderApp = (0, (/*@__PURE__*/$parcel$interopDefault($7244391317ff913c$exports)))(()=>{
    const animationConfig = (0, $5d7b1aa2c3e4450e$export$2e2bcd8739ae039)();
    $c1063bcab77d5448$var$renderWithAnimationConfig(animationConfig);
}, 200);
var $c1063bcab77d5448$export$2e2bcd8739ae039 = $c1063bcab77d5448$var$renderApp;



(function _() {
    Raven.config("https://c15e96f3605a494aa16146586308cfdf@sentry.io/1509641", {
        ignoreErrors: [
            /fullscreen error/,
            'ResizeObserver loop limit exceeded',
            'Fullscreen request denied'
        ]
    }).install();
    Raven.context(()=>{
        $85a5f86b715fe7db$var$_startApplication();
    });
})();
function $85a5f86b715fe7db$var$_startApplication() {
    (0, $52dd19ffb329f39b$export$3e2b244719956741)(()=>{
        (0, $c1063bcab77d5448$export$2e2bcd8739ae039)();
    });
    window.onresize = ()=>{
        (0, $c1063bcab77d5448$export$2e2bcd8739ae039)();
    };
    document.onfullscreenchange = ()=>(0, $c1063bcab77d5448$export$2e2bcd8739ae039)();
}


//# sourceMappingURL=path0.7b4d54b8.js.map
